export function getCssText() {
    return `
    <style type="text/css">svg:not(:root).svg-inline--fa {
        overflow: visible;
      }
      
      .svg-inline--fa {
        display: inline-block;
        font-size: inherit;
        height: 1em;
        overflow: visible;
        vertical-align: -0.125em;
      }
      .svg-inline--fa.fa-lg {
        vertical-align: -0.225em;
      }
      .svg-inline--fa.fa-w-1 {
        width: 0.0625em;
      }
      .svg-inline--fa.fa-w-2 {
        width: 0.125em;
      }
      .svg-inline--fa.fa-w-3 {
        width: 0.1875em;
      }
      .svg-inline--fa.fa-w-4 {
        width: 0.25em;
      }
      .svg-inline--fa.fa-w-5 {
        width: 0.3125em;
      }
      .svg-inline--fa.fa-w-6 {
        width: 0.375em;
      }
      .svg-inline--fa.fa-w-7 {
        width: 0.4375em;
      }
      .svg-inline--fa.fa-w-8 {
        width: 0.5em;
      }
      .svg-inline--fa.fa-w-9 {
        width: 0.5625em;
      }
      .svg-inline--fa.fa-w-10 {
        width: 0.625em;
      }
      .svg-inline--fa.fa-w-11 {
        width: 0.6875em;
      }
      .svg-inline--fa.fa-w-12 {
        width: 0.75em;
      }
      .svg-inline--fa.fa-w-13 {
        width: 0.8125em;
      }
      .svg-inline--fa.fa-w-14 {
        width: 0.875em;
      }
      .svg-inline--fa.fa-w-15 {
        width: 0.9375em;
      }
      .svg-inline--fa.fa-w-16 {
        width: 1em;
      }
      .svg-inline--fa.fa-w-17 {
        width: 1.0625em;
      }
      .svg-inline--fa.fa-w-18 {
        width: 1.125em;
      }
      .svg-inline--fa.fa-w-19 {
        width: 1.1875em;
      }
      .svg-inline--fa.fa-w-20 {
        width: 1.25em;
      }
      .svg-inline--fa.fa-pull-left {
        margin-right: 0.3em;
        width: auto;
      }
      .svg-inline--fa.fa-pull-right {
        margin-left: 0.3em;
        width: auto;
      }
      .svg-inline--fa.fa-border {
        height: 1.5em;
      }
      .svg-inline--fa.fa-li {
        width: 2em;
      }
      .svg-inline--fa.fa-fw {
        width: 1.25em;
      }
      
      .fa-layers svg.svg-inline--fa {
        bottom: 0;
        left: 0;
        margin: auto;
        position: absolute;
        right: 0;
        top: 0;
      }
      
      .fa-layers {
        display: inline-block;
        height: 1em;
        position: relative;
        text-align: center;
        vertical-align: -0.125em;
        width: 1em;
      }
      .fa-layers svg.svg-inline--fa {
        -webkit-transform-origin: center center;
                transform-origin: center center;
      }
      
      .fa-layers-counter, .fa-layers-text {
        display: inline-block;
        position: absolute;
        text-align: center;
      }
      
      .fa-layers-text {
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
        -webkit-transform-origin: center center;
                transform-origin: center center;
      }
      
      .fa-layers-counter {
        background-color: #ff253a;
        border-radius: 1em;
        -webkit-box-sizing: border-box;
                box-sizing: border-box;
        color: #fff;
        height: 1.5em;
        line-height: 1;
        max-width: 5em;
        min-width: 1.5em;
        overflow: hidden;
        padding: 0.25em;
        right: 0;
        text-overflow: ellipsis;
        top: 0;
        -webkit-transform: scale(0.25);
                transform: scale(0.25);
        -webkit-transform-origin: top right;
                transform-origin: top right;
      }
      
      .fa-layers-bottom-right {
        bottom: 0;
        right: 0;
        top: auto;
        -webkit-transform: scale(0.25);
                transform: scale(0.25);
        -webkit-transform-origin: bottom right;
                transform-origin: bottom right;
      }
      
      .fa-layers-bottom-left {
        bottom: 0;
        left: 0;
        right: auto;
        top: auto;
        -webkit-transform: scale(0.25);
                transform: scale(0.25);
        -webkit-transform-origin: bottom left;
                transform-origin: bottom left;
      }
      
      .fa-layers-top-right {
        right: 0;
        top: 0;
        -webkit-transform: scale(0.25);
                transform: scale(0.25);
        -webkit-transform-origin: top right;
                transform-origin: top right;
      }
      
      .fa-layers-top-left {
        left: 0;
        right: auto;
        top: 0;
        -webkit-transform: scale(0.25);
                transform: scale(0.25);
        -webkit-transform-origin: top left;
                transform-origin: top left;
      }
      
      .fa-lg {
        font-size: 1.3333333333em;
        line-height: 0.75em;
        vertical-align: -0.0667em;
      }
      
      .fa-xs {
        font-size: 0.75em;
      }
      
      .fa-sm {
        font-size: 0.875em;
      }
      
      .fa-1x {
        font-size: 1em;
      }
      
      .fa-2x {
        font-size: 2em;
      }
      
      .fa-3x {
        font-size: 3em;
      }
      
      .fa-4x {
        font-size: 4em;
      }
      
      .fa-5x {
        font-size: 5em;
      }
      
      .fa-6x {
        font-size: 6em;
      }
      
      .fa-7x {
        font-size: 7em;
      }
      
      .fa-8x {
        font-size: 8em;
      }
      
      .fa-9x {
        font-size: 9em;
      }
      
      .fa-10x {
        font-size: 10em;
      }
      
      .fa-fw {
        text-align: center;
        width: 1.25em;
      }
      
      .fa-ul {
        list-style-type: none;
        margin-left: 2.5em;
        padding-left: 0;
      }
      .fa-ul > li {
        position: relative;
      }
      
      .fa-li {
        left: -2em;
        position: absolute;
        text-align: center;
        width: 2em;
        line-height: inherit;
      }
      
      .fa-border {
        border: solid 0.08em #eee;
        border-radius: 0.1em;
        padding: 0.2em 0.25em 0.15em;
      }
      
      .fa-pull-left {
        float: left;
      }
      
      .fa-pull-right {
        float: right;
      }
      
      .fa.fa-pull-left,
      .fas.fa-pull-left,
      .far.fa-pull-left,
      .fal.fa-pull-left,
      .fab.fa-pull-left {
        margin-right: 0.3em;
      }
      .fa.fa-pull-right,
      .fas.fa-pull-right,
      .far.fa-pull-right,
      .fal.fa-pull-right,
      .fab.fa-pull-right {
        margin-left: 0.3em;
      }
      
      .fa-spin {
        -webkit-animation: fa-spin 2s infinite linear;
                animation: fa-spin 2s infinite linear;
      }
      
      .fa-pulse {
        -webkit-animation: fa-spin 1s infinite steps(8);
                animation: fa-spin 1s infinite steps(8);
      }
      
      @-webkit-keyframes fa-spin {
        0% {
          -webkit-transform: rotate(0deg);
                  transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
                  transform: rotate(360deg);
        }
      }
      
      @keyframes fa-spin {
        0% {
          -webkit-transform: rotate(0deg);
                  transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
                  transform: rotate(360deg);
        }
      }
      .fa-rotate-90 {
        -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
        -webkit-transform: rotate(90deg);
                transform: rotate(90deg);
      }
      
      .fa-rotate-180 {
        -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
        -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
      }
      
      .fa-rotate-270 {
        -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
        -webkit-transform: rotate(270deg);
                transform: rotate(270deg);
      }
      
      .fa-flip-horizontal {
        -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
        -webkit-transform: scale(-1, 1);
                transform: scale(-1, 1);
      }
      
      .fa-flip-vertical {
        -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
        -webkit-transform: scale(1, -1);
                transform: scale(1, -1);
      }
      
      .fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {
        -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
        -webkit-transform: scale(-1, -1);
                transform: scale(-1, -1);
      }
      
      :root .fa-rotate-90,
      :root .fa-rotate-180,
      :root .fa-rotate-270,
      :root .fa-flip-horizontal,
      :root .fa-flip-vertical,
      :root .fa-flip-both {
        -webkit-filter: none;
                filter: none;
      }
      
      .fa-stack {
        display: inline-block;
        height: 2em;
        position: relative;
        width: 2.5em;
      }
      
      .fa-stack-1x,
      .fa-stack-2x {
        bottom: 0;
        left: 0;
        margin: auto;
        position: absolute;
        right: 0;
        top: 0;
      }
      
      .svg-inline--fa.fa-stack-1x {
        height: 1em;
        width: 1.25em;
      }
      .svg-inline--fa.fa-stack-2x {
        height: 2em;
        width: 2.5em;
      }
      
      .fa-inverse {
        color: #fff;
      }
      
      .sr-only {
        border: 0;
        clip: rect(0, 0, 0, 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
      }
      
      .sr-only-focusable:active, .sr-only-focusable:focus {
        clip: auto;
        height: auto;
        margin: 0;
        overflow: visible;
        position: static;
        width: auto;
      }
      
      .svg-inline--fa .fa-primary {
        fill: var(--fa-primary-color, currentColor);
        opacity: 1;
        opacity: var(--fa-primary-opacity, 1);
      }
      
      .svg-inline--fa .fa-secondary {
        fill: var(--fa-secondary-color, currentColor);
        opacity: 0.4;
        opacity: var(--fa-secondary-opacity, 0.4);
      }
      
      .svg-inline--fa.fa-swap-opacity .fa-primary {
        opacity: 0.4;
        opacity: var(--fa-secondary-opacity, 0.4);
      }
      
      .svg-inline--fa.fa-swap-opacity .fa-secondary {
        opacity: 1;
        opacity: var(--fa-primary-opacity, 1);
      }
      
      .svg-inline--fa mask .fa-primary,
      .svg-inline--fa mask .fa-secondary {
        fill: black;
      }
      
      .fad.fa-inverse {
        color: #fff;
      }</style><link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css"><link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet"><link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" rel="stylesheet"><link href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp" rel="stylesheet"><link rel="stylesheet" href="https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css"><link rel="stylesheet" href="https://cdn.rawgit.com/openlayers/openlayers.github.io/master/en/v5.3.0/css/ol.css" type="text/css"><link rel="stylesheet" media="print" href="../src/plugins/bootstrap.min.css"><style type="text/css">.ex-alert {
        position: fixed;
        z-index: 99999;
        bottom: 24px;
        right: 80px;
        font-size: 12px;
        padding: 20px 30px;
        border-radius: 8px;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
                box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
      }
      .ex-alert.error {
        background-color: #ff0000;
      }
      .ex-alert.success {
        background-color: #0da313;
      }
      .ex-alert i {
        margin-right: 10px;
        color: #ffffff !important;
      }
      .ex-alert span {
        font-weight: bold;
        color: #ffffff;
        text-transform: uppercase;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-icon {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-icon--disabled {
        color: rgba(0, 0, 0, 0.38) !important;
      }
      
      .theme--dark.v-icon {
        color: #FFFFFF;
      }
      .theme--dark.v-icon--disabled {
        color: rgba(255, 255, 255, 0.5) !important;
      }
      
      .v-icon.v-icon {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-font-feature-settings: "liga";
                font-feature-settings: "liga";
        font-size: 24px;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        letter-spacing: normal;
        line-height: 1;
        text-indent: 0;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        vertical-align: middle;
      }
      
      .v-icon--right {
        margin-left: 8px;
      }
      .v-icon--left {
        margin-right: 8px;
      }
      .v-icon.v-icon.v-icon--link {
        cursor: pointer;
      }
      .v-icon--disabled {
        pointer-events: none;
        opacity: 0.6;
      }
      .v-icon--is-component {
        height: 24px;
        width: 24px;
      }
      .v-icon--svg {
        height: 24px;
        width: 24px;
        fill: currentColor;
      }
      .v-icon--dense {
        font-size: 20px;
      }
      .v-icon--dense--is-component {
        height: 20px;
      }</style><style type="text/css">#app {
        font-family: "OneInventory", serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
      }
      #nav {
        padding: 30px;
      }
      #nav a {
        font-weight: bold;
        color: #2c3e50;
      }
      #nav a.router-link-exact-active {
        color: #42b983;
      }</style><style type="text/css">/*!
       * Bootstrap v4.3.1 (https://getbootstrap.com/)
       * Copyright 2011-2019 The Bootstrap Authors
       * Copyright 2011-2019 Twitter, Inc.
       * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
       */
      :root {
        --blue: #007bff;
        --indigo: #6610f2;
        --purple: #6f42c1;
        --pink: #e83e8c;
        --red: #dc3545;
        --orange: #fd7e14;
        --yellow: #ffc107;
        --green: #28a745;
        --teal: #20c997;
        --cyan: #17a2b8;
        --white: #fff;
        --gray: #6c757d;
        --gray-dark: #343a40;
        --primary: #007bff;
        --secondary: #6c757d;
        --success: #28a745;
        --info: #17a2b8;
        --warning: #ffc107;
        --danger: #dc3545;
        --light: #f8f9fa;
        --dark: #343a40;
        --breakpoint-xs: 0;
        --breakpoint-sm: 576px;
        --breakpoint-md: 768px;
        --breakpoint-lg: 992px;
        --breakpoint-xl: 1200px;
        --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
      }
      
      *,
      *::before,
      *::after {
        -webkit-box-sizing: border-box;
                box-sizing: border-box;
      }
      
      html {
        font-family: sans-serif;
        line-height: 1.15;
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
      
      article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
        display: block;
      }
      
      body {
        margin: 0;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #212529;
        text-align: left;
        background-color: #fff;
      }
      
      [tabindex="-1"]:focus {
        outline: 0 !important;
      }
      
      hr {
        -webkit-box-sizing: content-box;
                box-sizing: content-box;
        height: 0;
        overflow: visible;
      }
      
      h1, h2, h3, h4, h5, h6 {
        margin-top: 0;
        margin-bottom: 0.5rem;
      }
      
      p {
        margin-top: 0;
        margin-bottom: 1rem;
      }
      
      abbr[title],
      abbr[data-original-title] {
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
        cursor: help;
        border-bottom: 0;
        -webkit-text-decoration-skip-ink: none;
        text-decoration-skip-ink: none;
      }
      
      address {
        margin-bottom: 1rem;
        font-style: normal;
        line-height: inherit;
      }
      
      ol,
      ul,
      dl {
        margin-top: 0;
        margin-bottom: 1rem;
      }
      
      ol ol,
      ul ul,
      ol ul,
      ul ol {
        margin-bottom: 0;
      }
      
      dt {
        font-weight: 700;
      }
      
      dd {
        margin-bottom: .5rem;
        margin-left: 0;
      }
      
      blockquote {
        margin: 0 0 1rem;
      }
      
      b,
      strong {
        font-weight: bolder;
      }
      
      small {
        font-size: 80%;
      }
      
      sub,
      sup {
        position: relative;
        font-size: 75%;
        line-height: 0;
        vertical-align: baseline;
      }
      
      sub {
        bottom: -.25em;
      }
      
      sup {
        top: -.5em;
      }
      
      a {
        color: #007bff;
        text-decoration: none;
        background-color: transparent;
      }
      
      a:hover {
        color: #0056b3;
        text-decoration: underline;
      }
      
      a:not([href]):not([tabindex]) {
        color: inherit;
        text-decoration: none;
      }
      
      a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {
        color: inherit;
        text-decoration: none;
      }
      
      a:not([href]):not([tabindex]):focus {
        outline: 0;
      }
      
      pre,
      code,
      kbd,
      samp {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
        font-size: 1em;
      }
      
      pre {
        margin-top: 0;
        margin-bottom: 1rem;
        overflow: auto;
      }
      
      figure {
        margin: 0 0 1rem;
      }
      
      img {
        vertical-align: middle;
        border-style: none;
      }
      
      svg {
        overflow: hidden;
        vertical-align: middle;
      }
      
      table {
        border-collapse: collapse;
      }
      
      caption {
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
        color: #6c757d;
        text-align: left;
        caption-side: bottom;
      }
      
      th {
        text-align: inherit;
      }
      
      label {
        display: inline-block;
        margin-bottom: 0.5rem;
      }
      
      button {
        border-radius: 0;
      }
      
      button:focus {
        outline: 1px dotted;
        outline: 5px auto -webkit-focus-ring-color;
      }
      
      input,
      button,
      select,
      optgroup,
      textarea {
        margin: 0;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
      }
      
      button,
      input {
        overflow: visible;
      }
      
      button,
      select {
        text-transform: none;
      }
      
      select {
        word-wrap: normal;
      }
      
      button,
      [type="button"],
      [type="reset"],
      [type="submit"] {
        -webkit-appearance: button;
      }
      
      button:not(:disabled),
      [type="button"]:not(:disabled),
      [type="reset"]:not(:disabled),
      [type="submit"]:not(:disabled) {
        cursor: pointer;
      }
      
      button::-moz-focus-inner,
      [type="button"]::-moz-focus-inner,
      [type="reset"]::-moz-focus-inner,
      [type="submit"]::-moz-focus-inner {
        padding: 0;
        border-style: none;
      }
      
      input[type="radio"],
      input[type="checkbox"] {
        -webkit-box-sizing: border-box;
                box-sizing: border-box;
        padding: 0;
      }
      
      input[type="date"],
      input[type="time"],
      input[type="datetime-local"],
      input[type="month"] {
        -webkit-appearance: listbox;
      }
      
      textarea {
        overflow: auto;
        resize: vertical;
      }
      
      fieldset {
        min-width: 0;
        padding: 0;
        margin: 0;
        border: 0;
      }
      
      legend {
        display: block;
        width: 100%;
        max-width: 100%;
        padding: 0;
        margin-bottom: .5rem;
        font-size: 1.5rem;
        line-height: inherit;
        color: inherit;
        white-space: normal;
      }
      
      progress {
        vertical-align: baseline;
      }
      
      [type="number"]::-webkit-inner-spin-button,
      [type="number"]::-webkit-outer-spin-button {
        height: auto;
      }
      
      [type="search"] {
        outline-offset: -2px;
        -webkit-appearance: none;
      }
      
      [type="search"]::-webkit-search-decoration {
        -webkit-appearance: none;
      }
      
      ::-webkit-file-upload-button {
        font: inherit;
        -webkit-appearance: button;
      }
      
      output {
        display: inline-block;
      }
      
      summary {
        display: list-item;
        cursor: pointer;
      }
      
      template {
        display: none;
      }
      
      [hidden] {
        display: none !important;
      }
      
      h1, h2, h3, h4, h5, h6,
      .h1, .h2, .h3, .h4, .h5, .h6 {
        margin-bottom: 0.5rem;
        font-weight: 500;
        line-height: 1.2;
      }
      
      h1, .h1 {
        font-size: 2.5rem;
      }
      
      h2, .h2 {
        font-size: 2rem;
      }
      
      h3, .h3 {
        font-size: 1.75rem;
      }
      
      h4, .h4 {
        font-size: 1.5rem;
      }
      
      h5, .h5 {
        font-size: 1.25rem;
      }
      
      h6, .h6 {
        font-size: 1rem;
      }
      
      .lead {
        font-size: 1.25rem;
        font-weight: 300;
      }
      
      .display-1 {
        font-size: 6rem;
        font-weight: 300;
        line-height: 1.2;
      }
      
      .display-2 {
        font-size: 5.5rem;
        font-weight: 300;
        line-height: 1.2;
      }
      
      .display-3 {
        font-size: 4.5rem;
        font-weight: 300;
        line-height: 1.2;
      }
      
      .display-4 {
        font-size: 3.5rem;
        font-weight: 300;
        line-height: 1.2;
      }
      
      hr {
        margin-top: 1rem;
        margin-bottom: 1rem;
        border: 0;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
      }
      
      small,
      .small {
        font-size: 80%;
        font-weight: 400;
      }
      
      mark,
      .mark {
        padding: 0.2em;
        background-color: #fcf8e3;
      }
      
      .list-unstyled {
        padding-left: 0;
        list-style: none;
      }
      
      .list-inline {
        padding-left: 0;
        list-style: none;
      }
      
      .list-inline-item {
        display: inline-block;
      }
      
      .list-inline-item:not(:last-child) {
        margin-right: 0.5rem;
      }
      
      .initialism {
        font-size: 90%;
        text-transform: uppercase;
      }
      
      .blockquote {
        margin-bottom: 1rem;
        font-size: 1.25rem;
      }
      
      .blockquote-footer {
        display: block;
        font-size: 80%;
        color: #6c757d;
      }
      
      .img-fluid {
        max-width: 100%;
        height: auto;
      }
      
      .img-thumbnail {
        padding: 0.25rem;
        background-color: #fff;
        border: 1px solid #dee2e6;
        border-radius: 0.25rem;
        max-width: 100%;
        height: auto;
      }
      
      .figure {
        display: inline-block;
      }
      
      .figure-img {
        margin-bottom: 0.5rem;
        line-height: 1;
      }
      
      .figure-caption {
        font-size: 90%;
        color: #6c757d;
      }
      
      code {
        font-size: 87.5%;
        color: #e83e8c;
        word-break: break-word;
      }
      
      a > code {
        color: inherit;
      }
      
      kbd {
        padding: 0.2rem 0.4rem;
        font-size: 87.5%;
        color: #fff;
        background-color: #212529;
        border-radius: 0.2rem;
      }
      
      kbd kbd {
        padding: 0;
        font-size: 100%;
        font-weight: 700;
      }
      
      pre {
        display: block;
        font-size: 87.5%;
        color: #212529;
      }
      
      pre code {
        font-size: inherit;
        color: inherit;
        word-break: normal;
      }
      
      .pre-scrollable {
        max-height: 340px;
        overflow-y: scroll;
      }
      
      .container {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
      }
      
      @media (min-width: 576px) {
        .container {
          max-width: 540px;
        }
      }
      
      @media (min-width: 768px) {
        .container {
          max-width: 720px;
        }
      }
      
      @media (min-width: 992px) {
        .container {
          max-width: 960px;
        }
      }
      
      @media (min-width: 1200px) {
        .container {
          max-width: 1140px;
        }
      }
      
      .container-fluid {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
      }
      
      .row {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin-right: -15px;
        margin-left: -15px;
      }
      
      .no-gutters {
        margin-right: 0;
        margin-left: 0;
      }
      
      .no-gutters > .col,
      .no-gutters > [class*="col-"] {
        padding-right: 0;
        padding-left: 0;
      }
      
      .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
      .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
      .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
      .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
      .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
      .col-xl-auto {
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
      }
      
      .col {
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -ms-flex-positive: 1;
        -webkit-box-flex: 1;
                flex-grow: 1;
        max-width: 100%;
      }
      
      .col-auto {
        -ms-flex: 0 0 auto;
        -webkit-box-flex: 0;
                flex: 0 0 auto;
        width: auto;
        max-width: 100%;
      }
      
      .col-1 {
        -ms-flex: 0 0 8.333333%;
        -webkit-box-flex: 0;
                flex: 0 0 8.333333%;
        max-width: 8.333333%;
      }
      
      .col-2 {
        -ms-flex: 0 0 16.666667%;
        -webkit-box-flex: 0;
                flex: 0 0 16.666667%;
        max-width: 16.666667%;
      }
      
      .col-3 {
        -ms-flex: 0 0 25%;
        -webkit-box-flex: 0;
                flex: 0 0 25%;
        max-width: 25%;
      }
      
      .col-4 {
        -ms-flex: 0 0 33.333333%;
        -webkit-box-flex: 0;
                flex: 0 0 33.333333%;
        max-width: 33.333333%;
      }
      
      .col-5 {
        -ms-flex: 0 0 41.666667%;
        -webkit-box-flex: 0;
                flex: 0 0 41.666667%;
        max-width: 41.666667%;
      }
      
      .col-6 {
        -ms-flex: 0 0 50%;
        -webkit-box-flex: 0;
                flex: 0 0 50%;
        max-width: 50%;
      }
      
      .col-7 {
        -ms-flex: 0 0 58.333333%;
        -webkit-box-flex: 0;
                flex: 0 0 58.333333%;
        max-width: 58.333333%;
      }
      
      .col-8 {
        -ms-flex: 0 0 66.666667%;
        -webkit-box-flex: 0;
                flex: 0 0 66.666667%;
        max-width: 66.666667%;
      }
      
      .col-9 {
        -ms-flex: 0 0 75%;
        -webkit-box-flex: 0;
                flex: 0 0 75%;
        max-width: 75%;
      }
      
      .col-10 {
        -ms-flex: 0 0 83.333333%;
        -webkit-box-flex: 0;
                flex: 0 0 83.333333%;
        max-width: 83.333333%;
      }
      
      .col-11 {
        -ms-flex: 0 0 91.666667%;
        -webkit-box-flex: 0;
                flex: 0 0 91.666667%;
        max-width: 91.666667%;
      }
      
      .col-12 {
        -ms-flex: 0 0 100%;
        -webkit-box-flex: 0;
                flex: 0 0 100%;
        max-width: 100%;
      }
      
      .order-first {
        -ms-flex-order: -1;
        -webkit-box-ordinal-group: 0;
                order: -1;
      }
      
      .order-last {
        -ms-flex-order: 13;
        -webkit-box-ordinal-group: 14;
                order: 13;
      }
      
      .order-0 {
        -ms-flex-order: 0;
        -webkit-box-ordinal-group: 1;
                order: 0;
      }
      
      .order-1 {
        -ms-flex-order: 1;
        -webkit-box-ordinal-group: 2;
                order: 1;
      }
      
      .order-2 {
        -ms-flex-order: 2;
        -webkit-box-ordinal-group: 3;
                order: 2;
      }
      
      .order-3 {
        -ms-flex-order: 3;
        -webkit-box-ordinal-group: 4;
                order: 3;
      }
      
      .order-4 {
        -ms-flex-order: 4;
        -webkit-box-ordinal-group: 5;
                order: 4;
      }
      
      .order-5 {
        -ms-flex-order: 5;
        -webkit-box-ordinal-group: 6;
                order: 5;
      }
      
      .order-6 {
        -ms-flex-order: 6;
        -webkit-box-ordinal-group: 7;
                order: 6;
      }
      
      .order-7 {
        -ms-flex-order: 7;
        -webkit-box-ordinal-group: 8;
                order: 7;
      }
      
      .order-8 {
        -ms-flex-order: 8;
        -webkit-box-ordinal-group: 9;
                order: 8;
      }
      
      .order-9 {
        -ms-flex-order: 9;
        -webkit-box-ordinal-group: 10;
                order: 9;
      }
      
      .order-10 {
        -ms-flex-order: 10;
        -webkit-box-ordinal-group: 11;
                order: 10;
      }
      
      .order-11 {
        -ms-flex-order: 11;
        -webkit-box-ordinal-group: 12;
                order: 11;
      }
      
      .order-12 {
        -ms-flex-order: 12;
        -webkit-box-ordinal-group: 13;
                order: 12;
      }
      
      .offset-1 {
        margin-left: 8.333333%;
      }
      
      .offset-2 {
        margin-left: 16.666667%;
      }
      
      .offset-3 {
        margin-left: 25%;
      }
      
      .offset-4 {
        margin-left: 33.333333%;
      }
      
      .offset-5 {
        margin-left: 41.666667%;
      }
      
      .offset-6 {
        margin-left: 50%;
      }
      
      .offset-7 {
        margin-left: 58.333333%;
      }
      
      .offset-8 {
        margin-left: 66.666667%;
      }
      
      .offset-9 {
        margin-left: 75%;
      }
      
      .offset-10 {
        margin-left: 83.333333%;
      }
      
      .offset-11 {
        margin-left: 91.666667%;
      }
      
      @media (min-width: 576px) {
        .col-sm {
          -ms-flex-preferred-size: 0;
          flex-basis: 0;
          -ms-flex-positive: 1;
          -webkit-box-flex: 1;
                  flex-grow: 1;
          max-width: 100%;
        }
        .col-sm-auto {
          -ms-flex: 0 0 auto;
          -webkit-box-flex: 0;
                  flex: 0 0 auto;
          width: auto;
          max-width: 100%;
        }
        .col-sm-1 {
          -ms-flex: 0 0 8.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 8.333333%;
          max-width: 8.333333%;
        }
        .col-sm-2 {
          -ms-flex: 0 0 16.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 16.666667%;
          max-width: 16.666667%;
        }
        .col-sm-3 {
          -ms-flex: 0 0 25%;
          -webkit-box-flex: 0;
                  flex: 0 0 25%;
          max-width: 25%;
        }
        .col-sm-4 {
          -ms-flex: 0 0 33.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 33.333333%;
          max-width: 33.333333%;
        }
        .col-sm-5 {
          -ms-flex: 0 0 41.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 41.666667%;
          max-width: 41.666667%;
        }
        .col-sm-6 {
          -ms-flex: 0 0 50%;
          -webkit-box-flex: 0;
                  flex: 0 0 50%;
          max-width: 50%;
        }
        .col-sm-7 {
          -ms-flex: 0 0 58.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 58.333333%;
          max-width: 58.333333%;
        }
        .col-sm-8 {
          -ms-flex: 0 0 66.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 66.666667%;
          max-width: 66.666667%;
        }
        .col-sm-9 {
          -ms-flex: 0 0 75%;
          -webkit-box-flex: 0;
                  flex: 0 0 75%;
          max-width: 75%;
        }
        .col-sm-10 {
          -ms-flex: 0 0 83.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 83.333333%;
          max-width: 83.333333%;
        }
        .col-sm-11 {
          -ms-flex: 0 0 91.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 91.666667%;
          max-width: 91.666667%;
        }
        .col-sm-12 {
          -ms-flex: 0 0 100%;
          -webkit-box-flex: 0;
                  flex: 0 0 100%;
          max-width: 100%;
        }
        .order-sm-first {
          -ms-flex-order: -1;
          -webkit-box-ordinal-group: 0;
                  order: -1;
        }
        .order-sm-last {
          -ms-flex-order: 13;
          -webkit-box-ordinal-group: 14;
                  order: 13;
        }
        .order-sm-0 {
          -ms-flex-order: 0;
          -webkit-box-ordinal-group: 1;
                  order: 0;
        }
        .order-sm-1 {
          -ms-flex-order: 1;
          -webkit-box-ordinal-group: 2;
                  order: 1;
        }
        .order-sm-2 {
          -ms-flex-order: 2;
          -webkit-box-ordinal-group: 3;
                  order: 2;
        }
        .order-sm-3 {
          -ms-flex-order: 3;
          -webkit-box-ordinal-group: 4;
                  order: 3;
        }
        .order-sm-4 {
          -ms-flex-order: 4;
          -webkit-box-ordinal-group: 5;
                  order: 4;
        }
        .order-sm-5 {
          -ms-flex-order: 5;
          -webkit-box-ordinal-group: 6;
                  order: 5;
        }
        .order-sm-6 {
          -ms-flex-order: 6;
          -webkit-box-ordinal-group: 7;
                  order: 6;
        }
        .order-sm-7 {
          -ms-flex-order: 7;
          -webkit-box-ordinal-group: 8;
                  order: 7;
        }
        .order-sm-8 {
          -ms-flex-order: 8;
          -webkit-box-ordinal-group: 9;
                  order: 8;
        }
        .order-sm-9 {
          -ms-flex-order: 9;
          -webkit-box-ordinal-group: 10;
                  order: 9;
        }
        .order-sm-10 {
          -ms-flex-order: 10;
          -webkit-box-ordinal-group: 11;
                  order: 10;
        }
        .order-sm-11 {
          -ms-flex-order: 11;
          -webkit-box-ordinal-group: 12;
                  order: 11;
        }
        .order-sm-12 {
          -ms-flex-order: 12;
          -webkit-box-ordinal-group: 13;
                  order: 12;
        }
        .offset-sm-0 {
          margin-left: 0;
        }
        .offset-sm-1 {
          margin-left: 8.333333%;
        }
        .offset-sm-2 {
          margin-left: 16.666667%;
        }
        .offset-sm-3 {
          margin-left: 25%;
        }
        .offset-sm-4 {
          margin-left: 33.333333%;
        }
        .offset-sm-5 {
          margin-left: 41.666667%;
        }
        .offset-sm-6 {
          margin-left: 50%;
        }
        .offset-sm-7 {
          margin-left: 58.333333%;
        }
        .offset-sm-8 {
          margin-left: 66.666667%;
        }
        .offset-sm-9 {
          margin-left: 75%;
        }
        .offset-sm-10 {
          margin-left: 83.333333%;
        }
        .offset-sm-11 {
          margin-left: 91.666667%;
        }
      }
      
      @media (min-width: 768px) {
        .col-md {
          -ms-flex-preferred-size: 0;
          flex-basis: 0;
          -ms-flex-positive: 1;
          -webkit-box-flex: 1;
                  flex-grow: 1;
          max-width: 100%;
        }
        .col-md-auto {
          -ms-flex: 0 0 auto;
          -webkit-box-flex: 0;
                  flex: 0 0 auto;
          width: auto;
          max-width: 100%;
        }
        .col-md-1 {
          -ms-flex: 0 0 8.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 8.333333%;
          max-width: 8.333333%;
        }
        .col-md-2 {
          -ms-flex: 0 0 16.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 16.666667%;
          max-width: 16.666667%;
        }
        .col-md-3 {
          -ms-flex: 0 0 25%;
          -webkit-box-flex: 0;
                  flex: 0 0 25%;
          max-width: 25%;
        }
        .col-md-4 {
          -ms-flex: 0 0 33.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 33.333333%;
          max-width: 33.333333%;
        }
        .col-md-5 {
          -ms-flex: 0 0 41.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 41.666667%;
          max-width: 41.666667%;
        }
        .col-md-6 {
          -ms-flex: 0 0 50%;
          -webkit-box-flex: 0;
                  flex: 0 0 50%;
          max-width: 50%;
        }
        .col-md-7 {
          -ms-flex: 0 0 58.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 58.333333%;
          max-width: 58.333333%;
        }
        .col-md-8 {
          -ms-flex: 0 0 66.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 66.666667%;
          max-width: 66.666667%;
        }
        .col-md-9 {
          -ms-flex: 0 0 75%;
          -webkit-box-flex: 0;
                  flex: 0 0 75%;
          max-width: 75%;
        }
        .col-md-10 {
          -ms-flex: 0 0 83.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 83.333333%;
          max-width: 83.333333%;
        }
        .col-md-11 {
          -ms-flex: 0 0 91.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 91.666667%;
          max-width: 91.666667%;
        }
        .col-md-12 {
          -ms-flex: 0 0 100%;
          -webkit-box-flex: 0;
                  flex: 0 0 100%;
          max-width: 100%;
        }
        .order-md-first {
          -ms-flex-order: -1;
          -webkit-box-ordinal-group: 0;
                  order: -1;
        }
        .order-md-last {
          -ms-flex-order: 13;
          -webkit-box-ordinal-group: 14;
                  order: 13;
        }
        .order-md-0 {
          -ms-flex-order: 0;
          -webkit-box-ordinal-group: 1;
                  order: 0;
        }
        .order-md-1 {
          -ms-flex-order: 1;
          -webkit-box-ordinal-group: 2;
                  order: 1;
        }
        .order-md-2 {
          -ms-flex-order: 2;
          -webkit-box-ordinal-group: 3;
                  order: 2;
        }
        .order-md-3 {
          -ms-flex-order: 3;
          -webkit-box-ordinal-group: 4;
                  order: 3;
        }
        .order-md-4 {
          -ms-flex-order: 4;
          -webkit-box-ordinal-group: 5;
                  order: 4;
        }
        .order-md-5 {
          -ms-flex-order: 5;
          -webkit-box-ordinal-group: 6;
                  order: 5;
        }
        .order-md-6 {
          -ms-flex-order: 6;
          -webkit-box-ordinal-group: 7;
                  order: 6;
        }
        .order-md-7 {
          -ms-flex-order: 7;
          -webkit-box-ordinal-group: 8;
                  order: 7;
        }
        .order-md-8 {
          -ms-flex-order: 8;
          -webkit-box-ordinal-group: 9;
                  order: 8;
        }
        .order-md-9 {
          -ms-flex-order: 9;
          -webkit-box-ordinal-group: 10;
                  order: 9;
        }
        .order-md-10 {
          -ms-flex-order: 10;
          -webkit-box-ordinal-group: 11;
                  order: 10;
        }
        .order-md-11 {
          -ms-flex-order: 11;
          -webkit-box-ordinal-group: 12;
                  order: 11;
        }
        .order-md-12 {
          -ms-flex-order: 12;
          -webkit-box-ordinal-group: 13;
                  order: 12;
        }
        .offset-md-0 {
          margin-left: 0;
        }
        .offset-md-1 {
          margin-left: 8.333333%;
        }
        .offset-md-2 {
          margin-left: 16.666667%;
        }
        .offset-md-3 {
          margin-left: 25%;
        }
        .offset-md-4 {
          margin-left: 33.333333%;
        }
        .offset-md-5 {
          margin-left: 41.666667%;
        }
        .offset-md-6 {
          margin-left: 50%;
        }
        .offset-md-7 {
          margin-left: 58.333333%;
        }
        .offset-md-8 {
          margin-left: 66.666667%;
        }
        .offset-md-9 {
          margin-left: 75%;
        }
        .offset-md-10 {
          margin-left: 83.333333%;
        }
        .offset-md-11 {
          margin-left: 91.666667%;
        }
      }
      
      @media (min-width: 992px) {
        .col-lg {
          -ms-flex-preferred-size: 0;
          flex-basis: 0;
          -ms-flex-positive: 1;
          -webkit-box-flex: 1;
                  flex-grow: 1;
          max-width: 100%;
        }
        .col-lg-auto {
          -ms-flex: 0 0 auto;
          -webkit-box-flex: 0;
                  flex: 0 0 auto;
          width: auto;
          max-width: 100%;
        }
        .col-lg-1 {
          -ms-flex: 0 0 8.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 8.333333%;
          max-width: 8.333333%;
        }
        .col-lg-2 {
          -ms-flex: 0 0 16.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 16.666667%;
          max-width: 16.666667%;
        }
        .col-lg-3 {
          -ms-flex: 0 0 25%;
          -webkit-box-flex: 0;
                  flex: 0 0 25%;
          max-width: 25%;
        }
        .col-lg-4 {
          -ms-flex: 0 0 33.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 33.333333%;
          max-width: 33.333333%;
        }
        .col-lg-5 {
          -ms-flex: 0 0 41.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 41.666667%;
          max-width: 41.666667%;
        }
        .col-lg-6 {
          -ms-flex: 0 0 50%;
          -webkit-box-flex: 0;
                  flex: 0 0 50%;
          max-width: 50%;
        }
        .col-lg-7 {
          -ms-flex: 0 0 58.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 58.333333%;
          max-width: 58.333333%;
        }
        .col-lg-8 {
          -ms-flex: 0 0 66.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 66.666667%;
          max-width: 66.666667%;
        }
        .col-lg-9 {
          -ms-flex: 0 0 75%;
          -webkit-box-flex: 0;
                  flex: 0 0 75%;
          max-width: 75%;
        }
        .col-lg-10 {
          -ms-flex: 0 0 83.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 83.333333%;
          max-width: 83.333333%;
        }
        .col-lg-11 {
          -ms-flex: 0 0 91.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 91.666667%;
          max-width: 91.666667%;
        }
        .col-lg-12 {
          -ms-flex: 0 0 100%;
          -webkit-box-flex: 0;
                  flex: 0 0 100%;
          max-width: 100%;
        }
        .order-lg-first {
          -ms-flex-order: -1;
          -webkit-box-ordinal-group: 0;
                  order: -1;
        }
        .order-lg-last {
          -ms-flex-order: 13;
          -webkit-box-ordinal-group: 14;
                  order: 13;
        }
        .order-lg-0 {
          -ms-flex-order: 0;
          -webkit-box-ordinal-group: 1;
                  order: 0;
        }
        .order-lg-1 {
          -ms-flex-order: 1;
          -webkit-box-ordinal-group: 2;
                  order: 1;
        }
        .order-lg-2 {
          -ms-flex-order: 2;
          -webkit-box-ordinal-group: 3;
                  order: 2;
        }
        .order-lg-3 {
          -ms-flex-order: 3;
          -webkit-box-ordinal-group: 4;
                  order: 3;
        }
        .order-lg-4 {
          -ms-flex-order: 4;
          -webkit-box-ordinal-group: 5;
                  order: 4;
        }
        .order-lg-5 {
          -ms-flex-order: 5;
          -webkit-box-ordinal-group: 6;
                  order: 5;
        }
        .order-lg-6 {
          -ms-flex-order: 6;
          -webkit-box-ordinal-group: 7;
                  order: 6;
        }
        .order-lg-7 {
          -ms-flex-order: 7;
          -webkit-box-ordinal-group: 8;
                  order: 7;
        }
        .order-lg-8 {
          -ms-flex-order: 8;
          -webkit-box-ordinal-group: 9;
                  order: 8;
        }
        .order-lg-9 {
          -ms-flex-order: 9;
          -webkit-box-ordinal-group: 10;
                  order: 9;
        }
        .order-lg-10 {
          -ms-flex-order: 10;
          -webkit-box-ordinal-group: 11;
                  order: 10;
        }
        .order-lg-11 {
          -ms-flex-order: 11;
          -webkit-box-ordinal-group: 12;
                  order: 11;
        }
        .order-lg-12 {
          -ms-flex-order: 12;
          -webkit-box-ordinal-group: 13;
                  order: 12;
        }
        .offset-lg-0 {
          margin-left: 0;
        }
        .offset-lg-1 {
          margin-left: 8.333333%;
        }
        .offset-lg-2 {
          margin-left: 16.666667%;
        }
        .offset-lg-3 {
          margin-left: 25%;
        }
        .offset-lg-4 {
          margin-left: 33.333333%;
        }
        .offset-lg-5 {
          margin-left: 41.666667%;
        }
        .offset-lg-6 {
          margin-left: 50%;
        }
        .offset-lg-7 {
          margin-left: 58.333333%;
        }
        .offset-lg-8 {
          margin-left: 66.666667%;
        }
        .offset-lg-9 {
          margin-left: 75%;
        }
        .offset-lg-10 {
          margin-left: 83.333333%;
        }
        .offset-lg-11 {
          margin-left: 91.666667%;
        }
      }
      
      @media (min-width: 1200px) {
        .col-xl {
          -ms-flex-preferred-size: 0;
          flex-basis: 0;
          -ms-flex-positive: 1;
          -webkit-box-flex: 1;
                  flex-grow: 1;
          max-width: 100%;
        }
        .col-xl-auto {
          -ms-flex: 0 0 auto;
          -webkit-box-flex: 0;
                  flex: 0 0 auto;
          width: auto;
          max-width: 100%;
        }
        .col-xl-1 {
          -ms-flex: 0 0 8.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 8.333333%;
          max-width: 8.333333%;
        }
        .col-xl-2 {
          -ms-flex: 0 0 16.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 16.666667%;
          max-width: 16.666667%;
        }
        .col-xl-3 {
          -ms-flex: 0 0 25%;
          -webkit-box-flex: 0;
                  flex: 0 0 25%;
          max-width: 25%;
        }
        .col-xl-4 {
          -ms-flex: 0 0 33.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 33.333333%;
          max-width: 33.333333%;
        }
        .col-xl-5 {
          -ms-flex: 0 0 41.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 41.666667%;
          max-width: 41.666667%;
        }
        .col-xl-6 {
          -ms-flex: 0 0 50%;
          -webkit-box-flex: 0;
                  flex: 0 0 50%;
          max-width: 50%;
        }
        .col-xl-7 {
          -ms-flex: 0 0 58.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 58.333333%;
          max-width: 58.333333%;
        }
        .col-xl-8 {
          -ms-flex: 0 0 66.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 66.666667%;
          max-width: 66.666667%;
        }
        .col-xl-9 {
          -ms-flex: 0 0 75%;
          -webkit-box-flex: 0;
                  flex: 0 0 75%;
          max-width: 75%;
        }
        .col-xl-10 {
          -ms-flex: 0 0 83.333333%;
          -webkit-box-flex: 0;
                  flex: 0 0 83.333333%;
          max-width: 83.333333%;
        }
        .col-xl-11 {
          -ms-flex: 0 0 91.666667%;
          -webkit-box-flex: 0;
                  flex: 0 0 91.666667%;
          max-width: 91.666667%;
        }
        .col-xl-12 {
          -ms-flex: 0 0 100%;
          -webkit-box-flex: 0;
                  flex: 0 0 100%;
          max-width: 100%;
        }
        .order-xl-first {
          -ms-flex-order: -1;
          -webkit-box-ordinal-group: 0;
                  order: -1;
        }
        .order-xl-last {
          -ms-flex-order: 13;
          -webkit-box-ordinal-group: 14;
                  order: 13;
        }
        .order-xl-0 {
          -ms-flex-order: 0;
          -webkit-box-ordinal-group: 1;
                  order: 0;
        }
        .order-xl-1 {
          -ms-flex-order: 1;
          -webkit-box-ordinal-group: 2;
                  order: 1;
        }
        .order-xl-2 {
          -ms-flex-order: 2;
          -webkit-box-ordinal-group: 3;
                  order: 2;
        }
        .order-xl-3 {
          -ms-flex-order: 3;
          -webkit-box-ordinal-group: 4;
                  order: 3;
        }
        .order-xl-4 {
          -ms-flex-order: 4;
          -webkit-box-ordinal-group: 5;
                  order: 4;
        }
        .order-xl-5 {
          -ms-flex-order: 5;
          -webkit-box-ordinal-group: 6;
                  order: 5;
        }
        .order-xl-6 {
          -ms-flex-order: 6;
          -webkit-box-ordinal-group: 7;
                  order: 6;
        }
        .order-xl-7 {
          -ms-flex-order: 7;
          -webkit-box-ordinal-group: 8;
                  order: 7;
        }
        .order-xl-8 {
          -ms-flex-order: 8;
          -webkit-box-ordinal-group: 9;
                  order: 8;
        }
        .order-xl-9 {
          -ms-flex-order: 9;
          -webkit-box-ordinal-group: 10;
                  order: 9;
        }
        .order-xl-10 {
          -ms-flex-order: 10;
          -webkit-box-ordinal-group: 11;
                  order: 10;
        }
        .order-xl-11 {
          -ms-flex-order: 11;
          -webkit-box-ordinal-group: 12;
                  order: 11;
        }
        .order-xl-12 {
          -ms-flex-order: 12;
          -webkit-box-ordinal-group: 13;
                  order: 12;
        }
        .offset-xl-0 {
          margin-left: 0;
        }
        .offset-xl-1 {
          margin-left: 8.333333%;
        }
        .offset-xl-2 {
          margin-left: 16.666667%;
        }
        .offset-xl-3 {
          margin-left: 25%;
        }
        .offset-xl-4 {
          margin-left: 33.333333%;
        }
        .offset-xl-5 {
          margin-left: 41.666667%;
        }
        .offset-xl-6 {
          margin-left: 50%;
        }
        .offset-xl-7 {
          margin-left: 58.333333%;
        }
        .offset-xl-8 {
          margin-left: 66.666667%;
        }
        .offset-xl-9 {
          margin-left: 75%;
        }
        .offset-xl-10 {
          margin-left: 83.333333%;
        }
        .offset-xl-11 {
          margin-left: 91.666667%;
        }
      }
      
      .table {
        width: 100%;
        margin-bottom: 1rem;
        color: #212529;
      }
      
      .table th,
      .table td {
        padding: 0.75rem;
        vertical-align: top;
        border-top: 1px solid #dee2e6;
      }
      
      .table thead th {
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
      }
      
      .table tbody + tbody {
        border-top: 2px solid #dee2e6;
      }
      
      .table-sm th,
      .table-sm td {
        padding: 0.3rem;
      }
      
      .table-bordered {
        border: 1px solid #dee2e6;
      }
      
      .table-bordered th,
      .table-bordered td {
        border: 1px solid #dee2e6;
      }
      
      .table-bordered thead th,
      .table-bordered thead td {
        border-bottom-width: 2px;
      }
      
      .table-borderless th,
      .table-borderless td,
      .table-borderless thead th,
      .table-borderless tbody + tbody {
        border: 0;
      }
      
      .table-striped tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, 0.05);
      }
      
      .table-hover tbody tr:hover {
        color: #212529;
        background-color: rgba(0, 0, 0, 0.075);
      }
      
      .table-primary,
      .table-primary > th,
      .table-primary > td {
        background-color: #b8daff;
      }
      
      .table-primary th,
      .table-primary td,
      .table-primary thead th,
      .table-primary tbody + tbody {
        border-color: #7abaff;
      }
      
      .table-hover .table-primary:hover {
        background-color: #9fcdff;
      }
      
      .table-hover .table-primary:hover > td,
      .table-hover .table-primary:hover > th {
        background-color: #9fcdff;
      }
      
      .table-secondary,
      .table-secondary > th,
      .table-secondary > td {
        background-color: #d6d8db;
      }
      
      .table-secondary th,
      .table-secondary td,
      .table-secondary thead th,
      .table-secondary tbody + tbody {
        border-color: #b3b7bb;
      }
      
      .table-hover .table-secondary:hover {
        background-color: #c8cbcf;
      }
      
      .table-hover .table-secondary:hover > td,
      .table-hover .table-secondary:hover > th {
        background-color: #c8cbcf;
      }
      
      .table-success,
      .table-success > th,
      .table-success > td {
        background-color: #c3e6cb;
      }
      
      .table-success th,
      .table-success td,
      .table-success thead th,
      .table-success tbody + tbody {
        border-color: #8fd19e;
      }
      
      .table-hover .table-success:hover {
        background-color: #b1dfbb;
      }
      
      .table-hover .table-success:hover > td,
      .table-hover .table-success:hover > th {
        background-color: #b1dfbb;
      }
      
      .table-info,
      .table-info > th,
      .table-info > td {
        background-color: #bee5eb;
      }
      
      .table-info th,
      .table-info td,
      .table-info thead th,
      .table-info tbody + tbody {
        border-color: #86cfda;
      }
      
      .table-hover .table-info:hover {
        background-color: #abdde5;
      }
      
      .table-hover .table-info:hover > td,
      .table-hover .table-info:hover > th {
        background-color: #abdde5;
      }
      
      .table-warning,
      .table-warning > th,
      .table-warning > td {
        background-color: #ffeeba;
      }
      
      .table-warning th,
      .table-warning td,
      .table-warning thead th,
      .table-warning tbody + tbody {
        border-color: #ffdf7e;
      }
      
      .table-hover .table-warning:hover {
        background-color: #ffe8a1;
      }
      
      .table-hover .table-warning:hover > td,
      .table-hover .table-warning:hover > th {
        background-color: #ffe8a1;
      }
      
      .table-danger,
      .table-danger > th,
      .table-danger > td {
        background-color: #f5c6cb;
      }
      
      .table-danger th,
      .table-danger td,
      .table-danger thead th,
      .table-danger tbody + tbody {
        border-color: #ed969e;
      }
      
      .table-hover .table-danger:hover {
        background-color: #f1b0b7;
      }
      
      .table-hover .table-danger:hover > td,
      .table-hover .table-danger:hover > th {
        background-color: #f1b0b7;
      }
      
      .table-light,
      .table-light > th,
      .table-light > td {
        background-color: #fdfdfe;
      }
      
      .table-light th,
      .table-light td,
      .table-light thead th,
      .table-light tbody + tbody {
        border-color: #fbfcfc;
      }
      
      .table-hover .table-light:hover {
        background-color: #ececf6;
      }
      
      .table-hover .table-light:hover > td,
      .table-hover .table-light:hover > th {
        background-color: #ececf6;
      }
      
      .table-dark,
      .table-dark > th,
      .table-dark > td {
        background-color: #c6c8ca;
      }
      
      .table-dark th,
      .table-dark td,
      .table-dark thead th,
      .table-dark tbody + tbody {
        border-color: #95999c;
      }
      
      .table-hover .table-dark:hover {
        background-color: #b9bbbe;
      }
      
      .table-hover .table-dark:hover > td,
      .table-hover .table-dark:hover > th {
        background-color: #b9bbbe;
      }
      
      .table-active,
      .table-active > th,
      .table-active > td {
        background-color: rgba(0, 0, 0, 0.075);
      }
      
      .table-hover .table-active:hover {
        background-color: rgba(0, 0, 0, 0.075);
      }
      
      .table-hover .table-active:hover > td,
      .table-hover .table-active:hover > th {
        background-color: rgba(0, 0, 0, 0.075);
      }
      
      .table .thead-dark th {
        color: #fff;
        background-color: #343a40;
        border-color: #454d55;
      }
      
      .table .thead-light th {
        color: #495057;
        background-color: #e9ecef;
        border-color: #dee2e6;
      }
      
      .table-dark {
        color: #fff;
        background-color: #343a40;
      }
      
      .table-dark th,
      .table-dark td,
      .table-dark thead th {
        border-color: #454d55;
      }
      
      .table-dark.table-bordered {
        border: 0;
      }
      
      .table-dark.table-striped tbody tr:nth-of-type(odd) {
        background-color: rgba(255, 255, 255, 0.05);
      }
      
      .table-dark.table-hover tbody tr:hover {
        color: #fff;
        background-color: rgba(255, 255, 255, 0.075);
      }
      
      @media (max-width: 575.98px) {
        .table-responsive-sm {
          display: block;
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .table-responsive-sm > .table-bordered {
          border: 0;
        }
      }
      
      @media (max-width: 767.98px) {
        .table-responsive-md {
          display: block;
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .table-responsive-md > .table-bordered {
          border: 0;
        }
      }
      
      @media (max-width: 991.98px) {
        .table-responsive-lg {
          display: block;
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .table-responsive-lg > .table-bordered {
          border: 0;
        }
      }
      
      @media (max-width: 1199.98px) {
        .table-responsive-xl {
          display: block;
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .table-responsive-xl > .table-bordered {
          border: 0;
        }
      }
      
      .table-responsive {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }
      
      .table-responsive > .table-bordered {
        border: 0;
      }
      
      .form-control {
        display: block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .form-control {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .form-control::-ms-expand {
        background-color: transparent;
        border: 0;
      }
      
      .form-control:focus {
        color: #495057;
        background-color: #fff;
        border-color: #80bdff;
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
      
      .form-control::-webkit-input-placeholder {
        color: #6c757d;
        opacity: 1;
      }
      
      .form-control::-moz-placeholder {
        color: #6c757d;
        opacity: 1;
      }
      
      .form-control:-ms-input-placeholder {
        color: #6c757d;
        opacity: 1;
      }
      
      .form-control::-ms-input-placeholder {
        color: #6c757d;
        opacity: 1;
      }
      
      .form-control::placeholder {
        color: #6c757d;
        opacity: 1;
      }
      
      .form-control:disabled, .form-control[readonly] {
        background-color: #e9ecef;
        opacity: 1;
      }
      
      select.form-control:focus::-ms-value {
        color: #495057;
        background-color: #fff;
      }
      
      .form-control-file,
      .form-control-range {
        display: block;
        width: 100%;
      }
      
      .col-form-label {
        padding-top: calc(0.375rem + 1px);
        padding-bottom: calc(0.375rem + 1px);
        margin-bottom: 0;
        font-size: inherit;
        line-height: 1.5;
      }
      
      .col-form-label-lg {
        padding-top: calc(0.5rem + 1px);
        padding-bottom: calc(0.5rem + 1px);
        font-size: 1.25rem;
        line-height: 1.5;
      }
      
      .col-form-label-sm {
        padding-top: calc(0.25rem + 1px);
        padding-bottom: calc(0.25rem + 1px);
        font-size: 0.875rem;
        line-height: 1.5;
      }
      
      .form-control-plaintext {
        display: block;
        width: 100%;
        padding-top: 0.375rem;
        padding-bottom: 0.375rem;
        margin-bottom: 0;
        line-height: 1.5;
        color: #212529;
        background-color: transparent;
        border: solid transparent;
        border-width: 1px 0;
      }
      
      .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
        padding-right: 0;
        padding-left: 0;
      }
      
      .form-control-sm {
        height: calc(1.5em + 0.5rem + 2px);
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
      
      .form-control-lg {
        height: calc(1.5em + 1rem + 2px);
        padding: 0.5rem 1rem;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: 0.3rem;
      }
      
      select.form-control[size], select.form-control[multiple] {
        height: auto;
      }
      
      textarea.form-control {
        height: auto;
      }
      
      .form-group {
        margin-bottom: 1rem;
      }
      
      .form-text {
        display: block;
        margin-top: 0.25rem;
      }
      
      .form-row {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin-right: -5px;
        margin-left: -5px;
      }
      
      .form-row > .col,
      .form-row > [class*="col-"] {
        padding-right: 5px;
        padding-left: 5px;
      }
      
      .form-check {
        position: relative;
        display: block;
        padding-left: 1.25rem;
      }
      
      .form-check-input {
        position: absolute;
        margin-top: 0.3rem;
        margin-left: -1.25rem;
      }
      
      .form-check-input:disabled ~ .form-check-label {
        color: #6c757d;
      }
      
      .form-check-label {
        margin-bottom: 0;
      }
      
      .form-check-inline {
        display: -ms-inline-flexbox;
        display: -webkit-inline-box;
        display: inline-flex;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
        padding-left: 0;
        margin-right: 0.75rem;
      }
      
      .form-check-inline .form-check-input {
        position: static;
        margin-top: 0;
        margin-right: 0.3125rem;
        margin-left: 0;
      }
      
      .valid-feedback {
        display: none;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #28a745;
      }
      
      .valid-tooltip {
        position: absolute;
        top: 100%;
        z-index: 5;
        display: none;
        max-width: 100%;
        padding: 0.25rem 0.5rem;
        margin-top: .1rem;
        font-size: 0.875rem;
        line-height: 1.5;
        color: #fff;
        background-color: rgba(40, 167, 69, 0.9);
        border-radius: 0.25rem;
      }
      
      .was-validated .form-control:valid, .form-control.is-valid {
        border-color: #28a745;
        padding-right: calc(1.5em + 0.75rem);
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: center right calc(0.375em + 0.1875rem);
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
      }
      
      .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
        border-color: #28a745;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
      }
      
      .was-validated .form-control:valid ~ .valid-feedback,
      .was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
      .form-control.is-valid ~ .valid-tooltip {
        display: block;
      }
      
      .was-validated textarea.form-control:valid, textarea.form-control.is-valid {
        padding-right: calc(1.5em + 0.75rem);
        background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
      }
      
      .was-validated .custom-select:valid, .custom-select.is-valid {
        border-color: #28a745;
        padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);
        background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px, url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
      }
      
      .was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
        border-color: #28a745;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
      }
      
      .was-validated .custom-select:valid ~ .valid-feedback,
      .was-validated .custom-select:valid ~ .valid-tooltip, .custom-select.is-valid ~ .valid-feedback,
      .custom-select.is-valid ~ .valid-tooltip {
        display: block;
      }
      
      .was-validated .form-control-file:valid ~ .valid-feedback,
      .was-validated .form-control-file:valid ~ .valid-tooltip, .form-control-file.is-valid ~ .valid-feedback,
      .form-control-file.is-valid ~ .valid-tooltip {
        display: block;
      }
      
      .was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
        color: #28a745;
      }
      
      .was-validated .form-check-input:valid ~ .valid-feedback,
      .was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
      .form-check-input.is-valid ~ .valid-tooltip {
        display: block;
      }
      
      .was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
        color: #28a745;
      }
      
      .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
        border-color: #28a745;
      }
      
      .was-validated .custom-control-input:valid ~ .valid-feedback,
      .was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
      .custom-control-input.is-valid ~ .valid-tooltip {
        display: block;
      }
      
      .was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
        border-color: #34ce57;
        background-color: #34ce57;
      }
      
      .was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
      }
      
      .was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
        border-color: #28a745;
      }
      
      .was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
        border-color: #28a745;
      }
      
      .was-validated .custom-file-input:valid ~ .valid-feedback,
      .was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
      .custom-file-input.is-valid ~ .valid-tooltip {
        display: block;
      }
      
      .was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
        border-color: #28a745;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
      }
      
      .invalid-feedback {
        display: none;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
      }
      
      .invalid-tooltip {
        position: absolute;
        top: 100%;
        z-index: 5;
        display: none;
        max-width: 100%;
        padding: 0.25rem 0.5rem;
        margin-top: .1rem;
        font-size: 0.875rem;
        line-height: 1.5;
        color: #fff;
        background-color: rgba(220, 53, 69, 0.9);
        border-radius: 0.25rem;
      }
      
      .was-validated .form-control:invalid, .form-control.is-invalid {
        border-color: #dc3545;
        padding-right: calc(1.5em + 0.75rem);
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
        background-repeat: no-repeat;
        background-position: center right calc(0.375em + 0.1875rem);
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
      }
      
      .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
        border-color: #dc3545;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
      }
      
      .was-validated .form-control:invalid ~ .invalid-feedback,
      .was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
      .form-control.is-invalid ~ .invalid-tooltip {
        display: block;
      }
      
      .was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
        padding-right: calc(1.5em + 0.75rem);
        background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
      }
      
      .was-validated .custom-select:invalid, .custom-select.is-invalid {
        border-color: #dc3545;
        padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);
        background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px, url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
      }
      
      .was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
        border-color: #dc3545;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
      }
      
      .was-validated .custom-select:invalid ~ .invalid-feedback,
      .was-validated .custom-select:invalid ~ .invalid-tooltip, .custom-select.is-invalid ~ .invalid-feedback,
      .custom-select.is-invalid ~ .invalid-tooltip {
        display: block;
      }
      
      .was-validated .form-control-file:invalid ~ .invalid-feedback,
      .was-validated .form-control-file:invalid ~ .invalid-tooltip, .form-control-file.is-invalid ~ .invalid-feedback,
      .form-control-file.is-invalid ~ .invalid-tooltip {
        display: block;
      }
      
      .was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
        color: #dc3545;
      }
      
      .was-validated .form-check-input:invalid ~ .invalid-feedback,
      .was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
      .form-check-input.is-invalid ~ .invalid-tooltip {
        display: block;
      }
      
      .was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
        color: #dc3545;
      }
      
      .was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
        border-color: #dc3545;
      }
      
      .was-validated .custom-control-input:invalid ~ .invalid-feedback,
      .was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
      .custom-control-input.is-invalid ~ .invalid-tooltip {
        display: block;
      }
      
      .was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
        border-color: #e4606d;
        background-color: #e4606d;
      }
      
      .was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
      }
      
      .was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
        border-color: #dc3545;
      }
      
      .was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
        border-color: #dc3545;
      }
      
      .was-validated .custom-file-input:invalid ~ .invalid-feedback,
      .was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
      .custom-file-input.is-invalid ~ .invalid-tooltip {
        display: block;
      }
      
      .was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
        border-color: #dc3545;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
      }
      
      .form-inline {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-flow: row wrap;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
                flex-flow: row wrap;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
      }
      
      .form-inline .form-check {
        width: 100%;
      }
      
      @media (min-width: 576px) {
        .form-inline label {
          display: -ms-flexbox;
          display: -webkit-box;
          display: flex;
          -ms-flex-align: center;
          -webkit-box-align: center;
                  align-items: center;
          -ms-flex-pack: center;
          -webkit-box-pack: center;
                  justify-content: center;
          margin-bottom: 0;
        }
        .form-inline .form-group {
          display: -ms-flexbox;
          display: -webkit-box;
          display: flex;
          -ms-flex: 0 0 auto;
          -webkit-box-flex: 0;
                  flex: 0 0 auto;
          -ms-flex-flow: row wrap;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-flow: row wrap;
          -ms-flex-align: center;
          -webkit-box-align: center;
                  align-items: center;
          margin-bottom: 0;
        }
        .form-inline .form-control {
          display: inline-block;
          width: auto;
          vertical-align: middle;
        }
        .form-inline .form-control-plaintext {
          display: inline-block;
        }
        .form-inline .input-group,
        .form-inline .custom-select {
          width: auto;
        }
        .form-inline .form-check {
          display: -ms-flexbox;
          display: -webkit-box;
          display: flex;
          -ms-flex-align: center;
          -webkit-box-align: center;
                  align-items: center;
          -ms-flex-pack: center;
          -webkit-box-pack: center;
                  justify-content: center;
          width: auto;
          padding-left: 0;
        }
        .form-inline .form-check-input {
          position: relative;
          -ms-flex-negative: 0;
          flex-shrink: 0;
          margin-top: 0;
          margin-right: 0.25rem;
          margin-left: 0;
        }
        .form-inline .custom-control {
          -ms-flex-align: center;
          -webkit-box-align: center;
                  align-items: center;
          -ms-flex-pack: center;
          -webkit-box-pack: center;
                  justify-content: center;
        }
        .form-inline .custom-control-label {
          margin-bottom: 0;
        }
      }
      
      .btn {
        display: inline-block;
        font-weight: 400;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid transparent;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: 0.25rem;
        -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .btn {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .btn:hover {
        color: #212529;
        text-decoration: none;
      }
      
      .btn:focus, .btn.focus {
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
      
      .btn.disabled, .btn:disabled {
        opacity: 0.65;
      }
      
      a.btn.disabled,
      fieldset:disabled a.btn {
        pointer-events: none;
      }
      
      .btn-primary {
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
      }
      
      .btn-primary:hover {
        color: #fff;
        background-color: #0069d9;
        border-color: #0062cc;
      }
      
      .btn-primary:focus, .btn-primary.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
      }
      
      .btn-primary.disabled, .btn-primary:disabled {
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
      }
      
      .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
      .show > .btn-primary.dropdown-toggle {
        color: #fff;
        background-color: #0062cc;
        border-color: #005cbf;
      }
      
      .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,
      .show > .btn-primary.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
      }
      
      .btn-secondary {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
      }
      
      .btn-secondary:hover {
        color: #fff;
        background-color: #5a6268;
        border-color: #545b62;
      }
      
      .btn-secondary:focus, .btn-secondary.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
      }
      
      .btn-secondary.disabled, .btn-secondary:disabled {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
      }
      
      .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,
      .show > .btn-secondary.dropdown-toggle {
        color: #fff;
        background-color: #545b62;
        border-color: #4e555b;
      }
      
      .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,
      .show > .btn-secondary.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
      }
      
      .btn-success {
        color: #fff;
        background-color: #28a745;
        border-color: #28a745;
      }
      
      .btn-success:hover {
        color: #fff;
        background-color: #218838;
        border-color: #1e7e34;
      }
      
      .btn-success:focus, .btn-success.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
      }
      
      .btn-success.disabled, .btn-success:disabled {
        color: #fff;
        background-color: #28a745;
        border-color: #28a745;
      }
      
      .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,
      .show > .btn-success.dropdown-toggle {
        color: #fff;
        background-color: #1e7e34;
        border-color: #1c7430;
      }
      
      .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,
      .show > .btn-success.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
      }
      
      .btn-info {
        color: #fff;
        background-color: #17a2b8;
        border-color: #17a2b8;
      }
      
      .btn-info:hover {
        color: #fff;
        background-color: #138496;
        border-color: #117a8b;
      }
      
      .btn-info:focus, .btn-info.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
      }
      
      .btn-info.disabled, .btn-info:disabled {
        color: #fff;
        background-color: #17a2b8;
        border-color: #17a2b8;
      }
      
      .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,
      .show > .btn-info.dropdown-toggle {
        color: #fff;
        background-color: #117a8b;
        border-color: #10707f;
      }
      
      .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,
      .show > .btn-info.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
      }
      
      .btn-warning {
        color: #212529;
        background-color: #ffc107;
        border-color: #ffc107;
      }
      
      .btn-warning:hover {
        color: #212529;
        background-color: #e0a800;
        border-color: #d39e00;
      }
      
      .btn-warning:focus, .btn-warning.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
      }
      
      .btn-warning.disabled, .btn-warning:disabled {
        color: #212529;
        background-color: #ffc107;
        border-color: #ffc107;
      }
      
      .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,
      .show > .btn-warning.dropdown-toggle {
        color: #212529;
        background-color: #d39e00;
        border-color: #c69500;
      }
      
      .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,
      .show > .btn-warning.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
      }
      
      .btn-danger {
        color: #fff;
        background-color: #dc3545;
        border-color: #dc3545;
      }
      
      .btn-danger:hover {
        color: #fff;
        background-color: #c82333;
        border-color: #bd2130;
      }
      
      .btn-danger:focus, .btn-danger.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
      }
      
      .btn-danger.disabled, .btn-danger:disabled {
        color: #fff;
        background-color: #dc3545;
        border-color: #dc3545;
      }
      
      .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,
      .show > .btn-danger.dropdown-toggle {
        color: #fff;
        background-color: #bd2130;
        border-color: #b21f2d;
      }
      
      .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,
      .show > .btn-danger.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
      }
      
      .btn-light {
        color: #212529;
        background-color: #f8f9fa;
        border-color: #f8f9fa;
      }
      
      .btn-light:hover {
        color: #212529;
        background-color: #e2e6ea;
        border-color: #dae0e5;
      }
      
      .btn-light:focus, .btn-light.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
      }
      
      .btn-light.disabled, .btn-light:disabled {
        color: #212529;
        background-color: #f8f9fa;
        border-color: #f8f9fa;
      }
      
      .btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,
      .show > .btn-light.dropdown-toggle {
        color: #212529;
        background-color: #dae0e5;
        border-color: #d3d9df;
      }
      
      .btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,
      .show > .btn-light.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
      }
      
      .btn-dark {
        color: #fff;
        background-color: #343a40;
        border-color: #343a40;
      }
      
      .btn-dark:hover {
        color: #fff;
        background-color: #23272b;
        border-color: #1d2124;
      }
      
      .btn-dark:focus, .btn-dark.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
      }
      
      .btn-dark.disabled, .btn-dark:disabled {
        color: #fff;
        background-color: #343a40;
        border-color: #343a40;
      }
      
      .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,
      .show > .btn-dark.dropdown-toggle {
        color: #fff;
        background-color: #1d2124;
        border-color: #171a1d;
      }
      
      .btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,
      .show > .btn-dark.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
      }
      
      .btn-outline-primary {
        color: #007bff;
        border-color: #007bff;
      }
      
      .btn-outline-primary:hover {
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
      }
      
      .btn-outline-primary:focus, .btn-outline-primary.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
      }
      
      .btn-outline-primary.disabled, .btn-outline-primary:disabled {
        color: #007bff;
        background-color: transparent;
      }
      
      .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,
      .show > .btn-outline-primary.dropdown-toggle {
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
      }
      
      .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
      .show > .btn-outline-primary.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
      }
      
      .btn-outline-secondary {
        color: #6c757d;
        border-color: #6c757d;
      }
      
      .btn-outline-secondary:hover {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
      }
      
      .btn-outline-secondary:focus, .btn-outline-secondary.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
      }
      
      .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
        color: #6c757d;
        background-color: transparent;
      }
      
      .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,
      .show > .btn-outline-secondary.dropdown-toggle {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
      }
      
      .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
      .show > .btn-outline-secondary.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
      }
      
      .btn-outline-success {
        color: #28a745;
        border-color: #28a745;
      }
      
      .btn-outline-success:hover {
        color: #fff;
        background-color: #28a745;
        border-color: #28a745;
      }
      
      .btn-outline-success:focus, .btn-outline-success.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
      }
      
      .btn-outline-success.disabled, .btn-outline-success:disabled {
        color: #28a745;
        background-color: transparent;
      }
      
      .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,
      .show > .btn-outline-success.dropdown-toggle {
        color: #fff;
        background-color: #28a745;
        border-color: #28a745;
      }
      
      .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,
      .show > .btn-outline-success.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
      }
      
      .btn-outline-info {
        color: #17a2b8;
        border-color: #17a2b8;
      }
      
      .btn-outline-info:hover {
        color: #fff;
        background-color: #17a2b8;
        border-color: #17a2b8;
      }
      
      .btn-outline-info:focus, .btn-outline-info.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
      }
      
      .btn-outline-info.disabled, .btn-outline-info:disabled {
        color: #17a2b8;
        background-color: transparent;
      }
      
      .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,
      .show > .btn-outline-info.dropdown-toggle {
        color: #fff;
        background-color: #17a2b8;
        border-color: #17a2b8;
      }
      
      .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,
      .show > .btn-outline-info.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
      }
      
      .btn-outline-warning {
        color: #ffc107;
        border-color: #ffc107;
      }
      
      .btn-outline-warning:hover {
        color: #212529;
        background-color: #ffc107;
        border-color: #ffc107;
      }
      
      .btn-outline-warning:focus, .btn-outline-warning.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
      }
      
      .btn-outline-warning.disabled, .btn-outline-warning:disabled {
        color: #ffc107;
        background-color: transparent;
      }
      
      .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,
      .show > .btn-outline-warning.dropdown-toggle {
        color: #212529;
        background-color: #ffc107;
        border-color: #ffc107;
      }
      
      .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,
      .show > .btn-outline-warning.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
      }
      
      .btn-outline-danger {
        color: #dc3545;
        border-color: #dc3545;
      }
      
      .btn-outline-danger:hover {
        color: #fff;
        background-color: #dc3545;
        border-color: #dc3545;
      }
      
      .btn-outline-danger:focus, .btn-outline-danger.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
      }
      
      .btn-outline-danger.disabled, .btn-outline-danger:disabled {
        color: #dc3545;
        background-color: transparent;
      }
      
      .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,
      .show > .btn-outline-danger.dropdown-toggle {
        color: #fff;
        background-color: #dc3545;
        border-color: #dc3545;
      }
      
      .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,
      .show > .btn-outline-danger.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
      }
      
      .btn-outline-light {
        color: #f8f9fa;
        border-color: #f8f9fa;
      }
      
      .btn-outline-light:hover {
        color: #212529;
        background-color: #f8f9fa;
        border-color: #f8f9fa;
      }
      
      .btn-outline-light:focus, .btn-outline-light.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
      }
      
      .btn-outline-light.disabled, .btn-outline-light:disabled {
        color: #f8f9fa;
        background-color: transparent;
      }
      
      .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,
      .show > .btn-outline-light.dropdown-toggle {
        color: #212529;
        background-color: #f8f9fa;
        border-color: #f8f9fa;
      }
      
      .btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,
      .show > .btn-outline-light.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
      }
      
      .btn-outline-dark {
        color: #343a40;
        border-color: #343a40;
      }
      
      .btn-outline-dark:hover {
        color: #fff;
        background-color: #343a40;
        border-color: #343a40;
      }
      
      .btn-outline-dark:focus, .btn-outline-dark.focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
      }
      
      .btn-outline-dark.disabled, .btn-outline-dark:disabled {
        color: #343a40;
        background-color: transparent;
      }
      
      .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,
      .show > .btn-outline-dark.dropdown-toggle {
        color: #fff;
        background-color: #343a40;
        border-color: #343a40;
      }
      
      .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,
      .show > .btn-outline-dark.dropdown-toggle:focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
      }
      
      .btn-link {
        font-weight: 400;
        color: #007bff;
        text-decoration: none;
      }
      
      .btn-link:hover {
        color: #0056b3;
        text-decoration: underline;
      }
      
      .btn-link:focus, .btn-link.focus {
        text-decoration: underline;
        -webkit-box-shadow: none;
                box-shadow: none;
      }
      
      .btn-link:disabled, .btn-link.disabled {
        color: #6c757d;
        pointer-events: none;
      }
      
      .btn-lg, .btn-group-lg > .btn {
        padding: 0.5rem 1rem;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: 0.3rem;
      }
      
      .btn-sm, .btn-group-sm > .btn {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
      
      .btn-block {
        display: block;
        width: 100%;
      }
      
      .btn-block + .btn-block {
        margin-top: 0.5rem;
      }
      
      input[type="submit"].btn-block,
      input[type="reset"].btn-block,
      input[type="button"].btn-block {
        width: 100%;
      }
      
      .fade {
        -webkit-transition: opacity 0.15s linear;
        transition: opacity 0.15s linear;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .fade {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .fade:not(.show) {
        opacity: 0;
      }
      
      .collapse:not(.show) {
        display: none;
      }
      
      .collapsing {
        position: relative;
        height: 0;
        overflow: hidden;
        -webkit-transition: height 0.35s ease;
        transition: height 0.35s ease;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .collapsing {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .dropup,
      .dropright,
      .dropdown,
      .dropleft {
        position: relative;
      }
      
      .dropdown-toggle {
        white-space: nowrap;
      }
      
      .dropdown-toggle::after {
        display: inline-block;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: "";
        border-top: 0.3em solid;
        border-right: 0.3em solid transparent;
        border-bottom: 0;
        border-left: 0.3em solid transparent;
      }
      
      .dropdown-toggle:empty::after {
        margin-left: 0;
      }
      
      .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
        float: left;
        min-width: 10rem;
        padding: 0.5rem 0;
        margin: 0.125rem 0 0;
        font-size: 1rem;
        color: #212529;
        text-align: left;
        list-style: none;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0.25rem;
      }
      
      .dropdown-menu-left {
        right: auto;
        left: 0;
      }
      
      .dropdown-menu-right {
        right: 0;
        left: auto;
      }
      
      @media (min-width: 576px) {
        .dropdown-menu-sm-left {
          right: auto;
          left: 0;
        }
        .dropdown-menu-sm-right {
          right: 0;
          left: auto;
        }
      }
      
      @media (min-width: 768px) {
        .dropdown-menu-md-left {
          right: auto;
          left: 0;
        }
        .dropdown-menu-md-right {
          right: 0;
          left: auto;
        }
      }
      
      @media (min-width: 992px) {
        .dropdown-menu-lg-left {
          right: auto;
          left: 0;
        }
        .dropdown-menu-lg-right {
          right: 0;
          left: auto;
        }
      }
      
      @media (min-width: 1200px) {
        .dropdown-menu-xl-left {
          right: auto;
          left: 0;
        }
        .dropdown-menu-xl-right {
          right: 0;
          left: auto;
        }
      }
      
      .dropup .dropdown-menu {
        top: auto;
        bottom: 100%;
        margin-top: 0;
        margin-bottom: 0.125rem;
      }
      
      .dropup .dropdown-toggle::after {
        display: inline-block;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: "";
        border-top: 0;
        border-right: 0.3em solid transparent;
        border-bottom: 0.3em solid;
        border-left: 0.3em solid transparent;
      }
      
      .dropup .dropdown-toggle:empty::after {
        margin-left: 0;
      }
      
      .dropright .dropdown-menu {
        top: 0;
        right: auto;
        left: 100%;
        margin-top: 0;
        margin-left: 0.125rem;
      }
      
      .dropright .dropdown-toggle::after {
        display: inline-block;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: "";
        border-top: 0.3em solid transparent;
        border-right: 0;
        border-bottom: 0.3em solid transparent;
        border-left: 0.3em solid;
      }
      
      .dropright .dropdown-toggle:empty::after {
        margin-left: 0;
      }
      
      .dropright .dropdown-toggle::after {
        vertical-align: 0;
      }
      
      .dropleft .dropdown-menu {
        top: 0;
        right: 100%;
        left: auto;
        margin-top: 0;
        margin-right: 0.125rem;
      }
      
      .dropleft .dropdown-toggle::after {
        display: inline-block;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: "";
      }
      
      .dropleft .dropdown-toggle::after {
        display: none;
      }
      
      .dropleft .dropdown-toggle::before {
        display: inline-block;
        margin-right: 0.255em;
        vertical-align: 0.255em;
        content: "";
        border-top: 0.3em solid transparent;
        border-right: 0.3em solid;
        border-bottom: 0.3em solid transparent;
      }
      
      .dropleft .dropdown-toggle:empty::after {
        margin-left: 0;
      }
      
      .dropleft .dropdown-toggle::before {
        vertical-align: 0;
      }
      
      .dropdown-menu[x-placement^="top"], .dropdown-menu[x-placement^="right"], .dropdown-menu[x-placement^="bottom"], .dropdown-menu[x-placement^="left"] {
        right: auto;
        bottom: auto;
      }
      
      .dropdown-divider {
        height: 0;
        margin: 0.5rem 0;
        overflow: hidden;
        border-top: 1px solid #e9ecef;
      }
      
      .dropdown-item {
        display: block;
        width: 100%;
        padding: 0.25rem 1.5rem;
        clear: both;
        font-weight: 400;
        color: #212529;
        text-align: inherit;
        white-space: nowrap;
        background-color: transparent;
        border: 0;
      }
      
      .dropdown-item:hover, .dropdown-item:focus {
        color: #16181b;
        text-decoration: none;
        background-color: #f8f9fa;
      }
      
      .dropdown-item.active, .dropdown-item:active {
        color: #fff;
        text-decoration: none;
        background-color: #007bff;
      }
      
      .dropdown-item.disabled, .dropdown-item:disabled {
        color: #6c757d;
        pointer-events: none;
        background-color: transparent;
      }
      
      .dropdown-menu.show {
        display: block;
      }
      
      .dropdown-header {
        display: block;
        padding: 0.5rem 1.5rem;
        margin-bottom: 0;
        font-size: 0.875rem;
        color: #6c757d;
        white-space: nowrap;
      }
      
      .dropdown-item-text {
        display: block;
        padding: 0.25rem 1.5rem;
        color: #212529;
      }
      
      .btn-group,
      .btn-group-vertical {
        position: relative;
        display: -ms-inline-flexbox;
        display: -webkit-inline-box;
        display: inline-flex;
        vertical-align: middle;
      }
      
      .btn-group > .btn,
      .btn-group-vertical > .btn {
        position: relative;
        -ms-flex: 1 1 auto;
        -webkit-box-flex: 1;
                flex: 1 1 auto;
      }
      
      .btn-group > .btn:hover,
      .btn-group-vertical > .btn:hover {
        z-index: 1;
      }
      
      .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
      .btn-group-vertical > .btn:focus,
      .btn-group-vertical > .btn:active,
      .btn-group-vertical > .btn.active {
        z-index: 1;
      }
      
      .btn-toolbar {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -ms-flex-pack: start;
        -webkit-box-pack: start;
                justify-content: flex-start;
      }
      
      .btn-toolbar .input-group {
        width: auto;
      }
      
      .btn-group > .btn:not(:first-child),
      .btn-group > .btn-group:not(:first-child) {
        margin-left: -1px;
      }
      
      .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
      .btn-group > .btn-group:not(:last-child) > .btn {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      
      .btn-group > .btn:not(:first-child),
      .btn-group > .btn-group:not(:first-child) > .btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      
      .dropdown-toggle-split {
        padding-right: 0.5625rem;
        padding-left: 0.5625rem;
      }
      
      .dropdown-toggle-split::after,
      .dropup .dropdown-toggle-split::after,
      .dropright .dropdown-toggle-split::after {
        margin-left: 0;
      }
      
      .dropleft .dropdown-toggle-split::before {
        margin-right: 0;
      }
      
      .btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
        padding-right: 0.375rem;
        padding-left: 0.375rem;
      }
      
      .btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
        padding-right: 0.75rem;
        padding-left: 0.75rem;
      }
      
      .btn-group-vertical {
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
                flex-direction: column;
        -ms-flex-align: start;
        -webkit-box-align: start;
                align-items: flex-start;
        -ms-flex-pack: center;
        -webkit-box-pack: center;
                justify-content: center;
      }
      
      .btn-group-vertical > .btn,
      .btn-group-vertical > .btn-group {
        width: 100%;
      }
      
      .btn-group-vertical > .btn:not(:first-child),
      .btn-group-vertical > .btn-group:not(:first-child) {
        margin-top: -1px;
      }
      
      .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
      .btn-group-vertical > .btn-group:not(:last-child) > .btn {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      }
      
      .btn-group-vertical > .btn:not(:first-child),
      .btn-group-vertical > .btn-group:not(:first-child) > .btn {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
      
      .btn-group-toggle > .btn,
      .btn-group-toggle > .btn-group > .btn {
        margin-bottom: 0;
      }
      
      .btn-group-toggle > .btn input[type="radio"],
      .btn-group-toggle > .btn input[type="checkbox"],
      .btn-group-toggle > .btn-group > .btn input[type="radio"],
      .btn-group-toggle > .btn-group > .btn input[type="checkbox"] {
        position: absolute;
        clip: rect(0, 0, 0, 0);
        pointer-events: none;
      }
      
      .input-group {
        position: relative;
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -ms-flex-align: stretch;
        -webkit-box-align: stretch;
                align-items: stretch;
        width: 100%;
      }
      
      .input-group > .form-control,
      .input-group > .form-control-plaintext,
      .input-group > .custom-select,
      .input-group > .custom-file {
        position: relative;
        -ms-flex: 1 1 auto;
        -webkit-box-flex: 1;
                flex: 1 1 auto;
        width: 1%;
        margin-bottom: 0;
      }
      
      .input-group > .form-control + .form-control,
      .input-group > .form-control + .custom-select,
      .input-group > .form-control + .custom-file,
      .input-group > .form-control-plaintext + .form-control,
      .input-group > .form-control-plaintext + .custom-select,
      .input-group > .form-control-plaintext + .custom-file,
      .input-group > .custom-select + .form-control,
      .input-group > .custom-select + .custom-select,
      .input-group > .custom-select + .custom-file,
      .input-group > .custom-file + .form-control,
      .input-group > .custom-file + .custom-select,
      .input-group > .custom-file + .custom-file {
        margin-left: -1px;
      }
      
      .input-group > .form-control:focus,
      .input-group > .custom-select:focus,
      .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
        z-index: 3;
      }
      
      .input-group > .custom-file .custom-file-input:focus {
        z-index: 4;
      }
      
      .input-group > .form-control:not(:last-child),
      .input-group > .custom-select:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      
      .input-group > .form-control:not(:first-child),
      .input-group > .custom-select:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      
      .input-group > .custom-file {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
      }
      
      .input-group > .custom-file:not(:last-child) .custom-file-label,
      .input-group > .custom-file:not(:last-child) .custom-file-label::after {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      
      .input-group > .custom-file:not(:first-child) .custom-file-label {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      
      .input-group-prepend,
      .input-group-append {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
      }
      
      .input-group-prepend .btn,
      .input-group-append .btn {
        position: relative;
        z-index: 2;
      }
      
      .input-group-prepend .btn:focus,
      .input-group-append .btn:focus {
        z-index: 3;
      }
      
      .input-group-prepend .btn + .btn,
      .input-group-prepend .btn + .input-group-text,
      .input-group-prepend .input-group-text + .input-group-text,
      .input-group-prepend .input-group-text + .btn,
      .input-group-append .btn + .btn,
      .input-group-append .btn + .input-group-text,
      .input-group-append .input-group-text + .input-group-text,
      .input-group-append .input-group-text + .btn {
        margin-left: -1px;
      }
      
      .input-group-prepend {
        margin-right: -1px;
      }
      
      .input-group-append {
        margin-left: -1px;
      }
      
      .input-group-text {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
        padding: 0.375rem 0.75rem;
        margin-bottom: 0;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        text-align: center;
        white-space: nowrap;
        background-color: #e9ecef;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
      }
      
      .input-group-text input[type="radio"],
      .input-group-text input[type="checkbox"] {
        margin-top: 0;
      }
      
      .input-group-lg > .form-control:not(textarea),
      .input-group-lg > .custom-select {
        height: calc(1.5em + 1rem + 2px);
      }
      
      .input-group-lg > .form-control,
      .input-group-lg > .custom-select,
      .input-group-lg > .input-group-prepend > .input-group-text,
      .input-group-lg > .input-group-append > .input-group-text,
      .input-group-lg > .input-group-prepend > .btn,
      .input-group-lg > .input-group-append > .btn {
        padding: 0.5rem 1rem;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: 0.3rem;
      }
      
      .input-group-sm > .form-control:not(textarea),
      .input-group-sm > .custom-select {
        height: calc(1.5em + 0.5rem + 2px);
      }
      
      .input-group-sm > .form-control,
      .input-group-sm > .custom-select,
      .input-group-sm > .input-group-prepend > .input-group-text,
      .input-group-sm > .input-group-append > .input-group-text,
      .input-group-sm > .input-group-prepend > .btn,
      .input-group-sm > .input-group-append > .btn {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
      
      .input-group-lg > .custom-select,
      .input-group-sm > .custom-select {
        padding-right: 1.75rem;
      }
      
      .input-group > .input-group-prepend > .btn,
      .input-group > .input-group-prepend > .input-group-text,
      .input-group > .input-group-append:not(:last-child) > .btn,
      .input-group > .input-group-append:not(:last-child) > .input-group-text,
      .input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
      .input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      
      .input-group > .input-group-append > .btn,
      .input-group > .input-group-append > .input-group-text,
      .input-group > .input-group-prepend:not(:first-child) > .btn,
      .input-group > .input-group-prepend:not(:first-child) > .input-group-text,
      .input-group > .input-group-prepend:first-child > .btn:not(:first-child),
      .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      
      .custom-control {
        position: relative;
        display: block;
        min-height: 1.5rem;
        padding-left: 1.5rem;
      }
      
      .custom-control-inline {
        display: -ms-inline-flexbox;
        display: -webkit-inline-box;
        display: inline-flex;
        margin-right: 1rem;
      }
      
      .custom-control-input {
        position: absolute;
        z-index: -1;
        opacity: 0;
      }
      
      .custom-control-input:checked ~ .custom-control-label::before {
        color: #fff;
        border-color: #007bff;
        background-color: #007bff;
      }
      
      .custom-control-input:focus ~ .custom-control-label::before {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
      
      .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
        border-color: #80bdff;
      }
      
      .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
        color: #fff;
        background-color: #b3d7ff;
        border-color: #b3d7ff;
      }
      
      .custom-control-input:disabled ~ .custom-control-label {
        color: #6c757d;
      }
      
      .custom-control-input:disabled ~ .custom-control-label::before {
        background-color: #e9ecef;
      }
      
      .custom-control-label {
        position: relative;
        margin-bottom: 0;
        vertical-align: top;
      }
      
      .custom-control-label::before {
        position: absolute;
        top: 0.25rem;
        left: -1.5rem;
        display: block;
        width: 1rem;
        height: 1rem;
        pointer-events: none;
        content: "";
        background-color: #fff;
        border: #adb5bd solid 1px;
      }
      
      .custom-control-label::after {
        position: absolute;
        top: 0.25rem;
        left: -1.5rem;
        display: block;
        width: 1rem;
        height: 1rem;
        content: "";
        background: no-repeat 50% / 50% 50%;
      }
      
      .custom-checkbox .custom-control-label::before {
        border-radius: 0.25rem;
      }
      
      .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
      }
      
      .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
        border-color: #007bff;
        background-color: #007bff;
      }
      
      .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e");
      }
      
      .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
        background-color: rgba(0, 123, 255, 0.5);
      }
      
      .custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
        background-color: rgba(0, 123, 255, 0.5);
      }
      
      .custom-radio .custom-control-label::before {
        border-radius: 50%;
      }
      
      .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
      }
      
      .custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
        background-color: rgba(0, 123, 255, 0.5);
      }
      
      .custom-switch {
        padding-left: 2.25rem;
      }
      
      .custom-switch .custom-control-label::before {
        left: -2.25rem;
        width: 1.75rem;
        pointer-events: all;
        border-radius: 0.5rem;
      }
      
      .custom-switch .custom-control-label::after {
        top: calc(0.25rem + 2px);
        left: calc(-2.25rem + 2px);
        width: calc(1rem - 4px);
        height: calc(1rem - 4px);
        background-color: #adb5bd;
        border-radius: 0.5rem;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out;
        -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .custom-switch .custom-control-label::after {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
        background-color: #fff;
        -webkit-transform: translateX(0.75rem);
        transform: translateX(0.75rem);
      }
      
      .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
        background-color: rgba(0, 123, 255, 0.5);
      }
      
      .custom-select {
        display: inline-block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        vertical-align: middle;
        background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
        background-color: #fff;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
      }
      
      .custom-select:focus {
        border-color: #80bdff;
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
      
      .custom-select:focus::-ms-value {
        color: #495057;
        background-color: #fff;
      }
      
      .custom-select[multiple], .custom-select[size]:not([size="1"]) {
        height: auto;
        padding-right: 0.75rem;
        background-image: none;
      }
      
      .custom-select:disabled {
        color: #6c757d;
        background-color: #e9ecef;
      }
      
      .custom-select::-ms-expand {
        display: none;
      }
      
      .custom-select-sm {
        height: calc(1.5em + 0.5rem + 2px);
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        padding-left: 0.5rem;
        font-size: 0.875rem;
      }
      
      .custom-select-lg {
        height: calc(1.5em + 1rem + 2px);
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        padding-left: 1rem;
        font-size: 1.25rem;
      }
      
      .custom-file {
        position: relative;
        display: inline-block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        margin-bottom: 0;
      }
      
      .custom-file-input {
        position: relative;
        z-index: 2;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        margin: 0;
        opacity: 0;
      }
      
      .custom-file-input:focus ~ .custom-file-label {
        border-color: #80bdff;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
      
      .custom-file-input:disabled ~ .custom-file-label {
        background-color: #e9ecef;
      }
      
      .custom-file-input:lang(en) ~ .custom-file-label::after {
        content: "Browse";
      }
      
      .custom-file-input ~ .custom-file-label[data-browse]::after {
        content: attr(data-browse);
      }
      
      .custom-file-label {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        z-index: 1;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
      }
      
      .custom-file-label::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 3;
        display: block;
        height: calc(1.5em + 0.75rem);
        padding: 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        content: "Browse";
        background-color: #e9ecef;
        border-left: inherit;
        border-radius: 0 0.25rem 0.25rem 0;
      }
      
      .custom-range {
        width: 100%;
        height: calc(1rem + 0.4rem);
        padding: 0;
        background-color: transparent;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
      }
      
      .custom-range:focus {
        outline: none;
      }
      
      .custom-range:focus::-webkit-slider-thumb {
        -webkit-box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
      
      .custom-range:focus::-moz-range-thumb {
        box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
      
      .custom-range:focus::-ms-thumb {
        box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
      
      .custom-range::-moz-focus-outer {
        border: 0;
      }
      
      .custom-range::-webkit-slider-thumb {
        width: 1rem;
        height: 1rem;
        margin-top: -0.25rem;
        background-color: #007bff;
        border: 0;
        border-radius: 1rem;
        -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        -webkit-appearance: none;
        appearance: none;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .custom-range::-webkit-slider-thumb {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .custom-range::-webkit-slider-thumb:active {
        background-color: #b3d7ff;
      }
      
      .custom-range::-webkit-slider-runnable-track {
        width: 100%;
        height: 0.5rem;
        color: transparent;
        cursor: pointer;
        background-color: #dee2e6;
        border-color: transparent;
        border-radius: 1rem;
      }
      
      .custom-range::-moz-range-thumb {
        width: 1rem;
        height: 1rem;
        background-color: #007bff;
        border: 0;
        border-radius: 1rem;
        -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        -moz-appearance: none;
        appearance: none;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .custom-range::-moz-range-thumb {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .custom-range::-moz-range-thumb:active {
        background-color: #b3d7ff;
      }
      
      .custom-range::-moz-range-track {
        width: 100%;
        height: 0.5rem;
        color: transparent;
        cursor: pointer;
        background-color: #dee2e6;
        border-color: transparent;
        border-radius: 1rem;
      }
      
      .custom-range::-ms-thumb {
        width: 1rem;
        height: 1rem;
        margin-top: 0;
        margin-right: 0.2rem;
        margin-left: 0.2rem;
        background-color: #007bff;
        border: 0;
        border-radius: 1rem;
        -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        appearance: none;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .custom-range::-ms-thumb {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .custom-range::-ms-thumb:active {
        background-color: #b3d7ff;
      }
      
      .custom-range::-ms-track {
        width: 100%;
        height: 0.5rem;
        color: transparent;
        cursor: pointer;
        background-color: transparent;
        border-color: transparent;
        border-width: 0.5rem;
      }
      
      .custom-range::-ms-fill-lower {
        background-color: #dee2e6;
        border-radius: 1rem;
      }
      
      .custom-range::-ms-fill-upper {
        margin-right: 15px;
        background-color: #dee2e6;
        border-radius: 1rem;
      }
      
      .custom-range:disabled::-webkit-slider-thumb {
        background-color: #adb5bd;
      }
      
      .custom-range:disabled::-webkit-slider-runnable-track {
        cursor: default;
      }
      
      .custom-range:disabled::-moz-range-thumb {
        background-color: #adb5bd;
      }
      
      .custom-range:disabled::-moz-range-track {
        cursor: default;
      }
      
      .custom-range:disabled::-ms-thumb {
        background-color: #adb5bd;
      }
      
      .custom-control-label::before,
      .custom-file-label,
      .custom-select {
        -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .custom-control-label::before,
        .custom-file-label,
        .custom-select {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .nav {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
      }
      
      .nav-link {
        display: block;
        padding: 0.5rem 1rem;
      }
      
      .nav-link:hover, .nav-link:focus {
        text-decoration: none;
      }
      
      .nav-link.disabled {
        color: #6c757d;
        pointer-events: none;
        cursor: default;
      }
      
      .nav-tabs {
        border-bottom: 1px solid #dee2e6;
      }
      
      .nav-tabs .nav-item {
        margin-bottom: -1px;
      }
      
      .nav-tabs .nav-link {
        border: 1px solid transparent;
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
      }
      
      .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
        border-color: #e9ecef #e9ecef #dee2e6;
      }
      
      .nav-tabs .nav-link.disabled {
        color: #6c757d;
        background-color: transparent;
        border-color: transparent;
      }
      
      .nav-tabs .nav-link.active,
      .nav-tabs .nav-item.show .nav-link {
        color: #495057;
        background-color: #fff;
        border-color: #dee2e6 #dee2e6 #fff;
      }
      
      .nav-tabs .dropdown-menu {
        margin-top: -1px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
      
      .nav-pills .nav-link {
        border-radius: 0.25rem;
      }
      
      .nav-pills .nav-link.active,
      .nav-pills .show > .nav-link {
        color: #fff;
        background-color: #007bff;
      }
      
      .nav-fill .nav-item {
        -ms-flex: 1 1 auto;
        -webkit-box-flex: 1;
                flex: 1 1 auto;
        text-align: center;
      }
      
      .nav-justified .nav-item {
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -ms-flex-positive: 1;
        -webkit-box-flex: 1;
                flex-grow: 1;
        text-align: center;
      }
      
      .tab-content > .tab-pane {
        display: none;
      }
      
      .tab-content > .active {
        display: block;
      }
      
      .navbar {
        position: relative;
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
        -ms-flex-pack: justify;
        -webkit-box-pack: justify;
                justify-content: space-between;
        padding: 0.5rem 1rem;
      }
      
      .navbar > .container,
      .navbar > .container-fluid {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
        -ms-flex-pack: justify;
        -webkit-box-pack: justify;
                justify-content: space-between;
      }
      
      .navbar-brand {
        display: inline-block;
        padding-top: 0.3125rem;
        padding-bottom: 0.3125rem;
        margin-right: 1rem;
        font-size: 1.25rem;
        line-height: inherit;
        white-space: nowrap;
      }
      
      .navbar-brand:hover, .navbar-brand:focus {
        text-decoration: none;
      }
      
      .navbar-nav {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
                flex-direction: column;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
      }
      
      .navbar-nav .nav-link {
        padding-right: 0;
        padding-left: 0;
      }
      
      .navbar-nav .dropdown-menu {
        position: static;
        float: none;
      }
      
      .navbar-text {
        display: inline-block;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
      }
      
      .navbar-collapse {
        -ms-flex-preferred-size: 100%;
        flex-basis: 100%;
        -ms-flex-positive: 1;
        -webkit-box-flex: 1;
                flex-grow: 1;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
      }
      
      .navbar-toggler {
        padding: 0.25rem 0.75rem;
        font-size: 1.25rem;
        line-height: 1;
        background-color: transparent;
        border: 1px solid transparent;
        border-radius: 0.25rem;
      }
      
      .navbar-toggler:hover, .navbar-toggler:focus {
        text-decoration: none;
      }
      
      .navbar-toggler-icon {
        display: inline-block;
        width: 1.5em;
        height: 1.5em;
        vertical-align: middle;
        content: "";
        background: no-repeat center center;
        background-size: 100% 100%;
      }
      
      @media (max-width: 575.98px) {
        .navbar-expand-sm > .container,
        .navbar-expand-sm > .container-fluid {
          padding-right: 0;
          padding-left: 0;
        }
      }
      
      @media (min-width: 576px) {
        .navbar-expand-sm {
          -ms-flex-flow: row nowrap;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-flow: row nowrap;
          -ms-flex-pack: start;
          -webkit-box-pack: start;
                  justify-content: flex-start;
        }
        .navbar-expand-sm .navbar-nav {
          -ms-flex-direction: row;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-direction: row;
        }
        .navbar-expand-sm .navbar-nav .dropdown-menu {
          position: absolute;
        }
        .navbar-expand-sm .navbar-nav .nav-link {
          padding-right: 0.5rem;
          padding-left: 0.5rem;
        }
        .navbar-expand-sm > .container,
        .navbar-expand-sm > .container-fluid {
          -ms-flex-wrap: nowrap;
          flex-wrap: nowrap;
        }
        .navbar-expand-sm .navbar-collapse {
          display: -ms-flexbox !important;
          display: -webkit-box !important;
          display: flex !important;
          -ms-flex-preferred-size: auto;
          flex-basis: auto;
        }
        .navbar-expand-sm .navbar-toggler {
          display: none;
        }
      }
      
      @media (max-width: 767.98px) {
        .navbar-expand-md > .container,
        .navbar-expand-md > .container-fluid {
          padding-right: 0;
          padding-left: 0;
        }
      }
      
      @media (min-width: 768px) {
        .navbar-expand-md {
          -ms-flex-flow: row nowrap;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-flow: row nowrap;
          -ms-flex-pack: start;
          -webkit-box-pack: start;
                  justify-content: flex-start;
        }
        .navbar-expand-md .navbar-nav {
          -ms-flex-direction: row;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-direction: row;
        }
        .navbar-expand-md .navbar-nav .dropdown-menu {
          position: absolute;
        }
        .navbar-expand-md .navbar-nav .nav-link {
          padding-right: 0.5rem;
          padding-left: 0.5rem;
        }
        .navbar-expand-md > .container,
        .navbar-expand-md > .container-fluid {
          -ms-flex-wrap: nowrap;
          flex-wrap: nowrap;
        }
        .navbar-expand-md .navbar-collapse {
          display: -ms-flexbox !important;
          display: -webkit-box !important;
          display: flex !important;
          -ms-flex-preferred-size: auto;
          flex-basis: auto;
        }
        .navbar-expand-md .navbar-toggler {
          display: none;
        }
      }
      
      @media (max-width: 991.98px) {
        .navbar-expand-lg > .container,
        .navbar-expand-lg > .container-fluid {
          padding-right: 0;
          padding-left: 0;
        }
      }
      
      @media (min-width: 992px) {
        .navbar-expand-lg {
          -ms-flex-flow: row nowrap;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-flow: row nowrap;
          -ms-flex-pack: start;
          -webkit-box-pack: start;
                  justify-content: flex-start;
        }
        .navbar-expand-lg .navbar-nav {
          -ms-flex-direction: row;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-direction: row;
        }
        .navbar-expand-lg .navbar-nav .dropdown-menu {
          position: absolute;
        }
        .navbar-expand-lg .navbar-nav .nav-link {
          padding-right: 0.5rem;
          padding-left: 0.5rem;
        }
        .navbar-expand-lg > .container,
        .navbar-expand-lg > .container-fluid {
          -ms-flex-wrap: nowrap;
          flex-wrap: nowrap;
        }
        .navbar-expand-lg .navbar-collapse {
          display: -ms-flexbox !important;
          display: -webkit-box !important;
          display: flex !important;
          -ms-flex-preferred-size: auto;
          flex-basis: auto;
        }
        .navbar-expand-lg .navbar-toggler {
          display: none;
        }
      }
      
      @media (max-width: 1199.98px) {
        .navbar-expand-xl > .container,
        .navbar-expand-xl > .container-fluid {
          padding-right: 0;
          padding-left: 0;
        }
      }
      
      @media (min-width: 1200px) {
        .navbar-expand-xl {
          -ms-flex-flow: row nowrap;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-flow: row nowrap;
          -ms-flex-pack: start;
          -webkit-box-pack: start;
                  justify-content: flex-start;
        }
        .navbar-expand-xl .navbar-nav {
          -ms-flex-direction: row;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-direction: row;
        }
        .navbar-expand-xl .navbar-nav .dropdown-menu {
          position: absolute;
        }
        .navbar-expand-xl .navbar-nav .nav-link {
          padding-right: 0.5rem;
          padding-left: 0.5rem;
        }
        .navbar-expand-xl > .container,
        .navbar-expand-xl > .container-fluid {
          -ms-flex-wrap: nowrap;
          flex-wrap: nowrap;
        }
        .navbar-expand-xl .navbar-collapse {
          display: -ms-flexbox !important;
          display: -webkit-box !important;
          display: flex !important;
          -ms-flex-preferred-size: auto;
          flex-basis: auto;
        }
        .navbar-expand-xl .navbar-toggler {
          display: none;
        }
      }
      
      .navbar-expand {
        -ms-flex-flow: row nowrap;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
                flex-flow: row nowrap;
        -ms-flex-pack: start;
        -webkit-box-pack: start;
                justify-content: flex-start;
      }
      
      .navbar-expand > .container,
      .navbar-expand > .container-fluid {
        padding-right: 0;
        padding-left: 0;
      }
      
      .navbar-expand .navbar-nav {
        -ms-flex-direction: row;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
                flex-direction: row;
      }
      
      .navbar-expand .navbar-nav .dropdown-menu {
        position: absolute;
      }
      
      .navbar-expand .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem;
      }
      
      .navbar-expand > .container,
      .navbar-expand > .container-fluid {
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
      }
      
      .navbar-expand .navbar-collapse {
        display: -ms-flexbox !important;
        display: -webkit-box !important;
        display: flex !important;
        -ms-flex-preferred-size: auto;
        flex-basis: auto;
      }
      
      .navbar-expand .navbar-toggler {
        display: none;
      }
      
      .navbar-light .navbar-brand {
        color: rgba(0, 0, 0, 0.9);
      }
      
      .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
        color: rgba(0, 0, 0, 0.9);
      }
      
      .navbar-light .navbar-nav .nav-link {
        color: rgba(0, 0, 0, 0.5);
      }
      
      .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
        color: rgba(0, 0, 0, 0.7);
      }
      
      .navbar-light .navbar-nav .nav-link.disabled {
        color: rgba(0, 0, 0, 0.3);
      }
      
      .navbar-light .navbar-nav .show > .nav-link,
      .navbar-light .navbar-nav .active > .nav-link,
      .navbar-light .navbar-nav .nav-link.show,
      .navbar-light .navbar-nav .nav-link.active {
        color: rgba(0, 0, 0, 0.9);
      }
      
      .navbar-light .navbar-toggler {
        color: rgba(0, 0, 0, 0.5);
        border-color: rgba(0, 0, 0, 0.1);
      }
      
      .navbar-light .navbar-toggler-icon {
        background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
      }
      
      .navbar-light .navbar-text {
        color: rgba(0, 0, 0, 0.5);
      }
      
      .navbar-light .navbar-text a {
        color: rgba(0, 0, 0, 0.9);
      }
      
      .navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
        color: rgba(0, 0, 0, 0.9);
      }
      
      .navbar-dark .navbar-brand {
        color: #fff;
      }
      
      .navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
        color: #fff;
      }
      
      .navbar-dark .navbar-nav .nav-link {
        color: rgba(255, 255, 255, 0.5);
      }
      
      .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
        color: rgba(255, 255, 255, 0.75);
      }
      
      .navbar-dark .navbar-nav .nav-link.disabled {
        color: rgba(255, 255, 255, 0.25);
      }
      
      .navbar-dark .navbar-nav .show > .nav-link,
      .navbar-dark .navbar-nav .active > .nav-link,
      .navbar-dark .navbar-nav .nav-link.show,
      .navbar-dark .navbar-nav .nav-link.active {
        color: #fff;
      }
      
      .navbar-dark .navbar-toggler {
        color: rgba(255, 255, 255, 0.5);
        border-color: rgba(255, 255, 255, 0.1);
      }
      
      .navbar-dark .navbar-toggler-icon {
        background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
      }
      
      .navbar-dark .navbar-text {
        color: rgba(255, 255, 255, 0.5);
      }
      
      .navbar-dark .navbar-text a {
        color: #fff;
      }
      
      .navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
        color: #fff;
      }
      
      .card {
        position: relative;
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
                flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
      }
      
      .card > hr {
        margin-right: 0;
        margin-left: 0;
      }
      
      .card > .list-group:first-child .list-group-item:first-child {
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
      }
      
      .card > .list-group:last-child .list-group-item:last-child {
        border-bottom-right-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
      }
      
      .card-body {
        -ms-flex: 1 1 auto;
        -webkit-box-flex: 1;
                flex: 1 1 auto;
        padding: 1.25rem;
      }
      
      .card-title {
        margin-bottom: 0.75rem;
      }
      
      .card-subtitle {
        margin-top: -0.375rem;
        margin-bottom: 0;
      }
      
      .card-text:last-child {
        margin-bottom: 0;
      }
      
      .card-link:hover {
        text-decoration: none;
      }
      
      .card-link + .card-link {
        margin-left: 1.25rem;
      }
      
      .card-header {
        padding: 0.75rem 1.25rem;
        margin-bottom: 0;
        background-color: rgba(0, 0, 0, 0.03);
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
      }
      
      .card-header:first-child {
        border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
      }
      
      .card-header + .list-group .list-group-item:first-child {
        border-top: 0;
      }
      
      .card-footer {
        padding: 0.75rem 1.25rem;
        background-color: rgba(0, 0, 0, 0.03);
        border-top: 1px solid rgba(0, 0, 0, 0.125);
      }
      
      .card-footer:last-child {
        border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
      }
      
      .card-header-tabs {
        margin-right: -0.625rem;
        margin-bottom: -0.75rem;
        margin-left: -0.625rem;
        border-bottom: 0;
      }
      
      .card-header-pills {
        margin-right: -0.625rem;
        margin-left: -0.625rem;
      }
      
      .card-img-overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 1.25rem;
      }
      
      .card-img {
        width: 100%;
        border-radius: calc(0.25rem - 1px);
      }
      
      .card-img-top {
        width: 100%;
        border-top-left-radius: calc(0.25rem - 1px);
        border-top-right-radius: calc(0.25rem - 1px);
      }
      
      .card-img-bottom {
        width: 100%;
        border-bottom-right-radius: calc(0.25rem - 1px);
        border-bottom-left-radius: calc(0.25rem - 1px);
      }
      
      .card-deck {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
                flex-direction: column;
      }
      
      .card-deck .card {
        margin-bottom: 15px;
      }
      
      @media (min-width: 576px) {
        .card-deck {
          -ms-flex-flow: row wrap;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-flow: row wrap;
          margin-right: -15px;
          margin-left: -15px;
        }
        .card-deck .card {
          display: -ms-flexbox;
          display: -webkit-box;
          display: flex;
          -ms-flex: 1 0 0%;
          -webkit-box-flex: 1;
                  flex: 1 0 0%;
          -ms-flex-direction: column;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
                  flex-direction: column;
          margin-right: 15px;
          margin-bottom: 0;
          margin-left: 15px;
        }
      }
      
      .card-group {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
                flex-direction: column;
      }
      
      .card-group > .card {
        margin-bottom: 15px;
      }
      
      @media (min-width: 576px) {
        .card-group {
          -ms-flex-flow: row wrap;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-flow: row wrap;
        }
        .card-group > .card {
          -ms-flex: 1 0 0%;
          -webkit-box-flex: 1;
                  flex: 1 0 0%;
          margin-bottom: 0;
        }
        .card-group > .card + .card {
          margin-left: 0;
          border-left: 0;
        }
        .card-group > .card:not(:last-child) {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
        .card-group > .card:not(:last-child) .card-img-top,
        .card-group > .card:not(:last-child) .card-header {
          border-top-right-radius: 0;
        }
        .card-group > .card:not(:last-child) .card-img-bottom,
        .card-group > .card:not(:last-child) .card-footer {
          border-bottom-right-radius: 0;
        }
        .card-group > .card:not(:first-child) {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
        .card-group > .card:not(:first-child) .card-img-top,
        .card-group > .card:not(:first-child) .card-header {
          border-top-left-radius: 0;
        }
        .card-group > .card:not(:first-child) .card-img-bottom,
        .card-group > .card:not(:first-child) .card-footer {
          border-bottom-left-radius: 0;
        }
      }
      
      .card-columns .card {
        margin-bottom: 0.75rem;
      }
      
      @media (min-width: 576px) {
        .card-columns {
          -webkit-column-count: 3;
          -moz-column-count: 3;
          column-count: 3;
          -webkit-column-gap: 1.25rem;
          -moz-column-gap: 1.25rem;
          column-gap: 1.25rem;
          orphans: 1;
          widows: 1;
        }
        .card-columns .card {
          display: inline-block;
          width: 100%;
        }
      }
      
      .accordion > .card {
        overflow: hidden;
      }
      
      .accordion > .card:not(:first-of-type) .card-header:first-child {
        border-radius: 0;
      }
      
      .accordion > .card:not(:first-of-type):not(:last-of-type) {
        border-bottom: 0;
        border-radius: 0;
      }
      
      .accordion > .card:first-of-type {
        border-bottom: 0;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      }
      
      .accordion > .card:last-of-type {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
      
      .accordion > .card .card-header {
        margin-bottom: -1px;
      }
      
      .breadcrumb {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding: 0.75rem 1rem;
        margin-bottom: 1rem;
        list-style: none;
        background-color: #e9ecef;
        border-radius: 0.25rem;
      }
      
      .breadcrumb-item + .breadcrumb-item {
        padding-left: 0.5rem;
      }
      
      .breadcrumb-item + .breadcrumb-item::before {
        display: inline-block;
        padding-right: 0.5rem;
        color: #6c757d;
        content: "/";
      }
      
      .breadcrumb-item + .breadcrumb-item:hover::before {
        text-decoration: underline;
      }
      
      .breadcrumb-item + .breadcrumb-item:hover::before {
        text-decoration: none;
      }
      
      .breadcrumb-item.active {
        color: #6c757d;
      }
      
      .pagination {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        padding-left: 0;
        list-style: none;
        border-radius: 0.25rem;
      }
      
      .page-link {
        position: relative;
        display: block;
        padding: 0.5rem 0.75rem;
        margin-left: -1px;
        line-height: 1.25;
        color: #007bff;
        background-color: #fff;
        border: 1px solid #dee2e6;
      }
      
      .page-link:hover {
        z-index: 2;
        color: #0056b3;
        text-decoration: none;
        background-color: #e9ecef;
        border-color: #dee2e6;
      }
      
      .page-link:focus {
        z-index: 2;
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
      
      .page-item:first-child .page-link {
        margin-left: 0;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
      }
      
      .page-item:last-child .page-link {
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
      }
      
      .page-item.active .page-link {
        z-index: 1;
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
      }
      
      .page-item.disabled .page-link {
        color: #6c757d;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
      }
      
      .pagination-lg .page-link {
        padding: 0.75rem 1.5rem;
        font-size: 1.25rem;
        line-height: 1.5;
      }
      
      .pagination-lg .page-item:first-child .page-link {
        border-top-left-radius: 0.3rem;
        border-bottom-left-radius: 0.3rem;
      }
      
      .pagination-lg .page-item:last-child .page-link {
        border-top-right-radius: 0.3rem;
        border-bottom-right-radius: 0.3rem;
      }
      
      .pagination-sm .page-link {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
      }
      
      .pagination-sm .page-item:first-child .page-link {
        border-top-left-radius: 0.2rem;
        border-bottom-left-radius: 0.2rem;
      }
      
      .pagination-sm .page-item:last-child .page-link {
        border-top-right-radius: 0.2rem;
        border-bottom-right-radius: 0.2rem;
      }
      
      .badge {
        display: inline-block;
        padding: 0.25em 0.4em;
        font-size: 75%;
        font-weight: 700;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: 0.25rem;
        -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .badge {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      a.badge:hover, a.badge:focus {
        text-decoration: none;
      }
      
      .badge:empty {
        display: none;
      }
      
      .btn .badge {
        position: relative;
        top: -1px;
      }
      
      .badge-pill {
        padding-right: 0.6em;
        padding-left: 0.6em;
        border-radius: 10rem;
      }
      
      .badge-primary {
        color: #fff;
        background-color: #007bff;
      }
      
      a.badge-primary:hover, a.badge-primary:focus {
        color: #fff;
        background-color: #0062cc;
      }
      
      a.badge-primary:focus, a.badge-primary.focus {
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
      }
      
      .badge-secondary {
        color: #fff;
        background-color: #6c757d;
      }
      
      a.badge-secondary:hover, a.badge-secondary:focus {
        color: #fff;
        background-color: #545b62;
      }
      
      a.badge-secondary:focus, a.badge-secondary.focus {
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
      }
      
      .badge-success {
        color: #fff;
        background-color: #28a745;
      }
      
      a.badge-success:hover, a.badge-success:focus {
        color: #fff;
        background-color: #1e7e34;
      }
      
      a.badge-success:focus, a.badge-success.focus {
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
      }
      
      .badge-info {
        color: #fff;
        background-color: #17a2b8;
      }
      
      a.badge-info:hover, a.badge-info:focus {
        color: #fff;
        background-color: #117a8b;
      }
      
      a.badge-info:focus, a.badge-info.focus {
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
      }
      
      .badge-warning {
        color: #212529;
        background-color: #ffc107;
      }
      
      a.badge-warning:hover, a.badge-warning:focus {
        color: #212529;
        background-color: #d39e00;
      }
      
      a.badge-warning:focus, a.badge-warning.focus {
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
      }
      
      .badge-danger {
        color: #fff;
        background-color: #dc3545;
      }
      
      a.badge-danger:hover, a.badge-danger:focus {
        color: #fff;
        background-color: #bd2130;
      }
      
      a.badge-danger:focus, a.badge-danger.focus {
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
      }
      
      .badge-light {
        color: #212529;
        background-color: #f8f9fa;
      }
      
      a.badge-light:hover, a.badge-light:focus {
        color: #212529;
        background-color: #dae0e5;
      }
      
      a.badge-light:focus, a.badge-light.focus {
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
      }
      
      .badge-dark {
        color: #fff;
        background-color: #343a40;
      }
      
      a.badge-dark:hover, a.badge-dark:focus {
        color: #fff;
        background-color: #1d2124;
      }
      
      a.badge-dark:focus, a.badge-dark.focus {
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
                box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
      }
      
      .jumbotron {
        padding: 2rem 1rem;
        margin-bottom: 2rem;
        background-color: #e9ecef;
        border-radius: 0.3rem;
      }
      
      @media (min-width: 576px) {
        .jumbotron {
          padding: 4rem 2rem;
        }
      }
      
      .jumbotron-fluid {
        padding-right: 0;
        padding-left: 0;
        border-radius: 0;
      }
      
      .alert {
        position: relative;
        padding: 0.75rem 1.25rem;
        margin-bottom: 1rem;
        border: 1px solid transparent;
        border-radius: 0.25rem;
      }
      
      .alert-heading {
        color: inherit;
      }
      
      .alert-link {
        font-weight: 700;
      }
      
      .alert-dismissible {
        padding-right: 4rem;
      }
      
      .alert-dismissible .close {
        position: absolute;
        top: 0;
        right: 0;
        padding: 0.75rem 1.25rem;
        color: inherit;
      }
      
      .alert-primary {
        color: #004085;
        background-color: #cce5ff;
        border-color: #b8daff;
      }
      
      .alert-primary hr {
        border-top-color: #9fcdff;
      }
      
      .alert-primary .alert-link {
        color: #002752;
      }
      
      .alert-secondary {
        color: #383d41;
        background-color: #e2e3e5;
        border-color: #d6d8db;
      }
      
      .alert-secondary hr {
        border-top-color: #c8cbcf;
      }
      
      .alert-secondary .alert-link {
        color: #202326;
      }
      
      .alert-success {
        color: #155724;
        background-color: #d4edda;
        border-color: #c3e6cb;
      }
      
      .alert-success hr {
        border-top-color: #b1dfbb;
      }
      
      .alert-success .alert-link {
        color: #0b2e13;
      }
      
      .alert-info {
        color: #0c5460;
        background-color: #d1ecf1;
        border-color: #bee5eb;
      }
      
      .alert-info hr {
        border-top-color: #abdde5;
      }
      
      .alert-info .alert-link {
        color: #062c33;
      }
      
      .alert-warning {
        color: #856404;
        background-color: #fff3cd;
        border-color: #ffeeba;
      }
      
      .alert-warning hr {
        border-top-color: #ffe8a1;
      }
      
      .alert-warning .alert-link {
        color: #533f03;
      }
      
      .alert-danger {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
      }
      
      .alert-danger hr {
        border-top-color: #f1b0b7;
      }
      
      .alert-danger .alert-link {
        color: #491217;
      }
      
      .alert-light {
        color: #818182;
        background-color: #fefefe;
        border-color: #fdfdfe;
      }
      
      .alert-light hr {
        border-top-color: #ececf6;
      }
      
      .alert-light .alert-link {
        color: #686868;
      }
      
      .alert-dark {
        color: #1b1e21;
        background-color: #d6d8d9;
        border-color: #c6c8ca;
      }
      
      .alert-dark hr {
        border-top-color: #b9bbbe;
      }
      
      .alert-dark .alert-link {
        color: #040505;
      }
      
      @-webkit-keyframes progress-bar-stripes {
        from {
          background-position: 1rem 0;
        }
        to {
          background-position: 0 0;
        }
      }
      
      @keyframes progress-bar-stripes {
        from {
          background-position: 1rem 0;
        }
        to {
          background-position: 0 0;
        }
      }
      
      .progress {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        height: 1rem;
        overflow: hidden;
        font-size: 0.75rem;
        background-color: #e9ecef;
        border-radius: 0.25rem;
      }
      
      .progress-bar {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
                flex-direction: column;
        -ms-flex-pack: center;
        -webkit-box-pack: center;
                justify-content: center;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        background-color: #007bff;
        -webkit-transition: width 0.6s ease;
        transition: width 0.6s ease;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .progress-bar {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .progress-bar-striped {
        background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
        background-size: 1rem 1rem;
      }
      
      .progress-bar-animated {
        -webkit-animation: progress-bar-stripes 1s linear infinite;
        animation: progress-bar-stripes 1s linear infinite;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .progress-bar-animated {
          -webkit-animation: none;
          animation: none;
        }
      }
      
      .media {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-align: start;
        -webkit-box-align: start;
                align-items: flex-start;
      }
      
      .media-body {
        -ms-flex: 1;
        -webkit-box-flex: 1;
                flex: 1;
      }
      
      .list-group {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
                flex-direction: column;
        padding-left: 0;
        margin-bottom: 0;
      }
      
      .list-group-item-action {
        width: 100%;
        color: #495057;
        text-align: inherit;
      }
      
      .list-group-item-action:hover, .list-group-item-action:focus {
        z-index: 1;
        color: #495057;
        text-decoration: none;
        background-color: #f8f9fa;
      }
      
      .list-group-item-action:active {
        color: #212529;
        background-color: #e9ecef;
      }
      
      .list-group-item {
        position: relative;
        display: block;
        padding: 0.75rem 1.25rem;
        margin-bottom: -1px;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.125);
      }
      
      .list-group-item:first-child {
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
      }
      
      .list-group-item:last-child {
        margin-bottom: 0;
        border-bottom-right-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
      }
      
      .list-group-item.disabled, .list-group-item:disabled {
        color: #6c757d;
        pointer-events: none;
        background-color: #fff;
      }
      
      .list-group-item.active {
        z-index: 2;
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
      }
      
      .list-group-horizontal {
        -ms-flex-direction: row;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
                flex-direction: row;
      }
      
      .list-group-horizontal .list-group-item {
        margin-right: -1px;
        margin-bottom: 0;
      }
      
      .list-group-horizontal .list-group-item:first-child {
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
        border-top-right-radius: 0;
      }
      
      .list-group-horizontal .list-group-item:last-child {
        margin-right: 0;
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
        border-bottom-left-radius: 0;
      }
      
      @media (min-width: 576px) {
        .list-group-horizontal-sm {
          -ms-flex-direction: row;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-direction: row;
        }
        .list-group-horizontal-sm .list-group-item {
          margin-right: -1px;
          margin-bottom: 0;
        }
        .list-group-horizontal-sm .list-group-item:first-child {
          border-top-left-radius: 0.25rem;
          border-bottom-left-radius: 0.25rem;
          border-top-right-radius: 0;
        }
        .list-group-horizontal-sm .list-group-item:last-child {
          margin-right: 0;
          border-top-right-radius: 0.25rem;
          border-bottom-right-radius: 0.25rem;
          border-bottom-left-radius: 0;
        }
      }
      
      @media (min-width: 768px) {
        .list-group-horizontal-md {
          -ms-flex-direction: row;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-direction: row;
        }
        .list-group-horizontal-md .list-group-item {
          margin-right: -1px;
          margin-bottom: 0;
        }
        .list-group-horizontal-md .list-group-item:first-child {
          border-top-left-radius: 0.25rem;
          border-bottom-left-radius: 0.25rem;
          border-top-right-radius: 0;
        }
        .list-group-horizontal-md .list-group-item:last-child {
          margin-right: 0;
          border-top-right-radius: 0.25rem;
          border-bottom-right-radius: 0.25rem;
          border-bottom-left-radius: 0;
        }
      }
      
      @media (min-width: 992px) {
        .list-group-horizontal-lg {
          -ms-flex-direction: row;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-direction: row;
        }
        .list-group-horizontal-lg .list-group-item {
          margin-right: -1px;
          margin-bottom: 0;
        }
        .list-group-horizontal-lg .list-group-item:first-child {
          border-top-left-radius: 0.25rem;
          border-bottom-left-radius: 0.25rem;
          border-top-right-radius: 0;
        }
        .list-group-horizontal-lg .list-group-item:last-child {
          margin-right: 0;
          border-top-right-radius: 0.25rem;
          border-bottom-right-radius: 0.25rem;
          border-bottom-left-radius: 0;
        }
      }
      
      @media (min-width: 1200px) {
        .list-group-horizontal-xl {
          -ms-flex-direction: row;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-direction: row;
        }
        .list-group-horizontal-xl .list-group-item {
          margin-right: -1px;
          margin-bottom: 0;
        }
        .list-group-horizontal-xl .list-group-item:first-child {
          border-top-left-radius: 0.25rem;
          border-bottom-left-radius: 0.25rem;
          border-top-right-radius: 0;
        }
        .list-group-horizontal-xl .list-group-item:last-child {
          margin-right: 0;
          border-top-right-radius: 0.25rem;
          border-bottom-right-radius: 0.25rem;
          border-bottom-left-radius: 0;
        }
      }
      
      .list-group-flush .list-group-item {
        border-right: 0;
        border-left: 0;
        border-radius: 0;
      }
      
      .list-group-flush .list-group-item:last-child {
        margin-bottom: -1px;
      }
      
      .list-group-flush:first-child .list-group-item:first-child {
        border-top: 0;
      }
      
      .list-group-flush:last-child .list-group-item:last-child {
        margin-bottom: 0;
        border-bottom: 0;
      }
      
      .list-group-item-primary {
        color: #004085;
        background-color: #b8daff;
      }
      
      .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
        color: #004085;
        background-color: #9fcdff;
      }
      
      .list-group-item-primary.list-group-item-action.active {
        color: #fff;
        background-color: #004085;
        border-color: #004085;
      }
      
      .list-group-item-secondary {
        color: #383d41;
        background-color: #d6d8db;
      }
      
      .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
        color: #383d41;
        background-color: #c8cbcf;
      }
      
      .list-group-item-secondary.list-group-item-action.active {
        color: #fff;
        background-color: #383d41;
        border-color: #383d41;
      }
      
      .list-group-item-success {
        color: #155724;
        background-color: #c3e6cb;
      }
      
      .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
        color: #155724;
        background-color: #b1dfbb;
      }
      
      .list-group-item-success.list-group-item-action.active {
        color: #fff;
        background-color: #155724;
        border-color: #155724;
      }
      
      .list-group-item-info {
        color: #0c5460;
        background-color: #bee5eb;
      }
      
      .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
        color: #0c5460;
        background-color: #abdde5;
      }
      
      .list-group-item-info.list-group-item-action.active {
        color: #fff;
        background-color: #0c5460;
        border-color: #0c5460;
      }
      
      .list-group-item-warning {
        color: #856404;
        background-color: #ffeeba;
      }
      
      .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
        color: #856404;
        background-color: #ffe8a1;
      }
      
      .list-group-item-warning.list-group-item-action.active {
        color: #fff;
        background-color: #856404;
        border-color: #856404;
      }
      
      .list-group-item-danger {
        color: #721c24;
        background-color: #f5c6cb;
      }
      
      .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
        color: #721c24;
        background-color: #f1b0b7;
      }
      
      .list-group-item-danger.list-group-item-action.active {
        color: #fff;
        background-color: #721c24;
        border-color: #721c24;
      }
      
      .list-group-item-light {
        color: #818182;
        background-color: #fdfdfe;
      }
      
      .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
        color: #818182;
        background-color: #ececf6;
      }
      
      .list-group-item-light.list-group-item-action.active {
        color: #fff;
        background-color: #818182;
        border-color: #818182;
      }
      
      .list-group-item-dark {
        color: #1b1e21;
        background-color: #c6c8ca;
      }
      
      .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
        color: #1b1e21;
        background-color: #b9bbbe;
      }
      
      .list-group-item-dark.list-group-item-action.active {
        color: #fff;
        background-color: #1b1e21;
        border-color: #1b1e21;
      }
      
      .close {
        float: right;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        opacity: .5;
      }
      
      .close:hover {
        color: #000;
        text-decoration: none;
      }
      
      .close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
        opacity: .75;
      }
      
      button.close {
        padding: 0;
        background-color: transparent;
        border: 0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
      }
      
      a.close.disabled {
        pointer-events: none;
      }
      
      .toast {
        max-width: 350px;
        overflow: hidden;
        font-size: 0.875rem;
        background-color: rgba(255, 255, 255, 0.85);
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
                box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        opacity: 0;
        border-radius: 0.25rem;
      }
      
      .toast:not(:last-child) {
        margin-bottom: 0.75rem;
      }
      
      .toast.showing {
        opacity: 1;
      }
      
      .toast.show {
        display: block;
        opacity: 1;
      }
      
      .toast.hide {
        display: none;
      }
      
      .toast-header {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
        padding: 0.25rem 0.75rem;
        color: #6c757d;
        background-color: rgba(255, 255, 255, 0.85);
        background-clip: padding-box;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      }
      
      .toast-body {
        padding: 0.75rem;
      }
      
      .modal-open {
        overflow: hidden;
      }
      
      .modal-open .modal {
        overflow-x: hidden;
        overflow-y: auto;
      }
      
      .modal {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1050;
        display: none;
        width: 100%;
        height: 100%;
        overflow: hidden;
        outline: 0;
      }
      
      .modal-dialog {
        position: relative;
        width: auto;
        margin: 0.5rem;
        pointer-events: none;
      }
      
      .modal.fade .modal-dialog {
        transition: -webkit-transform 0.3s ease-out;
        -webkit-transition: -webkit-transform 0.3s ease-out;
        transition: transform 0.3s ease-out;
        transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
        -webkit-transform: translate(0, -50px);
        transform: translate(0, -50px);
      }
      
      @media (prefers-reduced-motion: reduce) {
        .modal.fade .modal-dialog {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .modal.show .modal-dialog {
        -webkit-transform: none;
        transform: none;
      }
      
      .modal-dialog-scrollable {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        max-height: calc(100% - 1rem);
      }
      
      .modal-dialog-scrollable .modal-content {
        max-height: calc(100vh - 1rem);
        overflow: hidden;
      }
      
      .modal-dialog-scrollable .modal-header,
      .modal-dialog-scrollable .modal-footer {
        -ms-flex-negative: 0;
        flex-shrink: 0;
      }
      
      .modal-dialog-scrollable .modal-body {
        overflow-y: auto;
      }
      
      .modal-dialog-centered {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
        min-height: calc(100% - 1rem);
      }
      
      .modal-dialog-centered::before {
        display: block;
        height: calc(100vh - 1rem);
        content: "";
      }
      
      .modal-dialog-centered.modal-dialog-scrollable {
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
                flex-direction: column;
        -ms-flex-pack: center;
        -webkit-box-pack: center;
                justify-content: center;
        height: 100%;
      }
      
      .modal-dialog-centered.modal-dialog-scrollable .modal-content {
        max-height: none;
      }
      
      .modal-dialog-centered.modal-dialog-scrollable::before {
        content: none;
      }
      
      .modal-content {
        position: relative;
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
                flex-direction: column;
        width: 100%;
        pointer-events: auto;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 0.3rem;
        outline: 0;
      }
      
      .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1040;
        width: 100vw;
        height: 100vh;
        background-color: #000;
      }
      
      .modal-backdrop.fade {
        opacity: 0;
      }
      
      .modal-backdrop.show {
        opacity: 0.5;
      }
      
      .modal-header {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-align: start;
        -webkit-box-align: start;
                align-items: flex-start;
        -ms-flex-pack: justify;
        -webkit-box-pack: justify;
                justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #dee2e6;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
      }
      
      .modal-header .close {
        padding: 1rem 1rem;
        margin: -1rem -1rem -1rem auto;
      }
      
      .modal-title {
        margin-bottom: 0;
        line-height: 1.5;
      }
      
      .modal-body {
        position: relative;
        -ms-flex: 1 1 auto;
        -webkit-box-flex: 1;
                flex: 1 1 auto;
        padding: 1rem;
      }
      
      .modal-footer {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
        -ms-flex-pack: end;
        -webkit-box-pack: end;
                justify-content: flex-end;
        padding: 1rem;
        border-top: 1px solid #dee2e6;
        border-bottom-right-radius: 0.3rem;
        border-bottom-left-radius: 0.3rem;
      }
      
      .modal-footer > :not(:first-child) {
        margin-left: .25rem;
      }
      
      .modal-footer > :not(:last-child) {
        margin-right: .25rem;
      }
      
      .modal-scrollbar-measure {
        position: absolute;
        top: -9999px;
        width: 50px;
        height: 50px;
        overflow: scroll;
      }
      
      @media (min-width: 576px) {
        .modal-dialog {
          max-width: 500px;
          margin: 1.75rem auto;
        }
        .modal-dialog-scrollable {
          max-height: calc(100% - 3.5rem);
        }
        .modal-dialog-scrollable .modal-content {
          max-height: calc(100vh - 3.5rem);
        }
        .modal-dialog-centered {
          min-height: calc(100% - 3.5rem);
        }
        .modal-dialog-centered::before {
          height: calc(100vh - 3.5rem);
        }
        .modal-sm {
          max-width: 300px;
        }
      }
      
      @media (min-width: 992px) {
        .modal-lg,
        .modal-xl {
          max-width: 800px;
        }
      }
      
      @media (min-width: 1200px) {
        .modal-xl {
          max-width: 1140px;
        }
      }
      
      .tooltip {
        position: absolute;
        z-index: 1070;
        display: block;
        margin: 0;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        font-style: normal;
        font-weight: 400;
        line-height: 1.5;
        text-align: left;
        text-align: start;
        text-decoration: none;
        text-shadow: none;
        text-transform: none;
        letter-spacing: normal;
        word-break: normal;
        word-spacing: normal;
        white-space: normal;
        line-break: auto;
        font-size: 0.875rem;
        word-wrap: break-word;
        opacity: 0;
      }
      
      .tooltip.show {
        opacity: 0.9;
      }
      
      .tooltip .arrow {
        position: absolute;
        display: block;
        width: 0.8rem;
        height: 0.4rem;
      }
      
      .tooltip .arrow::before {
        position: absolute;
        content: "";
        border-color: transparent;
        border-style: solid;
      }
      
      .bs-tooltip-top, .bs-tooltip-auto[x-placement^="top"] {
        padding: 0.4rem 0;
      }
      
      .bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^="top"] .arrow {
        bottom: 0;
      }
      
      .bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
        top: 0;
        border-width: 0.4rem 0.4rem 0;
        border-top-color: #000;
      }
      
      .bs-tooltip-right, .bs-tooltip-auto[x-placement^="right"] {
        padding: 0 0.4rem;
      }
      
      .bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^="right"] .arrow {
        left: 0;
        width: 0.4rem;
        height: 0.8rem;
      }
      
      .bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^="right"] .arrow::before {
        right: 0;
        border-width: 0.4rem 0.4rem 0.4rem 0;
        border-right-color: #000;
      }
      
      .bs-tooltip-bottom, .bs-tooltip-auto[x-placement^="bottom"] {
        padding: 0.4rem 0;
      }
      
      .bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^="bottom"] .arrow {
        top: 0;
      }
      
      .bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
        bottom: 0;
        border-width: 0 0.4rem 0.4rem;
        border-bottom-color: #000;
      }
      
      .bs-tooltip-left, .bs-tooltip-auto[x-placement^="left"] {
        padding: 0 0.4rem;
      }
      
      .bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^="left"] .arrow {
        right: 0;
        width: 0.4rem;
        height: 0.8rem;
      }
      
      .bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^="left"] .arrow::before {
        left: 0;
        border-width: 0.4rem 0 0.4rem 0.4rem;
        border-left-color: #000;
      }
      
      .tooltip-inner {
        max-width: 200px;
        padding: 0.25rem 0.5rem;
        color: #fff;
        text-align: center;
        background-color: #000;
        border-radius: 0.25rem;
      }
      
      .popover {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1060;
        display: block;
        max-width: 276px;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        font-style: normal;
        font-weight: 400;
        line-height: 1.5;
        text-align: left;
        text-align: start;
        text-decoration: none;
        text-shadow: none;
        text-transform: none;
        letter-spacing: normal;
        word-break: normal;
        word-spacing: normal;
        white-space: normal;
        line-break: auto;
        font-size: 0.875rem;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 0.3rem;
      }
      
      .popover .arrow {
        position: absolute;
        display: block;
        width: 1rem;
        height: 0.5rem;
        margin: 0 0.3rem;
      }
      
      .popover .arrow::before, .popover .arrow::after {
        position: absolute;
        display: block;
        content: "";
        border-color: transparent;
        border-style: solid;
      }
      
      .bs-popover-top, .bs-popover-auto[x-placement^="top"] {
        margin-bottom: 0.5rem;
      }
      
      .bs-popover-top > .arrow, .bs-popover-auto[x-placement^="top"] > .arrow {
        bottom: calc((0.5rem + 1px) * -1);
      }
      
      .bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^="top"] > .arrow::before {
        bottom: 0;
        border-width: 0.5rem 0.5rem 0;
        border-top-color: rgba(0, 0, 0, 0.25);
      }
      
      .bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^="top"] > .arrow::after {
        bottom: 1px;
        border-width: 0.5rem 0.5rem 0;
        border-top-color: #fff;
      }
      
      .bs-popover-right, .bs-popover-auto[x-placement^="right"] {
        margin-left: 0.5rem;
      }
      
      .bs-popover-right > .arrow, .bs-popover-auto[x-placement^="right"] > .arrow {
        left: calc((0.5rem + 1px) * -1);
        width: 0.5rem;
        height: 1rem;
        margin: 0.3rem 0;
      }
      
      .bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^="right"] > .arrow::before {
        left: 0;
        border-width: 0.5rem 0.5rem 0.5rem 0;
        border-right-color: rgba(0, 0, 0, 0.25);
      }
      
      .bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^="right"] > .arrow::after {
        left: 1px;
        border-width: 0.5rem 0.5rem 0.5rem 0;
        border-right-color: #fff;
      }
      
      .bs-popover-bottom, .bs-popover-auto[x-placement^="bottom"] {
        margin-top: 0.5rem;
      }
      
      .bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^="bottom"] > .arrow {
        top: calc((0.5rem + 1px) * -1);
      }
      
      .bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^="bottom"] > .arrow::before {
        top: 0;
        border-width: 0 0.5rem 0.5rem 0.5rem;
        border-bottom-color: rgba(0, 0, 0, 0.25);
      }
      
      .bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^="bottom"] > .arrow::after {
        top: 1px;
        border-width: 0 0.5rem 0.5rem 0.5rem;
        border-bottom-color: #fff;
      }
      
      .bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^="bottom"] .popover-header::before {
        position: absolute;
        top: 0;
        left: 50%;
        display: block;
        width: 1rem;
        margin-left: -0.5rem;
        content: "";
        border-bottom: 1px solid #f7f7f7;
      }
      
      .bs-popover-left, .bs-popover-auto[x-placement^="left"] {
        margin-right: 0.5rem;
      }
      
      .bs-popover-left > .arrow, .bs-popover-auto[x-placement^="left"] > .arrow {
        right: calc((0.5rem + 1px) * -1);
        width: 0.5rem;
        height: 1rem;
        margin: 0.3rem 0;
      }
      
      .bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^="left"] > .arrow::before {
        right: 0;
        border-width: 0.5rem 0 0.5rem 0.5rem;
        border-left-color: rgba(0, 0, 0, 0.25);
      }
      
      .bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^="left"] > .arrow::after {
        right: 1px;
        border-width: 0.5rem 0 0.5rem 0.5rem;
        border-left-color: #fff;
      }
      
      .popover-header {
        padding: 0.5rem 0.75rem;
        margin-bottom: 0;
        font-size: 1rem;
        background-color: #f7f7f7;
        border-bottom: 1px solid #ebebeb;
        border-top-left-radius: calc(0.3rem - 1px);
        border-top-right-radius: calc(0.3rem - 1px);
      }
      
      .popover-header:empty {
        display: none;
      }
      
      .popover-body {
        padding: 0.5rem 0.75rem;
        color: #212529;
      }
      
      .carousel {
        position: relative;
      }
      
      .carousel.pointer-event {
        -ms-touch-action: pan-y;
        touch-action: pan-y;
      }
      
      .carousel-inner {
        position: relative;
        width: 100%;
        overflow: hidden;
      }
      
      .carousel-inner::after {
        display: block;
        clear: both;
        content: "";
      }
      
      .carousel-item {
        position: relative;
        display: none;
        float: left;
        width: 100%;
        margin-right: -100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        transition: -webkit-transform 0.6s ease-in-out;
        -webkit-transition: -webkit-transform 0.6s ease-in-out;
        transition: transform 0.6s ease-in-out;
        transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .carousel-item {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .carousel-item.active,
      .carousel-item-next,
      .carousel-item-prev {
        display: block;
      }
      
      .carousel-item-next:not(.carousel-item-left),
      .active.carousel-item-right {
        -webkit-transform: translateX(100%);
        transform: translateX(100%);
      }
      
      .carousel-item-prev:not(.carousel-item-right),
      .active.carousel-item-left {
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
      }
      
      .carousel-fade .carousel-item {
        opacity: 0;
        -webkit-transition-property: opacity;
        transition-property: opacity;
        -webkit-transform: none;
        transform: none;
      }
      
      .carousel-fade .carousel-item.active,
      .carousel-fade .carousel-item-next.carousel-item-left,
      .carousel-fade .carousel-item-prev.carousel-item-right {
        z-index: 1;
        opacity: 1;
      }
      
      .carousel-fade .active.carousel-item-left,
      .carousel-fade .active.carousel-item-right {
        z-index: 0;
        opacity: 0;
        -webkit-transition: 0s 0.6s opacity;
        transition: 0s 0.6s opacity;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .carousel-fade .active.carousel-item-left,
        .carousel-fade .active.carousel-item-right {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .carousel-control-prev,
      .carousel-control-next {
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: 1;
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-align: center;
        -webkit-box-align: center;
                align-items: center;
        -ms-flex-pack: center;
        -webkit-box-pack: center;
                justify-content: center;
        width: 15%;
        color: #fff;
        text-align: center;
        opacity: 0.5;
        -webkit-transition: opacity 0.15s ease;
        transition: opacity 0.15s ease;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .carousel-control-prev,
        .carousel-control-next {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .carousel-control-prev:hover, .carousel-control-prev:focus,
      .carousel-control-next:hover,
      .carousel-control-next:focus {
        color: #fff;
        text-decoration: none;
        outline: 0;
        opacity: 0.9;
      }
      
      .carousel-control-prev {
        left: 0;
      }
      
      .carousel-control-next {
        right: 0;
      }
      
      .carousel-control-prev-icon,
      .carousel-control-next-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: no-repeat 50% / 100% 100%;
      }
      
      .carousel-control-prev-icon {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e");
      }
      
      .carousel-control-next-icon {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e");
      }
      
      .carousel-indicators {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 15;
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-pack: center;
        -webkit-box-pack: center;
                justify-content: center;
        padding-left: 0;
        margin-right: 15%;
        margin-left: 15%;
        list-style: none;
      }
      
      .carousel-indicators li {
        -webkit-box-sizing: content-box;
                box-sizing: content-box;
        -ms-flex: 0 1 auto;
        -webkit-box-flex: 0;
                flex: 0 1 auto;
        width: 30px;
        height: 3px;
        margin-right: 3px;
        margin-left: 3px;
        text-indent: -999px;
        cursor: pointer;
        background-color: #fff;
        background-clip: padding-box;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        opacity: .5;
        -webkit-transition: opacity 0.6s ease;
        transition: opacity 0.6s ease;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .carousel-indicators li {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .carousel-indicators .active {
        opacity: 1;
      }
      
      .carousel-caption {
        position: absolute;
        right: 15%;
        bottom: 20px;
        left: 15%;
        z-index: 10;
        padding-top: 20px;
        padding-bottom: 20px;
        color: #fff;
        text-align: center;
      }
      
      @-webkit-keyframes spinner-border {
        to {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
      
      @keyframes spinner-border {
        to {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
      
      .spinner-border {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        border: 0.25em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        -webkit-animation: spinner-border .75s linear infinite;
        animation: spinner-border .75s linear infinite;
      }
      
      .spinner-border-sm {
        width: 1rem;
        height: 1rem;
        border-width: 0.2em;
      }
      
      @-webkit-keyframes spinner-grow {
        0% {
          -webkit-transform: scale(0);
          transform: scale(0);
        }
        50% {
          opacity: 1;
        }
      }
      
      @keyframes spinner-grow {
        0% {
          -webkit-transform: scale(0);
          transform: scale(0);
        }
        50% {
          opacity: 1;
        }
      }
      
      .spinner-grow {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        background-color: currentColor;
        border-radius: 50%;
        opacity: 0;
        -webkit-animation: spinner-grow .75s linear infinite;
        animation: spinner-grow .75s linear infinite;
      }
      
      .spinner-grow-sm {
        width: 1rem;
        height: 1rem;
      }
      
      .align-baseline {
        vertical-align: baseline !important;
      }
      
      .align-top {
        vertical-align: top !important;
      }
      
      .align-middle {
        vertical-align: middle !important;
      }
      
      .align-bottom {
        vertical-align: bottom !important;
      }
      
      .align-text-bottom {
        vertical-align: text-bottom !important;
      }
      
      .align-text-top {
        vertical-align: text-top !important;
      }
      
      .bg-primary {
        background-color: #007bff !important;
      }
      
      a.bg-primary:hover, a.bg-primary:focus,
      button.bg-primary:hover,
      button.bg-primary:focus {
        background-color: #0062cc !important;
      }
      
      .bg-secondary {
        background-color: #6c757d !important;
      }
      
      a.bg-secondary:hover, a.bg-secondary:focus,
      button.bg-secondary:hover,
      button.bg-secondary:focus {
        background-color: #545b62 !important;
      }
      
      .bg-success {
        background-color: #28a745 !important;
      }
      
      a.bg-success:hover, a.bg-success:focus,
      button.bg-success:hover,
      button.bg-success:focus {
        background-color: #1e7e34 !important;
      }
      
      .bg-info {
        background-color: #17a2b8 !important;
      }
      
      a.bg-info:hover, a.bg-info:focus,
      button.bg-info:hover,
      button.bg-info:focus {
        background-color: #117a8b !important;
      }
      
      .bg-warning {
        background-color: #ffc107 !important;
      }
      
      a.bg-warning:hover, a.bg-warning:focus,
      button.bg-warning:hover,
      button.bg-warning:focus {
        background-color: #d39e00 !important;
      }
      
      .bg-danger {
        background-color: #dc3545 !important;
      }
      
      a.bg-danger:hover, a.bg-danger:focus,
      button.bg-danger:hover,
      button.bg-danger:focus {
        background-color: #bd2130 !important;
      }
      
      .bg-light {
        background-color: #f8f9fa !important;
      }
      
      a.bg-light:hover, a.bg-light:focus,
      button.bg-light:hover,
      button.bg-light:focus {
        background-color: #dae0e5 !important;
      }
      
      .bg-dark {
        background-color: #343a40 !important;
      }
      
      a.bg-dark:hover, a.bg-dark:focus,
      button.bg-dark:hover,
      button.bg-dark:focus {
        background-color: #1d2124 !important;
      }
      
      .bg-white {
        background-color: #fff !important;
      }
      
      .bg-transparent {
        background-color: transparent !important;
      }
      
      .border {
        border: 1px solid #dee2e6 !important;
      }
      
      .border-top {
        border-top: 1px solid #dee2e6 !important;
      }
      
      .border-right {
        border-right: 1px solid #dee2e6 !important;
      }
      
      .border-bottom {
        border-bottom: 1px solid #dee2e6 !important;
      }
      
      .border-left {
        border-left: 1px solid #dee2e6 !important;
      }
      
      .border-0 {
        border: 0 !important;
      }
      
      .border-top-0 {
        border-top: 0 !important;
      }
      
      .border-right-0 {
        border-right: 0 !important;
      }
      
      .border-bottom-0 {
        border-bottom: 0 !important;
      }
      
      .border-left-0 {
        border-left: 0 !important;
      }
      
      .border-primary {
        border-color: #007bff !important;
      }
      
      .border-secondary {
        border-color: #6c757d !important;
      }
      
      .border-success {
        border-color: #28a745 !important;
      }
      
      .border-info {
        border-color: #17a2b8 !important;
      }
      
      .border-warning {
        border-color: #ffc107 !important;
      }
      
      .border-danger {
        border-color: #dc3545 !important;
      }
      
      .border-light {
        border-color: #f8f9fa !important;
      }
      
      .border-dark {
        border-color: #343a40 !important;
      }
      
      .border-white {
        border-color: #fff !important;
      }
      
      .rounded-sm {
        border-radius: 0.2rem !important;
      }
      
      .rounded {
        border-radius: 0.25rem !important;
      }
      
      .rounded-top {
        border-top-left-radius: 0.25rem !important;
        border-top-right-radius: 0.25rem !important;
      }
      
      .rounded-right {
        border-top-right-radius: 0.25rem !important;
        border-bottom-right-radius: 0.25rem !important;
      }
      
      .rounded-bottom {
        border-bottom-right-radius: 0.25rem !important;
        border-bottom-left-radius: 0.25rem !important;
      }
      
      .rounded-left {
        border-top-left-radius: 0.25rem !important;
        border-bottom-left-radius: 0.25rem !important;
      }
      
      .rounded-lg {
        border-radius: 0.3rem !important;
      }
      
      .rounded-circle {
        border-radius: 50% !important;
      }
      
      .rounded-pill {
        border-radius: 50rem !important;
      }
      
      .rounded-0 {
        border-radius: 0 !important;
      }
      
      .clearfix::after {
        display: block;
        clear: both;
        content: "";
      }
      
      .d-none {
        display: none !important;
      }
      
      .d-inline {
        display: inline !important;
      }
      
      .d-inline-block {
        display: inline-block !important;
      }
      
      .d-block {
        display: block !important;
      }
      
      .d-table {
        display: table !important;
      }
      
      .d-table-row {
        display: table-row !important;
      }
      
      .d-table-cell {
        display: table-cell !important;
      }
      
      .d-flex {
        display: -ms-flexbox !important;
        display: -webkit-box !important;
        display: flex !important;
      }
      
      .d-inline-flex {
        display: -ms-inline-flexbox !important;
        display: -webkit-inline-box !important;
        display: inline-flex !important;
      }
      
      @media (min-width: 576px) {
        .d-sm-none {
          display: none !important;
        }
        .d-sm-inline {
          display: inline !important;
        }
        .d-sm-inline-block {
          display: inline-block !important;
        }
        .d-sm-block {
          display: block !important;
        }
        .d-sm-table {
          display: table !important;
        }
        .d-sm-table-row {
          display: table-row !important;
        }
        .d-sm-table-cell {
          display: table-cell !important;
        }
        .d-sm-flex {
          display: -ms-flexbox !important;
          display: -webkit-box !important;
          display: flex !important;
        }
        .d-sm-inline-flex {
          display: -ms-inline-flexbox !important;
          display: -webkit-inline-box !important;
          display: inline-flex !important;
        }
      }
      
      @media (min-width: 768px) {
        .d-md-none {
          display: none !important;
        }
        .d-md-inline {
          display: inline !important;
        }
        .d-md-inline-block {
          display: inline-block !important;
        }
        .d-md-block {
          display: block !important;
        }
        .d-md-table {
          display: table !important;
        }
        .d-md-table-row {
          display: table-row !important;
        }
        .d-md-table-cell {
          display: table-cell !important;
        }
        .d-md-flex {
          display: -ms-flexbox !important;
          display: -webkit-box !important;
          display: flex !important;
        }
        .d-md-inline-flex {
          display: -ms-inline-flexbox !important;
          display: -webkit-inline-box !important;
          display: inline-flex !important;
        }
      }
      
      @media (min-width: 992px) {
        .d-lg-none {
          display: none !important;
        }
        .d-lg-inline {
          display: inline !important;
        }
        .d-lg-inline-block {
          display: inline-block !important;
        }
        .d-lg-block {
          display: block !important;
        }
        .d-lg-table {
          display: table !important;
        }
        .d-lg-table-row {
          display: table-row !important;
        }
        .d-lg-table-cell {
          display: table-cell !important;
        }
        .d-lg-flex {
          display: -ms-flexbox !important;
          display: -webkit-box !important;
          display: flex !important;
        }
        .d-lg-inline-flex {
          display: -ms-inline-flexbox !important;
          display: -webkit-inline-box !important;
          display: inline-flex !important;
        }
      }
      
      @media (min-width: 1200px) {
        .d-xl-none {
          display: none !important;
        }
        .d-xl-inline {
          display: inline !important;
        }
        .d-xl-inline-block {
          display: inline-block !important;
        }
        .d-xl-block {
          display: block !important;
        }
        .d-xl-table {
          display: table !important;
        }
        .d-xl-table-row {
          display: table-row !important;
        }
        .d-xl-table-cell {
          display: table-cell !important;
        }
        .d-xl-flex {
          display: -ms-flexbox !important;
          display: -webkit-box !important;
          display: flex !important;
        }
        .d-xl-inline-flex {
          display: -ms-inline-flexbox !important;
          display: -webkit-inline-box !important;
          display: inline-flex !important;
        }
      }
      
      @media print {
        .d-print-none {
          display: none !important;
        }
        .d-print-inline {
          display: inline !important;
        }
        .d-print-inline-block {
          display: inline-block !important;
        }
        .d-print-block {
          display: block !important;
        }
        .d-print-table {
          display: table !important;
        }
        .d-print-table-row {
          display: table-row !important;
        }
        .d-print-table-cell {
          display: table-cell !important;
        }
        .d-print-flex {
          display: -ms-flexbox !important;
          display: -webkit-box !important;
          display: flex !important;
        }
        .d-print-inline-flex {
          display: -ms-inline-flexbox !important;
          display: -webkit-inline-box !important;
          display: inline-flex !important;
        }
      }
      
      .embed-responsive {
        position: relative;
        display: block;
        width: 100%;
        padding: 0;
        overflow: hidden;
      }
      
      .embed-responsive::before {
        display: block;
        content: "";
      }
      
      .embed-responsive .embed-responsive-item,
      .embed-responsive iframe,
      .embed-responsive embed,
      .embed-responsive object,
      .embed-responsive video {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
      }
      
      .embed-responsive-21by9::before {
        padding-top: 42.857143%;
      }
      
      .embed-responsive-16by9::before {
        padding-top: 56.25%;
      }
      
      .embed-responsive-4by3::before {
        padding-top: 75%;
      }
      
      .embed-responsive-1by1::before {
        padding-top: 100%;
      }
      
      .flex-row {
        -ms-flex-direction: row !important;
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: normal !important;
                flex-direction: row !important;
      }
      
      .flex-column {
        -ms-flex-direction: column !important;
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: normal !important;
                flex-direction: column !important;
      }
      
      .flex-row-reverse {
        -ms-flex-direction: row-reverse !important;
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: reverse !important;
                flex-direction: row-reverse !important;
      }
      
      .flex-column-reverse {
        -ms-flex-direction: column-reverse !important;
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: reverse !important;
                flex-direction: column-reverse !important;
      }
      
      .flex-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
      }
      
      .flex-nowrap {
        -ms-flex-wrap: nowrap !important;
        flex-wrap: nowrap !important;
      }
      
      .flex-wrap-reverse {
        -ms-flex-wrap: wrap-reverse !important;
        flex-wrap: wrap-reverse !important;
      }
      
      .flex-fill {
        -ms-flex: 1 1 auto !important;
        -webkit-box-flex: 1 !important;
                flex: 1 1 auto !important;
      }
      
      .flex-grow-0 {
        -ms-flex-positive: 0 !important;
        -webkit-box-flex: 0 !important;
                flex-grow: 0 !important;
      }
      
      .flex-grow-1 {
        -ms-flex-positive: 1 !important;
        -webkit-box-flex: 1 !important;
                flex-grow: 1 !important;
      }
      
      .flex-shrink-0 {
        -ms-flex-negative: 0 !important;
        flex-shrink: 0 !important;
      }
      
      .flex-shrink-1 {
        -ms-flex-negative: 1 !important;
        flex-shrink: 1 !important;
      }
      
      .justify-content-start {
        -ms-flex-pack: start !important;
        -webkit-box-pack: start !important;
                justify-content: flex-start !important;
      }
      
      .justify-content-end {
        -ms-flex-pack: end !important;
        -webkit-box-pack: end !important;
                justify-content: flex-end !important;
      }
      
      .justify-content-center {
        -ms-flex-pack: center !important;
        -webkit-box-pack: center !important;
                justify-content: center !important;
      }
      
      .justify-content-between {
        -ms-flex-pack: justify !important;
        -webkit-box-pack: justify !important;
                justify-content: space-between !important;
      }
      
      .justify-content-around {
        -ms-flex-pack: distribute !important;
        justify-content: space-around !important;
      }
      
      .align-items-start {
        -ms-flex-align: start !important;
        -webkit-box-align: start !important;
                align-items: flex-start !important;
      }
      
      .align-items-end {
        -ms-flex-align: end !important;
        -webkit-box-align: end !important;
                align-items: flex-end !important;
      }
      
      .align-items-center {
        -ms-flex-align: center !important;
        -webkit-box-align: center !important;
                align-items: center !important;
      }
      
      .align-items-baseline {
        -ms-flex-align: baseline !important;
        -webkit-box-align: baseline !important;
                align-items: baseline !important;
      }
      
      .align-items-stretch {
        -ms-flex-align: stretch !important;
        -webkit-box-align: stretch !important;
                align-items: stretch !important;
      }
      
      .align-content-start {
        -ms-flex-line-pack: start !important;
        align-content: flex-start !important;
      }
      
      .align-content-end {
        -ms-flex-line-pack: end !important;
        align-content: flex-end !important;
      }
      
      .align-content-center {
        -ms-flex-line-pack: center !important;
        align-content: center !important;
      }
      
      .align-content-between {
        -ms-flex-line-pack: justify !important;
        align-content: space-between !important;
      }
      
      .align-content-around {
        -ms-flex-line-pack: distribute !important;
        align-content: space-around !important;
      }
      
      .align-content-stretch {
        -ms-flex-line-pack: stretch !important;
        align-content: stretch !important;
      }
      
      .align-self-auto {
        -ms-flex-item-align: auto !important;
        align-self: auto !important;
      }
      
      .align-self-start {
        -ms-flex-item-align: start !important;
        align-self: flex-start !important;
      }
      
      .align-self-end {
        -ms-flex-item-align: end !important;
        align-self: flex-end !important;
      }
      
      .align-self-center {
        -ms-flex-item-align: center !important;
        align-self: center !important;
      }
      
      .align-self-baseline {
        -ms-flex-item-align: baseline !important;
        align-self: baseline !important;
      }
      
      .align-self-stretch {
        -ms-flex-item-align: stretch !important;
        align-self: stretch !important;
      }
      
      @media (min-width: 576px) {
        .flex-sm-row {
          -ms-flex-direction: row !important;
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: normal !important;
                  flex-direction: row !important;
        }
        .flex-sm-column {
          -ms-flex-direction: column !important;
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: normal !important;
                  flex-direction: column !important;
        }
        .flex-sm-row-reverse {
          -ms-flex-direction: row-reverse !important;
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: reverse !important;
                  flex-direction: row-reverse !important;
        }
        .flex-sm-column-reverse {
          -ms-flex-direction: column-reverse !important;
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: reverse !important;
                  flex-direction: column-reverse !important;
        }
        .flex-sm-wrap {
          -ms-flex-wrap: wrap !important;
          flex-wrap: wrap !important;
        }
        .flex-sm-nowrap {
          -ms-flex-wrap: nowrap !important;
          flex-wrap: nowrap !important;
        }
        .flex-sm-wrap-reverse {
          -ms-flex-wrap: wrap-reverse !important;
          flex-wrap: wrap-reverse !important;
        }
        .flex-sm-fill {
          -ms-flex: 1 1 auto !important;
          -webkit-box-flex: 1 !important;
                  flex: 1 1 auto !important;
        }
        .flex-sm-grow-0 {
          -ms-flex-positive: 0 !important;
          -webkit-box-flex: 0 !important;
                  flex-grow: 0 !important;
        }
        .flex-sm-grow-1 {
          -ms-flex-positive: 1 !important;
          -webkit-box-flex: 1 !important;
                  flex-grow: 1 !important;
        }
        .flex-sm-shrink-0 {
          -ms-flex-negative: 0 !important;
          flex-shrink: 0 !important;
        }
        .flex-sm-shrink-1 {
          -ms-flex-negative: 1 !important;
          flex-shrink: 1 !important;
        }
        .justify-content-sm-start {
          -ms-flex-pack: start !important;
          -webkit-box-pack: start !important;
                  justify-content: flex-start !important;
        }
        .justify-content-sm-end {
          -ms-flex-pack: end !important;
          -webkit-box-pack: end !important;
                  justify-content: flex-end !important;
        }
        .justify-content-sm-center {
          -ms-flex-pack: center !important;
          -webkit-box-pack: center !important;
                  justify-content: center !important;
        }
        .justify-content-sm-between {
          -ms-flex-pack: justify !important;
          -webkit-box-pack: justify !important;
                  justify-content: space-between !important;
        }
        .justify-content-sm-around {
          -ms-flex-pack: distribute !important;
          justify-content: space-around !important;
        }
        .align-items-sm-start {
          -ms-flex-align: start !important;
          -webkit-box-align: start !important;
                  align-items: flex-start !important;
        }
        .align-items-sm-end {
          -ms-flex-align: end !important;
          -webkit-box-align: end !important;
                  align-items: flex-end !important;
        }
        .align-items-sm-center {
          -ms-flex-align: center !important;
          -webkit-box-align: center !important;
                  align-items: center !important;
        }
        .align-items-sm-baseline {
          -ms-flex-align: baseline !important;
          -webkit-box-align: baseline !important;
                  align-items: baseline !important;
        }
        .align-items-sm-stretch {
          -ms-flex-align: stretch !important;
          -webkit-box-align: stretch !important;
                  align-items: stretch !important;
        }
        .align-content-sm-start {
          -ms-flex-line-pack: start !important;
          align-content: flex-start !important;
        }
        .align-content-sm-end {
          -ms-flex-line-pack: end !important;
          align-content: flex-end !important;
        }
        .align-content-sm-center {
          -ms-flex-line-pack: center !important;
          align-content: center !important;
        }
        .align-content-sm-between {
          -ms-flex-line-pack: justify !important;
          align-content: space-between !important;
        }
        .align-content-sm-around {
          -ms-flex-line-pack: distribute !important;
          align-content: space-around !important;
        }
        .align-content-sm-stretch {
          -ms-flex-line-pack: stretch !important;
          align-content: stretch !important;
        }
        .align-self-sm-auto {
          -ms-flex-item-align: auto !important;
          align-self: auto !important;
        }
        .align-self-sm-start {
          -ms-flex-item-align: start !important;
          align-self: flex-start !important;
        }
        .align-self-sm-end {
          -ms-flex-item-align: end !important;
          align-self: flex-end !important;
        }
        .align-self-sm-center {
          -ms-flex-item-align: center !important;
          align-self: center !important;
        }
        .align-self-sm-baseline {
          -ms-flex-item-align: baseline !important;
          align-self: baseline !important;
        }
        .align-self-sm-stretch {
          -ms-flex-item-align: stretch !important;
          align-self: stretch !important;
        }
      }
      
      @media (min-width: 768px) {
        .flex-md-row {
          -ms-flex-direction: row !important;
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: normal !important;
                  flex-direction: row !important;
        }
        .flex-md-column {
          -ms-flex-direction: column !important;
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: normal !important;
                  flex-direction: column !important;
        }
        .flex-md-row-reverse {
          -ms-flex-direction: row-reverse !important;
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: reverse !important;
                  flex-direction: row-reverse !important;
        }
        .flex-md-column-reverse {
          -ms-flex-direction: column-reverse !important;
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: reverse !important;
                  flex-direction: column-reverse !important;
        }
        .flex-md-wrap {
          -ms-flex-wrap: wrap !important;
          flex-wrap: wrap !important;
        }
        .flex-md-nowrap {
          -ms-flex-wrap: nowrap !important;
          flex-wrap: nowrap !important;
        }
        .flex-md-wrap-reverse {
          -ms-flex-wrap: wrap-reverse !important;
          flex-wrap: wrap-reverse !important;
        }
        .flex-md-fill {
          -ms-flex: 1 1 auto !important;
          -webkit-box-flex: 1 !important;
                  flex: 1 1 auto !important;
        }
        .flex-md-grow-0 {
          -ms-flex-positive: 0 !important;
          -webkit-box-flex: 0 !important;
                  flex-grow: 0 !important;
        }
        .flex-md-grow-1 {
          -ms-flex-positive: 1 !important;
          -webkit-box-flex: 1 !important;
                  flex-grow: 1 !important;
        }
        .flex-md-shrink-0 {
          -ms-flex-negative: 0 !important;
          flex-shrink: 0 !important;
        }
        .flex-md-shrink-1 {
          -ms-flex-negative: 1 !important;
          flex-shrink: 1 !important;
        }
        .justify-content-md-start {
          -ms-flex-pack: start !important;
          -webkit-box-pack: start !important;
                  justify-content: flex-start !important;
        }
        .justify-content-md-end {
          -ms-flex-pack: end !important;
          -webkit-box-pack: end !important;
                  justify-content: flex-end !important;
        }
        .justify-content-md-center {
          -ms-flex-pack: center !important;
          -webkit-box-pack: center !important;
                  justify-content: center !important;
        }
        .justify-content-md-between {
          -ms-flex-pack: justify !important;
          -webkit-box-pack: justify !important;
                  justify-content: space-between !important;
        }
        .justify-content-md-around {
          -ms-flex-pack: distribute !important;
          justify-content: space-around !important;
        }
        .align-items-md-start {
          -ms-flex-align: start !important;
          -webkit-box-align: start !important;
                  align-items: flex-start !important;
        }
        .align-items-md-end {
          -ms-flex-align: end !important;
          -webkit-box-align: end !important;
                  align-items: flex-end !important;
        }
        .align-items-md-center {
          -ms-flex-align: center !important;
          -webkit-box-align: center !important;
                  align-items: center !important;
        }
        .align-items-md-baseline {
          -ms-flex-align: baseline !important;
          -webkit-box-align: baseline !important;
                  align-items: baseline !important;
        }
        .align-items-md-stretch {
          -ms-flex-align: stretch !important;
          -webkit-box-align: stretch !important;
                  align-items: stretch !important;
        }
        .align-content-md-start {
          -ms-flex-line-pack: start !important;
          align-content: flex-start !important;
        }
        .align-content-md-end {
          -ms-flex-line-pack: end !important;
          align-content: flex-end !important;
        }
        .align-content-md-center {
          -ms-flex-line-pack: center !important;
          align-content: center !important;
        }
        .align-content-md-between {
          -ms-flex-line-pack: justify !important;
          align-content: space-between !important;
        }
        .align-content-md-around {
          -ms-flex-line-pack: distribute !important;
          align-content: space-around !important;
        }
        .align-content-md-stretch {
          -ms-flex-line-pack: stretch !important;
          align-content: stretch !important;
        }
        .align-self-md-auto {
          -ms-flex-item-align: auto !important;
          align-self: auto !important;
        }
        .align-self-md-start {
          -ms-flex-item-align: start !important;
          align-self: flex-start !important;
        }
        .align-self-md-end {
          -ms-flex-item-align: end !important;
          align-self: flex-end !important;
        }
        .align-self-md-center {
          -ms-flex-item-align: center !important;
          align-self: center !important;
        }
        .align-self-md-baseline {
          -ms-flex-item-align: baseline !important;
          align-self: baseline !important;
        }
        .align-self-md-stretch {
          -ms-flex-item-align: stretch !important;
          align-self: stretch !important;
        }
      }
      
      @media (min-width: 992px) {
        .flex-lg-row {
          -ms-flex-direction: row !important;
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: normal !important;
                  flex-direction: row !important;
        }
        .flex-lg-column {
          -ms-flex-direction: column !important;
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: normal !important;
                  flex-direction: column !important;
        }
        .flex-lg-row-reverse {
          -ms-flex-direction: row-reverse !important;
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: reverse !important;
                  flex-direction: row-reverse !important;
        }
        .flex-lg-column-reverse {
          -ms-flex-direction: column-reverse !important;
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: reverse !important;
                  flex-direction: column-reverse !important;
        }
        .flex-lg-wrap {
          -ms-flex-wrap: wrap !important;
          flex-wrap: wrap !important;
        }
        .flex-lg-nowrap {
          -ms-flex-wrap: nowrap !important;
          flex-wrap: nowrap !important;
        }
        .flex-lg-wrap-reverse {
          -ms-flex-wrap: wrap-reverse !important;
          flex-wrap: wrap-reverse !important;
        }
        .flex-lg-fill {
          -ms-flex: 1 1 auto !important;
          -webkit-box-flex: 1 !important;
                  flex: 1 1 auto !important;
        }
        .flex-lg-grow-0 {
          -ms-flex-positive: 0 !important;
          -webkit-box-flex: 0 !important;
                  flex-grow: 0 !important;
        }
        .flex-lg-grow-1 {
          -ms-flex-positive: 1 !important;
          -webkit-box-flex: 1 !important;
                  flex-grow: 1 !important;
        }
        .flex-lg-shrink-0 {
          -ms-flex-negative: 0 !important;
          flex-shrink: 0 !important;
        }
        .flex-lg-shrink-1 {
          -ms-flex-negative: 1 !important;
          flex-shrink: 1 !important;
        }
        .justify-content-lg-start {
          -ms-flex-pack: start !important;
          -webkit-box-pack: start !important;
                  justify-content: flex-start !important;
        }
        .justify-content-lg-end {
          -ms-flex-pack: end !important;
          -webkit-box-pack: end !important;
                  justify-content: flex-end !important;
        }
        .justify-content-lg-center {
          -ms-flex-pack: center !important;
          -webkit-box-pack: center !important;
                  justify-content: center !important;
        }
        .justify-content-lg-between {
          -ms-flex-pack: justify !important;
          -webkit-box-pack: justify !important;
                  justify-content: space-between !important;
        }
        .justify-content-lg-around {
          -ms-flex-pack: distribute !important;
          justify-content: space-around !important;
        }
        .align-items-lg-start {
          -ms-flex-align: start !important;
          -webkit-box-align: start !important;
                  align-items: flex-start !important;
        }
        .align-items-lg-end {
          -ms-flex-align: end !important;
          -webkit-box-align: end !important;
                  align-items: flex-end !important;
        }
        .align-items-lg-center {
          -ms-flex-align: center !important;
          -webkit-box-align: center !important;
                  align-items: center !important;
        }
        .align-items-lg-baseline {
          -ms-flex-align: baseline !important;
          -webkit-box-align: baseline !important;
                  align-items: baseline !important;
        }
        .align-items-lg-stretch {
          -ms-flex-align: stretch !important;
          -webkit-box-align: stretch !important;
                  align-items: stretch !important;
        }
        .align-content-lg-start {
          -ms-flex-line-pack: start !important;
          align-content: flex-start !important;
        }
        .align-content-lg-end {
          -ms-flex-line-pack: end !important;
          align-content: flex-end !important;
        }
        .align-content-lg-center {
          -ms-flex-line-pack: center !important;
          align-content: center !important;
        }
        .align-content-lg-between {
          -ms-flex-line-pack: justify !important;
          align-content: space-between !important;
        }
        .align-content-lg-around {
          -ms-flex-line-pack: distribute !important;
          align-content: space-around !important;
        }
        .align-content-lg-stretch {
          -ms-flex-line-pack: stretch !important;
          align-content: stretch !important;
        }
        .align-self-lg-auto {
          -ms-flex-item-align: auto !important;
          align-self: auto !important;
        }
        .align-self-lg-start {
          -ms-flex-item-align: start !important;
          align-self: flex-start !important;
        }
        .align-self-lg-end {
          -ms-flex-item-align: end !important;
          align-self: flex-end !important;
        }
        .align-self-lg-center {
          -ms-flex-item-align: center !important;
          align-self: center !important;
        }
        .align-self-lg-baseline {
          -ms-flex-item-align: baseline !important;
          align-self: baseline !important;
        }
        .align-self-lg-stretch {
          -ms-flex-item-align: stretch !important;
          align-self: stretch !important;
        }
      }
      
      @media (min-width: 1200px) {
        .flex-xl-row {
          -ms-flex-direction: row !important;
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: normal !important;
                  flex-direction: row !important;
        }
        .flex-xl-column {
          -ms-flex-direction: column !important;
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: normal !important;
                  flex-direction: column !important;
        }
        .flex-xl-row-reverse {
          -ms-flex-direction: row-reverse !important;
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: reverse !important;
                  flex-direction: row-reverse !important;
        }
        .flex-xl-column-reverse {
          -ms-flex-direction: column-reverse !important;
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: reverse !important;
                  flex-direction: column-reverse !important;
        }
        .flex-xl-wrap {
          -ms-flex-wrap: wrap !important;
          flex-wrap: wrap !important;
        }
        .flex-xl-nowrap {
          -ms-flex-wrap: nowrap !important;
          flex-wrap: nowrap !important;
        }
        .flex-xl-wrap-reverse {
          -ms-flex-wrap: wrap-reverse !important;
          flex-wrap: wrap-reverse !important;
        }
        .flex-xl-fill {
          -ms-flex: 1 1 auto !important;
          -webkit-box-flex: 1 !important;
                  flex: 1 1 auto !important;
        }
        .flex-xl-grow-0 {
          -ms-flex-positive: 0 !important;
          -webkit-box-flex: 0 !important;
                  flex-grow: 0 !important;
        }
        .flex-xl-grow-1 {
          -ms-flex-positive: 1 !important;
          -webkit-box-flex: 1 !important;
                  flex-grow: 1 !important;
        }
        .flex-xl-shrink-0 {
          -ms-flex-negative: 0 !important;
          flex-shrink: 0 !important;
        }
        .flex-xl-shrink-1 {
          -ms-flex-negative: 1 !important;
          flex-shrink: 1 !important;
        }
        .justify-content-xl-start {
          -ms-flex-pack: start !important;
          -webkit-box-pack: start !important;
                  justify-content: flex-start !important;
        }
        .justify-content-xl-end {
          -ms-flex-pack: end !important;
          -webkit-box-pack: end !important;
                  justify-content: flex-end !important;
        }
        .justify-content-xl-center {
          -ms-flex-pack: center !important;
          -webkit-box-pack: center !important;
                  justify-content: center !important;
        }
        .justify-content-xl-between {
          -ms-flex-pack: justify !important;
          -webkit-box-pack: justify !important;
                  justify-content: space-between !important;
        }
        .justify-content-xl-around {
          -ms-flex-pack: distribute !important;
          justify-content: space-around !important;
        }
        .align-items-xl-start {
          -ms-flex-align: start !important;
          -webkit-box-align: start !important;
                  align-items: flex-start !important;
        }
        .align-items-xl-end {
          -ms-flex-align: end !important;
          -webkit-box-align: end !important;
                  align-items: flex-end !important;
        }
        .align-items-xl-center {
          -ms-flex-align: center !important;
          -webkit-box-align: center !important;
                  align-items: center !important;
        }
        .align-items-xl-baseline {
          -ms-flex-align: baseline !important;
          -webkit-box-align: baseline !important;
                  align-items: baseline !important;
        }
        .align-items-xl-stretch {
          -ms-flex-align: stretch !important;
          -webkit-box-align: stretch !important;
                  align-items: stretch !important;
        }
        .align-content-xl-start {
          -ms-flex-line-pack: start !important;
          align-content: flex-start !important;
        }
        .align-content-xl-end {
          -ms-flex-line-pack: end !important;
          align-content: flex-end !important;
        }
        .align-content-xl-center {
          -ms-flex-line-pack: center !important;
          align-content: center !important;
        }
        .align-content-xl-between {
          -ms-flex-line-pack: justify !important;
          align-content: space-between !important;
        }
        .align-content-xl-around {
          -ms-flex-line-pack: distribute !important;
          align-content: space-around !important;
        }
        .align-content-xl-stretch {
          -ms-flex-line-pack: stretch !important;
          align-content: stretch !important;
        }
        .align-self-xl-auto {
          -ms-flex-item-align: auto !important;
          align-self: auto !important;
        }
        .align-self-xl-start {
          -ms-flex-item-align: start !important;
          align-self: flex-start !important;
        }
        .align-self-xl-end {
          -ms-flex-item-align: end !important;
          align-self: flex-end !important;
        }
        .align-self-xl-center {
          -ms-flex-item-align: center !important;
          align-self: center !important;
        }
        .align-self-xl-baseline {
          -ms-flex-item-align: baseline !important;
          align-self: baseline !important;
        }
        .align-self-xl-stretch {
          -ms-flex-item-align: stretch !important;
          align-self: stretch !important;
        }
      }
      
      .float-left {
        float: left !important;
      }
      
      .float-right {
        float: right !important;
      }
      
      .float-none {
        float: none !important;
      }
      
      @media (min-width: 576px) {
        .float-sm-left {
          float: left !important;
        }
        .float-sm-right {
          float: right !important;
        }
        .float-sm-none {
          float: none !important;
        }
      }
      
      @media (min-width: 768px) {
        .float-md-left {
          float: left !important;
        }
        .float-md-right {
          float: right !important;
        }
        .float-md-none {
          float: none !important;
        }
      }
      
      @media (min-width: 992px) {
        .float-lg-left {
          float: left !important;
        }
        .float-lg-right {
          float: right !important;
        }
        .float-lg-none {
          float: none !important;
        }
      }
      
      @media (min-width: 1200px) {
        .float-xl-left {
          float: left !important;
        }
        .float-xl-right {
          float: right !important;
        }
        .float-xl-none {
          float: none !important;
        }
      }
      
      .overflow-auto {
        overflow: auto !important;
      }
      
      .overflow-hidden {
        overflow: hidden !important;
      }
      
      .position-static {
        position: static !important;
      }
      
      .position-relative {
        position: relative !important;
      }
      
      .position-absolute {
        position: absolute !important;
      }
      
      .position-fixed {
        position: fixed !important;
      }
      
      .position-sticky {
        position: -webkit-sticky !important;
        position: sticky !important;
      }
      
      .fixed-top {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: 1030;
      }
      
      .fixed-bottom {
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1030;
      }
      
      @supports ((position: -webkit-sticky) or (position: sticky)) {
        .sticky-top {
          position: -webkit-sticky;
          position: sticky;
          top: 0;
          z-index: 1020;
        }
      }
      
      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }
      
      .sr-only-focusable:active, .sr-only-focusable:focus {
        position: static;
        width: auto;
        height: auto;
        overflow: visible;
        clip: auto;
        white-space: normal;
      }
      
      .shadow-sm {
        -webkit-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
                box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
      }
      
      .shadow {
        -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
                box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
      }
      
      .shadow-lg {
        -webkit-box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
                box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
      }
      
      .shadow-none {
        -webkit-box-shadow: none !important;
                box-shadow: none !important;
      }
      
      .w-25 {
        width: 25% !important;
      }
      
      .w-50 {
        width: 50% !important;
      }
      
      .w-75 {
        width: 75% !important;
      }
      
      .w-100 {
        width: 100% !important;
      }
      
      .w-auto {
        width: auto !important;
      }
      
      .h-25 {
        height: 25% !important;
      }
      
      .h-50 {
        height: 50% !important;
      }
      
      .h-75 {
        height: 75% !important;
      }
      
      .h-100 {
        height: 100% !important;
      }
      
      .h-auto {
        height: auto !important;
      }
      
      .mw-100 {
        max-width: 100% !important;
      }
      
      .mh-100 {
        max-height: 100% !important;
      }
      
      .min-vw-100 {
        min-width: 100vw !important;
      }
      
      .min-vh-100 {
        min-height: 100vh !important;
      }
      
      .vw-100 {
        width: 100vw !important;
      }
      
      .vh-100 {
        height: 100vh !important;
      }
      
      .stretched-link::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
        pointer-events: auto;
        content: "";
        background-color: rgba(0, 0, 0, 0);
      }
      
      .m-0 {
        margin: 0 !important;
      }
      
      .mt-0,
      .my-0 {
        margin-top: 0 !important;
      }
      
      .mr-0,
      .mx-0 {
        margin-right: 0 !important;
      }
      
      .mb-0,
      .my-0 {
        margin-bottom: 0 !important;
      }
      
      .ml-0,
      .mx-0 {
        margin-left: 0 !important;
      }
      
      .m-1 {
        margin: 0.25rem !important;
      }
      
      .mt-1,
      .my-1 {
        margin-top: 0.25rem !important;
      }
      
      .mr-1,
      .mx-1 {
        margin-right: 0.25rem !important;
      }
      
      .mb-1,
      .my-1 {
        margin-bottom: 0.25rem !important;
      }
      
      .ml-1,
      .mx-1 {
        margin-left: 0.25rem !important;
      }
      
      .m-2 {
        margin: 0.5rem !important;
      }
      
      .mt-2,
      .my-2 {
        margin-top: 0.5rem !important;
      }
      
      .mr-2,
      .mx-2 {
        margin-right: 0.5rem !important;
      }
      
      .mb-2,
      .my-2 {
        margin-bottom: 0.5rem !important;
      }
      
      .ml-2,
      .mx-2 {
        margin-left: 0.5rem !important;
      }
      
      .m-3 {
        margin: 1rem !important;
      }
      
      .mt-3,
      .my-3 {
        margin-top: 1rem !important;
      }
      
      .mr-3,
      .mx-3 {
        margin-right: 1rem !important;
      }
      
      .mb-3,
      .my-3 {
        margin-bottom: 1rem !important;
      }
      
      .ml-3,
      .mx-3 {
        margin-left: 1rem !important;
      }
      
      .m-4 {
        margin: 1.5rem !important;
      }
      
      .mt-4,
      .my-4 {
        margin-top: 1.5rem !important;
      }
      
      .mr-4,
      .mx-4 {
        margin-right: 1.5rem !important;
      }
      
      .mb-4,
      .my-4 {
        margin-bottom: 1.5rem !important;
      }
      
      .ml-4,
      .mx-4 {
        margin-left: 1.5rem !important;
      }
      
      .m-5 {
        margin: 3rem !important;
      }
      
      .mt-5,
      .my-5 {
        margin-top: 3rem !important;
      }
      
      .mr-5,
      .mx-5 {
        margin-right: 3rem !important;
      }
      
      .mb-5,
      .my-5 {
        margin-bottom: 3rem !important;
      }
      
      .ml-5,
      .mx-5 {
        margin-left: 3rem !important;
      }
      
      .p-0 {
        padding: 0 !important;
      }
      
      .pt-0,
      .py-0 {
        padding-top: 0 !important;
      }
      
      .pr-0,
      .px-0 {
        padding-right: 0 !important;
      }
      
      .pb-0,
      .py-0 {
        padding-bottom: 0 !important;
      }
      
      .pl-0,
      .px-0 {
        padding-left: 0 !important;
      }
      
      .p-1 {
        padding: 0.25rem !important;
      }
      
      .pt-1,
      .py-1 {
        padding-top: 0.25rem !important;
      }
      
      .pr-1,
      .px-1 {
        padding-right: 0.25rem !important;
      }
      
      .pb-1,
      .py-1 {
        padding-bottom: 0.25rem !important;
      }
      
      .pl-1,
      .px-1 {
        padding-left: 0.25rem !important;
      }
      
      .p-2 {
        padding: 0.5rem !important;
      }
      
      .pt-2,
      .py-2 {
        padding-top: 0.5rem !important;
      }
      
      .pr-2,
      .px-2 {
        padding-right: 0.5rem !important;
      }
      
      .pb-2,
      .py-2 {
        padding-bottom: 0.5rem !important;
      }
      
      .pl-2,
      .px-2 {
        padding-left: 0.5rem !important;
      }
      
      .p-3 {
        padding: 1rem !important;
      }
      
      .pt-3,
      .py-3 {
        padding-top: 1rem !important;
      }
      
      .pr-3,
      .px-3 {
        padding-right: 1rem !important;
      }
      
      .pb-3,
      .py-3 {
        padding-bottom: 1rem !important;
      }
      
      .pl-3,
      .px-3 {
        padding-left: 1rem !important;
      }
      
      .p-4 {
        padding: 1.5rem !important;
      }
      
      .pt-4,
      .py-4 {
        padding-top: 1.5rem !important;
      }
      
      .pr-4,
      .px-4 {
        padding-right: 1.5rem !important;
      }
      
      .pb-4,
      .py-4 {
        padding-bottom: 1.5rem !important;
      }
      
      .pl-4,
      .px-4 {
        padding-left: 1.5rem !important;
      }
      
      .p-5 {
        padding: 3rem !important;
      }
      
      .pt-5,
      .py-5 {
        padding-top: 3rem !important;
      }
      
      .pr-5,
      .px-5 {
        padding-right: 3rem !important;
      }
      
      .pb-5,
      .py-5 {
        padding-bottom: 3rem !important;
      }
      
      .pl-5,
      .px-5 {
        padding-left: 3rem !important;
      }
      
      .m-n1 {
        margin: -0.25rem !important;
      }
      
      .mt-n1,
      .my-n1 {
        margin-top: -0.25rem !important;
      }
      
      .mr-n1,
      .mx-n1 {
        margin-right: -0.25rem !important;
      }
      
      .mb-n1,
      .my-n1 {
        margin-bottom: -0.25rem !important;
      }
      
      .ml-n1,
      .mx-n1 {
        margin-left: -0.25rem !important;
      }
      
      .m-n2 {
        margin: -0.5rem !important;
      }
      
      .mt-n2,
      .my-n2 {
        margin-top: -0.5rem !important;
      }
      
      .mr-n2,
      .mx-n2 {
        margin-right: -0.5rem !important;
      }
      
      .mb-n2,
      .my-n2 {
        margin-bottom: -0.5rem !important;
      }
      
      .ml-n2,
      .mx-n2 {
        margin-left: -0.5rem !important;
      }
      
      .m-n3 {
        margin: -1rem !important;
      }
      
      .mt-n3,
      .my-n3 {
        margin-top: -1rem !important;
      }
      
      .mr-n3,
      .mx-n3 {
        margin-right: -1rem !important;
      }
      
      .mb-n3,
      .my-n3 {
        margin-bottom: -1rem !important;
      }
      
      .ml-n3,
      .mx-n3 {
        margin-left: -1rem !important;
      }
      
      .m-n4 {
        margin: -1.5rem !important;
      }
      
      .mt-n4,
      .my-n4 {
        margin-top: -1.5rem !important;
      }
      
      .mr-n4,
      .mx-n4 {
        margin-right: -1.5rem !important;
      }
      
      .mb-n4,
      .my-n4 {
        margin-bottom: -1.5rem !important;
      }
      
      .ml-n4,
      .mx-n4 {
        margin-left: -1.5rem !important;
      }
      
      .m-n5 {
        margin: -3rem !important;
      }
      
      .mt-n5,
      .my-n5 {
        margin-top: -3rem !important;
      }
      
      .mr-n5,
      .mx-n5 {
        margin-right: -3rem !important;
      }
      
      .mb-n5,
      .my-n5 {
        margin-bottom: -3rem !important;
      }
      
      .ml-n5,
      .mx-n5 {
        margin-left: -3rem !important;
      }
      
      .m-auto {
        margin: auto !important;
      }
      
      .mt-auto,
      .my-auto {
        margin-top: auto !important;
      }
      
      .mr-auto,
      .mx-auto {
        margin-right: auto !important;
      }
      
      .mb-auto,
      .my-auto {
        margin-bottom: auto !important;
      }
      
      .ml-auto,
      .mx-auto {
        margin-left: auto !important;
      }
      
      @media (min-width: 576px) {
        .m-sm-0 {
          margin: 0 !important;
        }
        .mt-sm-0,
        .my-sm-0 {
          margin-top: 0 !important;
        }
        .mr-sm-0,
        .mx-sm-0 {
          margin-right: 0 !important;
        }
        .mb-sm-0,
        .my-sm-0 {
          margin-bottom: 0 !important;
        }
        .ml-sm-0,
        .mx-sm-0 {
          margin-left: 0 !important;
        }
        .m-sm-1 {
          margin: 0.25rem !important;
        }
        .mt-sm-1,
        .my-sm-1 {
          margin-top: 0.25rem !important;
        }
        .mr-sm-1,
        .mx-sm-1 {
          margin-right: 0.25rem !important;
        }
        .mb-sm-1,
        .my-sm-1 {
          margin-bottom: 0.25rem !important;
        }
        .ml-sm-1,
        .mx-sm-1 {
          margin-left: 0.25rem !important;
        }
        .m-sm-2 {
          margin: 0.5rem !important;
        }
        .mt-sm-2,
        .my-sm-2 {
          margin-top: 0.5rem !important;
        }
        .mr-sm-2,
        .mx-sm-2 {
          margin-right: 0.5rem !important;
        }
        .mb-sm-2,
        .my-sm-2 {
          margin-bottom: 0.5rem !important;
        }
        .ml-sm-2,
        .mx-sm-2 {
          margin-left: 0.5rem !important;
        }
        .m-sm-3 {
          margin: 1rem !important;
        }
        .mt-sm-3,
        .my-sm-3 {
          margin-top: 1rem !important;
        }
        .mr-sm-3,
        .mx-sm-3 {
          margin-right: 1rem !important;
        }
        .mb-sm-3,
        .my-sm-3 {
          margin-bottom: 1rem !important;
        }
        .ml-sm-3,
        .mx-sm-3 {
          margin-left: 1rem !important;
        }
        .m-sm-4 {
          margin: 1.5rem !important;
        }
        .mt-sm-4,
        .my-sm-4 {
          margin-top: 1.5rem !important;
        }
        .mr-sm-4,
        .mx-sm-4 {
          margin-right: 1.5rem !important;
        }
        .mb-sm-4,
        .my-sm-4 {
          margin-bottom: 1.5rem !important;
        }
        .ml-sm-4,
        .mx-sm-4 {
          margin-left: 1.5rem !important;
        }
        .m-sm-5 {
          margin: 3rem !important;
        }
        .mt-sm-5,
        .my-sm-5 {
          margin-top: 3rem !important;
        }
        .mr-sm-5,
        .mx-sm-5 {
          margin-right: 3rem !important;
        }
        .mb-sm-5,
        .my-sm-5 {
          margin-bottom: 3rem !important;
        }
        .ml-sm-5,
        .mx-sm-5 {
          margin-left: 3rem !important;
        }
        .p-sm-0 {
          padding: 0 !important;
        }
        .pt-sm-0,
        .py-sm-0 {
          padding-top: 0 !important;
        }
        .pr-sm-0,
        .px-sm-0 {
          padding-right: 0 !important;
        }
        .pb-sm-0,
        .py-sm-0 {
          padding-bottom: 0 !important;
        }
        .pl-sm-0,
        .px-sm-0 {
          padding-left: 0 !important;
        }
        .p-sm-1 {
          padding: 0.25rem !important;
        }
        .pt-sm-1,
        .py-sm-1 {
          padding-top: 0.25rem !important;
        }
        .pr-sm-1,
        .px-sm-1 {
          padding-right: 0.25rem !important;
        }
        .pb-sm-1,
        .py-sm-1 {
          padding-bottom: 0.25rem !important;
        }
        .pl-sm-1,
        .px-sm-1 {
          padding-left: 0.25rem !important;
        }
        .p-sm-2 {
          padding: 0.5rem !important;
        }
        .pt-sm-2,
        .py-sm-2 {
          padding-top: 0.5rem !important;
        }
        .pr-sm-2,
        .px-sm-2 {
          padding-right: 0.5rem !important;
        }
        .pb-sm-2,
        .py-sm-2 {
          padding-bottom: 0.5rem !important;
        }
        .pl-sm-2,
        .px-sm-2 {
          padding-left: 0.5rem !important;
        }
        .p-sm-3 {
          padding: 1rem !important;
        }
        .pt-sm-3,
        .py-sm-3 {
          padding-top: 1rem !important;
        }
        .pr-sm-3,
        .px-sm-3 {
          padding-right: 1rem !important;
        }
        .pb-sm-3,
        .py-sm-3 {
          padding-bottom: 1rem !important;
        }
        .pl-sm-3,
        .px-sm-3 {
          padding-left: 1rem !important;
        }
        .p-sm-4 {
          padding: 1.5rem !important;
        }
        .pt-sm-4,
        .py-sm-4 {
          padding-top: 1.5rem !important;
        }
        .pr-sm-4,
        .px-sm-4 {
          padding-right: 1.5rem !important;
        }
        .pb-sm-4,
        .py-sm-4 {
          padding-bottom: 1.5rem !important;
        }
        .pl-sm-4,
        .px-sm-4 {
          padding-left: 1.5rem !important;
        }
        .p-sm-5 {
          padding: 3rem !important;
        }
        .pt-sm-5,
        .py-sm-5 {
          padding-top: 3rem !important;
        }
        .pr-sm-5,
        .px-sm-5 {
          padding-right: 3rem !important;
        }
        .pb-sm-5,
        .py-sm-5 {
          padding-bottom: 3rem !important;
        }
        .pl-sm-5,
        .px-sm-5 {
          padding-left: 3rem !important;
        }
        .m-sm-n1 {
          margin: -0.25rem !important;
        }
        .mt-sm-n1,
        .my-sm-n1 {
          margin-top: -0.25rem !important;
        }
        .mr-sm-n1,
        .mx-sm-n1 {
          margin-right: -0.25rem !important;
        }
        .mb-sm-n1,
        .my-sm-n1 {
          margin-bottom: -0.25rem !important;
        }
        .ml-sm-n1,
        .mx-sm-n1 {
          margin-left: -0.25rem !important;
        }
        .m-sm-n2 {
          margin: -0.5rem !important;
        }
        .mt-sm-n2,
        .my-sm-n2 {
          margin-top: -0.5rem !important;
        }
        .mr-sm-n2,
        .mx-sm-n2 {
          margin-right: -0.5rem !important;
        }
        .mb-sm-n2,
        .my-sm-n2 {
          margin-bottom: -0.5rem !important;
        }
        .ml-sm-n2,
        .mx-sm-n2 {
          margin-left: -0.5rem !important;
        }
        .m-sm-n3 {
          margin: -1rem !important;
        }
        .mt-sm-n3,
        .my-sm-n3 {
          margin-top: -1rem !important;
        }
        .mr-sm-n3,
        .mx-sm-n3 {
          margin-right: -1rem !important;
        }
        .mb-sm-n3,
        .my-sm-n3 {
          margin-bottom: -1rem !important;
        }
        .ml-sm-n3,
        .mx-sm-n3 {
          margin-left: -1rem !important;
        }
        .m-sm-n4 {
          margin: -1.5rem !important;
        }
        .mt-sm-n4,
        .my-sm-n4 {
          margin-top: -1.5rem !important;
        }
        .mr-sm-n4,
        .mx-sm-n4 {
          margin-right: -1.5rem !important;
        }
        .mb-sm-n4,
        .my-sm-n4 {
          margin-bottom: -1.5rem !important;
        }
        .ml-sm-n4,
        .mx-sm-n4 {
          margin-left: -1.5rem !important;
        }
        .m-sm-n5 {
          margin: -3rem !important;
        }
        .mt-sm-n5,
        .my-sm-n5 {
          margin-top: -3rem !important;
        }
        .mr-sm-n5,
        .mx-sm-n5 {
          margin-right: -3rem !important;
        }
        .mb-sm-n5,
        .my-sm-n5 {
          margin-bottom: -3rem !important;
        }
        .ml-sm-n5,
        .mx-sm-n5 {
          margin-left: -3rem !important;
        }
        .m-sm-auto {
          margin: auto !important;
        }
        .mt-sm-auto,
        .my-sm-auto {
          margin-top: auto !important;
        }
        .mr-sm-auto,
        .mx-sm-auto {
          margin-right: auto !important;
        }
        .mb-sm-auto,
        .my-sm-auto {
          margin-bottom: auto !important;
        }
        .ml-sm-auto,
        .mx-sm-auto {
          margin-left: auto !important;
        }
      }
      
      @media (min-width: 768px) {
        .m-md-0 {
          margin: 0 !important;
        }
        .mt-md-0,
        .my-md-0 {
          margin-top: 0 !important;
        }
        .mr-md-0,
        .mx-md-0 {
          margin-right: 0 !important;
        }
        .mb-md-0,
        .my-md-0 {
          margin-bottom: 0 !important;
        }
        .ml-md-0,
        .mx-md-0 {
          margin-left: 0 !important;
        }
        .m-md-1 {
          margin: 0.25rem !important;
        }
        .mt-md-1,
        .my-md-1 {
          margin-top: 0.25rem !important;
        }
        .mr-md-1,
        .mx-md-1 {
          margin-right: 0.25rem !important;
        }
        .mb-md-1,
        .my-md-1 {
          margin-bottom: 0.25rem !important;
        }
        .ml-md-1,
        .mx-md-1 {
          margin-left: 0.25rem !important;
        }
        .m-md-2 {
          margin: 0.5rem !important;
        }
        .mt-md-2,
        .my-md-2 {
          margin-top: 0.5rem !important;
        }
        .mr-md-2,
        .mx-md-2 {
          margin-right: 0.5rem !important;
        }
        .mb-md-2,
        .my-md-2 {
          margin-bottom: 0.5rem !important;
        }
        .ml-md-2,
        .mx-md-2 {
          margin-left: 0.5rem !important;
        }
        .m-md-3 {
          margin: 1rem !important;
        }
        .mt-md-3,
        .my-md-3 {
          margin-top: 1rem !important;
        }
        .mr-md-3,
        .mx-md-3 {
          margin-right: 1rem !important;
        }
        .mb-md-3,
        .my-md-3 {
          margin-bottom: 1rem !important;
        }
        .ml-md-3,
        .mx-md-3 {
          margin-left: 1rem !important;
        }
        .m-md-4 {
          margin: 1.5rem !important;
        }
        .mt-md-4,
        .my-md-4 {
          margin-top: 1.5rem !important;
        }
        .mr-md-4,
        .mx-md-4 {
          margin-right: 1.5rem !important;
        }
        .mb-md-4,
        .my-md-4 {
          margin-bottom: 1.5rem !important;
        }
        .ml-md-4,
        .mx-md-4 {
          margin-left: 1.5rem !important;
        }
        .m-md-5 {
          margin: 3rem !important;
        }
        .mt-md-5,
        .my-md-5 {
          margin-top: 3rem !important;
        }
        .mr-md-5,
        .mx-md-5 {
          margin-right: 3rem !important;
        }
        .mb-md-5,
        .my-md-5 {
          margin-bottom: 3rem !important;
        }
        .ml-md-5,
        .mx-md-5 {
          margin-left: 3rem !important;
        }
        .p-md-0 {
          padding: 0 !important;
        }
        .pt-md-0,
        .py-md-0 {
          padding-top: 0 !important;
        }
        .pr-md-0,
        .px-md-0 {
          padding-right: 0 !important;
        }
        .pb-md-0,
        .py-md-0 {
          padding-bottom: 0 !important;
        }
        .pl-md-0,
        .px-md-0 {
          padding-left: 0 !important;
        }
        .p-md-1 {
          padding: 0.25rem !important;
        }
        .pt-md-1,
        .py-md-1 {
          padding-top: 0.25rem !important;
        }
        .pr-md-1,
        .px-md-1 {
          padding-right: 0.25rem !important;
        }
        .pb-md-1,
        .py-md-1 {
          padding-bottom: 0.25rem !important;
        }
        .pl-md-1,
        .px-md-1 {
          padding-left: 0.25rem !important;
        }
        .p-md-2 {
          padding: 0.5rem !important;
        }
        .pt-md-2,
        .py-md-2 {
          padding-top: 0.5rem !important;
        }
        .pr-md-2,
        .px-md-2 {
          padding-right: 0.5rem !important;
        }
        .pb-md-2,
        .py-md-2 {
          padding-bottom: 0.5rem !important;
        }
        .pl-md-2,
        .px-md-2 {
          padding-left: 0.5rem !important;
        }
        .p-md-3 {
          padding: 1rem !important;
        }
        .pt-md-3,
        .py-md-3 {
          padding-top: 1rem !important;
        }
        .pr-md-3,
        .px-md-3 {
          padding-right: 1rem !important;
        }
        .pb-md-3,
        .py-md-3 {
          padding-bottom: 1rem !important;
        }
        .pl-md-3,
        .px-md-3 {
          padding-left: 1rem !important;
        }
        .p-md-4 {
          padding: 1.5rem !important;
        }
        .pt-md-4,
        .py-md-4 {
          padding-top: 1.5rem !important;
        }
        .pr-md-4,
        .px-md-4 {
          padding-right: 1.5rem !important;
        }
        .pb-md-4,
        .py-md-4 {
          padding-bottom: 1.5rem !important;
        }
        .pl-md-4,
        .px-md-4 {
          padding-left: 1.5rem !important;
        }
        .p-md-5 {
          padding: 3rem !important;
        }
        .pt-md-5,
        .py-md-5 {
          padding-top: 3rem !important;
        }
        .pr-md-5,
        .px-md-5 {
          padding-right: 3rem !important;
        }
        .pb-md-5,
        .py-md-5 {
          padding-bottom: 3rem !important;
        }
        .pl-md-5,
        .px-md-5 {
          padding-left: 3rem !important;
        }
        .m-md-n1 {
          margin: -0.25rem !important;
        }
        .mt-md-n1,
        .my-md-n1 {
          margin-top: -0.25rem !important;
        }
        .mr-md-n1,
        .mx-md-n1 {
          margin-right: -0.25rem !important;
        }
        .mb-md-n1,
        .my-md-n1 {
          margin-bottom: -0.25rem !important;
        }
        .ml-md-n1,
        .mx-md-n1 {
          margin-left: -0.25rem !important;
        }
        .m-md-n2 {
          margin: -0.5rem !important;
        }
        .mt-md-n2,
        .my-md-n2 {
          margin-top: -0.5rem !important;
        }
        .mr-md-n2,
        .mx-md-n2 {
          margin-right: -0.5rem !important;
        }
        .mb-md-n2,
        .my-md-n2 {
          margin-bottom: -0.5rem !important;
        }
        .ml-md-n2,
        .mx-md-n2 {
          margin-left: -0.5rem !important;
        }
        .m-md-n3 {
          margin: -1rem !important;
        }
        .mt-md-n3,
        .my-md-n3 {
          margin-top: -1rem !important;
        }
        .mr-md-n3,
        .mx-md-n3 {
          margin-right: -1rem !important;
        }
        .mb-md-n3,
        .my-md-n3 {
          margin-bottom: -1rem !important;
        }
        .ml-md-n3,
        .mx-md-n3 {
          margin-left: -1rem !important;
        }
        .m-md-n4 {
          margin: -1.5rem !important;
        }
        .mt-md-n4,
        .my-md-n4 {
          margin-top: -1.5rem !important;
        }
        .mr-md-n4,
        .mx-md-n4 {
          margin-right: -1.5rem !important;
        }
        .mb-md-n4,
        .my-md-n4 {
          margin-bottom: -1.5rem !important;
        }
        .ml-md-n4,
        .mx-md-n4 {
          margin-left: -1.5rem !important;
        }
        .m-md-n5 {
          margin: -3rem !important;
        }
        .mt-md-n5,
        .my-md-n5 {
          margin-top: -3rem !important;
        }
        .mr-md-n5,
        .mx-md-n5 {
          margin-right: -3rem !important;
        }
        .mb-md-n5,
        .my-md-n5 {
          margin-bottom: -3rem !important;
        }
        .ml-md-n5,
        .mx-md-n5 {
          margin-left: -3rem !important;
        }
        .m-md-auto {
          margin: auto !important;
        }
        .mt-md-auto,
        .my-md-auto {
          margin-top: auto !important;
        }
        .mr-md-auto,
        .mx-md-auto {
          margin-right: auto !important;
        }
        .mb-md-auto,
        .my-md-auto {
          margin-bottom: auto !important;
        }
        .ml-md-auto,
        .mx-md-auto {
          margin-left: auto !important;
        }
      }
      
      @media (min-width: 992px) {
        .m-lg-0 {
          margin: 0 !important;
        }
        .mt-lg-0,
        .my-lg-0 {
          margin-top: 0 !important;
        }
        .mr-lg-0,
        .mx-lg-0 {
          margin-right: 0 !important;
        }
        .mb-lg-0,
        .my-lg-0 {
          margin-bottom: 0 !important;
        }
        .ml-lg-0,
        .mx-lg-0 {
          margin-left: 0 !important;
        }
        .m-lg-1 {
          margin: 0.25rem !important;
        }
        .mt-lg-1,
        .my-lg-1 {
          margin-top: 0.25rem !important;
        }
        .mr-lg-1,
        .mx-lg-1 {
          margin-right: 0.25rem !important;
        }
        .mb-lg-1,
        .my-lg-1 {
          margin-bottom: 0.25rem !important;
        }
        .ml-lg-1,
        .mx-lg-1 {
          margin-left: 0.25rem !important;
        }
        .m-lg-2 {
          margin: 0.5rem !important;
        }
        .mt-lg-2,
        .my-lg-2 {
          margin-top: 0.5rem !important;
        }
        .mr-lg-2,
        .mx-lg-2 {
          margin-right: 0.5rem !important;
        }
        .mb-lg-2,
        .my-lg-2 {
          margin-bottom: 0.5rem !important;
        }
        .ml-lg-2,
        .mx-lg-2 {
          margin-left: 0.5rem !important;
        }
        .m-lg-3 {
          margin: 1rem !important;
        }
        .mt-lg-3,
        .my-lg-3 {
          margin-top: 1rem !important;
        }
        .mr-lg-3,
        .mx-lg-3 {
          margin-right: 1rem !important;
        }
        .mb-lg-3,
        .my-lg-3 {
          margin-bottom: 1rem !important;
        }
        .ml-lg-3,
        .mx-lg-3 {
          margin-left: 1rem !important;
        }
        .m-lg-4 {
          margin: 1.5rem !important;
        }
        .mt-lg-4,
        .my-lg-4 {
          margin-top: 1.5rem !important;
        }
        .mr-lg-4,
        .mx-lg-4 {
          margin-right: 1.5rem !important;
        }
        .mb-lg-4,
        .my-lg-4 {
          margin-bottom: 1.5rem !important;
        }
        .ml-lg-4,
        .mx-lg-4 {
          margin-left: 1.5rem !important;
        }
        .m-lg-5 {
          margin: 3rem !important;
        }
        .mt-lg-5,
        .my-lg-5 {
          margin-top: 3rem !important;
        }
        .mr-lg-5,
        .mx-lg-5 {
          margin-right: 3rem !important;
        }
        .mb-lg-5,
        .my-lg-5 {
          margin-bottom: 3rem !important;
        }
        .ml-lg-5,
        .mx-lg-5 {
          margin-left: 3rem !important;
        }
        .p-lg-0 {
          padding: 0 !important;
        }
        .pt-lg-0,
        .py-lg-0 {
          padding-top: 0 !important;
        }
        .pr-lg-0,
        .px-lg-0 {
          padding-right: 0 !important;
        }
        .pb-lg-0,
        .py-lg-0 {
          padding-bottom: 0 !important;
        }
        .pl-lg-0,
        .px-lg-0 {
          padding-left: 0 !important;
        }
        .p-lg-1 {
          padding: 0.25rem !important;
        }
        .pt-lg-1,
        .py-lg-1 {
          padding-top: 0.25rem !important;
        }
        .pr-lg-1,
        .px-lg-1 {
          padding-right: 0.25rem !important;
        }
        .pb-lg-1,
        .py-lg-1 {
          padding-bottom: 0.25rem !important;
        }
        .pl-lg-1,
        .px-lg-1 {
          padding-left: 0.25rem !important;
        }
        .p-lg-2 {
          padding: 0.5rem !important;
        }
        .pt-lg-2,
        .py-lg-2 {
          padding-top: 0.5rem !important;
        }
        .pr-lg-2,
        .px-lg-2 {
          padding-right: 0.5rem !important;
        }
        .pb-lg-2,
        .py-lg-2 {
          padding-bottom: 0.5rem !important;
        }
        .pl-lg-2,
        .px-lg-2 {
          padding-left: 0.5rem !important;
        }
        .p-lg-3 {
          padding: 1rem !important;
        }
        .pt-lg-3,
        .py-lg-3 {
          padding-top: 1rem !important;
        }
        .pr-lg-3,
        .px-lg-3 {
          padding-right: 1rem !important;
        }
        .pb-lg-3,
        .py-lg-3 {
          padding-bottom: 1rem !important;
        }
        .pl-lg-3,
        .px-lg-3 {
          padding-left: 1rem !important;
        }
        .p-lg-4 {
          padding: 1.5rem !important;
        }
        .pt-lg-4,
        .py-lg-4 {
          padding-top: 1.5rem !important;
        }
        .pr-lg-4,
        .px-lg-4 {
          padding-right: 1.5rem !important;
        }
        .pb-lg-4,
        .py-lg-4 {
          padding-bottom: 1.5rem !important;
        }
        .pl-lg-4,
        .px-lg-4 {
          padding-left: 1.5rem !important;
        }
        .p-lg-5 {
          padding: 3rem !important;
        }
        .pt-lg-5,
        .py-lg-5 {
          padding-top: 3rem !important;
        }
        .pr-lg-5,
        .px-lg-5 {
          padding-right: 3rem !important;
        }
        .pb-lg-5,
        .py-lg-5 {
          padding-bottom: 3rem !important;
        }
        .pl-lg-5,
        .px-lg-5 {
          padding-left: 3rem !important;
        }
        .m-lg-n1 {
          margin: -0.25rem !important;
        }
        .mt-lg-n1,
        .my-lg-n1 {
          margin-top: -0.25rem !important;
        }
        .mr-lg-n1,
        .mx-lg-n1 {
          margin-right: -0.25rem !important;
        }
        .mb-lg-n1,
        .my-lg-n1 {
          margin-bottom: -0.25rem !important;
        }
        .ml-lg-n1,
        .mx-lg-n1 {
          margin-left: -0.25rem !important;
        }
        .m-lg-n2 {
          margin: -0.5rem !important;
        }
        .mt-lg-n2,
        .my-lg-n2 {
          margin-top: -0.5rem !important;
        }
        .mr-lg-n2,
        .mx-lg-n2 {
          margin-right: -0.5rem !important;
        }
        .mb-lg-n2,
        .my-lg-n2 {
          margin-bottom: -0.5rem !important;
        }
        .ml-lg-n2,
        .mx-lg-n2 {
          margin-left: -0.5rem !important;
        }
        .m-lg-n3 {
          margin: -1rem !important;
        }
        .mt-lg-n3,
        .my-lg-n3 {
          margin-top: -1rem !important;
        }
        .mr-lg-n3,
        .mx-lg-n3 {
          margin-right: -1rem !important;
        }
        .mb-lg-n3,
        .my-lg-n3 {
          margin-bottom: -1rem !important;
        }
        .ml-lg-n3,
        .mx-lg-n3 {
          margin-left: -1rem !important;
        }
        .m-lg-n4 {
          margin: -1.5rem !important;
        }
        .mt-lg-n4,
        .my-lg-n4 {
          margin-top: -1.5rem !important;
        }
        .mr-lg-n4,
        .mx-lg-n4 {
          margin-right: -1.5rem !important;
        }
        .mb-lg-n4,
        .my-lg-n4 {
          margin-bottom: -1.5rem !important;
        }
        .ml-lg-n4,
        .mx-lg-n4 {
          margin-left: -1.5rem !important;
        }
        .m-lg-n5 {
          margin: -3rem !important;
        }
        .mt-lg-n5,
        .my-lg-n5 {
          margin-top: -3rem !important;
        }
        .mr-lg-n5,
        .mx-lg-n5 {
          margin-right: -3rem !important;
        }
        .mb-lg-n5,
        .my-lg-n5 {
          margin-bottom: -3rem !important;
        }
        .ml-lg-n5,
        .mx-lg-n5 {
          margin-left: -3rem !important;
        }
        .m-lg-auto {
          margin: auto !important;
        }
        .mt-lg-auto,
        .my-lg-auto {
          margin-top: auto !important;
        }
        .mr-lg-auto,
        .mx-lg-auto {
          margin-right: auto !important;
        }
        .mb-lg-auto,
        .my-lg-auto {
          margin-bottom: auto !important;
        }
        .ml-lg-auto,
        .mx-lg-auto {
          margin-left: auto !important;
        }
      }
      
      @media (min-width: 1200px) {
        .m-xl-0 {
          margin: 0 !important;
        }
        .mt-xl-0,
        .my-xl-0 {
          margin-top: 0 !important;
        }
        .mr-xl-0,
        .mx-xl-0 {
          margin-right: 0 !important;
        }
        .mb-xl-0,
        .my-xl-0 {
          margin-bottom: 0 !important;
        }
        .ml-xl-0,
        .mx-xl-0 {
          margin-left: 0 !important;
        }
        .m-xl-1 {
          margin: 0.25rem !important;
        }
        .mt-xl-1,
        .my-xl-1 {
          margin-top: 0.25rem !important;
        }
        .mr-xl-1,
        .mx-xl-1 {
          margin-right: 0.25rem !important;
        }
        .mb-xl-1,
        .my-xl-1 {
          margin-bottom: 0.25rem !important;
        }
        .ml-xl-1,
        .mx-xl-1 {
          margin-left: 0.25rem !important;
        }
        .m-xl-2 {
          margin: 0.5rem !important;
        }
        .mt-xl-2,
        .my-xl-2 {
          margin-top: 0.5rem !important;
        }
        .mr-xl-2,
        .mx-xl-2 {
          margin-right: 0.5rem !important;
        }
        .mb-xl-2,
        .my-xl-2 {
          margin-bottom: 0.5rem !important;
        }
        .ml-xl-2,
        .mx-xl-2 {
          margin-left: 0.5rem !important;
        }
        .m-xl-3 {
          margin: 1rem !important;
        }
        .mt-xl-3,
        .my-xl-3 {
          margin-top: 1rem !important;
        }
        .mr-xl-3,
        .mx-xl-3 {
          margin-right: 1rem !important;
        }
        .mb-xl-3,
        .my-xl-3 {
          margin-bottom: 1rem !important;
        }
        .ml-xl-3,
        .mx-xl-3 {
          margin-left: 1rem !important;
        }
        .m-xl-4 {
          margin: 1.5rem !important;
        }
        .mt-xl-4,
        .my-xl-4 {
          margin-top: 1.5rem !important;
        }
        .mr-xl-4,
        .mx-xl-4 {
          margin-right: 1.5rem !important;
        }
        .mb-xl-4,
        .my-xl-4 {
          margin-bottom: 1.5rem !important;
        }
        .ml-xl-4,
        .mx-xl-4 {
          margin-left: 1.5rem !important;
        }
        .m-xl-5 {
          margin: 3rem !important;
        }
        .mt-xl-5,
        .my-xl-5 {
          margin-top: 3rem !important;
        }
        .mr-xl-5,
        .mx-xl-5 {
          margin-right: 3rem !important;
        }
        .mb-xl-5,
        .my-xl-5 {
          margin-bottom: 3rem !important;
        }
        .ml-xl-5,
        .mx-xl-5 {
          margin-left: 3rem !important;
        }
        .p-xl-0 {
          padding: 0 !important;
        }
        .pt-xl-0,
        .py-xl-0 {
          padding-top: 0 !important;
        }
        .pr-xl-0,
        .px-xl-0 {
          padding-right: 0 !important;
        }
        .pb-xl-0,
        .py-xl-0 {
          padding-bottom: 0 !important;
        }
        .pl-xl-0,
        .px-xl-0 {
          padding-left: 0 !important;
        }
        .p-xl-1 {
          padding: 0.25rem !important;
        }
        .pt-xl-1,
        .py-xl-1 {
          padding-top: 0.25rem !important;
        }
        .pr-xl-1,
        .px-xl-1 {
          padding-right: 0.25rem !important;
        }
        .pb-xl-1,
        .py-xl-1 {
          padding-bottom: 0.25rem !important;
        }
        .pl-xl-1,
        .px-xl-1 {
          padding-left: 0.25rem !important;
        }
        .p-xl-2 {
          padding: 0.5rem !important;
        }
        .pt-xl-2,
        .py-xl-2 {
          padding-top: 0.5rem !important;
        }
        .pr-xl-2,
        .px-xl-2 {
          padding-right: 0.5rem !important;
        }
        .pb-xl-2,
        .py-xl-2 {
          padding-bottom: 0.5rem !important;
        }
        .pl-xl-2,
        .px-xl-2 {
          padding-left: 0.5rem !important;
        }
        .p-xl-3 {
          padding: 1rem !important;
        }
        .pt-xl-3,
        .py-xl-3 {
          padding-top: 1rem !important;
        }
        .pr-xl-3,
        .px-xl-3 {
          padding-right: 1rem !important;
        }
        .pb-xl-3,
        .py-xl-3 {
          padding-bottom: 1rem !important;
        }
        .pl-xl-3,
        .px-xl-3 {
          padding-left: 1rem !important;
        }
        .p-xl-4 {
          padding: 1.5rem !important;
        }
        .pt-xl-4,
        .py-xl-4 {
          padding-top: 1.5rem !important;
        }
        .pr-xl-4,
        .px-xl-4 {
          padding-right: 1.5rem !important;
        }
        .pb-xl-4,
        .py-xl-4 {
          padding-bottom: 1.5rem !important;
        }
        .pl-xl-4,
        .px-xl-4 {
          padding-left: 1.5rem !important;
        }
        .p-xl-5 {
          padding: 3rem !important;
        }
        .pt-xl-5,
        .py-xl-5 {
          padding-top: 3rem !important;
        }
        .pr-xl-5,
        .px-xl-5 {
          padding-right: 3rem !important;
        }
        .pb-xl-5,
        .py-xl-5 {
          padding-bottom: 3rem !important;
        }
        .pl-xl-5,
        .px-xl-5 {
          padding-left: 3rem !important;
        }
        .m-xl-n1 {
          margin: -0.25rem !important;
        }
        .mt-xl-n1,
        .my-xl-n1 {
          margin-top: -0.25rem !important;
        }
        .mr-xl-n1,
        .mx-xl-n1 {
          margin-right: -0.25rem !important;
        }
        .mb-xl-n1,
        .my-xl-n1 {
          margin-bottom: -0.25rem !important;
        }
        .ml-xl-n1,
        .mx-xl-n1 {
          margin-left: -0.25rem !important;
        }
        .m-xl-n2 {
          margin: -0.5rem !important;
        }
        .mt-xl-n2,
        .my-xl-n2 {
          margin-top: -0.5rem !important;
        }
        .mr-xl-n2,
        .mx-xl-n2 {
          margin-right: -0.5rem !important;
        }
        .mb-xl-n2,
        .my-xl-n2 {
          margin-bottom: -0.5rem !important;
        }
        .ml-xl-n2,
        .mx-xl-n2 {
          margin-left: -0.5rem !important;
        }
        .m-xl-n3 {
          margin: -1rem !important;
        }
        .mt-xl-n3,
        .my-xl-n3 {
          margin-top: -1rem !important;
        }
        .mr-xl-n3,
        .mx-xl-n3 {
          margin-right: -1rem !important;
        }
        .mb-xl-n3,
        .my-xl-n3 {
          margin-bottom: -1rem !important;
        }
        .ml-xl-n3,
        .mx-xl-n3 {
          margin-left: -1rem !important;
        }
        .m-xl-n4 {
          margin: -1.5rem !important;
        }
        .mt-xl-n4,
        .my-xl-n4 {
          margin-top: -1.5rem !important;
        }
        .mr-xl-n4,
        .mx-xl-n4 {
          margin-right: -1.5rem !important;
        }
        .mb-xl-n4,
        .my-xl-n4 {
          margin-bottom: -1.5rem !important;
        }
        .ml-xl-n4,
        .mx-xl-n4 {
          margin-left: -1.5rem !important;
        }
        .m-xl-n5 {
          margin: -3rem !important;
        }
        .mt-xl-n5,
        .my-xl-n5 {
          margin-top: -3rem !important;
        }
        .mr-xl-n5,
        .mx-xl-n5 {
          margin-right: -3rem !important;
        }
        .mb-xl-n5,
        .my-xl-n5 {
          margin-bottom: -3rem !important;
        }
        .ml-xl-n5,
        .mx-xl-n5 {
          margin-left: -3rem !important;
        }
        .m-xl-auto {
          margin: auto !important;
        }
        .mt-xl-auto,
        .my-xl-auto {
          margin-top: auto !important;
        }
        .mr-xl-auto,
        .mx-xl-auto {
          margin-right: auto !important;
        }
        .mb-xl-auto,
        .my-xl-auto {
          margin-bottom: auto !important;
        }
        .ml-xl-auto,
        .mx-xl-auto {
          margin-left: auto !important;
        }
      }
      
      .text-monospace {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
      }
      
      .text-justify {
        text-align: justify !important;
      }
      
      .text-wrap {
        white-space: normal !important;
      }
      
      .text-nowrap {
        white-space: nowrap !important;
      }
      
      .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      
      .text-left {
        text-align: left !important;
      }
      
      .text-right {
        text-align: right !important;
      }
      
      .text-center {
        text-align: center !important;
      }
      
      @media (min-width: 576px) {
        .text-sm-left {
          text-align: left !important;
        }
        .text-sm-right {
          text-align: right !important;
        }
        .text-sm-center {
          text-align: center !important;
        }
      }
      
      @media (min-width: 768px) {
        .text-md-left {
          text-align: left !important;
        }
        .text-md-right {
          text-align: right !important;
        }
        .text-md-center {
          text-align: center !important;
        }
      }
      
      @media (min-width: 992px) {
        .text-lg-left {
          text-align: left !important;
        }
        .text-lg-right {
          text-align: right !important;
        }
        .text-lg-center {
          text-align: center !important;
        }
      }
      
      @media (min-width: 1200px) {
        .text-xl-left {
          text-align: left !important;
        }
        .text-xl-right {
          text-align: right !important;
        }
        .text-xl-center {
          text-align: center !important;
        }
      }
      
      .text-lowercase {
        text-transform: lowercase !important;
      }
      
      .text-uppercase {
        text-transform: uppercase !important;
      }
      
      .text-capitalize {
        text-transform: capitalize !important;
      }
      
      .font-weight-light {
        font-weight: 300 !important;
      }
      
      .font-weight-lighter {
        font-weight: lighter !important;
      }
      
      .font-weight-normal {
        font-weight: 400 !important;
      }
      
      .font-weight-bold {
        font-weight: 700 !important;
      }
      
      .font-weight-bolder {
        font-weight: bolder !important;
      }
      
      .font-italic {
        font-style: italic !important;
      }
      
      .text-white {
        color: #fff !important;
      }
      
      .text-primary {
        color: #007bff !important;
      }
      
      a.text-primary:hover, a.text-primary:focus {
        color: #0056b3 !important;
      }
      
      .text-secondary {
        color: #6c757d !important;
      }
      
      a.text-secondary:hover, a.text-secondary:focus {
        color: #494f54 !important;
      }
      
      .text-success {
        color: #28a745 !important;
      }
      
      a.text-success:hover, a.text-success:focus {
        color: #19692c !important;
      }
      
      .text-info {
        color: #17a2b8 !important;
      }
      
      a.text-info:hover, a.text-info:focus {
        color: #0f6674 !important;
      }
      
      .text-warning {
        color: #ffc107 !important;
      }
      
      a.text-warning:hover, a.text-warning:focus {
        color: #ba8b00 !important;
      }
      
      .text-danger {
        color: #dc3545 !important;
      }
      
      a.text-danger:hover, a.text-danger:focus {
        color: #a71d2a !important;
      }
      
      .text-light {
        color: #f8f9fa !important;
      }
      
      a.text-light:hover, a.text-light:focus {
        color: #cbd3da !important;
      }
      
      .text-dark {
        color: #343a40 !important;
      }
      
      a.text-dark:hover, a.text-dark:focus {
        color: #121416 !important;
      }
      
      .text-body {
        color: #212529 !important;
      }
      
      .text-muted {
        color: #6c757d !important;
      }
      
      .text-black-50 {
        color: rgba(0, 0, 0, 0.5) !important;
      }
      
      .text-white-50 {
        color: rgba(255, 255, 255, 0.5) !important;
      }
      
      .text-hide {
        font: 0/0 a;
        color: transparent;
        text-shadow: none;
        background-color: transparent;
        border: 0;
      }
      
      .text-decoration-none {
        text-decoration: none !important;
      }
      
      .text-break {
        word-break: break-word !important;
        overflow-wrap: break-word !important;
      }
      
      .text-reset {
        color: inherit !important;
      }
      
      .visible {
        visibility: visible !important;
      }
      
      .invisible {
        visibility: hidden !important;
      }
      
      @media print {
        *,
        *::before,
        *::after {
          text-shadow: none !important;
          -webkit-box-shadow: none !important;
                  box-shadow: none !important;
        }
        a:not(.btn) {
          text-decoration: underline;
        }
        abbr[title]::after {
          content: " (" attr(title) ")";
        }
        pre {
          white-space: pre-wrap !important;
        }
        pre,
        blockquote {
          border: 1px solid #adb5bd;
          page-break-inside: avoid;
        }
        thead {
          display: table-header-group;
        }
        tr,
        img {
          page-break-inside: avoid;
        }
        p,
        h2,
        h3 {
          orphans: 3;
          widows: 3;
        }
        h2,
        h3 {
          page-break-after: avoid;
        }
        @page {
          size: a3;
        }
        body {
          min-width: 992px !important;
        }
        .container {
          min-width: 992px !important;
        }
        .navbar {
          display: none;
        }
        .badge {
          border: 1px solid #000;
        }
        .table {
          border-collapse: collapse !important;
        }
        .table td,
        .table th {
          background-color: #fff !important;
        }
        .table-bordered th,
        .table-bordered td {
          border: 1px solid #dee2e6 !important;
        }
        .table-dark {
          color: inherit;
        }
        .table-dark th,
        .table-dark td,
        .table-dark thead th,
        .table-dark tbody + tbody {
          border-color: #dee2e6;
        }
        .table .thead-dark th {
          color: inherit;
          border-color: #dee2e6;
        }
      }</style><style type="text/css">@charset "UTF-8";
      /*!
       * BootstrapVue Custom CSS (https://bootstrap-vue.js.org)
       */
      @media (max-width: 575.98px) {
        .bv-d-xs-down-none {
          display: none !important;
        }
      }
      
      @media (max-width: 767.98px) {
        .bv-d-sm-down-none {
          display: none !important;
        }
      }
      
      @media (max-width: 991.98px) {
        .bv-d-md-down-none {
          display: none !important;
        }
      }
      
      @media (max-width: 1199.98px) {
        .bv-d-lg-down-none {
          display: none !important;
        }
      }
      
      .bv-d-xl-down-none {
        display: none !important;
      }
      
      .card-img-left {
        border-top-left-radius: calc(0.25rem - 1px);
        border-bottom-left-radius: calc(0.25rem - 1px);
      }
      
      .card-img-right {
        border-top-right-radius: calc(0.25rem - 1px);
        border-bottom-right-radius: calc(0.25rem - 1px);
      }
      
      .dropdown:not(.dropleft) .dropdown-toggle.dropdown-toggle-no-caret::after {
        display: none !important;
      }
      
      .dropdown.dropleft .dropdown-toggle.dropdown-toggle-no-caret::before {
        display: none !important;
      }
      
      .dropdown.b-dropdown .b-dropdown-form {
        display: inline-block;
        padding: 0.25rem 1.5rem;
        width: 100%;
        clear: both;
        font-weight: 400;
      }
      
      .dropdown.b-dropdown .b-dropdown-form:focus {
        outline: 1px dotted !important;
        outline: 5px auto -webkit-focus-ring-color !important;
      }
      
      .dropdown.b-dropdown .b-dropdown-form.disabled, .dropdown.b-dropdown .b-dropdown-form:disabled {
        outline: 0 !important;
        color: #6c757d;
        pointer-events: none;
      }
      
      .b-dropdown-text {
        display: inline-block;
        padding: 0.25rem 1.5rem;
        margin-bottom: 0;
        width: 100%;
        clear: both;
        font-weight: lighter;
      }
      
      .input-group > .input-group-prepend > .btn-group > .btn,
      .input-group > .input-group-append:not(:last-child) > .btn-group > .btn,
      .input-group > .input-group-append:last-child > .btn-group:not(:last-child):not(.dropdown-toggle) > .btn {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      
      .input-group > .input-group-append > .btn-group > .btn,
      .input-group > .input-group-prepend:not(:first-child) > .btn-group > .btn,
      .input-group > .input-group-prepend:first-child > .btn-group:not(:first-child) > .btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      
      .was-validated .form-control:invalid,
      .was-validated .form-control:valid, .form-control.is-invalid, .form-control.is-valid {
        background-position: right calc(0.375em + 0.1875rem) center;
      }
      
      input[type="color"].form-control {
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.125rem 0.25rem;
      }
      
      input[type="color"].form-control.form-control-sm,
      .input-group-sm input[type="color"].form-control {
        height: calc(1.5em + 0.5rem + 2px);
        padding: 0.125rem 0.25rem;
      }
      
      input[type="color"].form-control.form-control-lg,
      .input-group-lg input[type="color"].form-control {
        height: calc(1.5em + 1rem + 2px);
        padding: 0.125rem 0.25rem;
      }
      
      input[type="color"].form-control:disabled {
        background-color: #adb5bd;
        opacity: 0.65;
      }
      
      .input-group > .custom-range {
        position: relative;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        width: 1%;
        margin-bottom: 0;
      }
      
      .input-group > .custom-range + .form-control,
      .input-group > .custom-range + .form-control-plaintext,
      .input-group > .custom-range + .custom-select,
      .input-group > .custom-range + .custom-range,
      .input-group > .custom-range + .custom-file {
        margin-left: -1px;
      }
      
      .input-group > .form-control + .custom-range,
      .input-group > .form-control-plaintext + .custom-range,
      .input-group > .custom-select + .custom-range,
      .input-group > .custom-range + .custom-range,
      .input-group > .custom-file + .custom-range {
        margin-left: -1px;
      }
      
      .input-group > .custom-range:focus {
        z-index: 3;
      }
      
      .input-group > .custom-range:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      
      .input-group > .custom-range:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      
      .input-group > .custom-range {
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0 0.75rem;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        height: calc(1.5em + 0.75rem + 2px);
        border-radius: 0.25rem;
        -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      }
      
      @media (prefers-reduced-motion: reduce) {
        .input-group > .custom-range {
          -webkit-transition: none;
          transition: none;
        }
      }
      
      .input-group > .custom-range:focus {
        color: #495057;
        background-color: #fff;
        border-color: #80bdff;
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
      
      .input-group > .custom-range:disabled, .input-group > .custom-range[readonly] {
        background-color: #e9ecef;
      }
      
      .input-group-lg > .custom-range {
        height: calc(1.5em + 1rem + 2px);
        padding: 0 1rem;
        border-radius: 0.3rem;
      }
      
      .input-group-sm > .custom-range {
        height: calc(1.5em + 0.5rem + 2px);
        padding: 0 0.5rem;
        border-radius: 0.2rem;
      }
      
      .was-validated .input-group .custom-range:valid, .input-group .custom-range.is-valid {
        border-color: #28a745;
      }
      
      .was-validated .input-group .custom-range:valid:focus, .input-group .custom-range.is-valid:focus {
        border-color: #28a745;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
      }
      
      .was-validated .custom-range:valid:focus::-webkit-slider-thumb, .custom-range.is-valid:focus::-webkit-slider-thumb {
        -webkit-box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #9be7ac;
                box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #9be7ac;
      }
      
      .was-validated .custom-range:valid:focus::-moz-range-thumb, .custom-range.is-valid:focus::-moz-range-thumb {
        box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #9be7ac;
      }
      
      .was-validated .custom-range:valid:focus::-ms-thumb, .custom-range.is-valid:focus::-ms-thumb {
        box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #9be7ac;
      }
      
      .was-validated .custom-range:valid::-webkit-slider-thumb, .custom-range.is-valid::-webkit-slider-thumb {
        background-color: #28a745;
        background-image: none;
      }
      
      .was-validated .custom-range:valid::-webkit-slider-thumb:active, .custom-range.is-valid::-webkit-slider-thumb:active {
        background-color: #9be7ac;
        background-image: none;
      }
      
      .was-validated .custom-range:valid::-webkit-slider-runnable-track, .custom-range.is-valid::-webkit-slider-runnable-track {
        background-color: rgba(40, 167, 69, 0.35);
      }
      
      .was-validated .custom-range:valid::-moz-range-thumb, .custom-range.is-valid::-moz-range-thumb {
        background-color: #28a745;
        background-image: none;
      }
      
      .was-validated .custom-range:valid::-moz-range-thumb:active, .custom-range.is-valid::-moz-range-thumb:active {
        background-color: #9be7ac;
        background-image: none;
      }
      
      .was-validated .custom-range:valid::-moz-range-track, .custom-range.is-valid::-moz-range-track {
        background: rgba(40, 167, 69, 0.35);
      }
      
      .was-validated .custom-range:valid ~ .valid-feedback,
      .was-validated .custom-range:valid ~ .valid-tooltip, .custom-range.is-valid ~ .valid-feedback,
      .custom-range.is-valid ~ .valid-tooltip {
        display: block;
      }
      
      .was-validated .custom-range:valid::-ms-thumb, .custom-range.is-valid::-ms-thumb {
        background-color: #28a745;
        background-image: none;
      }
      
      .was-validated .custom-range:valid::-ms-thumb:active, .custom-range.is-valid::-ms-thumb:active {
        background-color: #9be7ac;
        background-image: none;
      }
      
      .was-validated .custom-range:valid::-ms-track-lower, .custom-range.is-valid::-ms-track-lower {
        background: rgba(40, 167, 69, 0.35);
      }
      
      .was-validated .custom-range:valid::-ms-track-upper, .custom-range.is-valid::-ms-track-upper {
        background: rgba(40, 167, 69, 0.35);
      }
      
      .was-validated .input-group .custom-range:invalid, .input-group .custom-range.is-invalid {
        border-color: #dc3545;
      }
      
      .was-validated .input-group .custom-range:invalid:focus, .input-group .custom-range.is-invalid:focus {
        border-color: #dc3545;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
                box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
      }
      
      .was-validated .custom-range:invalid:focus::-webkit-slider-thumb, .custom-range.is-invalid:focus::-webkit-slider-thumb {
        -webkit-box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #f6cdd1;
                box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #f6cdd1;
      }
      
      .was-validated .custom-range:invalid:focus::-moz-range-thumb, .custom-range.is-invalid:focus::-moz-range-thumb {
        box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #f6cdd1;
      }
      
      .was-validated .custom-range:invalid:focus::-ms-thumb, .custom-range.is-invalid:focus::-ms-thumb {
        box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #f6cdd1;
      }
      
      .was-validated .custom-range:invalid::-webkit-slider-thumb, .custom-range.is-invalid::-webkit-slider-thumb {
        background-color: #dc3545;
        background-image: none;
      }
      
      .was-validated .custom-range:invalid::-webkit-slider-thumb:active, .custom-range.is-invalid::-webkit-slider-thumb:active {
        background-color: #f6cdd1;
        background-image: none;
      }
      
      .was-validated .custom-range:invalid::-webkit-slider-runnable-track, .custom-range.is-invalid::-webkit-slider-runnable-track {
        background-color: rgba(220, 53, 69, 0.35);
      }
      
      .was-validated .custom-range:invalid::-moz-range-thumb, .custom-range.is-invalid::-moz-range-thumb {
        background-color: #dc3545;
        background-image: none;
      }
      
      .was-validated .custom-range:invalid::-moz-range-thumb:active, .custom-range.is-invalid::-moz-range-thumb:active {
        background-color: #f6cdd1;
        background-image: none;
      }
      
      .was-validated .custom-range:invalid::-moz-range-track, .custom-range.is-invalid::-moz-range-track {
        background: rgba(220, 53, 69, 0.35);
      }
      
      .was-validated .custom-range:invalid ~ .invalid-feedback,
      .was-validated .custom-range:invalid ~ .invalid-tooltip, .custom-range.is-invalid ~ .invalid-feedback,
      .custom-range.is-invalid ~ .invalid-tooltip {
        display: block;
      }
      
      .was-validated .custom-range:invalid::-ms-thumb, .custom-range.is-invalid::-ms-thumb {
        background-color: #dc3545;
        background-image: none;
      }
      
      .was-validated .custom-range:invalid::-ms-thumb:active, .custom-range.is-invalid::-ms-thumb:active {
        background-color: #f6cdd1;
        background-image: none;
      }
      
      .was-validated .custom-range:invalid::-ms-track-lower, .custom-range.is-invalid::-ms-track-lower {
        background: rgba(220, 53, 69, 0.35);
      }
      
      .was-validated .custom-range:invalid::-ms-track-upper, .custom-range.is-invalid::-ms-track-upper {
        background: rgba(220, 53, 69, 0.35);
      }
      
      .modal-backdrop {
        opacity: 0.5;
      }
      
      .b-popover-primary.popover {
        background-color: #cce5ff;
        border-color: #b8daff;
      }
      
      .b-popover-primary.bs-popover-top > .arrow::before, .b-popover-primary.bs-popover-auto[x-placement^="top"] > .arrow::before {
        border-top-color: #b8daff;
      }
      
      .b-popover-primary.bs-popover-top > .arrow::after, .b-popover-primary.bs-popover-auto[x-placement^="top"] > .arrow::after {
        border-top-color: #cce5ff;
      }
      
      .b-popover-primary.bs-popover-right > .arrow::before, .b-popover-primary.bs-popover-auto[x-placement^="right"] > .arrow::before {
        border-right-color: #b8daff;
      }
      
      .b-popover-primary.bs-popover-right > .arrow::after, .b-popover-primary.bs-popover-auto[x-placement^="right"] > .arrow::after {
        border-right-color: #cce5ff;
      }
      
      .b-popover-primary.bs-popover-bottom > .arrow::before, .b-popover-primary.bs-popover-auto[x-placement^="bottom"] > .arrow::before {
        border-bottom-color: #b8daff;
      }
      
      .b-popover-primary.bs-popover-bottom > .arrow::after, .b-popover-primary.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
        border-bottom-color: #bdddff;
      }
      
      .b-popover-primary.bs-popover-bottom .popover-header::before, .b-popover-primary.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
        border-bottom-color: #bdddff;
      }
      
      .b-popover-primary.bs-popover-left > .arrow::before, .b-popover-primary.bs-popover-auto[x-placement^="left"] > .arrow::before {
        border-left-color: #b8daff;
      }
      
      .b-popover-primary.bs-popover-left > .arrow::after, .b-popover-primary.bs-popover-auto[x-placement^="left"] > .arrow::after {
        border-left-color: #cce5ff;
      }
      
      .b-popover-primary .popover-header {
        color: #212529;
        background-color: #bdddff;
        border-bottom-color: #a3d0ff;
      }
      
      .b-popover-primary .popover-body {
        color: #004085;
      }
      
      .b-popover-secondary.popover {
        background-color: #e2e3e5;
        border-color: #d6d8db;
      }
      
      .b-popover-secondary.bs-popover-top > .arrow::before, .b-popover-secondary.bs-popover-auto[x-placement^="top"] > .arrow::before {
        border-top-color: #d6d8db;
      }
      
      .b-popover-secondary.bs-popover-top > .arrow::after, .b-popover-secondary.bs-popover-auto[x-placement^="top"] > .arrow::after {
        border-top-color: #e2e3e5;
      }
      
      .b-popover-secondary.bs-popover-right > .arrow::before, .b-popover-secondary.bs-popover-auto[x-placement^="right"] > .arrow::before {
        border-right-color: #d6d8db;
      }
      
      .b-popover-secondary.bs-popover-right > .arrow::after, .b-popover-secondary.bs-popover-auto[x-placement^="right"] > .arrow::after {
        border-right-color: #e2e3e5;
      }
      
      .b-popover-secondary.bs-popover-bottom > .arrow::before, .b-popover-secondary.bs-popover-auto[x-placement^="bottom"] > .arrow::before {
        border-bottom-color: #d6d8db;
      }
      
      .b-popover-secondary.bs-popover-bottom > .arrow::after, .b-popover-secondary.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
        border-bottom-color: #dadbde;
      }
      
      .b-popover-secondary.bs-popover-bottom .popover-header::before, .b-popover-secondary.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
        border-bottom-color: #dadbde;
      }
      
      .b-popover-secondary.bs-popover-left > .arrow::before, .b-popover-secondary.bs-popover-auto[x-placement^="left"] > .arrow::before {
        border-left-color: #d6d8db;
      }
      
      .b-popover-secondary.bs-popover-left > .arrow::after, .b-popover-secondary.bs-popover-auto[x-placement^="left"] > .arrow::after {
        border-left-color: #e2e3e5;
      }
      
      .b-popover-secondary .popover-header {
        color: #212529;
        background-color: #dadbde;
        border-bottom-color: #ccced2;
      }
      
      .b-popover-secondary .popover-body {
        color: #383d41;
      }
      
      .b-popover-success.popover {
        background-color: #d4edda;
        border-color: #c3e6cb;
      }
      
      .b-popover-success.bs-popover-top > .arrow::before, .b-popover-success.bs-popover-auto[x-placement^="top"] > .arrow::before {
        border-top-color: #c3e6cb;
      }
      
      .b-popover-success.bs-popover-top > .arrow::after, .b-popover-success.bs-popover-auto[x-placement^="top"] > .arrow::after {
        border-top-color: #d4edda;
      }
      
      .b-popover-success.bs-popover-right > .arrow::before, .b-popover-success.bs-popover-auto[x-placement^="right"] > .arrow::before {
        border-right-color: #c3e6cb;
      }
      
      .b-popover-success.bs-popover-right > .arrow::after, .b-popover-success.bs-popover-auto[x-placement^="right"] > .arrow::after {
        border-right-color: #d4edda;
      }
      
      .b-popover-success.bs-popover-bottom > .arrow::before, .b-popover-success.bs-popover-auto[x-placement^="bottom"] > .arrow::before {
        border-bottom-color: #c3e6cb;
      }
      
      .b-popover-success.bs-popover-bottom > .arrow::after, .b-popover-success.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
        border-bottom-color: #c9e8d1;
      }
      
      .b-popover-success.bs-popover-bottom .popover-header::before, .b-popover-success.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
        border-bottom-color: #c9e8d1;
      }
      
      .b-popover-success.bs-popover-left > .arrow::before, .b-popover-success.bs-popover-auto[x-placement^="left"] > .arrow::before {
        border-left-color: #c3e6cb;
      }
      
      .b-popover-success.bs-popover-left > .arrow::after, .b-popover-success.bs-popover-auto[x-placement^="left"] > .arrow::after {
        border-left-color: #d4edda;
      }
      
      .b-popover-success .popover-header {
        color: #212529;
        background-color: #c9e8d1;
        border-bottom-color: #b7e1c1;
      }
      
      .b-popover-success .popover-body {
        color: #155724;
      }
      
      .b-popover-info.popover {
        background-color: #d1ecf1;
        border-color: #bee5eb;
      }
      
      .b-popover-info.bs-popover-top > .arrow::before, .b-popover-info.bs-popover-auto[x-placement^="top"] > .arrow::before {
        border-top-color: #bee5eb;
      }
      
      .b-popover-info.bs-popover-top > .arrow::after, .b-popover-info.bs-popover-auto[x-placement^="top"] > .arrow::after {
        border-top-color: #d1ecf1;
      }
      
      .b-popover-info.bs-popover-right > .arrow::before, .b-popover-info.bs-popover-auto[x-placement^="right"] > .arrow::before {
        border-right-color: #bee5eb;
      }
      
      .b-popover-info.bs-popover-right > .arrow::after, .b-popover-info.bs-popover-auto[x-placement^="right"] > .arrow::after {
        border-right-color: #d1ecf1;
      }
      
      .b-popover-info.bs-popover-bottom > .arrow::before, .b-popover-info.bs-popover-auto[x-placement^="bottom"] > .arrow::before {
        border-bottom-color: #bee5eb;
      }
      
      .b-popover-info.bs-popover-bottom > .arrow::after, .b-popover-info.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
        border-bottom-color: #c5e7ed;
      }
      
      .b-popover-info.bs-popover-bottom .popover-header::before, .b-popover-info.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
        border-bottom-color: #c5e7ed;
      }
      
      .b-popover-info.bs-popover-left > .arrow::before, .b-popover-info.bs-popover-auto[x-placement^="left"] > .arrow::before {
        border-left-color: #bee5eb;
      }
      
      .b-popover-info.bs-popover-left > .arrow::after, .b-popover-info.bs-popover-auto[x-placement^="left"] > .arrow::after {
        border-left-color: #d1ecf1;
      }
      
      .b-popover-info .popover-header {
        color: #212529;
        background-color: #c5e7ed;
        border-bottom-color: #b2dfe7;
      }
      
      .b-popover-info .popover-body {
        color: #0c5460;
      }
      
      .b-popover-warning.popover {
        background-color: #fff3cd;
        border-color: #ffeeba;
      }
      
      .b-popover-warning.bs-popover-top > .arrow::before, .b-popover-warning.bs-popover-auto[x-placement^="top"] > .arrow::before {
        border-top-color: #ffeeba;
      }
      
      .b-popover-warning.bs-popover-top > .arrow::after, .b-popover-warning.bs-popover-auto[x-placement^="top"] > .arrow::after {
        border-top-color: #fff3cd;
      }
      
      .b-popover-warning.bs-popover-right > .arrow::before, .b-popover-warning.bs-popover-auto[x-placement^="right"] > .arrow::before {
        border-right-color: #ffeeba;
      }
      
      .b-popover-warning.bs-popover-right > .arrow::after, .b-popover-warning.bs-popover-auto[x-placement^="right"] > .arrow::after {
        border-right-color: #fff3cd;
      }
      
      .b-popover-warning.bs-popover-bottom > .arrow::before, .b-popover-warning.bs-popover-auto[x-placement^="bottom"] > .arrow::before {
        border-bottom-color: #ffeeba;
      }
      
      .b-popover-warning.bs-popover-bottom > .arrow::after, .b-popover-warning.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
        border-bottom-color: #ffefbe;
      }
      
      .b-popover-warning.bs-popover-bottom .popover-header::before, .b-popover-warning.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
        border-bottom-color: #ffefbe;
      }
      
      .b-popover-warning.bs-popover-left > .arrow::before, .b-popover-warning.bs-popover-auto[x-placement^="left"] > .arrow::before {
        border-left-color: #ffeeba;
      }
      
      .b-popover-warning.bs-popover-left > .arrow::after, .b-popover-warning.bs-popover-auto[x-placement^="left"] > .arrow::after {
        border-left-color: #fff3cd;
      }
      
      .b-popover-warning .popover-header {
        color: #212529;
        background-color: #ffefbe;
        border-bottom-color: #ffe9a4;
      }
      
      .b-popover-warning .popover-body {
        color: #856404;
      }
      
      .b-popover-danger.popover {
        background-color: #f8d7da;
        border-color: #f5c6cb;
      }
      
      .b-popover-danger.bs-popover-top > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^="top"] > .arrow::before {
        border-top-color: #f5c6cb;
      }
      
      .b-popover-danger.bs-popover-top > .arrow::after, .b-popover-danger.bs-popover-auto[x-placement^="top"] > .arrow::after {
        border-top-color: #f8d7da;
      }
      
      .b-popover-danger.bs-popover-right > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^="right"] > .arrow::before {
        border-right-color: #f5c6cb;
      }
      
      .b-popover-danger.bs-popover-right > .arrow::after, .b-popover-danger.bs-popover-auto[x-placement^="right"] > .arrow::after {
        border-right-color: #f8d7da;
      }
      
      .b-popover-danger.bs-popover-bottom > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^="bottom"] > .arrow::before {
        border-bottom-color: #f5c6cb;
      }
      
      .b-popover-danger.bs-popover-bottom > .arrow::after, .b-popover-danger.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
        border-bottom-color: #f6cace;
      }
      
      .b-popover-danger.bs-popover-bottom .popover-header::before, .b-popover-danger.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
        border-bottom-color: #f6cace;
      }
      
      .b-popover-danger.bs-popover-left > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^="left"] > .arrow::before {
        border-left-color: #f5c6cb;
      }
      
      .b-popover-danger.bs-popover-left > .arrow::after, .b-popover-danger.bs-popover-auto[x-placement^="left"] > .arrow::after {
        border-left-color: #f8d7da;
      }
      
      .b-popover-danger .popover-header {
        color: #212529;
        background-color: #f6cace;
        border-bottom-color: #f2b4ba;
      }
      
      .b-popover-danger .popover-body {
        color: #721c24;
      }
      
      .b-popover-light.popover {
        background-color: #fefefe;
        border-color: #fdfdfe;
      }
      
      .b-popover-light.bs-popover-top > .arrow::before, .b-popover-light.bs-popover-auto[x-placement^="top"] > .arrow::before {
        border-top-color: #fdfdfe;
      }
      
      .b-popover-light.bs-popover-top > .arrow::after, .b-popover-light.bs-popover-auto[x-placement^="top"] > .arrow::after {
        border-top-color: #fefefe;
      }
      
      .b-popover-light.bs-popover-right > .arrow::before, .b-popover-light.bs-popover-auto[x-placement^="right"] > .arrow::before {
        border-right-color: #fdfdfe;
      }
      
      .b-popover-light.bs-popover-right > .arrow::after, .b-popover-light.bs-popover-auto[x-placement^="right"] > .arrow::after {
        border-right-color: #fefefe;
      }
      
      .b-popover-light.bs-popover-bottom > .arrow::before, .b-popover-light.bs-popover-auto[x-placement^="bottom"] > .arrow::before {
        border-bottom-color: #fdfdfe;
      }
      
      .b-popover-light.bs-popover-bottom > .arrow::after, .b-popover-light.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
        border-bottom-color: #f6f6f6;
      }
      
      .b-popover-light.bs-popover-bottom .popover-header::before, .b-popover-light.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
        border-bottom-color: #f6f6f6;
      }
      
      .b-popover-light.bs-popover-left > .arrow::before, .b-popover-light.bs-popover-auto[x-placement^="left"] > .arrow::before {
        border-left-color: #fdfdfe;
      }
      
      .b-popover-light.bs-popover-left > .arrow::after, .b-popover-light.bs-popover-auto[x-placement^="left"] > .arrow::after {
        border-left-color: #fefefe;
      }
      
      .b-popover-light .popover-header {
        color: #212529;
        background-color: #f6f6f6;
        border-bottom-color: #eaeaea;
      }
      
      .b-popover-light .popover-body {
        color: #818182;
      }
      
      .b-popover-dark.popover {
        background-color: #d6d8d9;
        border-color: #c6c8ca;
      }
      
      .b-popover-dark.bs-popover-top > .arrow::before, .b-popover-dark.bs-popover-auto[x-placement^="top"] > .arrow::before {
        border-top-color: #c6c8ca;
      }
      
      .b-popover-dark.bs-popover-top > .arrow::after, .b-popover-dark.bs-popover-auto[x-placement^="top"] > .arrow::after {
        border-top-color: #d6d8d9;
      }
      
      .b-popover-dark.bs-popover-right > .arrow::before, .b-popover-dark.bs-popover-auto[x-placement^="right"] > .arrow::before {
        border-right-color: #c6c8ca;
      }
      
      .b-popover-dark.bs-popover-right > .arrow::after, .b-popover-dark.bs-popover-auto[x-placement^="right"] > .arrow::after {
        border-right-color: #d6d8d9;
      }
      
      .b-popover-dark.bs-popover-bottom > .arrow::before, .b-popover-dark.bs-popover-auto[x-placement^="bottom"] > .arrow::before {
        border-bottom-color: #c6c8ca;
      }
      
      .b-popover-dark.bs-popover-bottom > .arrow::after, .b-popover-dark.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
        border-bottom-color: #ced0d2;
      }
      
      .b-popover-dark.bs-popover-bottom .popover-header::before, .b-popover-dark.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
        border-bottom-color: #ced0d2;
      }
      
      .b-popover-dark.bs-popover-left > .arrow::before, .b-popover-dark.bs-popover-auto[x-placement^="left"] > .arrow::before {
        border-left-color: #c6c8ca;
      }
      
      .b-popover-dark.bs-popover-left > .arrow::after, .b-popover-dark.bs-popover-auto[x-placement^="left"] > .arrow::after {
        border-left-color: #d6d8d9;
      }
      
      .b-popover-dark .popover-header {
        color: #212529;
        background-color: #ced0d2;
        border-bottom-color: #c1c4c5;
      }
      
      .b-popover-dark .popover-body {
        color: #1b1e21;
      }
      
      .table.b-table.b-table-fixed {
        table-layout: fixed;
      }
      
      .table.b-table[aria-busy="true"] {
        opacity: 0.55;
      }
      
      .table.b-table > tbody > tr.b-table-details > td {
        border-top: none !important;
      }
      
      .table.b-table > caption {
        caption-side: bottom;
      }
      
      .table.b-table > caption.b-table-caption-top {
        caption-side: top !important;
      }
      
      .table.b-table > thead > tr > th[aria-sort],
      .table.b-table > tfoot > tr > th[aria-sort] {
        cursor: pointer;
      }
      
      .table.b-table > thead > tr > th[aria-sort]::before,
      .table.b-table > tfoot > tr > th[aria-sort]::before {
        display: inline-block;
        float: right;
        margin-left: 0.5em;
        width: 0.5em;
        font-size: inherit;
        line-height: inherit;
        opacity: 0.4;
        speak: none;
      }
      
      .table.b-table > thead > tr > th[aria-sort][aria-sort="ascending"]::before,
      .table.b-table > tfoot > tr > th[aria-sort][aria-sort="ascending"]::before {
        opacity: 1;
      }
      
      .table.b-table > thead > tr > th[aria-sort][aria-sort="descending"]::before,
      .table.b-table > tfoot > tr > th[aria-sort][aria-sort="descending"]::before {
        opacity: 1;
      }
      
      @media (max-width: 575.98px) {
        .table.b-table.b-table-stacked-sm {
          display: block;
          width: 100%;
        }
        .table.b-table.b-table-stacked-sm > caption,
        .table.b-table.b-table-stacked-sm > tbody,
        .table.b-table.b-table-stacked-sm > tbody > tr,
        .table.b-table.b-table-stacked-sm > tbody > tr > td,
        .table.b-table.b-table-stacked-sm > tbody > tr > td {
          display: block;
        }
        .table.b-table.b-table-stacked-sm > thead,
        .table.b-table.b-table-stacked-sm > tfoot {
          display: none;
        }
        .table.b-table.b-table-stacked-sm > thead > tr.b-table-top-row,
        .table.b-table.b-table-stacked-sm > thead > tr.b-table-bottom-row,
        .table.b-table.b-table-stacked-sm > tfoot > tr.b-table-top-row,
        .table.b-table.b-table-stacked-sm > tfoot > tr.b-table-bottom-row {
          display: none;
        }
        .table.b-table.b-table-stacked-sm > caption {
          caption-side: top !important;
        }
        .table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::before {
          content: attr(data-label);
          display: inline-block;
          width: 40%;
          float: left;
          text-align: right;
          overflow-wrap: break-word;
          font-weight: bold;
          font-style: normal;
          padding: 0;
          margin: 0;
        }
        .table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::after {
          display: block;
          clear: both;
          content: "";
        }
        .table.b-table.b-table-stacked-sm > tbody > tr > [data-label] > div {
          display: inline-block;
          width: calc(100% - 40%);
          padding: 0 0 0 1rem;
          margin: 0;
        }
        .table.b-table.b-table-stacked-sm > tbody > tr.top-row, .table.b-table.b-table-stacked-sm > tbody > tr.bottom-row {
          display: none;
        }
        .table.b-table.b-table-stacked-sm > tbody > tr > :first-child {
          border-top-width: 3px;
        }
      }
      
      @media (max-width: 767.98px) {
        .table.b-table.b-table-stacked-md {
          display: block;
          width: 100%;
        }
        .table.b-table.b-table-stacked-md > caption,
        .table.b-table.b-table-stacked-md > tbody,
        .table.b-table.b-table-stacked-md > tbody > tr,
        .table.b-table.b-table-stacked-md > tbody > tr > td,
        .table.b-table.b-table-stacked-md > tbody > tr > td {
          display: block;
        }
        .table.b-table.b-table-stacked-md > thead,
        .table.b-table.b-table-stacked-md > tfoot {
          display: none;
        }
        .table.b-table.b-table-stacked-md > thead > tr.b-table-top-row,
        .table.b-table.b-table-stacked-md > thead > tr.b-table-bottom-row,
        .table.b-table.b-table-stacked-md > tfoot > tr.b-table-top-row,
        .table.b-table.b-table-stacked-md > tfoot > tr.b-table-bottom-row {
          display: none;
        }
        .table.b-table.b-table-stacked-md > caption {
          caption-side: top !important;
        }
        .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
          content: attr(data-label);
          display: inline-block;
          width: 40%;
          float: left;
          text-align: right;
          overflow-wrap: break-word;
          font-weight: bold;
          font-style: normal;
          padding: 0;
          margin: 0;
        }
        .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::after {
          display: block;
          clear: both;
          content: "";
        }
        .table.b-table.b-table-stacked-md > tbody > tr > [data-label] > div {
          display: inline-block;
          width: calc(100% - 40%);
          padding: 0 0 0 1rem;
          margin: 0;
        }
        .table.b-table.b-table-stacked-md > tbody > tr.top-row, .table.b-table.b-table-stacked-md > tbody > tr.bottom-row {
          display: none;
        }
        .table.b-table.b-table-stacked-md > tbody > tr > :first-child {
          border-top-width: 3px;
        }
      }
      
      @media (max-width: 991.98px) {
        .table.b-table.b-table-stacked-lg {
          display: block;
          width: 100%;
        }
        .table.b-table.b-table-stacked-lg > caption,
        .table.b-table.b-table-stacked-lg > tbody,
        .table.b-table.b-table-stacked-lg > tbody > tr,
        .table.b-table.b-table-stacked-lg > tbody > tr > td,
        .table.b-table.b-table-stacked-lg > tbody > tr > td {
          display: block;
        }
        .table.b-table.b-table-stacked-lg > thead,
        .table.b-table.b-table-stacked-lg > tfoot {
          display: none;
        }
        .table.b-table.b-table-stacked-lg > thead > tr.b-table-top-row,
        .table.b-table.b-table-stacked-lg > thead > tr.b-table-bottom-row,
        .table.b-table.b-table-stacked-lg > tfoot > tr.b-table-top-row,
        .table.b-table.b-table-stacked-lg > tfoot > tr.b-table-bottom-row {
          display: none;
        }
        .table.b-table.b-table-stacked-lg > caption {
          caption-side: top !important;
        }
        .table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::before {
          content: attr(data-label);
          display: inline-block;
          width: 40%;
          float: left;
          text-align: right;
          overflow-wrap: break-word;
          font-weight: bold;
          font-style: normal;
          padding: 0;
          margin: 0;
        }
        .table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::after {
          display: block;
          clear: both;
          content: "";
        }
        .table.b-table.b-table-stacked-lg > tbody > tr > [data-label] > div {
          display: inline-block;
          width: calc(100% - 40%);
          padding: 0 0 0 1rem;
          margin: 0;
        }
        .table.b-table.b-table-stacked-lg > tbody > tr.top-row, .table.b-table.b-table-stacked-lg > tbody > tr.bottom-row {
          display: none;
        }
        .table.b-table.b-table-stacked-lg > tbody > tr > :first-child {
          border-top-width: 3px;
        }
      }
      
      @media (max-width: 1199.98px) {
        .table.b-table.b-table-stacked-xl {
          display: block;
          width: 100%;
        }
        .table.b-table.b-table-stacked-xl > caption,
        .table.b-table.b-table-stacked-xl > tbody,
        .table.b-table.b-table-stacked-xl > tbody > tr,
        .table.b-table.b-table-stacked-xl > tbody > tr > td,
        .table.b-table.b-table-stacked-xl > tbody > tr > td {
          display: block;
        }
        .table.b-table.b-table-stacked-xl > thead,
        .table.b-table.b-table-stacked-xl > tfoot {
          display: none;
        }
        .table.b-table.b-table-stacked-xl > thead > tr.b-table-top-row,
        .table.b-table.b-table-stacked-xl > thead > tr.b-table-bottom-row,
        .table.b-table.b-table-stacked-xl > tfoot > tr.b-table-top-row,
        .table.b-table.b-table-stacked-xl > tfoot > tr.b-table-bottom-row {
          display: none;
        }
        .table.b-table.b-table-stacked-xl > caption {
          caption-side: top !important;
        }
        .table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::before {
          content: attr(data-label);
          display: inline-block;
          width: 40%;
          float: left;
          text-align: right;
          overflow-wrap: break-word;
          font-weight: bold;
          font-style: normal;
          padding: 0;
          margin: 0;
        }
        .table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::after {
          display: block;
          clear: both;
          content: "";
        }
        .table.b-table.b-table-stacked-xl > tbody > tr > [data-label] > div {
          display: inline-block;
          width: calc(100% - 40%);
          padding: 0 0 0 1rem;
          margin: 0;
        }
        .table.b-table.b-table-stacked-xl > tbody > tr.top-row, .table.b-table.b-table-stacked-xl > tbody > tr.bottom-row {
          display: none;
        }
        .table.b-table.b-table-stacked-xl > tbody > tr > :first-child {
          border-top-width: 3px;
        }
      }
      
      .table.b-table.b-table-stacked {
        display: block;
        width: 100%;
      }
      
      .table.b-table.b-table-stacked > caption,
      .table.b-table.b-table-stacked > tbody,
      .table.b-table.b-table-stacked > tbody > tr,
      .table.b-table.b-table-stacked > tbody > tr > td,
      .table.b-table.b-table-stacked > tbody > tr > td {
        display: block;
      }
      
      .table.b-table.b-table-stacked > thead,
      .table.b-table.b-table-stacked > tfoot {
        display: none;
      }
      
      .table.b-table.b-table-stacked > thead > tr.b-table-top-row,
      .table.b-table.b-table-stacked > thead > tr.b-table-bottom-row,
      .table.b-table.b-table-stacked > tfoot > tr.b-table-top-row,
      .table.b-table.b-table-stacked > tfoot > tr.b-table-bottom-row {
        display: none;
      }
      
      .table.b-table.b-table-stacked > caption {
        caption-side: top !important;
      }
      
      .table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
        content: attr(data-label);
        display: inline-block;
        width: 40%;
        float: left;
        text-align: right;
        overflow-wrap: break-word;
        font-weight: bold;
        font-style: normal;
        padding: 0;
        margin: 0;
      }
      
      .table.b-table.b-table-stacked > tbody > tr > [data-label]::after {
        display: block;
        clear: both;
        content: "";
      }
      
      .table.b-table.b-table-stacked > tbody > tr > [data-label] > div {
        display: inline-block;
        width: calc(100% - 40%);
        padding: 0 0 0 1rem;
        margin: 0;
      }
      
      .table.b-table.b-table-stacked > tbody > tr.top-row, .table.b-table.b-table-stacked > tbody > tr.bottom-row {
        display: none;
      }
      
      .table.b-table.b-table-stacked > tbody > tr > :first-child {
        border-top-width: 3px;
      }
      
      .table.b-table.b-table-selectable > tbody > tr {
        cursor: pointer;
      }
      
      .table.b-table.b-table-selectable.b-table-selecting.b-table-select-range > tbody > tr {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
      
      .b-toast {
        display: block;
        position: relative;
        max-width: 350px;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        background-clip: padding-box;
        z-index: 1;
        border-radius: 0.25rem;
      }
      
      .b-toast:not(:last-child) {
        margin-bottom: 0.75rem;
      }
      
      .b-toast.b-toast-solid .toast {
        background-color: white;
      }
      
      .b-toast .toast {
        opacity: 1;
      }
      
      .b-toast .toast.fade:not(.show) {
        opacity: 0;
      }
      
      .b-toast .toast .toast-body {
        display: block;
      }
      
      .b-toast-primary .toast {
        background-color: rgba(230, 242, 255, 0.85);
        border-color: rgba(184, 218, 255, 0.85);
        color: #004085;
      }
      
      .b-toast-primary .toast .toast-header {
        color: #004085;
        background-color: rgba(204, 229, 255, 0.85);
        border-bottom-color: rgba(184, 218, 255, 0.85);
      }
      
      .b-toast-primary.b-toast-solid .toast {
        background-color: #e6f2ff;
      }
      
      .b-toast-secondary .toast {
        background-color: rgba(239, 240, 241, 0.85);
        border-color: rgba(214, 216, 219, 0.85);
        color: #383d41;
      }
      
      .b-toast-secondary .toast .toast-header {
        color: #383d41;
        background-color: rgba(226, 227, 229, 0.85);
        border-bottom-color: rgba(214, 216, 219, 0.85);
      }
      
      .b-toast-secondary.b-toast-solid .toast {
        background-color: #eff0f1;
      }
      
      .b-toast-success .toast {
        background-color: rgba(230, 245, 233, 0.85);
        border-color: rgba(195, 230, 203, 0.85);
        color: #155724;
      }
      
      .b-toast-success .toast .toast-header {
        color: #155724;
        background-color: rgba(212, 237, 218, 0.85);
        border-bottom-color: rgba(195, 230, 203, 0.85);
      }
      
      .b-toast-success.b-toast-solid .toast {
        background-color: #e6f5e9;
      }
      
      .b-toast-info .toast {
        background-color: rgba(229, 244, 247, 0.85);
        border-color: rgba(190, 229, 235, 0.85);
        color: #0c5460;
      }
      
      .b-toast-info .toast .toast-header {
        color: #0c5460;
        background-color: rgba(209, 236, 241, 0.85);
        border-bottom-color: rgba(190, 229, 235, 0.85);
      }
      
      .b-toast-info.b-toast-solid .toast {
        background-color: #e5f4f7;
      }
      
      .b-toast-warning .toast {
        background-color: rgba(255, 249, 231, 0.85);
        border-color: rgba(255, 238, 186, 0.85);
        color: #856404;
      }
      
      .b-toast-warning .toast .toast-header {
        color: #856404;
        background-color: rgba(255, 243, 205, 0.85);
        border-bottom-color: rgba(255, 238, 186, 0.85);
      }
      
      .b-toast-warning.b-toast-solid .toast {
        background-color: #fff9e7;
      }
      
      .b-toast-danger .toast {
        background-color: rgba(252, 237, 238, 0.85);
        border-color: rgba(245, 198, 203, 0.85);
        color: #721c24;
      }
      
      .b-toast-danger .toast .toast-header {
        color: #721c24;
        background-color: rgba(248, 215, 218, 0.85);
        border-bottom-color: rgba(245, 198, 203, 0.85);
      }
      
      .b-toast-danger.b-toast-solid .toast {
        background-color: #fcedee;
      }
      
      .b-toast-light .toast {
        background-color: rgba(255, 255, 255, 0.85);
        border-color: rgba(253, 253, 254, 0.85);
        color: #818182;
      }
      
      .b-toast-light .toast .toast-header {
        color: #818182;
        background-color: rgba(254, 254, 254, 0.85);
        border-bottom-color: rgba(253, 253, 254, 0.85);
      }
      
      .b-toast-light.b-toast-solid .toast {
        background-color: white;
      }
      
      .b-toast-dark .toast {
        background-color: rgba(227, 229, 229, 0.85);
        border-color: rgba(198, 200, 202, 0.85);
        color: #1b1e21;
      }
      
      .b-toast-dark .toast .toast-header {
        color: #1b1e21;
        background-color: rgba(214, 216, 217, 0.85);
        border-bottom-color: rgba(198, 200, 202, 0.85);
      }
      
      .b-toast-dark.b-toast-solid .toast {
        background-color: #e3e5e5;
      }
      
      .b-toaster {
        z-index: 1100;
      }
      
      .b-toaster .b-toaster-slot {
        position: relative;
        display: block;
      }
      
      .b-toaster .b-toaster-slot:empty {
        display: none !important;
      }
      
      .b-toaster.b-toaster-top-right, .b-toaster.b-toaster-top-left, .b-toaster.b-toaster-top-center, .b-toaster.b-toaster-top-full, .b-toaster.b-toaster-bottom-right, .b-toaster.b-toaster-bottom-left, .b-toaster.b-toaster-bottom-center, .b-toaster.b-toaster-bottom-full {
        position: fixed;
        left: 0.5rem;
        right: 0.5rem;
        margin: 0;
        padding: 0;
        height: 0;
        overflow: visible;
      }
      
      .b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-top-full .b-toaster-slot, .b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {
        position: absolute;
        max-width: 350px;
        width: 100%;
        /* IE11 fix */
        left: 0;
        right: 0;
        padding: 0;
        margin: 0;
      }
      
      .b-toaster.b-toaster-top-full .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {
        width: 100%;
        max-width: 100%;
      }
      
      .b-toaster.b-toaster-top-full .b-toaster-slot .b-toast,
      .b-toaster.b-toaster-top-full .b-toaster-slot .toast, .b-toaster.b-toaster-bottom-full .b-toaster-slot .b-toast,
      .b-toaster.b-toaster-bottom-full .b-toaster-slot .toast {
        width: 100%;
        max-width: 100%;
      }
      
      .b-toaster.b-toaster-top-right, .b-toaster.b-toaster-top-left, .b-toaster.b-toaster-top-center, .b-toaster.b-toaster-top-full {
        top: 0;
      }
      
      .b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-top-full .b-toaster-slot {
        top: 0.5rem;
      }
      
      .b-toaster.b-toaster-bottom-right, .b-toaster.b-toaster-bottom-left, .b-toaster.b-toaster-bottom-center, .b-toaster.b-toaster-bottom-full {
        bottom: 0;
      }
      
      .b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {
        bottom: 0.5rem;
      }
      
      .b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot {
        margin-left: auto;
      }
      
      .b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot {
        margin-right: auto;
      }
      
      .b-toaster.b-toaster-top-right .b-toast, .b-toaster.b-toaster-top-left .b-toast, .b-toaster.b-toaster-bottom-right .b-toast, .b-toaster.b-toaster-bottom-left .b-toast {
        /*
            &.b-toaster-enter-active,
            &.b-toaster-enter-to {
              .toast.fade {
                // Delay the appearance of the toast until
                // the move transition has completed
                transition-delay: 0.175s;
              }
            }
      
            &.b-toaster-move {
              transition: transform 0.175s;
              // transition-delay: 0.175s;
            }
      
            &.b-toaster-enter-active {
              z-index: 0;
            }
      
            &.b-toaster-leave-active {
              transition: transform 0.175s;
            }
      
            &.b-toaster-leave,
            &.b-toaster-leave-active {
              position: absolute;
              z-index: 0;
              transition-delay: 0.175s;
      
              .toast.fade {
                transition-delay: 0s;
              }
            }
      
            &.b-toaster-leave {
            }
      
            &.b-toaster-leave-to {
            }
            */
      }
      
      .b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-right .b-toast.b-toaster-move, .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-move, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-move, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-move {
        transition: -webkit-transform 0.175s;
        -webkit-transition: -webkit-transform 0.175s;
        transition: transform 0.175s;
        transition: transform 0.175s, -webkit-transform 0.175s;
      }
      
      .b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-active .toast.fade, .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-active .toast.fade, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-active .toast.fade, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-active .toast.fade {
        -webkit-transition-delay: 0.175s;
                transition-delay: 0.175s;
      }
      
      .b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active {
        position: absolute;
        -webkit-transition-delay: 0.175s;
                transition-delay: 0.175s;
      }
      
      .b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active .toast.fade, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active .toast.fade, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active .toast.fade, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active .toast.fade {
        -webkit-transition-delay: 0s;
                transition-delay: 0s;
      }
      
      .tooltip.b-tooltip-primary.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^="top"] .arrow::before {
        border-top-color: #007bff;
      }
      
      .tooltip.b-tooltip-primary.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^="right"] .arrow::before {
        border-right-color: #007bff;
      }
      
      .tooltip.b-tooltip-primary.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
        border-bottom-color: #007bff;
      }
      
      .tooltip.b-tooltip-primary.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^="left"] .arrow::before {
        border-left-color: #007bff;
      }
      
      .tooltip.b-tooltip-primary .tooltip-inner {
        color: #fff;
        background-color: #007bff;
      }
      
      .tooltip.b-tooltip-secondary.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^="top"] .arrow::before {
        border-top-color: #6c757d;
      }
      
      .tooltip.b-tooltip-secondary.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^="right"] .arrow::before {
        border-right-color: #6c757d;
      }
      
      .tooltip.b-tooltip-secondary.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
        border-bottom-color: #6c757d;
      }
      
      .tooltip.b-tooltip-secondary.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^="left"] .arrow::before {
        border-left-color: #6c757d;
      }
      
      .tooltip.b-tooltip-secondary .tooltip-inner {
        color: #fff;
        background-color: #6c757d;
      }
      
      .tooltip.b-tooltip-success.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^="top"] .arrow::before {
        border-top-color: #28a745;
      }
      
      .tooltip.b-tooltip-success.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^="right"] .arrow::before {
        border-right-color: #28a745;
      }
      
      .tooltip.b-tooltip-success.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
        border-bottom-color: #28a745;
      }
      
      .tooltip.b-tooltip-success.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^="left"] .arrow::before {
        border-left-color: #28a745;
      }
      
      .tooltip.b-tooltip-success .tooltip-inner {
        color: #fff;
        background-color: #28a745;
      }
      
      .tooltip.b-tooltip-info.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^="top"] .arrow::before {
        border-top-color: #17a2b8;
      }
      
      .tooltip.b-tooltip-info.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^="right"] .arrow::before {
        border-right-color: #17a2b8;
      }
      
      .tooltip.b-tooltip-info.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
        border-bottom-color: #17a2b8;
      }
      
      .tooltip.b-tooltip-info.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^="left"] .arrow::before {
        border-left-color: #17a2b8;
      }
      
      .tooltip.b-tooltip-info .tooltip-inner {
        color: #fff;
        background-color: #17a2b8;
      }
      
      .tooltip.b-tooltip-warning.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^="top"] .arrow::before {
        border-top-color: #ffc107;
      }
      
      .tooltip.b-tooltip-warning.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^="right"] .arrow::before {
        border-right-color: #ffc107;
      }
      
      .tooltip.b-tooltip-warning.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
        border-bottom-color: #ffc107;
      }
      
      .tooltip.b-tooltip-warning.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^="left"] .arrow::before {
        border-left-color: #ffc107;
      }
      
      .tooltip.b-tooltip-warning .tooltip-inner {
        color: #212529;
        background-color: #ffc107;
      }
      
      .tooltip.b-tooltip-danger.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^="top"] .arrow::before {
        border-top-color: #dc3545;
      }
      
      .tooltip.b-tooltip-danger.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^="right"] .arrow::before {
        border-right-color: #dc3545;
      }
      
      .tooltip.b-tooltip-danger.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
        border-bottom-color: #dc3545;
      }
      
      .tooltip.b-tooltip-danger.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^="left"] .arrow::before {
        border-left-color: #dc3545;
      }
      
      .tooltip.b-tooltip-danger .tooltip-inner {
        color: #fff;
        background-color: #dc3545;
      }
      
      .tooltip.b-tooltip-light.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^="top"] .arrow::before {
        border-top-color: #f8f9fa;
      }
      
      .tooltip.b-tooltip-light.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^="right"] .arrow::before {
        border-right-color: #f8f9fa;
      }
      
      .tooltip.b-tooltip-light.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
        border-bottom-color: #f8f9fa;
      }
      
      .tooltip.b-tooltip-light.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^="left"] .arrow::before {
        border-left-color: #f8f9fa;
      }
      
      .tooltip.b-tooltip-light .tooltip-inner {
        color: #212529;
        background-color: #f8f9fa;
      }
      
      .tooltip.b-tooltip-dark.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^="top"] .arrow::before {
        border-top-color: #343a40;
      }
      
      .tooltip.b-tooltip-dark.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^="right"] .arrow::before {
        border-right-color: #343a40;
      }
      
      .tooltip.b-tooltip-dark.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
        border-bottom-color: #343a40;
      }
      
      .tooltip.b-tooltip-dark.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^="left"] .arrow::before {
        border-left-color: #343a40;
      }
      
      .tooltip.b-tooltip-dark .tooltip-inner {
        color: #fff;
        background-color: #343a40;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-application {
        background: #fafafa;
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-application .text--primary {
        color: rgba(0, 0, 0, 0.87) !important;
      }
      .theme--light.v-application .text--secondary {
        color: rgba(0, 0, 0, 0.54) !important;
      }
      .theme--light.v-application .text--disabled {
        color: rgba(0, 0, 0, 0.38) !important;
      }
      
      .theme--dark.v-application {
        background: #303030;
        color: #FFFFFF;
      }
      .theme--dark.v-application .text--primary {
        color: #FFFFFF !important;
      }
      .theme--dark.v-application .text--secondary {
        color: rgba(255, 255, 255, 0.7) !important;
      }
      .theme--dark.v-application .text--disabled {
        color: rgba(255, 255, 255, 0.5) !important;
      }
      
      .v-application {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .v-application a {
        cursor: pointer;
      }
      .v-application--is-rtl {
        direction: rtl;
      }
      .v-application--wrap {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        -webkit-backface-visibility: hidden;
                backface-visibility: hidden;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        min-height: 100vh;
        max-width: 100%;
        position: relative;
      }
      
      @-moz-document url-prefix() {
        @media print {
          .v-application {
            display: block;
          }
          .v-application--wrap {
            display: block;
          }
        }
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-app-bar:not([data-booted=true]) {
        -webkit-transition: none !important;
        transition: none !important;
      }
      
      .v-app-bar.v-app-bar--fixed {
        position: fixed;
        top: 0;
        z-index: 5;
      }
      
      .v-app-bar.v-app-bar--hide-shadow {
        -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
      }
      
      .v-app-bar--fade-img-on-scroll .v-toolbar__image .v-image__image {
        -webkit-transition: 0.4s opacity cubic-bezier(0.4, 0, 0.2, 1);
        transition: 0.4s opacity cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      .v-app-bar.v-toolbar--prominent.v-app-bar--shrink-on-scroll .v-toolbar__content {
        will-change: height;
      }
      .v-app-bar.v-toolbar--prominent.v-app-bar--shrink-on-scroll .v-toolbar__image {
        will-change: opacity;
      }
      .v-app-bar.v-toolbar--prominent.v-app-bar--shrink-on-scroll.v-app-bar--collapse-on-scroll .v-toolbar__extension {
        display: none;
      }
      .v-app-bar.v-toolbar--prominent.v-app-bar--shrink-on-scroll.v-app-bar--is-scrolled .v-toolbar__title {
        padding-bottom: 9px;
      }
      
      .v-app-bar.v-app-bar--shrink-on-scroll .v-toolbar__title {
        font-size: inherit;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-toolbar {
        contain: layout;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        -webkit-box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
      }
      .v-toolbar.v-sheet {
        -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1) background-color, 0.2s cubic-bezier(0.4, 0, 0.2, 1) left, 0.2s cubic-bezier(0.4, 0, 0.2, 1) right, 0.25s cubic-bezier(0.4, 0, 0.2, 1) width, 0.2s cubic-bezier(0.4, 0, 0.2, 1) -webkit-transform, 280ms cubic-bezier(0.4, 0, 0.2, 1) -webkit-box-shadow;
        transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1) background-color, 0.2s cubic-bezier(0.4, 0, 0.2, 1) left, 0.2s cubic-bezier(0.4, 0, 0.2, 1) right, 0.25s cubic-bezier(0.4, 0, 0.2, 1) width, 0.2s cubic-bezier(0.4, 0, 0.2, 1) -webkit-transform, 280ms cubic-bezier(0.4, 0, 0.2, 1) -webkit-box-shadow;
        transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1) transform, 0.2s cubic-bezier(0.4, 0, 0.2, 1) background-color, 0.2s cubic-bezier(0.4, 0, 0.2, 1) left, 0.2s cubic-bezier(0.4, 0, 0.2, 1) right, 280ms cubic-bezier(0.4, 0, 0.2, 1) box-shadow, 0.25s cubic-bezier(0.4, 0, 0.2, 1) width;
        transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1) transform, 0.2s cubic-bezier(0.4, 0, 0.2, 1) background-color, 0.2s cubic-bezier(0.4, 0, 0.2, 1) left, 0.2s cubic-bezier(0.4, 0, 0.2, 1) right, 280ms cubic-bezier(0.4, 0, 0.2, 1) box-shadow, 0.25s cubic-bezier(0.4, 0, 0.2, 1) width, 0.2s cubic-bezier(0.4, 0, 0.2, 1) -webkit-transform, 280ms cubic-bezier(0.4, 0, 0.2, 1) -webkit-box-shadow;
      }
      .v-toolbar .v-input {
        padding-top: 0;
        margin-top: 0;
      }
      
      .v-toolbar__content,
      .v-toolbar__extension {
        padding: 4px 16px;
      }
      .v-toolbar__content .v-btn.v-btn--icon,
      .v-toolbar__extension .v-btn.v-btn--icon {
        height: 48px;
        width: 48px;
      }
      .v-toolbar__content > .v-btn.v-btn--icon:first-child,
      .v-toolbar__extension > .v-btn.v-btn--icon:first-child {
        margin-left: -12px;
      }
      .v-toolbar__content > .v-btn.v-btn--icon:first-child + .v-toolbar__title,
      .v-toolbar__extension > .v-btn.v-btn--icon:first-child + .v-toolbar__title {
        padding-left: 20px;
      }
      .v-toolbar__content > .v-btn.v-btn--icon:last-child,
      .v-toolbar__extension > .v-btn.v-btn--icon:last-child {
        margin-right: -12px;
      }
      .v-application--is-rtl .v-toolbar__content > .v-btn.v-btn--icon:first-child,
      .v-application--is-rtl .v-toolbar__extension > .v-btn.v-btn--icon:first-child {
        margin-right: -12px;
      }
      .v-application--is-rtl .v-toolbar__content > .v-btn.v-btn--icon:first-child + .v-toolbar__title,
      .v-application--is-rtl .v-toolbar__extension > .v-btn.v-btn--icon:first-child + .v-toolbar__title {
        padding-right: 20px;
      }
      .v-application--is-rtl .v-toolbar__content > .v-btn.v-btn--icon:last-child,
      .v-application--is-rtl .v-toolbar__extension > .v-btn.v-btn--icon:last-child {
        margin-left: -12px;
      }
      .v-toolbar__content > .v-tabs,
      .v-toolbar__extension > .v-tabs {
        height: inherit;
        margin-top: -4px;
        margin-bottom: -4px;
      }
      .v-toolbar__content > .v-tabs .v-tabs-bar,
      .v-toolbar__extension > .v-tabs .v-tabs-bar {
        height: inherit;
      }
      .v-toolbar__content > .v-tabs:first-child,
      .v-toolbar__extension > .v-tabs:first-child {
        margin-left: -16px;
      }
      .v-toolbar__content > .v-tabs:last-child,
      .v-toolbar__extension > .v-tabs:last-child {
        margin-right: -16px;
      }
      
      .v-toolbar__content,
      .v-toolbar__extension {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        position: relative;
        z-index: 0;
      }
      
      .v-toolbar__image {
        border-radius: inherit;
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        z-index: 0;
        contain: strict;
      }
      .v-toolbar__image .v-image {
        border-radius: inherit;
      }
      
      .v-toolbar__items {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: inherit;
      }
      .v-toolbar__items > .v-btn {
        border-radius: 0;
        height: 100% !important;
        max-height: none;
      }
      
      .v-toolbar__title {
        font-size: 1.25rem;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      
      .v-toolbar.v-toolbar--absolute {
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 1;
      }
      
      .v-toolbar.v-toolbar--bottom {
        top: initial;
        bottom: 0;
      }
      
      .v-toolbar.v-toolbar--collapse .v-toolbar__title {
        white-space: nowrap;
      }
      
      .v-toolbar.v-toolbar--collapsed {
        border-bottom-right-radius: 24px;
        width: 112px;
      }
      .v-toolbar.v-toolbar--collapsed .v-toolbar__title,
      .v-toolbar.v-toolbar--collapsed .v-toolbar__extension {
        display: none;
      }
      
      .v-toolbar--dense .v-toolbar__content,
      .v-toolbar--dense .v-toolbar__extension {
        padding-top: 0;
        padding-bottom: 0;
      }
      
      .v-toolbar--flat {
        -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
      }
      
      .v-toolbar--floating {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
      }
      
      .v-toolbar--prominent .v-toolbar__content {
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
      }
      .v-toolbar--prominent .v-toolbar__title {
        -ms-flex-item-align: end;
            align-self: flex-end;
        font-size: 1.5rem;
        padding-bottom: 6px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-sheet {
        background-color: #FFFFFF;
        border-color: #FFFFFF;
        color: rgba(0, 0, 0, 0.87);
      }
      
      .theme--dark.v-sheet {
        background-color: #424242;
        border-color: #424242;
        color: #FFFFFF;
      }
      
      .v-sheet {
        display: block;
        border-radius: 4px;
        position: relative;
        -webkit-transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
        transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
        transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
        transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
        will-change: box-shadow;
      }
      .v-sheet > *:first-child:not(.v-btn):not(.v-chip) {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
      }
      .v-sheet > *:last-child:not(.v-btn):not(.v-chip) {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
      }
      .v-sheet--tile {
        border-radius: 0;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-image {
        z-index: 0;
      }
      
      .v-image__image,
      .v-image__placeholder {
        z-index: -1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      
      .v-image__image {
        background-repeat: no-repeat;
      }
      .v-image__image--preload {
        -webkit-filter: blur(2px);
                filter: blur(2px);
      }
      .v-image__image--contain {
        background-size: contain;
      }
      .v-image__image--cover {
        background-size: cover;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-responsive {
        position: relative;
        overflow: hidden;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        max-width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .v-responsive__content {
        -webkit-box-flex: 1;
            -ms-flex: 1 0 0px;
                flex: 1 0 0px;
        max-width: 100%;
      }
      .v-responsive__sizer {
        -webkit-transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
        -webkit-box-flex: 0;
            -ms-flex: 0 0 0px;
                flex: 0 0 0px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-ripple__container {
        color: inherit;
        border-radius: inherit;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        overflow: hidden;
        z-index: 0;
        pointer-events: none;
        contain: strict;
      }
      .v-ripple__animation {
        color: inherit;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 50%;
        background: currentColor;
        opacity: 0;
        pointer-events: none;
        overflow: hidden;
        will-change: transform, opacity;
      }
      .v-ripple__animation--enter {
        -webkit-transition: none;
        transition: none;
      }
      .v-ripple__animation--in {
        -webkit-transition: opacity 0.1s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        transition: opacity 0.1s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.1s cubic-bezier(0.4, 0, 0.2, 1);
        transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.1s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }
      .v-ripple__animation--out {
        -webkit-transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-btn:not(.v-btn--outlined).primary, .v-btn:not(.v-btn--outlined).secondary, .v-btn:not(.v-btn--outlined).accent, .v-btn:not(.v-btn--outlined).success, .v-btn:not(.v-btn--outlined).error, .v-btn:not(.v-btn--outlined).warning, .v-btn:not(.v-btn--outlined).info {
        color: #FFFFFF;
      }
      
      .theme--light.v-btn {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-btn.v-btn--disabled {
        color: rgba(0, 0, 0, 0.26) !important;
      }
      .theme--light.v-btn.v-btn--disabled .v-icon,
      .theme--light.v-btn.v-btn--disabled .v-btn__loading {
        color: rgba(0, 0, 0, 0.26) !important;
      }
      .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: rgba(0, 0, 0, 0.12) !important;
      }
      .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #f5f5f5;
      }
      .theme--light.v-btn.v-btn--outlined.v-btn--text {
        border-color: rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-btn.v-btn--icon {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-btn:hover::before {
        opacity: 0.04;
      }
      .theme--light.v-btn:focus::before {
        opacity: 0.12;
      }
      .theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
        opacity: 0.12;
      }
      .theme--light.v-btn--active:focus::before {
        opacity: 0.16;
      }
      
      .theme--dark.v-btn {
        color: #FFFFFF;
      }
      .theme--dark.v-btn.v-btn--disabled {
        color: rgba(255, 255, 255, 0.3) !important;
      }
      .theme--dark.v-btn.v-btn--disabled .v-icon,
      .theme--dark.v-btn.v-btn--disabled .v-btn__loading {
        color: rgba(255, 255, 255, 0.3) !important;
      }
      .theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: rgba(255, 255, 255, 0.12) !important;
      }
      .theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #212121;
      }
      .theme--dark.v-btn.v-btn--outlined.v-btn--text {
        border-color: rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-btn.v-btn--icon {
        color: #FFFFFF;
      }
      .theme--dark.v-btn:hover::before {
        opacity: 0.08;
      }
      .theme--dark.v-btn:focus::before {
        opacity: 0.24;
      }
      .theme--dark.v-btn--active:hover::before, .theme--dark.v-btn--active::before {
        opacity: 0.24;
      }
      .theme--dark.v-btn--active:focus::before {
        opacity: 0.32;
      }
      
      .v-btn {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        border-radius: 4px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
                flex: 0 0 auto;
        font-size: 0.875rem;
        font-weight: 500;
        letter-spacing: 0.0892857143em;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        max-width: 100%;
        outline: 0;
        position: relative;
        text-decoration: none;
        text-indent: 0.0892857143em;
        text-transform: uppercase;
        -webkit-transition-duration: 0.28s;
                transition-duration: 0.28s;
        -webkit-transition-property: opacity, -webkit-box-shadow, -webkit-transform;
        transition-property: opacity, -webkit-box-shadow, -webkit-transform;
        transition-property: box-shadow, transform, opacity;
        transition-property: box-shadow, transform, opacity, -webkit-box-shadow, -webkit-transform;
        -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        vertical-align: middle;
        white-space: nowrap;
      }
      .v-btn:before {
        border-radius: inherit;
        bottom: 0;
        color: inherit;
        content: "";
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
        transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
      }
      .v-btn:before {
        background-color: currentColor;
      }
      .v-btn:not(.v-btn--disabled) {
        will-change: box-shadow;
      }
      .v-btn:not(.v-btn--round).v-size--x-small {
        height: 20px;
        min-width: 36px;
        padding: 0 8.8888888889px;
      }
      .v-btn:not(.v-btn--round).v-size--small {
        height: 28px;
        min-width: 50px;
        padding: 0 12.4444444444px;
      }
      .v-btn:not(.v-btn--round).v-size--default {
        height: 36px;
        min-width: 64px;
        padding: 0 16px;
      }
      .v-btn:not(.v-btn--round).v-size--large {
        height: 44px;
        min-width: 78px;
        padding: 0 19.5555555556px;
      }
      .v-btn:not(.v-btn--round).v-size--x-large {
        height: 52px;
        min-width: 92px;
        padding: 0 23.1111111111px;
      }
      .v-application--is-rtl .v-btn .v-icon--left {
        margin-left: 8px;
        margin-right: -4px;
      }
      .v-application--is-rtl .v-btn .v-icon--right {
        margin-left: -4px;
        margin-right: 8px;
      }
      .v-btn > .v-btn__content .v-icon {
        color: inherit;
      }
      
      .v-btn__content {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        color: inherit;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        -webkit-box-pack: inherit;
            -ms-flex-pack: inherit;
                justify-content: inherit;
        line-height: normal;
        position: relative;
      }
      .v-btn__content .v-icon--left,
      .v-btn__content .v-icon--right {
        font-size: 18px;
        height: 18px;
        width: 18px;
      }
      .v-btn__content .v-icon--left {
        margin-left: -4px;
        margin-right: 8px;
      }
      .v-btn__content .v-icon--right {
        margin-left: 8px;
        margin-right: -4px;
      }
      
      .v-btn__loader {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 100%;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }
      
      .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
        opacity: 0.18;
      }
      .v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before {
        opacity: 0.08;
      }
      .v-btn:not(.v-btn--text):not(.v-btn--outlined):focus:before {
        opacity: 0.24;
      }
      
      .v-btn--absolute,
      .v-btn--fixed {
        position: absolute;
      }
      .v-btn--absolute.v-btn--right,
      .v-btn--fixed.v-btn--right {
        right: 16px;
      }
      .v-btn--absolute.v-btn--left,
      .v-btn--fixed.v-btn--left {
        left: 16px;
      }
      .v-btn--absolute.v-btn--top,
      .v-btn--fixed.v-btn--top {
        top: 16px;
      }
      .v-btn--absolute.v-btn--bottom,
      .v-btn--fixed.v-btn--bottom {
        bottom: 16px;
      }
      
      .v-btn--block {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        min-width: 100% !important;
        max-width: auto;
      }
      
      .v-btn--contained {
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
      .v-btn--contained:after {
        -webkit-box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
      }
      .v-btn--contained:active {
        -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
      }
      
      .v-btn--depressed {
        -webkit-box-shadow: none !important;
                box-shadow: none !important;
      }
      
      .v-btn--disabled {
        -webkit-box-shadow: none;
                box-shadow: none;
        pointer-events: none;
      }
      
      .v-btn--fab {
        min-height: 0;
        min-width: 0;
        padding: 0;
      }
      .v-btn--fab.v-btn--contained {
        -webkit-box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
      }
      .v-btn--fab.v-btn--contained:after {
        -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
      }
      .v-btn--fab.v-btn--contained:active {
        -webkit-box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
      }
      .v-btn--fab.v-btn--fixed, .v-btn--fab.v-btn--absolute {
        z-index: 4;
      }
      .v-btn--fab.v-size--x-small .v-icon {
        height: 18px;
        font-size: 18px;
        width: 18px;
      }
      .v-btn--fab.v-size--small .v-icon {
        height: 24px;
        font-size: 24px;
        width: 24px;
      }
      .v-btn--fab.v-size--default .v-icon {
        height: 24px;
        font-size: 24px;
        width: 24px;
      }
      .v-btn--fab.v-size--large .v-icon {
        height: 28px;
        font-size: 28px;
        width: 28px;
      }
      .v-btn--fab.v-size--x-large .v-icon {
        height: 32px;
        font-size: 32px;
        width: 32px;
      }
      .v-btn--fab.v-size--x-small {
        height: 32px;
        width: 32px;
      }
      .v-btn--fab.v-size--x-small.v-btn--absolute.v-btn--bottom {
        bottom: -16px;
      }
      .v-btn--fab.v-size--x-small.v-btn--absolute.v-btn--top {
        top: -16px;
      }
      .v-btn--fab.v-size--small {
        height: 40px;
        width: 40px;
      }
      .v-btn--fab.v-size--small.v-btn--absolute.v-btn--bottom {
        bottom: -20px;
      }
      .v-btn--fab.v-size--small.v-btn--absolute.v-btn--top {
        top: -20px;
      }
      .v-btn--fab.v-size--default {
        height: 56px;
        width: 56px;
      }
      .v-btn--fab.v-size--default.v-btn--absolute.v-btn--bottom {
        bottom: -28px;
      }
      .v-btn--fab.v-size--default.v-btn--absolute.v-btn--top {
        top: -28px;
      }
      .v-btn--fab.v-size--large {
        height: 64px;
        width: 64px;
      }
      .v-btn--fab.v-size--large.v-btn--absolute.v-btn--bottom {
        bottom: -32px;
      }
      .v-btn--fab.v-size--large.v-btn--absolute.v-btn--top {
        top: -32px;
      }
      .v-btn--fab.v-size--x-large {
        height: 72px;
        width: 72px;
      }
      .v-btn--fab.v-size--x-large.v-btn--absolute.v-btn--bottom {
        bottom: -36px;
      }
      .v-btn--fab.v-size--x-large.v-btn--absolute.v-btn--top {
        top: -36px;
      }
      
      .v-btn--fixed {
        position: fixed;
      }
      
      .v-btn--loading {
        pointer-events: none;
        -webkit-transition: none;
        transition: none;
      }
      .v-btn--loading .v-btn__content {
        opacity: 0;
      }
      
      .v-btn--outlined {
        border: thin solid currentColor;
      }
      .v-btn--outlined:before {
        border-radius: 0;
      }
      
      .v-btn--outlined .v-btn__content .v-icon,
      .v-btn--round .v-btn__content .v-icon {
        color: currentColor;
      }
      
      .v-btn--outlined,
      .v-btn--flat,
      .v-btn--text {
        background-color: transparent;
      }
      
      .v-btn--round:before,
      .v-btn--rounded:before {
        border-radius: inherit;
      }
      
      .v-btn--round {
        border-radius: 50%;
      }
      
      .v-btn--rounded {
        border-radius: 28px;
      }
      
      .v-btn--tile {
        border-radius: 0;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-progress-circular {
        position: relative;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        vertical-align: middle;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
      }
      .v-progress-circular svg {
        width: 100%;
        height: 100%;
        margin: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 0;
      }
      .v-progress-circular--indeterminate svg {
        -webkit-animation: progress-circular-rotate 1.4s linear infinite;
                animation: progress-circular-rotate 1.4s linear infinite;
        -webkit-transform-origin: center center;
                transform-origin: center center;
        -webkit-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
      }
      .v-progress-circular--indeterminate .v-progress-circular__overlay {
        -webkit-animation: progress-circular-dash 1.4s ease-in-out infinite;
                animation: progress-circular-dash 1.4s ease-in-out infinite;
        stroke-linecap: round;
        stroke-dasharray: 80, 200;
        stroke-dashoffset: 0px;
      }
      .v-progress-circular__info {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
      }
      .v-progress-circular__underlay {
        stroke: rgba(0, 0, 0, 0.1);
        z-index: 1;
      }
      .v-progress-circular__overlay {
        stroke: currentColor;
        z-index: 2;
        -webkit-transition: all 0.6s ease-in-out;
        transition: all 0.6s ease-in-out;
      }
      
      @-webkit-keyframes progress-circular-dash {
        0% {
          stroke-dasharray: 1, 200;
          stroke-dashoffset: 0px;
        }
        50% {
          stroke-dasharray: 100, 200;
          stroke-dashoffset: -15px;
        }
        100% {
          stroke-dasharray: 100, 200;
          stroke-dashoffset: -125px;
        }
      }
      
      @keyframes progress-circular-dash {
        0% {
          stroke-dasharray: 1, 200;
          stroke-dashoffset: 0px;
        }
        50% {
          stroke-dasharray: 100, 200;
          stroke-dashoffset: -15px;
        }
        100% {
          stroke-dasharray: 100, 200;
          stroke-dashoffset: -125px;
        }
      }
      @-webkit-keyframes progress-circular-rotate {
        100% {
          -webkit-transform: rotate(360deg);
                  transform: rotate(360deg);
        }
      }
      @keyframes progress-circular-rotate {
        100% {
          -webkit-transform: rotate(360deg);
                  transform: rotate(360deg);
        }
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-alert .v-alert--prominent .v-alert__icon:after {
        background: rgba(0, 0, 0, 0.12);
      }
      
      .theme--dark.v-alert .v-alert--prominent .v-alert__icon:after {
        background: rgba(255, 255, 255, 0.12);
      }
      
      .v-alert {
        font-size: 16px;
        margin-bottom: 16px;
        padding: 16px;
      }
      .v-alert > .v-icon,
      .v-alert > .v-alert__content {
        margin-right: 16px;
      }
      .v-alert > .v-icon + .v-alert__content {
        margin-right: 0;
      }
      .v-alert > .v-alert__content + .v-icon {
        margin-right: 0;
      }
      .v-application--is-rtl .v-alert > .v-icon,
      .v-application--is-rtl .v-alert > .v-alert__content {
        margin-right: 0;
        margin-left: 16px;
      }
      .v-application--is-rtl .v-alert > .v-icon + .v-alert__content {
        margin-left: 0;
      }
      .v-application--is-rtl .v-alert > .v-alert__content + .v-icon {
        margin-left: 0;
      }
      
      .v-alert__border {
        border-style: solid;
        border-width: 4px;
        content: "";
        position: absolute;
      }
      .v-alert__border:not(.v-alert__border--has-color) {
        opacity: 0.26;
      }
      .v-alert__border--left, .v-alert__border--right {
        bottom: 0;
        top: 0;
      }
      .v-alert__border--bottom, .v-alert__border--top {
        left: 0;
        right: 0;
      }
      .v-alert__border--bottom {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
        bottom: 0;
      }
      .v-alert__border--left {
        border-top-left-radius: inherit;
        border-bottom-left-radius: inherit;
        left: 0;
      }
      .v-alert__border--right {
        border-top-right-radius: inherit;
        border-bottom-right-radius: inherit;
        right: 0;
      }
      .v-alert__border--top {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
        top: 0;
      }
      .v-application--is-rtl .v-alert__border--left {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: inherit;
        border-bottom-right-radius: inherit;
        left: auto;
        right: 0;
      }
      .v-application--is-rtl .v-alert__border--right {
        border-top-left-radius: inherit;
        border-bottom-left-radius: inherit;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        left: 0;
        right: auto;
      }
      
      .v-alert__content {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
      }
      
      .v-alert__dismissible {
        margin-top: -6px;
        margin-bottom: -6px;
      }
      
      .v-alert__icon {
        -ms-flex-item-align: start;
            align-self: flex-start;
        border-radius: 50%;
        height: 24px;
        margin-right: 16px;
        min-width: 24px;
        position: relative;
      }
      .v-application--is-rtl .v-alert__icon {
        margin-right: 0;
        margin-left: 16px;
      }
      .v-alert__icon.v-icon {
        font-size: 24px;
      }
      
      .v-alert__wrapper {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      
      .v-alert--dense {
        padding-top: 8px;
        padding-bottom: 8px;
      }
      .v-alert--dense .v-alert__border {
        border-width: medium;
      }
      
      .v-alert--outlined {
        background: transparent !important;
        border: thin solid currentColor !important;
      }
      .v-alert--outlined .v-alert__icon {
        color: inherit !important;
      }
      
      .v-alert--prominent .v-alert__icon {
        -ms-flex-item-align: center;
            align-self: center;
        height: 48px;
        min-width: 48px;
      }
      .v-alert--prominent .v-alert__icon:after {
        background: currentColor !important;
        border-radius: 50%;
        bottom: 0;
        content: "";
        left: 0;
        opacity: 0.16;
        position: absolute;
        right: 0;
        top: 0;
      }
      .v-alert--prominent .v-alert__icon.v-icon {
        font-size: 32px;
      }
      
      .v-alert--text {
        background: transparent !important;
      }
      .v-alert--text:before {
        background-color: currentColor;
        border-radius: inherit;
        bottom: 0;
        content: "";
        left: 0;
        opacity: 0.12;
        position: absolute;
        right: 0;
        top: 0;
      }</style><style type="text/css">.v-autocomplete.v-input > .v-input__control > .v-input__slot {
        cursor: text;
      }
      .v-autocomplete input {
        -ms-flex-item-align: center;
            align-self: center;
      }
      .v-autocomplete--is-selecting-index input {
        opacity: 0;
      }
      .v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__slot > input {
        margin-top: 24px;
      }
      .v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input {
        pointer-events: inherit;
      }
      .v-autocomplete__content.v-menu__content {
        border-radius: 0;
      }
      .v-autocomplete__content.v-menu__content .v-card {
        border-radius: 0;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border-color: rgba(0, 0, 0, 0.42);
      }
      .theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
        border-color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before {
        -o-border-image: repeating-linear-gradient(to right, rgba(0, 0, 0, 0.38) 0px, rgba(0, 0, 0, 0.38) 2px, transparent 2px, transparent 4px) 1 repeat;
           border-image: repeating-linear-gradient(to right, rgba(0, 0, 0, 0.38) 0px, rgba(0, 0, 0, 0.38) 2px, transparent 2px, transparent 4px) 1 repeat;
      }
      .theme--light.v-text-field.v-input--is-disabled .v-text-field__prefix,
      .theme--light.v-text-field.v-input--is-disabled .v-text-field__suffix {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-text-field__prefix, .theme--light.v-text-field__suffix {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
        background: #FFFFFF;
      }
      .theme--light.v-text-field--solo-inverted.v-text-field--solo > .v-input__control > .v-input__slot {
        background: rgba(0, 0, 0, 0.16);
      }
      .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot {
        background: #424242;
      }
      .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot .v-label,
      .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot input {
        color: #FFFFFF;
      }
      .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
        background: rgba(0, 0, 0, 0.06);
      }
      .theme--light.v-text-field--filled .v-text-field__prefix,
      .theme--light.v-text-field--filled .v-text-field__suffix {
        max-height: 32px;
        margin-top: 20px;
      }
      .theme--light.v-text-field--filled:not(.v-input--is-focused) > .v-input__control > .v-input__slot:hover {
        background: rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-text-field--outlined fieldset {
        border-color: rgba(0, 0, 0, 0.24);
      }
      .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state):hover fieldset {
        border-color: rgba(0, 0, 0, 0.86);
      }
      
      .theme--dark.v-text-field > .v-input__control > .v-input__slot:before {
        border-color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
        border-color: #FFFFFF;
      }
      .theme--dark.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before {
        -o-border-image: repeating-linear-gradient(to right, rgba(255, 255, 255, 0.5) 0px, rgba(255, 255, 255, 0.5) 2px, transparent 2px, transparent 4px) 1 repeat;
           border-image: repeating-linear-gradient(to right, rgba(255, 255, 255, 0.5) 0px, rgba(255, 255, 255, 0.5) 2px, transparent 2px, transparent 4px) 1 repeat;
      }
      .theme--dark.v-text-field.v-input--is-disabled .v-text-field__prefix,
      .theme--dark.v-text-field.v-input--is-disabled .v-text-field__suffix {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-text-field__prefix, .theme--dark.v-text-field__suffix {
        color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
        background: #424242;
      }
      .theme--dark.v-text-field--solo-inverted.v-text-field--solo > .v-input__control > .v-input__slot {
        background: rgba(255, 255, 255, 0.16);
      }
      .theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot {
        background: #FFFFFF;
      }
      .theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot .v-label,
      .theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot input {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--dark.v-text-field--filled > .v-input__control > .v-input__slot {
        background: rgba(0, 0, 0, 0.1);
      }
      .theme--dark.v-text-field--filled .v-text-field__prefix,
      .theme--dark.v-text-field--filled .v-text-field__suffix {
        max-height: 32px;
        margin-top: 20px;
      }
      .theme--dark.v-text-field--filled:not(.v-input--is-focused) > .v-input__control > .v-input__slot:hover {
        background: rgba(0, 0, 0, 0.2);
      }
      .v-text-field {
        padding-top: 12px;
        margin-top: 4px;
      }
      .v-text-field input {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        line-height: 20px;
        padding: 8px 0 8px;
        max-width: 100%;
        min-width: 0px;
        width: 100%;
      }
      .v-text-field input[type=text]::-ms-clear {
        display: none;
      }
      .v-text-field .v-input__prepend-inner,
      .v-text-field .v-input__append-inner {
        -ms-flex-item-align: start;
            align-self: flex-start;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        margin-top: 4px;
        line-height: 1;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-text-field .v-input__prepend-inner {
        margin-right: auto;
        padding-right: 4px;
      }
      .v-application--is-rtl .v-text-field .v-input__prepend-inner {
        padding-right: 0;
        padding-left: 4px;
      }
      .v-text-field .v-input__append-inner {
        margin-left: auto;
        padding-left: 4px;
      }
      .v-application--is-rtl .v-text-field .v-input__append-inner {
        padding-left: 0;
        padding-right: 4px;
      }
      .v-text-field .v-counter {
        margin-left: 8px;
        white-space: nowrap;
      }
      .v-application--is-rtl .v-text-field .v-counter {
        margin-left: 0;
        margin-right: 8px;
      }
      .v-text-field .v-label {
        max-width: 90%;
        overflow: hidden;
        text-overflow: ellipsis;
        top: 6px;
        -webkit-transform-origin: top left;
                transform-origin: top left;
        white-space: nowrap;
        pointer-events: none;
      }
      .v-text-field .v-label--active {
        max-width: 133%;
        -webkit-transform: translateY(-18px) scale(0.75);
                transform: translateY(-18px) scale(0.75);
      }
      .v-text-field > .v-input__control > .v-input__slot {
        cursor: text;
        -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-text-field > .v-input__control > .v-input__slot:before, .v-text-field > .v-input__control > .v-input__slot:after {
        bottom: -1px;
        content: "";
        left: 0;
        position: absolute;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        width: 100%;
      }
      .v-text-field > .v-input__control > .v-input__slot:before {
        border-style: solid;
        border-width: thin 0 0 0;
      }
      .v-text-field > .v-input__control > .v-input__slot:after {
        border-color: currentColor;
        border-style: solid;
        border-width: thin 0 thin 0;
        -webkit-transform: scaleX(0);
                transform: scaleX(0);
      }
      .v-text-field__details {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        max-width: 100%;
        min-height: 14px;
        overflow: hidden;
      }
      .v-text-field__prefix, .v-text-field__suffix {
        -ms-flex-item-align: center;
            align-self: center;
        cursor: default;
        -webkit-transition: color 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: color 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        white-space: nowrap;
      }
      .v-text-field__prefix {
        text-align: right;
        padding-right: 4px;
      }
      .v-application--is-rtl .v-text-field__prefix {
        padding-right: 0;
        padding-left: 4px;
      }
      .v-text-field__suffix {
        padding-left: 4px;
        white-space: nowrap;
      }
      .v-application--is-rtl .v-text-field__suffix {
        padding-left: 0;
        padding-right: 4px;
      }
      .v-text-field--reverse .v-text-field__prefix {
        text-align: left;
        padding-right: 0;
        padding-left: 4px;
      }
      .v-application--is-rtl .v-text-field--reverse .v-text-field__prefix {
        padding-right: 4px;
        padding-left: 0;
      }
      .v-text-field--reverse .v-text-field__suffix {
        padding-left: 0;
        padding-right: 4px;
      }
      .v-application--is-rtl .v-text-field--reverse .v-text-field__suffix {
        padding-left: 4px;
        padding-right: 0;
      }
      .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        position: relative;
      }
      .v-text-field:not(.v-text-field--is-booted) .v-label,
      .v-text-field:not(.v-text-field--is-booted) legend {
        -webkit-transition: none;
        transition: none;
      }
      .v-text-field--filled, .v-text-field--full-width, .v-text-field--outlined {
        position: relative;
      }
      .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
        min-height: 56px;
      }
      .v-text-field--filled input, .v-text-field--full-width input {
        margin-top: 22px;
      }
      .v-text-field--filled.v-text-field--single-line input, .v-text-field--full-width.v-text-field--single-line input {
        margin-top: 12px;
      }
      .v-text-field--filled .v-label, .v-text-field--full-width .v-label {
        top: 18px;
      }
      .v-text-field--filled .v-label--active, .v-text-field--full-width .v-label--active {
        -webkit-transform: translateY(-6px) scale(0.75);
                transform: translateY(-6px) scale(0.75);
      }
      .v-text-field--filled > .v-input__control > .v-input__slot {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
      .v-text-field.v-text-field--enclosed {
        margin: 0;
        padding: 0;
      }
      .v-text-field.v-text-field--enclosed.v-text-field--single-line .v-text-field__prefix,
      .v-text-field.v-text-field--enclosed.v-text-field--single-line .v-text-field__suffix {
        margin-top: 0;
      }
      .v-text-field.v-text-field--enclosed:not(.v-text-field--filled) .v-progress-linear__background {
        display: none;
      }
      .v-text-field.v-text-field--enclosed .v-input__prepend-outer,
      .v-text-field.v-text-field--enclosed .v-input__prepend-inner,
      .v-text-field.v-text-field--enclosed .v-input__append-inner,
      .v-text-field.v-text-field--enclosed .v-input__append-outer {
        margin-top: 16px;
      }
      .v-text-field.v-text-field--enclosed .v-text-field__details, .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
        padding: 0 12px;
      }
      .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-bottom: 8px;
      }
      .v-text-field--reverse input {
        text-align: right;
      }
      .v-text-field--reverse .v-label {
        -webkit-transform-origin: top right;
                transform-origin: top right;
      }
      .v-text-field--reverse > .v-input__control > .v-input__slot,
      .v-text-field--reverse .v-text-field__slot {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: reverse;
            -ms-flex-direction: row-reverse;
                flex-direction: row-reverse;
      }
      .v-text-field--solo > .v-input__control > .v-input__slot:before, .v-text-field--solo > .v-input__control > .v-input__slot:after, .v-text-field--outlined > .v-input__control > .v-input__slot:before, .v-text-field--outlined > .v-input__control > .v-input__slot:after, .v-text-field--full-width > .v-input__control > .v-input__slot:before, .v-text-field--full-width > .v-input__control > .v-input__slot:after, .v-text-field--rounded > .v-input__control > .v-input__slot:before, .v-text-field--rounded > .v-input__control > .v-input__slot:after {
        display: none;
      }
      .v-text-field--outlined {
        margin-bottom: 16px;
        -webkit-transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-text-field--outlined .v-label {
        top: 18px;
      }
      .v-text-field--outlined .v-label--active {
        -webkit-transform: translateY(-24px) scale(0.75);
                transform: translateY(-24px) scale(0.75);
      }
      .v-text-field--outlined fieldset {
        border-style: solid;
        border-width: 1px;
        bottom: 0;
        left: 0;
        padding-left: 8px;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: -5px;
        -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
        -webkit-transition-property: border, border-width;
        transition-property: border, border-width;
        -webkit-transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
                transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      .v-application--is-rtl .v-text-field--outlined fieldset {
        padding-left: 0;
        padding-right: 8px;
      }
      .v-text-field--outlined legend {
        line-height: 11px;
        padding: 0;
        text-align: left;
        -webkit-transition: width 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: width 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-application--is-rtl .v-text-field--outlined legend {
        text-align: right;
      }
      .v-text-field--outlined.v-text-field--rounded legend {
        margin-left: 12px;
      }
      .v-application--is-rtl .v-text-field--outlined.v-text-field--rounded legend {
        margin-left: 0;
        margin-right: 12px;
      }
      .v-text-field--outlined > .v-input__control > .v-input__slot {
        background: transparent !important;
      }
      .v-text-field--outlined .v-text-field__prefix {
        max-height: 32px;
      }
      .v-text-field--outlined .v-input__prepend-outer,
      .v-text-field--outlined .v-input__append-outer {
        margin-top: 18px;
      }
      .v-text-field--outlined.v-input--is-focused fieldset, .v-text-field--outlined.v-input--has-state fieldset {
        border-color: currentColor;
        border-width: 2px;
      }
      .v-text-field--solo, .v-text-field--outlined {
        border-radius: 4px;
      }
      .v-text-field--solo fieldset,
      .v-text-field--solo .v-input__control,
      .v-text-field--solo .v-input__slot, .v-text-field--outlined fieldset,
      .v-text-field--outlined .v-input__control,
      .v-text-field--outlined .v-input__slot {
        border-radius: inherit;
      }
      .v-text-field--solo .v-text-field__slot, .v-text-field--outlined .v-text-field__slot {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
      }
      .v-text-field--rounded {
        border-radius: 28px;
      }
      .v-text-field--rounded.v-text-field--outlined fieldset {
        border-radius: 28px;
      }
      .v-text-field--rounded > .v-input__control > .v-input__slot {
        border-radius: 28px;
        padding: 0 24px !important;
      }
      .v-text-field--shaped.v-text-field--outlined fieldset {
        border-radius: 16px 16px 0 0;
      }
      .v-text-field--shaped > .v-input__control > .v-input__slot {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
      }
      .v-text-field.v-text-field--solo .v-label {
        top: calc(50% - 10px);
      }
      .v-text-field.v-text-field--solo .v-input__control {
        min-height: 48px;
        padding: 0;
      }
      .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
      .v-text-field.v-text-field--solo .v-input__append-inner,
      .v-text-field.v-text-field--solo .v-input__prepend-inner {
        -ms-flex-item-align: center;
            align-self: center;
        margin-top: 0;
      }
      .v-text-field.v-text-field--solo .v-input__prepend-outer,
      .v-text-field.v-text-field--solo .v-input__append-outer {
        margin-top: 12px;
      }
      .v-text-field.v-input--is-focused > .v-input__control > .v-input__slot:after {
        -webkit-transform: scaleX(1);
                transform: scaleX(1);
      }
      .v-text-field.v-input--has-state > .v-input__control > .v-input__slot:before {
        border-color: currentColor;
      }
      .v-application--is-rtl .v-text-field .v-label {
        -webkit-transform-origin: top right;
                transform-origin: top right;
      }
      .v-application--is-rtl .v-text-field .v-counter {
        margin-left: 0;
        margin-right: 8px;
      }
      .v-application--is-rtl .v-text-field--enclosed .v-input__append-outer {
        margin-left: 0;
        margin-right: 16px;
      }
      .v-application--is-rtl .v-text-field--enclosed .v-input__prepend-outer {
        margin-left: 16px;
        margin-right: 0;
      }
      .v-application--is-rtl .v-text-field--reverse input {
        text-align: left;
      }
      .v-application--is-rtl .v-text-field--reverse .v-label {
        -webkit-transform-origin: top left;
                transform-origin: top left;
      }
      .v-application--is-rtl .v-text-field__prefix {
        text-align: left;
        padding-right: 0;
        padding-left: 4px;
      }
      .v-application--is-rtl .v-text-field__suffix {
        padding-left: 0;
        padding-right: 4px;
      }
      .v-application--is-rtl .v-text-field--reverse .v-text-field__prefix {
        text-align: right;
        padding-left: 0;
        padding-right: 4px;
      }
      .v-application--is-rtl .v-text-field--reverse .v-text-field__suffix {
        padding-left: 0;
        padding-right: 4px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-select .v-select__selections {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-select.v-input--is-disabled .v-select__selections {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-select .v-chip--disabled,
      .theme--light.v-select .v-select__selection--disabled {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selections {
        color: #FFFFFF;
      }
      
      .theme--dark.v-select .v-select__selections {
        color: #FFFFFF;
      }
      .theme--dark.v-select.v-input--is-disabled .v-select__selections {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-select .v-chip--disabled,
      .theme--dark.v-select .v-select__selection--disabled {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selections {
        color: rgba(0, 0, 0, 0.87);
      }
      
      .v-select {
        position: relative;
      }
      .v-select > .v-input__control > .v-input__slot {
        cursor: pointer;
      }
      .v-select .v-chip {
        -webkit-box-flex: 0;
            -ms-flex: 0 1 auto;
                flex: 0 1 auto;
        margin: 4px;
      }
      .v-select .v-chip--selected:after {
        opacity: 0.22;
      }
      .v-select .fade-transition-leave-active {
        position: absolute;
        left: 0;
      }
      .v-select.v-input--is-dirty ::-webkit-input-placeholder {
        color: transparent !important;
      }
      .v-select.v-input--is-dirty ::-moz-placeholder {
        color: transparent !important;
      }
      .v-select.v-input--is-dirty :-ms-input-placeholder {
        color: transparent !important;
      }
      .v-select.v-input--is-dirty ::-ms-input-placeholder {
        color: transparent !important;
      }
      .v-select.v-input--is-dirty ::placeholder {
        color: transparent !important;
      }
      .v-select:not(.v-input--is-dirty):not(.v-input--is-focused) .v-text-field__prefix {
        line-height: 20px;
        position: absolute;
        top: 7px;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-select.v-text-field--enclosed:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__selections {
        padding-top: 24px;
      }
      .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
        padding: 8px 0;
      }
      .v-select.v-text-field input {
        -webkit-box-flex: 1;
            -ms-flex: 1 1;
                flex: 1 1;
        margin-top: 0;
        min-width: 0;
        pointer-events: none;
        position: relative;
      }
      .v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
        -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
      }
      .v-select.v-select--chips input {
        margin: 0;
      }
      .v-select.v-select--chips .v-select__selections {
        min-height: 42px;
      }
      .v-select.v-select--chips .v-chip--select.v-chip--active::before {
        opacity: 0.2;
      }
      .v-select.v-select--chips.v-select--chips--small .v-select__selections {
        min-height: 32px;
      }
      .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box .v-select__selections, .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections {
        min-height: 68px;
      }
      .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box.v-select--chips--small .v-select__selections, .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-select--chips--small .v-select__selections {
        min-height: 56px;
      }
      .v-select.v-text-field--reverse .v-select__slot,
      .v-select.v-text-field--reverse .v-select__selections {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: reverse;
            -ms-flex-direction: row-reverse;
                flex-direction: row-reverse;
      }
      .v-select__selections {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        line-height: 18px;
      }
      .v-select__selection {
        max-width: 90%;
      }
      .v-select__selection--comma {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        margin: 7px 4px 7px 0;
      }
      .v-select__slot {
        position: relative;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
      }
      .v-select:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__slot > input {
        -ms-flex-item-align: end;
            align-self: flex-end;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-chip:not(.v-chip--outlined).primary, .v-chip:not(.v-chip--outlined).secondary, .v-chip:not(.v-chip--outlined).accent, .v-chip:not(.v-chip--outlined).success, .v-chip:not(.v-chip--outlined).error, .v-chip:not(.v-chip--outlined).warning, .v-chip:not(.v-chip--outlined).info {
        color: #FFFFFF;
      }
      
      .theme--light.v-chip {
        border-color: rgba(0, 0, 0, 0.12);
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-chip:not(.v-chip--active) {
        background: #e0e0e0;
      }
      .theme--light.v-chip:hover::before {
        opacity: 0.04;
      }
      .theme--light.v-chip:focus::before {
        opacity: 0.12;
      }
      .theme--light.v-chip--active:hover::before, .theme--light.v-chip--active::before {
        opacity: 0.12;
      }
      .theme--light.v-chip--active:focus::before {
        opacity: 0.16;
      }
      
      .theme--dark.v-chip {
        border-color: rgba(255, 255, 255, 0.12);
        color: #FFFFFF;
      }
      .theme--dark.v-chip:not(.v-chip--active) {
        background: #555;
      }
      .theme--dark.v-chip:hover::before {
        opacity: 0.08;
      }
      .theme--dark.v-chip:focus::before {
        opacity: 0.24;
      }
      .theme--dark.v-chip--active:hover::before, .theme--dark.v-chip--active::before {
        opacity: 0.24;
      }
      .theme--dark.v-chip--active:focus::before {
        opacity: 0.32;
      }
      
      .v-chip {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        cursor: default;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        line-height: 20px;
        outline: none;
        padding: 0 12px;
        position: relative;
        text-decoration: none;
        -webkit-transition-duration: 0.28s;
                transition-duration: 0.28s;
        -webkit-transition-property: opacity, -webkit-box-shadow;
        transition-property: opacity, -webkit-box-shadow;
        transition-property: box-shadow, opacity;
        transition-property: box-shadow, opacity, -webkit-box-shadow;
        -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        vertical-align: middle;
      }
      .v-chip:before {
        background-color: currentColor;
        bottom: 0;
        border-radius: inherit;
        content: "";
        left: 0;
        opacity: 0;
        position: absolute;
        pointer-events: none;
        right: 0;
        top: 0;
      }
      .v-chip .v-avatar {
        height: 24px !important;
        min-width: 24px !important;
        width: 24px !important;
      }
      .v-chip .v-icon {
        font-size: 24px;
      }
      .v-chip .v-avatar--left,
      .v-chip .v-icon--left {
        margin-left: -6px;
        margin-right: 8px;
      }
      .v-chip .v-avatar--right,
      .v-chip .v-icon--right {
        margin-left: 8px;
        margin-right: -6px;
      }
      .v-application--is-rtl .v-chip .v-avatar--left,
      .v-application--is-rtl .v-chip .v-icon--left {
        margin-left: 8px;
        margin-right: -6px;
      }
      .v-application--is-rtl .v-chip .v-avatar--right,
      .v-application--is-rtl .v-chip .v-icon--right {
        margin-left: -6px;
        margin-right: 8px;
      }
      .v-chip:not(.v-chip--no-color) .v-icon {
        color: inherit;
      }
      
      .v-chip__close.v-icon {
        font-size: 18px;
        max-height: 18px;
        max-width: 18px;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-chip__close.v-icon.v-icon--right {
        margin-right: -4px;
      }
      .v-application--is-rtl .v-chip__close.v-icon.v-icon--right {
        margin-left: -4px;
        margin-right: 8px;
      }
      .v-chip__close.v-icon:hover, .v-chip__close.v-icon:focus, .v-chip__close.v-icon:active {
        opacity: 0.72;
      }
      
      .v-chip__content {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        height: 100%;
      }
      
      .v-chip--active .v-icon {
        color: inherit;
      }
      
      .v-chip--link::before {
        -webkit-transition: opacity 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: opacity 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-chip--link:focus::before {
        opacity: 0.32;
      }
      
      .v-chip--clickable {
        cursor: pointer;
      }
      .v-chip--clickable:active {
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
      
      .v-chip--disabled {
        opacity: 0.4;
        pointer-events: none;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      
      .v-chip__filter {
        max-width: 24px;
      }
      .v-chip__filter.v-icon {
        color: inherit;
      }
      .v-chip__filter.expand-x-transition-leave-active, .v-chip__filter.expand-x-transition-enter {
        margin: 0;
      }
      
      .v-chip--pill .v-chip__filter {
        margin-right: 0 16px 0 0;
      }
      .v-chip--pill .v-avatar {
        height: 32px !important;
        width: 32px !important;
      }
      .v-chip--pill .v-avatar--left {
        margin-left: -12px;
      }
      .v-chip--pill .v-avatar--right {
        margin-right: -12px;
      }
      .v-application--is-rtl .v-chip--pill .v-avatar--left {
        margin-left: chip-pill-avatar-margin-after;
        margin-right: -12px;
      }
      .v-application--is-rtl .v-chip--pill .v-avatar--right {
        margin-left: -12px;
        margin-right: chip-pill-avatar-margin-after;
      }
      
      .v-chip--label {
        border-radius: 4px !important;
      }
      
      .v-chip.v-chip--outlined {
        border-width: thin;
        border-style: solid;
      }
      .v-chip.v-chip--outlined:not(.v-chip--active):before {
        opacity: 0;
      }
      .v-chip.v-chip--outlined.v-chip--active:before {
        opacity: 0.08;
      }
      .v-chip.v-chip--outlined .v-icon {
        color: inherit;
      }
      .v-chip.v-chip--outlined.v-chip.v-chip {
        background-color: transparent !important;
      }
      
      .v-chip.v-chip--selected {
        background: transparent;
      }
      .v-chip.v-chip--selected:after {
        opacity: 0.28;
      }
      
      .v-chip.v-size--x-small {
        border-radius: 8px;
        font-size: 10px;
        height: 16px;
      }
      .v-chip.v-size--small {
        border-radius: 12px;
        font-size: 12px;
        height: 24px;
      }
      .v-chip.v-size--default {
        border-radius: 16px;
        font-size: 14px;
        height: 32px;
      }
      .v-chip.v-size--large {
        border-radius: 27px;
        font-size: 16px;
        height: 54px;
      }
      .v-chip.v-size--x-large {
        border-radius: 33px;
        font-size: 18px;
        height: 66px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-menu {
        display: block;
        vertical-align: middle;
      }
      .v-menu--inline {
        display: inline-block;
      }
      .v-menu__activator {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .v-menu__activator * {
        cursor: pointer;
      }
      .v-menu__content {
        position: absolute;
        display: inline-block;
        border-radius: 2px;
        max-width: 80%;
        overflow-y: auto;
        overflow-x: hidden;
        contain: content;
        will-change: transform;
        -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
      }
      .v-menu__content--active {
        pointer-events: none;
      }
      .v-menu__content--auto .v-list-item {
        -webkit-transition-property: opacity, -webkit-transform;
        transition-property: opacity, -webkit-transform;
        transition-property: transform, opacity;
        transition-property: transform, opacity, -webkit-transform;
        -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
        -webkit-transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
                transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      .v-menu__content--fixed {
        position: fixed;
      }
      .v-menu__content > .card {
        contain: content;
        -webkit-backface-visibility: hidden;
                backface-visibility: hidden;
      }
      .v-menu > .v-menu__content {
        max-width: none;
      }
      .v-menu-transition-enter .v-list-item {
        min-width: 0;
        pointer-events: none;
      }
      .v-menu-transition-enter-to .v-list-item {
        pointer-events: auto;
        -webkit-transition-delay: 0.1s;
                transition-delay: 0.1s;
      }
      .v-menu-transition-leave-active, .v-menu-transition-leave-to {
        pointer-events: none;
      }
      .v-menu-transition-enter, .v-menu-transition-leave-to {
        opacity: 0;
      }
      .v-menu-transition-enter-active, .v-menu-transition-leave-active {
        -webkit-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      
      .v-menu-transition-enter.v-menu__content--auto {
        -webkit-transition: none !important;
        transition: none !important;
      }
      .v-menu-transition-enter.v-menu__content--auto .v-list-item {
        opacity: 0;
        -webkit-transform: translateY(-15px);
                transform: translateY(-15px);
      }
      .v-menu-transition-enter.v-menu__content--auto .v-list-item--active {
        opacity: 1;
        -webkit-transform: none !important;
                transform: none !important;
        pointer-events: auto;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-card {
        background-color: #FFFFFF;
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-card .v-card__text {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-card.v-card--outlined {
        border: 1px solid rgba(0, 0, 0, 0.12);
      }
      
      .theme--dark.v-card {
        background-color: #424242;
        color: #FFFFFF;
      }
      .theme--dark.v-card .v-card__text {
        color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-card.v-card--outlined {
        border: 1px solid rgba(255, 255, 255, 0.12);
      }
      
      .v-card {
        max-width: 100%;
        outline: none;
        text-decoration: none;
        -webkit-transition-property: opacity, -webkit-box-shadow;
        transition-property: opacity, -webkit-box-shadow;
        transition-property: box-shadow, opacity;
        transition-property: box-shadow, opacity, -webkit-box-shadow;
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
      .v-card > *:first-child:not(.v-btn):not(.v-chip),
      .v-card > .v-card__progress + *:not(.v-btn):not(.v-chip) {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
      }
      .v-card > *:last-child:not(.v-btn):not(.v-chip) {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
      }
      
      .v-card__progress {
        top: 0;
        left: 0;
        right: 0;
        overflow: hidden;
      }
      
      .v-card__title {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        font-size: 1.5rem;
        font-weight: 400;
        letter-spacing: normal;
        line-height: 2rem;
        padding: 16px 16px 8px;
      }
      .v-card__title + .v-card__text {
        padding-top: 0;
      }
      
      .v-card__text {
        font-size: 0.875rem;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
        padding: 16px;
        width: 100%;
      }
      
      .v-card__actions {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding: 8px;
      }
      .v-card__actions .v-btn.v-size--default {
        padding: 0 8px;
      }
      .v-card__actions .v-btn.v-size--default + .v-btn {
        margin-left: 8px;
      }
      .v-application--is-rtl .v-card__actions .v-btn.v-size--default + .v-btn {
        margin-left: 0;
        margin-right: 8px;
      }
      
      .v-card--flat {
        -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
      }
      
      .v-card--hover {
        cursor: pointer;
        -webkit-transition: -webkit-box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: -webkit-box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), -webkit-box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      .v-card--hover:hover {
        -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
      }
      
      .v-card--link {
        cursor: pointer;
      }
      .v-card--link .v-chip {
        cursor: pointer;
      }
      .v-card--link:focus:before {
        opacity: 0.08;
      }
      .v-card--link:before {
        background: currentColor;
        bottom: 0;
        content: "";
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transition: 0.2s opacity;
        transition: 0.2s opacity;
      }
      
      .v-card--disabled {
        pointer-events: none;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-card--disabled > *:not(.v-card__progress) {
        opacity: 0.6;
        -webkit-transition: inherit;
        transition: inherit;
      }
      
      .v-card--loading {
        overflow: hidden;
      }
      
      .v-card--outlined {
        -webkit-box-shadow: none;
                box-shadow: none;
      }
      
      .v-card--raised {
        -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-simple-checkbox {
        -ms-flex-item-align: center;
            align-self: center;
        line-height: normal;
        position: relative;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        cursor: pointer;
      }
      
      .v-simple-checkbox--disabled {
        cursor: default;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-divider {
        border-color: rgba(0, 0, 0, 0.12);
      }
      
      .theme--dark.v-divider {
        border-color: rgba(255, 255, 255, 0.12);
      }
      
      .v-divider {
        display: block;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 0px;
                flex: 1 1 0px;
        max-width: 100%;
        height: 0px;
        max-height: 0px;
        border: solid;
        border-width: thin 0 0 0;
        -webkit-transition: inherit;
        transition: inherit;
      }
      .v-divider--inset:not(.v-divider--vertical) {
        margin-left: 72px;
        max-width: calc(100% - 72px);
      }
      .v-divider--vertical {
        -ms-flex-item-align: stretch;
            align-self: stretch;
        border: solid;
        border-width: 0 thin 0 0;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        height: inherit;
        min-height: 100%;
        max-height: 100%;
        max-width: 0px;
        width: 0px;
        vertical-align: text-bottom;
      }
      .v-divider--vertical.v-divider--inset {
        margin-top: 8px;
        min-height: 0;
        max-height: calc(100% - 16px);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-subheader {
        color: rgba(0, 0, 0, 0.54);
      }
      
      .theme--dark.v-subheader {
        color: rgba(255, 255, 255, 0.7);
      }
      
      .v-subheader {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 48px;
        font-size: 0.875rem;
        font-weight: 400;
        padding: 0 16px 0 16px;
      }
      .v-subheader--inset {
        margin-left: 56px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-list.primary > .v-list-item, .v-list.secondary > .v-list-item, .v-list.accent > .v-list-item, .v-list.success > .v-list-item, .v-list.error > .v-list-item, .v-list.warning > .v-list-item, .v-list.info > .v-list-item {
        color: #FFFFFF;
      }
      
      .theme--light.v-list {
        background: #FFFFFF;
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-list .v-list--disabled {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-list .v-list-group--active:before,
      .theme--light.v-list .v-list-group--active:after {
        background: rgba(0, 0, 0, 0.12);
      }
      
      .theme--dark.v-list {
        background: #424242;
        color: #FFFFFF;
      }
      .theme--dark.v-list .v-list--disabled {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-list .v-list-group--active:before,
      .theme--dark.v-list .v-list-group--active:after {
        background: rgba(255, 255, 255, 0.12);
      }
      
      .v-list {
        padding: 8px 0;
      }
      .v-list.v-sheet {
        position: static;
      }
      
      .v-list--disabled {
        pointer-events: none;
      }
      
      .v-list--flat .v-list-item:before {
        display: none;
      }
      
      .v-list--dense .v-subheader {
        font-size: 0.75rem;
        height: 40px;
        padding: 0 8px;
      }
      
      .v-list--nav .v-list-item:not(:last-child):not(:only-child),
      .v-list--rounded .v-list-item:not(:last-child):not(:only-child) {
        margin-bottom: 8px;
      }
      .v-list--nav.v-list--dense .v-list-item:not(:last-child):not(:only-child),
      .v-list--nav .v-list-item--dense:not(:last-child):not(:only-child),
      .v-list--rounded.v-list--dense .v-list-item:not(:last-child):not(:only-child),
      .v-list--rounded .v-list-item--dense:not(:last-child):not(:only-child) {
        margin-bottom: 4px;
      }
      
      .v-list--nav {
        padding-left: 8px;
        padding-right: 8px;
      }
      .v-list--nav .v-list-item {
        padding: 0 8px;
      }
      .v-list--nav .v-list-item,
      .v-list--nav .v-list-item:before {
        border-radius: 4px;
      }
      
      .v-list--shaped {
        padding-right: 8px;
      }
      .v-list--shaped .v-list-item,
      .v-list--shaped .v-list-item:before,
      .v-list--shaped .v-ripple__container {
        border-bottom-right-radius: 32px !important;
        border-top-right-radius: 32px !important;
      }
      .v-list--shaped.v-list--two-line .v-list-item,
      .v-list--shaped.v-list--two-line .v-list-item:before,
      .v-list--shaped.v-list--two-line .v-ripple__container {
        border-bottom-right-radius: 42.6666666667px !important;
        border-top-right-radius: 42.6666666667px !important;
      }
      .v-list--shaped.v-list--three-line .v-list-item,
      .v-list--shaped.v-list--three-line .v-list-item:before,
      .v-list--shaped.v-list--three-line .v-ripple__container {
        border-bottom-right-radius: 58.6666666667px !important;
        border-top-right-radius: 58.6666666667px !important;
      }
      .v-application--is-rtl .v-list--shaped {
        padding-left: 8px;
        padding-right: 0;
      }
      
      .v-list--rounded {
        padding: 8px;
      }
      .v-list--rounded .v-list-item,
      .v-list--rounded .v-list-item:before,
      .v-list--rounded .v-ripple__container {
        border-radius: 32px !important;
      }
      .v-list--rounded.v-list--two-line .v-list-item,
      .v-list--rounded.v-list--two-line .v-list-item:before,
      .v-list--rounded.v-list--two-line .v-ripple__container {
        border-radius: 42.6666666667px !important;
      }
      .v-list--rounded.v-list--three-line .v-list-item,
      .v-list--rounded.v-list--three-line .v-list-item:before,
      .v-list--rounded.v-list--three-line .v-ripple__container {
        border-radius: 58.6666666667px !important;
      }
      
      .v-list--subheader {
        padding-top: 0;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-list-group .v-list-item__icon.v-list-group__header__append-icon {
        min-width: 48px;
        -webkit-box-pack: end;
            -ms-flex-pack: end;
                justify-content: flex-end;
        margin-left: 0;
      }
      
      .v-list-group--sub-group {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
      }
      
      .v-list-group__header.v-list-item--active:not(:hover):not(:focus):before {
        display: none;
      }
      
      .v-list-group__items {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
      }
      
      .v-list-group--active > .v-list-group__header > .v-list-group__header__append-icon .v-icon {
        -webkit-transform: rotate(-180deg);
                transform: rotate(-180deg);
      }
      .v-list-group--active > .v-list-group__header.v-list-group__header--sub-group > .v-list-group__header__prepend-icon .v-icon {
        -webkit-transform: rotate(-180deg);
                transform: rotate(-180deg);
      }
      .v-list-group--active > .v-list-group__header .v-list-item,
      .v-list-group--active > .v-list-group__header .v-list-item__content,
      .v-list-group--active > .v-list-group__header .v-list-group__header__prepend-icon .v-icon {
        color: inherit;
      }
      
      .v-application--is-ltr .v-list-group--sub-group .v-list-item__action:first-child,
      .v-application--is-ltr .v-list-group--sub-group .v-list-item__avatar:first-child,
      .v-application--is-ltr .v-list-group--sub-group .v-list-item__icon:first-child {
        margin-right: 16px;
      }
      .v-application--is-rtl .v-list-group--sub-group .v-list-item__action:first-child,
      .v-application--is-rtl .v-list-group--sub-group .v-list-item__avatar:first-child,
      .v-application--is-rtl .v-list-group--sub-group .v-list-item__icon:first-child {
        margin-left: 16px;
      }
      .v-application--is-ltr .v-list-group--sub-group .v-list-group__header {
        padding-left: 32px;
      }
      .v-application--is-rtl .v-list-group--sub-group .v-list-group__header {
        padding-right: 32px;
      }
      .v-application--is-ltr .v-list-group--sub-group .v-list-group__items .v-list-item {
        padding-left: 40px;
      }
      .v-application--is-rtl .v-list-group--sub-group .v-list-group__items .v-list-item {
        padding-right: 40px;
      }
      .v-list-group--sub-group.v-list-group--active .v-list-item__icon.v-list-group__header__prepend-icon .v-icon {
        -webkit-transform: rotate(-180deg);
                transform: rotate(-180deg);
      }
      
      .v-application--is-ltr .v-list-group--no-action > .v-list-group__items > div > .v-list-item {
        padding-left: 72px;
      }
      .v-application--is-rtl .v-list-group--no-action > .v-list-group__items > div > .v-list-item {
        padding-right: 72px;
      }
      .v-application--is-ltr .v-list-group--no-action.v-list-group--sub-group > .v-list-group__items > div > .v-list-item {
        padding-left: 88px;
      }
      .v-application--is-rtl .v-list-group--no-action.v-list-group--sub-group > .v-list-group__items > div > .v-list-item {
        padding-right: 88px;
      }
      
      .v-application--is-ltr .v-list--dense .v-list-group--sub-group .v-list-group__header {
        padding-left: 24px;
      }
      .v-application--is-rtl .v-list--dense .v-list-group--sub-group .v-list-group__header {
        padding-right: 24px;
      }
      .v-application--is-ltr .v-list--dense .v-list-group--no-action > .v-list-group__items > div > .v-list-item {
        padding-left: 64px;
      }
      .v-application--is-rtl .v-list--dense .v-list-group--no-action > .v-list-group__items > div > .v-list-item {
        padding-right: 64px;
      }
      .v-application--is-ltr .v-list--dense .v-list-group--no-action.v-list-group--sub-group > .v-list-group__items > div > .v-list-item {
        padding-left: 80px;
      }
      .v-application--is-rtl .v-list--dense .v-list-group--no-action.v-list-group--sub-group > .v-list-group__items > div > .v-list-item {
        padding-right: 80px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-list-item--disabled {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
        color: rgba(0, 0, 0, 0.87) !important;
      }
      .theme--light.v-list-item .v-list-item__mask {
        color: rgba(0, 0, 0, 0.38);
        background: #eeeeee;
      }
      .theme--light.v-list-item .v-list-item__subtitle,
      .theme--light.v-list-item .v-list-item__action-text {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-list-item:hover::before {
        opacity: 0.04;
      }
      .theme--light.v-list-item:focus::before {
        opacity: 0.12;
      }
      .theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before {
        opacity: 0.12;
      }
      .theme--light.v-list-item--active:focus::before {
        opacity: 0.16;
      }
      .theme--light.v-list-item.v-list-item--highlighted::before {
        opacity: 0.16;
      }
      
      .theme--dark.v-list-item--disabled {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
        color: #FFFFFF !important;
      }
      .theme--dark.v-list-item .v-list-item__mask {
        color: rgba(255, 255, 255, 0.5);
        background: #494949;
      }
      .theme--dark.v-list-item .v-list-item__subtitle,
      .theme--dark.v-list-item .v-list-item__action-text {
        color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-list-item:hover::before {
        opacity: 0.08;
      }
      .theme--dark.v-list-item:focus::before {
        opacity: 0.24;
      }
      .theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before {
        opacity: 0.24;
      }
      .theme--dark.v-list-item--active:focus::before {
        opacity: 0.32;
      }
      .theme--dark.v-list-item.v-list-item--highlighted::before {
        opacity: 0.32;
      }
      
      .v-list-item {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 100%;
                flex: 1 1 100%;
        letter-spacing: normal;
        min-height: 48px;
        outline: none;
        padding: 0 16px;
        position: relative;
        text-decoration: none;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-list-item--disabled {
        pointer-events: none;
      }
      
      .v-list-item__action {
        -ms-flex-item-align: center;
            align-self: center;
        margin: 12px 0;
      }
      .v-list-item__action .v-input,
      .v-list-item__action .v-input__control,
      .v-list-item__action .v-input__slot,
      .v-list-item__action .v-input--selection-controls__input {
        margin: 0 !important;
      }
      .v-list-item__action .v-input {
        padding: 0;
      }
      .v-list-item__action .v-input .v-messages {
        display: none;
      }
      
      .v-list-item__action-text {
        font-size: 0.75rem;
      }
      
      .v-list-item__avatar {
        -ms-flex-item-align: center;
            align-self: center;
        -webkit-box-pack: start;
            -ms-flex-pack: start;
                justify-content: flex-start;
        margin-bottom: 8px;
        margin-top: 8px;
      }
      .v-list-item__avatar.v-list-item__avatar--horizontal {
        margin-bottom: 8px;
        margin-top: 8px;
      }
      .v-list-item__avatar.v-list-item__avatar--horizontal:first-child {
        margin-left: -16px;
      }
      .v-list-item__avatar.v-list-item__avatar--horizontal:last-child {
        margin-left: -16px;
      }
      
      .v-list-item__content {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -ms-flex-item-align: center;
            align-self: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        -webkit-box-flex: 1;
            -ms-flex: 1 1;
                flex: 1 1;
        overflow: hidden;
        padding: 12px 0;
      }
      .v-list-item__content > * {
        line-height: 1.1;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 100%;
                flex: 1 0 100%;
      }
      .v-list-item__content > *:not(:last-child) {
        margin-bottom: 2px;
      }
      
      .v-list-item__icon {
        -ms-flex-item-align: start;
            align-self: flex-start;
        margin: 16px 0;
      }
      
      .v-list-item__action:last-of-type:not(:only-child),
      .v-list-item__avatar:last-of-type:not(:only-child),
      .v-list-item__icon:last-of-type:not(:only-child) {
        margin-left: 16px;
      }
      
      .v-application--is-ltr .v-list-item__avatar:first-child {
        margin-right: 24px;
      }
      .v-application--is-rtl .v-list-item__avatar:first-child {
        margin-left: 24px;
      }
      
      .v-application--is-ltr .v-list-item__action:first-child,
      .v-application--is-ltr .v-list-item__icon:first-child {
        margin-right: 32px;
      }
      .v-application--is-rtl .v-list-item__action:first-child,
      .v-application--is-rtl .v-list-item__icon:first-child {
        margin-left: 32px;
      }
      
      .v-list-item__action,
      .v-list-item__avatar,
      .v-list-item__icon {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        min-width: 24px;
      }
      
      .v-list-item .v-list-item__title,
      .v-list-item .v-list-item__subtitle {
        line-height: 1.2;
      }
      
      .v-list-item__title,
      .v-list-item__subtitle {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 100%;
                flex: 1 1 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      
      .v-list-item__title {
        -ms-flex-item-align: center;
            align-self: center;
        font-size: 1rem;
      }
      .v-list-item__title > .v-badge {
        margin-top: 16px;
      }
      
      .v-list-item__subtitle {
        font-size: 0.875rem;
      }
      
      .v-list-item--dense,
      .v-list--dense .v-list-item {
        min-height: 40px;
      }
      .v-list-item--dense .v-list-item__icon,
      .v-list--dense .v-list-item .v-list-item__icon {
        margin-top: 8px;
        margin-bottom: 8px;
      }
      .v-list-item--dense .v-list-item__content,
      .v-list--dense .v-list-item .v-list-item__content {
        padding: 8px 0;
      }
      .v-list-item--dense .v-list-item__title,
      .v-list-item--dense .v-list-item__subtitle,
      .v-list--dense .v-list-item .v-list-item__title,
      .v-list--dense .v-list-item .v-list-item__subtitle {
        font-size: 0.8125rem;
        font-weight: 500;
        line-height: 1rem;
      }
      .v-list-item--dense.v-list-item--two-line,
      .v-list--dense .v-list-item.v-list-item--two-line {
        min-height: 60px;
      }
      .v-list-item--dense.v-list-item--three-line,
      .v-list--dense .v-list-item.v-list-item--three-line {
        min-height: 76px;
      }
      
      .v-list-item--link {
        cursor: pointer;
      }
      .v-list-item--link:before {
        background-color: currentColor;
        bottom: 0;
        content: "";
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      
      .v-list-item--active .v-icon {
        color: inherit;
      }
      
      .v-list-item__action--stack {
        -webkit-box-align: end;
            -ms-flex-align: end;
                align-items: flex-end;
        -ms-flex-item-align: stretch;
            align-self: stretch;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        white-space: nowrap;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
      }
      
      .v-list--two-line .v-list-item .v-list-item__avatar:not(.v-list-item__avatar--horizontal),
      .v-list--two-line .v-list-item .v-list-item__icon,
      .v-list--three-line .v-list-item .v-list-item__avatar:not(.v-list-item__avatar--horizontal),
      .v-list--three-line .v-list-item .v-list-item__icon,
      .v-list-item--two-line .v-list-item__avatar:not(.v-list-item__avatar--horizontal),
      .v-list-item--two-line .v-list-item__icon,
      .v-list-item--three-line .v-list-item__avatar:not(.v-list-item__avatar--horizontal),
      .v-list-item--three-line .v-list-item__icon {
        margin-bottom: 16px;
        margin-top: 16px;
      }
      
      .v-list--two-line .v-list-item,
      .v-list-item--two-line {
        min-height: 64px;
      }
      .v-list--two-line .v-list-item .v-list-item__icon,
      .v-list-item--two-line .v-list-item__icon {
        margin-bottom: 32px;
      }
      
      .v-list--three-line .v-list-item,
      .v-list-item--three-line {
        min-height: 88px;
      }
      .v-list--three-line .v-list-item .v-list-item__avatar,
      .v-list--three-line .v-list-item .v-list-item__action,
      .v-list-item--three-line .v-list-item__avatar,
      .v-list-item--three-line .v-list-item__action {
        -ms-flex-item-align: start;
            align-self: flex-start;
        margin-top: 16px;
        margin-bottom: 16px;
      }
      .v-list--three-line .v-list-item .v-list-item__content,
      .v-list-item--three-line .v-list-item__content {
        -ms-flex-item-align: stretch;
            align-self: stretch;
      }
      .v-list--three-line .v-list-item .v-list-item__subtitle,
      .v-list-item--three-line .v-list-item__subtitle {
        white-space: initial;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-list-item-group .v-list-item--active {
        color: inherit;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-item-group {
        -webkit-box-flex: 0;
            -ms-flex: 0 1 auto;
                flex: 0 1 auto;
        position: relative;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-avatar {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        border-radius: 50%;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        line-height: normal;
        position: relative;
        text-align: center;
        vertical-align: middle;
      }
      .v-avatar img,
      .v-avatar .v-icon,
      .v-avatar .v-image,
      .v-avatar .v-responsive__content {
        border-radius: inherit;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        height: inherit;
        width: inherit;
      }
      .v-avatar--tile {
        border-radius: 0;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      /* Theme */
      .theme--light.v-input:not(.v-input--is-disabled) input,
      .theme--light.v-input:not(.v-input--is-disabled) textarea {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-input input::-webkit-input-placeholder,
      .theme--light.v-input textarea::-webkit-input-placeholder {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-input input::-moz-placeholder,
      .theme--light.v-input textarea::-moz-placeholder {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-input input:-ms-input-placeholder,
      .theme--light.v-input textarea:-ms-input-placeholder {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-input input::-ms-input-placeholder,
      .theme--light.v-input textarea::-ms-input-placeholder {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-input input::placeholder,
      .theme--light.v-input textarea::placeholder {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-input--is-disabled .v-label,
      .theme--light.v-input--is-disabled input,
      .theme--light.v-input--is-disabled textarea {
        color: rgba(0, 0, 0, 0.38);
      }
      
      .theme--dark.v-input:not(.v-input--is-disabled) input,
      .theme--dark.v-input:not(.v-input--is-disabled) textarea {
        color: #FFFFFF;
      }
      .theme--dark.v-input input::-webkit-input-placeholder,
      .theme--dark.v-input textarea::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-input input::-moz-placeholder,
      .theme--dark.v-input textarea::-moz-placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-input input:-ms-input-placeholder,
      .theme--dark.v-input textarea:-ms-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-input input::-ms-input-placeholder,
      .theme--dark.v-input textarea::-ms-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-input input::placeholder,
      .theme--dark.v-input textarea::placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-input--is-disabled .v-label,
      .theme--dark.v-input--is-disabled input,
      .theme--dark.v-input--is-disabled textarea {
        color: rgba(255, 255, 255, 0.5);
      }
      
      .v-input {
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        font-size: 16px;
        letter-spacing: normal;
        text-align: left;
      }
      .v-input .v-progress-linear {
        top: calc(100% - 1px);
        left: 0;
      }
      .v-input input {
        max-height: 32px;
      }
      .v-input input:invalid,
      .v-input textarea:invalid {
        -webkit-box-shadow: none;
                box-shadow: none;
      }
      .v-input input:focus, .v-input input:active,
      .v-input textarea:focus,
      .v-input textarea:active {
        outline: none;
      }
      .v-input .v-label {
        height: 20px;
        line-height: 20px;
      }
      .v-input__append-outer, .v-input__prepend-outer {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        margin-bottom: 4px;
        margin-top: 4px;
        line-height: 1;
      }
      .v-input__append-outer .v-icon, .v-input__prepend-outer .v-icon {
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-input__append-outer {
        margin-left: 9px;
      }
      .v-input__prepend-outer {
        margin-right: 9px;
      }
      .v-input__control {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        height: auto;
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        width: 100%;
      }
      .v-input__icon {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        height: 24px;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        min-width: 24px;
        width: 24px;
      }
      .v-input__icon--clear {
        border-radius: 50%;
      }
      .v-input__slot {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        color: inherit;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin-bottom: 8px;
        min-height: inherit;
        position: relative;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        width: 100%;
      }
      .v-input--is-disabled:not(.v-input--is-readonly) {
        pointer-events: none;
      }
      .v-input--is-loading > .v-input__control > .v-input__slot:before, .v-input--is-loading > .v-input__control > .v-input__slot:after {
        display: none;
      }
      .v-input--hide-details > .v-input__control > .v-input__slot {
        margin-bottom: 0;
      }
      .v-input--has-state.error--text .v-label {
        -webkit-animation: v-shake 0.6s cubic-bezier(0.25, 0.8, 0.5, 1);
                animation: v-shake 0.6s cubic-bezier(0.25, 0.8, 0.5, 1);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-label {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-label--is-disabled {
        color: rgba(0, 0, 0, 0.38);
      }
      
      .theme--dark.v-label {
        color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-label--is-disabled {
        color: rgba(255, 255, 255, 0.5);
      }
      
      .v-label {
        font-size: 16px;
        line-height: 1;
        min-height: 8px;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      /* Theme */
      .theme--light.v-messages {
        color: rgba(0, 0, 0, 0.54);
      }
      
      .theme--dark.v-messages {
        color: rgba(255, 255, 255, 0.7);
      }
      
      .v-messages {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        font-size: 12px;
        min-height: 14px;
        min-width: 1px;
        position: relative;
      }
      .v-application--is-rtl .v-messages {
        text-align: right;
      }
      .v-messages__message {
        line-height: normal;
        word-break: break-word;
        overflow-wrap: break-word;
        word-wrap: break-word;
        -webkit-hyphens: auto;
            -ms-hyphens: auto;
                hyphens: auto;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      /* Theme */
      .theme--light.v-counter {
        color: rgba(0, 0, 0, 0.54);
      }
      
      .theme--dark.v-counter {
        color: rgba(255, 255, 255, 0.7);
      }
      
      .v-counter {
        -webkit-box-flex: 0;
            -ms-flex: 0 1 auto;
                flex: 0 1 auto;
        font-size: 12px;
        min-height: 12px;
        line-height: 1;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-progress-linear {
        color: rgba(0, 0, 0, 0.87);
      }
      
      .theme--dark.v-progress-linear {
        color: #FFFFFF;
      }
      
      .v-progress-linear {
        background: transparent;
        overflow: hidden;
        position: relative;
        -webkit-transition: 0.2s;
        transition: 0.2s;
        width: 100%;
      }
      
      .v-progress-linear__buffer {
        height: inherit;
        left: 0;
        position: absolute;
        top: 0;
        -webkit-transition: inherit;
        transition: inherit;
        width: 100%;
        z-index: 1;
      }
      
      .v-progress-linear__background {
        bottom: 0;
        left: 0;
        position: absolute;
        top: 0;
        -webkit-transition: inherit;
        transition: inherit;
      }
      
      .v-progress-linear__content {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 100%;
        left: 0;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 2;
      }
      
      .v-progress-linear__determinate {
        height: inherit;
        -webkit-transition: inherit;
        transition: inherit;
      }
      
      .v-progress-linear__indeterminate .long, .v-progress-linear__indeterminate .short {
        background-color: inherit;
        bottom: 0;
        height: inherit;
        left: 0;
        position: absolute;
        top: 0;
        width: auto;
        will-change: left, right;
      }
      .v-progress-linear__indeterminate--active .long {
        -webkit-animation: indeterminate;
                animation: indeterminate;
        -webkit-animation-duration: 2.2s;
                animation-duration: 2.2s;
        -webkit-animation-iteration-count: infinite;
                animation-iteration-count: infinite;
      }
      .v-progress-linear__indeterminate--active .short {
        -webkit-animation: indeterminate-short;
                animation: indeterminate-short;
        -webkit-animation-duration: 2.2s;
                animation-duration: 2.2s;
        -webkit-animation-iteration-count: infinite;
                animation-iteration-count: infinite;
      }
      
      .v-progress-linear__stream {
        -webkit-animation: stream 0.25s infinite linear;
                animation: stream 0.25s infinite linear;
        border-color: currentColor;
        border-top: 4px dotted;
        bottom: 0;
        opacity: 0.3;
        pointer-events: none;
        position: absolute;
        right: -8px;
        top: calc(50% - 2px);
        -webkit-transition: inherit;
        transition: inherit;
      }
      
      .v-progress-linear__wrapper {
        overflow: hidden;
        position: relative;
        -webkit-transition: inherit;
        transition: inherit;
      }
      
      .v-progress-linear--absolute,
      .v-progress-linear--fixed {
        left: 0;
        z-index: 1;
      }
      
      .v-progress-linear--absolute {
        position: absolute;
      }
      
      .v-progress-linear--fixed {
        position: fixed;
      }
      
      .v-progress-linear--reactive .v-progress-linear__content {
        pointer-events: none;
      }
      
      .v-progress-linear--rounded {
        border-radius: 4px;
      }
      
      .v-progress-linear--striped .v-progress-linear__determinate {
        background-image: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 25%, transparent 0, transparent 50%, rgba(255, 255, 255, 0.25) 0, rgba(255, 255, 255, 0.25) 75%, transparent 0, transparent);
        background-size: 40px 40px;
        background-repeat: repeat-x;
      }
      
      .v-progress-linear--query .v-progress-linear__indeterminate--active .long {
        -webkit-animation: query;
                animation: query;
        -webkit-animation-duration: 2s;
                animation-duration: 2s;
        -webkit-animation-iteration-count: infinite;
                animation-iteration-count: infinite;
      }
      .v-progress-linear--query .v-progress-linear__indeterminate--active .short {
        -webkit-animation: query-short;
                animation: query-short;
        -webkit-animation-duration: 2s;
                animation-duration: 2s;
        -webkit-animation-iteration-count: infinite;
                animation-iteration-count: infinite;
      }
      
      @-webkit-keyframes indeterminate {
        0% {
          left: -90%;
          right: 100%;
        }
        60% {
          left: -90%;
          right: 100%;
        }
        100% {
          left: 100%;
          right: -35%;
        }
      }
      
      @keyframes indeterminate {
        0% {
          left: -90%;
          right: 100%;
        }
        60% {
          left: -90%;
          right: 100%;
        }
        100% {
          left: 100%;
          right: -35%;
        }
      }
      @-webkit-keyframes indeterminate-short {
        0% {
          left: -200%;
          right: 100%;
        }
        60% {
          left: 107%;
          right: -8%;
        }
        100% {
          left: 107%;
          right: -8%;
        }
      }
      @keyframes indeterminate-short {
        0% {
          left: -200%;
          right: 100%;
        }
        60% {
          left: 107%;
          right: -8%;
        }
        100% {
          left: 107%;
          right: -8%;
        }
      }
      @-webkit-keyframes query {
        0% {
          right: -90%;
          left: 100%;
        }
        60% {
          right: -90%;
          left: 100%;
        }
        100% {
          right: 100%;
          left: -35%;
        }
      }
      @keyframes query {
        0% {
          right: -90%;
          left: 100%;
        }
        60% {
          right: -90%;
          left: 100%;
        }
        100% {
          right: 100%;
          left: -35%;
        }
      }
      @-webkit-keyframes query-short {
        0% {
          right: -200%;
          left: 100%;
        }
        60% {
          right: 107%;
          left: -8%;
        }
        100% {
          right: 107%;
          left: -8%;
        }
      }
      @keyframes query-short {
        0% {
          right: -200%;
          left: 100%;
        }
        60% {
          right: 107%;
          left: -8%;
        }
        100% {
          right: 107%;
          left: -8%;
        }
      }
      @-webkit-keyframes stream {
        to {
          -webkit-transform: translateX(-8px);
                  transform: translateX(-8px);
        }
      }
      @keyframes stream {
        to {
          -webkit-transform: translateX(-8px);
                  transform: translateX(-8px);
        }
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-badge {
        display: inline-block;
        line-height: 1;
        position: relative;
      }
      .v-badge__badge {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        border-radius: 11px;
        color: #FFFFFF;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        font-size: 14px;
        height: 22px;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        line-height: normal;
        min-width: 22px;
        padding: 0 4px;
        position: absolute;
        right: -22px;
        top: -11px;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-badge__badge .v-icon {
        font-size: 14px;
      }
      .v-badge--overlap .v-badge__badge {
        top: -8px;
        right: -8px;
      }
      .v-badge--overlap.v-badge--left .v-badge__badge {
        left: -8px;
        right: initial;
      }
      .v-badge--overlap.v-badge--bottom .v-badge__badge {
        bottom: -8px;
        top: initial;
      }
      .v-badge--left .v-badge__badge {
        left: -22px;
        right: initial;
      }
      .v-badge--bottom .v-badge__badge {
        bottom: -11px;
        top: initial;
      }
      .v-application--is-rtl .v-badge__badge {
        right: initial;
        left: -22px;
      }
      .v-application--is-rtl .v-badge--overlap .v-badge__badge {
        right: initial;
        left: -8px;
      }
      .v-application--is-rtl .v-badge--overlap.v-badge--left .v-badge__badge {
        right: -8px;
        left: initial;
      }
      .v-application--is-rtl .v-badge--left .v-badge__badge {
        right: -22px;
        left: initial;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-banner .v-banner__wrapper {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }
      
      .theme--dark.v-banner .v-banner__wrapper {
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
      }
      
      .v-banner__actions {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -ms-flex-item-align: end;
            align-self: flex-end;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        -webkit-box-pack: end;
            -ms-flex-pack: end;
                justify-content: flex-end;
        margin-left: 90px;
        margin-bottom: -8px;
      }
      .v-banner__actions > * {
        margin-left: 8px;
      }
      .v-application--is-rtl .v-banner__actions > * {
        margin-left: 0;
        margin-right: 8px;
      }
      .v-application--is-rtl .v-banner__actions {
        margin-left: 0;
        margin-right: 90px;
      }
      
      .v-banner__content {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        overflow: hidden;
      }
      
      .v-banner__text {
        line-height: 20px;
      }
      
      .v-banner__icon {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        margin-right: 24px;
        -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
                flex: 0 0 auto;
      }
      .v-application--is-rtl .v-banner__icon {
        margin-left: 24px;
        margin-right: 0;
      }
      
      .v-banner__wrapper {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        padding: 16px 8px 16px 24px;
      }
      .v-application--is-rtl .v-banner__wrapper {
        padding-right: 24px;
        padding-left: 8px;
      }
      
      .v-banner--single-line .v-banner__actions {
        margin-bottom: 0;
      }
      .v-banner--single-line .v-banner__text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .v-banner--single-line .v-banner__wrapper {
        padding-top: 8px;
        padding-bottom: 8px;
      }
      
      .v-banner--has-icon .v-banner__wrapper {
        padding-left: 16px;
      }
      .v-application--is-rtl .v-banner--has-icon .v-banner__wrapper {
        padding-left: 8px;
        padding-right: 16px;
      }
      
      .v-banner--is-mobile .v-banner__actions {
        -webkit-box-flex: 1;
            -ms-flex: 1 0 100%;
                flex: 1 0 100%;
        margin-left: 0;
        margin-right: 0;
        padding-top: 12px;
      }
      .v-banner--is-mobile .v-banner__wrapper {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        padding-left: 16px;
        padding-top: 16px;
      }
      .v-application--is-rtl .v-banner--is-mobile .v-banner__wrapper {
        padding-left: 0;
        padding-right: 16px;
      }
      .v-banner--is-mobile.v-banner--has-icon .v-banner__wrapper {
        padding-top: 24px;
      }
      .v-banner--is-mobile.v-banner--single-line .v-banner__actions {
        -webkit-box-flex: initial;
            -ms-flex: initial;
                flex: initial;
        margin-left: 36px;
        padding-top: 0;
      }
      .v-application--is-rtl .v-banner--is-mobile.v-banner--single-line .v-banner__actions {
        margin-left: 0;
        margin-right: 36px;
      }
      .v-banner--is-mobile.v-banner--single-line .v-banner__wrapper {
        -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
        padding-top: 10px;
      }
      .v-banner--is-mobile .v-banner__icon {
        margin-right: 16px;
      }
      .v-application--is-rtl .v-banner--is-mobile .v-banner__icon {
        margin-right: 0;
        margin-left: 16px;
      }
      .v-banner--is-mobile .v-banner__content {
        padding-right: 8px;
      }
      .v-application--is-rtl .v-banner--is-mobile .v-banner__content {
        padding-left: 8px;
        padding-right: 0;
      }
      .v-banner--is-mobile .v-banner__content .v-banner__wrapper {
        -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
        padding-top: 10px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-bottom-navigation {
        background-color: #FFFFFF;
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-bottom-navigation .v-btn:not(.v-btn--active) {
        color: rgba(0, 0, 0, 0.54) !important;
      }
      
      .theme--dark.v-bottom-navigation {
        background-color: #424242;
        color: #FFFFFF;
      }
      .theme--dark.v-bottom-navigation .v-btn:not(.v-btn--active) {
        color: rgba(255, 255, 255, 0.7) !important;
      }
      
      .v-item-group.v-bottom-navigation {
        bottom: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        left: 0;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        width: 100%;
        -webkit-box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
      }
      .v-item-group.v-bottom-navigation .v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: transparent;
      }
      .v-item-group.v-bottom-navigation .v-btn {
        border-radius: 0;
        -webkit-box-shadow: none;
                box-shadow: none;
        -webkit-box-flex: 0;
            -ms-flex: 0 1 auto;
                flex: 0 1 auto;
        font-size: 0.75rem;
        height: inherit;
        max-width: 168px;
        min-width: 80px;
        position: relative;
        text-transform: none;
      }
      .v-item-group.v-bottom-navigation .v-btn:after {
        content: none;
      }
      .v-item-group.v-bottom-navigation .v-btn .v-btn__content {
        -webkit-box-orient: vertical;
        -webkit-box-direction: reverse;
            -ms-flex-direction: column-reverse;
                flex-direction: column-reverse;
        height: inherit;
        opacity: 0.7;
      }
      .v-item-group.v-bottom-navigation .v-btn .v-btn__content .v-icon {
        margin-bottom: 4px;
      }
      .v-item-group.v-bottom-navigation .v-btn .v-btn__content > *:not(.v-icon) {
        line-height: 1.2;
      }
      .v-item-group.v-bottom-navigation .v-btn.v-btn--active {
        color: inherit;
      }
      .v-item-group.v-bottom-navigation .v-btn.v-btn--active:not(:hover):before {
        opacity: 0;
      }
      .v-item-group.v-bottom-navigation .v-btn.v-btn--active .v-btn__content {
        opacity: 1;
      }
      
      .v-item-group.v-bottom-navigation--absolute,
      .v-item-group.v-bottom-navigation--fixed {
        z-index: 4;
      }
      
      .v-item-group.v-bottom-navigation--absolute {
        position: absolute;
      }
      
      .v-item-group.v-bottom-navigation--active {
        -webkit-transform: translate(0, 0);
                transform: translate(0, 0);
      }
      
      .v-item-group.v-bottom-navigation--fixed {
        position: fixed;
      }
      
      .v-item-group.v-bottom-navigation--grow .v-btn {
        width: 100%;
      }
      
      .v-item-group.v-bottom-navigation--horizontal .v-btn > .v-btn__content {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: reverse;
            -ms-flex-direction: row-reverse;
                flex-direction: row-reverse;
      }
      .v-item-group.v-bottom-navigation--horizontal .v-btn > .v-btn__content > .v-icon {
        margin-bottom: 0;
        margin-right: 16px;
      }
      
      .v-item-group.v-bottom-navigation--shift .v-btn .v-btn__content > *:not(.v-icon) {
        opacity: 0;
        position: absolute;
        top: calc(100% - 12px);
        -webkit-transform: scale(0.9);
                transform: scale(0.9);
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-item-group.v-bottom-navigation--shift .v-btn--active .v-btn__content > .v-icon {
        -webkit-transform: translateY(-8px);
                transform: translateY(-8px);
      }
      .v-item-group.v-bottom-navigation--shift .v-btn--active .v-btn__content > *:not(.v-icon) {
        opacity: 1;
        top: calc(100% - 22px);
        -webkit-transform: scale(1);
                transform: scale(1);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .bottom-sheet-transition-enter {
        -webkit-transform: translateY(100%);
                transform: translateY(100%);
      }
      .bottom-sheet-transition-leave-to {
        -webkit-transform: translateY(100%);
                transform: translateY(100%);
      }
      
      .v-bottom-sheet.v-dialog {
        -ms-flex-item-align: end;
            align-self: flex-end;
        border-radius: 0;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 100%;
                flex: 1 0 100%;
        margin: 0;
        min-width: 100%;
        overflow: visible;
      }
      .v-bottom-sheet.v-dialog.v-bottom-sheet--inset {
        max-width: 70%;
        min-width: 0;
      }
      @media only screen and (max-width: 599px) {
        .v-bottom-sheet.v-dialog.v-bottom-sheet--inset {
          max-width: none;
        }
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-dialog {
        border-radius: 4px;
        margin: 24px;
        overflow-y: auto;
        pointer-events: auto;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        width: 100%;
        z-index: inherit;
        -webkit-box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
      }
      .v-dialog:not(.v-dialog--fullscreen) {
        max-height: 90%;
      }
      .v-dialog > * {
        width: 100%;
      }
      
      .v-dialog__content {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 100%;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        left: 0;
        pointer-events: none;
        position: fixed;
        top: 0;
        -webkit-transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
        width: 100%;
        z-index: 6;
        outline: none;
      }
      
      .v-dialog__activator {
        cursor: pointer;
      }
      .v-dialog__activator * {
        cursor: pointer;
      }
      
      .v-dialog__container {
        display: inline-block;
        vertical-align: middle;
      }
      
      .v-dialog--animated {
        -webkit-animation-duration: 0.15s;
                animation-duration: 0.15s;
        -webkit-animation-name: animate-dialog;
                animation-name: animate-dialog;
        -webkit-animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
                animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      
      .v-dialog--fullscreen {
        border-radius: 0;
        margin: 0;
        height: 100%;
        position: fixed;
        overflow-y: auto;
        top: 0;
        left: 0;
      }
      .v-dialog--fullscreen > .v-card {
        min-height: 100%;
        min-width: 100%;
        margin: 0 !important;
        padding: 0 !important;
      }
      
      .v-dialog--scrollable,
      .v-dialog--scrollable > form {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .v-dialog--scrollable > .v-card,
      .v-dialog--scrollable > form > .v-card {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 100%;
                flex: 1 1 100%;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        max-height: 100%;
        max-width: 100%;
      }
      .v-dialog--scrollable > .v-card > .v-card__title,
      .v-dialog--scrollable > .v-card > .v-card__actions,
      .v-dialog--scrollable > form > .v-card > .v-card__title,
      .v-dialog--scrollable > form > .v-card > .v-card__actions {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
                flex: 0 0 auto;
      }
      .v-dialog--scrollable > .v-card > .v-card__text,
      .v-dialog--scrollable > form > .v-card > .v-card__text {
        -webkit-backface-visibility: hidden;
                backface-visibility: hidden;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        overflow-y: auto;
      }
      
      @-webkit-keyframes animate-dialog {
        0% {
          -webkit-transform: scale(1);
                  transform: scale(1);
        }
        50% {
          -webkit-transform: scale(1.03);
                  transform: scale(1.03);
        }
        100% {
          -webkit-transform: scale(1);
                  transform: scale(1);
        }
      }
      
      @keyframes animate-dialog {
        0% {
          -webkit-transform: scale(1);
                  transform: scale(1);
        }
        50% {
          -webkit-transform: scale(1.03);
                  transform: scale(1.03);
        }
        100% {
          -webkit-transform: scale(1);
                  transform: scale(1);
        }
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-overlay {
        color: rgba(0, 0, 0, 0.87);
      }
      
      .theme--dark.v-overlay {
        color: #FFFFFF;
      }
      
      .v-overlay {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        border-radius: inherit;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      
      .v-overlay__content {
        position: relative;
      }
      
      .v-overlay__scrim {
        border-radius: inherit;
        bottom: 0;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        width: 100%;
        will-change: opacity;
      }
      
      .v-overlay--absolute {
        position: absolute;
      }
      
      .v-overlay--active {
        pointer-events: auto;
        -ms-touch-action: none;
            touch-action: none;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-breadcrumbs .v-breadcrumbs__divider, .theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled {
        color: rgba(0, 0, 0, 0.38);
      }
      
      .theme--dark.v-breadcrumbs .v-breadcrumbs__divider, .theme--dark.v-breadcrumbs .v-breadcrumbs__item--disabled {
        color: rgba(255, 255, 255, 0.5);
      }
      
      .v-breadcrumbs {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        -webkit-box-flex: 0;
            -ms-flex: 0 1 auto;
                flex: 0 1 auto;
        list-style-type: none;
        margin: 0;
        padding: 18px 12px;
      }
      .v-breadcrumbs li {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        font-size: 14px;
      }
      .v-breadcrumbs li .v-icon {
        font-size: 16px;
      }
      .v-breadcrumbs li:nth-child(even) {
        padding: 0 12px;
      }
      
      .v-breadcrumbs__item {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        text-decoration: none;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-breadcrumbs__item--disabled {
        pointer-events: none;
      }
      
      .v-breadcrumbs--large li {
        font-size: 16px;
      }
      .v-breadcrumbs--large li .v-icon {
        font-size: 16px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-btn-toggle {
        background: #FFFFFF;
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-btn-toggle .v-btn.v-btn {
        border-color: rgba(0, 0, 0, 0.12) !important;
      }
      .theme--light.v-btn-toggle .v-btn.v-btn:focus:not(:active) {
        border-color: rgba(0, 0, 0, 0.26);
      }
      .theme--light.v-btn-toggle .v-btn.v-btn .v-icon {
        color: #000000;
      }
      
      .theme--dark.v-btn-toggle {
        background: #424242;
        color: #FFFFFF;
      }
      .theme--dark.v-btn-toggle .v-btn.v-btn {
        border-color: rgba(255, 255, 255, 0.12) !important;
      }
      .theme--dark.v-btn-toggle .v-btn.v-btn:focus:not(:active) {
        border-color: rgba(255, 255, 255, 0.3);
      }
      .theme--dark.v-btn-toggle .v-btn.v-btn .v-icon {
        color: #FFFFFF;
      }
      
      .v-btn-toggle {
        border-radius: 2px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        max-width: 100%;
      }
      .v-btn-toggle > .v-btn {
        opacity: 0.8;
      }
      .v-btn-toggle > .v-btn--active {
        color: inherit;
        opacity: 1;
      }
      .v-btn-toggle > .v-btn.v-size--default {
        height: 48px;
        min-height: 0;
        min-width: 48px;
        padding: 0 12px;
      }
      .v-btn-toggle > .v-btn.v-btn {
        border-radius: 0;
        border-style: solid;
        border-width: thin;
        -webkit-box-shadow: none;
                box-shadow: none;
      }
      .v-btn-toggle > .v-btn.v-btn:first-child {
        border-top-left-radius: inherit;
        border-bottom-left-radius: inherit;
      }
      .v-btn-toggle > .v-btn.v-btn:last-child {
        border-top-right-radius: inherit;
        border-bottom-right-radius: inherit;
      }
      .v-btn-toggle > .v-btn.v-btn:after {
        display: none;
      }
      .v-btn-toggle > .v-btn.v-btn:not(:first-child) {
        border-left-width: 0;
      }
      
      .v-btn-toggle--rounded {
        border-radius: 24px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-calendar-events .v-event-timed {
        border: 1px solid !important;
      }
      
      .theme--dark.v-calendar-events .v-event-timed {
        border: 1px solid !important;
      }
      
      .v-calendar .v-event {
        position: relative;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        cursor: pointer;
        margin-right: -1px;
      }
      .v-calendar .v-event.v-event-start {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      .v-calendar .v-event.v-event-end {
        width: 95%;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
      .v-calendar .v-event-more {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        cursor: pointer;
        border-radius: 4px;
        font-weight: bold;
        width: 95%;
      }
      .v-calendar .v-event-timed-container {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 95%;
        pointer-events: none;
      }
      .v-calendar .v-event-timed {
        position: absolute;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 12px;
        cursor: pointer;
        border-radius: 4px;
        pointer-events: all;
      }
      .v-calendar.v-calendar-events .v-calendar-weekly__day {
        overflow: visible;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-calendar-weekly {
        background-color: #FFFFFF;
      }
      .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {
        border-right: #e0e0e0 1px solid;
        color: #000000;
      }
      .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-past {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {
        background-color: #f7f7f7;
      }
      .theme--light.v-calendar-weekly .v-calendar-weekly__day {
        border-right: #e0e0e0 1px solid;
        border-bottom: #e0e0e0 1px solid;
        color: #000000;
      }
      .theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
        background-color: #f7f7f7;
      }
      
      .theme--dark.v-calendar-weekly {
        background-color: #303030;
      }
      .theme--dark.v-calendar-weekly .v-calendar-weekly__head-weekday {
        border-right: #9e9e9e 1px solid;
        color: #FFFFFF;
      }
      .theme--dark.v-calendar-weekly .v-calendar-weekly__head-weekday.v-past {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {
        background-color: #202020;
      }
      .theme--dark.v-calendar-weekly .v-calendar-weekly__day {
        border-right: #9e9e9e 1px solid;
        border-bottom: #9e9e9e 1px solid;
        color: #FFFFFF;
      }
      .theme--dark.v-calendar-weekly .v-calendar-weekly__day.v-outside {
        background-color: #202020;
      }
      
      .v-calendar-weekly {
        width: 100%;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
      }
      
      .v-calendar-weekly__head {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      
      .v-calendar-weekly__head-weekday {
        -webkit-box-flex: 1;
            -ms-flex: 1 0 20px;
                flex: 1 0 20px;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        padding: 0px 4px 0px 4px;
        font-size: 11px;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        text-transform: uppercase;
        white-space: nowrap;
      }
      
      .v-calendar-weekly__week {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        height: 0;
      }
      
      .v-calendar-weekly__day {
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        width: 0;
        overflow: hidden;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        position: relative;
        padding: 0px 0px 0px 0px;
      }
      .v-calendar-weekly__day.v-present .v-calendar-weekly__day-month {
        color: currentColor;
      }
      
      .v-calendar-weekly__day-label {
        text-decoration: none;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        cursor: pointer;
        -webkit-box-shadow: none;
                box-shadow: none;
        text-align: center;
        margin: 4px 0 0 0;
      }
      .v-calendar-weekly__day-label .v-btn {
        font-size: 12px;
        text-transform: none;
      }
      
      .v-calendar-weekly__day-month {
        position: absolute;
        text-decoration: none;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        -webkit-box-shadow: none;
                box-shadow: none;
        top: 0;
        left: 36px;
        height: 32px;
        line-height: 32px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-calendar-daily {
        background-color: #FFFFFF;
      }
      .theme--light.v-calendar-daily .v-calendar-daily__intervals-head {
        border-right: #e0e0e0 1px solid;
      }
      .theme--light.v-calendar-daily .v-calendar-daily_head-day {
        border-right: #e0e0e0 1px solid;
        border-bottom: #e0e0e0 1px solid;
        color: #000000;
      }
      .theme--light.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-weekday,
      .theme--light.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-day-label {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-calendar-daily .v-calendar-daily__intervals-body {
        border-right: #e0e0e0 1px solid;
      }
      .theme--light.v-calendar-daily .v-calendar-daily__intervals-body .v-calendar-daily__interval-text {
        color: #424242 1px solid;
      }
      .theme--light.v-calendar-daily .v-calendar-daily__day {
        border-right: #e0e0e0 1px solid;
        border-bottom: #e0e0e0 1px solid;
      }
      .theme--light.v-calendar-daily .v-calendar-daily__day-interval {
        border-top: #e0e0e0 1px solid;
      }
      .theme--light.v-calendar-daily .v-calendar-daily__day-interval:first-child {
        border-top: none !important;
      }
      
      .theme--dark.v-calendar-daily {
        background-color: #303030;
      }
      .theme--dark.v-calendar-daily .v-calendar-daily__intervals-head {
        border-right: #9e9e9e 1px solid;
      }
      .theme--dark.v-calendar-daily .v-calendar-daily_head-day {
        border-right: #9e9e9e 1px solid;
        border-bottom: #9e9e9e 1px solid;
        color: #FFFFFF;
      }
      .theme--dark.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-weekday,
      .theme--dark.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-day-label {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-calendar-daily .v-calendar-daily__intervals-body {
        border-right: #9e9e9e 1px solid;
      }
      .theme--dark.v-calendar-daily .v-calendar-daily__intervals-body .v-calendar-daily__interval-text {
        color: #eeeeee 1px solid;
      }
      .theme--dark.v-calendar-daily .v-calendar-daily__day {
        border-right: #9e9e9e 1px solid;
        border-bottom: #9e9e9e 1px solid;
      }
      .theme--dark.v-calendar-daily .v-calendar-daily__day-interval {
        border-top: #9e9e9e 1px solid;
      }
      .theme--dark.v-calendar-daily .v-calendar-daily__day-interval:first-child {
        border-top: none !important;
      }
      
      .v-calendar-daily {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        overflow: hidden;
        height: 100%;
      }
      
      .v-calendar-daily__head {
        -webkit-box-flex: 0;
            -ms-flex: none;
                flex: none;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      
      .v-calendar-daily__intervals-head {
        -webkit-box-flex: 0;
            -ms-flex: none;
                flex: none;
        width: 44px;
      }
      
      .v-calendar-daily_head-day {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        width: 0;
      }
      
      .v-calendar-daily_head-weekday {
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        padding: 3px 0px 0px 0px;
        font-size: 11px;
        text-align: center;
        text-transform: uppercase;
      }
      
      .v-calendar-daily_head-day-label {
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        padding: 0px 0px 3px 0px;
        cursor: pointer;
        text-align: center;
      }
      
      .v-calendar-daily__body {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 60%;
                flex: 1 1 60%;
        overflow: hidden;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        position: relative;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
      }
      
      .v-calendar-daily__scroll-area {
        overflow-y: scroll;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
      }
      
      .v-calendar-daily__pane {
        width: 100%;
        overflow-y: hidden;
        -webkit-box-flex: 0;
            -ms-flex: none;
                flex: none;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
      }
      
      .v-calendar-daily__day-container {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        width: 100%;
        height: 100%;
      }
      
      .v-calendar-daily__intervals-body {
        -webkit-box-flex: 0;
            -ms-flex: none;
                flex: none;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        width: 44px;
      }
      
      .v-calendar-daily__interval {
        text-align: center;
        border-bottom: none;
      }
      
      .v-calendar-daily__interval-text {
        display: block;
        position: relative;
        top: -6px;
        font-size: 10px;
      }
      
      .v-calendar-daily__day {
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        width: 0;
        position: relative;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-carousel {
        overflow: hidden;
        position: relative;
        width: 100%;
      }
      .v-carousel__controls {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        background: rgba(0, 0, 0, 0.3);
        bottom: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 50px;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        list-style-type: none;
        position: absolute;
        width: 100%;
        z-index: 1;
      }
      .v-carousel__controls > .v-item-group {
        -webkit-box-flex: 0;
            -ms-flex: 0 1 auto;
                flex: 0 1 auto;
      }
      .v-carousel__controls__item {
        margin: 0 8px;
      }
      .v-carousel__controls__item .v-icon {
        opacity: 0.5;
      }
      .v-carousel__controls__item--active .v-icon {
        opacity: 1;
        vertical-align: middle;
      }
      .v-carousel__controls__item:hover {
        background: none;
      }
      .v-carousel__controls__item:hover .v-icon {
        opacity: 0.8;
      }
      
      .v-carousel__progress {
        margin: 0;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
      }
      
      .v-carousel .v-window-item {
        display: block;
        height: inherit;
        text-decoration: none;
      }
      
      .v-carousel--hide-delimiter-background .v-carousel__controls {
        background: transparent;
      }
      
      .v-carousel--vertical-delimiters .v-carousel__controls {
        height: 100% !important;
        width: 50px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-window__container {
        position: relative;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-window__container--is-active {
        overflow: hidden;
      }
      .v-window__prev, .v-window__next {
        background: rgba(0, 0, 0, 0.3);
        border-radius: 50%;
        position: absolute;
        margin: 0 16px;
        top: calc(50% - 20px);
        z-index: 1;
      }
      .v-window__prev .v-btn:hover, .v-window__next .v-btn:hover {
        background: none;
      }
      .v-window__prev {
        left: 0;
      }
      .v-window__next {
        right: 0;
      }
      .v-application--is-rtl .v-window__prev {
        left: auto;
        right: 0;
      }
      .v-application--is-rtl .v-window__next {
        left: 0;
        right: auto;
      }
      .v-window--show-arrows-on-hover {
        overflow: hidden;
      }
      .v-window--show-arrows-on-hover .v-window__next,
      .v-window--show-arrows-on-hover .v-window__prev {
        -webkit-transition: 0.2s -webkit-transform cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.2s -webkit-transform cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.2s transform cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.2s transform cubic-bezier(0.25, 0.8, 0.5, 1), 0.2s -webkit-transform cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-window--show-arrows-on-hover .v-window__prev {
        -webkit-transform: translateX(-200%);
                transform: translateX(-200%);
      }
      .v-window--show-arrows-on-hover .v-window__next {
        -webkit-transform: translateX(200%);
                transform: translateX(200%);
      }
      .v-window--show-arrows-on-hover:hover .v-window__next,
      .v-window--show-arrows-on-hover:hover .v-window__prev {
        -webkit-transform: translateX(0);
                transform: translateX(0);
      }
      .v-window-x-transition-enter-active, .v-window-x-transition-leave-active, .v-window-x-reverse-transition-enter-active, .v-window-x-reverse-transition-leave-active, .v-window-y-transition-enter-active, .v-window-y-transition-leave-active, .v-window-y-reverse-transition-enter-active, .v-window-y-reverse-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-window-x-transition-leave, .v-window-x-transition-leave-to, .v-window-x-reverse-transition-leave, .v-window-x-reverse-transition-leave-to, .v-window-y-transition-leave, .v-window-y-transition-leave-to, .v-window-y-reverse-transition-leave, .v-window-y-reverse-transition-leave-to {
        position: absolute !important;
        top: 0;
        width: 100%;
      }
      .v-window-x-transition-enter {
        -webkit-transform: translateX(100%);
                transform: translateX(100%);
      }
      .v-window-x-transition-leave-to {
        -webkit-transform: translateX(-100%);
                transform: translateX(-100%);
      }
      .v-window-x-reverse-transition-enter {
        -webkit-transform: translateX(-100%);
                transform: translateX(-100%);
      }
      .v-window-x-reverse-transition-leave-to {
        -webkit-transform: translateX(100%);
                transform: translateX(100%);
      }
      .v-window-y-transition-enter {
        -webkit-transform: translateY(100%);
                transform: translateY(100%);
      }
      .v-window-y-transition-leave-to {
        -webkit-transform: translateY(-100%);
                transform: translateY(-100%);
      }
      .v-window-y-reverse-transition-enter {
        -webkit-transform: translateY(-100%);
                transform: translateY(-100%);
      }
      .v-window-y-reverse-transition-leave-to {
        -webkit-transform: translateY(100%);
                transform: translateY(100%);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-input--checkbox.v-input--indeterminate.v-input--is-disabled {
        opacity: 0.6;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon {
        color: rgba(0, 0, 0, 0.26) !important;
      }
      
      .theme--dark.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon {
        color: rgba(255, 255, 255, 0.3) !important;
      }
      
      .v-input--selection-controls {
        margin-top: 16px;
        padding-top: 4px;
      }
      .v-input--selection-controls .v-input__append-outer,
      .v-input--selection-controls .v-input__prepend-outer {
        margin-top: 0;
        margin-bottom: 0;
      }
      .v-input--selection-controls .v-input__control {
        -webkit-box-flex: 0;
            -ms-flex-positive: 0;
                flex-grow: 0;
        width: auto;
      }
      .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 12px;
      }
      .v-input--selection-controls__input {
        color: inherit;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
                flex: 0 0 auto;
        height: 24px;
        position: relative;
        margin-right: 8px;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        -webkit-transition-property: color, -webkit-transform;
        transition-property: color, -webkit-transform;
        transition-property: color, transform;
        transition-property: color, transform, -webkit-transform;
        width: 24px;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-application--is-rtl .v-input--selection-controls__input {
        margin-right: 0;
        margin-left: 8px;
      }
      .v-input--selection-controls__input input {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-input--selection-controls__input + .v-label {
        cursor: pointer;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-input--selection-controls__ripple {
        border-radius: 50%;
        cursor: pointer;
        height: 34px;
        position: absolute;
        -webkit-transition: inherit;
        transition: inherit;
        width: 34px;
        left: -12px;
        top: calc(50% - 24px);
        margin: 7px;
      }
      .v-input--selection-controls__ripple:before {
        border-radius: inherit;
        bottom: 0;
        content: "";
        position: absolute;
        opacity: 0.2;
        left: 0;
        right: 0;
        top: 0;
        -webkit-transform-origin: center center;
                transform-origin: center center;
        -webkit-transform: scale(0.2);
                transform: scale(0.2);
        -webkit-transition: inherit;
        transition: inherit;
      }
      .v-input--selection-controls__ripple .v-ripple__container {
        -webkit-transform: scale(1.2);
                transform: scale(1.2);
      }
      .v-input--selection-controls.v-input {
        -webkit-box-flex: 0;
            -ms-flex: 0 1 auto;
                flex: 0 1 auto;
      }
      .v-input--selection-controls.v-input .v-label {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        top: 0;
        height: auto;
      }
      .v-input--selection-controls.v-input--is-focused .v-input--selection-controls__ripple:before,
      .v-input--selection-controls .v-radio--is-focused .v-input--selection-controls__ripple:before {
        background: currentColor;
        opacity: 0.4;
        -webkit-transform: scale(1.2);
                transform: scale(1.2);
      }
      .v-input--selection-controls .v-input--selection-controls__input:hover .v-input--selection-controls__ripple:before {
        background: currentColor;
        -webkit-transform: scale(1.2);
                transform: scale(1.2);
        -webkit-transition: none;
        transition: none;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-chip-group .v-chip:not(.v-chip--active) {
        color: rgba(0, 0, 0, 0.87) !important;
      }
      
      .theme--dark.v-chip-group .v-chip:not(.v-chip--active) {
        color: #FFFFFF !important;
      }
      
      .v-chip-group .v-chip {
        margin: 4px 8px 4px 0;
      }
      .v-chip-group .v-chip--active {
        color: inherit;
      }
      .v-chip-group .v-chip--active.v-chip--no-color:after {
        opacity: 0.22;
      }
      .v-chip-group .v-chip--active.v-chip--no-color:focus:after {
        opacity: 0.32;
      }
      
      .v-chip-group .v-slide-group__content {
        padding: 4px 0;
      }
      
      .v-chip-group--column .v-slide-group__content {
        white-space: normal;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        max-width: 100%;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-slide-group {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .v-slide-group.v-item-group > .v-slide-group__next,
      .v-slide-group.v-item-group > .v-slide-group__prev {
        cursor: pointer;
      }
      
      .v-slide-item {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-flex: 0;
            -ms-flex: 0 1 auto;
                flex: 0 1 auto;
      }
      
      .v-slide-group__next,
      .v-slide-group__prev {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 0;
            -ms-flex: 0 1 52px;
                flex: 0 1 52px;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        min-width: 52px;
      }
      
      .v-slide-group__content {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        position: relative;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        white-space: nowrap;
      }
      
      .v-slide-group__wrapper {
        contain: content;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        overflow: hidden;
      }
      
      .v-slide-group__next--disabled,
      .v-slide-group__prev--disabled {
        pointer-events: none;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-color-picker .v-color-picker__input input {
        border: thin solid rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-color-picker span {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-color-picker .v-color-picker__dot, .theme--light.v-color-picker .v-color-picker__color {
        background-color: rgba(255, 255, 255, 0);
      }
      
      .theme--dark.v-color-picker .v-color-picker__input input {
        border: thin solid rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-color-picker span {
        color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-color-picker .v-color-picker__dot, .theme--dark.v-color-picker .v-color-picker__color {
        background-color: rgba(255, 255, 255, 0.12);
      }
      
      .v-color-picker {
        -ms-flex-item-align: start;
            align-self: flex-start;
        contain: content;
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
      
      .v-color-picker__controls {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        padding: 16px;
      }
      
      .v-color-picker--flat {
        -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
      }
      .v-color-picker--flat .v-color-picker__track:not(.v-input--is-disabled) .v-slider__thumb {
        -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-color-picker .v-input__slider {
        border-radius: 5px;
      }
      .v-color-picker .v-input__slider .v-slider {
        margin: 0;
      }
      
      .v-color-picker__alpha:not(.v-input--is-disabled) .v-slider {
        border-radius: 5px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGElEQVQYlWNgYGCQwoKxgqGgcJA5h3yFAAs8BRWVSwooAAAAAElFTkSuQmCC) repeat;
      }
      
      .v-color-picker__sliders {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
      }
      
      .v-color-picker__dot {
        position: relative;
        height: 30px;
        margin-right: 24px;
        width: 30px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGElEQVQYlWNgYGCQwoKxgqGgcJA5h3yFAAs8BRWVSwooAAAAAElFTkSuQmCC) repeat;
        border-radius: 50%;
        overflow: hidden;
      }
      .v-color-picker__dot > div {
        width: 100%;
        height: 100%;
      }
      
      .v-color-picker__hue {
        margin-bottom: 24px;
      }
      .v-color-picker__hue:not(.v-input--is-disabled) {
        background: -webkit-gradient(linear, left top, right top, from(#F00), color-stop(16.66%, #FF0), color-stop(33.33%, #0F0), color-stop(50%, #0FF), color-stop(66.66%, #00F), color-stop(83.33%, #F0F), to(#F00));
        background: linear-gradient(to right, #F00 0%, #FF0 16.66%, #0F0 33.33%, #0FF 50%, #00F 66.66%, #F0F 83.33%, #F00 100%);
      }
      
      .v-color-picker__track {
        position: relative;
        width: 100%;
      }
      
      .v-color-picker__preview {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .v-color-picker__preview .v-slider {
        min-height: 10px;
      }
      .v-color-picker__preview .v-slider:not(.v-slider--disabled) .v-slider__thumb {
        -webkit-box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
      }
      .v-color-picker__preview .v-slider:not(.v-slider--disabled) .v-slider__track-container {
        opacity: 0;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-slider .v-slider__track-background,
      .theme--light.v-slider .v-slider__track-fill,
      .theme--light.v-slider .v-slider__thumb {
        background: rgba(0, 0, 0, 0.26);
      }
      
      .theme--dark.v-slider .v-slider__track-background,
      .theme--dark.v-slider .v-slider__track-fill,
      .theme--dark.v-slider .v-slider__thumb {
        background: rgba(255, 255, 255, 0.2);
      }
      
      .v-slider {
        cursor: default;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        position: relative;
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-slider input {
        cursor: default;
        padding: 0;
        width: 100%;
        display: none;
      }
      
      .v-slider__track-container {
        position: absolute;
        border-radius: 0;
      }
      
      .v-slider__track-background, .v-slider__track-fill {
        position: absolute;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      
      .v-slider__thumb-container {
        outline: none;
        position: absolute;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        top: 50%;
      }
      .v-slider__thumb-container:hover .v-slider__thumb:before {
        -webkit-transform: scale(1);
                transform: scale(1);
      }
      
      .v-slider__thumb {
        position: absolute;
        width: 12px;
        height: 12px;
        left: -6px;
        top: 50%;
        border-radius: 50%;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-slider__thumb:before {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        content: "";
        color: inherit;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: currentColor;
        opacity: 0.3;
        position: absolute;
        left: -12px;
        top: -12px;
        -webkit-transform: scale(0.1);
                transform: scale(0.1);
        pointer-events: none;
      }
      
      .v-slider__ticks-container {
        position: absolute;
      }
      
      .v-slider__tick {
        position: absolute;
        opacity: 0;
        background-color: rgba(0, 0, 0, 0.5);
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        border-radius: 0;
      }
      .v-slider__tick--filled {
        background-color: rgba(255, 255, 255, 0.5);
      }
      .v-slider__tick:first-child .v-slider__tick-label {
        -webkit-transform: none;
                transform: none;
      }
      .v-application--is-rtl .v-slider__tick:first-child .v-slider__tick-label {
        -webkit-transform: translateX(100%);
                transform: translateX(100%);
      }
      .v-slider__tick:last-child .v-slider__tick-label {
        -webkit-transform: translateX(-100%);
                transform: translateX(-100%);
      }
      .v-application--is-rtl .v-slider__tick:last-child .v-slider__tick-label {
        -webkit-transform: none;
                transform: none;
      }
      
      .v-slider__tick-label {
        position: absolute;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        white-space: nowrap;
      }
      
      .v-slider__thumb-label-container {
        position: absolute;
        left: 0;
        top: 0;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      
      .v-slider__thumb-label {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        font-size: 12px;
        color: #fff;
        width: 32px;
        height: 32px;
        border-radius: 50% 50% 0;
        position: absolute;
        left: 0;
        bottom: 100%;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      
      .v-slider--horizontal {
        min-height: 32px;
        margin-left: 8px;
        margin-right: 8px;
      }
      .v-slider--horizontal .v-slider__track-container {
        width: 100%;
        height: 2px;
        left: 0;
        top: 50%;
        -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
      }
      .v-slider--horizontal .v-slider__track-background, .v-slider--horizontal .v-slider__track-fill {
        height: 100%;
      }
      .v-slider--horizontal .v-slider__ticks-container {
        left: 0;
        height: 2px;
        width: 100%;
      }
      .v-slider--horizontal .v-slider__tick:first-child .v-slider__tick-label {
        -webkit-transform: translateX(0%);
                transform: translateX(0%);
      }
      .v-application--is-rtl .v-slider--horizontal .v-slider__tick:first-child .v-slider__tick-label {
        -webkit-transform: translate(100%);
                transform: translate(100%);
      }
      .v-slider--horizontal .v-slider__tick:last-child .v-slider__tick-label {
        -webkit-transform: translateX(-100%);
                transform: translateX(-100%);
      }
      .v-application--is-rtl .v-slider--horizontal .v-slider__tick:last-child .v-slider__tick-label {
        -webkit-transform: translateX(0%);
                transform: translateX(0%);
      }
      .v-slider--horizontal .v-slider__tick .v-slider__tick-label {
        top: 8px;
        -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
      }
      .v-application--is-rtl .v-slider--horizontal .v-slider__tick .v-slider__tick-label {
        -webkit-transform: translateX(50%);
                transform: translateX(50%);
      }
      .v-slider--horizontal .v-slider__thumb-label {
        -webkit-transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);
                transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);
      }
      .v-slider--horizontal .v-slider__thumb-label > * {
        -webkit-transform: rotate(-45deg);
                transform: rotate(-45deg);
      }
      
      .v-slider--vertical {
        min-height: 150px;
        margin-top: 12px;
        margin-bottom: 12px;
      }
      .v-slider--vertical .v-slider__track-container {
        height: 100%;
        width: 2px;
        left: 50%;
        top: 0;
        -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
      }
      .v-slider--vertical .v-slider__track-background, .v-slider--vertical .v-slider__track-fill {
        width: 100%;
      }
      .v-slider--vertical .v-slider__thumb-container {
        left: 50%;
      }
      .v-slider--vertical .v-slider__ticks-container {
        top: 0;
        width: 2px;
        height: 100%;
        left: 50%;
        -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
      }
      .v-slider--vertical .v-slider__tick:first-child .v-slider__tick-label {
        -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
      }
      .v-application--is-rtl .v-slider--vertical .v-slider__tick:first-child .v-slider__tick-label {
        right: 12px;
      }
      .v-slider--vertical .v-slider__tick:last-child .v-slider__tick-label {
        -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
      }
      .v-application--is-rtl .v-slider--vertical .v-slider__tick:last-child .v-slider__tick-label {
        -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
      }
      .v-slider--vertical .v-slider__tick .v-slider__tick-label {
        left: 12px;
        -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
      }
      .v-application--is-rtl .v-slider--vertical .v-slider__tick .v-slider__tick-label {
        left: auto;
        right: 12px;
      }
      .v-slider--vertical .v-slider__thumb-label > * {
        -webkit-transform: rotate(-135deg);
                transform: rotate(-135deg);
      }
      
      .v-slider__thumb-container--focused .v-slider__thumb:before {
        -webkit-transform: scale(1);
                transform: scale(1);
      }
      
      .v-slider--active .v-slider__tick {
        opacity: 1;
      }
      
      .v-slider__thumb-container--active .v-slider__thumb:before {
        -webkit-transform: scale(1.5) !important;
                transform: scale(1.5) !important;
      }
      
      .v-slider--disabled {
        pointer-events: none;
      }
      .v-slider--disabled .v-slider__thumb {
        width: 8px;
        height: 8px;
        left: -4px;
      }
      .v-slider--disabled .v-slider__thumb:before {
        display: none;
      }
      
      .v-slider__ticks-container--always-show .v-slider__tick {
        opacity: 1;
      }
      
      .v-slider--readonly {
        pointer-events: none;
      }
      
      .v-input__slider .v-input__slot .v-label {
        margin-left: 0;
        margin-right: 12px;
      }
      .v-application--is-rtl .v-input__slider .v-input__slot .v-label {
        margin-right: 0;
        margin-left: 12px;
      }
      
      .v-input__slider--inverse-label .v-input__slot .v-label {
        margin-right: 0;
        margin-left: 12px;
      }
      .v-application--is-rtl .v-input__slider--inverse-label .v-input__slot .v-label {
        margin-left: 0;
        margin-right: 12px;
      }
      
      .v-input__slider--vertical {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: reverse;
            -ms-flex-direction: column-reverse;
                flex-direction: column-reverse;
      }
      .v-application--is-rtl .v-input__slider--vertical {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
      }
      .v-input__slider--vertical .v-input__slot, .v-input__slider--vertical .v-input__prepend-outer, .v-input__slider--vertical .v-input__append-outer {
        margin: 0;
      }
      .v-input__slider--vertical .v-messages {
        display: none;
      }
      
      .v-input--has-state .v-slider__track-background {
        opacity: 0.4;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-color-picker__canvas {
        position: relative;
        overflow: hidden;
        contain: strict;
      }
      .v-color-picker__canvas-dot {
        position: absolute;
        top: 0;
        left: 0;
        width: 15px;
        height: 15px;
        background: transparent;
        border-radius: 50%;
        -webkit-box-shadow: 0px 0px 0px 1.5px white, inset 0px 0px 1px 1.5px rgba(0, 0, 0, 0.3);
                box-shadow: 0px 0px 0px 1.5px white, inset 0px 0px 1px 1.5px rgba(0, 0, 0, 0.3);
      }
      .v-color-picker__canvas-dot--disabled {
        -webkit-box-shadow: 0px 0px 0px 1.5px rgba(255, 255, 255, 0.7), inset 0px 0px 1px 1.5px rgba(0, 0, 0, 0.3);
                box-shadow: 0px 0px 0px 1.5px rgba(255, 255, 255, 0.7), inset 0px 0px 1px 1.5px rgba(0, 0, 0, 0.3);
      }
      .v-color-picker__canvas:hover .v-color-picker__canvas-dot {
        will-change: transform;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-color-picker__edit {
        margin-top: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      
      .v-color-picker__input {
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        text-align: center;
      }
      .v-color-picker__input:not(:last-child) {
        margin-right: 8px;
      }
      .v-color-picker__input input {
        border-radius: 4px;
        margin-bottom: 8px;
        min-width: 0;
        outline: none;
        text-align: center;
        width: 100%;
        height: 28px;
      }
      .v-color-picker__input span {
        font-size: 0.75rem;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-color-picker__swatches {
        overflow-y: auto;
      }
      .v-color-picker__swatches > div {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        padding: 8px;
      }
      
      .v-color-picker__swatch {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        margin-bottom: 10px;
      }
      
      .v-color-picker__color {
        position: relative;
        height: 18px;
        max-height: 18px;
        width: 45px;
        margin: 2px 4px;
        border-radius: 2px;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        overflow: hidden;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGElEQVQYlWNgYGCQwoKxgqGgcJA5h3yFAAs8BRWVSwooAAAAAElFTkSuQmCC) repeat;
        cursor: pointer;
      }
      .v-color-picker__color > div {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        width: 100%;
        height: 100%;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-content {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        max-width: 100%;
        -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      }
      .v-content:not([data-booted=true]) {
        -webkit-transition: none !important;
        transition: none !important;
      }
      .v-content__wrap {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        max-width: 100%;
        position: relative;
      }
      @-moz-document url-prefix() {
        @media print {
          .v-content {
            display: block;
          }
        }
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-data-footer {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        -webkit-box-pack: end;
            -ms-flex-pack: end;
                justify-content: flex-end;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        font-size: 12px;
      }
      .v-data-footer .v-btn {
        color: inherit;
      }
      
      .v-application--is-ltr .v-data-footer__icons-before .v-btn:last-child {
        margin-right: 7px;
      }
      .v-application--is-rtl .v-data-footer__icons-before .v-btn:last-child {
        margin-left: 7px;
      }
      
      .v-application--is-ltr .v-data-footer__icons-after .v-btn:first-child {
        margin-left: 7px;
      }
      .v-application--is-rtl .v-data-footer__icons-after .v-btn:first-child {
        margin-right: 7px;
      }
      
      .v-data-footer__pagination {
        display: block;
        text-align: center;
      }
      .v-application--is-ltr .v-data-footer__pagination {
        margin: 0 32px 0 24px;
      }
      .v-application--is-rtl .v-data-footer__pagination {
        margin: 0 24px 0 32px;
      }
      
      .v-data-footer__select {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-flex: 0;
            -ms-flex: 0 0 0px;
                flex: 0 0 0;
        -webkit-box-pack: end;
            -ms-flex-pack: end;
                justify-content: flex-end;
        white-space: nowrap;
      }
      .v-application--is-ltr .v-data-footer__select {
        margin-right: 14px;
      }
      .v-application--is-rtl .v-data-footer__select {
        margin-left: 14px;
      }
      .v-data-footer__select .v-select {
        -webkit-box-flex: 0;
            -ms-flex: 0 1 0px;
                flex: 0 1 0;
        padding: 0;
        position: initial;
      }
      .v-application--is-ltr .v-data-footer__select .v-select {
        margin: 13px 0 13px 34px;
      }
      .v-application--is-rtl .v-data-footer__select .v-select {
        margin: 13px 34px 13px 0;
      }
      .v-data-footer__select .v-select__selections {
        -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
      }
      .v-data-footer__select .v-select__selections .v-select__selection--comma {
        font-size: 12px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expand-row) {
        background: #eeeeee;
      }
      .theme--light.v-data-table tbody tr.expanded.expanded__row {
        background: #f5f5f5;
      }
      .theme--light.v-data-table .v-row-group__header, .theme--light.v-data-table .v-row-group__summary {
        background: #e0e0e0;
      }
      .theme--light.v-data-table .v-data-footer {
        border-top: 1px solid rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-data-table .v-data-table__empty-wrapper {
        color: rgba(0, 0, 0, 0.38);
      }
      
      .theme--dark.v-data-table tbody tr:hover:not(.v-data-table__expand-row) {
        background: #616161;
      }
      .theme--dark.v-data-table tbody tr.expanded.expanded__row {
        background: #505050;
      }
      .theme--dark.v-data-table .v-row-group__header, .theme--dark.v-data-table .v-row-group__summary {
        background: #757575;
      }
      .theme--dark.v-data-table .v-data-footer {
        border-top: 1px solid rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-data-table .v-data-table__empty-wrapper {
        color: rgba(255, 255, 255, 0.5);
      }
      
      .v-data-table tbody tr.expanded {
        border-bottom: 0;
      }
      .v-data-table tbody tr.expanded.expanded__content {
        -webkit-box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0.75), inset 0px -4px 8px -5px rgba(50, 50, 50, 0.75);
                box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0.75), inset 0px -4px 8px -5px rgba(50, 50, 50, 0.75);
      }
      
      .v-data-table__empty-wrapper {
        text-align: center;
        pointer-events: none;
      }
      
      .v-data-table__mobile-row {
        display: block;
      }
      .v-data-table__mobile-row__wrapper {
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
      }
      .v-data-table__mobile-row__header {
        font-weight: 600;
      }
      .v-data-table__mobile-row__cell {
        text-align: right;
      }
      
      .v-data-table__expand-row {
        border: none !important;
      }
      .v-data-table__expand-col {
        padding: 0 !important;
        height: 0px !important;
      }
      .v-data-table__expand-col--expanded {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }
      .v-data-table__expand-content {
        -webkit-transition: height 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: height 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-data-table__expand-content > .card {
        border-radius: 0;
        -webkit-box-shadow: none;
                box-shadow: none;
      }
      
      .v-row-group__header td, .v-row-group__summary td {
        height: 35px;
      }
      
      .v-data-table__expand-icon {
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        cursor: pointer;
      }
      .v-data-table__expand-icon--active {
        -webkit-transform: rotate(-180deg);
                transform: rotate(-180deg);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-data-table .v-data-table-header th.sortable:hover {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-data-table .v-data-table-header th.sortable.active {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-data-table .v-data-table-header__sort-badge {
        background-color: rgba(0, 0, 0, 0.12);
        color: rgba(0, 0, 0, 0.87);
      }
      
      .theme--dark.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-data-table .v-data-table-header th.sortable:hover {
        color: white;
      }
      .theme--dark.v-data-table .v-data-table-header th.sortable.active {
        color: white;
      }
      .theme--dark.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon {
        color: white;
      }
      .theme--dark.v-data-table .v-data-table-header__sort-badge {
        background-color: rgba(255, 255, 255, 0.12);
        color: #FFFFFF;
      }
      
      .v-data-table-header th.sortable {
        pointer-events: auto;
        cursor: pointer;
        outline: 0;
      }
      .v-data-table-header th.active .v-data-table-header__icon, .v-data-table-header th:hover .v-data-table-header__icon {
        -webkit-transform: none;
                transform: none;
        opacity: 1;
      }
      .v-data-table-header th.desc .v-data-table-header__icon {
        -webkit-transform: rotate(-180deg);
                transform: rotate(-180deg);
      }
      
      .v-data-table-header__icon {
        display: inline-block;
        opacity: 0;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      
      .v-data-table-header__sort-badge {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        border: 0px;
        border-radius: 50%;
        min-width: 18px;
        min-height: 18px;
        height: 18px;
        width: 18px;
      }
      
      .v-data-table-header-mobile th {
        height: initial;
      }
      
      .v-data-table-header-mobile__wrapper {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .v-data-table-header-mobile__wrapper .v-select {
        margin-bottom: 8px;
      }
      .v-data-table-header-mobile__wrapper .v-select .v-chip {
        height: 24px;
      }
      .v-data-table-header-mobile__wrapper .v-select .v-chip__close.desc .v-icon {
        -webkit-transform: rotate(-180deg);
                transform: rotate(-180deg);
      }
      
      .v-data-table-header-mobile__select {
        min-width: 56px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-data-table {
        background-color: #FFFFFF;
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-data-table colgroup .divider {
        border-right: 1px solid rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-data-table.v-data-table--fixed-header thead th {
        background: #FFFFFF;
        -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.12);
                box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-data-table thead tr:last-child th {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-data-table thead tr th {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-data-table tbody tr:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-data-table tbody tr.active {
        background: #f5f5f5;
      }
      .theme--light.v-data-table tbody tr:hover {
        background: #eeeeee;
      }
      
      .theme--dark.v-data-table {
        background-color: #424242;
        color: #FFFFFF;
      }
      .theme--dark.v-data-table colgroup .divider {
        border-right: 1px solid rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-data-table.v-data-table--fixed-header thead th {
        background: #424242;
        -webkit-box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.12);
                box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-data-table thead tr:last-child th {
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-data-table thead tr th {
        color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-data-table tbody tr:not(:last-child) {
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-data-table tbody tr.active {
        background: #505050;
      }
      .theme--dark.v-data-table tbody tr:hover {
        background: #616161;
      }
      
      .v-data-table table {
        width: 100%;
        border-collapse: collapse;
      }
      .v-data-table td, .v-data-table th {
        padding: 0 16px;
      }
      .v-data-table th {
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        font-size: 12px;
        height: 48px;
      }
      .v-application--is-ltr .v-data-table th {
        text-align: left;
      }
      .v-application--is-rtl .v-data-table th {
        text-align: right;
      }
      .v-data-table td {
        font-size: 14px;
        height: 48px;
      }
      
      .v-data-table__wrapper {
        overflow-x: auto;
        overflow-y: hidden;
      }
      
      .v-data-table__progress {
        height: auto !important;
      }
      .v-data-table__progress th {
        height: auto !important;
        border: none !important;
        padding: 0;
      }
      
      .v-data-table--dense td {
        height: 24px;
      }
      .v-data-table--dense th {
        height: 32px;
      }
      
      .v-data-table--fixed-height .v-data-table__wrapper {
        overflow-y: auto;
      }
      
      .v-data-table--fixed-header .v-data-table__wrapper {
        overflow-y: auto;
      }
      .v-data-table--fixed-header thead th {
        border-bottom: 0px !important;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 2;
      }
      .v-data-table--fixed-header thead tr:nth-child(2) th {
        top: 48px;
      }
      .v-application--is-ltr .v-data-table--fixed-header .v-data-footer {
        margin-right: 17px;
      }
      .v-application--is-rtl .v-data-table--fixed-header .v-data-footer {
        margin-left: 17px;
      }
      
      .v-data-table--fixed.v-data-table--dense thead tr:nth-child(2) th {
        top: 32px;
      }
      
      .v-data-table--mobile tr, .v-data-table--mobile td, .v-data-table--mobile th {
        display: block;
      }
      .v-data-table--mobile td, .v-data-table--mobile th {
        padding: 14px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-small-dialog__menu-content, .theme--light.v-small-dialog__actions {
        background: #FFFFFF;
      }
      
      .theme--dark.v-small-dialog__menu-content, .theme--dark.v-small-dialog__actions {
        background: #424242;
      }
      
      .v-small-dialog {
        display: block;
      }
      .v-small-dialog__activator {
        cursor: pointer;
        height: 100%;
      }
      .v-small-dialog__content {
        padding: 0 16px;
      }
      .v-small-dialog__actions {
        padding: 8px;
        text-align: right;
        white-space: pre;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-virtual-table {
        position: relative;
      }
      
      .v-virtual-table__wrapper {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      
      .v-virtual-table__table {
        width: 100%;
        height: 100%;
        overflow-x: auto;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-date-picker-title {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        line-height: 1;
      }
      .v-application--is-rtl .v-date-picker-title .v-picker__title__btn {
        text-align: right;
      }
      .v-date-picker-title__year {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 8px;
      }
      .v-date-picker-title__date {
        font-size: 34px;
        text-align: left;
        font-weight: 500;
        position: relative;
        overflow: hidden;
        padding-bottom: 8px;
        margin-bottom: -8px;
      }
      .v-date-picker-title__date > div {
        position: relative;
      }
      .v-date-picker-title--disabled {
        pointer-events: none;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus) {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-date-picker-header .v-date-picker-header__value--disabled button {
        color: rgba(0, 0, 0, 0.38);
      }
      
      .theme--dark.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus) {
        color: #FFFFFF;
      }
      .theme--dark.v-date-picker-header .v-date-picker-header__value--disabled button {
        color: rgba(255, 255, 255, 0.5);
      }
      
      .v-date-picker-header {
        padding: 4px 16px;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        position: relative;
      }
      .v-date-picker-header .v-btn {
        margin: 0;
        z-index: auto;
      }
      .v-date-picker-header .v-icon {
        cursor: pointer;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      
      .v-date-picker-header__value {
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        text-align: center;
        position: relative;
        overflow: hidden;
      }
      .v-date-picker-header__value div {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        width: 100%;
      }
      .v-date-picker-header__value button {
        cursor: pointer;
        font-weight: bold;
        outline: none;
        padding: 0.5rem;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      
      .v-date-picker-header--disabled {
        pointer-events: none;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-date-picker-table th,
      .theme--light.v-date-picker-table .v-date-picker-table--date__week {
        color: rgba(0, 0, 0, 0.38);
      }
      
      .theme--dark.v-date-picker-table th,
      .theme--dark.v-date-picker-table .v-date-picker-table--date__week {
        color: rgba(255, 255, 255, 0.5);
      }
      
      .v-date-picker-table {
        position: relative;
        padding: 0 12px;
        height: 242px;
      }
      .v-date-picker-table table {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        top: 0;
        table-layout: fixed;
        width: 100%;
      }
      .v-date-picker-table td, .v-date-picker-table th {
        text-align: center;
        position: relative;
      }
      .v-date-picker-table th {
        font-size: 12px;
      }
      .v-date-picker-table--date .v-btn {
        height: 32px;
        width: 32px;
      }
      .v-date-picker-table .v-btn {
        z-index: auto;
        margin: 0;
        font-size: 12px;
      }
      .v-date-picker-table .v-btn.v-btn--active {
        color: #FFFFFF;
      }
      
      .v-date-picker-table--month td {
        width: 33.333333%;
        height: 56px;
        vertical-align: middle;
        text-align: center;
      }
      .v-date-picker-table--month td .v-btn {
        margin: 0 auto;
        max-width: 160px;
        min-width: 40px;
        width: 100%;
      }
      
      .v-date-picker-table--date th {
        padding: 8px 0;
        font-weight: 600;
      }
      .v-date-picker-table--date td {
        width: 45px;
      }
      
      .v-date-picker-table__events {
        height: 8px;
        left: 0;
        position: absolute;
        text-align: center;
        white-space: pre;
        width: 100%;
      }
      .v-date-picker-table__events > div {
        border-radius: 50%;
        display: inline-block;
        height: 8px;
        margin: 0 1px;
        width: 8px;
      }
      
      .v-date-picker-table--date .v-date-picker-table__events {
        bottom: 6px;
      }
      
      .v-date-picker-table--month .v-date-picker-table__events {
        bottom: 8px;
      }
      
      .v-date-picker-table--disabled {
        pointer-events: none;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-date-picker-years {
        font-size: 16px;
        font-weight: 400;
        height: 286px;
        list-style-type: none;
        overflow: auto;
        text-align: center;
      }
      .v-date-picker-years.v-date-picker-years {
        padding: 0;
      }
      .v-date-picker-years li {
        cursor: pointer;
        padding: 8px 0;
        -webkit-transition: none;
        transition: none;
      }
      .v-date-picker-years li.active {
        font-size: 26px;
        font-weight: 500;
        padding: 10px 0;
      }
      .v-date-picker-years li:hover {
        background: rgba(0, 0, 0, 0.12);
      }
      
      .v-picker--landscape .v-date-picker-years {
        padding: 0;
        height: 286px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-picker__title {
        background: #e0e0e0;
      }
      
      .theme--dark.v-picker__title {
        background: #616161;
      }
      
      .theme--light.v-picker__body {
        background: #FFFFFF;
      }
      
      .theme--dark.v-picker__body {
        background: #424242;
      }
      
      .v-picker {
        border-radius: 2px;
        contain: layout style;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        vertical-align: top;
        position: relative;
      }
      
      .v-picker--full-width {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      
      .v-picker__title {
        color: #FFFFFF;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
        padding: 16px;
      }
      
      .v-picker__title__btn {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-picker__title__btn:not(.v-picker__title__btn--active) {
        opacity: 0.6;
        cursor: pointer;
      }
      .v-picker__title__btn:not(.v-picker__title__btn--active):hover:not(:focus) {
        opacity: 1;
      }
      
      .v-picker__title__btn--readonly {
        pointer-events: none;
      }
      
      .v-picker__title__btn--active {
        opacity: 1;
      }
      
      .v-picker__body {
        height: auto;
        overflow: hidden;
        position: relative;
        z-index: 0;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
      }
      .v-picker__body > div {
        width: 100%;
      }
      .v-picker__body > div.fade-transition-leave-active {
        position: absolute;
      }
      
      .v-picker--landscape .v-picker__title {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        width: 170px;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        z-index: 1;
      }
      .v-picker--landscape .v-picker__body:not(.v-picker__body--no-title),
      .v-picker--landscape .v-picker__actions:not(.v-picker__actions--no-title) {
        margin-left: 170px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-expansion-panels .v-expansion-panel {
        background-color: #FFFFFF;
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-expansion-panels .v-expansion-panel--disabled {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-expansion-panels .v-expansion-panel:not(:first-child)::after {
        border-color: rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header:hover::before {
        opacity: 0.04;
      }
      .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header:focus::before {
        opacity: 0.12;
      }
      .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:hover::before, .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active::before {
        opacity: 0.12;
      }
      .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:focus::before {
        opacity: 0.16;
      }
      
      .theme--dark.v-expansion-panels .v-expansion-panel {
        background-color: #424242;
        color: #FFFFFF;
      }
      .theme--dark.v-expansion-panels .v-expansion-panel--disabled {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-expansion-panels .v-expansion-panel:not(:first-child)::after {
        border-color: rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
        color: #FFFFFF;
      }
      .theme--dark.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header:hover::before {
        opacity: 0.08;
      }
      .theme--dark.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header:focus::before {
        opacity: 0.24;
      }
      .theme--dark.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:hover::before, .theme--dark.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active::before {
        opacity: 0.24;
      }
      .theme--dark.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:focus::before {
        opacity: 0.32;
      }
      
      .v-expansion-panels {
        border-radius: 4px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        list-style-type: none;
        padding: 0;
        width: 100%;
        z-index: 1;
      }
      .v-expansion-panels > * {
        cursor: auto;
      }
      .v-expansion-panels > *:first-child {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
      }
      .v-expansion-panels > *:last-child {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
      }
      
      .v-expansion-panel {
        -webkit-box-flex: 1;
            -ms-flex: 1 0 100%;
                flex: 1 0 100%;
        max-width: 100%;
        position: relative;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-expansion-panel::before {
        border-radius: inherit;
        bottom: 0;
        content: "";
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        z-index: -1;
        -webkit-transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
        transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
        transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
        transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
        will-change: box-shadow;
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
      .v-expansion-panel:not(:first-child)::after {
        border-top: thin solid;
        content: "";
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transition: 0.2s border-color cubic-bezier(0.4, 0, 0.2, 1), 0.2s opacity cubic-bezier(0.4, 0, 0.2, 1);
        transition: 0.2s border-color cubic-bezier(0.4, 0, 0.2, 1), 0.2s opacity cubic-bezier(0.4, 0, 0.2, 1);
      }
      .v-expansion-panel--disabled .v-expansion-panel-header {
        pointer-events: none;
      }
      .v-expansion-panel--active:not(:first-child),
      .v-expansion-panel--active + .v-expansion-panel {
        margin-top: 16px;
      }
      .v-expansion-panel--active:not(:first-child)::after,
      .v-expansion-panel--active + .v-expansion-panel::after {
        opacity: 0;
      }
      .v-expansion-panel--active .v-expansion-panel-header {
        min-height: 64px;
      }
      .v-expansion-panel--active > .v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon {
        -webkit-transform: rotate(-180deg);
                transform: rotate(-180deg);
      }
      
      .v-expansion-panels:not(.v-expansion-panels--accordion) > .v-expansion-panel--active {
        border-radius: 4px;
      }
      .v-expansion-panels:not(.v-expansion-panels--accordion) > .v-expansion-panel--active + .v-expansion-panel {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
      .v-expansion-panels:not(.v-expansion-panels--accordion) > .v-expansion-panel--next-active {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
      .v-expansion-panels:not(.v-expansion-panels--accordion) > .v-expansion-panel--next-active .v-expansion-panel-header {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
      }
      
      .v-expansion-panel-header__icon {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        margin-bottom: -4px;
        margin-left: auto;
        margin-top: -4px;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-application--is-rtl .v-expansion-panel-header__icon {
        margin-left: initial;
        margin-right: auto;
      }
      
      .v-expansion-panel-header {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        font-size: 0.9375rem;
        line-height: 1;
        min-height: 48px;
        outline: none;
        padding: 16px 24px;
        position: relative;
        text-align: left;
        -webkit-transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
        width: 100%;
      }
      .v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus::before {
        opacity: 0.12;
      }
      .v-application--is-rtl .v-expansion-panel-header {
        text-align: right;
      }
      .v-expansion-panel-header:before {
        background-color: currentColor;
        border-radius: inherit;
        bottom: 0;
        content: "";
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transition: 0.3s opacity cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s opacity cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-expansion-panel-header > *:not(.v-expansion-panel-header__icon) {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
      }
      
      .v-expansion-panel-content {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .v-expansion-panel-content__wrap {
        padding: 0 24px 16px;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
      }
      
      .v-expansion-panels--accordion .v-expansion-panel {
        margin-top: 0;
      }
      .v-expansion-panels--accordion .v-expansion-panel::after {
        opacity: 1;
      }
      
      .v-expansion-panels--popout .v-expansion-panel {
        max-width: calc(100% - 32px);
      }
      .v-expansion-panels--popout .v-expansion-panel--active {
        max-width: calc(100% + 16px);
      }
      
      .v-expansion-panels--inset .v-expansion-panel {
        max-width: 100%;
      }
      .v-expansion-panels--inset .v-expansion-panel--active {
        max-width: calc(100% - 32px);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-file-input .v-file-input__text {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-file-input .v-file-input__text--placeholder {
        color: rgba(0, 0, 0, 0.54);
      }
      
      .theme--dark.v-file-input .v-file-input__text {
        color: #FFFFFF;
      }
      .theme--dark.v-file-input .v-file-input__text--placeholder {
        color: rgba(255, 255, 255, 0.7);
      }
      
      .v-file-input input[type=file] {
        opacity: 0;
        max-width: 0;
        width: 0;
      }
      
      .v-file-input .v-file-input__text {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -ms-flex-item-align: stretch;
            align-self: stretch;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        width: 100%;
      }
      .v-file-input .v-file-input__text.v-file-input__text--chips {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
      }
      .v-file-input .v-file-input__text .v-chip {
        margin: 4px;
      }
      
      .v-file-input.v-text-field--filled:not(.v-text-field--single-line) .v-file-input__text {
        padding-top: 22px;
      }
      
      .v-file-input.v-text-field--outlined .v-text-field__slot {
        padding: 6px 0;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-footer {
        background-color: #f5f5f5;
        color: rgba(0, 0, 0, 0.87);
      }
      
      .theme--dark.v-footer {
        background-color: #212121;
        color: #FFFFFF;
      }
      
      .v-footer {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 0 !important;
            -ms-flex: 0 1 auto !important;
                flex: 0 1 auto !important;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        padding: 6px 16px;
        -webkit-transition-duration: 0.2s;
                transition-duration: 0.2s;
        -webkit-transition-property: background-color, left, right;
        transition-property: background-color, left, right;
        -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      }
      .v-footer:not([data-booted=true]) {
        -webkit-transition: none !important;
        transition: none !important;
      }
      
      .v-footer--absolute,
      .v-footer--fixed {
        z-index: 3;
      }
      
      .v-footer--absolute {
        position: absolute;
        width: 100%;
      }
      
      .v-footer--fixed {
        position: fixed;
      }
      
      .v-footer--padless {
        padding: 0px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .container.grow-shrink-0 {
        -webkit-box-flex: 0;
            -ms-flex-positive: 0;
                flex-grow: 0;
        -ms-flex-negative: 0;
            flex-shrink: 0;
      }
      .container.fill-height {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .container.fill-height > .layout {
        height: 100%;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
      }
      .container.fill-height > .layout.grow-shrink-0 {
        -webkit-box-flex: 0;
            -ms-flex-positive: 0;
                flex-grow: 0;
        -ms-flex-negative: 0;
            flex-shrink: 0;
      }
      .container.grid-list-xs .layout .flex {
        padding: 1px;
      }
      .container.grid-list-xs .layout:only-child {
        margin: -1px;
      }
      .container.grid-list-xs .layout:not(:only-child) {
        margin: auto -1px;
      }
      .container.grid-list-xs *:not(:only-child) .layout:first-child {
        margin-top: -1px;
      }
      .container.grid-list-xs *:not(:only-child) .layout:last-child {
        margin-bottom: -1px;
      }
      .container.grid-list-sm .layout .flex {
        padding: 2px;
      }
      .container.grid-list-sm .layout:only-child {
        margin: -2px;
      }
      .container.grid-list-sm .layout:not(:only-child) {
        margin: auto -2px;
      }
      .container.grid-list-sm *:not(:only-child) .layout:first-child {
        margin-top: -2px;
      }
      .container.grid-list-sm *:not(:only-child) .layout:last-child {
        margin-bottom: -2px;
      }
      .container.grid-list-md .layout .flex {
        padding: 4px;
      }
      .container.grid-list-md .layout:only-child {
        margin: -4px;
      }
      .container.grid-list-md .layout:not(:only-child) {
        margin: auto -4px;
      }
      .container.grid-list-md *:not(:only-child) .layout:first-child {
        margin-top: -4px;
      }
      .container.grid-list-md *:not(:only-child) .layout:last-child {
        margin-bottom: -4px;
      }
      .container.grid-list-lg .layout .flex {
        padding: 8px;
      }
      .container.grid-list-lg .layout:only-child {
        margin: -8px;
      }
      .container.grid-list-lg .layout:not(:only-child) {
        margin: auto -8px;
      }
      .container.grid-list-lg *:not(:only-child) .layout:first-child {
        margin-top: -8px;
      }
      .container.grid-list-lg *:not(:only-child) .layout:last-child {
        margin-bottom: -8px;
      }
      .container.grid-list-xl .layout .flex {
        padding: 12px;
      }
      .container.grid-list-xl .layout:only-child {
        margin: -12px;
      }
      .container.grid-list-xl .layout:not(:only-child) {
        margin: auto -12px;
      }
      .container.grid-list-xl *:not(:only-child) .layout:first-child {
        margin-top: -12px;
      }
      .container.grid-list-xl *:not(:only-child) .layout:last-child {
        margin-bottom: -12px;
      }
      
      .layout {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
        min-width: 0;
      }
      .layout.reverse {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: reverse;
            -ms-flex-direction: row-reverse;
                flex-direction: row-reverse;
      }
      .layout.column {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
      }
      .layout.column.reverse {
        -webkit-box-orient: vertical;
        -webkit-box-direction: reverse;
            -ms-flex-direction: column-reverse;
                flex-direction: column-reverse;
      }
      .layout.column > .flex {
        max-width: 100%;
      }
      .layout.wrap {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
      }
      .layout.grow-shrink-0 {
        -webkit-box-flex: 0;
            -ms-flex-positive: 0;
                flex-grow: 0;
        -ms-flex-negative: 0;
            flex-shrink: 0;
      }
      
      @media all and (min-width: 0) {
        .flex.xs12 {
          -ms-flex-preferred-size: 100%;
              flex-basis: 100%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 100%;
        }
      
        .flex.order-xs12 {
          -webkit-box-ordinal-group: 13;
              -ms-flex-order: 12;
                  order: 12;
        }
      
        .flex.xs11 {
          -ms-flex-preferred-size: 91.6666666667%;
              flex-basis: 91.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 91.6666666667%;
        }
      
        .flex.order-xs11 {
          -webkit-box-ordinal-group: 12;
              -ms-flex-order: 11;
                  order: 11;
        }
      
        .flex.xs10 {
          -ms-flex-preferred-size: 83.3333333333%;
              flex-basis: 83.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 83.3333333333%;
        }
      
        .flex.order-xs10 {
          -webkit-box-ordinal-group: 11;
              -ms-flex-order: 10;
                  order: 10;
        }
      
        .flex.xs9 {
          -ms-flex-preferred-size: 75%;
              flex-basis: 75%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 75%;
        }
      
        .flex.order-xs9 {
          -webkit-box-ordinal-group: 10;
              -ms-flex-order: 9;
                  order: 9;
        }
      
        .flex.xs8 {
          -ms-flex-preferred-size: 66.6666666667%;
              flex-basis: 66.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 66.6666666667%;
        }
      
        .flex.order-xs8 {
          -webkit-box-ordinal-group: 9;
              -ms-flex-order: 8;
                  order: 8;
        }
      
        .flex.xs7 {
          -ms-flex-preferred-size: 58.3333333333%;
              flex-basis: 58.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 58.3333333333%;
        }
      
        .flex.order-xs7 {
          -webkit-box-ordinal-group: 8;
              -ms-flex-order: 7;
                  order: 7;
        }
      
        .flex.xs6 {
          -ms-flex-preferred-size: 50%;
              flex-basis: 50%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 50%;
        }
      
        .flex.order-xs6 {
          -webkit-box-ordinal-group: 7;
              -ms-flex-order: 6;
                  order: 6;
        }
      
        .flex.xs5 {
          -ms-flex-preferred-size: 41.6666666667%;
              flex-basis: 41.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 41.6666666667%;
        }
      
        .flex.order-xs5 {
          -webkit-box-ordinal-group: 6;
              -ms-flex-order: 5;
                  order: 5;
        }
      
        .flex.xs4 {
          -ms-flex-preferred-size: 33.3333333333%;
              flex-basis: 33.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 33.3333333333%;
        }
      
        .flex.order-xs4 {
          -webkit-box-ordinal-group: 5;
              -ms-flex-order: 4;
                  order: 4;
        }
      
        .flex.xs3 {
          -ms-flex-preferred-size: 25%;
              flex-basis: 25%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 25%;
        }
      
        .flex.order-xs3 {
          -webkit-box-ordinal-group: 4;
              -ms-flex-order: 3;
                  order: 3;
        }
      
        .flex.xs2 {
          -ms-flex-preferred-size: 16.6666666667%;
              flex-basis: 16.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 16.6666666667%;
        }
      
        .flex.order-xs2 {
          -webkit-box-ordinal-group: 3;
              -ms-flex-order: 2;
                  order: 2;
        }
      
        .flex.xs1 {
          -ms-flex-preferred-size: 8.3333333333%;
              flex-basis: 8.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 8.3333333333%;
        }
      
        .flex.order-xs1 {
          -webkit-box-ordinal-group: 2;
              -ms-flex-order: 1;
                  order: 1;
        }
      
        .flex.offset-xs12 {
          margin-left: 100%;
        }
      
        .flex.offset-xs11 {
          margin-left: 91.6666666667%;
        }
      
        .flex.offset-xs10 {
          margin-left: 83.3333333333%;
        }
      
        .flex.offset-xs9 {
          margin-left: 75%;
        }
      
        .flex.offset-xs8 {
          margin-left: 66.6666666667%;
        }
      
        .flex.offset-xs7 {
          margin-left: 58.3333333333%;
        }
      
        .flex.offset-xs6 {
          margin-left: 50%;
        }
      
        .flex.offset-xs5 {
          margin-left: 41.6666666667%;
        }
      
        .flex.offset-xs4 {
          margin-left: 33.3333333333%;
        }
      
        .flex.offset-xs3 {
          margin-left: 25%;
        }
      
        .flex.offset-xs2 {
          margin-left: 16.6666666667%;
        }
      
        .flex.offset-xs1 {
          margin-left: 8.3333333333%;
        }
      
        .flex.offset-xs0 {
          margin-left: 0%;
        }
      }
      @media all and (min-width: 600px) {
        .flex.sm12 {
          -ms-flex-preferred-size: 100%;
              flex-basis: 100%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 100%;
        }
      
        .flex.order-sm12 {
          -webkit-box-ordinal-group: 13;
              -ms-flex-order: 12;
                  order: 12;
        }
      
        .flex.sm11 {
          -ms-flex-preferred-size: 91.6666666667%;
              flex-basis: 91.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 91.6666666667%;
        }
      
        .flex.order-sm11 {
          -webkit-box-ordinal-group: 12;
              -ms-flex-order: 11;
                  order: 11;
        }
      
        .flex.sm10 {
          -ms-flex-preferred-size: 83.3333333333%;
              flex-basis: 83.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 83.3333333333%;
        }
      
        .flex.order-sm10 {
          -webkit-box-ordinal-group: 11;
              -ms-flex-order: 10;
                  order: 10;
        }
      
        .flex.sm9 {
          -ms-flex-preferred-size: 75%;
              flex-basis: 75%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 75%;
        }
      
        .flex.order-sm9 {
          -webkit-box-ordinal-group: 10;
              -ms-flex-order: 9;
                  order: 9;
        }
      
        .flex.sm8 {
          -ms-flex-preferred-size: 66.6666666667%;
              flex-basis: 66.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 66.6666666667%;
        }
      
        .flex.order-sm8 {
          -webkit-box-ordinal-group: 9;
              -ms-flex-order: 8;
                  order: 8;
        }
      
        .flex.sm7 {
          -ms-flex-preferred-size: 58.3333333333%;
              flex-basis: 58.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 58.3333333333%;
        }
      
        .flex.order-sm7 {
          -webkit-box-ordinal-group: 8;
              -ms-flex-order: 7;
                  order: 7;
        }
      
        .flex.sm6 {
          -ms-flex-preferred-size: 50%;
              flex-basis: 50%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 50%;
        }
      
        .flex.order-sm6 {
          -webkit-box-ordinal-group: 7;
              -ms-flex-order: 6;
                  order: 6;
        }
      
        .flex.sm5 {
          -ms-flex-preferred-size: 41.6666666667%;
              flex-basis: 41.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 41.6666666667%;
        }
      
        .flex.order-sm5 {
          -webkit-box-ordinal-group: 6;
              -ms-flex-order: 5;
                  order: 5;
        }
      
        .flex.sm4 {
          -ms-flex-preferred-size: 33.3333333333%;
              flex-basis: 33.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 33.3333333333%;
        }
      
        .flex.order-sm4 {
          -webkit-box-ordinal-group: 5;
              -ms-flex-order: 4;
                  order: 4;
        }
      
        .flex.sm3 {
          -ms-flex-preferred-size: 25%;
              flex-basis: 25%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 25%;
        }
      
        .flex.order-sm3 {
          -webkit-box-ordinal-group: 4;
              -ms-flex-order: 3;
                  order: 3;
        }
      
        .flex.sm2 {
          -ms-flex-preferred-size: 16.6666666667%;
              flex-basis: 16.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 16.6666666667%;
        }
      
        .flex.order-sm2 {
          -webkit-box-ordinal-group: 3;
              -ms-flex-order: 2;
                  order: 2;
        }
      
        .flex.sm1 {
          -ms-flex-preferred-size: 8.3333333333%;
              flex-basis: 8.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 8.3333333333%;
        }
      
        .flex.order-sm1 {
          -webkit-box-ordinal-group: 2;
              -ms-flex-order: 1;
                  order: 1;
        }
      
        .flex.offset-sm12 {
          margin-left: 100%;
        }
      
        .flex.offset-sm11 {
          margin-left: 91.6666666667%;
        }
      
        .flex.offset-sm10 {
          margin-left: 83.3333333333%;
        }
      
        .flex.offset-sm9 {
          margin-left: 75%;
        }
      
        .flex.offset-sm8 {
          margin-left: 66.6666666667%;
        }
      
        .flex.offset-sm7 {
          margin-left: 58.3333333333%;
        }
      
        .flex.offset-sm6 {
          margin-left: 50%;
        }
      
        .flex.offset-sm5 {
          margin-left: 41.6666666667%;
        }
      
        .flex.offset-sm4 {
          margin-left: 33.3333333333%;
        }
      
        .flex.offset-sm3 {
          margin-left: 25%;
        }
      
        .flex.offset-sm2 {
          margin-left: 16.6666666667%;
        }
      
        .flex.offset-sm1 {
          margin-left: 8.3333333333%;
        }
      
        .flex.offset-sm0 {
          margin-left: 0%;
        }
      }
      @media all and (min-width: 960px) {
        .flex.md12 {
          -ms-flex-preferred-size: 100%;
              flex-basis: 100%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 100%;
        }
      
        .flex.order-md12 {
          -webkit-box-ordinal-group: 13;
              -ms-flex-order: 12;
                  order: 12;
        }
      
        .flex.md11 {
          -ms-flex-preferred-size: 91.6666666667%;
              flex-basis: 91.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 91.6666666667%;
        }
      
        .flex.order-md11 {
          -webkit-box-ordinal-group: 12;
              -ms-flex-order: 11;
                  order: 11;
        }
      
        .flex.md10 {
          -ms-flex-preferred-size: 83.3333333333%;
              flex-basis: 83.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 83.3333333333%;
        }
      
        .flex.order-md10 {
          -webkit-box-ordinal-group: 11;
              -ms-flex-order: 10;
                  order: 10;
        }
      
        .flex.md9 {
          -ms-flex-preferred-size: 75%;
              flex-basis: 75%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 75%;
        }
      
        .flex.order-md9 {
          -webkit-box-ordinal-group: 10;
              -ms-flex-order: 9;
                  order: 9;
        }
      
        .flex.md8 {
          -ms-flex-preferred-size: 66.6666666667%;
              flex-basis: 66.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 66.6666666667%;
        }
      
        .flex.order-md8 {
          -webkit-box-ordinal-group: 9;
              -ms-flex-order: 8;
                  order: 8;
        }
      
        .flex.md7 {
          -ms-flex-preferred-size: 58.3333333333%;
              flex-basis: 58.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 58.3333333333%;
        }
      
        .flex.order-md7 {
          -webkit-box-ordinal-group: 8;
              -ms-flex-order: 7;
                  order: 7;
        }
      
        .flex.md6 {
          -ms-flex-preferred-size: 50%;
              flex-basis: 50%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 50%;
        }
      
        .flex.order-md6 {
          -webkit-box-ordinal-group: 7;
              -ms-flex-order: 6;
                  order: 6;
        }
      
        .flex.md5 {
          -ms-flex-preferred-size: 41.6666666667%;
              flex-basis: 41.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 41.6666666667%;
        }
      
        .flex.order-md5 {
          -webkit-box-ordinal-group: 6;
              -ms-flex-order: 5;
                  order: 5;
        }
      
        .flex.md4 {
          -ms-flex-preferred-size: 33.3333333333%;
              flex-basis: 33.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 33.3333333333%;
        }
      
        .flex.order-md4 {
          -webkit-box-ordinal-group: 5;
              -ms-flex-order: 4;
                  order: 4;
        }
      
        .flex.md3 {
          -ms-flex-preferred-size: 25%;
              flex-basis: 25%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 25%;
        }
      
        .flex.order-md3 {
          -webkit-box-ordinal-group: 4;
              -ms-flex-order: 3;
                  order: 3;
        }
      
        .flex.md2 {
          -ms-flex-preferred-size: 16.6666666667%;
              flex-basis: 16.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 16.6666666667%;
        }
      
        .flex.order-md2 {
          -webkit-box-ordinal-group: 3;
              -ms-flex-order: 2;
                  order: 2;
        }
      
        .flex.md1 {
          -ms-flex-preferred-size: 8.3333333333%;
              flex-basis: 8.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 8.3333333333%;
        }
      
        .flex.order-md1 {
          -webkit-box-ordinal-group: 2;
              -ms-flex-order: 1;
                  order: 1;
        }
      
        .flex.offset-md12 {
          margin-left: 100%;
        }
      
        .flex.offset-md11 {
          margin-left: 91.6666666667%;
        }
      
        .flex.offset-md10 {
          margin-left: 83.3333333333%;
        }
      
        .flex.offset-md9 {
          margin-left: 75%;
        }
      
        .flex.offset-md8 {
          margin-left: 66.6666666667%;
        }
      
        .flex.offset-md7 {
          margin-left: 58.3333333333%;
        }
      
        .flex.offset-md6 {
          margin-left: 50%;
        }
      
        .flex.offset-md5 {
          margin-left: 41.6666666667%;
        }
      
        .flex.offset-md4 {
          margin-left: 33.3333333333%;
        }
      
        .flex.offset-md3 {
          margin-left: 25%;
        }
      
        .flex.offset-md2 {
          margin-left: 16.6666666667%;
        }
      
        .flex.offset-md1 {
          margin-left: 8.3333333333%;
        }
      
        .flex.offset-md0 {
          margin-left: 0%;
        }
      }
      @media all and (min-width: 1264px) {
        .flex.lg12 {
          -ms-flex-preferred-size: 100%;
              flex-basis: 100%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 100%;
        }
      
        .flex.order-lg12 {
          -webkit-box-ordinal-group: 13;
              -ms-flex-order: 12;
                  order: 12;
        }
      
        .flex.lg11 {
          -ms-flex-preferred-size: 91.6666666667%;
              flex-basis: 91.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 91.6666666667%;
        }
      
        .flex.order-lg11 {
          -webkit-box-ordinal-group: 12;
              -ms-flex-order: 11;
                  order: 11;
        }
      
        .flex.lg10 {
          -ms-flex-preferred-size: 83.3333333333%;
              flex-basis: 83.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 83.3333333333%;
        }
      
        .flex.order-lg10 {
          -webkit-box-ordinal-group: 11;
              -ms-flex-order: 10;
                  order: 10;
        }
      
        .flex.lg9 {
          -ms-flex-preferred-size: 75%;
              flex-basis: 75%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 75%;
        }
      
        .flex.order-lg9 {
          -webkit-box-ordinal-group: 10;
              -ms-flex-order: 9;
                  order: 9;
        }
      
        .flex.lg8 {
          -ms-flex-preferred-size: 66.6666666667%;
              flex-basis: 66.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 66.6666666667%;
        }
      
        .flex.order-lg8 {
          -webkit-box-ordinal-group: 9;
              -ms-flex-order: 8;
                  order: 8;
        }
      
        .flex.lg7 {
          -ms-flex-preferred-size: 58.3333333333%;
              flex-basis: 58.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 58.3333333333%;
        }
      
        .flex.order-lg7 {
          -webkit-box-ordinal-group: 8;
              -ms-flex-order: 7;
                  order: 7;
        }
      
        .flex.lg6 {
          -ms-flex-preferred-size: 50%;
              flex-basis: 50%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 50%;
        }
      
        .flex.order-lg6 {
          -webkit-box-ordinal-group: 7;
              -ms-flex-order: 6;
                  order: 6;
        }
      
        .flex.lg5 {
          -ms-flex-preferred-size: 41.6666666667%;
              flex-basis: 41.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 41.6666666667%;
        }
      
        .flex.order-lg5 {
          -webkit-box-ordinal-group: 6;
              -ms-flex-order: 5;
                  order: 5;
        }
      
        .flex.lg4 {
          -ms-flex-preferred-size: 33.3333333333%;
              flex-basis: 33.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 33.3333333333%;
        }
      
        .flex.order-lg4 {
          -webkit-box-ordinal-group: 5;
              -ms-flex-order: 4;
                  order: 4;
        }
      
        .flex.lg3 {
          -ms-flex-preferred-size: 25%;
              flex-basis: 25%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 25%;
        }
      
        .flex.order-lg3 {
          -webkit-box-ordinal-group: 4;
              -ms-flex-order: 3;
                  order: 3;
        }
      
        .flex.lg2 {
          -ms-flex-preferred-size: 16.6666666667%;
              flex-basis: 16.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 16.6666666667%;
        }
      
        .flex.order-lg2 {
          -webkit-box-ordinal-group: 3;
              -ms-flex-order: 2;
                  order: 2;
        }
      
        .flex.lg1 {
          -ms-flex-preferred-size: 8.3333333333%;
              flex-basis: 8.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 8.3333333333%;
        }
      
        .flex.order-lg1 {
          -webkit-box-ordinal-group: 2;
              -ms-flex-order: 1;
                  order: 1;
        }
      
        .flex.offset-lg12 {
          margin-left: 100%;
        }
      
        .flex.offset-lg11 {
          margin-left: 91.6666666667%;
        }
      
        .flex.offset-lg10 {
          margin-left: 83.3333333333%;
        }
      
        .flex.offset-lg9 {
          margin-left: 75%;
        }
      
        .flex.offset-lg8 {
          margin-left: 66.6666666667%;
        }
      
        .flex.offset-lg7 {
          margin-left: 58.3333333333%;
        }
      
        .flex.offset-lg6 {
          margin-left: 50%;
        }
      
        .flex.offset-lg5 {
          margin-left: 41.6666666667%;
        }
      
        .flex.offset-lg4 {
          margin-left: 33.3333333333%;
        }
      
        .flex.offset-lg3 {
          margin-left: 25%;
        }
      
        .flex.offset-lg2 {
          margin-left: 16.6666666667%;
        }
      
        .flex.offset-lg1 {
          margin-left: 8.3333333333%;
        }
      
        .flex.offset-lg0 {
          margin-left: 0%;
        }
      }
      @media all and (min-width: 1904px) {
        .flex.xl12 {
          -ms-flex-preferred-size: 100%;
              flex-basis: 100%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 100%;
        }
      
        .flex.order-xl12 {
          -webkit-box-ordinal-group: 13;
              -ms-flex-order: 12;
                  order: 12;
        }
      
        .flex.xl11 {
          -ms-flex-preferred-size: 91.6666666667%;
              flex-basis: 91.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 91.6666666667%;
        }
      
        .flex.order-xl11 {
          -webkit-box-ordinal-group: 12;
              -ms-flex-order: 11;
                  order: 11;
        }
      
        .flex.xl10 {
          -ms-flex-preferred-size: 83.3333333333%;
              flex-basis: 83.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 83.3333333333%;
        }
      
        .flex.order-xl10 {
          -webkit-box-ordinal-group: 11;
              -ms-flex-order: 10;
                  order: 10;
        }
      
        .flex.xl9 {
          -ms-flex-preferred-size: 75%;
              flex-basis: 75%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 75%;
        }
      
        .flex.order-xl9 {
          -webkit-box-ordinal-group: 10;
              -ms-flex-order: 9;
                  order: 9;
        }
      
        .flex.xl8 {
          -ms-flex-preferred-size: 66.6666666667%;
              flex-basis: 66.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 66.6666666667%;
        }
      
        .flex.order-xl8 {
          -webkit-box-ordinal-group: 9;
              -ms-flex-order: 8;
                  order: 8;
        }
      
        .flex.xl7 {
          -ms-flex-preferred-size: 58.3333333333%;
              flex-basis: 58.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 58.3333333333%;
        }
      
        .flex.order-xl7 {
          -webkit-box-ordinal-group: 8;
              -ms-flex-order: 7;
                  order: 7;
        }
      
        .flex.xl6 {
          -ms-flex-preferred-size: 50%;
              flex-basis: 50%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 50%;
        }
      
        .flex.order-xl6 {
          -webkit-box-ordinal-group: 7;
              -ms-flex-order: 6;
                  order: 6;
        }
      
        .flex.xl5 {
          -ms-flex-preferred-size: 41.6666666667%;
              flex-basis: 41.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 41.6666666667%;
        }
      
        .flex.order-xl5 {
          -webkit-box-ordinal-group: 6;
              -ms-flex-order: 5;
                  order: 5;
        }
      
        .flex.xl4 {
          -ms-flex-preferred-size: 33.3333333333%;
              flex-basis: 33.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 33.3333333333%;
        }
      
        .flex.order-xl4 {
          -webkit-box-ordinal-group: 5;
              -ms-flex-order: 4;
                  order: 4;
        }
      
        .flex.xl3 {
          -ms-flex-preferred-size: 25%;
              flex-basis: 25%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 25%;
        }
      
        .flex.order-xl3 {
          -webkit-box-ordinal-group: 4;
              -ms-flex-order: 3;
                  order: 3;
        }
      
        .flex.xl2 {
          -ms-flex-preferred-size: 16.6666666667%;
              flex-basis: 16.6666666667%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 16.6666666667%;
        }
      
        .flex.order-xl2 {
          -webkit-box-ordinal-group: 3;
              -ms-flex-order: 2;
                  order: 2;
        }
      
        .flex.xl1 {
          -ms-flex-preferred-size: 8.3333333333%;
              flex-basis: 8.3333333333%;
          -webkit-box-flex: 0;
              -ms-flex-positive: 0;
                  flex-grow: 0;
          max-width: 8.3333333333%;
        }
      
        .flex.order-xl1 {
          -webkit-box-ordinal-group: 2;
              -ms-flex-order: 1;
                  order: 1;
        }
      
        .flex.offset-xl12 {
          margin-left: 100%;
        }
      
        .flex.offset-xl11 {
          margin-left: 91.6666666667%;
        }
      
        .flex.offset-xl10 {
          margin-left: 83.3333333333%;
        }
      
        .flex.offset-xl9 {
          margin-left: 75%;
        }
      
        .flex.offset-xl8 {
          margin-left: 66.6666666667%;
        }
      
        .flex.offset-xl7 {
          margin-left: 58.3333333333%;
        }
      
        .flex.offset-xl6 {
          margin-left: 50%;
        }
      
        .flex.offset-xl5 {
          margin-left: 41.6666666667%;
        }
      
        .flex.offset-xl4 {
          margin-left: 33.3333333333%;
        }
      
        .flex.offset-xl3 {
          margin-left: 25%;
        }
      
        .flex.offset-xl2 {
          margin-left: 16.6666666667%;
        }
      
        .flex.offset-xl1 {
          margin-left: 8.3333333333%;
        }
      
        .flex.offset-xl0 {
          margin-left: 0%;
        }
      }
      .flex,
      .child-flex > * {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        max-width: 100%;
      }
      .flex.grow-shrink-0,
      .child-flex > *.grow-shrink-0 {
        -webkit-box-flex: 0;
            -ms-flex-positive: 0;
                flex-grow: 0;
        -ms-flex-negative: 0;
            flex-shrink: 0;
      }
      
      .spacer {
        -webkit-box-flex: 1 !important;
            -ms-flex-positive: 1 !important;
                flex-grow: 1 !important;
      }
      
      .grow {
        -webkit-box-flex: 1 !important;
            -ms-flex-positive: 1 !important;
                flex-grow: 1 !important;
        -ms-flex-negative: 0 !important;
            flex-shrink: 0 !important;
      }
      
      .shrink {
        -webkit-box-flex: 0 !important;
            -ms-flex-positive: 0 !important;
                flex-grow: 0 !important;
        -ms-flex-negative: 1 !important;
            flex-shrink: 1 !important;
      }
      
      .fill-height {
        height: 100%;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .container {
        width: 100%;
        padding: 12px;
        margin-right: auto;
        margin-left: auto;
      }
      @media (min-width: 960px) {
        .container {
          max-width: 960px;
        }
      }
      @media (min-width: 1264px) {
        .container {
          max-width: 1264px;
        }
      }
      @media (min-width: 1904px) {
        .container {
          max-width: 1904px;
        }
      }
      .container--fluid {
        max-width: 100%;
      }
      
      .row {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        margin-right: -12px;
        margin-left: -12px;
      }
      .row--dense {
        margin-right: -4px;
        margin-left: -4px;
      }
      .row--dense > .col,
      .row--dense > [class*=col-] {
        padding: 4px;
      }
      
      .no-gutters {
        margin-right: 0;
        margin-left: 0;
      }
      .no-gutters > .col,
      .no-gutters > [class*=col-] {
        padding: 0;
      }
      
      .col-xl,
      .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
      .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
      .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
      .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
      .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
        width: 100%;
        padding: 12px;
      }
      
      .col {
        -ms-flex-preferred-size: 0;
            flex-basis: 0;
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        max-width: 100%;
      }
      
      .col-auto {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
                flex: 0 0 auto;
        width: auto;
        max-width: 100%;
      }
      
      .col-1 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 8.3333333333%;
                flex: 0 0 8.3333333333%;
        max-width: 8.3333333333%;
      }
      
      .col-2 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 16.6666666667%;
                flex: 0 0 16.6666666667%;
        max-width: 16.6666666667%;
      }
      
      .col-3 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 25%;
                flex: 0 0 25%;
        max-width: 25%;
      }
      
      .col-4 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 33.3333333333%;
                flex: 0 0 33.3333333333%;
        max-width: 33.3333333333%;
      }
      
      .col-5 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 41.6666666667%;
                flex: 0 0 41.6666666667%;
        max-width: 41.6666666667%;
      }
      
      .col-6 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 50%;
                flex: 0 0 50%;
        max-width: 50%;
      }
      
      .col-7 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 58.3333333333%;
                flex: 0 0 58.3333333333%;
        max-width: 58.3333333333%;
      }
      
      .col-8 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 66.6666666667%;
                flex: 0 0 66.6666666667%;
        max-width: 66.6666666667%;
      }
      
      .col-9 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 75%;
                flex: 0 0 75%;
        max-width: 75%;
      }
      
      .col-10 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 83.3333333333%;
                flex: 0 0 83.3333333333%;
        max-width: 83.3333333333%;
      }
      
      .col-11 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 91.6666666667%;
                flex: 0 0 91.6666666667%;
        max-width: 91.6666666667%;
      }
      
      .col-12 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 100%;
                flex: 0 0 100%;
        max-width: 100%;
      }
      
      .offset-1 {
        margin-left: 8.3333333333%;
      }
      
      .offset-2 {
        margin-left: 16.6666666667%;
      }
      
      .offset-3 {
        margin-left: 25%;
      }
      
      .offset-4 {
        margin-left: 33.3333333333%;
      }
      
      .offset-5 {
        margin-left: 41.6666666667%;
      }
      
      .offset-6 {
        margin-left: 50%;
      }
      
      .offset-7 {
        margin-left: 58.3333333333%;
      }
      
      .offset-8 {
        margin-left: 66.6666666667%;
      }
      
      .offset-9 {
        margin-left: 75%;
      }
      
      .offset-10 {
        margin-left: 83.3333333333%;
      }
      
      .offset-11 {
        margin-left: 91.6666666667%;
      }
      
      @media (min-width: 600px) {
        .col-sm {
          -ms-flex-preferred-size: 0;
              flex-basis: 0;
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          max-width: 100%;
        }
      
        .col-sm-auto {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 auto;
                  flex: 0 0 auto;
          width: auto;
          max-width: 100%;
        }
      
        .col-sm-1 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 8.3333333333%;
                  flex: 0 0 8.3333333333%;
          max-width: 8.3333333333%;
        }
      
        .col-sm-2 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 16.6666666667%;
                  flex: 0 0 16.6666666667%;
          max-width: 16.6666666667%;
        }
      
        .col-sm-3 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 25%;
                  flex: 0 0 25%;
          max-width: 25%;
        }
      
        .col-sm-4 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 33.3333333333%;
                  flex: 0 0 33.3333333333%;
          max-width: 33.3333333333%;
        }
      
        .col-sm-5 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 41.6666666667%;
                  flex: 0 0 41.6666666667%;
          max-width: 41.6666666667%;
        }
      
        .col-sm-6 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 50%;
                  flex: 0 0 50%;
          max-width: 50%;
        }
      
        .col-sm-7 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 58.3333333333%;
                  flex: 0 0 58.3333333333%;
          max-width: 58.3333333333%;
        }
      
        .col-sm-8 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 66.6666666667%;
                  flex: 0 0 66.6666666667%;
          max-width: 66.6666666667%;
        }
      
        .col-sm-9 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 75%;
                  flex: 0 0 75%;
          max-width: 75%;
        }
      
        .col-sm-10 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 83.3333333333%;
                  flex: 0 0 83.3333333333%;
          max-width: 83.3333333333%;
        }
      
        .col-sm-11 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 91.6666666667%;
                  flex: 0 0 91.6666666667%;
          max-width: 91.6666666667%;
        }
      
        .col-sm-12 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
          max-width: 100%;
        }
      
        .offset-sm-0 {
          margin-left: 0;
        }
      
        .offset-sm-1 {
          margin-left: 8.3333333333%;
        }
      
        .offset-sm-2 {
          margin-left: 16.6666666667%;
        }
      
        .offset-sm-3 {
          margin-left: 25%;
        }
      
        .offset-sm-4 {
          margin-left: 33.3333333333%;
        }
      
        .offset-sm-5 {
          margin-left: 41.6666666667%;
        }
      
        .offset-sm-6 {
          margin-left: 50%;
        }
      
        .offset-sm-7 {
          margin-left: 58.3333333333%;
        }
      
        .offset-sm-8 {
          margin-left: 66.6666666667%;
        }
      
        .offset-sm-9 {
          margin-left: 75%;
        }
      
        .offset-sm-10 {
          margin-left: 83.3333333333%;
        }
      
        .offset-sm-11 {
          margin-left: 91.6666666667%;
        }
      }
      @media (min-width: 960px) {
        .col-md {
          -ms-flex-preferred-size: 0;
              flex-basis: 0;
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          max-width: 100%;
        }
      
        .col-md-auto {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 auto;
                  flex: 0 0 auto;
          width: auto;
          max-width: 100%;
        }
      
        .col-md-1 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 8.3333333333%;
                  flex: 0 0 8.3333333333%;
          max-width: 8.3333333333%;
        }
      
        .col-md-2 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 16.6666666667%;
                  flex: 0 0 16.6666666667%;
          max-width: 16.6666666667%;
        }
      
        .col-md-3 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 25%;
                  flex: 0 0 25%;
          max-width: 25%;
        }
      
        .col-md-4 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 33.3333333333%;
                  flex: 0 0 33.3333333333%;
          max-width: 33.3333333333%;
        }
      
        .col-md-5 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 41.6666666667%;
                  flex: 0 0 41.6666666667%;
          max-width: 41.6666666667%;
        }
      
        .col-md-6 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 50%;
                  flex: 0 0 50%;
          max-width: 50%;
        }
      
        .col-md-7 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 58.3333333333%;
                  flex: 0 0 58.3333333333%;
          max-width: 58.3333333333%;
        }
      
        .col-md-8 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 66.6666666667%;
                  flex: 0 0 66.6666666667%;
          max-width: 66.6666666667%;
        }
      
        .col-md-9 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 75%;
                  flex: 0 0 75%;
          max-width: 75%;
        }
      
        .col-md-10 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 83.3333333333%;
                  flex: 0 0 83.3333333333%;
          max-width: 83.3333333333%;
        }
      
        .col-md-11 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 91.6666666667%;
                  flex: 0 0 91.6666666667%;
          max-width: 91.6666666667%;
        }
      
        .col-md-12 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
          max-width: 100%;
        }
      
        .offset-md-0 {
          margin-left: 0;
        }
      
        .offset-md-1 {
          margin-left: 8.3333333333%;
        }
      
        .offset-md-2 {
          margin-left: 16.6666666667%;
        }
      
        .offset-md-3 {
          margin-left: 25%;
        }
      
        .offset-md-4 {
          margin-left: 33.3333333333%;
        }
      
        .offset-md-5 {
          margin-left: 41.6666666667%;
        }
      
        .offset-md-6 {
          margin-left: 50%;
        }
      
        .offset-md-7 {
          margin-left: 58.3333333333%;
        }
      
        .offset-md-8 {
          margin-left: 66.6666666667%;
        }
      
        .offset-md-9 {
          margin-left: 75%;
        }
      
        .offset-md-10 {
          margin-left: 83.3333333333%;
        }
      
        .offset-md-11 {
          margin-left: 91.6666666667%;
        }
      }
      @media (min-width: 1264px) {
        .col-lg {
          -ms-flex-preferred-size: 0;
              flex-basis: 0;
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          max-width: 100%;
        }
      
        .col-lg-auto {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 auto;
                  flex: 0 0 auto;
          width: auto;
          max-width: 100%;
        }
      
        .col-lg-1 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 8.3333333333%;
                  flex: 0 0 8.3333333333%;
          max-width: 8.3333333333%;
        }
      
        .col-lg-2 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 16.6666666667%;
                  flex: 0 0 16.6666666667%;
          max-width: 16.6666666667%;
        }
      
        .col-lg-3 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 25%;
                  flex: 0 0 25%;
          max-width: 25%;
        }
      
        .col-lg-4 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 33.3333333333%;
                  flex: 0 0 33.3333333333%;
          max-width: 33.3333333333%;
        }
      
        .col-lg-5 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 41.6666666667%;
                  flex: 0 0 41.6666666667%;
          max-width: 41.6666666667%;
        }
      
        .col-lg-6 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 50%;
                  flex: 0 0 50%;
          max-width: 50%;
        }
      
        .col-lg-7 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 58.3333333333%;
                  flex: 0 0 58.3333333333%;
          max-width: 58.3333333333%;
        }
      
        .col-lg-8 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 66.6666666667%;
                  flex: 0 0 66.6666666667%;
          max-width: 66.6666666667%;
        }
      
        .col-lg-9 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 75%;
                  flex: 0 0 75%;
          max-width: 75%;
        }
      
        .col-lg-10 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 83.3333333333%;
                  flex: 0 0 83.3333333333%;
          max-width: 83.3333333333%;
        }
      
        .col-lg-11 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 91.6666666667%;
                  flex: 0 0 91.6666666667%;
          max-width: 91.6666666667%;
        }
      
        .col-lg-12 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
          max-width: 100%;
        }
      
        .offset-lg-0 {
          margin-left: 0;
        }
      
        .offset-lg-1 {
          margin-left: 8.3333333333%;
        }
      
        .offset-lg-2 {
          margin-left: 16.6666666667%;
        }
      
        .offset-lg-3 {
          margin-left: 25%;
        }
      
        .offset-lg-4 {
          margin-left: 33.3333333333%;
        }
      
        .offset-lg-5 {
          margin-left: 41.6666666667%;
        }
      
        .offset-lg-6 {
          margin-left: 50%;
        }
      
        .offset-lg-7 {
          margin-left: 58.3333333333%;
        }
      
        .offset-lg-8 {
          margin-left: 66.6666666667%;
        }
      
        .offset-lg-9 {
          margin-left: 75%;
        }
      
        .offset-lg-10 {
          margin-left: 83.3333333333%;
        }
      
        .offset-lg-11 {
          margin-left: 91.6666666667%;
        }
      }
      @media (min-width: 1904px) {
        .col-xl {
          -ms-flex-preferred-size: 0;
              flex-basis: 0;
          -webkit-box-flex: 1;
              -ms-flex-positive: 1;
                  flex-grow: 1;
          max-width: 100%;
        }
      
        .col-xl-auto {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 auto;
                  flex: 0 0 auto;
          width: auto;
          max-width: 100%;
        }
      
        .col-xl-1 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 8.3333333333%;
                  flex: 0 0 8.3333333333%;
          max-width: 8.3333333333%;
        }
      
        .col-xl-2 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 16.6666666667%;
                  flex: 0 0 16.6666666667%;
          max-width: 16.6666666667%;
        }
      
        .col-xl-3 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 25%;
                  flex: 0 0 25%;
          max-width: 25%;
        }
      
        .col-xl-4 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 33.3333333333%;
                  flex: 0 0 33.3333333333%;
          max-width: 33.3333333333%;
        }
      
        .col-xl-5 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 41.6666666667%;
                  flex: 0 0 41.6666666667%;
          max-width: 41.6666666667%;
        }
      
        .col-xl-6 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 50%;
                  flex: 0 0 50%;
          max-width: 50%;
        }
      
        .col-xl-7 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 58.3333333333%;
                  flex: 0 0 58.3333333333%;
          max-width: 58.3333333333%;
        }
      
        .col-xl-8 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 66.6666666667%;
                  flex: 0 0 66.6666666667%;
          max-width: 66.6666666667%;
        }
      
        .col-xl-9 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 75%;
                  flex: 0 0 75%;
          max-width: 75%;
        }
      
        .col-xl-10 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 83.3333333333%;
                  flex: 0 0 83.3333333333%;
          max-width: 83.3333333333%;
        }
      
        .col-xl-11 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 91.6666666667%;
                  flex: 0 0 91.6666666667%;
          max-width: 91.6666666667%;
        }
      
        .col-xl-12 {
          -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
          max-width: 100%;
        }
      
        .offset-xl-0 {
          margin-left: 0;
        }
      
        .offset-xl-1 {
          margin-left: 8.3333333333%;
        }
      
        .offset-xl-2 {
          margin-left: 16.6666666667%;
        }
      
        .offset-xl-3 {
          margin-left: 25%;
        }
      
        .offset-xl-4 {
          margin-left: 33.3333333333%;
        }
      
        .offset-xl-5 {
          margin-left: 41.6666666667%;
        }
      
        .offset-xl-6 {
          margin-left: 50%;
        }
      
        .offset-xl-7 {
          margin-left: 58.3333333333%;
        }
      
        .offset-xl-8 {
          margin-left: 66.6666666667%;
        }
      
        .offset-xl-9 {
          margin-left: 75%;
        }
      
        .offset-xl-10 {
          margin-left: 83.3333333333%;
        }
      
        .offset-xl-11 {
          margin-left: 91.6666666667%;
        }
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-navigation-drawer {
        background-color: #FFFFFF;
      }
      .theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
        background-color: rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-navigation-drawer .v-divider {
        border-color: rgba(0, 0, 0, 0.12);
      }
      
      .theme--dark.v-navigation-drawer {
        background-color: #424242;
      }
      .theme--dark.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
        background-color: rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-navigation-drawer .v-divider {
        border-color: rgba(255, 255, 255, 0.12);
      }
      
      .v-navigation-drawer {
        -webkit-overflow-scrolling: touch;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        left: 0;
        max-width: 100%;
        overflow: hidden;
        pointer-events: auto;
        top: 0;
        -webkit-transition-duration: 0.2s;
                transition-duration: 0.2s;
        -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        will-change: transform;
        -webkit-transition-property: width, -webkit-transform;
        transition-property: width, -webkit-transform;
        transition-property: transform, width;
        transition-property: transform, width, -webkit-transform;
      }
      .v-navigation-drawer:not([data-booted=true]) {
        -webkit-transition: none !important;
        transition: none !important;
      }
      .v-navigation-drawer.v-navigation-drawer--right:after {
        left: 0;
        right: initial;
      }
      .v-navigation-drawer .v-list {
        background: inherit;
      }
      
      .v-navigation-drawer__border {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 1px;
      }
      
      .v-navigation-drawer__content {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
      }
      
      .v-navigation-drawer__image {
        border-radius: inherit;
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: -1;
        contain: strict;
        width: 100%;
      }
      .v-navigation-drawer__image .v-image {
        border-radius: inherit;
      }
      
      .v-navigation-drawer--bottom.v-navigation-drawer--is-mobile {
        max-height: 50%;
        top: auto;
        bottom: 0;
        min-width: 100%;
      }
      
      .v-navigation-drawer--right {
        left: auto;
        right: 0;
      }
      .v-navigation-drawer--right > .v-navigation-drawer__border {
        right: auto;
        left: 0;
      }
      
      .v-navigation-drawer--absolute {
        z-index: 1;
      }
      
      .v-navigation-drawer--fixed {
        z-index: 6;
      }
      
      .v-navigation-drawer--absolute {
        position: absolute;
      }
      
      .v-navigation-drawer--clipped {
        z-index: 4;
      }
      
      .v-navigation-drawer--fixed {
        position: fixed;
      }
      
      .v-navigation-drawer--floating:after {
        display: none;
      }
      
      .v-navigation-drawer--mini-variant {
        overflow: hidden;
      }
      .v-navigation-drawer--mini-variant .v-list-item {
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
      }
      .v-navigation-drawer--mini-variant .v-list-item > *:first-child {
        margin-left: 0;
        margin-right: 0;
      }
      .v-navigation-drawer--mini-variant .v-list-item > *:not(:first-child) {
        display: none;
      }
      .v-navigation-drawer--mini-variant .v-list-group--no-action .v-list-group__items,
      .v-navigation-drawer--mini-variant .v-list-group--sub-group {
        display: none;
      }
      
      .v-navigation-drawer--temporary,
      .v-navigation-drawer--is-mobile {
        z-index: 6;
      }
      .v-navigation-drawer--temporary:not(.v-navigation-drawer--close),
      .v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close) {
        -webkit-box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-overflow-btn .v-input__control::before,
      .theme--light.v-overflow-btn .v-input__slot::before {
        background-color: rgba(0, 0, 0, 0.12) !important;
      }
      .theme--light.v-overflow-btn.v-text-field--outline .v-input__control::before,
      .theme--light.v-overflow-btn.v-text-field--outline .v-input__slot::before {
        background-color: transparent !important;
      }
      .theme--light.v-overflow-btn--segmented .v-input__append-inner, .theme--light.v-overflow-btn--editable:hover .v-input__append-inner, .theme--light.v-overflow-btn--editable.v-input--is-focused .v-input__append-inner, .theme--light.v-overflow-btn--editable.v-select--is-menu-active .v-input__append-inner {
        border-left: 1px solid rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-overflow-btn:hover .v-input__slot, .theme--light.v-overflow-btn.v-input--is-focused .v-input__slot, .theme--light.v-overflow-btn.v-select--is-menu-active .v-input__slot {
        background: #FFFFFF;
      }
      
      .theme--dark.v-overflow-btn .v-input__control::before,
      .theme--dark.v-overflow-btn .v-input__slot::before {
        background-color: rgba(255, 255, 255, 0.12) !important;
      }
      .theme--dark.v-overflow-btn.v-text-field--outline .v-input__control::before,
      .theme--dark.v-overflow-btn.v-text-field--outline .v-input__slot::before {
        background-color: transparent !important;
      }
      .theme--dark.v-overflow-btn--segmented .v-input__append-inner, .theme--dark.v-overflow-btn--editable:hover .v-input__append-inner, .theme--dark.v-overflow-btn--editable.v-input--is-focused .v-input__append-inner, .theme--dark.v-overflow-btn--editable.v-select--is-menu-active .v-input__append-inner {
        border-left: 1px solid rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-overflow-btn:hover .v-input__slot, .theme--dark.v-overflow-btn.v-input--is-focused .v-input__slot, .theme--dark.v-overflow-btn.v-select--is-menu-active .v-input__slot {
        background: #424242;
      }
      
      .v-overflow-btn {
        margin-top: 12px;
        padding-top: 0;
      }
      .v-overflow-btn:not(.v-overflow-btn--editable) > .v-input__control > .v-input__slot {
        cursor: pointer;
      }
      .v-overflow-btn .v-select__slot {
        height: 48px;
      }
      .v-overflow-btn .v-select__slot input {
        margin-left: 16px;
        cursor: pointer;
      }
      .v-overflow-btn .v-select__selection--comma:first-child {
        margin-left: 16px;
      }
      .v-overflow-btn .v-input__slot {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-overflow-btn .v-input__slot::after {
        content: none;
      }
      .v-overflow-btn .v-label {
        margin-left: 16px;
        top: calc(50% - 10px);
      }
      .v-overflow-btn .v-input__append-inner {
        width: 48px;
        height: 48px;
        -ms-flex-item-align: auto;
            align-self: auto;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        margin-top: 0;
        padding: 0;
        -ms-flex-negative: 0;
            flex-shrink: 0;
      }
      .v-overflow-btn .v-input__append-outer,
      .v-overflow-btn .v-input__prepend-outer {
        margin-top: 12px;
        margin-bottom: 12px;
      }
      .v-overflow-btn .v-input__control::before {
        height: 1px;
        top: -1px;
        content: "";
        left: 0;
        position: absolute;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        width: 100%;
      }
      .v-overflow-btn.v-input--is-focused .v-input__slot, .v-overflow-btn.v-select--is-menu-active .v-input__slot {
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
      .v-overflow-btn .v-select__selections {
        width: 0px;
      }
      .v-overflow-btn--segmented .v-select__selections {
        -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
      }
      .v-overflow-btn--segmented .v-select__selections .v-btn {
        border-radius: 0;
        margin: 0;
        margin-right: -16px;
        height: 48px;
        width: 100%;
      }
      .v-overflow-btn--segmented .v-select__selections .v-btn__content {
        -webkit-box-pack: start;
            -ms-flex-pack: start;
                justify-content: start;
      }
      .v-overflow-btn--segmented .v-select__selections .v-btn__content::before {
        background-color: transparent;
      }
      .v-overflow-btn--editable .v-select__slot input {
        cursor: text;
      }
      .v-overflow-btn--editable .v-input__append-inner,
      .v-overflow-btn--editable .v-input__append-inner * {
        cursor: pointer;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-pagination .v-pagination__item {
        background: #FFFFFF;
        color: rgba(0, 0, 0, 0.87);
        min-width: 34px;
        padding: 0 5px;
        width: auto;
      }
      .theme--light.v-pagination .v-pagination__item--active {
        color: #FFFFFF;
      }
      .theme--light.v-pagination .v-pagination__navigation {
        background: #FFFFFF;
      }
      
      .theme--dark.v-pagination .v-pagination__item {
        background: #424242;
        color: #FFFFFF;
        min-width: 34px;
        padding: 0 5px;
        width: auto;
      }
      .theme--dark.v-pagination .v-pagination__item--active {
        color: #FFFFFF;
      }
      .theme--dark.v-pagination .v-pagination__navigation {
        background: #424242;
      }
      
      .v-pagination {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        list-style-type: none;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        margin: 0;
        max-width: 100%;
        width: 100%;
      }
      .v-pagination.v-pagination {
        padding-left: 0;
      }
      .v-pagination > li {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .v-pagination--circle .v-pagination__item,
      .v-pagination--circle .v-pagination__more,
      .v-pagination--circle .v-pagination__navigation {
        border-radius: 50%;
      }
      .v-pagination--disabled {
        pointer-events: none;
        opacity: 0.6;
      }
      .v-pagination__item {
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        font-size: 14px;
        background: transparent;
        height: 34px;
        width: 34px;
        margin: 0.3rem;
        text-decoration: none;
        -webkit-transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
        transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
      }
      .v-pagination__item--active {
        -webkit-box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
      }
      .v-pagination__navigation {
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        text-decoration: none;
        height: 2rem;
        border-radius: 4px;
        width: 2rem;
        margin: 0.3rem 10px;
      }
      .v-pagination__navigation .v-icon {
        font-size: 2rem;
        -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);
        transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);
        vertical-align: middle;
      }
      .v-pagination__navigation--disabled {
        opacity: 0.6;
        pointer-events: none;
      }
      .v-pagination__more {
        margin: 0.3rem;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-align: end;
            -ms-flex-align: end;
                align-items: flex-end;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        height: 2rem;
        width: 2rem;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-parallax {
        position: relative;
        overflow: hidden;
        z-index: 0;
      }
      .v-parallax__image-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        contain: strict;
      }
      .v-parallax__image {
        position: absolute;
        bottom: 0;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        display: none;
        -webkit-transform: translate(-50%, 0);
                transform: translate(-50%, 0);
        will-change: transform;
        -webkit-transition: 0.3s opacity cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s opacity cubic-bezier(0.25, 0.8, 0.5, 1);
        z-index: 1;
      }
      .v-parallax__content {
        color: #FFFFFF;
        height: 100%;
        z-index: 2;
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        padding: 0 1rem;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-input--radio-group__input {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
      }
      .v-input--radio-group--column .v-input--radio-group__input > .v-label {
        padding-bottom: 8px;
      }
      .v-input--radio-group--row .v-input--radio-group__input > .v-label {
        padding-right: 8px;
      }
      .v-input--radio-group--row .v-input--radio-group__input {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
      }
      .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
        margin-bottom: 8px;
      }
      .v-input--radio-group--column .v-input--radio-group__input {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-radio--is-disabled label {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-radio--is-disabled .v-icon {
        color: rgba(0, 0, 0, 0.26) !important;
      }
      
      .theme--dark.v-radio--is-disabled label {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-radio--is-disabled .v-icon {
        color: rgba(255, 255, 255, 0.3) !important;
      }
      
      .v-radio {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: auto;
        margin-right: 16px;
        outline: none;
      }
      .v-radio--is-disabled {
        pointer-events: none;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-input--range-slider.v-input--slider.v-input--is-disabled .v-slider.v-slider .v-slider__thumb {
        background: #fafafa;
      }
      
      .theme--dark.v-input--range-slider.v-input--slider.v-input--is-disabled .v-slider.v-slider .v-slider__thumb {
        background: #424242;
      }
      
      /** Input Group */
      .v-input--range-slider.v-input--is-disabled .v-slider__track-fill {
        display: none;
      }
      .v-input--range-slider.v-input--is-disabled.v-input--slider .v-slider.v-slider .v-slider__thumb {
        border-color: transparent;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-rating {
        max-width: 100%;
        white-space: nowrap;
      }
      .v-rating .v-icon {
        padding: 0.5rem;
        border-radius: 50%;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-rating--readonly .v-icon {
        pointer-events: none;
      }
      .v-rating--dense .v-icon {
        padding: 0.1rem;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-snack {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        color: #FFFFFF;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        font-size: 14px;
        left: 8px;
        pointer-events: none;
        position: fixed;
        right: 8px;
        text-align: left;
        -webkit-transition-duration: 0.15s;
                transition-duration: 0.15s;
        -webkit-transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
                transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
        z-index: 1000;
      }
      .v-snack--absolute {
        position: absolute;
      }
      .v-snack--top {
        top: 8px;
      }
      .v-snack--bottom {
        bottom: 8px;
      }
      .v-snack__wrapper {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        background-color: #323232;
        border-radius: 4px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin: 0 auto;
        pointer-events: auto;
        -webkit-transition: inherit;
        transition: inherit;
        -webkit-transition-property: opacity, -webkit-transform;
        transition-property: opacity, -webkit-transform;
        transition-property: opacity, transform;
        transition-property: opacity, transform, -webkit-transform;
        min-width: 100%;
        -webkit-box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
      }
      .v-snack__content {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        min-height: 48px;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        overflow: hidden;
        padding: 8px 16px;
        width: 100%;
      }
      .v-snack__content .v-btn.v-btn {
        color: #FFFFFF;
        -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
                flex: 0 0 auto;
        height: auto;
        margin: 0 -8px 0 24px;
        min-width: auto;
        padding: 8px;
        width: auto;
      }
      .v-snack__content .v-btn.v-btn__content {
        margin: -2px;
      }
      .v-application--is-rtl .v-snack__content .v-btn.v-btn {
        margin: 0 24px 0 -8px;
      }
      .v-snack__content .v-btn.v-btn::before {
        display: none;
      }
      .v-snack--multi-line .v-snack__content {
        height: auto;
        min-height: 68px;
      }
      .v-snack--vertical .v-snack__content {
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        height: auto;
        padding: 16px 16px 8px;
      }
      .v-snack--vertical .v-snack__content .v-btn.v-btn {
        -ms-flex-item-align: end;
            align-self: flex-end;
        justify-self: flex-end;
        margin-left: 0;
        margin-top: 18px;
      }
      .v-snack--vertical .v-snack__content .v-btn__content {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
                flex: 0 0 auto;
        margin: 0;
      }
      
      @media only screen and (min-width: 600px) {
        .v-snack__wrapper {
          min-width: 344px;
          max-width: 672px;
        }
        .v-snack--left .v-snack__wrapper {
          margin-left: 0;
        }
        .v-snack--right .v-snack__wrapper {
          margin-right: 0;
        }
        .v-snack__content .v-btn:first-of-type {
          margin-left: 42px;
        }
        .v-application--is-rtl .v-snack__content .v-btn:first-of-type {
          margin-left: 0;
          margin-right: 42px;
        }
      }
      .v-snack-transition-enter .v-snack__wrapper {
        -webkit-transform: scale(0.8);
                transform: scale(0.8);
      }
      .v-snack-transition-enter .v-snack__wrapper, .v-snack-transition-leave-to .v-snack__wrapper {
        opacity: 0;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-speed-dial {
        position: relative;
      }
      .v-speed-dial--absolute {
        position: absolute;
      }
      .v-speed-dial--fixed {
        position: fixed;
      }
      .v-speed-dial--fixed, .v-speed-dial--absolute {
        z-index: 4;
      }
      .v-speed-dial--fixed > .v-btn--floating, .v-speed-dial--absolute > .v-btn--floating {
        margin: 0;
      }
      .v-speed-dial--top {
        top: 16px;
      }
      .v-speed-dial--bottom {
        bottom: 16px;
      }
      .v-speed-dial--left {
        left: 16px;
      }
      .v-speed-dial--right {
        right: 16px;
      }
      .v-speed-dial--direction-left .v-speed-dial__list, .v-speed-dial--direction-right .v-speed-dial__list {
        height: 100%;
        top: 0;
        padding: 0 16px;
      }
      .v-speed-dial--direction-top .v-speed-dial__list, .v-speed-dial--direction-bottom .v-speed-dial__list {
        left: 0;
        width: 100%;
      }
      .v-speed-dial--direction-top .v-speed-dial__list {
        -webkit-box-orient: vertical;
        -webkit-box-direction: reverse;
            -ms-flex-direction: column-reverse;
                flex-direction: column-reverse;
        bottom: 100%;
      }
      .v-speed-dial--direction-right .v-speed-dial__list {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        left: 100%;
      }
      .v-speed-dial--direction-bottom .v-speed-dial__list {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        top: 100%;
      }
      .v-speed-dial--direction-left .v-speed-dial__list {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: reverse;
            -ms-flex-direction: row-reverse;
                flex-direction: row-reverse;
        right: 100%;
      }
      
      /** Elements */
      .v-speed-dial__list {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        padding: 16px 0;
        position: absolute;
      }
      .v-speed-dial__list .v-btn {
        margin: 6px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-stepper {
        background: #FFFFFF;
      }
      .theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
        background: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-stepper .v-stepper__step__step {
        color: white;
      }
      .theme--light.v-stepper .v-stepper__step__step .v-icon {
        color: white;
      }
      .theme--light.v-stepper .v-stepper__header .v-divider {
        border-color: rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-stepper .v-stepper__step--active .v-stepper__label {
        text-shadow: 0px 0px 0px black;
      }
      .theme--light.v-stepper .v-stepper__step--editable:hover {
        background: rgba(0, 0, 0, 0.06);
      }
      .theme--light.v-stepper .v-stepper__step--editable:hover .v-stepper__label {
        text-shadow: 0px 0px 0px black;
      }
      .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-stepper .v-stepper__step--inactive.v-stepper__step--editable:not(.v-stepper__step--error):hover .v-stepper__step__step {
        background: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-stepper .v-stepper__label {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-stepper .v-stepper__label small {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-stepper--non-linear .v-stepper__step:not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__label {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-stepper--vertical .v-stepper__content:not(:last-child) {
        border-left: 1px solid rgba(0, 0, 0, 0.12);
      }
      
      .theme--dark.v-stepper {
        background: #303030;
      }
      .theme--dark.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
        background: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-stepper .v-stepper__step__step {
        color: white;
      }
      .theme--dark.v-stepper .v-stepper__step__step .v-icon {
        color: white;
      }
      .theme--dark.v-stepper .v-stepper__header .v-divider {
        border-color: rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-stepper .v-stepper__step--active .v-stepper__label {
        text-shadow: 0px 0px 0px white;
      }
      .theme--dark.v-stepper .v-stepper__step--editable:hover {
        background: rgba(255, 255, 255, 0.06);
      }
      .theme--dark.v-stepper .v-stepper__step--editable:hover .v-stepper__label {
        text-shadow: 0px 0px 0px white;
      }
      .theme--dark.v-stepper .v-stepper__step--complete .v-stepper__label {
        color: rgba(255, 255, 255, 0.87);
      }
      .theme--dark.v-stepper .v-stepper__step--inactive.v-stepper__step--editable:not(.v-stepper__step--error):hover .v-stepper__step__step {
        background: rgba(255, 255, 255, 0.75);
      }
      .theme--dark.v-stepper .v-stepper__label {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-stepper .v-stepper__label small {
        color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-stepper--non-linear .v-stepper__step:not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__label {
        color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-stepper--vertical .v-stepper__content:not(:last-child) {
        border-left: 1px solid rgba(255, 255, 255, 0.12);
      }
      
      .v-stepper {
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
      .v-stepper__header {
        height: 72px;
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
      .v-stepper__header .v-divider {
        -ms-flex-item-align: center;
            align-self: center;
        margin: 0 -16px;
      }
      .v-stepper__items {
        position: relative;
        overflow: hidden;
      }
      .v-stepper__step__step {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        border-radius: 50%;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        font-size: 12px;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        height: 24px;
        margin-right: 8px;
        min-width: 24px;
        width: 24px;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      .v-stepper__step__step .v-icon {
        font-size: 18px;
      }
      .v-stepper__step {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        padding: 24px;
        position: relative;
      }
      .v-stepper__step--active .v-stepper__label {
        -webkit-transition: 0.3s cubic-bezier(0.4, 0, 0.6, 1);
        transition: 0.3s cubic-bezier(0.4, 0, 0.6, 1);
      }
      .v-stepper__step--editable {
        cursor: pointer;
      }
      .v-stepper__step.v-stepper__step--error .v-stepper__step__step {
        background: transparent;
        color: inherit;
      }
      .v-stepper__step.v-stepper__step--error .v-stepper__step__step .v-icon {
        font-size: 24px;
        color: inherit;
      }
      .v-stepper__step.v-stepper__step--error .v-stepper__label {
        color: inherit;
        text-shadow: none;
        font-weight: 500;
      }
      .v-stepper__step.v-stepper__step--error .v-stepper__label small {
        color: inherit;
      }
      .v-stepper__label {
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        line-height: 1;
        text-align: left;
      }
      .v-stepper__label small {
        font-size: 12px;
        font-weight: 300;
        text-shadow: none;
      }
      .v-stepper__wrapper {
        overflow: hidden;
        -webkit-transition: none;
        transition: none;
      }
      .v-stepper__content {
        top: 0;
        padding: 24px 24px 16px 24px;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        width: 100%;
      }
      .v-stepper__content > .v-btn {
        margin: 24px 8px 8px 0;
      }
      .v-stepper--is-booted .v-stepper__content, .v-stepper--is-booted .v-stepper__wrapper {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-stepper--vertical {
        padding-bottom: 36px;
      }
      .v-stepper--vertical .v-stepper__content {
        margin: -8px -36px -16px 36px;
        padding: 16px 60px 16px 23px;
        width: auto;
      }
      .v-stepper--vertical .v-stepper__step {
        padding: 24px 24px 16px;
      }
      .v-stepper--vertical .v-stepper__step__step {
        margin-right: 12px;
      }
      .v-stepper--alt-labels .v-stepper__header {
        height: auto;
      }
      .v-stepper--alt-labels .v-stepper__header .v-divider {
        margin: 35px -67px 0;
        -ms-flex-item-align: start;
            align-self: flex-start;
      }
      .v-stepper--alt-labels .v-stepper__step {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-pack: start;
            -ms-flex-pack: start;
                justify-content: flex-start;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -ms-flex-preferred-size: 175px;
            flex-basis: 175px;
      }
      .v-stepper--alt-labels .v-stepper__step small {
        -ms-flex-item-align: center;
            align-self: center;
      }
      .v-stepper--alt-labels .v-stepper__step__step {
        margin-right: 0;
        margin-bottom: 11px;
      }
      .v-application--is-rtl .v-stepper .v-stepper__step__step {
        margin-right: 0;
        margin-left: 12px;
      }
      
      @media only screen and (max-width: 959px) {
        .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
          display: none;
        }
        .v-stepper:not(.v-stepper--vertical) .v-stepper__step__step {
          margin-right: 0;
        }
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-input--switch .v-input--switch__thumb {
        color: #FFFFFF;
      }
      .theme--light.v-input--switch .v-input--switch__track {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-input--switch.v-input--is-disabled:not(.v-input--is-dirty) .v-input--switch__thumb {
        color: #fafafa !important;
      }
      .theme--light.v-input--switch.v-input--is-disabled:not(.v-input--is-dirty) .v-input--switch__track {
        color: rgba(0, 0, 0, 0.12) !important;
      }
      
      .theme--dark.v-input--switch .v-input--switch__thumb {
        color: #bdbdbd;
      }
      .theme--dark.v-input--switch .v-input--switch__track {
        color: rgba(255, 255, 255, 0.3);
      }
      .theme--dark.v-input--switch.v-input--is-disabled:not(.v-input--is-dirty) .v-input--switch__thumb {
        color: #424242 !important;
      }
      .theme--dark.v-input--switch.v-input--is-disabled:not(.v-input--is-dirty) .v-input--switch__track {
        color: rgba(255, 255, 255, 0.1) !important;
      }
      
      .v-input--switch__track, .v-input--switch__thumb {
        background-color: currentColor;
        pointer-events: none;
        -webkit-transition: inherit;
        transition: inherit;
      }
      .v-input--switch__track {
        border-radius: 8px;
        width: 36px;
        height: 14px;
        left: 2px;
        position: absolute;
        opacity: 0.6;
        right: 2px;
        top: calc(50% - 7px);
      }
      .v-input--switch__thumb {
        border-radius: 50%;
        top: calc(50% - 10px);
        height: 20px;
        position: relative;
        width: 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-input--switch .v-input--selection-controls__input {
        width: 38px;
      }
      .v-input--switch .v-input--selection-controls__ripple {
        top: calc(50% - 24px);
      }
      .v-input--switch.v-input--is-dirty.v-input--is-disabled {
        opacity: 0.6;
      }
      .v-application--is-ltr .v-input--switch .v-input--selection-controls__ripple {
        left: -14px;
      }
      .v-application--is-ltr .v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,
      .v-application--is-ltr .v-input--switch.v-input--is-dirty .v-input--switch__thumb {
        -webkit-transform: translate(20px, 0);
                transform: translate(20px, 0);
      }
      .v-application--is-rtl .v-input--switch .v-input--selection-controls__ripple {
        right: -14px;
      }
      .v-application--is-rtl .v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,
      .v-application--is-rtl .v-input--switch.v-input--is-dirty .v-input--switch__thumb {
        -webkit-transform: translate(-20px, 0);
                transform: translate(-20px, 0);
      }
      .v-input--switch:not(.v-input--switch--flat):not(.v-input--switch--inset) .v-input--switch__thumb {
        -webkit-box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
      }
      .v-input--switch--inset .v-input--switch__track,
      .v-input--switch--inset .v-input--selection-controls__input {
        width: 48px;
      }
      .v-input--switch--inset .v-input--switch__track {
        border-radius: 14px;
        height: 28px;
        left: -4px;
        opacity: 0.32;
        top: calc(50% - 14px);
      }
      .v-application--is-ltr .v-input--switch--inset .v-input--selection-controls__ripple,
      .v-application--is-ltr .v-input--switch--inset .v-input--switch__thumb {
        -webkit-transform: translate(0, 0) !important;
                transform: translate(0, 0) !important;
      }
      .v-application--is-ltr .v-input--switch--inset.v-input--is-dirty .v-input--selection-controls__ripple,
      .v-application--is-ltr .v-input--switch--inset.v-input--is-dirty .v-input--switch__thumb {
        -webkit-transform: translate(20px, 0) !important;
                transform: translate(20px, 0) !important;
      }
      .v-application--is-rtl .v-input--switch--inset .v-input--selection-controls__ripple,
      .v-application--is-rtl .v-input--switch--inset .v-input--switch__thumb {
        -webkit-transform: translate(-6px, 0) !important;
                transform: translate(-6px, 0) !important;
      }
      .v-application--is-rtl .v-input--switch--inset.v-input--is-dirty .v-input--selection-controls__ripple,
      .v-application--is-rtl .v-input--switch--inset.v-input--is-dirty .v-input--switch__thumb {
        -webkit-transform: translate(-26px, 0) !important;
                transform: translate(-26px, 0) !important;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      /* Theme */
      .theme--light.v-system-bar {
        background-color: #e0e0e0;
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-system-bar .v-icon {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-system-bar--lights-out {
        background-color: rgba(255, 255, 255, 0.7) !important;
      }
      
      .theme--dark.v-system-bar {
        background-color: #000000;
        color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-system-bar .v-icon {
        color: rgba(255, 255, 255, 0.7);
      }
      .theme--dark.v-system-bar--lights-out {
        background-color: rgba(0, 0, 0, 0.2) !important;
      }
      
      .v-system-bar {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        font-size: 0.875rem;
        font-weight: 400;
        padding: 0 8px;
      }
      .v-system-bar .v-icon {
        font-size: 1rem;
        margin-right: 4px;
      }
      .v-system-bar--fixed, .v-system-bar--absolute {
        left: 0;
        top: 0;
        width: 100%;
        z-index: 3;
      }
      .v-system-bar--fixed {
        position: fixed;
      }
      .v-system-bar--absolute {
        position: absolute;
      }
      .v-system-bar--window .v-icon {
        font-size: 1.25rem;
        margin-right: 8px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-tabs .v-tab:not(.v-tab--active),
      .theme--light.v-tabs .v-tab:not(.v-tab--active) > .v-icon,
      .theme--light.v-tabs .v-tab--disabled {
        color: rgba(0, 0, 0, 0.54);
      }
      .theme--light.v-tabs .v-tabs-bar {
        background-color: #FFFFFF;
      }
      .theme--light.v-tabs .v-tab:hover::before {
        opacity: 0.04;
      }
      .theme--light.v-tabs .v-tab:focus::before {
        opacity: 0.12;
      }
      .theme--light.v-tabs .v-tab--active:hover::before, .theme--light.v-tabs .v-tab--active::before {
        opacity: 0.12;
      }
      .theme--light.v-tabs .v-tab--active:focus::before {
        opacity: 0.16;
      }
      
      .theme--dark.v-tabs .v-tab:not(.v-tab--active),
      .theme--dark.v-tabs .v-tab:not(.v-tab--active) > .v-icon,
      .theme--dark.v-tabs .v-tab--disabled {
        color: rgba(255, 255, 255, 0.6);
      }
      .theme--dark.v-tabs .v-tabs-bar {
        background-color: #424242;
      }
      .theme--dark.v-tabs .v-tab:hover::before {
        opacity: 0.08;
      }
      .theme--dark.v-tabs .v-tab:focus::before {
        opacity: 0.24;
      }
      .theme--dark.v-tabs .v-tab--active:hover::before, .theme--dark.v-tabs .v-tab--active::before {
        opacity: 0.24;
      }
      .theme--dark.v-tabs .v-tab--active:focus::before {
        opacity: 0.32;
      }
      
      .theme--light.v-tabs-items {
        background-color: #FFFFFF;
      }
      
      .theme--dark.v-tabs-items {
        background-color: #424242;
      }
      
      .v-tabs-bar.theme--dark .v-tab:not(.v-tab--active):not(.v-tab--disabled) {
        opacity: 0.7;
      }
      
      .v-tabs-bar.primary .v-tab,
      .v-tabs-bar.primary .v-tabs-slider, .v-tabs-bar.secondary .v-tab,
      .v-tabs-bar.secondary .v-tabs-slider, .v-tabs-bar.accent .v-tab,
      .v-tabs-bar.accent .v-tabs-slider, .v-tabs-bar.success .v-tab,
      .v-tabs-bar.success .v-tabs-slider, .v-tabs-bar.error .v-tab,
      .v-tabs-bar.error .v-tabs-slider, .v-tabs-bar.warning .v-tab,
      .v-tabs-bar.warning .v-tabs-slider, .v-tabs-bar.info .v-tab,
      .v-tabs-bar.info .v-tabs-slider {
        color: #FFFFFF;
      }
      
      .v-tabs {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        width: 100%;
      }
      .v-tabs .v-menu__activator {
        height: 100%;
      }
      
      .v-tabs-bar {
        border-radius: inherit;
        height: 48px;
      }
      .v-application--is-ltr .v-tabs-bar.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tab:first-child, .v-application--is-ltr .v-tabs-bar.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tabs-slider-wrapper + .v-tab {
        margin-left: 52px;
      }
      .v-application--is-rtl .v-tabs-bar.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tab:first-child, .v-application--is-rtl .v-tabs-bar.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tabs-slider-wrapper + .v-tab {
        margin-right: 52px;
      }
      .v-tabs-bar.v-item-group > * {
        cursor: initial;
      }
      
      .v-tab {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 0;
            -ms-flex: 0 1 auto;
                flex: 0 1 auto;
        font-size: 0.875rem;
        font-weight: 500;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        line-height: normal;
        min-width: 90px;
        max-width: 360px;
        outline: none;
        padding: 0 16px;
        position: relative;
        text-decoration: none;
        text-transform: uppercase;
        -webkit-transition: none;
        transition: none;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-tab.v-tab {
        color: inherit;
      }
      .v-tab:before {
        background-color: currentColor;
        bottom: 0;
        content: "";
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-tab:not(.v-tab-disabled) {
        cursor: pointer;
      }
      
      .v-tabs-slider {
        background-color: currentColor;
        height: 100%;
        width: 100%;
      }
      .v-tabs-slider-wrapper {
        bottom: 0;
        margin: 0 !important;
        position: absolute;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      
      .v-application--is-ltr .v-tabs--align-with-title > .v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tab:first-child, .v-application--is-ltr .v-tabs--align-with-title > .v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tabs-slider-wrapper + .v-tab {
        margin-left: 72px;
      }
      .v-application--is-rtl .v-tabs--align-with-title > .v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tab:first-child, .v-application--is-rtl .v-tabs--align-with-title > .v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tabs-slider-wrapper + .v-tab {
        margin-right: 72px;
      }
      
      .v-application--is-ltr .v-tabs--fixed-tabs .v-tabs-bar__content > *:last-child,
      .v-application--is-ltr .v-tabs--centered .v-tabs-bar__content > *:last-child {
        margin-right: auto;
      }
      .v-application--is-ltr .v-tabs--fixed-tabs .v-tabs-bar__content > *:first-child:not(.v-tabs-slider-wrapper),
      .v-application--is-ltr .v-tabs--centered .v-tabs-bar__content > *:first-child:not(.v-tabs-slider-wrapper) {
        margin-left: auto;
      }
      .v-application--is-ltr .v-tabs--fixed-tabs .v-tabs-slider-wrapper + *,
      .v-application--is-ltr .v-tabs--centered .v-tabs-slider-wrapper + * {
        margin-left: auto;
      }
      .v-application--is-rtl .v-tabs--fixed-tabs .v-tabs-bar__content > *:last-child,
      .v-application--is-rtl .v-tabs--centered .v-tabs-bar__content > *:last-child {
        margin-left: auto;
      }
      .v-application--is-rtl .v-tabs--fixed-tabs .v-tabs-bar__content > *:first-child:not(.v-tabs-slider-wrapper),
      .v-application--is-rtl .v-tabs--centered .v-tabs-bar__content > *:first-child:not(.v-tabs-slider-wrapper) {
        margin-right: auto;
      }
      .v-application--is-rtl .v-tabs--fixed-tabs .v-tabs-slider-wrapper + *,
      .v-application--is-rtl .v-tabs--centered .v-tabs-slider-wrapper + * {
        margin-right: auto;
      }
      
      .v-tabs--fixed-tabs .v-tab {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        width: 100%;
      }
      
      .v-tabs--grow .v-tab {
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
        max-width: none;
      }
      
      .v-tabs--icons-and-text .v-tabs-bar {
        height: 72px;
      }
      .v-tabs--icons-and-text .v-tab {
        -webkit-box-orient: vertical;
        -webkit-box-direction: reverse;
            -ms-flex-direction: column-reverse;
                flex-direction: column-reverse;
      }
      .v-tabs--icons-and-text .v-tab > *:first-child {
        margin-bottom: 6px;
      }
      
      .v-tabs--overflow .v-tab {
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
      }
      
      .v-application--is-ltr .v-tabs--right .v-tab:first-child,
      .v-application--is-ltr .v-tabs--right .v-tabs-slider-wrapper + .v-tab {
        margin-left: auto;
      }
      .v-application--is-rtl .v-tabs--right .v-tab:first-child,
      .v-application--is-rtl .v-tabs--right .v-tabs-slider-wrapper + .v-tab {
        margin-right: auto;
      }
      .v-application--is-ltr .v-tabs--right .v-tab:last-child {
        margin-right: 0;
      }
      .v-application--is-rtl .v-tabs--right .v-tab:last-child {
        margin-left: 0;
      }
      
      .v-tabs--vertical {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .v-tabs--vertical > .v-tabs-bar {
        height: auto;
      }
      .v-tabs--vertical > .v-tabs-bar .v-tabs-bar__content {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
      }
      .v-tabs--vertical > .v-tabs-bar .v-tab {
        height: 48px;
      }
      .v-tabs--vertical > .v-tabs-bar .v-tabs-slider {
        height: 100%;
      }
      .v-tabs--vertical > .v-window {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
      }
      .v-tabs--vertical.v-tabs--icons-and-text > .v-tabs-bar .v-tab {
        height: 72px;
      }
      
      .v-tab--active {
        color: inherit;
      }
      .v-tab--active.v-tab:not(:focus)::before {
        opacity: 0;
      }
      .v-tab--active .v-icon {
        color: inherit;
      }
      
      .v-tab--disabled {
        pointer-events: none;
        opacity: 0.5;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-textarea.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused textarea {
        color: #FFFFFF;
      }
      
      .theme--dark.v-textarea.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused textarea {
        color: rgba(0, 0, 0, 0.87);
      }
      
      .v-textarea textarea {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        line-height: 18px;
        max-width: 100%;
        min-height: 32px;
        outline: none;
        padding: 7px 0 8px;
        width: 100%;
      }
      .v-textarea .v-text-field__prefix {
        padding-top: 4px;
        -ms-flex-item-align: start;
            align-self: start;
      }
      .v-textarea.v-text-field--box .v-text-field__prefix,
      .v-textarea.v-text-field--box textarea, .v-textarea.v-text-field--enclosed .v-text-field__prefix,
      .v-textarea.v-text-field--enclosed textarea {
        margin-top: 24px;
      }
      .v-textarea.v-text-field--box.v-text-field--single-line .v-text-field__prefix,
      .v-textarea.v-text-field--box.v-text-field--single-line textarea, .v-textarea.v-text-field--box.v-text-field--outlined .v-text-field__prefix,
      .v-textarea.v-text-field--box.v-text-field--outlined textarea, .v-textarea.v-text-field--enclosed.v-text-field--single-line .v-text-field__prefix,
      .v-textarea.v-text-field--enclosed.v-text-field--single-line textarea, .v-textarea.v-text-field--enclosed.v-text-field--outlined .v-text-field__prefix,
      .v-textarea.v-text-field--enclosed.v-text-field--outlined textarea {
        margin-top: 12px;
      }
      .v-textarea.v-text-field--box.v-text-field--single-line .v-label, .v-textarea.v-text-field--box.v-text-field--outlined .v-label, .v-textarea.v-text-field--enclosed.v-text-field--single-line .v-label, .v-textarea.v-text-field--enclosed.v-text-field--outlined .v-label {
        top: 18px;
      }
      .v-textarea.v-text-field--solo {
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
      }
      .v-textarea.v-text-field--solo .v-input__prepend-inner,
      .v-textarea.v-text-field--solo .v-input__prepend-outer,
      .v-textarea.v-text-field--solo .v-input__append-inner,
      .v-textarea.v-text-field--solo .v-input__append-outer {
        -ms-flex-item-align: start;
            align-self: flex-start;
        margin-top: 16px;
      }
      .v-textarea--auto-grow textarea {
        overflow: hidden;
      }
      .v-textarea--no-resize textarea {
        resize: none;
      }
      .v-textarea.v-text-field--enclosed .v-text-field__slot {
        margin-right: -12px;
      }
      .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
        padding-right: 12px;
      }
      .v-application--is-rtl .v-textarea.v-text-field--enclosed .v-text-field__slot {
        margin-right: 0;
        margin-left: -12px;
      }
      .v-application--is-rtl .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
        padding-right: 0;
        padding-left: 12px;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-timeline::before {
        background: rgba(0, 0, 0, 0.12);
      }
      .theme--light.v-timeline .v-timeline-item__dot {
        background: #FFFFFF;
      }
      .theme--light.v-timeline .v-timeline-item .v-card::before {
        border-right-color: rgba(0, 0, 0, 0.12);
      }
      
      .theme--dark.v-timeline::before {
        background: rgba(255, 255, 255, 0.12);
      }
      .theme--dark.v-timeline .v-timeline-item__dot {
        background: #424242;
      }
      .theme--dark.v-timeline .v-timeline-item .v-card::before {
        border-right-color: rgba(0, 0, 0, 0.12);
      }
      
      .v-timeline {
        padding-top: 24px;
        position: relative;
      }
      .v-timeline:before {
        bottom: 0;
        content: "";
        height: 100%;
        position: absolute;
        top: 0;
        width: 2px;
      }
      
      .v-timeline-item {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding-bottom: 24px;
      }
      
      .v-timeline-item__body {
        position: relative;
        height: 100%;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
      }
      
      .v-timeline-item__divider {
        position: relative;
        min-width: 96px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
      }
      
      .v-timeline-item__dot {
        z-index: 2;
        border-radius: 50%;
        -webkit-box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
        height: 38px;
        left: calc(50% - 19px);
        width: 38px;
      }
      .v-timeline-item__dot .v-timeline-item__inner-dot {
        height: 30px;
        margin: 4px;
        width: 30px;
      }
      .v-timeline-item__dot--small {
        height: 24px;
        left: calc(50% - 12px);
        width: 24px;
      }
      .v-timeline-item__dot--small .v-timeline-item__inner-dot {
        height: 18px;
        margin: 3px;
        width: 18px;
      }
      .v-timeline-item__dot--large {
        height: 52px;
        left: calc(50% - 26px);
        width: 52px;
      }
      .v-timeline-item__dot--large .v-timeline-item__inner-dot {
        height: 42px;
        margin: 5px;
        width: 42px;
      }
      
      .v-timeline-item__inner-dot {
        border-radius: 50%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
      }
      
      .v-timeline-item__opposite {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        -ms-flex-item-align: center;
            align-self: center;
        max-width: calc(50% - 48px);
      }
      
      .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(odd):not(.v-timeline-item--before), .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: reverse;
            -ms-flex-direction: row-reverse;
                flex-direction: row-reverse;
      }
      .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(odd):not(.v-timeline-item--before) .v-timeline-item__opposite, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after .v-timeline-item__opposite {
        text-align: right;
      }
      .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(odd):not(.v-timeline-item--before) .v-timeline-item__opposite, .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after .v-timeline-item__opposite {
        text-align: left;
      }
      .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(odd):not(.v-timeline-item--before) .v-timeline-item__body > .v-card:before, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(odd):not(.v-timeline-item--before) .v-timeline-item__body .v-card:after, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after .v-timeline-item__body > .v-card:before, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(0);
                transform: rotate(0);
        left: -10px;
        right: initial;
      }
      .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(odd):not(.v-timeline-item--before) .v-timeline-item__body > .v-card:before, .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(odd):not(.v-timeline-item--before) .v-timeline-item__body .v-card:after, .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after .v-timeline-item__body > .v-card:before, .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
        left: initial;
        right: -10px;
      }
      .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(odd):not(.v-timeline-item--before) .v-timeline-item__body, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after .v-timeline-item__body {
        max-width: calc(50% - 48px);
      }
      .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(even):not(.v-timeline-item--after), .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--before {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
      }
      .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(even):not(.v-timeline-item--after) .v-timeline-item__opposite, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--before .v-timeline-item__opposite {
        text-align: left;
      }
      .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(even):not(.v-timeline-item--after) .v-timeline-item__opposite, .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--before .v-timeline-item__opposite {
        text-align: right;
      }
      .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(even):not(.v-timeline-item--after) .v-timeline-item__body > .v-card:before, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(even):not(.v-timeline-item--after) .v-timeline-item__body .v-card:after, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--before .v-timeline-item__body > .v-card:before, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--before .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
        right: -10px;
        left: initial;
      }
      .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(even):not(.v-timeline-item--after) .v-timeline-item__body > .v-card:before, .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(even):not(.v-timeline-item--after) .v-timeline-item__body .v-card:after, .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--before .v-timeline-item__body > .v-card:before, .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--before .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(0);
                transform: rotate(0);
        right: initial;
        left: -10px;
      }
      .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item:nth-child(even):not(.v-timeline-item--after) .v-timeline-item__body, .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--before .v-timeline-item__body {
        max-width: calc(50% - 48px);
      }
      
      .v-timeline-item__body > .v-card:before, .v-timeline-item__body > .v-card:after {
        content: "";
        position: absolute;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-right: 10px solid black;
        top: calc(50% - 10px);
      }
      .v-timeline-item__body > .v-card:after {
        border-right-color: inherit;
      }
      .v-timeline-item__body > .v-card:before {
        top: calc(50% - 10px + 2px);
      }
      
      .v-timeline--align-top .v-timeline-item__dot {
        -ms-flex-item-align: start;
            align-self: start;
      }
      .v-timeline--align-top .v-timeline-item__body > .v-card:before {
        top: calc(0% + 10px + 2px);
      }
      .v-timeline--align-top .v-timeline-item__body > .v-card:after {
        top: calc(0% + 10px);
      }
      
      .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse):before {
        left: calc(50% - 1px);
        right: initial;
      }
      .v-application--is-rtl .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse):before {
        left: initial;
        right: calc(50% - 1px);
      }
      
      .v-timeline--reverse:not(.v-timeline--dense):before {
        right: calc(50% - 1px);
        left: initial;
      }
      .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense):before {
        right: initial;
        left: calc(50% - 1px);
      }
      .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(odd):not(.v-timeline-item--after), .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--before {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
      }
      .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(odd):not(.v-timeline-item--after) .v-timeline-item__opposite, .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--before .v-timeline-item__opposite {
        text-align: left;
      }
      .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(odd):not(.v-timeline-item--after) .v-timeline-item__opposite, .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--before .v-timeline-item__opposite {
        text-align: right;
      }
      .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(odd):not(.v-timeline-item--after) .v-timeline-item__body > .v-card:before, .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(odd):not(.v-timeline-item--after) .v-timeline-item__body .v-card:after, .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--before .v-timeline-item__body > .v-card:before, .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--before .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
        right: -10px;
        left: initial;
      }
      .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(odd):not(.v-timeline-item--after) .v-timeline-item__body > .v-card:before, .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(odd):not(.v-timeline-item--after) .v-timeline-item__body .v-card:after, .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--before .v-timeline-item__body > .v-card:before, .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--before .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(0);
                transform: rotate(0);
        right: initial;
        left: -10px;
      }
      .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(odd):not(.v-timeline-item--after) .v-timeline-item__body, .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--before .v-timeline-item__body {
        max-width: calc(50% - 48px);
      }
      .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(even):not(.v-timeline-item--before), .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--after {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: reverse;
            -ms-flex-direction: row-reverse;
                flex-direction: row-reverse;
      }
      .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(even):not(.v-timeline-item--before) .v-timeline-item__opposite, .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--after .v-timeline-item__opposite {
        text-align: right;
      }
      .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(even):not(.v-timeline-item--before) .v-timeline-item__opposite, .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--after .v-timeline-item__opposite {
        text-align: left;
      }
      .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(even):not(.v-timeline-item--before) .v-timeline-item__body > .v-card:before, .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(even):not(.v-timeline-item--before) .v-timeline-item__body .v-card:after, .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--after .v-timeline-item__body > .v-card:before, .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--after .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(0);
                transform: rotate(0);
        left: -10px;
        right: initial;
      }
      .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(even):not(.v-timeline-item--before) .v-timeline-item__body > .v-card:before, .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(even):not(.v-timeline-item--before) .v-timeline-item__body .v-card:after, .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--after .v-timeline-item__body > .v-card:before, .v-application--is-rtl .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--after .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
        left: initial;
        right: -10px;
      }
      .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item:nth-child(even):not(.v-timeline-item--before) .v-timeline-item__body, .v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--after .v-timeline-item__body {
        max-width: calc(50% - 48px);
      }
      
      .v-timeline--reverse.v-timeline--dense:before {
        right: calc(48px - 1px);
        left: initial;
      }
      .v-application--is-rtl .v-timeline--reverse.v-timeline--dense:before {
        right: initial;
        left: calc(48px - 1px);
      }
      
      .v-timeline--dense:not(.v-timeline--reverse):before {
        left: calc(48px - 1px);
        right: initial;
      }
      .v-application--is-rtl .v-timeline--dense:not(.v-timeline--reverse):before {
        left: initial;
        right: calc(48px - 1px);
      }
      
      .v-timeline--dense .v-timeline-item {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: reverse !important;
            -ms-flex-direction: row-reverse !important;
                flex-direction: row-reverse !important;
      }
      .v-timeline--dense .v-timeline-item .v-timeline-item__body > .v-card:before, .v-timeline--dense .v-timeline-item .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(0);
                transform: rotate(0);
        left: -10px;
        right: initial;
      }
      .v-application--is-rtl .v-timeline--dense .v-timeline-item .v-timeline-item__body > .v-card:before, .v-application--is-rtl .v-timeline--dense .v-timeline-item .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
        left: initial;
        right: -10px;
      }
      .v-timeline--dense .v-timeline-item__body {
        max-width: calc(100% - 96px);
      }
      .v-timeline--dense .v-timeline-item__opposite {
        display: none;
      }
      
      .v-timeline--reverse.v-timeline--dense .v-timeline-item {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: normal !important;
            -ms-flex-direction: row !important;
                flex-direction: row !important;
      }
      .v-timeline--reverse.v-timeline--dense .v-timeline-item .v-timeline-item__body > .v-card:before, .v-timeline--reverse.v-timeline--dense .v-timeline-item .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
        right: -10px;
        left: initial;
      }
      .v-application--is-rtl .v-timeline--reverse.v-timeline--dense .v-timeline-item .v-timeline-item__body > .v-card:before, .v-application--is-rtl .v-timeline--reverse.v-timeline--dense .v-timeline-item .v-timeline-item__body .v-card:after {
        -webkit-transform: rotate(0);
                transform: rotate(0);
        right: initial;
        left: -10px;
      }
      
      .v-timeline-item--fill-dot .v-timeline-item__inner-dot {
        height: inherit;
        margin: 0;
        width: inherit;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-time-picker-title {
        color: #FFFFFF;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        line-height: 1;
        -webkit-box-pack: end;
            -ms-flex-pack: end;
                justify-content: flex-end;
      }
      
      .v-time-picker-title__time {
        white-space: nowrap;
      }
      .v-time-picker-title__time .v-picker__title__btn,
      .v-time-picker-title__time span {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        height: 70px;
        font-size: 70px;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
      }
      
      .v-time-picker-title__ampm {
        -ms-flex-item-align: end;
            align-self: flex-end;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        font-size: 16px;
        margin: 8px 0 6px 8px;
        text-transform: uppercase;
      }
      .v-time-picker-title__ampm div:only-child {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
      }
      
      .v-picker__title--landscape .v-time-picker-title {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        height: 100%;
      }
      .v-picker__title--landscape .v-time-picker-title__time {
        text-align: right;
      }
      .v-picker__title--landscape .v-time-picker-title__time .v-picker__title__btn,
      .v-picker__title--landscape .v-time-picker-title__time span {
        height: 55px;
        font-size: 55px;
      }
      .v-picker__title--landscape .v-time-picker-title__ampm {
        margin: 16px 0 0;
        -ms-flex-item-align: initial;
            align-self: initial;
        text-align: center;
      }
      
      .v-picker--time .v-picker__title--landscape {
        padding: 0;
      }
      .v-picker--time .v-picker__title--landscape .v-time-picker-title__time {
        text-align: center;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-time-picker-clock {
        background: #e0e0e0;
      }
      .theme--light.v-time-picker-clock .v-time-picker-clock__item--disabled {
        color: rgba(0, 0, 0, 0.26);
      }
      .theme--light.v-time-picker-clock .v-time-picker-clock__item--disabled.v-time-picker-clock__item--active {
        color: rgba(255, 255, 255, 0.3);
      }
      .theme--light.v-time-picker-clock--indeterminate .v-time-picker-clock__hand {
        background-color: #bdbdbd;
      }
      .theme--light.v-time-picker-clock--indeterminate:after {
        color: #bdbdbd;
      }
      .theme--light.v-time-picker-clock--indeterminate .v-time-picker-clock__item--active {
        background-color: #bdbdbd;
      }
      
      .theme--dark.v-time-picker-clock {
        background: #616161;
      }
      .theme--dark.v-time-picker-clock .v-time-picker-clock__item--disabled {
        color: rgba(255, 255, 255, 0.3);
      }
      .theme--dark.v-time-picker-clock .v-time-picker-clock__item--disabled.v-time-picker-clock__item--active {
        color: rgba(255, 255, 255, 0.3);
      }
      .theme--dark.v-time-picker-clock--indeterminate .v-time-picker-clock__hand {
        background-color: #757575;
      }
      .theme--dark.v-time-picker-clock--indeterminate:after {
        color: #757575;
      }
      .theme--dark.v-time-picker-clock--indeterminate .v-time-picker-clock__item--active {
        background-color: #757575;
      }
      
      .v-time-picker-clock {
        border-radius: 100%;
        position: relative;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        width: 100%;
        padding-top: 100%;
        -webkit-box-flex: 1;
            -ms-flex: 1 0 auto;
                flex: 1 0 auto;
      }
      .v-time-picker-clock__container {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        padding: 10px;
      }
      .v-time-picker-clock__ampm {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        -webkit-box-align: end;
            -ms-flex-align: end;
                align-items: flex-end;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        margin: 0;
        padding: 10px;
      }
      .v-time-picker-clock__hand {
        height: calc(50% - 4px);
        width: 2px;
        bottom: 50%;
        left: calc(50% - 1px);
        -webkit-transform-origin: center bottom;
                transform-origin: center bottom;
        position: absolute;
        will-change: transform;
        z-index: 1;
      }
      .v-time-picker-clock__hand:before {
        background: transparent;
        border-width: 2px;
        border-style: solid;
        border-color: inherit;
        border-radius: 100%;
        width: 10px;
        height: 10px;
        content: "";
        position: absolute;
        top: -4px;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
      }
      .v-time-picker-clock__hand:after {
        content: "";
        position: absolute;
        height: 8px;
        width: 8px;
        top: 100%;
        left: 50%;
        border-radius: 100%;
        border-style: solid;
        border-color: inherit;
        background-color: inherit;
        -webkit-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
      }
      .v-time-picker-clock__hand--inner:after {
        height: 14px;
      }
      
      .v-picker--full-width .v-time-picker-clock__container {
        max-width: 290px;
      }
      
      .v-time-picker-clock__inner {
        position: absolute;
        bottom: 27px;
        left: 27px;
        right: 27px;
        top: 27px;
      }
      
      .v-time-picker-clock__item {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        border-radius: 100%;
        cursor: default;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        font-size: 16px;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        height: 40px;
        position: absolute;
        text-align: center;
        width: 40px;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        -webkit-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
      }
      .v-time-picker-clock__item > span {
        z-index: 1;
      }
      .v-time-picker-clock__item:before, .v-time-picker-clock__item:after {
        content: "";
        border-radius: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        height: 14px;
        width: 14px;
        -webkit-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
      }
      .v-time-picker-clock__item:after, .v-time-picker-clock__item:before {
        height: 40px;
        width: 40px;
      }
      .v-time-picker-clock__item--active {
        color: #FFFFFF;
        cursor: default;
        z-index: 2;
      }
      .v-time-picker-clock__item--disabled {
        pointer-events: none;
      }
      
      .v-picker--landscape .v-time-picker-clock__container {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
      }
      .v-picker--landscape .v-time-picker-clock__ampm {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .v-tooltip__content {
        background: rgba(97, 97, 97, 0.9);
        color: #FFFFFF;
        border-radius: 4px;
        font-size: 14px;
        line-height: 22px;
        display: inline-block;
        padding: 5px 16px;
        position: absolute;
        text-transform: initial;
        width: auto;
        opacity: 1;
        pointer-events: none;
      }
      .v-tooltip__content[class*=-active] {
        -webkit-transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
                transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      }
      .v-tooltip__content[class*=enter-active] {
        -webkit-transition-duration: 150ms;
                transition-duration: 150ms;
      }
      .v-tooltip__content[class*=leave-active] {
        -webkit-transition-duration: 75ms;
                transition-duration: 75ms;
      }</style><style type="text/css">/** Ripples */
      /** Elements */
      .theme--light.v-treeview {
        color: rgba(0, 0, 0, 0.87);
      }
      .theme--light.v-treeview--hoverable .v-treeview-node__root:hover::before,
      .theme--light.v-treeview .v-treeview-node--click > .v-treeview-node__root:hover::before {
        opacity: 0.04;
      }
      .theme--light.v-treeview--hoverable .v-treeview-node__root:focus::before,
      .theme--light.v-treeview .v-treeview-node--click > .v-treeview-node__root:focus::before {
        opacity: 0.12;
      }
      .theme--light.v-treeview--hoverable .v-treeview-node__root--active:hover::before, .theme--light.v-treeview--hoverable .v-treeview-node__root--active::before,
      .theme--light.v-treeview .v-treeview-node--click > .v-treeview-node__root--active:hover::before,
      .theme--light.v-treeview .v-treeview-node--click > .v-treeview-node__root--active::before {
        opacity: 0.12;
      }
      .theme--light.v-treeview--hoverable .v-treeview-node__root--active:focus::before,
      .theme--light.v-treeview .v-treeview-node--click > .v-treeview-node__root--active:focus::before {
        opacity: 0.16;
      }
      .theme--light.v-treeview .v-treeview-node__root.v-treeview-node--active:hover::before, .theme--light.v-treeview .v-treeview-node__root.v-treeview-node--active::before {
        opacity: 0.12;
      }
      .theme--light.v-treeview .v-treeview-node__root.v-treeview-node--active:focus::before {
        opacity: 0.16;
      }
      .theme--light.v-treeview .v-treeview-node--disabled {
        color: rgba(0, 0, 0, 0.38);
      }
      .theme--light.v-treeview .v-treeview-node--disabled .v-treeview-node__toggle,
      .theme--light.v-treeview .v-treeview-node--disabled .v-treeview-node__checkbox {
        color: rgba(0, 0, 0, 0.38) !important;
      }
      
      .theme--dark.v-treeview {
        color: #FFFFFF;
      }
      .theme--dark.v-treeview--hoverable .v-treeview-node__root:hover::before,
      .theme--dark.v-treeview .v-treeview-node--click > .v-treeview-node__root:hover::before {
        opacity: 0.08;
      }
      .theme--dark.v-treeview--hoverable .v-treeview-node__root:focus::before,
      .theme--dark.v-treeview .v-treeview-node--click > .v-treeview-node__root:focus::before {
        opacity: 0.24;
      }
      .theme--dark.v-treeview--hoverable .v-treeview-node__root--active:hover::before, .theme--dark.v-treeview--hoverable .v-treeview-node__root--active::before,
      .theme--dark.v-treeview .v-treeview-node--click > .v-treeview-node__root--active:hover::before,
      .theme--dark.v-treeview .v-treeview-node--click > .v-treeview-node__root--active::before {
        opacity: 0.24;
      }
      .theme--dark.v-treeview--hoverable .v-treeview-node__root--active:focus::before,
      .theme--dark.v-treeview .v-treeview-node--click > .v-treeview-node__root--active:focus::before {
        opacity: 0.32;
      }
      .theme--dark.v-treeview .v-treeview-node__root.v-treeview-node--active:hover::before, .theme--dark.v-treeview .v-treeview-node__root.v-treeview-node--active::before {
        opacity: 0.24;
      }
      .theme--dark.v-treeview .v-treeview-node__root.v-treeview-node--active:focus::before {
        opacity: 0.32;
      }
      .theme--dark.v-treeview .v-treeview-node--disabled {
        color: rgba(255, 255, 255, 0.5);
      }
      .theme--dark.v-treeview .v-treeview-node--disabled .v-treeview-node__toggle,
      .theme--dark.v-treeview .v-treeview-node--disabled .v-treeview-node__checkbox {
        color: rgba(255, 255, 255, 0.5) !important;
      }
      
      .v-treeview > .v-treeview-node {
        margin-left: 0;
      }
      .v-treeview > .v-treeview-node--leaf {
        margin-left: 16px;
      }
      .v-treeview > .v-treeview-node--leaf > .v-treeview-node__root {
        padding-left: 8px;
        padding-right: 8px;
      }
      .v-treeview-node {
        margin-left: 26px;
      }
      .v-treeview-node--disabled {
        pointer-events: none;
      }
      .v-treeview-node.v-treeview-node--shaped .v-treeview-node__root,
      .v-treeview-node.v-treeview-node--shaped .v-treeview-node__root:before {
        border-bottom-right-radius: 24px !important;
        border-top-right-radius: 24px !important;
      }
      .v-treeview-node.v-treeview-node--shaped .v-treeview-node__root {
        margin-top: 8px;
        margin-bottom: 8px;
      }
      .v-treeview-node.v-treeview-node--rounded .v-treeview-node__root,
      .v-treeview-node.v-treeview-node--rounded .v-treeview-node__root:before {
        border-radius: 24px !important;
      }
      .v-treeview-node.v-treeview-node--rounded .v-treeview-node__root {
        margin-top: 8px;
        margin-bottom: 8px;
      }
      .v-treeview-node--excluded {
        display: none;
      }
      .v-treeview-node--click > .v-treeview-node__root,
      .v-treeview-node--click > .v-treeview-node__root > .v-treeview-node__content > * {
        cursor: pointer;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-treeview-node--leaf {
        margin-left: 26px;
      }
      .v-treeview-node--leaf > .v-treeview-node__root {
        padding-left: 24px;
        padding-right: 8px;
      }
      .v-treeview-node__root {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        min-height: 48px;
        padding-right: 8px;
        position: relative;
      }
      .v-treeview-node__root::before {
        background-color: currentColor;
        bottom: 0;
        content: "";
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .v-treeview-node__root.v-treeview-node--active .v-treeview-node__content .v-icon {
        color: inherit;
      }
      .v-treeview-node__content {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-preferred-size: 0%;
            flex-basis: 0%;
        -webkit-box-flex: 1;
            -ms-flex-positive: 1;
                flex-grow: 1;
        -ms-flex-negative: 0;
            flex-shrink: 0;
        min-width: 0;
      }
      .v-treeview-node__content .v-btn {
        -webkit-box-flex: 0 !important;
            -ms-flex-positive: 0 !important;
                flex-grow: 0 !important;
        -ms-flex-negative: 1 !important;
            flex-shrink: 1 !important;
      }
      .v-treeview-node__label {
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        font-size: inherit;
        margin-left: 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .v-treeview-node__label .v-icon {
        padding-right: 8px;
      }
      .v-treeview-node__checkbox {
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-treeview-node__toggle {
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
        -webkit-transform: rotate(-90deg);
                transform: rotate(-90deg);
      }
      .v-treeview-node__toggle--open {
        -webkit-transform: none;
                transform: none;
      }
      .v-treeview-node__toggle--loading {
        -webkit-animation: progress-circular-rotate 1s linear infinite;
                animation: progress-circular-rotate 1s linear infinite;
      }
      .v-treeview-node__children {
        -webkit-transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
        transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
      }
      .v-application--is-rtl .v-treeview > .v-treeview-node {
        margin-right: 0;
      }
      .v-application--is-rtl .v-treeview > .v-treeview-node--leaf {
        margin-right: 16px;
        margin-left: 0;
      }
      .v-application--is-rtl .v-treeview > .v-treeview-node--leaf > .v-treeview-node__root {
        padding-right: 8px;
        padding-left: 8px;
      }
      .v-application--is-rtl .v-treeview-node {
        margin-right: 26px;
        margin-left: 0;
      }
      .v-application--is-rtl .v-treeview-node--leaf {
        margin-right: 26px;
        margin-left: 0;
      }
      .v-application--is-rtl .v-treeview-node--leaf > .v-treeview-node__root {
        padding-right: 24px;
        padding-left: 8px;
      }
      .v-application--is-rtl .v-treeview-node__root {
        padding-right: 0;
        padding-left: 8px;
      }
      .v-application--is-rtl .v-treeview-node__toggle {
        -webkit-transform: rotate(90deg);
                transform: rotate(90deg);
      }
      .v-application--is-rtl .v-treeview-node__toggle--open {
        -webkit-transform: none;
                transform: none;
      }
      .v-treeview--dense .v-treeview-node__root {
        min-height: 40px;
      }
      .v-treeview--dense.v-treeview-node--shaped .v-treeview-node__root,
      .v-treeview--dense.v-treeview-node--shaped .v-treeview-node__root:before {
        border-bottom-right-radius: 20px !important;
        border-top-right-radius: 20px !important;
      }
      .v-treeview--dense.v-treeview-node--shaped .v-treeview-node__root {
        margin-top: 8px;
        margin-bottom: 8px;
      }
      .v-treeview--dense.v-treeview-node--rounded .v-treeview-node__root,
      .v-treeview--dense.v-treeview-node--rounded .v-treeview-node__root:before {
        border-radius: 20px !important;
      }
      .v-treeview--dense.v-treeview-node--rounded .v-treeview-node__root {
        margin-top: 8px;
        margin-bottom: 8px;
      }</style><style type="text/css">@charset "UTF-8";
      /** Ripples */
      /** Elements */
      @-webkit-keyframes v-shake {
        59% {
          margin-left: 0;
        }
        60%, 80% {
          margin-left: 2px;
        }
        70%, 90% {
          margin-left: -2px;
        }
      }
      @keyframes v-shake {
        59% {
          margin-left: 0;
        }
        60%, 80% {
          margin-left: 2px;
        }
        70%, 90% {
          margin-left: -2px;
        }
      }
      .v-application .black {
        background-color: #000000 !important;
        border-color: #000000 !important;
      }
      
      .v-application .black--text {
        color: #000000 !important;
        caret-color: #000000 !important;
      }
      
      .v-application .white {
        background-color: #FFFFFF !important;
        border-color: #FFFFFF !important;
      }
      
      .v-application .white--text {
        color: #FFFFFF !important;
        caret-color: #FFFFFF !important;
      }
      
      .v-application .transparent {
        background-color: transparent !important;
        border-color: transparent !important;
      }
      
      .v-application .transparent--text {
        color: transparent !important;
        caret-color: transparent !important;
      }
      
      .v-application .red {
        background-color: #F44336 !important;
        border-color: #F44336 !important;
      }
      
      .v-application .red--text {
        color: #F44336 !important;
        caret-color: #F44336 !important;
      }
      
      .v-application .red.lighten-5 {
        background-color: #FFEBEE !important;
        border-color: #FFEBEE !important;
      }
      
      .v-application .red--text.text--lighten-5 {
        color: #FFEBEE !important;
        caret-color: #FFEBEE !important;
      }
      
      .v-application .red.lighten-4 {
        background-color: #FFCDD2 !important;
        border-color: #FFCDD2 !important;
      }
      
      .v-application .red--text.text--lighten-4 {
        color: #FFCDD2 !important;
        caret-color: #FFCDD2 !important;
      }
      
      .v-application .red.lighten-3 {
        background-color: #EF9A9A !important;
        border-color: #EF9A9A !important;
      }
      
      .v-application .red--text.text--lighten-3 {
        color: #EF9A9A !important;
        caret-color: #EF9A9A !important;
      }
      
      .v-application .red.lighten-2 {
        background-color: #E57373 !important;
        border-color: #E57373 !important;
      }
      
      .v-application .red--text.text--lighten-2 {
        color: #E57373 !important;
        caret-color: #E57373 !important;
      }
      
      .v-application .red.lighten-1 {
        background-color: #EF5350 !important;
        border-color: #EF5350 !important;
      }
      
      .v-application .red--text.text--lighten-1 {
        color: #EF5350 !important;
        caret-color: #EF5350 !important;
      }
      
      .v-application .red.darken-1 {
        background-color: #E53935 !important;
        border-color: #E53935 !important;
      }
      
      .v-application .red--text.text--darken-1 {
        color: #E53935 !important;
        caret-color: #E53935 !important;
      }
      
      .v-application .red.darken-2 {
        background-color: #D32F2F !important;
        border-color: #D32F2F !important;
      }
      
      .v-application .red--text.text--darken-2 {
        color: #D32F2F !important;
        caret-color: #D32F2F !important;
      }
      
      .v-application .red.darken-3 {
        background-color: #C62828 !important;
        border-color: #C62828 !important;
      }
      
      .v-application .red--text.text--darken-3 {
        color: #C62828 !important;
        caret-color: #C62828 !important;
      }
      
      .v-application .red.darken-4 {
        background-color: #B71C1C !important;
        border-color: #B71C1C !important;
      }
      
      .v-application .red--text.text--darken-4 {
        color: #B71C1C !important;
        caret-color: #B71C1C !important;
      }
      
      .v-application .red.accent-1 {
        background-color: #FF8A80 !important;
        border-color: #FF8A80 !important;
      }
      
      .v-application .red--text.text--accent-1 {
        color: #FF8A80 !important;
        caret-color: #FF8A80 !important;
      }
      
      .v-application .red.accent-2 {
        background-color: #FF5252 !important;
        border-color: #FF5252 !important;
      }
      
      .v-application .red--text.text--accent-2 {
        color: #FF5252 !important;
        caret-color: #FF5252 !important;
      }
      
      .v-application .red.accent-3 {
        background-color: #FF1744 !important;
        border-color: #FF1744 !important;
      }
      
      .v-application .red--text.text--accent-3 {
        color: #FF1744 !important;
        caret-color: #FF1744 !important;
      }
      
      .v-application .red.accent-4 {
        background-color: #D50000 !important;
        border-color: #D50000 !important;
      }
      
      .v-application .red--text.text--accent-4 {
        color: #D50000 !important;
        caret-color: #D50000 !important;
      }
      
      .v-application .pink {
        background-color: #e91e63 !important;
        border-color: #e91e63 !important;
      }
      
      .v-application .pink--text {
        color: #e91e63 !important;
        caret-color: #e91e63 !important;
      }
      
      .v-application .pink.lighten-5 {
        background-color: #fce4ec !important;
        border-color: #fce4ec !important;
      }
      
      .v-application .pink--text.text--lighten-5 {
        color: #fce4ec !important;
        caret-color: #fce4ec !important;
      }
      
      .v-application .pink.lighten-4 {
        background-color: #f8bbd0 !important;
        border-color: #f8bbd0 !important;
      }
      
      .v-application .pink--text.text--lighten-4 {
        color: #f8bbd0 !important;
        caret-color: #f8bbd0 !important;
      }
      
      .v-application .pink.lighten-3 {
        background-color: #f48fb1 !important;
        border-color: #f48fb1 !important;
      }
      
      .v-application .pink--text.text--lighten-3 {
        color: #f48fb1 !important;
        caret-color: #f48fb1 !important;
      }
      
      .v-application .pink.lighten-2 {
        background-color: #f06292 !important;
        border-color: #f06292 !important;
      }
      
      .v-application .pink--text.text--lighten-2 {
        color: #f06292 !important;
        caret-color: #f06292 !important;
      }
      
      .v-application .pink.lighten-1 {
        background-color: #ec407a !important;
        border-color: #ec407a !important;
      }
      
      .v-application .pink--text.text--lighten-1 {
        color: #ec407a !important;
        caret-color: #ec407a !important;
      }
      
      .v-application .pink.darken-1 {
        background-color: #d81b60 !important;
        border-color: #d81b60 !important;
      }
      
      .v-application .pink--text.text--darken-1 {
        color: #d81b60 !important;
        caret-color: #d81b60 !important;
      }
      
      .v-application .pink.darken-2 {
        background-color: #c2185b !important;
        border-color: #c2185b !important;
      }
      
      .v-application .pink--text.text--darken-2 {
        color: #c2185b !important;
        caret-color: #c2185b !important;
      }
      
      .v-application .pink.darken-3 {
        background-color: #ad1457 !important;
        border-color: #ad1457 !important;
      }
      
      .v-application .pink--text.text--darken-3 {
        color: #ad1457 !important;
        caret-color: #ad1457 !important;
      }
      
      .v-application .pink.darken-4 {
        background-color: #880e4f !important;
        border-color: #880e4f !important;
      }
      
      .v-application .pink--text.text--darken-4 {
        color: #880e4f !important;
        caret-color: #880e4f !important;
      }
      
      .v-application .pink.accent-1 {
        background-color: #ff80ab !important;
        border-color: #ff80ab !important;
      }
      
      .v-application .pink--text.text--accent-1 {
        color: #ff80ab !important;
        caret-color: #ff80ab !important;
      }
      
      .v-application .pink.accent-2 {
        background-color: #ff4081 !important;
        border-color: #ff4081 !important;
      }
      
      .v-application .pink--text.text--accent-2 {
        color: #ff4081 !important;
        caret-color: #ff4081 !important;
      }
      
      .v-application .pink.accent-3 {
        background-color: #f50057 !important;
        border-color: #f50057 !important;
      }
      
      .v-application .pink--text.text--accent-3 {
        color: #f50057 !important;
        caret-color: #f50057 !important;
      }
      
      .v-application .pink.accent-4 {
        background-color: #c51162 !important;
        border-color: #c51162 !important;
      }
      
      .v-application .pink--text.text--accent-4 {
        color: #c51162 !important;
        caret-color: #c51162 !important;
      }
      
      .v-application .purple {
        background-color: #9c27b0 !important;
        border-color: #9c27b0 !important;
      }
      
      .v-application .purple--text {
        color: #9c27b0 !important;
        caret-color: #9c27b0 !important;
      }
      
      .v-application .purple.lighten-5 {
        background-color: #f3e5f5 !important;
        border-color: #f3e5f5 !important;
      }
      
      .v-application .purple--text.text--lighten-5 {
        color: #f3e5f5 !important;
        caret-color: #f3e5f5 !important;
      }
      
      .v-application .purple.lighten-4 {
        background-color: #e1bee7 !important;
        border-color: #e1bee7 !important;
      }
      
      .v-application .purple--text.text--lighten-4 {
        color: #e1bee7 !important;
        caret-color: #e1bee7 !important;
      }
      
      .v-application .purple.lighten-3 {
        background-color: #ce93d8 !important;
        border-color: #ce93d8 !important;
      }
      
      .v-application .purple--text.text--lighten-3 {
        color: #ce93d8 !important;
        caret-color: #ce93d8 !important;
      }
      
      .v-application .purple.lighten-2 {
        background-color: #ba68c8 !important;
        border-color: #ba68c8 !important;
      }
      
      .v-application .purple--text.text--lighten-2 {
        color: #ba68c8 !important;
        caret-color: #ba68c8 !important;
      }
      
      .v-application .purple.lighten-1 {
        background-color: #ab47bc !important;
        border-color: #ab47bc !important;
      }
      
      .v-application .purple--text.text--lighten-1 {
        color: #ab47bc !important;
        caret-color: #ab47bc !important;
      }
      
      .v-application .purple.darken-1 {
        background-color: #8e24aa !important;
        border-color: #8e24aa !important;
      }
      
      .v-application .purple--text.text--darken-1 {
        color: #8e24aa !important;
        caret-color: #8e24aa !important;
      }
      
      .v-application .purple.darken-2 {
        background-color: #7b1fa2 !important;
        border-color: #7b1fa2 !important;
      }
      
      .v-application .purple--text.text--darken-2 {
        color: #7b1fa2 !important;
        caret-color: #7b1fa2 !important;
      }
      
      .v-application .purple.darken-3 {
        background-color: #6a1b9a !important;
        border-color: #6a1b9a !important;
      }
      
      .v-application .purple--text.text--darken-3 {
        color: #6a1b9a !important;
        caret-color: #6a1b9a !important;
      }
      
      .v-application .purple.darken-4 {
        background-color: #4a148c !important;
        border-color: #4a148c !important;
      }
      
      .v-application .purple--text.text--darken-4 {
        color: #4a148c !important;
        caret-color: #4a148c !important;
      }
      
      .v-application .purple.accent-1 {
        background-color: #ea80fc !important;
        border-color: #ea80fc !important;
      }
      
      .v-application .purple--text.text--accent-1 {
        color: #ea80fc !important;
        caret-color: #ea80fc !important;
      }
      
      .v-application .purple.accent-2 {
        background-color: #e040fb !important;
        border-color: #e040fb !important;
      }
      
      .v-application .purple--text.text--accent-2 {
        color: #e040fb !important;
        caret-color: #e040fb !important;
      }
      
      .v-application .purple.accent-3 {
        background-color: #d500f9 !important;
        border-color: #d500f9 !important;
      }
      
      .v-application .purple--text.text--accent-3 {
        color: #d500f9 !important;
        caret-color: #d500f9 !important;
      }
      
      .v-application .purple.accent-4 {
        background-color: #aa00ff !important;
        border-color: #aa00ff !important;
      }
      
      .v-application .purple--text.text--accent-4 {
        color: #aa00ff !important;
        caret-color: #aa00ff !important;
      }
      
      .v-application .deep-purple {
        background-color: #673ab7 !important;
        border-color: #673ab7 !important;
      }
      
      .v-application .deep-purple--text {
        color: #673ab7 !important;
        caret-color: #673ab7 !important;
      }
      
      .v-application .deep-purple.lighten-5 {
        background-color: #ede7f6 !important;
        border-color: #ede7f6 !important;
      }
      
      .v-application .deep-purple--text.text--lighten-5 {
        color: #ede7f6 !important;
        caret-color: #ede7f6 !important;
      }
      
      .v-application .deep-purple.lighten-4 {
        background-color: #d1c4e9 !important;
        border-color: #d1c4e9 !important;
      }
      
      .v-application .deep-purple--text.text--lighten-4 {
        color: #d1c4e9 !important;
        caret-color: #d1c4e9 !important;
      }
      
      .v-application .deep-purple.lighten-3 {
        background-color: #b39ddb !important;
        border-color: #b39ddb !important;
      }
      
      .v-application .deep-purple--text.text--lighten-3 {
        color: #b39ddb !important;
        caret-color: #b39ddb !important;
      }
      
      .v-application .deep-purple.lighten-2 {
        background-color: #9575cd !important;
        border-color: #9575cd !important;
      }
      
      .v-application .deep-purple--text.text--lighten-2 {
        color: #9575cd !important;
        caret-color: #9575cd !important;
      }
      
      .v-application .deep-purple.lighten-1 {
        background-color: #7e57c2 !important;
        border-color: #7e57c2 !important;
      }
      
      .v-application .deep-purple--text.text--lighten-1 {
        color: #7e57c2 !important;
        caret-color: #7e57c2 !important;
      }
      
      .v-application .deep-purple.darken-1 {
        background-color: #5e35b1 !important;
        border-color: #5e35b1 !important;
      }
      
      .v-application .deep-purple--text.text--darken-1 {
        color: #5e35b1 !important;
        caret-color: #5e35b1 !important;
      }
      
      .v-application .deep-purple.darken-2 {
        background-color: #512da8 !important;
        border-color: #512da8 !important;
      }
      
      .v-application .deep-purple--text.text--darken-2 {
        color: #512da8 !important;
        caret-color: #512da8 !important;
      }
      
      .v-application .deep-purple.darken-3 {
        background-color: #4527a0 !important;
        border-color: #4527a0 !important;
      }
      
      .v-application .deep-purple--text.text--darken-3 {
        color: #4527a0 !important;
        caret-color: #4527a0 !important;
      }
      
      .v-application .deep-purple.darken-4 {
        background-color: #311b92 !important;
        border-color: #311b92 !important;
      }
      
      .v-application .deep-purple--text.text--darken-4 {
        color: #311b92 !important;
        caret-color: #311b92 !important;
      }
      
      .v-application .deep-purple.accent-1 {
        background-color: #b388ff !important;
        border-color: #b388ff !important;
      }
      
      .v-application .deep-purple--text.text--accent-1 {
        color: #b388ff !important;
        caret-color: #b388ff !important;
      }
      
      .v-application .deep-purple.accent-2 {
        background-color: #7c4dff !important;
        border-color: #7c4dff !important;
      }
      
      .v-application .deep-purple--text.text--accent-2 {
        color: #7c4dff !important;
        caret-color: #7c4dff !important;
      }
      
      .v-application .deep-purple.accent-3 {
        background-color: #651fff !important;
        border-color: #651fff !important;
      }
      
      .v-application .deep-purple--text.text--accent-3 {
        color: #651fff !important;
        caret-color: #651fff !important;
      }
      
      .v-application .deep-purple.accent-4 {
        background-color: #6200ea !important;
        border-color: #6200ea !important;
      }
      
      .v-application .deep-purple--text.text--accent-4 {
        color: #6200ea !important;
        caret-color: #6200ea !important;
      }
      
      .v-application .indigo {
        background-color: #3f51b5 !important;
        border-color: #3f51b5 !important;
      }
      
      .v-application .indigo--text {
        color: #3f51b5 !important;
        caret-color: #3f51b5 !important;
      }
      
      .v-application .indigo.lighten-5 {
        background-color: #e8eaf6 !important;
        border-color: #e8eaf6 !important;
      }
      
      .v-application .indigo--text.text--lighten-5 {
        color: #e8eaf6 !important;
        caret-color: #e8eaf6 !important;
      }
      
      .v-application .indigo.lighten-4 {
        background-color: #c5cae9 !important;
        border-color: #c5cae9 !important;
      }
      
      .v-application .indigo--text.text--lighten-4 {
        color: #c5cae9 !important;
        caret-color: #c5cae9 !important;
      }
      
      .v-application .indigo.lighten-3 {
        background-color: #9fa8da !important;
        border-color: #9fa8da !important;
      }
      
      .v-application .indigo--text.text--lighten-3 {
        color: #9fa8da !important;
        caret-color: #9fa8da !important;
      }
      
      .v-application .indigo.lighten-2 {
        background-color: #7986cb !important;
        border-color: #7986cb !important;
      }
      
      .v-application .indigo--text.text--lighten-2 {
        color: #7986cb !important;
        caret-color: #7986cb !important;
      }
      
      .v-application .indigo.lighten-1 {
        background-color: #5c6bc0 !important;
        border-color: #5c6bc0 !important;
      }
      
      .v-application .indigo--text.text--lighten-1 {
        color: #5c6bc0 !important;
        caret-color: #5c6bc0 !important;
      }
      
      .v-application .indigo.darken-1 {
        background-color: #3949ab !important;
        border-color: #3949ab !important;
      }
      
      .v-application .indigo--text.text--darken-1 {
        color: #3949ab !important;
        caret-color: #3949ab !important;
      }
      
      .v-application .indigo.darken-2 {
        background-color: #303f9f !important;
        border-color: #303f9f !important;
      }
      
      .v-application .indigo--text.text--darken-2 {
        color: #303f9f !important;
        caret-color: #303f9f !important;
      }
      
      .v-application .indigo.darken-3 {
        background-color: #283593 !important;
        border-color: #283593 !important;
      }
      
      .v-application .indigo--text.text--darken-3 {
        color: #283593 !important;
        caret-color: #283593 !important;
      }
      
      .v-application .indigo.darken-4 {
        background-color: #1a237e !important;
        border-color: #1a237e !important;
      }
      
      .v-application .indigo--text.text--darken-4 {
        color: #1a237e !important;
        caret-color: #1a237e !important;
      }
      
      .v-application .indigo.accent-1 {
        background-color: #8c9eff !important;
        border-color: #8c9eff !important;
      }
      
      .v-application .indigo--text.text--accent-1 {
        color: #8c9eff !important;
        caret-color: #8c9eff !important;
      }
      
      .v-application .indigo.accent-2 {
        background-color: #536dfe !important;
        border-color: #536dfe !important;
      }
      
      .v-application .indigo--text.text--accent-2 {
        color: #536dfe !important;
        caret-color: #536dfe !important;
      }
      
      .v-application .indigo.accent-3 {
        background-color: #3d5afe !important;
        border-color: #3d5afe !important;
      }
      
      .v-application .indigo--text.text--accent-3 {
        color: #3d5afe !important;
        caret-color: #3d5afe !important;
      }
      
      .v-application .indigo.accent-4 {
        background-color: #304ffe !important;
        border-color: #304ffe !important;
      }
      
      .v-application .indigo--text.text--accent-4 {
        color: #304ffe !important;
        caret-color: #304ffe !important;
      }
      
      .v-application .blue {
        background-color: #2196F3 !important;
        border-color: #2196F3 !important;
      }
      
      .v-application .blue--text {
        color: #2196F3 !important;
        caret-color: #2196F3 !important;
      }
      
      .v-application .blue.lighten-5 {
        background-color: #E3F2FD !important;
        border-color: #E3F2FD !important;
      }
      
      .v-application .blue--text.text--lighten-5 {
        color: #E3F2FD !important;
        caret-color: #E3F2FD !important;
      }
      
      .v-application .blue.lighten-4 {
        background-color: #BBDEFB !important;
        border-color: #BBDEFB !important;
      }
      
      .v-application .blue--text.text--lighten-4 {
        color: #BBDEFB !important;
        caret-color: #BBDEFB !important;
      }
      
      .v-application .blue.lighten-3 {
        background-color: #90CAF9 !important;
        border-color: #90CAF9 !important;
      }
      
      .v-application .blue--text.text--lighten-3 {
        color: #90CAF9 !important;
        caret-color: #90CAF9 !important;
      }
      
      .v-application .blue.lighten-2 {
        background-color: #64B5F6 !important;
        border-color: #64B5F6 !important;
      }
      
      .v-application .blue--text.text--lighten-2 {
        color: #64B5F6 !important;
        caret-color: #64B5F6 !important;
      }
      
      .v-application .blue.lighten-1 {
        background-color: #42A5F5 !important;
        border-color: #42A5F5 !important;
      }
      
      .v-application .blue--text.text--lighten-1 {
        color: #42A5F5 !important;
        caret-color: #42A5F5 !important;
      }
      
      .v-application .blue.darken-1 {
        background-color: #1E88E5 !important;
        border-color: #1E88E5 !important;
      }
      
      .v-application .blue--text.text--darken-1 {
        color: #1E88E5 !important;
        caret-color: #1E88E5 !important;
      }
      
      .v-application .blue.darken-2 {
        background-color: #1976D2 !important;
        border-color: #1976D2 !important;
      }
      
      .v-application .blue--text.text--darken-2 {
        color: #1976D2 !important;
        caret-color: #1976D2 !important;
      }
      
      .v-application .blue.darken-3 {
        background-color: #1565C0 !important;
        border-color: #1565C0 !important;
      }
      
      .v-application .blue--text.text--darken-3 {
        color: #1565C0 !important;
        caret-color: #1565C0 !important;
      }
      
      .v-application .blue.darken-4 {
        background-color: #0D47A1 !important;
        border-color: #0D47A1 !important;
      }
      
      .v-application .blue--text.text--darken-4 {
        color: #0D47A1 !important;
        caret-color: #0D47A1 !important;
      }
      
      .v-application .blue.accent-1 {
        background-color: #82B1FF !important;
        border-color: #82B1FF !important;
      }
      
      .v-application .blue--text.text--accent-1 {
        color: #82B1FF !important;
        caret-color: #82B1FF !important;
      }
      
      .v-application .blue.accent-2 {
        background-color: #448AFF !important;
        border-color: #448AFF !important;
      }
      
      .v-application .blue--text.text--accent-2 {
        color: #448AFF !important;
        caret-color: #448AFF !important;
      }
      
      .v-application .blue.accent-3 {
        background-color: #2979FF !important;
        border-color: #2979FF !important;
      }
      
      .v-application .blue--text.text--accent-3 {
        color: #2979FF !important;
        caret-color: #2979FF !important;
      }
      
      .v-application .blue.accent-4 {
        background-color: #2962FF !important;
        border-color: #2962FF !important;
      }
      
      .v-application .blue--text.text--accent-4 {
        color: #2962FF !important;
        caret-color: #2962FF !important;
      }
      
      .v-application .light-blue {
        background-color: #03a9f4 !important;
        border-color: #03a9f4 !important;
      }
      
      .v-application .light-blue--text {
        color: #03a9f4 !important;
        caret-color: #03a9f4 !important;
      }
      
      .v-application .light-blue.lighten-5 {
        background-color: #e1f5fe !important;
        border-color: #e1f5fe !important;
      }
      
      .v-application .light-blue--text.text--lighten-5 {
        color: #e1f5fe !important;
        caret-color: #e1f5fe !important;
      }
      
      .v-application .light-blue.lighten-4 {
        background-color: #b3e5fc !important;
        border-color: #b3e5fc !important;
      }
      
      .v-application .light-blue--text.text--lighten-4 {
        color: #b3e5fc !important;
        caret-color: #b3e5fc !important;
      }
      
      .v-application .light-blue.lighten-3 {
        background-color: #81d4fa !important;
        border-color: #81d4fa !important;
      }
      
      .v-application .light-blue--text.text--lighten-3 {
        color: #81d4fa !important;
        caret-color: #81d4fa !important;
      }
      
      .v-application .light-blue.lighten-2 {
        background-color: #4fc3f7 !important;
        border-color: #4fc3f7 !important;
      }
      
      .v-application .light-blue--text.text--lighten-2 {
        color: #4fc3f7 !important;
        caret-color: #4fc3f7 !important;
      }
      
      .v-application .light-blue.lighten-1 {
        background-color: #29b6f6 !important;
        border-color: #29b6f6 !important;
      }
      
      .v-application .light-blue--text.text--lighten-1 {
        color: #29b6f6 !important;
        caret-color: #29b6f6 !important;
      }
      
      .v-application .light-blue.darken-1 {
        background-color: #039be5 !important;
        border-color: #039be5 !important;
      }
      
      .v-application .light-blue--text.text--darken-1 {
        color: #039be5 !important;
        caret-color: #039be5 !important;
      }
      
      .v-application .light-blue.darken-2 {
        background-color: #0288d1 !important;
        border-color: #0288d1 !important;
      }
      
      .v-application .light-blue--text.text--darken-2 {
        color: #0288d1 !important;
        caret-color: #0288d1 !important;
      }
      
      .v-application .light-blue.darken-3 {
        background-color: #0277bd !important;
        border-color: #0277bd !important;
      }
      
      .v-application .light-blue--text.text--darken-3 {
        color: #0277bd !important;
        caret-color: #0277bd !important;
      }
      
      .v-application .light-blue.darken-4 {
        background-color: #01579b !important;
        border-color: #01579b !important;
      }
      
      .v-application .light-blue--text.text--darken-4 {
        color: #01579b !important;
        caret-color: #01579b !important;
      }
      
      .v-application .light-blue.accent-1 {
        background-color: #80d8ff !important;
        border-color: #80d8ff !important;
      }
      
      .v-application .light-blue--text.text--accent-1 {
        color: #80d8ff !important;
        caret-color: #80d8ff !important;
      }
      
      .v-application .light-blue.accent-2 {
        background-color: #40c4ff !important;
        border-color: #40c4ff !important;
      }
      
      .v-application .light-blue--text.text--accent-2 {
        color: #40c4ff !important;
        caret-color: #40c4ff !important;
      }
      
      .v-application .light-blue.accent-3 {
        background-color: #00b0ff !important;
        border-color: #00b0ff !important;
      }
      
      .v-application .light-blue--text.text--accent-3 {
        color: #00b0ff !important;
        caret-color: #00b0ff !important;
      }
      
      .v-application .light-blue.accent-4 {
        background-color: #0091ea !important;
        border-color: #0091ea !important;
      }
      
      .v-application .light-blue--text.text--accent-4 {
        color: #0091ea !important;
        caret-color: #0091ea !important;
      }
      
      .v-application .cyan {
        background-color: #00bcd4 !important;
        border-color: #00bcd4 !important;
      }
      
      .v-application .cyan--text {
        color: #00bcd4 !important;
        caret-color: #00bcd4 !important;
      }
      
      .v-application .cyan.lighten-5 {
        background-color: #e0f7fa !important;
        border-color: #e0f7fa !important;
      }
      
      .v-application .cyan--text.text--lighten-5 {
        color: #e0f7fa !important;
        caret-color: #e0f7fa !important;
      }
      
      .v-application .cyan.lighten-4 {
        background-color: #b2ebf2 !important;
        border-color: #b2ebf2 !important;
      }
      
      .v-application .cyan--text.text--lighten-4 {
        color: #b2ebf2 !important;
        caret-color: #b2ebf2 !important;
      }
      
      .v-application .cyan.lighten-3 {
        background-color: #80deea !important;
        border-color: #80deea !important;
      }
      
      .v-application .cyan--text.text--lighten-3 {
        color: #80deea !important;
        caret-color: #80deea !important;
      }
      
      .v-application .cyan.lighten-2 {
        background-color: #4dd0e1 !important;
        border-color: #4dd0e1 !important;
      }
      
      .v-application .cyan--text.text--lighten-2 {
        color: #4dd0e1 !important;
        caret-color: #4dd0e1 !important;
      }
      
      .v-application .cyan.lighten-1 {
        background-color: #26c6da !important;
        border-color: #26c6da !important;
      }
      
      .v-application .cyan--text.text--lighten-1 {
        color: #26c6da !important;
        caret-color: #26c6da !important;
      }
      
      .v-application .cyan.darken-1 {
        background-color: #00acc1 !important;
        border-color: #00acc1 !important;
      }
      
      .v-application .cyan--text.text--darken-1 {
        color: #00acc1 !important;
        caret-color: #00acc1 !important;
      }
      
      .v-application .cyan.darken-2 {
        background-color: #0097a7 !important;
        border-color: #0097a7 !important;
      }
      
      .v-application .cyan--text.text--darken-2 {
        color: #0097a7 !important;
        caret-color: #0097a7 !important;
      }
      
      .v-application .cyan.darken-3 {
        background-color: #00838f !important;
        border-color: #00838f !important;
      }
      
      .v-application .cyan--text.text--darken-3 {
        color: #00838f !important;
        caret-color: #00838f !important;
      }
      
      .v-application .cyan.darken-4 {
        background-color: #006064 !important;
        border-color: #006064 !important;
      }
      
      .v-application .cyan--text.text--darken-4 {
        color: #006064 !important;
        caret-color: #006064 !important;
      }
      
      .v-application .cyan.accent-1 {
        background-color: #84ffff !important;
        border-color: #84ffff !important;
      }
      
      .v-application .cyan--text.text--accent-1 {
        color: #84ffff !important;
        caret-color: #84ffff !important;
      }
      
      .v-application .cyan.accent-2 {
        background-color: #18ffff !important;
        border-color: #18ffff !important;
      }
      
      .v-application .cyan--text.text--accent-2 {
        color: #18ffff !important;
        caret-color: #18ffff !important;
      }
      
      .v-application .cyan.accent-3 {
        background-color: #00e5ff !important;
        border-color: #00e5ff !important;
      }
      
      .v-application .cyan--text.text--accent-3 {
        color: #00e5ff !important;
        caret-color: #00e5ff !important;
      }
      
      .v-application .cyan.accent-4 {
        background-color: #00b8d4 !important;
        border-color: #00b8d4 !important;
      }
      
      .v-application .cyan--text.text--accent-4 {
        color: #00b8d4 !important;
        caret-color: #00b8d4 !important;
      }
      
      .v-application .teal {
        background-color: #009688 !important;
        border-color: #009688 !important;
      }
      
      .v-application .teal--text {
        color: #009688 !important;
        caret-color: #009688 !important;
      }
      
      .v-application .teal.lighten-5 {
        background-color: #e0f2f1 !important;
        border-color: #e0f2f1 !important;
      }
      
      .v-application .teal--text.text--lighten-5 {
        color: #e0f2f1 !important;
        caret-color: #e0f2f1 !important;
      }
      
      .v-application .teal.lighten-4 {
        background-color: #b2dfdb !important;
        border-color: #b2dfdb !important;
      }
      
      .v-application .teal--text.text--lighten-4 {
        color: #b2dfdb !important;
        caret-color: #b2dfdb !important;
      }
      
      .v-application .teal.lighten-3 {
        background-color: #80cbc4 !important;
        border-color: #80cbc4 !important;
      }
      
      .v-application .teal--text.text--lighten-3 {
        color: #80cbc4 !important;
        caret-color: #80cbc4 !important;
      }
      
      .v-application .teal.lighten-2 {
        background-color: #4db6ac !important;
        border-color: #4db6ac !important;
      }
      
      .v-application .teal--text.text--lighten-2 {
        color: #4db6ac !important;
        caret-color: #4db6ac !important;
      }
      
      .v-application .teal.lighten-1 {
        background-color: #26a69a !important;
        border-color: #26a69a !important;
      }
      
      .v-application .teal--text.text--lighten-1 {
        color: #26a69a !important;
        caret-color: #26a69a !important;
      }
      
      .v-application .teal.darken-1 {
        background-color: #00897b !important;
        border-color: #00897b !important;
      }
      
      .v-application .teal--text.text--darken-1 {
        color: #00897b !important;
        caret-color: #00897b !important;
      }
      
      .v-application .teal.darken-2 {
        background-color: #00796b !important;
        border-color: #00796b !important;
      }
      
      .v-application .teal--text.text--darken-2 {
        color: #00796b !important;
        caret-color: #00796b !important;
      }
      
      .v-application .teal.darken-3 {
        background-color: #00695c !important;
        border-color: #00695c !important;
      }
      
      .v-application .teal--text.text--darken-3 {
        color: #00695c !important;
        caret-color: #00695c !important;
      }
      
      .v-application .teal.darken-4 {
        background-color: #004d40 !important;
        border-color: #004d40 !important;
      }
      
      .v-application .teal--text.text--darken-4 {
        color: #004d40 !important;
        caret-color: #004d40 !important;
      }
      
      .v-application .teal.accent-1 {
        background-color: #a7ffeb !important;
        border-color: #a7ffeb !important;
      }
      
      .v-application .teal--text.text--accent-1 {
        color: #a7ffeb !important;
        caret-color: #a7ffeb !important;
      }
      
      .v-application .teal.accent-2 {
        background-color: #64ffda !important;
        border-color: #64ffda !important;
      }
      
      .v-application .teal--text.text--accent-2 {
        color: #64ffda !important;
        caret-color: #64ffda !important;
      }
      
      .v-application .teal.accent-3 {
        background-color: #1de9b6 !important;
        border-color: #1de9b6 !important;
      }
      
      .v-application .teal--text.text--accent-3 {
        color: #1de9b6 !important;
        caret-color: #1de9b6 !important;
      }
      
      .v-application .teal.accent-4 {
        background-color: #00bfa5 !important;
        border-color: #00bfa5 !important;
      }
      
      .v-application .teal--text.text--accent-4 {
        color: #00bfa5 !important;
        caret-color: #00bfa5 !important;
      }
      
      .v-application .green {
        background-color: #4CAF50 !important;
        border-color: #4CAF50 !important;
      }
      
      .v-application .green--text {
        color: #4CAF50 !important;
        caret-color: #4CAF50 !important;
      }
      
      .v-application .green.lighten-5 {
        background-color: #E8F5E9 !important;
        border-color: #E8F5E9 !important;
      }
      
      .v-application .green--text.text--lighten-5 {
        color: #E8F5E9 !important;
        caret-color: #E8F5E9 !important;
      }
      
      .v-application .green.lighten-4 {
        background-color: #C8E6C9 !important;
        border-color: #C8E6C9 !important;
      }
      
      .v-application .green--text.text--lighten-4 {
        color: #C8E6C9 !important;
        caret-color: #C8E6C9 !important;
      }
      
      .v-application .green.lighten-3 {
        background-color: #A5D6A7 !important;
        border-color: #A5D6A7 !important;
      }
      
      .v-application .green--text.text--lighten-3 {
        color: #A5D6A7 !important;
        caret-color: #A5D6A7 !important;
      }
      
      .v-application .green.lighten-2 {
        background-color: #81C784 !important;
        border-color: #81C784 !important;
      }
      
      .v-application .green--text.text--lighten-2 {
        color: #81C784 !important;
        caret-color: #81C784 !important;
      }
      
      .v-application .green.lighten-1 {
        background-color: #66BB6A !important;
        border-color: #66BB6A !important;
      }
      
      .v-application .green--text.text--lighten-1 {
        color: #66BB6A !important;
        caret-color: #66BB6A !important;
      }
      
      .v-application .green.darken-1 {
        background-color: #43A047 !important;
        border-color: #43A047 !important;
      }
      
      .v-application .green--text.text--darken-1 {
        color: #43A047 !important;
        caret-color: #43A047 !important;
      }
      
      .v-application .green.darken-2 {
        background-color: #388E3C !important;
        border-color: #388E3C !important;
      }
      
      .v-application .green--text.text--darken-2 {
        color: #388E3C !important;
        caret-color: #388E3C !important;
      }
      
      .v-application .green.darken-3 {
        background-color: #2E7D32 !important;
        border-color: #2E7D32 !important;
      }
      
      .v-application .green--text.text--darken-3 {
        color: #2E7D32 !important;
        caret-color: #2E7D32 !important;
      }
      
      .v-application .green.darken-4 {
        background-color: #1B5E20 !important;
        border-color: #1B5E20 !important;
      }
      
      .v-application .green--text.text--darken-4 {
        color: #1B5E20 !important;
        caret-color: #1B5E20 !important;
      }
      
      .v-application .green.accent-1 {
        background-color: #B9F6CA !important;
        border-color: #B9F6CA !important;
      }
      
      .v-application .green--text.text--accent-1 {
        color: #B9F6CA !important;
        caret-color: #B9F6CA !important;
      }
      
      .v-application .green.accent-2 {
        background-color: #69F0AE !important;
        border-color: #69F0AE !important;
      }
      
      .v-application .green--text.text--accent-2 {
        color: #69F0AE !important;
        caret-color: #69F0AE !important;
      }
      
      .v-application .green.accent-3 {
        background-color: #00E676 !important;
        border-color: #00E676 !important;
      }
      
      .v-application .green--text.text--accent-3 {
        color: #00E676 !important;
        caret-color: #00E676 !important;
      }
      
      .v-application .green.accent-4 {
        background-color: #00C853 !important;
        border-color: #00C853 !important;
      }
      
      .v-application .green--text.text--accent-4 {
        color: #00C853 !important;
        caret-color: #00C853 !important;
      }
      
      .v-application .light-green {
        background-color: #8bc34a !important;
        border-color: #8bc34a !important;
      }
      
      .v-application .light-green--text {
        color: #8bc34a !important;
        caret-color: #8bc34a !important;
      }
      
      .v-application .light-green.lighten-5 {
        background-color: #f1f8e9 !important;
        border-color: #f1f8e9 !important;
      }
      
      .v-application .light-green--text.text--lighten-5 {
        color: #f1f8e9 !important;
        caret-color: #f1f8e9 !important;
      }
      
      .v-application .light-green.lighten-4 {
        background-color: #dcedc8 !important;
        border-color: #dcedc8 !important;
      }
      
      .v-application .light-green--text.text--lighten-4 {
        color: #dcedc8 !important;
        caret-color: #dcedc8 !important;
      }
      
      .v-application .light-green.lighten-3 {
        background-color: #c5e1a5 !important;
        border-color: #c5e1a5 !important;
      }
      
      .v-application .light-green--text.text--lighten-3 {
        color: #c5e1a5 !important;
        caret-color: #c5e1a5 !important;
      }
      
      .v-application .light-green.lighten-2 {
        background-color: #aed581 !important;
        border-color: #aed581 !important;
      }
      
      .v-application .light-green--text.text--lighten-2 {
        color: #aed581 !important;
        caret-color: #aed581 !important;
      }
      
      .v-application .light-green.lighten-1 {
        background-color: #9ccc65 !important;
        border-color: #9ccc65 !important;
      }
      
      .v-application .light-green--text.text--lighten-1 {
        color: #9ccc65 !important;
        caret-color: #9ccc65 !important;
      }
      
      .v-application .light-green.darken-1 {
        background-color: #7cb342 !important;
        border-color: #7cb342 !important;
      }
      
      .v-application .light-green--text.text--darken-1 {
        color: #7cb342 !important;
        caret-color: #7cb342 !important;
      }
      
      .v-application .light-green.darken-2 {
        background-color: #689f38 !important;
        border-color: #689f38 !important;
      }
      
      .v-application .light-green--text.text--darken-2 {
        color: #689f38 !important;
        caret-color: #689f38 !important;
      }
      
      .v-application .light-green.darken-3 {
        background-color: #558b2f !important;
        border-color: #558b2f !important;
      }
      
      .v-application .light-green--text.text--darken-3 {
        color: #558b2f !important;
        caret-color: #558b2f !important;
      }
      
      .v-application .light-green.darken-4 {
        background-color: #33691e !important;
        border-color: #33691e !important;
      }
      
      .v-application .light-green--text.text--darken-4 {
        color: #33691e !important;
        caret-color: #33691e !important;
      }
      
      .v-application .light-green.accent-1 {
        background-color: #ccff90 !important;
        border-color: #ccff90 !important;
      }
      
      .v-application .light-green--text.text--accent-1 {
        color: #ccff90 !important;
        caret-color: #ccff90 !important;
      }
      
      .v-application .light-green.accent-2 {
        background-color: #b2ff59 !important;
        border-color: #b2ff59 !important;
      }
      
      .v-application .light-green--text.text--accent-2 {
        color: #b2ff59 !important;
        caret-color: #b2ff59 !important;
      }
      
      .v-application .light-green.accent-3 {
        background-color: #76ff03 !important;
        border-color: #76ff03 !important;
      }
      
      .v-application .light-green--text.text--accent-3 {
        color: #76ff03 !important;
        caret-color: #76ff03 !important;
      }
      
      .v-application .light-green.accent-4 {
        background-color: #64dd17 !important;
        border-color: #64dd17 !important;
      }
      
      .v-application .light-green--text.text--accent-4 {
        color: #64dd17 !important;
        caret-color: #64dd17 !important;
      }
      
      .v-application .lime {
        background-color: #cddc39 !important;
        border-color: #cddc39 !important;
      }
      
      .v-application .lime--text {
        color: #cddc39 !important;
        caret-color: #cddc39 !important;
      }
      
      .v-application .lime.lighten-5 {
        background-color: #f9fbe7 !important;
        border-color: #f9fbe7 !important;
      }
      
      .v-application .lime--text.text--lighten-5 {
        color: #f9fbe7 !important;
        caret-color: #f9fbe7 !important;
      }
      
      .v-application .lime.lighten-4 {
        background-color: #f0f4c3 !important;
        border-color: #f0f4c3 !important;
      }
      
      .v-application .lime--text.text--lighten-4 {
        color: #f0f4c3 !important;
        caret-color: #f0f4c3 !important;
      }
      
      .v-application .lime.lighten-3 {
        background-color: #e6ee9c !important;
        border-color: #e6ee9c !important;
      }
      
      .v-application .lime--text.text--lighten-3 {
        color: #e6ee9c !important;
        caret-color: #e6ee9c !important;
      }
      
      .v-application .lime.lighten-2 {
        background-color: #dce775 !important;
        border-color: #dce775 !important;
      }
      
      .v-application .lime--text.text--lighten-2 {
        color: #dce775 !important;
        caret-color: #dce775 !important;
      }
      
      .v-application .lime.lighten-1 {
        background-color: #d4e157 !important;
        border-color: #d4e157 !important;
      }
      
      .v-application .lime--text.text--lighten-1 {
        color: #d4e157 !important;
        caret-color: #d4e157 !important;
      }
      
      .v-application .lime.darken-1 {
        background-color: #c0ca33 !important;
        border-color: #c0ca33 !important;
      }
      
      .v-application .lime--text.text--darken-1 {
        color: #c0ca33 !important;
        caret-color: #c0ca33 !important;
      }
      
      .v-application .lime.darken-2 {
        background-color: #afb42b !important;
        border-color: #afb42b !important;
      }
      
      .v-application .lime--text.text--darken-2 {
        color: #afb42b !important;
        caret-color: #afb42b !important;
      }
      
      .v-application .lime.darken-3 {
        background-color: #9e9d24 !important;
        border-color: #9e9d24 !important;
      }
      
      .v-application .lime--text.text--darken-3 {
        color: #9e9d24 !important;
        caret-color: #9e9d24 !important;
      }
      
      .v-application .lime.darken-4 {
        background-color: #827717 !important;
        border-color: #827717 !important;
      }
      
      .v-application .lime--text.text--darken-4 {
        color: #827717 !important;
        caret-color: #827717 !important;
      }
      
      .v-application .lime.accent-1 {
        background-color: #f4ff81 !important;
        border-color: #f4ff81 !important;
      }
      
      .v-application .lime--text.text--accent-1 {
        color: #f4ff81 !important;
        caret-color: #f4ff81 !important;
      }
      
      .v-application .lime.accent-2 {
        background-color: #eeff41 !important;
        border-color: #eeff41 !important;
      }
      
      .v-application .lime--text.text--accent-2 {
        color: #eeff41 !important;
        caret-color: #eeff41 !important;
      }
      
      .v-application .lime.accent-3 {
        background-color: #c6ff00 !important;
        border-color: #c6ff00 !important;
      }
      
      .v-application .lime--text.text--accent-3 {
        color: #c6ff00 !important;
        caret-color: #c6ff00 !important;
      }
      
      .v-application .lime.accent-4 {
        background-color: #aeea00 !important;
        border-color: #aeea00 !important;
      }
      
      .v-application .lime--text.text--accent-4 {
        color: #aeea00 !important;
        caret-color: #aeea00 !important;
      }
      
      .v-application .yellow {
        background-color: #ffeb3b !important;
        border-color: #ffeb3b !important;
      }
      
      .v-application .yellow--text {
        color: #ffeb3b !important;
        caret-color: #ffeb3b !important;
      }
      
      .v-application .yellow.lighten-5 {
        background-color: #fffde7 !important;
        border-color: #fffde7 !important;
      }
      
      .v-application .yellow--text.text--lighten-5 {
        color: #fffde7 !important;
        caret-color: #fffde7 !important;
      }
      
      .v-application .yellow.lighten-4 {
        background-color: #fff9c4 !important;
        border-color: #fff9c4 !important;
      }
      
      .v-application .yellow--text.text--lighten-4 {
        color: #fff9c4 !important;
        caret-color: #fff9c4 !important;
      }
      
      .v-application .yellow.lighten-3 {
        background-color: #fff59d !important;
        border-color: #fff59d !important;
      }
      
      .v-application .yellow--text.text--lighten-3 {
        color: #fff59d !important;
        caret-color: #fff59d !important;
      }
      
      .v-application .yellow.lighten-2 {
        background-color: #fff176 !important;
        border-color: #fff176 !important;
      }
      
      .v-application .yellow--text.text--lighten-2 {
        color: #fff176 !important;
        caret-color: #fff176 !important;
      }
      
      .v-application .yellow.lighten-1 {
        background-color: #ffee58 !important;
        border-color: #ffee58 !important;
      }
      
      .v-application .yellow--text.text--lighten-1 {
        color: #ffee58 !important;
        caret-color: #ffee58 !important;
      }
      
      .v-application .yellow.darken-1 {
        background-color: #fdd835 !important;
        border-color: #fdd835 !important;
      }
      
      .v-application .yellow--text.text--darken-1 {
        color: #fdd835 !important;
        caret-color: #fdd835 !important;
      }
      
      .v-application .yellow.darken-2 {
        background-color: #fbc02d !important;
        border-color: #fbc02d !important;
      }
      
      .v-application .yellow--text.text--darken-2 {
        color: #fbc02d !important;
        caret-color: #fbc02d !important;
      }
      
      .v-application .yellow.darken-3 {
        background-color: #f9a825 !important;
        border-color: #f9a825 !important;
      }
      
      .v-application .yellow--text.text--darken-3 {
        color: #f9a825 !important;
        caret-color: #f9a825 !important;
      }
      
      .v-application .yellow.darken-4 {
        background-color: #f57f17 !important;
        border-color: #f57f17 !important;
      }
      
      .v-application .yellow--text.text--darken-4 {
        color: #f57f17 !important;
        caret-color: #f57f17 !important;
      }
      
      .v-application .yellow.accent-1 {
        background-color: #ffff8d !important;
        border-color: #ffff8d !important;
      }
      
      .v-application .yellow--text.text--accent-1 {
        color: #ffff8d !important;
        caret-color: #ffff8d !important;
      }
      
      .v-application .yellow.accent-2 {
        background-color: #ffff00 !important;
        border-color: #ffff00 !important;
      }
      
      .v-application .yellow--text.text--accent-2 {
        color: #ffff00 !important;
        caret-color: #ffff00 !important;
      }
      
      .v-application .yellow.accent-3 {
        background-color: #ffea00 !important;
        border-color: #ffea00 !important;
      }
      
      .v-application .yellow--text.text--accent-3 {
        color: #ffea00 !important;
        caret-color: #ffea00 !important;
      }
      
      .v-application .yellow.accent-4 {
        background-color: #ffd600 !important;
        border-color: #ffd600 !important;
      }
      
      .v-application .yellow--text.text--accent-4 {
        color: #ffd600 !important;
        caret-color: #ffd600 !important;
      }
      
      .v-application .amber {
        background-color: #ffc107 !important;
        border-color: #ffc107 !important;
      }
      
      .v-application .amber--text {
        color: #ffc107 !important;
        caret-color: #ffc107 !important;
      }
      
      .v-application .amber.lighten-5 {
        background-color: #fff8e1 !important;
        border-color: #fff8e1 !important;
      }
      
      .v-application .amber--text.text--lighten-5 {
        color: #fff8e1 !important;
        caret-color: #fff8e1 !important;
      }
      
      .v-application .amber.lighten-4 {
        background-color: #ffecb3 !important;
        border-color: #ffecb3 !important;
      }
      
      .v-application .amber--text.text--lighten-4 {
        color: #ffecb3 !important;
        caret-color: #ffecb3 !important;
      }
      
      .v-application .amber.lighten-3 {
        background-color: #ffe082 !important;
        border-color: #ffe082 !important;
      }
      
      .v-application .amber--text.text--lighten-3 {
        color: #ffe082 !important;
        caret-color: #ffe082 !important;
      }
      
      .v-application .amber.lighten-2 {
        background-color: #ffd54f !important;
        border-color: #ffd54f !important;
      }
      
      .v-application .amber--text.text--lighten-2 {
        color: #ffd54f !important;
        caret-color: #ffd54f !important;
      }
      
      .v-application .amber.lighten-1 {
        background-color: #ffca28 !important;
        border-color: #ffca28 !important;
      }
      
      .v-application .amber--text.text--lighten-1 {
        color: #ffca28 !important;
        caret-color: #ffca28 !important;
      }
      
      .v-application .amber.darken-1 {
        background-color: #ffb300 !important;
        border-color: #ffb300 !important;
      }
      
      .v-application .amber--text.text--darken-1 {
        color: #ffb300 !important;
        caret-color: #ffb300 !important;
      }
      
      .v-application .amber.darken-2 {
        background-color: #ffa000 !important;
        border-color: #ffa000 !important;
      }
      
      .v-application .amber--text.text--darken-2 {
        color: #ffa000 !important;
        caret-color: #ffa000 !important;
      }
      
      .v-application .amber.darken-3 {
        background-color: #ff8f00 !important;
        border-color: #ff8f00 !important;
      }
      
      .v-application .amber--text.text--darken-3 {
        color: #ff8f00 !important;
        caret-color: #ff8f00 !important;
      }
      
      .v-application .amber.darken-4 {
        background-color: #ff6f00 !important;
        border-color: #ff6f00 !important;
      }
      
      .v-application .amber--text.text--darken-4 {
        color: #ff6f00 !important;
        caret-color: #ff6f00 !important;
      }
      
      .v-application .amber.accent-1 {
        background-color: #ffe57f !important;
        border-color: #ffe57f !important;
      }
      
      .v-application .amber--text.text--accent-1 {
        color: #ffe57f !important;
        caret-color: #ffe57f !important;
      }
      
      .v-application .amber.accent-2 {
        background-color: #ffd740 !important;
        border-color: #ffd740 !important;
      }
      
      .v-application .amber--text.text--accent-2 {
        color: #ffd740 !important;
        caret-color: #ffd740 !important;
      }
      
      .v-application .amber.accent-3 {
        background-color: #ffc400 !important;
        border-color: #ffc400 !important;
      }
      
      .v-application .amber--text.text--accent-3 {
        color: #ffc400 !important;
        caret-color: #ffc400 !important;
      }
      
      .v-application .amber.accent-4 {
        background-color: #ffab00 !important;
        border-color: #ffab00 !important;
      }
      
      .v-application .amber--text.text--accent-4 {
        color: #ffab00 !important;
        caret-color: #ffab00 !important;
      }
      
      .v-application .orange {
        background-color: #ff9800 !important;
        border-color: #ff9800 !important;
      }
      
      .v-application .orange--text {
        color: #ff9800 !important;
        caret-color: #ff9800 !important;
      }
      
      .v-application .orange.lighten-5 {
        background-color: #fff3e0 !important;
        border-color: #fff3e0 !important;
      }
      
      .v-application .orange--text.text--lighten-5 {
        color: #fff3e0 !important;
        caret-color: #fff3e0 !important;
      }
      
      .v-application .orange.lighten-4 {
        background-color: #ffe0b2 !important;
        border-color: #ffe0b2 !important;
      }
      
      .v-application .orange--text.text--lighten-4 {
        color: #ffe0b2 !important;
        caret-color: #ffe0b2 !important;
      }
      
      .v-application .orange.lighten-3 {
        background-color: #ffcc80 !important;
        border-color: #ffcc80 !important;
      }
      
      .v-application .orange--text.text--lighten-3 {
        color: #ffcc80 !important;
        caret-color: #ffcc80 !important;
      }
      
      .v-application .orange.lighten-2 {
        background-color: #ffb74d !important;
        border-color: #ffb74d !important;
      }
      
      .v-application .orange--text.text--lighten-2 {
        color: #ffb74d !important;
        caret-color: #ffb74d !important;
      }
      
      .v-application .orange.lighten-1 {
        background-color: #ffa726 !important;
        border-color: #ffa726 !important;
      }
      
      .v-application .orange--text.text--lighten-1 {
        color: #ffa726 !important;
        caret-color: #ffa726 !important;
      }
      
      .v-application .orange.darken-1 {
        background-color: #fb8c00 !important;
        border-color: #fb8c00 !important;
      }
      
      .v-application .orange--text.text--darken-1 {
        color: #fb8c00 !important;
        caret-color: #fb8c00 !important;
      }
      
      .v-application .orange.darken-2 {
        background-color: #f57c00 !important;
        border-color: #f57c00 !important;
      }
      
      .v-application .orange--text.text--darken-2 {
        color: #f57c00 !important;
        caret-color: #f57c00 !important;
      }
      
      .v-application .orange.darken-3 {
        background-color: #ef6c00 !important;
        border-color: #ef6c00 !important;
      }
      
      .v-application .orange--text.text--darken-3 {
        color: #ef6c00 !important;
        caret-color: #ef6c00 !important;
      }
      
      .v-application .orange.darken-4 {
        background-color: #e65100 !important;
        border-color: #e65100 !important;
      }
      
      .v-application .orange--text.text--darken-4 {
        color: #e65100 !important;
        caret-color: #e65100 !important;
      }
      
      .v-application .orange.accent-1 {
        background-color: #ffd180 !important;
        border-color: #ffd180 !important;
      }
      
      .v-application .orange--text.text--accent-1 {
        color: #ffd180 !important;
        caret-color: #ffd180 !important;
      }
      
      .v-application .orange.accent-2 {
        background-color: #ffab40 !important;
        border-color: #ffab40 !important;
      }
      
      .v-application .orange--text.text--accent-2 {
        color: #ffab40 !important;
        caret-color: #ffab40 !important;
      }
      
      .v-application .orange.accent-3 {
        background-color: #ff9100 !important;
        border-color: #ff9100 !important;
      }
      
      .v-application .orange--text.text--accent-3 {
        color: #ff9100 !important;
        caret-color: #ff9100 !important;
      }
      
      .v-application .orange.accent-4 {
        background-color: #ff6d00 !important;
        border-color: #ff6d00 !important;
      }
      
      .v-application .orange--text.text--accent-4 {
        color: #ff6d00 !important;
        caret-color: #ff6d00 !important;
      }
      
      .v-application .deep-orange {
        background-color: #ff5722 !important;
        border-color: #ff5722 !important;
      }
      
      .v-application .deep-orange--text {
        color: #ff5722 !important;
        caret-color: #ff5722 !important;
      }
      
      .v-application .deep-orange.lighten-5 {
        background-color: #fbe9e7 !important;
        border-color: #fbe9e7 !important;
      }
      
      .v-application .deep-orange--text.text--lighten-5 {
        color: #fbe9e7 !important;
        caret-color: #fbe9e7 !important;
      }
      
      .v-application .deep-orange.lighten-4 {
        background-color: #ffccbc !important;
        border-color: #ffccbc !important;
      }
      
      .v-application .deep-orange--text.text--lighten-4 {
        color: #ffccbc !important;
        caret-color: #ffccbc !important;
      }
      
      .v-application .deep-orange.lighten-3 {
        background-color: #ffab91 !important;
        border-color: #ffab91 !important;
      }
      
      .v-application .deep-orange--text.text--lighten-3 {
        color: #ffab91 !important;
        caret-color: #ffab91 !important;
      }
      
      .v-application .deep-orange.lighten-2 {
        background-color: #ff8a65 !important;
        border-color: #ff8a65 !important;
      }
      
      .v-application .deep-orange--text.text--lighten-2 {
        color: #ff8a65 !important;
        caret-color: #ff8a65 !important;
      }
      
      .v-application .deep-orange.lighten-1 {
        background-color: #ff7043 !important;
        border-color: #ff7043 !important;
      }
      
      .v-application .deep-orange--text.text--lighten-1 {
        color: #ff7043 !important;
        caret-color: #ff7043 !important;
      }
      
      .v-application .deep-orange.darken-1 {
        background-color: #f4511e !important;
        border-color: #f4511e !important;
      }
      
      .v-application .deep-orange--text.text--darken-1 {
        color: #f4511e !important;
        caret-color: #f4511e !important;
      }
      
      .v-application .deep-orange.darken-2 {
        background-color: #e64a19 !important;
        border-color: #e64a19 !important;
      }
      
      .v-application .deep-orange--text.text--darken-2 {
        color: #e64a19 !important;
        caret-color: #e64a19 !important;
      }
      
      .v-application .deep-orange.darken-3 {
        background-color: #d84315 !important;
        border-color: #d84315 !important;
      }
      
      .v-application .deep-orange--text.text--darken-3 {
        color: #d84315 !important;
        caret-color: #d84315 !important;
      }
      
      .v-application .deep-orange.darken-4 {
        background-color: #bf360c !important;
        border-color: #bf360c !important;
      }
      
      .v-application .deep-orange--text.text--darken-4 {
        color: #bf360c !important;
        caret-color: #bf360c !important;
      }
      
      .v-application .deep-orange.accent-1 {
        background-color: #ff9e80 !important;
        border-color: #ff9e80 !important;
      }
      
      .v-application .deep-orange--text.text--accent-1 {
        color: #ff9e80 !important;
        caret-color: #ff9e80 !important;
      }
      
      .v-application .deep-orange.accent-2 {
        background-color: #ff6e40 !important;
        border-color: #ff6e40 !important;
      }
      
      .v-application .deep-orange--text.text--accent-2 {
        color: #ff6e40 !important;
        caret-color: #ff6e40 !important;
      }
      
      .v-application .deep-orange.accent-3 {
        background-color: #ff3d00 !important;
        border-color: #ff3d00 !important;
      }
      
      .v-application .deep-orange--text.text--accent-3 {
        color: #ff3d00 !important;
        caret-color: #ff3d00 !important;
      }
      
      .v-application .deep-orange.accent-4 {
        background-color: #dd2c00 !important;
        border-color: #dd2c00 !important;
      }
      
      .v-application .deep-orange--text.text--accent-4 {
        color: #dd2c00 !important;
        caret-color: #dd2c00 !important;
      }
      
      .v-application .brown {
        background-color: #795548 !important;
        border-color: #795548 !important;
      }
      
      .v-application .brown--text {
        color: #795548 !important;
        caret-color: #795548 !important;
      }
      
      .v-application .brown.lighten-5 {
        background-color: #efebe9 !important;
        border-color: #efebe9 !important;
      }
      
      .v-application .brown--text.text--lighten-5 {
        color: #efebe9 !important;
        caret-color: #efebe9 !important;
      }
      
      .v-application .brown.lighten-4 {
        background-color: #d7ccc8 !important;
        border-color: #d7ccc8 !important;
      }
      
      .v-application .brown--text.text--lighten-4 {
        color: #d7ccc8 !important;
        caret-color: #d7ccc8 !important;
      }
      
      .v-application .brown.lighten-3 {
        background-color: #bcaaa4 !important;
        border-color: #bcaaa4 !important;
      }
      
      .v-application .brown--text.text--lighten-3 {
        color: #bcaaa4 !important;
        caret-color: #bcaaa4 !important;
      }
      
      .v-application .brown.lighten-2 {
        background-color: #a1887f !important;
        border-color: #a1887f !important;
      }
      
      .v-application .brown--text.text--lighten-2 {
        color: #a1887f !important;
        caret-color: #a1887f !important;
      }
      
      .v-application .brown.lighten-1 {
        background-color: #8d6e63 !important;
        border-color: #8d6e63 !important;
      }
      
      .v-application .brown--text.text--lighten-1 {
        color: #8d6e63 !important;
        caret-color: #8d6e63 !important;
      }
      
      .v-application .brown.darken-1 {
        background-color: #6d4c41 !important;
        border-color: #6d4c41 !important;
      }
      
      .v-application .brown--text.text--darken-1 {
        color: #6d4c41 !important;
        caret-color: #6d4c41 !important;
      }
      
      .v-application .brown.darken-2 {
        background-color: #5d4037 !important;
        border-color: #5d4037 !important;
      }
      
      .v-application .brown--text.text--darken-2 {
        color: #5d4037 !important;
        caret-color: #5d4037 !important;
      }
      
      .v-application .brown.darken-3 {
        background-color: #4e342e !important;
        border-color: #4e342e !important;
      }
      
      .v-application .brown--text.text--darken-3 {
        color: #4e342e !important;
        caret-color: #4e342e !important;
      }
      
      .v-application .brown.darken-4 {
        background-color: #3e2723 !important;
        border-color: #3e2723 !important;
      }
      
      .v-application .brown--text.text--darken-4 {
        color: #3e2723 !important;
        caret-color: #3e2723 !important;
      }
      
      .v-application .blue-grey {
        background-color: #607d8b !important;
        border-color: #607d8b !important;
      }
      
      .v-application .blue-grey--text {
        color: #607d8b !important;
        caret-color: #607d8b !important;
      }
      
      .v-application .blue-grey.lighten-5 {
        background-color: #eceff1 !important;
        border-color: #eceff1 !important;
      }
      
      .v-application .blue-grey--text.text--lighten-5 {
        color: #eceff1 !important;
        caret-color: #eceff1 !important;
      }
      
      .v-application .blue-grey.lighten-4 {
        background-color: #cfd8dc !important;
        border-color: #cfd8dc !important;
      }
      
      .v-application .blue-grey--text.text--lighten-4 {
        color: #cfd8dc !important;
        caret-color: #cfd8dc !important;
      }
      
      .v-application .blue-grey.lighten-3 {
        background-color: #b0bec5 !important;
        border-color: #b0bec5 !important;
      }
      
      .v-application .blue-grey--text.text--lighten-3 {
        color: #b0bec5 !important;
        caret-color: #b0bec5 !important;
      }
      
      .v-application .blue-grey.lighten-2 {
        background-color: #90a4ae !important;
        border-color: #90a4ae !important;
      }
      
      .v-application .blue-grey--text.text--lighten-2 {
        color: #90a4ae !important;
        caret-color: #90a4ae !important;
      }
      
      .v-application .blue-grey.lighten-1 {
        background-color: #78909c !important;
        border-color: #78909c !important;
      }
      
      .v-application .blue-grey--text.text--lighten-1 {
        color: #78909c !important;
        caret-color: #78909c !important;
      }
      
      .v-application .blue-grey.darken-1 {
        background-color: #546e7a !important;
        border-color: #546e7a !important;
      }
      
      .v-application .blue-grey--text.text--darken-1 {
        color: #546e7a !important;
        caret-color: #546e7a !important;
      }
      
      .v-application .blue-grey.darken-2 {
        background-color: #455a64 !important;
        border-color: #455a64 !important;
      }
      
      .v-application .blue-grey--text.text--darken-2 {
        color: #455a64 !important;
        caret-color: #455a64 !important;
      }
      
      .v-application .blue-grey.darken-3 {
        background-color: #37474f !important;
        border-color: #37474f !important;
      }
      
      .v-application .blue-grey--text.text--darken-3 {
        color: #37474f !important;
        caret-color: #37474f !important;
      }
      
      .v-application .blue-grey.darken-4 {
        background-color: #263238 !important;
        border-color: #263238 !important;
      }
      
      .v-application .blue-grey--text.text--darken-4 {
        color: #263238 !important;
        caret-color: #263238 !important;
      }
      
      .v-application .grey {
        background-color: #9e9e9e !important;
        border-color: #9e9e9e !important;
      }
      
      .v-application .grey--text {
        color: #9e9e9e !important;
        caret-color: #9e9e9e !important;
      }
      
      .v-application .grey.lighten-5 {
        background-color: #fafafa !important;
        border-color: #fafafa !important;
      }
      
      .v-application .grey--text.text--lighten-5 {
        color: #fafafa !important;
        caret-color: #fafafa !important;
      }
      
      .v-application .grey.lighten-4 {
        background-color: #f5f5f5 !important;
        border-color: #f5f5f5 !important;
      }
      
      .v-application .grey--text.text--lighten-4 {
        color: #f5f5f5 !important;
        caret-color: #f5f5f5 !important;
      }
      
      .v-application .grey.lighten-3 {
        background-color: #eeeeee !important;
        border-color: #eeeeee !important;
      }
      
      .v-application .grey--text.text--lighten-3 {
        color: #eeeeee !important;
        caret-color: #eeeeee !important;
      }
      
      .v-application .grey.lighten-2 {
        background-color: #e0e0e0 !important;
        border-color: #e0e0e0 !important;
      }
      
      .v-application .grey--text.text--lighten-2 {
        color: #e0e0e0 !important;
        caret-color: #e0e0e0 !important;
      }
      
      .v-application .grey.lighten-1 {
        background-color: #bdbdbd !important;
        border-color: #bdbdbd !important;
      }
      
      .v-application .grey--text.text--lighten-1 {
        color: #bdbdbd !important;
        caret-color: #bdbdbd !important;
      }
      
      .v-application .grey.darken-1 {
        background-color: #757575 !important;
        border-color: #757575 !important;
      }
      
      .v-application .grey--text.text--darken-1 {
        color: #757575 !important;
        caret-color: #757575 !important;
      }
      
      .v-application .grey.darken-2 {
        background-color: #616161 !important;
        border-color: #616161 !important;
      }
      
      .v-application .grey--text.text--darken-2 {
        color: #616161 !important;
        caret-color: #616161 !important;
      }
      
      .v-application .grey.darken-3 {
        background-color: #424242 !important;
        border-color: #424242 !important;
      }
      
      .v-application .grey--text.text--darken-3 {
        color: #424242 !important;
        caret-color: #424242 !important;
      }
      
      .v-application .grey.darken-4 {
        background-color: #212121 !important;
        border-color: #212121 !important;
      }
      
      .v-application .grey--text.text--darken-4 {
        color: #212121 !important;
        caret-color: #212121 !important;
      }
      
      .v-application .shades.black {
        background-color: #000000 !important;
        border-color: #000000 !important;
      }
      
      .v-application .shades--text.text--black {
        color: #000000 !important;
        caret-color: #000000 !important;
      }
      
      .v-application .shades.white {
        background-color: #FFFFFF !important;
        border-color: #FFFFFF !important;
      }
      
      .v-application .shades--text.text--white {
        color: #FFFFFF !important;
        caret-color: #FFFFFF !important;
      }
      
      .v-application .shades.transparent {
        background-color: transparent !important;
        border-color: transparent !important;
      }
      
      .v-application .shades--text.text--transparent {
        color: transparent !important;
        caret-color: transparent !important;
      }
      
      /* ! ress.css • v1.1.1 - MIT License - github.com/filipelinhares/ress */
      /* # =================================================================
         # Global selectors
         # ================================================================= */
      html {
        -webkit-box-sizing: border-box;
                box-sizing: border-box;
        overflow-y: scroll;
        /* All browsers without overlaying scrollbars */
        -webkit-text-size-adjust: 100%;
        /* iOS 8+ */
      }
      
      *,
      ::before,
      ::after {
        -webkit-box-sizing: inherit;
                box-sizing: inherit;
      }
      
      ::before,
      ::after {
        text-decoration: inherit;
        /* Inherit text-decoration and vertical align to ::before and ::after pseudo elements */
        vertical-align: inherit;
      }
      
      /* Remove margin, padding of all elements and set background-no-repeat as default */
      * {
        background-repeat: no-repeat;
        padding: 0;
        margin: 0;
      }
      
      /* # =================================================================
         # General elements
         # ================================================================= */
      /* Add the correct display in iOS 4-7.*/
      audio:not([controls]) {
        display: none;
        height: 0;
      }
      
      hr {
        overflow: visible;
        /* Show the overflow in Edge and IE */
      }
      article,
      aside,
      details,
      figcaption,
      figure,
      footer,
      header,
      main,
      menu,
      nav,
      section,
      summary {
        display: block;
      }
      
      summary {
        display: list-item;
        /* Add the correct display in all browsers */
      }
      
      small {
        font-size: 80%;
      }
      
      [hidden],
      template {
        display: none;
        /* Add the correct display in IE */
      }
      
      abbr[title] {
        border-bottom: 1px dotted;
        /* Add a bordered underline effect in all browsers */
        text-decoration: none;
        /* Remove text decoration in Firefox 40+ */
      }
      
      a {
        background-color: transparent;
        /* Remove the gray background on active links in IE 10 */
        -webkit-text-decoration-skip: objects;
        /* Remove gaps in links underline in iOS 8+ and Safari 8+ */
      }
      
      a:active,
      a:hover {
        outline-width: 0;
        /* Remove the outline when hovering in all browsers */
      }
      
      code,
      kbd,
      pre,
      samp {
        font-family: monospace, monospace;
        /* Specify the font family of code elements */
      }
      
      b,
      strong {
        font-weight: bolder;
      }
      
      dfn {
        font-style: italic;
        /* Address styling not present in Safari and Chrome */
      }
      
      /* Address styling not present in IE 8/9 */
      mark {
        background-color: #ff0;
        color: #000;
      }
      
      /* https://gist.github.com/unruthless/413930 */
      sub,
      sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }
      
      sub {
        bottom: -0.25em;
      }
      
      sup {
        top: -0.5em;
      }
      
      /* # =================================================================
         # Forms
         # ================================================================= */
      input {
        border-radius: 0;
      }
      
      /* Apply cursor pointer to button elements */
      button,
      [type=button],
      [type=reset],
      [type=submit] [role=button] {
        cursor: pointer;
      }
      
      /* Replace pointer cursor in disabled elements */
      [disabled] {
        cursor: default;
      }
      
      [type=number] {
        width: auto;
        /* Firefox 36+ */
      }
      
      [type=search] {
        -webkit-appearance: textfield;
        /* Safari 8+ */
      }
      
      [type=search]::-webkit-search-cancel-button,
      [type=search]::-webkit-search-decoration {
        -webkit-appearance: none;
        /* Safari 8 */
      }
      
      textarea {
        overflow: auto;
        /* Internet Explorer 11+ */
        resize: vertical;
        /* Specify textarea resizability */
      }
      
      button,
      input,
      optgroup,
      select,
      textarea {
        font: inherit;
        /* Specify font inheritance of form elements */
      }
      
      optgroup {
        font-weight: bold;
        /* Restore the font weight unset by the previous rule. */
      }
      
      button {
        overflow: visible;
      }
      
      /* Remove inner padding and border in Firefox 4+ */
      button::-moz-focus-inner,
      [type=button]::-moz-focus-inner,
      [type=reset]::-moz-focus-inner,
      [type=submit]::-moz-focus-inner {
        border-style: 0;
        padding: 0;
      }
      
      /* Replace focus style removed in the border reset above */
      button:-moz-focusring,
      [type=button]::-moz-focus-inner,
      [type=reset]::-moz-focus-inner,
      [type=submit]::-moz-focus-inner {
        outline: 0;
        border: 0;
      }
      
      button,
      html [type=button],
      [type=reset],
      [type=submit] {
        -webkit-appearance: button;
        /* Correct the inability to style clickable types in iOS */
      }
      
      button,
      select {
        text-transform: none;
        /* Firefox 40+, Internet Explorer 11- */
      }
      
      /* Remove the default button styling in all browsers */
      button,
      input,
      select,
      textarea {
        background-color: transparent;
        border-style: none;
        color: inherit;
      }
      
      /* Style select like a standard input */
      select {
        -moz-appearance: none;
        /* Firefox 36+ */
        -webkit-appearance: none;
        /* Chrome 41+ */
      }
      
      select::-ms-expand {
        display: none;
        /* Internet Explorer 11+ */
      }
      
      select::-ms-value {
        color: currentColor;
        /* Internet Explorer 11+ */
      }
      
      legend {
        border: 0;
        color: inherit;
        display: table;
        /* Correct the text wrapping in Edge and IE */
        max-width: 100%;
        /* Correct the text wrapping in Edge and IE */
        white-space: normal;
        /* Correct the text wrapping in Edge and IE */
      }
      
      ::-webkit-file-upload-button {
        -webkit-appearance: button;
        /* Correct the inability to style clickable types in iOS and Safari */
        font: inherit;
      }
      
      [type=search] {
        -webkit-appearance: textfield;
        /* Correct the odd appearance in Chrome and Safari */
        outline-offset: -2px;
        /* Correct the outline style in Safari */
      }
      
      /* # =================================================================
         # Specify media element style
         # ================================================================= */
      img {
        border-style: none;
      }
      
      /* Add the correct vertical alignment in Chrome, Firefox, and Opera */
      progress {
        vertical-align: baseline;
      }
      
      svg:not(:root) {
        overflow: hidden;
        /* Internet Explorer 11- */
      }
      
      audio,
      canvas,
      progress,
      video {
        display: inline-block;
        /* Internet Explorer 11+, Windows Phone 8.1+ */
      }
      
      /* # =================================================================
         # Acessibility
         # ================================================================= */
      /* Hide content from screens but not screenreaders */
      @media screen {
        [hidden~=screen] {
          display: inherit;
        }
      
        [hidden~=screen]:not(:active):not(:focus):not(:target) {
          position: absolute !important;
          clip: rect(0 0 0 0) !important;
        }
      }
      /* Specify the progress cursor of updating elements */
      [aria-busy=true] {
        cursor: progress;
      }
      
      /* Specify the pointer cursor of trigger elements */
      [aria-controls] {
        cursor: pointer;
      }
      
      /* Specify the unstyled cursor of disabled, not-editable, or otherwise inoperable elements */
      [aria-disabled] {
        cursor: default;
      }
      
      /* # =================================================================
         # Selection
         # ================================================================= */
      /* Specify text selection background color and omit drop shadow */
      ::-moz-selection {
        background-color: #b3d4fc;
        /* Required when declaring ::selection */
        color: #000;
        text-shadow: none;
      }
      
      ::selection {
        background-color: #b3d4fc;
        /* Required when declaring ::selection */
        color: #000;
        text-shadow: none;
      }
      
      .v-application .elevation-24 {
        -webkit-box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-23 {
        -webkit-box-shadow: 0px 11px 14px -7px rgba(0, 0, 0, 0.2), 0px 23px 36px 3px rgba(0, 0, 0, 0.14), 0px 9px 44px 8px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 11px 14px -7px rgba(0, 0, 0, 0.2), 0px 23px 36px 3px rgba(0, 0, 0, 0.14), 0px 9px 44px 8px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-22 {
        -webkit-box-shadow: 0px 10px 14px -6px rgba(0, 0, 0, 0.2), 0px 22px 35px 3px rgba(0, 0, 0, 0.14), 0px 8px 42px 7px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 10px 14px -6px rgba(0, 0, 0, 0.2), 0px 22px 35px 3px rgba(0, 0, 0, 0.14), 0px 8px 42px 7px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-21 {
        -webkit-box-shadow: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 21px 33px 3px rgba(0, 0, 0, 0.14), 0px 8px 40px 7px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 21px 33px 3px rgba(0, 0, 0, 0.14), 0px 8px 40px 7px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-20 {
        -webkit-box-shadow: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-19 {
        -webkit-box-shadow: 0px 9px 12px -6px rgba(0, 0, 0, 0.2), 0px 19px 29px 2px rgba(0, 0, 0, 0.14), 0px 7px 36px 6px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 9px 12px -6px rgba(0, 0, 0, 0.2), 0px 19px 29px 2px rgba(0, 0, 0, 0.14), 0px 7px 36px 6px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-18 {
        -webkit-box-shadow: 0px 9px 11px -5px rgba(0, 0, 0, 0.2), 0px 18px 28px 2px rgba(0, 0, 0, 0.14), 0px 7px 34px 6px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 9px 11px -5px rgba(0, 0, 0, 0.2), 0px 18px 28px 2px rgba(0, 0, 0, 0.14), 0px 7px 34px 6px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-17 {
        -webkit-box-shadow: 0px 8px 11px -5px rgba(0, 0, 0, 0.2), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 8px 11px -5px rgba(0, 0, 0, 0.2), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-16 {
        -webkit-box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-15 {
        -webkit-box-shadow: 0px 8px 9px -5px rgba(0, 0, 0, 0.2), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 6px 28px 5px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 8px 9px -5px rgba(0, 0, 0, 0.2), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 6px 28px 5px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-14 {
        -webkit-box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.2), 0px 14px 21px 2px rgba(0, 0, 0, 0.14), 0px 5px 26px 4px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.2), 0px 14px 21px 2px rgba(0, 0, 0, 0.14), 0px 5px 26px 4px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-13 {
        -webkit-box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 13px 19px 2px rgba(0, 0, 0, 0.14), 0px 5px 24px 4px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 13px 19px 2px rgba(0, 0, 0, 0.14), 0px 5px 24px 4px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-12 {
        -webkit-box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-11 {
        -webkit-box-shadow: 0px 6px 7px -4px rgba(0, 0, 0, 0.2), 0px 11px 15px 1px rgba(0, 0, 0, 0.14), 0px 4px 20px 3px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 6px 7px -4px rgba(0, 0, 0, 0.2), 0px 11px 15px 1px rgba(0, 0, 0, 0.14), 0px 4px 20px 3px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-10 {
        -webkit-box-shadow: 0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-9 {
        -webkit-box-shadow: 0px 5px 6px -3px rgba(0, 0, 0, 0.2), 0px 9px 12px 1px rgba(0, 0, 0, 0.14), 0px 3px 16px 2px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 5px 6px -3px rgba(0, 0, 0, 0.2), 0px 9px 12px 1px rgba(0, 0, 0, 0.14), 0px 3px 16px 2px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-8 {
        -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-7 {
        -webkit-box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-6 {
        -webkit-box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-5 {
        -webkit-box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-4 {
        -webkit-box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-3 {
        -webkit-box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-2 {
        -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-1 {
        -webkit-box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .elevation-0 {
        -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12) !important;
                box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12) !important;
      }
      
      .v-application .carousel-transition-enter {
        -webkit-transform: translate(100%, 0);
                transform: translate(100%, 0);
      }
      .v-application .carousel-transition-leave, .v-application .carousel-transition-leave-to {
        position: absolute;
        top: 0;
        -webkit-transform: translate(-100%, 0);
                transform: translate(-100%, 0);
      }
      
      .carousel-reverse-transition-enter {
        -webkit-transform: translate(-100%, 0);
                transform: translate(-100%, 0);
      }
      .carousel-reverse-transition-leave, .carousel-reverse-transition-leave-to {
        position: absolute;
        top: 0;
        -webkit-transform: translate(100%, 0);
                transform: translate(100%, 0);
      }
      
      .dialog-transition-enter, .dialog-transition-leave-to {
        -webkit-transform: scale(0.5);
                transform: scale(0.5);
        opacity: 0;
      }
      .dialog-transition-enter-to, .dialog-transition-leave {
        opacity: 1;
      }
      
      .dialog-bottom-transition-enter, .dialog-bottom-transition-leave-to {
        -webkit-transform: translateY(100%);
                transform: translateY(100%);
      }
      
      .picker-transition-enter-active, .picker-transition-leave-active,
      .picker-reverse-transition-enter-active,
      .picker-reverse-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
        transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
      }
      .picker-transition-enter, .picker-transition-leave-to,
      .picker-reverse-transition-enter,
      .picker-reverse-transition-leave-to {
        opacity: 0;
      }
      .picker-transition-leave, .picker-transition-leave-active, .picker-transition-leave-to,
      .picker-reverse-transition-leave,
      .picker-reverse-transition-leave-active,
      .picker-reverse-transition-leave-to {
        position: absolute !important;
      }
      
      .picker-transition-enter {
        -webkit-transform: translate(0, 100%);
                transform: translate(0, 100%);
      }
      .picker-transition-leave-to {
        -webkit-transform: translate(0, -100%);
                transform: translate(0, -100%);
      }
      
      .picker-reverse-transition-enter {
        -webkit-transform: translate(0, -100%);
                transform: translate(0, -100%);
      }
      .picker-reverse-transition-leave-to {
        -webkit-transform: translate(0, 100%);
                transform: translate(0, 100%);
      }
      
      .picker-title-transition-enter-to, .picker-title-transition-leave {
        -webkit-transform: translate(0, 0);
                transform: translate(0, 0);
      }
      .picker-title-transition-enter {
        -webkit-transform: translate(-100%, 0);
                transform: translate(-100%, 0);
      }
      .picker-title-transition-leave-to {
        opacity: 0;
        -webkit-transform: translate(100%, 0);
                transform: translate(100%, 0);
      }
      .picker-title-transition-leave, .picker-title-transition-leave-to, .picker-title-transition-leave-active {
        position: absolute !important;
      }
      
      .tab-transition-enter {
        -webkit-transform: translate(100%, 0);
                transform: translate(100%, 0);
      }
      .tab-transition-leave, .tab-transition-leave-active {
        position: absolute;
        top: 0;
      }
      .tab-transition-leave-to {
        position: absolute;
        -webkit-transform: translate(-100%, 0);
                transform: translate(-100%, 0);
      }
      
      .tab-reverse-transition-enter {
        -webkit-transform: translate(-100%, 0);
                transform: translate(-100%, 0);
      }
      .tab-reverse-transition-leave, .tab-reverse-transition-leave-to {
        top: 0;
        position: absolute;
        -webkit-transform: translate(100%, 0);
                transform: translate(100%, 0);
      }
      
      .expand-transition-enter-active, .expand-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .expand-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      
      .expand-x-transition-enter-active, .expand-x-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .expand-x-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      
      .scale-transition-enter-active, .scale-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .scale-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .scale-transition-enter, .scale-transition-leave, .scale-transition-leave-to {
        opacity: 0;
        -webkit-transform: scale(0);
                transform: scale(0);
      }
      
      .message-transition-enter-active, .message-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .message-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .message-transition-enter, .message-transition-leave-to {
        opacity: 0;
        -webkit-transform: translateY(-15px);
                transform: translateY(-15px);
      }
      .message-transition-leave, .message-transition-leave-active {
        position: absolute;
      }
      
      .slide-y-transition-enter-active, .slide-y-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .slide-y-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .slide-y-transition-enter, .slide-y-transition-leave-to {
        opacity: 0;
        -webkit-transform: translateY(-15px);
                transform: translateY(-15px);
      }
      
      .slide-y-reverse-transition-enter-active, .slide-y-reverse-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .slide-y-reverse-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .slide-y-reverse-transition-enter, .slide-y-reverse-transition-leave-to {
        opacity: 0;
        -webkit-transform: translateY(15px);
                transform: translateY(15px);
      }
      
      .scroll-y-transition-enter-active, .scroll-y-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .scroll-y-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .scroll-y-transition-enter, .scroll-y-transition-leave-to {
        opacity: 0;
      }
      .scroll-y-transition-enter {
        -webkit-transform: translateY(-15px);
                transform: translateY(-15px);
      }
      .scroll-y-transition-leave-to {
        -webkit-transform: translateY(15px);
                transform: translateY(15px);
      }
      
      .scroll-y-reverse-transition-enter-active, .scroll-y-reverse-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .scroll-y-reverse-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .scroll-y-reverse-transition-enter, .scroll-y-reverse-transition-leave-to {
        opacity: 0;
      }
      .scroll-y-reverse-transition-enter {
        -webkit-transform: translateY(15px);
                transform: translateY(15px);
      }
      .scroll-y-reverse-transition-leave-to {
        -webkit-transform: translateY(-15px);
                transform: translateY(-15px);
      }
      
      .scroll-x-transition-enter-active, .scroll-x-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .scroll-x-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .scroll-x-transition-enter, .scroll-x-transition-leave-to {
        opacity: 0;
      }
      .scroll-x-transition-enter {
        -webkit-transform: translateX(-15px);
                transform: translateX(-15px);
      }
      .scroll-x-transition-leave-to {
        -webkit-transform: translateX(15px);
                transform: translateX(15px);
      }
      
      .scroll-x-reverse-transition-enter-active, .scroll-x-reverse-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .scroll-x-reverse-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .scroll-x-reverse-transition-enter, .scroll-x-reverse-transition-leave-to {
        opacity: 0;
      }
      .scroll-x-reverse-transition-enter {
        -webkit-transform: translateX(15px);
                transform: translateX(15px);
      }
      .scroll-x-reverse-transition-leave-to {
        -webkit-transform: translateX(-15px);
                transform: translateX(-15px);
      }
      
      .slide-x-transition-enter-active, .slide-x-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .slide-x-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .slide-x-transition-enter, .slide-x-transition-leave-to {
        opacity: 0;
        -webkit-transform: translateX(-15px);
                transform: translateX(-15px);
      }
      
      .slide-x-reverse-transition-enter-active, .slide-x-reverse-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .slide-x-reverse-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .slide-x-reverse-transition-enter, .slide-x-reverse-transition-leave-to {
        opacity: 0;
        -webkit-transform: translateX(15px);
                transform: translateX(15px);
      }
      
      .fade-transition-enter-active, .fade-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .fade-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .fade-transition-enter, .fade-transition-leave-to {
        opacity: 0 !important;
      }
      
      .fab-transition-enter-active, .fab-transition-leave-active {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
      .fab-transition-move {
        -webkit-transition: -webkit-transform 0.6s;
        transition: -webkit-transform 0.6s;
        transition: transform 0.6s;
        transition: transform 0.6s, -webkit-transform 0.6s;
      }
      .fab-transition-enter, .fab-transition-leave-to {
        -webkit-transform: scale(0) rotate(-45deg);
                transform: scale(0) rotate(-45deg);
      }
      
      .v-application .blockquote {
        padding: 16px 0 16px 24px;
        font-size: 18px;
        font-weight: 300;
      }
      
      .v-application code, .v-application kbd {
        display: inline-block;
        border-radius: 3px;
        white-space: pre-wrap;
        font-size: 85%;
        font-weight: 900;
      }
      .v-application code:after, .v-application code:before, .v-application kbd:after, .v-application kbd:before {
        letter-spacing: -1px;
      }
      .v-application code {
        background-color: #f5f5f5;
        color: #bd4147;
        -webkit-box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
      }
      .v-application kbd {
        background: #616161;
        color: #FFFFFF;
      }
      
      html {
        font-size: 16px;
        overflow-x: hidden;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
      
      .v-application {
        font-family: "Roboto", sans-serif;
        line-height: 1.5;
      }
      .v-application ::-ms-clear,
      .v-application ::-ms-reveal {
        display: none;
      }
      
      .v-application .theme--light.heading {
        color: rgba(0, 0, 0, 0.87);
      }
      
      .v-application .theme--dark.heading {
        color: #FFFFFF;
      }
      
      .v-application ul, .v-application ol {
        padding-left: 24px;
      }
      
      .v-application .display-4 {
        font-size: 6rem !important;
        font-weight: 300;
        line-height: 6rem;
        letter-spacing: -0.015625em !important;
        font-family: "Roboto", sans-serif !important;
      }
      .v-application .display-3 {
        font-size: 3.75rem !important;
        font-weight: 300;
        line-height: 3.75rem;
        letter-spacing: -0.0083333333em !important;
        font-family: "Roboto", sans-serif !important;
      }
      .v-application .display-2 {
        font-size: 3rem !important;
        font-weight: 400;
        line-height: 3.125rem;
        letter-spacing: normal !important;
        font-family: "Roboto", sans-serif !important;
      }
      .v-application .display-1 {
        font-size: 2.125rem !important;
        font-weight: 400;
        line-height: 2.5rem;
        letter-spacing: 0.0073529412em !important;
        font-family: "Roboto", sans-serif !important;
      }
      .v-application .headline {
        font-size: 1.5rem !important;
        font-weight: 400;
        line-height: 2rem;
        letter-spacing: normal !important;
        font-family: "Roboto", sans-serif !important;
      }
      .v-application .title {
        font-size: 1.25rem !important;
        font-weight: 500;
        line-height: 2rem;
        letter-spacing: 0.0125em !important;
        font-family: "Roboto", sans-serif !important;
      }
      .v-application .subtitle-1 {
        font-size: 1rem !important;
        font-weight: 400;
        letter-spacing: 0.009375em !important;
        line-height: 1.75rem;
      }
      .v-application .subtitle-2 {
        font-size: 0.875rem !important;
        font-weight: 500;
        letter-spacing: 0.0071428571em !important;
        line-height: 1.375rem;
      }
      .v-application .body-2 {
        font-size: 0.875rem !important;
        font-weight: 400;
        letter-spacing: 0.0178571429em !important;
        line-height: 1.25rem;
      }
      .v-application .body-1 {
        font-size: 1rem !important;
        font-weight: 400;
        letter-spacing: 0.03125em !important;
        line-height: 1.5rem;
      }
      .v-application .caption {
        font-size: 0.75rem !important;
        font-weight: 400;
        letter-spacing: 0.0333333333em !important;
        line-height: 1.25rem;
      }
      .v-application .overline {
        font-size: 0.625rem !important;
        font-weight: 400;
        letter-spacing: 0.1666666667em !important;
        line-height: 1rem;
        text-transform: uppercase;
      }
      .v-application p {
        margin-bottom: 16px;
      }
      
      /** Ripples */
      /** Elements */
      .theme--light.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon {
        color: rgba(0, 0, 0, 0.26) !important;
      }
      
      .theme--dark.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon {
        color: rgba(255, 255, 255, 0.3) !important;
      }
      
      .v-input--selection-controls {
        margin-top: 16px;
        padding-top: 4px;
      }
      .v-input--selection-controls .v-input__append-outer,
      .v-input--selection-controls .v-input__prepend-outer {
        margin-top: 0;
        margin-bottom: 0;
      }
      .v-input--selection-controls .v-input__control {
        -webkit-box-flex: 0;
            -ms-flex-positive: 0;
                flex-grow: 0;
        width: auto;
      }
      .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 12px;
      }
      .v-input--selection-controls__input {
        color: inherit;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
                flex: 0 0 auto;
        height: 24px;
        position: relative;
        margin-right: 8px;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        -webkit-transition-property: color, -webkit-transform;
        transition-property: color, -webkit-transform;
        transition-property: color, transform;
        transition-property: color, transform, -webkit-transform;
        width: 24px;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-application--is-rtl .v-input--selection-controls__input {
        margin-right: 0;
        margin-left: 8px;
      }
      .v-input--selection-controls__input input {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-input--selection-controls__input + .v-label {
        cursor: pointer;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      }
      .v-input--selection-controls__ripple {
        border-radius: 50%;
        cursor: pointer;
        height: 34px;
        position: absolute;
        -webkit-transition: inherit;
        transition: inherit;
        width: 34px;
        left: -12px;
        top: calc(50% - 24px);
        margin: 7px;
      }
      .v-input--selection-controls__ripple:before {
        border-radius: inherit;
        bottom: 0;
        content: "";
        position: absolute;
        opacity: 0.2;
        left: 0;
        right: 0;
        top: 0;
        -webkit-transform-origin: center center;
                transform-origin: center center;
        -webkit-transform: scale(0.2);
                transform: scale(0.2);
        -webkit-transition: inherit;
        transition: inherit;
      }
      .v-input--selection-controls__ripple .v-ripple__container {
        -webkit-transform: scale(1.2);
                transform: scale(1.2);
      }
      .v-input--selection-controls.v-input {
        -webkit-box-flex: 0;
            -ms-flex: 0 1 auto;
                flex: 0 1 auto;
      }
      .v-input--selection-controls.v-input .v-label {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        top: 0;
        height: auto;
      }
      .v-input--selection-controls.v-input--is-focused .v-input--selection-controls__ripple:before,
      .v-input--selection-controls .v-radio--is-focused .v-input--selection-controls__ripple:before {
        background: currentColor;
        opacity: 0.4;
        -webkit-transform: scale(1.2);
                transform: scale(1.2);
      }
      .v-input--selection-controls .v-input--selection-controls__input:hover .v-input--selection-controls__ripple:before {
        background: currentColor;
        -webkit-transform: scale(1.2);
                transform: scale(1.2);
        -webkit-transition: none;
        transition: none;
      }
      
      @media only print {
        .v-application .hidden-print-only {
          display: none !important;
        }
      }
      @media only screen {
        .v-application .hidden-screen-only {
          display: none !important;
        }
      }
      @media only screen and (max-width: 599px) {
        .v-application .hidden-xs-only {
          display: none !important;
        }
      }
      @media only screen and (min-width: 600px) and (max-width: 959px) {
        .v-application .hidden-sm-only {
          display: none !important;
        }
      }
      @media only screen and (max-width: 959px) {
        .v-application .hidden-sm-and-down {
          display: none !important;
        }
      }
      @media only screen and (min-width: 600px) {
        .v-application .hidden-sm-and-up {
          display: none !important;
        }
      }
      @media only screen and (min-width: 960px) and (max-width: 1263px) {
        .v-application .hidden-md-only {
          display: none !important;
        }
      }
      @media only screen and (max-width: 1263px) {
        .v-application .hidden-md-and-down {
          display: none !important;
        }
      }
      @media only screen and (min-width: 960px) {
        .v-application .hidden-md-and-up {
          display: none !important;
        }
      }
      @media only screen and (min-width: 1264px) and (max-width: 1903px) {
        .v-application .hidden-lg-only {
          display: none !important;
        }
      }
      @media only screen and (max-width: 1903px) {
        .v-application .hidden-lg-and-down {
          display: none !important;
        }
      }
      @media only screen and (min-width: 1264px) {
        .v-application .hidden-lg-and-up {
          display: none !important;
        }
      }
      @media only screen and (min-width: 1904px) {
        .v-application .hidden-xl-only {
          display: none !important;
        }
      }
      
      .v-application .font-weight-thin {
        font-weight: 100 !important;
      }
      .v-application .font-weight-light {
        font-weight: 300 !important;
      }
      .v-application .font-weight-regular {
        font-weight: 400 !important;
      }
      .v-application .font-weight-medium {
        font-weight: 500 !important;
      }
      .v-application .font-weight-bold {
        font-weight: 700 !important;
      }
      .v-application .font-weight-black {
        font-weight: 900 !important;
      }
      .v-application .font-italic {
        font-style: italic !important;
      }
      
      .v-application .transition-fast-out-slow-in {
        -webkit-transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
        transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      }
      .v-application .transition-linear-out-slow-in {
        -webkit-transition: 0.3s cubic-bezier(0, 0, 0.2, 1) !important;
        transition: 0.3s cubic-bezier(0, 0, 0.2, 1) !important;
      }
      .v-application .transition-fast-out-linear-in {
        -webkit-transition: 0.3s cubic-bezier(0.4, 0, 1, 1) !important;
        transition: 0.3s cubic-bezier(0.4, 0, 1, 1) !important;
      }
      .v-application .transition-ease-in-out {
        -webkit-transition: 0.3s cubic-bezier(0.4, 0, 0.6, 1) !important;
        transition: 0.3s cubic-bezier(0.4, 0, 0.6, 1) !important;
      }
      .v-application .transition-fast-in-fast-out {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
      }
      .v-application .transition-swing {
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
      }
      
      .v-application .overflow-auto {
        overflow: auto !important;
      }
      
      .v-application .overflow-hidden {
        overflow: hidden !important;
      }
      
      .v-application .overflow-visible {
        overflow: visible !important;
      }
      
      .v-application .overflow-x-auto {
        overflow-x: auto !important;
      }
      
      .v-application .overflow-x-hidden {
        overflow-x: hidden !important;
      }
      
      .v-application .overflow-y-auto {
        overflow-y: auto !important;
      }
      
      .v-application .overflow-y-hidden {
        overflow-y: hidden !important;
      }
      
      .v-application .d-none {
        display: none !important;
      }
      
      .v-application .d-inline {
        display: inline !important;
      }
      
      .v-application .d-inline-block {
        display: inline-block !important;
      }
      
      .v-application .d-block {
        display: block !important;
      }
      
      .v-application .d-table {
        display: table !important;
      }
      
      .v-application .d-table-row {
        display: table-row !important;
      }
      
      .v-application .d-table-cell {
        display: table-cell !important;
      }
      
      .v-application .d-flex {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
      }
      
      .v-application .d-inline-flex {
        display: -webkit-inline-box !important;
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
      }
      
      .v-application .float-none {
        float: none !important;
      }
      
      .v-application .float-left {
        float: left !important;
      }
      
      .v-application .float-right {
        float: right !important;
      }
      
      .v-application .flex-fill {
        -webkit-box-flex: 1 !important;
            -ms-flex: 1 1 auto !important;
                flex: 1 1 auto !important;
      }
      
      .v-application .flex-row {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: normal !important;
            -ms-flex-direction: row !important;
                flex-direction: row !important;
      }
      
      .v-application .flex-column {
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: normal !important;
            -ms-flex-direction: column !important;
                flex-direction: column !important;
      }
      
      .v-application .flex-row-reverse {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: reverse !important;
            -ms-flex-direction: row-reverse !important;
                flex-direction: row-reverse !important;
      }
      
      .v-application .flex-column-reverse {
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: reverse !important;
            -ms-flex-direction: column-reverse !important;
                flex-direction: column-reverse !important;
      }
      
      .v-application .flex-grow-0 {
        -webkit-box-flex: 0 !important;
            -ms-flex-positive: 0 !important;
                flex-grow: 0 !important;
      }
      
      .v-application .flex-grow-1 {
        -webkit-box-flex: 1 !important;
            -ms-flex-positive: 1 !important;
                flex-grow: 1 !important;
      }
      
      .v-application .flex-shrink-0 {
        -ms-flex-negative: 0 !important;
            flex-shrink: 0 !important;
      }
      
      .v-application .flex-shrink-1 {
        -ms-flex-negative: 1 !important;
            flex-shrink: 1 !important;
      }
      
      .v-application .flex-wrap {
        -ms-flex-wrap: wrap !important;
            flex-wrap: wrap !important;
      }
      
      .v-application .flex-nowrap {
        -ms-flex-wrap: nowrap !important;
            flex-wrap: nowrap !important;
      }
      
      .v-application .flex-wrap-reverse {
        -ms-flex-wrap: wrap-reverse !important;
            flex-wrap: wrap-reverse !important;
      }
      
      .v-application .justify-start {
        -webkit-box-pack: start !important;
            -ms-flex-pack: start !important;
                justify-content: flex-start !important;
      }
      
      .v-application .justify-end {
        -webkit-box-pack: end !important;
            -ms-flex-pack: end !important;
                justify-content: flex-end !important;
      }
      
      .v-application .justify-center {
        -webkit-box-pack: center !important;
            -ms-flex-pack: center !important;
                justify-content: center !important;
      }
      
      .v-application .justify-space-between {
        -webkit-box-pack: justify !important;
            -ms-flex-pack: justify !important;
                justify-content: space-between !important;
      }
      
      .v-application .justify-space-around {
        -ms-flex-pack: distribute !important;
            justify-content: space-around !important;
      }
      
      .v-application .align-start {
        -webkit-box-align: start !important;
            -ms-flex-align: start !important;
                align-items: flex-start !important;
      }
      
      .v-application .align-end {
        -webkit-box-align: end !important;
            -ms-flex-align: end !important;
                align-items: flex-end !important;
      }
      
      .v-application .align-center {
        -webkit-box-align: center !important;
            -ms-flex-align: center !important;
                align-items: center !important;
      }
      
      .v-application .align-baseline {
        -webkit-box-align: baseline !important;
            -ms-flex-align: baseline !important;
                align-items: baseline !important;
      }
      
      .v-application .align-stretch {
        -webkit-box-align: stretch !important;
            -ms-flex-align: stretch !important;
                align-items: stretch !important;
      }
      
      .v-application .align-content-start {
        -ms-flex-line-pack: start !important;
            align-content: flex-start !important;
      }
      
      .v-application .align-content-end {
        -ms-flex-line-pack: end !important;
            align-content: flex-end !important;
      }
      
      .v-application .align-content-center {
        -ms-flex-line-pack: center !important;
            align-content: center !important;
      }
      
      .v-application .align-content-space-between {
        -ms-flex-line-pack: justify !important;
            align-content: space-between !important;
      }
      
      .v-application .align-content-space-around {
        -ms-flex-line-pack: distribute !important;
            align-content: space-around !important;
      }
      
      .v-application .align-content-stretch {
        -ms-flex-line-pack: stretch !important;
            align-content: stretch !important;
      }
      
      .v-application .align-self-auto {
        -ms-flex-item-align: auto !important;
            align-self: auto !important;
      }
      
      .v-application .align-self-start {
        -ms-flex-item-align: start !important;
            align-self: flex-start !important;
      }
      
      .v-application .align-self-end {
        -ms-flex-item-align: end !important;
            align-self: flex-end !important;
      }
      
      .v-application .align-self-center {
        -ms-flex-item-align: center !important;
            align-self: center !important;
      }
      
      .v-application .align-self-baseline {
        -ms-flex-item-align: baseline !important;
            align-self: baseline !important;
      }
      
      .v-application .align-self-stretch {
        -ms-flex-item-align: stretch !important;
            align-self: stretch !important;
      }
      
      .v-application .order-first {
        -webkit-box-ordinal-group: 0 !important;
            -ms-flex-order: -1 !important;
                order: -1 !important;
      }
      
      .v-application .order-0 {
        -webkit-box-ordinal-group: 1 !important;
            -ms-flex-order: 0 !important;
                order: 0 !important;
      }
      
      .v-application .order-1 {
        -webkit-box-ordinal-group: 2 !important;
            -ms-flex-order: 1 !important;
                order: 1 !important;
      }
      
      .v-application .order-2 {
        -webkit-box-ordinal-group: 3 !important;
            -ms-flex-order: 2 !important;
                order: 2 !important;
      }
      
      .v-application .order-3 {
        -webkit-box-ordinal-group: 4 !important;
            -ms-flex-order: 3 !important;
                order: 3 !important;
      }
      
      .v-application .order-4 {
        -webkit-box-ordinal-group: 5 !important;
            -ms-flex-order: 4 !important;
                order: 4 !important;
      }
      
      .v-application .order-5 {
        -webkit-box-ordinal-group: 6 !important;
            -ms-flex-order: 5 !important;
                order: 5 !important;
      }
      
      .v-application .order-6 {
        -webkit-box-ordinal-group: 7 !important;
            -ms-flex-order: 6 !important;
                order: 6 !important;
      }
      
      .v-application .order-7 {
        -webkit-box-ordinal-group: 8 !important;
            -ms-flex-order: 7 !important;
                order: 7 !important;
      }
      
      .v-application .order-8 {
        -webkit-box-ordinal-group: 9 !important;
            -ms-flex-order: 8 !important;
                order: 8 !important;
      }
      
      .v-application .order-9 {
        -webkit-box-ordinal-group: 10 !important;
            -ms-flex-order: 9 !important;
                order: 9 !important;
      }
      
      .v-application .order-10 {
        -webkit-box-ordinal-group: 11 !important;
            -ms-flex-order: 10 !important;
                order: 10 !important;
      }
      
      .v-application .order-11 {
        -webkit-box-ordinal-group: 12 !important;
            -ms-flex-order: 11 !important;
                order: 11 !important;
      }
      
      .v-application .order-12 {
        -webkit-box-ordinal-group: 13 !important;
            -ms-flex-order: 12 !important;
                order: 12 !important;
      }
      
      .v-application .order-last {
        -webkit-box-ordinal-group: 14 !important;
            -ms-flex-order: 13 !important;
                order: 13 !important;
      }
      
      .v-application .ma-0 {
        margin: 0px !important;
      }
      
      .v-application .ma-1 {
        margin: 4px !important;
      }
      
      .v-application .ma-2 {
        margin: 8px !important;
      }
      
      .v-application .ma-3 {
        margin: 12px !important;
      }
      
      .v-application .ma-4 {
        margin: 16px !important;
      }
      
      .v-application .ma-5 {
        margin: 20px !important;
      }
      
      .v-application .ma-6 {
        margin: 24px !important;
      }
      
      .v-application .ma-7 {
        margin: 28px !important;
      }
      
      .v-application .ma-8 {
        margin: 32px !important;
      }
      
      .v-application .ma-9 {
        margin: 36px !important;
      }
      
      .v-application .ma-10 {
        margin: 40px !important;
      }
      
      .v-application .ma-11 {
        margin: 44px !important;
      }
      
      .v-application .ma-12 {
        margin: 48px !important;
      }
      
      .v-application .ma-auto {
        margin: auto !important;
      }
      
      .v-application .mx-0 {
        margin-right: 0px !important;
        margin-left: 0px !important;
      }
      
      .v-application .mx-1 {
        margin-right: 4px !important;
        margin-left: 4px !important;
      }
      
      .v-application .mx-2 {
        margin-right: 8px !important;
        margin-left: 8px !important;
      }
      
      .v-application .mx-3 {
        margin-right: 12px !important;
        margin-left: 12px !important;
      }
      
      .v-application .mx-4 {
        margin-right: 16px !important;
        margin-left: 16px !important;
      }
      
      .v-application .mx-5 {
        margin-right: 20px !important;
        margin-left: 20px !important;
      }
      
      .v-application .mx-6 {
        margin-right: 24px !important;
        margin-left: 24px !important;
      }
      
      .v-application .mx-7 {
        margin-right: 28px !important;
        margin-left: 28px !important;
      }
      
      .v-application .mx-8 {
        margin-right: 32px !important;
        margin-left: 32px !important;
      }
      
      .v-application .mx-9 {
        margin-right: 36px !important;
        margin-left: 36px !important;
      }
      
      .v-application .mx-10 {
        margin-right: 40px !important;
        margin-left: 40px !important;
      }
      
      .v-application .mx-11 {
        margin-right: 44px !important;
        margin-left: 44px !important;
      }
      
      .v-application .mx-12 {
        margin-right: 48px !important;
        margin-left: 48px !important;
      }
      
      .v-application .mx-auto {
        margin-right: auto !important;
        margin-left: auto !important;
      }
      
      .v-application .my-0 {
        margin-top: 0px !important;
        margin-bottom: 0px !important;
      }
      
      .v-application .my-1 {
        margin-top: 4px !important;
        margin-bottom: 4px !important;
      }
      
      .v-application .my-2 {
        margin-top: 8px !important;
        margin-bottom: 8px !important;
      }
      
      .v-application .my-3 {
        margin-top: 12px !important;
        margin-bottom: 12px !important;
      }
      
      .v-application .my-4 {
        margin-top: 16px !important;
        margin-bottom: 16px !important;
      }
      
      .v-application .my-5 {
        margin-top: 20px !important;
        margin-bottom: 20px !important;
      }
      
      .v-application .my-6 {
        margin-top: 24px !important;
        margin-bottom: 24px !important;
      }
      
      .v-application .my-7 {
        margin-top: 28px !important;
        margin-bottom: 28px !important;
      }
      
      .v-application .my-8 {
        margin-top: 32px !important;
        margin-bottom: 32px !important;
      }
      
      .v-application .my-9 {
        margin-top: 36px !important;
        margin-bottom: 36px !important;
      }
      
      .v-application .my-10 {
        margin-top: 40px !important;
        margin-bottom: 40px !important;
      }
      
      .v-application .my-11 {
        margin-top: 44px !important;
        margin-bottom: 44px !important;
      }
      
      .v-application .my-12 {
        margin-top: 48px !important;
        margin-bottom: 48px !important;
      }
      
      .v-application .my-auto {
        margin-top: auto !important;
        margin-bottom: auto !important;
      }
      
      .v-application .mt-0 {
        margin-top: 0px !important;
      }
      
      .v-application .mt-1 {
        margin-top: 4px !important;
      }
      
      .v-application .mt-2 {
        margin-top: 8px !important;
      }
      
      .v-application .mt-3 {
        margin-top: 12px !important;
      }
      
      .v-application .mt-4 {
        margin-top: 16px !important;
      }
      
      .v-application .mt-5 {
        margin-top: 20px !important;
      }
      
      .v-application .mt-6 {
        margin-top: 24px !important;
      }
      
      .v-application .mt-7 {
        margin-top: 28px !important;
      }
      
      .v-application .mt-8 {
        margin-top: 32px !important;
      }
      
      .v-application .mt-9 {
        margin-top: 36px !important;
      }
      
      .v-application .mt-10 {
        margin-top: 40px !important;
      }
      
      .v-application .mt-11 {
        margin-top: 44px !important;
      }
      
      .v-application .mt-12 {
        margin-top: 48px !important;
      }
      
      .v-application .mt-auto {
        margin-top: auto !important;
      }
      
      .v-application .mr-0 {
        margin-right: 0px !important;
      }
      
      .v-application .mr-1 {
        margin-right: 4px !important;
      }
      
      .v-application .mr-2 {
        margin-right: 8px !important;
      }
      
      .v-application .mr-3 {
        margin-right: 12px !important;
      }
      
      .v-application .mr-4 {
        margin-right: 16px !important;
      }
      
      .v-application .mr-5 {
        margin-right: 20px !important;
      }
      
      .v-application .mr-6 {
        margin-right: 24px !important;
      }
      
      .v-application .mr-7 {
        margin-right: 28px !important;
      }
      
      .v-application .mr-8 {
        margin-right: 32px !important;
      }
      
      .v-application .mr-9 {
        margin-right: 36px !important;
      }
      
      .v-application .mr-10 {
        margin-right: 40px !important;
      }
      
      .v-application .mr-11 {
        margin-right: 44px !important;
      }
      
      .v-application .mr-12 {
        margin-right: 48px !important;
      }
      
      .v-application .mr-auto {
        margin-right: auto !important;
      }
      
      .v-application .mb-0 {
        margin-bottom: 0px !important;
      }
      
      .v-application .mb-1 {
        margin-bottom: 4px !important;
      }
      
      .v-application .mb-2 {
        margin-bottom: 8px !important;
      }
      
      .v-application .mb-3 {
        margin-bottom: 12px !important;
      }
      
      .v-application .mb-4 {
        margin-bottom: 16px !important;
      }
      
      .v-application .mb-5 {
        margin-bottom: 20px !important;
      }
      
      .v-application .mb-6 {
        margin-bottom: 24px !important;
      }
      
      .v-application .mb-7 {
        margin-bottom: 28px !important;
      }
      
      .v-application .mb-8 {
        margin-bottom: 32px !important;
      }
      
      .v-application .mb-9 {
        margin-bottom: 36px !important;
      }
      
      .v-application .mb-10 {
        margin-bottom: 40px !important;
      }
      
      .v-application .mb-11 {
        margin-bottom: 44px !important;
      }
      
      .v-application .mb-12 {
        margin-bottom: 48px !important;
      }
      
      .v-application .mb-auto {
        margin-bottom: auto !important;
      }
      
      .v-application .ml-0 {
        margin-left: 0px !important;
      }
      
      .v-application .ml-1 {
        margin-left: 4px !important;
      }
      
      .v-application .ml-2 {
        margin-left: 8px !important;
      }
      
      .v-application .ml-3 {
        margin-left: 12px !important;
      }
      
      .v-application .ml-4 {
        margin-left: 16px !important;
      }
      
      .v-application .ml-5 {
        margin-left: 20px !important;
      }
      
      .v-application .ml-6 {
        margin-left: 24px !important;
      }
      
      .v-application .ml-7 {
        margin-left: 28px !important;
      }
      
      .v-application .ml-8 {
        margin-left: 32px !important;
      }
      
      .v-application .ml-9 {
        margin-left: 36px !important;
      }
      
      .v-application .ml-10 {
        margin-left: 40px !important;
      }
      
      .v-application .ml-11 {
        margin-left: 44px !important;
      }
      
      .v-application .ml-12 {
        margin-left: 48px !important;
      }
      
      .v-application .ml-auto {
        margin-left: auto !important;
      }
      
      .v-application--is-ltr .ms-0 {
        margin-left: 0px !important;
      }
      
      .v-application--is-rtl .ms-0 {
        margin-right: 0px !important;
      }
      
      .v-application--is-ltr .ms-1 {
        margin-left: 4px !important;
      }
      
      .v-application--is-rtl .ms-1 {
        margin-right: 4px !important;
      }
      
      .v-application--is-ltr .ms-2 {
        margin-left: 8px !important;
      }
      
      .v-application--is-rtl .ms-2 {
        margin-right: 8px !important;
      }
      
      .v-application--is-ltr .ms-3 {
        margin-left: 12px !important;
      }
      
      .v-application--is-rtl .ms-3 {
        margin-right: 12px !important;
      }
      
      .v-application--is-ltr .ms-4 {
        margin-left: 16px !important;
      }
      
      .v-application--is-rtl .ms-4 {
        margin-right: 16px !important;
      }
      
      .v-application--is-ltr .ms-5 {
        margin-left: 20px !important;
      }
      
      .v-application--is-rtl .ms-5 {
        margin-right: 20px !important;
      }
      
      .v-application--is-ltr .ms-6 {
        margin-left: 24px !important;
      }
      
      .v-application--is-rtl .ms-6 {
        margin-right: 24px !important;
      }
      
      .v-application--is-ltr .ms-7 {
        margin-left: 28px !important;
      }
      
      .v-application--is-rtl .ms-7 {
        margin-right: 28px !important;
      }
      
      .v-application--is-ltr .ms-8 {
        margin-left: 32px !important;
      }
      
      .v-application--is-rtl .ms-8 {
        margin-right: 32px !important;
      }
      
      .v-application--is-ltr .ms-9 {
        margin-left: 36px !important;
      }
      
      .v-application--is-rtl .ms-9 {
        margin-right: 36px !important;
      }
      
      .v-application--is-ltr .ms-10 {
        margin-left: 40px !important;
      }
      
      .v-application--is-rtl .ms-10 {
        margin-right: 40px !important;
      }
      
      .v-application--is-ltr .ms-11 {
        margin-left: 44px !important;
      }
      
      .v-application--is-rtl .ms-11 {
        margin-right: 44px !important;
      }
      
      .v-application--is-ltr .ms-12 {
        margin-left: 48px !important;
      }
      
      .v-application--is-rtl .ms-12 {
        margin-right: 48px !important;
      }
      
      .v-application--is-ltr .ms-auto {
        margin-left: auto !important;
      }
      
      .v-application--is-rtl .ms-auto {
        margin-right: auto !important;
      }
      
      .v-application--is-ltr .me-0 {
        margin-right: 0px !important;
      }
      
      .v-application--is-rtl .me-0 {
        margin-left: 0px !important;
      }
      
      .v-application--is-ltr .me-1 {
        margin-right: 4px !important;
      }
      
      .v-application--is-rtl .me-1 {
        margin-left: 4px !important;
      }
      
      .v-application--is-ltr .me-2 {
        margin-right: 8px !important;
      }
      
      .v-application--is-rtl .me-2 {
        margin-left: 8px !important;
      }
      
      .v-application--is-ltr .me-3 {
        margin-right: 12px !important;
      }
      
      .v-application--is-rtl .me-3 {
        margin-left: 12px !important;
      }
      
      .v-application--is-ltr .me-4 {
        margin-right: 16px !important;
      }
      
      .v-application--is-rtl .me-4 {
        margin-left: 16px !important;
      }
      
      .v-application--is-ltr .me-5 {
        margin-right: 20px !important;
      }
      
      .v-application--is-rtl .me-5 {
        margin-left: 20px !important;
      }
      
      .v-application--is-ltr .me-6 {
        margin-right: 24px !important;
      }
      
      .v-application--is-rtl .me-6 {
        margin-left: 24px !important;
      }
      
      .v-application--is-ltr .me-7 {
        margin-right: 28px !important;
      }
      
      .v-application--is-rtl .me-7 {
        margin-left: 28px !important;
      }
      
      .v-application--is-ltr .me-8 {
        margin-right: 32px !important;
      }
      
      .v-application--is-rtl .me-8 {
        margin-left: 32px !important;
      }
      
      .v-application--is-ltr .me-9 {
        margin-right: 36px !important;
      }
      
      .v-application--is-rtl .me-9 {
        margin-left: 36px !important;
      }
      
      .v-application--is-ltr .me-10 {
        margin-right: 40px !important;
      }
      
      .v-application--is-rtl .me-10 {
        margin-left: 40px !important;
      }
      
      .v-application--is-ltr .me-11 {
        margin-right: 44px !important;
      }
      
      .v-application--is-rtl .me-11 {
        margin-left: 44px !important;
      }
      
      .v-application--is-ltr .me-12 {
        margin-right: 48px !important;
      }
      
      .v-application--is-rtl .me-12 {
        margin-left: 48px !important;
      }
      
      .v-application--is-ltr .me-auto {
        margin-right: auto !important;
      }
      
      .v-application--is-rtl .me-auto {
        margin-left: auto !important;
      }
      
      .v-application .ma-n1 {
        margin: -4px !important;
      }
      
      .v-application .ma-n2 {
        margin: -8px !important;
      }
      
      .v-application .ma-n3 {
        margin: -12px !important;
      }
      
      .v-application .ma-n4 {
        margin: -16px !important;
      }
      
      .v-application .ma-n5 {
        margin: -20px !important;
      }
      
      .v-application .ma-n6 {
        margin: -24px !important;
      }
      
      .v-application .ma-n7 {
        margin: -28px !important;
      }
      
      .v-application .ma-n8 {
        margin: -32px !important;
      }
      
      .v-application .ma-n9 {
        margin: -36px !important;
      }
      
      .v-application .ma-n10 {
        margin: -40px !important;
      }
      
      .v-application .ma-n11 {
        margin: -44px !important;
      }
      
      .v-application .ma-n12 {
        margin: -48px !important;
      }
      
      .v-application .mx-n1 {
        margin-right: -4px !important;
        margin-left: -4px !important;
      }
      
      .v-application .mx-n2 {
        margin-right: -8px !important;
        margin-left: -8px !important;
      }
      
      .v-application .mx-n3 {
        margin-right: -12px !important;
        margin-left: -12px !important;
      }
      
      .v-application .mx-n4 {
        margin-right: -16px !important;
        margin-left: -16px !important;
      }
      
      .v-application .mx-n5 {
        margin-right: -20px !important;
        margin-left: -20px !important;
      }
      
      .v-application .mx-n6 {
        margin-right: -24px !important;
        margin-left: -24px !important;
      }
      
      .v-application .mx-n7 {
        margin-right: -28px !important;
        margin-left: -28px !important;
      }
      
      .v-application .mx-n8 {
        margin-right: -32px !important;
        margin-left: -32px !important;
      }
      
      .v-application .mx-n9 {
        margin-right: -36px !important;
        margin-left: -36px !important;
      }
      
      .v-application .mx-n10 {
        margin-right: -40px !important;
        margin-left: -40px !important;
      }
      
      .v-application .mx-n11 {
        margin-right: -44px !important;
        margin-left: -44px !important;
      }
      
      .v-application .mx-n12 {
        margin-right: -48px !important;
        margin-left: -48px !important;
      }
      
      .v-application .my-n1 {
        margin-top: -4px !important;
        margin-bottom: -4px !important;
      }
      
      .v-application .my-n2 {
        margin-top: -8px !important;
        margin-bottom: -8px !important;
      }
      
      .v-application .my-n3 {
        margin-top: -12px !important;
        margin-bottom: -12px !important;
      }
      
      .v-application .my-n4 {
        margin-top: -16px !important;
        margin-bottom: -16px !important;
      }
      
      .v-application .my-n5 {
        margin-top: -20px !important;
        margin-bottom: -20px !important;
      }
      
      .v-application .my-n6 {
        margin-top: -24px !important;
        margin-bottom: -24px !important;
      }
      
      .v-application .my-n7 {
        margin-top: -28px !important;
        margin-bottom: -28px !important;
      }
      
      .v-application .my-n8 {
        margin-top: -32px !important;
        margin-bottom: -32px !important;
      }
      
      .v-application .my-n9 {
        margin-top: -36px !important;
        margin-bottom: -36px !important;
      }
      
      .v-application .my-n10 {
        margin-top: -40px !important;
        margin-bottom: -40px !important;
      }
      
      .v-application .my-n11 {
        margin-top: -44px !important;
        margin-bottom: -44px !important;
      }
      
      .v-application .my-n12 {
        margin-top: -48px !important;
        margin-bottom: -48px !important;
      }
      
      .v-application .mt-n1 {
        margin-top: -4px !important;
      }
      
      .v-application .mt-n2 {
        margin-top: -8px !important;
      }
      
      .v-application .mt-n3 {
        margin-top: -12px !important;
      }
      
      .v-application .mt-n4 {
        margin-top: -16px !important;
      }
      
      .v-application .mt-n5 {
        margin-top: -20px !important;
      }
      
      .v-application .mt-n6 {
        margin-top: -24px !important;
      }
      
      .v-application .mt-n7 {
        margin-top: -28px !important;
      }
      
      .v-application .mt-n8 {
        margin-top: -32px !important;
      }
      
      .v-application .mt-n9 {
        margin-top: -36px !important;
      }
      
      .v-application .mt-n10 {
        margin-top: -40px !important;
      }
      
      .v-application .mt-n11 {
        margin-top: -44px !important;
      }
      
      .v-application .mt-n12 {
        margin-top: -48px !important;
      }
      
      .v-application .mr-n1 {
        margin-right: -4px !important;
      }
      
      .v-application .mr-n2 {
        margin-right: -8px !important;
      }
      
      .v-application .mr-n3 {
        margin-right: -12px !important;
      }
      
      .v-application .mr-n4 {
        margin-right: -16px !important;
      }
      
      .v-application .mr-n5 {
        margin-right: -20px !important;
      }
      
      .v-application .mr-n6 {
        margin-right: -24px !important;
      }
      
      .v-application .mr-n7 {
        margin-right: -28px !important;
      }
      
      .v-application .mr-n8 {
        margin-right: -32px !important;
      }
      
      .v-application .mr-n9 {
        margin-right: -36px !important;
      }
      
      .v-application .mr-n10 {
        margin-right: -40px !important;
      }
      
      .v-application .mr-n11 {
        margin-right: -44px !important;
      }
      
      .v-application .mr-n12 {
        margin-right: -48px !important;
      }
      
      .v-application .mb-n1 {
        margin-bottom: -4px !important;
      }
      
      .v-application .mb-n2 {
        margin-bottom: -8px !important;
      }
      
      .v-application .mb-n3 {
        margin-bottom: -12px !important;
      }
      
      .v-application .mb-n4 {
        margin-bottom: -16px !important;
      }
      
      .v-application .mb-n5 {
        margin-bottom: -20px !important;
      }
      
      .v-application .mb-n6 {
        margin-bottom: -24px !important;
      }
      
      .v-application .mb-n7 {
        margin-bottom: -28px !important;
      }
      
      .v-application .mb-n8 {
        margin-bottom: -32px !important;
      }
      
      .v-application .mb-n9 {
        margin-bottom: -36px !important;
      }
      
      .v-application .mb-n10 {
        margin-bottom: -40px !important;
      }
      
      .v-application .mb-n11 {
        margin-bottom: -44px !important;
      }
      
      .v-application .mb-n12 {
        margin-bottom: -48px !important;
      }
      
      .v-application .ml-n1 {
        margin-left: -4px !important;
      }
      
      .v-application .ml-n2 {
        margin-left: -8px !important;
      }
      
      .v-application .ml-n3 {
        margin-left: -12px !important;
      }
      
      .v-application .ml-n4 {
        margin-left: -16px !important;
      }
      
      .v-application .ml-n5 {
        margin-left: -20px !important;
      }
      
      .v-application .ml-n6 {
        margin-left: -24px !important;
      }
      
      .v-application .ml-n7 {
        margin-left: -28px !important;
      }
      
      .v-application .ml-n8 {
        margin-left: -32px !important;
      }
      
      .v-application .ml-n9 {
        margin-left: -36px !important;
      }
      
      .v-application .ml-n10 {
        margin-left: -40px !important;
      }
      
      .v-application .ml-n11 {
        margin-left: -44px !important;
      }
      
      .v-application .ml-n12 {
        margin-left: -48px !important;
      }
      
      .v-application--is-ltr .ms-n1 {
        margin-left: -4px !important;
      }
      
      .v-application--is-rtl .ms-n1 {
        margin-right: -4px !important;
      }
      
      .v-application--is-ltr .ms-n2 {
        margin-left: -8px !important;
      }
      
      .v-application--is-rtl .ms-n2 {
        margin-right: -8px !important;
      }
      
      .v-application--is-ltr .ms-n3 {
        margin-left: -12px !important;
      }
      
      .v-application--is-rtl .ms-n3 {
        margin-right: -12px !important;
      }
      
      .v-application--is-ltr .ms-n4 {
        margin-left: -16px !important;
      }
      
      .v-application--is-rtl .ms-n4 {
        margin-right: -16px !important;
      }
      
      .v-application--is-ltr .ms-n5 {
        margin-left: -20px !important;
      }
      
      .v-application--is-rtl .ms-n5 {
        margin-right: -20px !important;
      }
      
      .v-application--is-ltr .ms-n6 {
        margin-left: -24px !important;
      }
      
      .v-application--is-rtl .ms-n6 {
        margin-right: -24px !important;
      }
      
      .v-application--is-ltr .ms-n7 {
        margin-left: -28px !important;
      }
      
      .v-application--is-rtl .ms-n7 {
        margin-right: -28px !important;
      }
      
      .v-application--is-ltr .ms-n8 {
        margin-left: -32px !important;
      }
      
      .v-application--is-rtl .ms-n8 {
        margin-right: -32px !important;
      }
      
      .v-application--is-ltr .ms-n9 {
        margin-left: -36px !important;
      }
      
      .v-application--is-rtl .ms-n9 {
        margin-right: -36px !important;
      }
      
      .v-application--is-ltr .ms-n10 {
        margin-left: -40px !important;
      }
      
      .v-application--is-rtl .ms-n10 {
        margin-right: -40px !important;
      }
      
      .v-application--is-ltr .ms-n11 {
        margin-left: -44px !important;
      }
      
      .v-application--is-rtl .ms-n11 {
        margin-right: -44px !important;
      }
      
      .v-application--is-ltr .ms-n12 {
        margin-left: -48px !important;
      }
      
      .v-application--is-rtl .ms-n12 {
        margin-right: -48px !important;
      }
      
      .v-application--is-ltr .me-n1 {
        margin-right: -4px !important;
      }
      
      .v-application--is-rtl .me-n1 {
        margin-left: -4px !important;
      }
      
      .v-application--is-ltr .me-n2 {
        margin-right: -8px !important;
      }
      
      .v-application--is-rtl .me-n2 {
        margin-left: -8px !important;
      }
      
      .v-application--is-ltr .me-n3 {
        margin-right: -12px !important;
      }
      
      .v-application--is-rtl .me-n3 {
        margin-left: -12px !important;
      }
      
      .v-application--is-ltr .me-n4 {
        margin-right: -16px !important;
      }
      
      .v-application--is-rtl .me-n4 {
        margin-left: -16px !important;
      }
      
      .v-application--is-ltr .me-n5 {
        margin-right: -20px !important;
      }
      
      .v-application--is-rtl .me-n5 {
        margin-left: -20px !important;
      }
      
      .v-application--is-ltr .me-n6 {
        margin-right: -24px !important;
      }
      
      .v-application--is-rtl .me-n6 {
        margin-left: -24px !important;
      }
      
      .v-application--is-ltr .me-n7 {
        margin-right: -28px !important;
      }
      
      .v-application--is-rtl .me-n7 {
        margin-left: -28px !important;
      }
      
      .v-application--is-ltr .me-n8 {
        margin-right: -32px !important;
      }
      
      .v-application--is-rtl .me-n8 {
        margin-left: -32px !important;
      }
      
      .v-application--is-ltr .me-n9 {
        margin-right: -36px !important;
      }
      
      .v-application--is-rtl .me-n9 {
        margin-left: -36px !important;
      }
      
      .v-application--is-ltr .me-n10 {
        margin-right: -40px !important;
      }
      
      .v-application--is-rtl .me-n10 {
        margin-left: -40px !important;
      }
      
      .v-application--is-ltr .me-n11 {
        margin-right: -44px !important;
      }
      
      .v-application--is-rtl .me-n11 {
        margin-left: -44px !important;
      }
      
      .v-application--is-ltr .me-n12 {
        margin-right: -48px !important;
      }
      
      .v-application--is-rtl .me-n12 {
        margin-left: -48px !important;
      }
      
      .v-application .pa-0 {
        padding: 0px !important;
      }
      
      .v-application .pa-1 {
        padding: 4px !important;
      }
      
      .v-application .pa-2 {
        padding: 8px !important;
      }
      
      .v-application .pa-3 {
        padding: 12px !important;
      }
      
      .v-application .pa-4 {
        padding: 16px !important;
      }
      
      .v-application .pa-5 {
        padding: 20px !important;
      }
      
      .v-application .pa-6 {
        padding: 24px !important;
      }
      
      .v-application .pa-7 {
        padding: 28px !important;
      }
      
      .v-application .pa-8 {
        padding: 32px !important;
      }
      
      .v-application .pa-9 {
        padding: 36px !important;
      }
      
      .v-application .pa-10 {
        padding: 40px !important;
      }
      
      .v-application .pa-11 {
        padding: 44px !important;
      }
      
      .v-application .pa-12 {
        padding: 48px !important;
      }
      
      .v-application .px-0 {
        padding-right: 0px !important;
        padding-left: 0px !important;
      }
      
      .v-application .px-1 {
        padding-right: 4px !important;
        padding-left: 4px !important;
      }
      
      .v-application .px-2 {
        padding-right: 8px !important;
        padding-left: 8px !important;
      }
      
      .v-application .px-3 {
        padding-right: 12px !important;
        padding-left: 12px !important;
      }
      
      .v-application .px-4 {
        padding-right: 16px !important;
        padding-left: 16px !important;
      }
      
      .v-application .px-5 {
        padding-right: 20px !important;
        padding-left: 20px !important;
      }
      
      .v-application .px-6 {
        padding-right: 24px !important;
        padding-left: 24px !important;
      }
      
      .v-application .px-7 {
        padding-right: 28px !important;
        padding-left: 28px !important;
      }
      
      .v-application .px-8 {
        padding-right: 32px !important;
        padding-left: 32px !important;
      }
      
      .v-application .px-9 {
        padding-right: 36px !important;
        padding-left: 36px !important;
      }
      
      .v-application .px-10 {
        padding-right: 40px !important;
        padding-left: 40px !important;
      }
      
      .v-application .px-11 {
        padding-right: 44px !important;
        padding-left: 44px !important;
      }
      
      .v-application .px-12 {
        padding-right: 48px !important;
        padding-left: 48px !important;
      }
      
      .v-application .py-0 {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
      }
      
      .v-application .py-1 {
        padding-top: 4px !important;
        padding-bottom: 4px !important;
      }
      
      .v-application .py-2 {
        padding-top: 8px !important;
        padding-bottom: 8px !important;
      }
      
      .v-application .py-3 {
        padding-top: 12px !important;
        padding-bottom: 12px !important;
      }
      
      .v-application .py-4 {
        padding-top: 16px !important;
        padding-bottom: 16px !important;
      }
      
      .v-application .py-5 {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
      }
      
      .v-application .py-6 {
        padding-top: 24px !important;
        padding-bottom: 24px !important;
      }
      
      .v-application .py-7 {
        padding-top: 28px !important;
        padding-bottom: 28px !important;
      }
      
      .v-application .py-8 {
        padding-top: 32px !important;
        padding-bottom: 32px !important;
      }
      
      .v-application .py-9 {
        padding-top: 36px !important;
        padding-bottom: 36px !important;
      }
      
      .v-application .py-10 {
        padding-top: 40px !important;
        padding-bottom: 40px !important;
      }
      
      .v-application .py-11 {
        padding-top: 44px !important;
        padding-bottom: 44px !important;
      }
      
      .v-application .py-12 {
        padding-top: 48px !important;
        padding-bottom: 48px !important;
      }
      
      .v-application .pt-0 {
        padding-top: 0px !important;
      }
      
      .v-application .pt-1 {
        padding-top: 4px !important;
      }
      
      .v-application .pt-2 {
        padding-top: 8px !important;
      }
      
      .v-application .pt-3 {
        padding-top: 12px !important;
      }
      
      .v-application .pt-4 {
        padding-top: 16px !important;
      }
      
      .v-application .pt-5 {
        padding-top: 20px !important;
      }
      
      .v-application .pt-6 {
        padding-top: 24px !important;
      }
      
      .v-application .pt-7 {
        padding-top: 28px !important;
      }
      
      .v-application .pt-8 {
        padding-top: 32px !important;
      }
      
      .v-application .pt-9 {
        padding-top: 36px !important;
      }
      
      .v-application .pt-10 {
        padding-top: 40px !important;
      }
      
      .v-application .pt-11 {
        padding-top: 44px !important;
      }
      
      .v-application .pt-12 {
        padding-top: 48px !important;
      }
      
      .v-application .pr-0 {
        padding-right: 0px !important;
      }
      
      .v-application .pr-1 {
        padding-right: 4px !important;
      }
      
      .v-application .pr-2 {
        padding-right: 8px !important;
      }
      
      .v-application .pr-3 {
        padding-right: 12px !important;
      }
      
      .v-application .pr-4 {
        padding-right: 16px !important;
      }
      
      .v-application .pr-5 {
        padding-right: 20px !important;
      }
      
      .v-application .pr-6 {
        padding-right: 24px !important;
      }
      
      .v-application .pr-7 {
        padding-right: 28px !important;
      }
      
      .v-application .pr-8 {
        padding-right: 32px !important;
      }
      
      .v-application .pr-9 {
        padding-right: 36px !important;
      }
      
      .v-application .pr-10 {
        padding-right: 40px !important;
      }
      
      .v-application .pr-11 {
        padding-right: 44px !important;
      }
      
      .v-application .pr-12 {
        padding-right: 48px !important;
      }
      
      .v-application .pb-0 {
        padding-bottom: 0px !important;
      }
      
      .v-application .pb-1 {
        padding-bottom: 4px !important;
      }
      
      .v-application .pb-2 {
        padding-bottom: 8px !important;
      }
      
      .v-application .pb-3 {
        padding-bottom: 12px !important;
      }
      
      .v-application .pb-4 {
        padding-bottom: 16px !important;
      }
      
      .v-application .pb-5 {
        padding-bottom: 20px !important;
      }
      
      .v-application .pb-6 {
        padding-bottom: 24px !important;
      }
      
      .v-application .pb-7 {
        padding-bottom: 28px !important;
      }
      
      .v-application .pb-8 {
        padding-bottom: 32px !important;
      }
      
      .v-application .pb-9 {
        padding-bottom: 36px !important;
      }
      
      .v-application .pb-10 {
        padding-bottom: 40px !important;
      }
      
      .v-application .pb-11 {
        padding-bottom: 44px !important;
      }
      
      .v-application .pb-12 {
        padding-bottom: 48px !important;
      }
      
      .v-application .pl-0 {
        padding-left: 0px !important;
      }
      
      .v-application .pl-1 {
        padding-left: 4px !important;
      }
      
      .v-application .pl-2 {
        padding-left: 8px !important;
      }
      
      .v-application .pl-3 {
        padding-left: 12px !important;
      }
      
      .v-application .pl-4 {
        padding-left: 16px !important;
      }
      
      .v-application .pl-5 {
        padding-left: 20px !important;
      }
      
      .v-application .pl-6 {
        padding-left: 24px !important;
      }
      
      .v-application .pl-7 {
        padding-left: 28px !important;
      }
      
      .v-application .pl-8 {
        padding-left: 32px !important;
      }
      
      .v-application .pl-9 {
        padding-left: 36px !important;
      }
      
      .v-application .pl-10 {
        padding-left: 40px !important;
      }
      
      .v-application .pl-11 {
        padding-left: 44px !important;
      }
      
      .v-application .pl-12 {
        padding-left: 48px !important;
      }
      
      .v-application--is-ltr .ps-0 {
        padding-left: 0px !important;
      }
      
      .v-application--is-rtl .ps-0 {
        padding-right: 0px !important;
      }
      
      .v-application--is-ltr .ps-1 {
        padding-left: 4px !important;
      }
      
      .v-application--is-rtl .ps-1 {
        padding-right: 4px !important;
      }
      
      .v-application--is-ltr .ps-2 {
        padding-left: 8px !important;
      }
      
      .v-application--is-rtl .ps-2 {
        padding-right: 8px !important;
      }
      
      .v-application--is-ltr .ps-3 {
        padding-left: 12px !important;
      }
      
      .v-application--is-rtl .ps-3 {
        padding-right: 12px !important;
      }
      
      .v-application--is-ltr .ps-4 {
        padding-left: 16px !important;
      }
      
      .v-application--is-rtl .ps-4 {
        padding-right: 16px !important;
      }
      
      .v-application--is-ltr .ps-5 {
        padding-left: 20px !important;
      }
      
      .v-application--is-rtl .ps-5 {
        padding-right: 20px !important;
      }
      
      .v-application--is-ltr .ps-6 {
        padding-left: 24px !important;
      }
      
      .v-application--is-rtl .ps-6 {
        padding-right: 24px !important;
      }
      
      .v-application--is-ltr .ps-7 {
        padding-left: 28px !important;
      }
      
      .v-application--is-rtl .ps-7 {
        padding-right: 28px !important;
      }
      
      .v-application--is-ltr .ps-8 {
        padding-left: 32px !important;
      }
      
      .v-application--is-rtl .ps-8 {
        padding-right: 32px !important;
      }
      
      .v-application--is-ltr .ps-9 {
        padding-left: 36px !important;
      }
      
      .v-application--is-rtl .ps-9 {
        padding-right: 36px !important;
      }
      
      .v-application--is-ltr .ps-10 {
        padding-left: 40px !important;
      }
      
      .v-application--is-rtl .ps-10 {
        padding-right: 40px !important;
      }
      
      .v-application--is-ltr .ps-11 {
        padding-left: 44px !important;
      }
      
      .v-application--is-rtl .ps-11 {
        padding-right: 44px !important;
      }
      
      .v-application--is-ltr .ps-12 {
        padding-left: 48px !important;
      }
      
      .v-application--is-rtl .ps-12 {
        padding-right: 48px !important;
      }
      
      .v-application--is-ltr .pe-0 {
        padding-right: 0px !important;
      }
      
      .v-application--is-rtl .pe-0 {
        padding-left: 0px !important;
      }
      
      .v-application--is-ltr .pe-1 {
        padding-right: 4px !important;
      }
      
      .v-application--is-rtl .pe-1 {
        padding-left: 4px !important;
      }
      
      .v-application--is-ltr .pe-2 {
        padding-right: 8px !important;
      }
      
      .v-application--is-rtl .pe-2 {
        padding-left: 8px !important;
      }
      
      .v-application--is-ltr .pe-3 {
        padding-right: 12px !important;
      }
      
      .v-application--is-rtl .pe-3 {
        padding-left: 12px !important;
      }
      
      .v-application--is-ltr .pe-4 {
        padding-right: 16px !important;
      }
      
      .v-application--is-rtl .pe-4 {
        padding-left: 16px !important;
      }
      
      .v-application--is-ltr .pe-5 {
        padding-right: 20px !important;
      }
      
      .v-application--is-rtl .pe-5 {
        padding-left: 20px !important;
      }
      
      .v-application--is-ltr .pe-6 {
        padding-right: 24px !important;
      }
      
      .v-application--is-rtl .pe-6 {
        padding-left: 24px !important;
      }
      
      .v-application--is-ltr .pe-7 {
        padding-right: 28px !important;
      }
      
      .v-application--is-rtl .pe-7 {
        padding-left: 28px !important;
      }
      
      .v-application--is-ltr .pe-8 {
        padding-right: 32px !important;
      }
      
      .v-application--is-rtl .pe-8 {
        padding-left: 32px !important;
      }
      
      .v-application--is-ltr .pe-9 {
        padding-right: 36px !important;
      }
      
      .v-application--is-rtl .pe-9 {
        padding-left: 36px !important;
      }
      
      .v-application--is-ltr .pe-10 {
        padding-right: 40px !important;
      }
      
      .v-application--is-rtl .pe-10 {
        padding-left: 40px !important;
      }
      
      .v-application--is-ltr .pe-11 {
        padding-right: 44px !important;
      }
      
      .v-application--is-rtl .pe-11 {
        padding-left: 44px !important;
      }
      
      .v-application--is-ltr .pe-12 {
        padding-right: 48px !important;
      }
      
      .v-application--is-rtl .pe-12 {
        padding-left: 48px !important;
      }
      
      .v-application .text-left {
        text-align: left !important;
      }
      
      .v-application .text-right {
        text-align: right !important;
      }
      
      .v-application .text-center {
        text-align: center !important;
      }
      
      .v-application .text-justify {
        text-align: justify !important;
      }
      
      .v-application .text-start {
        text-align: start !important;
      }
      
      .v-application .text-end {
        text-align: end !important;
      }
      
      .v-application .text-wrap {
        white-space: normal !important;
      }
      
      .v-application .text-no-wrap {
        white-space: nowrap !important;
      }
      
      .v-application .text-break {
        overflow-wrap: break-word !important;
        word-break: break-word !important;
      }
      
      .v-application .text-truncate {
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
      }
      
      .v-application .text-none {
        text-transform: none !important;
      }
      
      .v-application .text-capitalize {
        text-transform: capitalize !important;
      }
      
      .v-application .text-lowercase {
        text-transform: lowercase !important;
      }
      
      .v-application .text-uppercase {
        text-transform: uppercase !important;
      }
      
      @media (min-width: 600px) {
        .v-application .d-sm-none {
          display: none !important;
        }
      
        .v-application .d-sm-inline {
          display: inline !important;
        }
      
        .v-application .d-sm-inline-block {
          display: inline-block !important;
        }
      
        .v-application .d-sm-block {
          display: block !important;
        }
      
        .v-application .d-sm-table {
          display: table !important;
        }
      
        .v-application .d-sm-table-row {
          display: table-row !important;
        }
      
        .v-application .d-sm-table-cell {
          display: table-cell !important;
        }
      
        .v-application .d-sm-flex {
          display: -webkit-box !important;
          display: -ms-flexbox !important;
          display: flex !important;
        }
      
        .v-application .d-sm-inline-flex {
          display: -webkit-inline-box !important;
          display: -ms-inline-flexbox !important;
          display: inline-flex !important;
        }
      
        .v-application .float-sm-none {
          float: none !important;
        }
      
        .v-application .float-sm-left {
          float: left !important;
        }
      
        .v-application .float-sm-right {
          float: right !important;
        }
      
        .v-application .flex-sm-fill {
          -webkit-box-flex: 1 !important;
              -ms-flex: 1 1 auto !important;
                  flex: 1 1 auto !important;
        }
      
        .v-application .flex-sm-row {
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: normal !important;
              -ms-flex-direction: row !important;
                  flex-direction: row !important;
        }
      
        .v-application .flex-sm-column {
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: normal !important;
              -ms-flex-direction: column !important;
                  flex-direction: column !important;
        }
      
        .v-application .flex-sm-row-reverse {
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: reverse !important;
              -ms-flex-direction: row-reverse !important;
                  flex-direction: row-reverse !important;
        }
      
        .v-application .flex-sm-column-reverse {
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: reverse !important;
              -ms-flex-direction: column-reverse !important;
                  flex-direction: column-reverse !important;
        }
      
        .v-application .flex-sm-grow-0 {
          -webkit-box-flex: 0 !important;
              -ms-flex-positive: 0 !important;
                  flex-grow: 0 !important;
        }
      
        .v-application .flex-sm-grow-1 {
          -webkit-box-flex: 1 !important;
              -ms-flex-positive: 1 !important;
                  flex-grow: 1 !important;
        }
      
        .v-application .flex-sm-shrink-0 {
          -ms-flex-negative: 0 !important;
              flex-shrink: 0 !important;
        }
      
        .v-application .flex-sm-shrink-1 {
          -ms-flex-negative: 1 !important;
              flex-shrink: 1 !important;
        }
      
        .v-application .flex-sm-wrap {
          -ms-flex-wrap: wrap !important;
              flex-wrap: wrap !important;
        }
      
        .v-application .flex-sm-nowrap {
          -ms-flex-wrap: nowrap !important;
              flex-wrap: nowrap !important;
        }
      
        .v-application .flex-sm-wrap-reverse {
          -ms-flex-wrap: wrap-reverse !important;
              flex-wrap: wrap-reverse !important;
        }
      
        .v-application .justify-sm-start {
          -webkit-box-pack: start !important;
              -ms-flex-pack: start !important;
                  justify-content: flex-start !important;
        }
      
        .v-application .justify-sm-end {
          -webkit-box-pack: end !important;
              -ms-flex-pack: end !important;
                  justify-content: flex-end !important;
        }
      
        .v-application .justify-sm-center {
          -webkit-box-pack: center !important;
              -ms-flex-pack: center !important;
                  justify-content: center !important;
        }
      
        .v-application .justify-sm-space-between {
          -webkit-box-pack: justify !important;
              -ms-flex-pack: justify !important;
                  justify-content: space-between !important;
        }
      
        .v-application .justify-sm-space-around {
          -ms-flex-pack: distribute !important;
              justify-content: space-around !important;
        }
      
        .v-application .align-sm-start {
          -webkit-box-align: start !important;
              -ms-flex-align: start !important;
                  align-items: flex-start !important;
        }
      
        .v-application .align-sm-end {
          -webkit-box-align: end !important;
              -ms-flex-align: end !important;
                  align-items: flex-end !important;
        }
      
        .v-application .align-sm-center {
          -webkit-box-align: center !important;
              -ms-flex-align: center !important;
                  align-items: center !important;
        }
      
        .v-application .align-sm-baseline {
          -webkit-box-align: baseline !important;
              -ms-flex-align: baseline !important;
                  align-items: baseline !important;
        }
      
        .v-application .align-sm-stretch {
          -webkit-box-align: stretch !important;
              -ms-flex-align: stretch !important;
                  align-items: stretch !important;
        }
      
        .v-application .align-content-sm-start {
          -ms-flex-line-pack: start !important;
              align-content: flex-start !important;
        }
      
        .v-application .align-content-sm-end {
          -ms-flex-line-pack: end !important;
              align-content: flex-end !important;
        }
      
        .v-application .align-content-sm-center {
          -ms-flex-line-pack: center !important;
              align-content: center !important;
        }
      
        .v-application .align-content-sm-space-between {
          -ms-flex-line-pack: justify !important;
              align-content: space-between !important;
        }
      
        .v-application .align-content-sm-space-around {
          -ms-flex-line-pack: distribute !important;
              align-content: space-around !important;
        }
      
        .v-application .align-content-sm-stretch {
          -ms-flex-line-pack: stretch !important;
              align-content: stretch !important;
        }
      
        .v-application .align-self-sm-auto {
          -ms-flex-item-align: auto !important;
              align-self: auto !important;
        }
      
        .v-application .align-self-sm-start {
          -ms-flex-item-align: start !important;
              align-self: flex-start !important;
        }
      
        .v-application .align-self-sm-end {
          -ms-flex-item-align: end !important;
              align-self: flex-end !important;
        }
      
        .v-application .align-self-sm-center {
          -ms-flex-item-align: center !important;
              align-self: center !important;
        }
      
        .v-application .align-self-sm-baseline {
          -ms-flex-item-align: baseline !important;
              align-self: baseline !important;
        }
      
        .v-application .align-self-sm-stretch {
          -ms-flex-item-align: stretch !important;
              align-self: stretch !important;
        }
      
        .v-application .order-sm-first {
          -webkit-box-ordinal-group: 0 !important;
              -ms-flex-order: -1 !important;
                  order: -1 !important;
        }
      
        .v-application .order-sm-0 {
          -webkit-box-ordinal-group: 1 !important;
              -ms-flex-order: 0 !important;
                  order: 0 !important;
        }
      
        .v-application .order-sm-1 {
          -webkit-box-ordinal-group: 2 !important;
              -ms-flex-order: 1 !important;
                  order: 1 !important;
        }
      
        .v-application .order-sm-2 {
          -webkit-box-ordinal-group: 3 !important;
              -ms-flex-order: 2 !important;
                  order: 2 !important;
        }
      
        .v-application .order-sm-3 {
          -webkit-box-ordinal-group: 4 !important;
              -ms-flex-order: 3 !important;
                  order: 3 !important;
        }
      
        .v-application .order-sm-4 {
          -webkit-box-ordinal-group: 5 !important;
              -ms-flex-order: 4 !important;
                  order: 4 !important;
        }
      
        .v-application .order-sm-5 {
          -webkit-box-ordinal-group: 6 !important;
              -ms-flex-order: 5 !important;
                  order: 5 !important;
        }
      
        .v-application .order-sm-6 {
          -webkit-box-ordinal-group: 7 !important;
              -ms-flex-order: 6 !important;
                  order: 6 !important;
        }
      
        .v-application .order-sm-7 {
          -webkit-box-ordinal-group: 8 !important;
              -ms-flex-order: 7 !important;
                  order: 7 !important;
        }
      
        .v-application .order-sm-8 {
          -webkit-box-ordinal-group: 9 !important;
              -ms-flex-order: 8 !important;
                  order: 8 !important;
        }
      
        .v-application .order-sm-9 {
          -webkit-box-ordinal-group: 10 !important;
              -ms-flex-order: 9 !important;
                  order: 9 !important;
        }
      
        .v-application .order-sm-10 {
          -webkit-box-ordinal-group: 11 !important;
              -ms-flex-order: 10 !important;
                  order: 10 !important;
        }
      
        .v-application .order-sm-11 {
          -webkit-box-ordinal-group: 12 !important;
              -ms-flex-order: 11 !important;
                  order: 11 !important;
        }
      
        .v-application .order-sm-12 {
          -webkit-box-ordinal-group: 13 !important;
              -ms-flex-order: 12 !important;
                  order: 12 !important;
        }
      
        .v-application .order-sm-last {
          -webkit-box-ordinal-group: 14 !important;
              -ms-flex-order: 13 !important;
                  order: 13 !important;
        }
      
        .v-application .ma-sm-0 {
          margin: 0px !important;
        }
      
        .v-application .ma-sm-1 {
          margin: 4px !important;
        }
      
        .v-application .ma-sm-2 {
          margin: 8px !important;
        }
      
        .v-application .ma-sm-3 {
          margin: 12px !important;
        }
      
        .v-application .ma-sm-4 {
          margin: 16px !important;
        }
      
        .v-application .ma-sm-5 {
          margin: 20px !important;
        }
      
        .v-application .ma-sm-6 {
          margin: 24px !important;
        }
      
        .v-application .ma-sm-7 {
          margin: 28px !important;
        }
      
        .v-application .ma-sm-8 {
          margin: 32px !important;
        }
      
        .v-application .ma-sm-9 {
          margin: 36px !important;
        }
      
        .v-application .ma-sm-10 {
          margin: 40px !important;
        }
      
        .v-application .ma-sm-11 {
          margin: 44px !important;
        }
      
        .v-application .ma-sm-12 {
          margin: 48px !important;
        }
      
        .v-application .ma-sm-auto {
          margin: auto !important;
        }
      
        .v-application .mx-sm-0 {
          margin-right: 0px !important;
          margin-left: 0px !important;
        }
      
        .v-application .mx-sm-1 {
          margin-right: 4px !important;
          margin-left: 4px !important;
        }
      
        .v-application .mx-sm-2 {
          margin-right: 8px !important;
          margin-left: 8px !important;
        }
      
        .v-application .mx-sm-3 {
          margin-right: 12px !important;
          margin-left: 12px !important;
        }
      
        .v-application .mx-sm-4 {
          margin-right: 16px !important;
          margin-left: 16px !important;
        }
      
        .v-application .mx-sm-5 {
          margin-right: 20px !important;
          margin-left: 20px !important;
        }
      
        .v-application .mx-sm-6 {
          margin-right: 24px !important;
          margin-left: 24px !important;
        }
      
        .v-application .mx-sm-7 {
          margin-right: 28px !important;
          margin-left: 28px !important;
        }
      
        .v-application .mx-sm-8 {
          margin-right: 32px !important;
          margin-left: 32px !important;
        }
      
        .v-application .mx-sm-9 {
          margin-right: 36px !important;
          margin-left: 36px !important;
        }
      
        .v-application .mx-sm-10 {
          margin-right: 40px !important;
          margin-left: 40px !important;
        }
      
        .v-application .mx-sm-11 {
          margin-right: 44px !important;
          margin-left: 44px !important;
        }
      
        .v-application .mx-sm-12 {
          margin-right: 48px !important;
          margin-left: 48px !important;
        }
      
        .v-application .mx-sm-auto {
          margin-right: auto !important;
          margin-left: auto !important;
        }
      
        .v-application .my-sm-0 {
          margin-top: 0px !important;
          margin-bottom: 0px !important;
        }
      
        .v-application .my-sm-1 {
          margin-top: 4px !important;
          margin-bottom: 4px !important;
        }
      
        .v-application .my-sm-2 {
          margin-top: 8px !important;
          margin-bottom: 8px !important;
        }
      
        .v-application .my-sm-3 {
          margin-top: 12px !important;
          margin-bottom: 12px !important;
        }
      
        .v-application .my-sm-4 {
          margin-top: 16px !important;
          margin-bottom: 16px !important;
        }
      
        .v-application .my-sm-5 {
          margin-top: 20px !important;
          margin-bottom: 20px !important;
        }
      
        .v-application .my-sm-6 {
          margin-top: 24px !important;
          margin-bottom: 24px !important;
        }
      
        .v-application .my-sm-7 {
          margin-top: 28px !important;
          margin-bottom: 28px !important;
        }
      
        .v-application .my-sm-8 {
          margin-top: 32px !important;
          margin-bottom: 32px !important;
        }
      
        .v-application .my-sm-9 {
          margin-top: 36px !important;
          margin-bottom: 36px !important;
        }
      
        .v-application .my-sm-10 {
          margin-top: 40px !important;
          margin-bottom: 40px !important;
        }
      
        .v-application .my-sm-11 {
          margin-top: 44px !important;
          margin-bottom: 44px !important;
        }
      
        .v-application .my-sm-12 {
          margin-top: 48px !important;
          margin-bottom: 48px !important;
        }
      
        .v-application .my-sm-auto {
          margin-top: auto !important;
          margin-bottom: auto !important;
        }
      
        .v-application .mt-sm-0 {
          margin-top: 0px !important;
        }
      
        .v-application .mt-sm-1 {
          margin-top: 4px !important;
        }
      
        .v-application .mt-sm-2 {
          margin-top: 8px !important;
        }
      
        .v-application .mt-sm-3 {
          margin-top: 12px !important;
        }
      
        .v-application .mt-sm-4 {
          margin-top: 16px !important;
        }
      
        .v-application .mt-sm-5 {
          margin-top: 20px !important;
        }
      
        .v-application .mt-sm-6 {
          margin-top: 24px !important;
        }
      
        .v-application .mt-sm-7 {
          margin-top: 28px !important;
        }
      
        .v-application .mt-sm-8 {
          margin-top: 32px !important;
        }
      
        .v-application .mt-sm-9 {
          margin-top: 36px !important;
        }
      
        .v-application .mt-sm-10 {
          margin-top: 40px !important;
        }
      
        .v-application .mt-sm-11 {
          margin-top: 44px !important;
        }
      
        .v-application .mt-sm-12 {
          margin-top: 48px !important;
        }
      
        .v-application .mt-sm-auto {
          margin-top: auto !important;
        }
      
        .v-application .mr-sm-0 {
          margin-right: 0px !important;
        }
      
        .v-application .mr-sm-1 {
          margin-right: 4px !important;
        }
      
        .v-application .mr-sm-2 {
          margin-right: 8px !important;
        }
      
        .v-application .mr-sm-3 {
          margin-right: 12px !important;
        }
      
        .v-application .mr-sm-4 {
          margin-right: 16px !important;
        }
      
        .v-application .mr-sm-5 {
          margin-right: 20px !important;
        }
      
        .v-application .mr-sm-6 {
          margin-right: 24px !important;
        }
      
        .v-application .mr-sm-7 {
          margin-right: 28px !important;
        }
      
        .v-application .mr-sm-8 {
          margin-right: 32px !important;
        }
      
        .v-application .mr-sm-9 {
          margin-right: 36px !important;
        }
      
        .v-application .mr-sm-10 {
          margin-right: 40px !important;
        }
      
        .v-application .mr-sm-11 {
          margin-right: 44px !important;
        }
      
        .v-application .mr-sm-12 {
          margin-right: 48px !important;
        }
      
        .v-application .mr-sm-auto {
          margin-right: auto !important;
        }
      
        .v-application .mb-sm-0 {
          margin-bottom: 0px !important;
        }
      
        .v-application .mb-sm-1 {
          margin-bottom: 4px !important;
        }
      
        .v-application .mb-sm-2 {
          margin-bottom: 8px !important;
        }
      
        .v-application .mb-sm-3 {
          margin-bottom: 12px !important;
        }
      
        .v-application .mb-sm-4 {
          margin-bottom: 16px !important;
        }
      
        .v-application .mb-sm-5 {
          margin-bottom: 20px !important;
        }
      
        .v-application .mb-sm-6 {
          margin-bottom: 24px !important;
        }
      
        .v-application .mb-sm-7 {
          margin-bottom: 28px !important;
        }
      
        .v-application .mb-sm-8 {
          margin-bottom: 32px !important;
        }
      
        .v-application .mb-sm-9 {
          margin-bottom: 36px !important;
        }
      
        .v-application .mb-sm-10 {
          margin-bottom: 40px !important;
        }
      
        .v-application .mb-sm-11 {
          margin-bottom: 44px !important;
        }
      
        .v-application .mb-sm-12 {
          margin-bottom: 48px !important;
        }
      
        .v-application .mb-sm-auto {
          margin-bottom: auto !important;
        }
      
        .v-application .ml-sm-0 {
          margin-left: 0px !important;
        }
      
        .v-application .ml-sm-1 {
          margin-left: 4px !important;
        }
      
        .v-application .ml-sm-2 {
          margin-left: 8px !important;
        }
      
        .v-application .ml-sm-3 {
          margin-left: 12px !important;
        }
      
        .v-application .ml-sm-4 {
          margin-left: 16px !important;
        }
      
        .v-application .ml-sm-5 {
          margin-left: 20px !important;
        }
      
        .v-application .ml-sm-6 {
          margin-left: 24px !important;
        }
      
        .v-application .ml-sm-7 {
          margin-left: 28px !important;
        }
      
        .v-application .ml-sm-8 {
          margin-left: 32px !important;
        }
      
        .v-application .ml-sm-9 {
          margin-left: 36px !important;
        }
      
        .v-application .ml-sm-10 {
          margin-left: 40px !important;
        }
      
        .v-application .ml-sm-11 {
          margin-left: 44px !important;
        }
      
        .v-application .ml-sm-12 {
          margin-left: 48px !important;
        }
      
        .v-application .ml-sm-auto {
          margin-left: auto !important;
        }
      
        .v-application--is-ltr .ms-sm-0 {
          margin-left: 0px !important;
        }
      
        .v-application--is-rtl .ms-sm-0 {
          margin-right: 0px !important;
        }
      
        .v-application--is-ltr .ms-sm-1 {
          margin-left: 4px !important;
        }
      
        .v-application--is-rtl .ms-sm-1 {
          margin-right: 4px !important;
        }
      
        .v-application--is-ltr .ms-sm-2 {
          margin-left: 8px !important;
        }
      
        .v-application--is-rtl .ms-sm-2 {
          margin-right: 8px !important;
        }
      
        .v-application--is-ltr .ms-sm-3 {
          margin-left: 12px !important;
        }
      
        .v-application--is-rtl .ms-sm-3 {
          margin-right: 12px !important;
        }
      
        .v-application--is-ltr .ms-sm-4 {
          margin-left: 16px !important;
        }
      
        .v-application--is-rtl .ms-sm-4 {
          margin-right: 16px !important;
        }
      
        .v-application--is-ltr .ms-sm-5 {
          margin-left: 20px !important;
        }
      
        .v-application--is-rtl .ms-sm-5 {
          margin-right: 20px !important;
        }
      
        .v-application--is-ltr .ms-sm-6 {
          margin-left: 24px !important;
        }
      
        .v-application--is-rtl .ms-sm-6 {
          margin-right: 24px !important;
        }
      
        .v-application--is-ltr .ms-sm-7 {
          margin-left: 28px !important;
        }
      
        .v-application--is-rtl .ms-sm-7 {
          margin-right: 28px !important;
        }
      
        .v-application--is-ltr .ms-sm-8 {
          margin-left: 32px !important;
        }
      
        .v-application--is-rtl .ms-sm-8 {
          margin-right: 32px !important;
        }
      
        .v-application--is-ltr .ms-sm-9 {
          margin-left: 36px !important;
        }
      
        .v-application--is-rtl .ms-sm-9 {
          margin-right: 36px !important;
        }
      
        .v-application--is-ltr .ms-sm-10 {
          margin-left: 40px !important;
        }
      
        .v-application--is-rtl .ms-sm-10 {
          margin-right: 40px !important;
        }
      
        .v-application--is-ltr .ms-sm-11 {
          margin-left: 44px !important;
        }
      
        .v-application--is-rtl .ms-sm-11 {
          margin-right: 44px !important;
        }
      
        .v-application--is-ltr .ms-sm-12 {
          margin-left: 48px !important;
        }
      
        .v-application--is-rtl .ms-sm-12 {
          margin-right: 48px !important;
        }
      
        .v-application--is-ltr .ms-sm-auto {
          margin-left: auto !important;
        }
      
        .v-application--is-rtl .ms-sm-auto {
          margin-right: auto !important;
        }
      
        .v-application--is-ltr .me-sm-0 {
          margin-right: 0px !important;
        }
      
        .v-application--is-rtl .me-sm-0 {
          margin-left: 0px !important;
        }
      
        .v-application--is-ltr .me-sm-1 {
          margin-right: 4px !important;
        }
      
        .v-application--is-rtl .me-sm-1 {
          margin-left: 4px !important;
        }
      
        .v-application--is-ltr .me-sm-2 {
          margin-right: 8px !important;
        }
      
        .v-application--is-rtl .me-sm-2 {
          margin-left: 8px !important;
        }
      
        .v-application--is-ltr .me-sm-3 {
          margin-right: 12px !important;
        }
      
        .v-application--is-rtl .me-sm-3 {
          margin-left: 12px !important;
        }
      
        .v-application--is-ltr .me-sm-4 {
          margin-right: 16px !important;
        }
      
        .v-application--is-rtl .me-sm-4 {
          margin-left: 16px !important;
        }
      
        .v-application--is-ltr .me-sm-5 {
          margin-right: 20px !important;
        }
      
        .v-application--is-rtl .me-sm-5 {
          margin-left: 20px !important;
        }
      
        .v-application--is-ltr .me-sm-6 {
          margin-right: 24px !important;
        }
      
        .v-application--is-rtl .me-sm-6 {
          margin-left: 24px !important;
        }
      
        .v-application--is-ltr .me-sm-7 {
          margin-right: 28px !important;
        }
      
        .v-application--is-rtl .me-sm-7 {
          margin-left: 28px !important;
        }
      
        .v-application--is-ltr .me-sm-8 {
          margin-right: 32px !important;
        }
      
        .v-application--is-rtl .me-sm-8 {
          margin-left: 32px !important;
        }
      
        .v-application--is-ltr .me-sm-9 {
          margin-right: 36px !important;
        }
      
        .v-application--is-rtl .me-sm-9 {
          margin-left: 36px !important;
        }
      
        .v-application--is-ltr .me-sm-10 {
          margin-right: 40px !important;
        }
      
        .v-application--is-rtl .me-sm-10 {
          margin-left: 40px !important;
        }
      
        .v-application--is-ltr .me-sm-11 {
          margin-right: 44px !important;
        }
      
        .v-application--is-rtl .me-sm-11 {
          margin-left: 44px !important;
        }
      
        .v-application--is-ltr .me-sm-12 {
          margin-right: 48px !important;
        }
      
        .v-application--is-rtl .me-sm-12 {
          margin-left: 48px !important;
        }
      
        .v-application--is-ltr .me-sm-auto {
          margin-right: auto !important;
        }
      
        .v-application--is-rtl .me-sm-auto {
          margin-left: auto !important;
        }
      
        .v-application .ma-sm-n1 {
          margin: -4px !important;
        }
      
        .v-application .ma-sm-n2 {
          margin: -8px !important;
        }
      
        .v-application .ma-sm-n3 {
          margin: -12px !important;
        }
      
        .v-application .ma-sm-n4 {
          margin: -16px !important;
        }
      
        .v-application .ma-sm-n5 {
          margin: -20px !important;
        }
      
        .v-application .ma-sm-n6 {
          margin: -24px !important;
        }
      
        .v-application .ma-sm-n7 {
          margin: -28px !important;
        }
      
        .v-application .ma-sm-n8 {
          margin: -32px !important;
        }
      
        .v-application .ma-sm-n9 {
          margin: -36px !important;
        }
      
        .v-application .ma-sm-n10 {
          margin: -40px !important;
        }
      
        .v-application .ma-sm-n11 {
          margin: -44px !important;
        }
      
        .v-application .ma-sm-n12 {
          margin: -48px !important;
        }
      
        .v-application .mx-sm-n1 {
          margin-right: -4px !important;
          margin-left: -4px !important;
        }
      
        .v-application .mx-sm-n2 {
          margin-right: -8px !important;
          margin-left: -8px !important;
        }
      
        .v-application .mx-sm-n3 {
          margin-right: -12px !important;
          margin-left: -12px !important;
        }
      
        .v-application .mx-sm-n4 {
          margin-right: -16px !important;
          margin-left: -16px !important;
        }
      
        .v-application .mx-sm-n5 {
          margin-right: -20px !important;
          margin-left: -20px !important;
        }
      
        .v-application .mx-sm-n6 {
          margin-right: -24px !important;
          margin-left: -24px !important;
        }
      
        .v-application .mx-sm-n7 {
          margin-right: -28px !important;
          margin-left: -28px !important;
        }
      
        .v-application .mx-sm-n8 {
          margin-right: -32px !important;
          margin-left: -32px !important;
        }
      
        .v-application .mx-sm-n9 {
          margin-right: -36px !important;
          margin-left: -36px !important;
        }
      
        .v-application .mx-sm-n10 {
          margin-right: -40px !important;
          margin-left: -40px !important;
        }
      
        .v-application .mx-sm-n11 {
          margin-right: -44px !important;
          margin-left: -44px !important;
        }
      
        .v-application .mx-sm-n12 {
          margin-right: -48px !important;
          margin-left: -48px !important;
        }
      
        .v-application .my-sm-n1 {
          margin-top: -4px !important;
          margin-bottom: -4px !important;
        }
      
        .v-application .my-sm-n2 {
          margin-top: -8px !important;
          margin-bottom: -8px !important;
        }
      
        .v-application .my-sm-n3 {
          margin-top: -12px !important;
          margin-bottom: -12px !important;
        }
      
        .v-application .my-sm-n4 {
          margin-top: -16px !important;
          margin-bottom: -16px !important;
        }
      
        .v-application .my-sm-n5 {
          margin-top: -20px !important;
          margin-bottom: -20px !important;
        }
      
        .v-application .my-sm-n6 {
          margin-top: -24px !important;
          margin-bottom: -24px !important;
        }
      
        .v-application .my-sm-n7 {
          margin-top: -28px !important;
          margin-bottom: -28px !important;
        }
      
        .v-application .my-sm-n8 {
          margin-top: -32px !important;
          margin-bottom: -32px !important;
        }
      
        .v-application .my-sm-n9 {
          margin-top: -36px !important;
          margin-bottom: -36px !important;
        }
      
        .v-application .my-sm-n10 {
          margin-top: -40px !important;
          margin-bottom: -40px !important;
        }
      
        .v-application .my-sm-n11 {
          margin-top: -44px !important;
          margin-bottom: -44px !important;
        }
      
        .v-application .my-sm-n12 {
          margin-top: -48px !important;
          margin-bottom: -48px !important;
        }
      
        .v-application .mt-sm-n1 {
          margin-top: -4px !important;
        }
      
        .v-application .mt-sm-n2 {
          margin-top: -8px !important;
        }
      
        .v-application .mt-sm-n3 {
          margin-top: -12px !important;
        }
      
        .v-application .mt-sm-n4 {
          margin-top: -16px !important;
        }
      
        .v-application .mt-sm-n5 {
          margin-top: -20px !important;
        }
      
        .v-application .mt-sm-n6 {
          margin-top: -24px !important;
        }
      
        .v-application .mt-sm-n7 {
          margin-top: -28px !important;
        }
      
        .v-application .mt-sm-n8 {
          margin-top: -32px !important;
        }
      
        .v-application .mt-sm-n9 {
          margin-top: -36px !important;
        }
      
        .v-application .mt-sm-n10 {
          margin-top: -40px !important;
        }
      
        .v-application .mt-sm-n11 {
          margin-top: -44px !important;
        }
      
        .v-application .mt-sm-n12 {
          margin-top: -48px !important;
        }
      
        .v-application .mr-sm-n1 {
          margin-right: -4px !important;
        }
      
        .v-application .mr-sm-n2 {
          margin-right: -8px !important;
        }
      
        .v-application .mr-sm-n3 {
          margin-right: -12px !important;
        }
      
        .v-application .mr-sm-n4 {
          margin-right: -16px !important;
        }
      
        .v-application .mr-sm-n5 {
          margin-right: -20px !important;
        }
      
        .v-application .mr-sm-n6 {
          margin-right: -24px !important;
        }
      
        .v-application .mr-sm-n7 {
          margin-right: -28px !important;
        }
      
        .v-application .mr-sm-n8 {
          margin-right: -32px !important;
        }
      
        .v-application .mr-sm-n9 {
          margin-right: -36px !important;
        }
      
        .v-application .mr-sm-n10 {
          margin-right: -40px !important;
        }
      
        .v-application .mr-sm-n11 {
          margin-right: -44px !important;
        }
      
        .v-application .mr-sm-n12 {
          margin-right: -48px !important;
        }
      
        .v-application .mb-sm-n1 {
          margin-bottom: -4px !important;
        }
      
        .v-application .mb-sm-n2 {
          margin-bottom: -8px !important;
        }
      
        .v-application .mb-sm-n3 {
          margin-bottom: -12px !important;
        }
      
        .v-application .mb-sm-n4 {
          margin-bottom: -16px !important;
        }
      
        .v-application .mb-sm-n5 {
          margin-bottom: -20px !important;
        }
      
        .v-application .mb-sm-n6 {
          margin-bottom: -24px !important;
        }
      
        .v-application .mb-sm-n7 {
          margin-bottom: -28px !important;
        }
      
        .v-application .mb-sm-n8 {
          margin-bottom: -32px !important;
        }
      
        .v-application .mb-sm-n9 {
          margin-bottom: -36px !important;
        }
      
        .v-application .mb-sm-n10 {
          margin-bottom: -40px !important;
        }
      
        .v-application .mb-sm-n11 {
          margin-bottom: -44px !important;
        }
      
        .v-application .mb-sm-n12 {
          margin-bottom: -48px !important;
        }
      
        .v-application .ml-sm-n1 {
          margin-left: -4px !important;
        }
      
        .v-application .ml-sm-n2 {
          margin-left: -8px !important;
        }
      
        .v-application .ml-sm-n3 {
          margin-left: -12px !important;
        }
      
        .v-application .ml-sm-n4 {
          margin-left: -16px !important;
        }
      
        .v-application .ml-sm-n5 {
          margin-left: -20px !important;
        }
      
        .v-application .ml-sm-n6 {
          margin-left: -24px !important;
        }
      
        .v-application .ml-sm-n7 {
          margin-left: -28px !important;
        }
      
        .v-application .ml-sm-n8 {
          margin-left: -32px !important;
        }
      
        .v-application .ml-sm-n9 {
          margin-left: -36px !important;
        }
      
        .v-application .ml-sm-n10 {
          margin-left: -40px !important;
        }
      
        .v-application .ml-sm-n11 {
          margin-left: -44px !important;
        }
      
        .v-application .ml-sm-n12 {
          margin-left: -48px !important;
        }
      
        .v-application--is-ltr .ms-sm-n1 {
          margin-left: -4px !important;
        }
      
        .v-application--is-rtl .ms-sm-n1 {
          margin-right: -4px !important;
        }
      
        .v-application--is-ltr .ms-sm-n2 {
          margin-left: -8px !important;
        }
      
        .v-application--is-rtl .ms-sm-n2 {
          margin-right: -8px !important;
        }
      
        .v-application--is-ltr .ms-sm-n3 {
          margin-left: -12px !important;
        }
      
        .v-application--is-rtl .ms-sm-n3 {
          margin-right: -12px !important;
        }
      
        .v-application--is-ltr .ms-sm-n4 {
          margin-left: -16px !important;
        }
      
        .v-application--is-rtl .ms-sm-n4 {
          margin-right: -16px !important;
        }
      
        .v-application--is-ltr .ms-sm-n5 {
          margin-left: -20px !important;
        }
      
        .v-application--is-rtl .ms-sm-n5 {
          margin-right: -20px !important;
        }
      
        .v-application--is-ltr .ms-sm-n6 {
          margin-left: -24px !important;
        }
      
        .v-application--is-rtl .ms-sm-n6 {
          margin-right: -24px !important;
        }
      
        .v-application--is-ltr .ms-sm-n7 {
          margin-left: -28px !important;
        }
      
        .v-application--is-rtl .ms-sm-n7 {
          margin-right: -28px !important;
        }
      
        .v-application--is-ltr .ms-sm-n8 {
          margin-left: -32px !important;
        }
      
        .v-application--is-rtl .ms-sm-n8 {
          margin-right: -32px !important;
        }
      
        .v-application--is-ltr .ms-sm-n9 {
          margin-left: -36px !important;
        }
      
        .v-application--is-rtl .ms-sm-n9 {
          margin-right: -36px !important;
        }
      
        .v-application--is-ltr .ms-sm-n10 {
          margin-left: -40px !important;
        }
      
        .v-application--is-rtl .ms-sm-n10 {
          margin-right: -40px !important;
        }
      
        .v-application--is-ltr .ms-sm-n11 {
          margin-left: -44px !important;
        }
      
        .v-application--is-rtl .ms-sm-n11 {
          margin-right: -44px !important;
        }
      
        .v-application--is-ltr .ms-sm-n12 {
          margin-left: -48px !important;
        }
      
        .v-application--is-rtl .ms-sm-n12 {
          margin-right: -48px !important;
        }
      
        .v-application--is-ltr .me-sm-n1 {
          margin-right: -4px !important;
        }
      
        .v-application--is-rtl .me-sm-n1 {
          margin-left: -4px !important;
        }
      
        .v-application--is-ltr .me-sm-n2 {
          margin-right: -8px !important;
        }
      
        .v-application--is-rtl .me-sm-n2 {
          margin-left: -8px !important;
        }
      
        .v-application--is-ltr .me-sm-n3 {
          margin-right: -12px !important;
        }
      
        .v-application--is-rtl .me-sm-n3 {
          margin-left: -12px !important;
        }
      
        .v-application--is-ltr .me-sm-n4 {
          margin-right: -16px !important;
        }
      
        .v-application--is-rtl .me-sm-n4 {
          margin-left: -16px !important;
        }
      
        .v-application--is-ltr .me-sm-n5 {
          margin-right: -20px !important;
        }
      
        .v-application--is-rtl .me-sm-n5 {
          margin-left: -20px !important;
        }
      
        .v-application--is-ltr .me-sm-n6 {
          margin-right: -24px !important;
        }
      
        .v-application--is-rtl .me-sm-n6 {
          margin-left: -24px !important;
        }
      
        .v-application--is-ltr .me-sm-n7 {
          margin-right: -28px !important;
        }
      
        .v-application--is-rtl .me-sm-n7 {
          margin-left: -28px !important;
        }
      
        .v-application--is-ltr .me-sm-n8 {
          margin-right: -32px !important;
        }
      
        .v-application--is-rtl .me-sm-n8 {
          margin-left: -32px !important;
        }
      
        .v-application--is-ltr .me-sm-n9 {
          margin-right: -36px !important;
        }
      
        .v-application--is-rtl .me-sm-n9 {
          margin-left: -36px !important;
        }
      
        .v-application--is-ltr .me-sm-n10 {
          margin-right: -40px !important;
        }
      
        .v-application--is-rtl .me-sm-n10 {
          margin-left: -40px !important;
        }
      
        .v-application--is-ltr .me-sm-n11 {
          margin-right: -44px !important;
        }
      
        .v-application--is-rtl .me-sm-n11 {
          margin-left: -44px !important;
        }
      
        .v-application--is-ltr .me-sm-n12 {
          margin-right: -48px !important;
        }
      
        .v-application--is-rtl .me-sm-n12 {
          margin-left: -48px !important;
        }
      
        .v-application .pa-sm-0 {
          padding: 0px !important;
        }
      
        .v-application .pa-sm-1 {
          padding: 4px !important;
        }
      
        .v-application .pa-sm-2 {
          padding: 8px !important;
        }
      
        .v-application .pa-sm-3 {
          padding: 12px !important;
        }
      
        .v-application .pa-sm-4 {
          padding: 16px !important;
        }
      
        .v-application .pa-sm-5 {
          padding: 20px !important;
        }
      
        .v-application .pa-sm-6 {
          padding: 24px !important;
        }
      
        .v-application .pa-sm-7 {
          padding: 28px !important;
        }
      
        .v-application .pa-sm-8 {
          padding: 32px !important;
        }
      
        .v-application .pa-sm-9 {
          padding: 36px !important;
        }
      
        .v-application .pa-sm-10 {
          padding: 40px !important;
        }
      
        .v-application .pa-sm-11 {
          padding: 44px !important;
        }
      
        .v-application .pa-sm-12 {
          padding: 48px !important;
        }
      
        .v-application .px-sm-0 {
          padding-right: 0px !important;
          padding-left: 0px !important;
        }
      
        .v-application .px-sm-1 {
          padding-right: 4px !important;
          padding-left: 4px !important;
        }
      
        .v-application .px-sm-2 {
          padding-right: 8px !important;
          padding-left: 8px !important;
        }
      
        .v-application .px-sm-3 {
          padding-right: 12px !important;
          padding-left: 12px !important;
        }
      
        .v-application .px-sm-4 {
          padding-right: 16px !important;
          padding-left: 16px !important;
        }
      
        .v-application .px-sm-5 {
          padding-right: 20px !important;
          padding-left: 20px !important;
        }
      
        .v-application .px-sm-6 {
          padding-right: 24px !important;
          padding-left: 24px !important;
        }
      
        .v-application .px-sm-7 {
          padding-right: 28px !important;
          padding-left: 28px !important;
        }
      
        .v-application .px-sm-8 {
          padding-right: 32px !important;
          padding-left: 32px !important;
        }
      
        .v-application .px-sm-9 {
          padding-right: 36px !important;
          padding-left: 36px !important;
        }
      
        .v-application .px-sm-10 {
          padding-right: 40px !important;
          padding-left: 40px !important;
        }
      
        .v-application .px-sm-11 {
          padding-right: 44px !important;
          padding-left: 44px !important;
        }
      
        .v-application .px-sm-12 {
          padding-right: 48px !important;
          padding-left: 48px !important;
        }
      
        .v-application .py-sm-0 {
          padding-top: 0px !important;
          padding-bottom: 0px !important;
        }
      
        .v-application .py-sm-1 {
          padding-top: 4px !important;
          padding-bottom: 4px !important;
        }
      
        .v-application .py-sm-2 {
          padding-top: 8px !important;
          padding-bottom: 8px !important;
        }
      
        .v-application .py-sm-3 {
          padding-top: 12px !important;
          padding-bottom: 12px !important;
        }
      
        .v-application .py-sm-4 {
          padding-top: 16px !important;
          padding-bottom: 16px !important;
        }
      
        .v-application .py-sm-5 {
          padding-top: 20px !important;
          padding-bottom: 20px !important;
        }
      
        .v-application .py-sm-6 {
          padding-top: 24px !important;
          padding-bottom: 24px !important;
        }
      
        .v-application .py-sm-7 {
          padding-top: 28px !important;
          padding-bottom: 28px !important;
        }
      
        .v-application .py-sm-8 {
          padding-top: 32px !important;
          padding-bottom: 32px !important;
        }
      
        .v-application .py-sm-9 {
          padding-top: 36px !important;
          padding-bottom: 36px !important;
        }
      
        .v-application .py-sm-10 {
          padding-top: 40px !important;
          padding-bottom: 40px !important;
        }
      
        .v-application .py-sm-11 {
          padding-top: 44px !important;
          padding-bottom: 44px !important;
        }
      
        .v-application .py-sm-12 {
          padding-top: 48px !important;
          padding-bottom: 48px !important;
        }
      
        .v-application .pt-sm-0 {
          padding-top: 0px !important;
        }
      
        .v-application .pt-sm-1 {
          padding-top: 4px !important;
        }
      
        .v-application .pt-sm-2 {
          padding-top: 8px !important;
        }
      
        .v-application .pt-sm-3 {
          padding-top: 12px !important;
        }
      
        .v-application .pt-sm-4 {
          padding-top: 16px !important;
        }
      
        .v-application .pt-sm-5 {
          padding-top: 20px !important;
        }
      
        .v-application .pt-sm-6 {
          padding-top: 24px !important;
        }
      
        .v-application .pt-sm-7 {
          padding-top: 28px !important;
        }
      
        .v-application .pt-sm-8 {
          padding-top: 32px !important;
        }
      
        .v-application .pt-sm-9 {
          padding-top: 36px !important;
        }
      
        .v-application .pt-sm-10 {
          padding-top: 40px !important;
        }
      
        .v-application .pt-sm-11 {
          padding-top: 44px !important;
        }
      
        .v-application .pt-sm-12 {
          padding-top: 48px !important;
        }
      
        .v-application .pr-sm-0 {
          padding-right: 0px !important;
        }
      
        .v-application .pr-sm-1 {
          padding-right: 4px !important;
        }
      
        .v-application .pr-sm-2 {
          padding-right: 8px !important;
        }
      
        .v-application .pr-sm-3 {
          padding-right: 12px !important;
        }
      
        .v-application .pr-sm-4 {
          padding-right: 16px !important;
        }
      
        .v-application .pr-sm-5 {
          padding-right: 20px !important;
        }
      
        .v-application .pr-sm-6 {
          padding-right: 24px !important;
        }
      
        .v-application .pr-sm-7 {
          padding-right: 28px !important;
        }
      
        .v-application .pr-sm-8 {
          padding-right: 32px !important;
        }
      
        .v-application .pr-sm-9 {
          padding-right: 36px !important;
        }
      
        .v-application .pr-sm-10 {
          padding-right: 40px !important;
        }
      
        .v-application .pr-sm-11 {
          padding-right: 44px !important;
        }
      
        .v-application .pr-sm-12 {
          padding-right: 48px !important;
        }
      
        .v-application .pb-sm-0 {
          padding-bottom: 0px !important;
        }
      
        .v-application .pb-sm-1 {
          padding-bottom: 4px !important;
        }
      
        .v-application .pb-sm-2 {
          padding-bottom: 8px !important;
        }
      
        .v-application .pb-sm-3 {
          padding-bottom: 12px !important;
        }
      
        .v-application .pb-sm-4 {
          padding-bottom: 16px !important;
        }
      
        .v-application .pb-sm-5 {
          padding-bottom: 20px !important;
        }
      
        .v-application .pb-sm-6 {
          padding-bottom: 24px !important;
        }
      
        .v-application .pb-sm-7 {
          padding-bottom: 28px !important;
        }
      
        .v-application .pb-sm-8 {
          padding-bottom: 32px !important;
        }
      
        .v-application .pb-sm-9 {
          padding-bottom: 36px !important;
        }
      
        .v-application .pb-sm-10 {
          padding-bottom: 40px !important;
        }
      
        .v-application .pb-sm-11 {
          padding-bottom: 44px !important;
        }
      
        .v-application .pb-sm-12 {
          padding-bottom: 48px !important;
        }
      
        .v-application .pl-sm-0 {
          padding-left: 0px !important;
        }
      
        .v-application .pl-sm-1 {
          padding-left: 4px !important;
        }
      
        .v-application .pl-sm-2 {
          padding-left: 8px !important;
        }
      
        .v-application .pl-sm-3 {
          padding-left: 12px !important;
        }
      
        .v-application .pl-sm-4 {
          padding-left: 16px !important;
        }
      
        .v-application .pl-sm-5 {
          padding-left: 20px !important;
        }
      
        .v-application .pl-sm-6 {
          padding-left: 24px !important;
        }
      
        .v-application .pl-sm-7 {
          padding-left: 28px !important;
        }
      
        .v-application .pl-sm-8 {
          padding-left: 32px !important;
        }
      
        .v-application .pl-sm-9 {
          padding-left: 36px !important;
        }
      
        .v-application .pl-sm-10 {
          padding-left: 40px !important;
        }
      
        .v-application .pl-sm-11 {
          padding-left: 44px !important;
        }
      
        .v-application .pl-sm-12 {
          padding-left: 48px !important;
        }
      
        .v-application--is-ltr .ps-sm-0 {
          padding-left: 0px !important;
        }
      
        .v-application--is-rtl .ps-sm-0 {
          padding-right: 0px !important;
        }
      
        .v-application--is-ltr .ps-sm-1 {
          padding-left: 4px !important;
        }
      
        .v-application--is-rtl .ps-sm-1 {
          padding-right: 4px !important;
        }
      
        .v-application--is-ltr .ps-sm-2 {
          padding-left: 8px !important;
        }
      
        .v-application--is-rtl .ps-sm-2 {
          padding-right: 8px !important;
        }
      
        .v-application--is-ltr .ps-sm-3 {
          padding-left: 12px !important;
        }
      
        .v-application--is-rtl .ps-sm-3 {
          padding-right: 12px !important;
        }
      
        .v-application--is-ltr .ps-sm-4 {
          padding-left: 16px !important;
        }
      
        .v-application--is-rtl .ps-sm-4 {
          padding-right: 16px !important;
        }
      
        .v-application--is-ltr .ps-sm-5 {
          padding-left: 20px !important;
        }
      
        .v-application--is-rtl .ps-sm-5 {
          padding-right: 20px !important;
        }
      
        .v-application--is-ltr .ps-sm-6 {
          padding-left: 24px !important;
        }
      
        .v-application--is-rtl .ps-sm-6 {
          padding-right: 24px !important;
        }
      
        .v-application--is-ltr .ps-sm-7 {
          padding-left: 28px !important;
        }
      
        .v-application--is-rtl .ps-sm-7 {
          padding-right: 28px !important;
        }
      
        .v-application--is-ltr .ps-sm-8 {
          padding-left: 32px !important;
        }
      
        .v-application--is-rtl .ps-sm-8 {
          padding-right: 32px !important;
        }
      
        .v-application--is-ltr .ps-sm-9 {
          padding-left: 36px !important;
        }
      
        .v-application--is-rtl .ps-sm-9 {
          padding-right: 36px !important;
        }
      
        .v-application--is-ltr .ps-sm-10 {
          padding-left: 40px !important;
        }
      
        .v-application--is-rtl .ps-sm-10 {
          padding-right: 40px !important;
        }
      
        .v-application--is-ltr .ps-sm-11 {
          padding-left: 44px !important;
        }
      
        .v-application--is-rtl .ps-sm-11 {
          padding-right: 44px !important;
        }
      
        .v-application--is-ltr .ps-sm-12 {
          padding-left: 48px !important;
        }
      
        .v-application--is-rtl .ps-sm-12 {
          padding-right: 48px !important;
        }
      
        .v-application--is-ltr .pe-sm-0 {
          padding-right: 0px !important;
        }
      
        .v-application--is-rtl .pe-sm-0 {
          padding-left: 0px !important;
        }
      
        .v-application--is-ltr .pe-sm-1 {
          padding-right: 4px !important;
        }
      
        .v-application--is-rtl .pe-sm-1 {
          padding-left: 4px !important;
        }
      
        .v-application--is-ltr .pe-sm-2 {
          padding-right: 8px !important;
        }
      
        .v-application--is-rtl .pe-sm-2 {
          padding-left: 8px !important;
        }
      
        .v-application--is-ltr .pe-sm-3 {
          padding-right: 12px !important;
        }
      
        .v-application--is-rtl .pe-sm-3 {
          padding-left: 12px !important;
        }
      
        .v-application--is-ltr .pe-sm-4 {
          padding-right: 16px !important;
        }
      
        .v-application--is-rtl .pe-sm-4 {
          padding-left: 16px !important;
        }
      
        .v-application--is-ltr .pe-sm-5 {
          padding-right: 20px !important;
        }
      
        .v-application--is-rtl .pe-sm-5 {
          padding-left: 20px !important;
        }
      
        .v-application--is-ltr .pe-sm-6 {
          padding-right: 24px !important;
        }
      
        .v-application--is-rtl .pe-sm-6 {
          padding-left: 24px !important;
        }
      
        .v-application--is-ltr .pe-sm-7 {
          padding-right: 28px !important;
        }
      
        .v-application--is-rtl .pe-sm-7 {
          padding-left: 28px !important;
        }
      
        .v-application--is-ltr .pe-sm-8 {
          padding-right: 32px !important;
        }
      
        .v-application--is-rtl .pe-sm-8 {
          padding-left: 32px !important;
        }
      
        .v-application--is-ltr .pe-sm-9 {
          padding-right: 36px !important;
        }
      
        .v-application--is-rtl .pe-sm-9 {
          padding-left: 36px !important;
        }
      
        .v-application--is-ltr .pe-sm-10 {
          padding-right: 40px !important;
        }
      
        .v-application--is-rtl .pe-sm-10 {
          padding-left: 40px !important;
        }
      
        .v-application--is-ltr .pe-sm-11 {
          padding-right: 44px !important;
        }
      
        .v-application--is-rtl .pe-sm-11 {
          padding-left: 44px !important;
        }
      
        .v-application--is-ltr .pe-sm-12 {
          padding-right: 48px !important;
        }
      
        .v-application--is-rtl .pe-sm-12 {
          padding-left: 48px !important;
        }
      
        .v-application .text-sm-left {
          text-align: left !important;
        }
      
        .v-application .text-sm-right {
          text-align: right !important;
        }
      
        .v-application .text-sm-center {
          text-align: center !important;
        }
      
        .v-application .text-sm-justify {
          text-align: justify !important;
        }
      
        .v-application .text-sm-start {
          text-align: start !important;
        }
      
        .v-application .text-sm-end {
          text-align: end !important;
        }
      }
      @media (min-width: 960px) {
        .v-application .d-md-none {
          display: none !important;
        }
      
        .v-application .d-md-inline {
          display: inline !important;
        }
      
        .v-application .d-md-inline-block {
          display: inline-block !important;
        }
      
        .v-application .d-md-block {
          display: block !important;
        }
      
        .v-application .d-md-table {
          display: table !important;
        }
      
        .v-application .d-md-table-row {
          display: table-row !important;
        }
      
        .v-application .d-md-table-cell {
          display: table-cell !important;
        }
      
        .v-application .d-md-flex {
          display: -webkit-box !important;
          display: -ms-flexbox !important;
          display: flex !important;
        }
      
        .v-application .d-md-inline-flex {
          display: -webkit-inline-box !important;
          display: -ms-inline-flexbox !important;
          display: inline-flex !important;
        }
      
        .v-application .float-md-none {
          float: none !important;
        }
      
        .v-application .float-md-left {
          float: left !important;
        }
      
        .v-application .float-md-right {
          float: right !important;
        }
      
        .v-application .flex-md-fill {
          -webkit-box-flex: 1 !important;
              -ms-flex: 1 1 auto !important;
                  flex: 1 1 auto !important;
        }
      
        .v-application .flex-md-row {
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: normal !important;
              -ms-flex-direction: row !important;
                  flex-direction: row !important;
        }
      
        .v-application .flex-md-column {
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: normal !important;
              -ms-flex-direction: column !important;
                  flex-direction: column !important;
        }
      
        .v-application .flex-md-row-reverse {
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: reverse !important;
              -ms-flex-direction: row-reverse !important;
                  flex-direction: row-reverse !important;
        }
      
        .v-application .flex-md-column-reverse {
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: reverse !important;
              -ms-flex-direction: column-reverse !important;
                  flex-direction: column-reverse !important;
        }
      
        .v-application .flex-md-grow-0 {
          -webkit-box-flex: 0 !important;
              -ms-flex-positive: 0 !important;
                  flex-grow: 0 !important;
        }
      
        .v-application .flex-md-grow-1 {
          -webkit-box-flex: 1 !important;
              -ms-flex-positive: 1 !important;
                  flex-grow: 1 !important;
        }
      
        .v-application .flex-md-shrink-0 {
          -ms-flex-negative: 0 !important;
              flex-shrink: 0 !important;
        }
      
        .v-application .flex-md-shrink-1 {
          -ms-flex-negative: 1 !important;
              flex-shrink: 1 !important;
        }
      
        .v-application .flex-md-wrap {
          -ms-flex-wrap: wrap !important;
              flex-wrap: wrap !important;
        }
      
        .v-application .flex-md-nowrap {
          -ms-flex-wrap: nowrap !important;
              flex-wrap: nowrap !important;
        }
      
        .v-application .flex-md-wrap-reverse {
          -ms-flex-wrap: wrap-reverse !important;
              flex-wrap: wrap-reverse !important;
        }
      
        .v-application .justify-md-start {
          -webkit-box-pack: start !important;
              -ms-flex-pack: start !important;
                  justify-content: flex-start !important;
        }
      
        .v-application .justify-md-end {
          -webkit-box-pack: end !important;
              -ms-flex-pack: end !important;
                  justify-content: flex-end !important;
        }
      
        .v-application .justify-md-center {
          -webkit-box-pack: center !important;
              -ms-flex-pack: center !important;
                  justify-content: center !important;
        }
      
        .v-application .justify-md-space-between {
          -webkit-box-pack: justify !important;
              -ms-flex-pack: justify !important;
                  justify-content: space-between !important;
        }
      
        .v-application .justify-md-space-around {
          -ms-flex-pack: distribute !important;
              justify-content: space-around !important;
        }
      
        .v-application .align-md-start {
          -webkit-box-align: start !important;
              -ms-flex-align: start !important;
                  align-items: flex-start !important;
        }
      
        .v-application .align-md-end {
          -webkit-box-align: end !important;
              -ms-flex-align: end !important;
                  align-items: flex-end !important;
        }
      
        .v-application .align-md-center {
          -webkit-box-align: center !important;
              -ms-flex-align: center !important;
                  align-items: center !important;
        }
      
        .v-application .align-md-baseline {
          -webkit-box-align: baseline !important;
              -ms-flex-align: baseline !important;
                  align-items: baseline !important;
        }
      
        .v-application .align-md-stretch {
          -webkit-box-align: stretch !important;
              -ms-flex-align: stretch !important;
                  align-items: stretch !important;
        }
      
        .v-application .align-content-md-start {
          -ms-flex-line-pack: start !important;
              align-content: flex-start !important;
        }
      
        .v-application .align-content-md-end {
          -ms-flex-line-pack: end !important;
              align-content: flex-end !important;
        }
      
        .v-application .align-content-md-center {
          -ms-flex-line-pack: center !important;
              align-content: center !important;
        }
      
        .v-application .align-content-md-space-between {
          -ms-flex-line-pack: justify !important;
              align-content: space-between !important;
        }
      
        .v-application .align-content-md-space-around {
          -ms-flex-line-pack: distribute !important;
              align-content: space-around !important;
        }
      
        .v-application .align-content-md-stretch {
          -ms-flex-line-pack: stretch !important;
              align-content: stretch !important;
        }
      
        .v-application .align-self-md-auto {
          -ms-flex-item-align: auto !important;
              align-self: auto !important;
        }
      
        .v-application .align-self-md-start {
          -ms-flex-item-align: start !important;
              align-self: flex-start !important;
        }
      
        .v-application .align-self-md-end {
          -ms-flex-item-align: end !important;
              align-self: flex-end !important;
        }
      
        .v-application .align-self-md-center {
          -ms-flex-item-align: center !important;
              align-self: center !important;
        }
      
        .v-application .align-self-md-baseline {
          -ms-flex-item-align: baseline !important;
              align-self: baseline !important;
        }
      
        .v-application .align-self-md-stretch {
          -ms-flex-item-align: stretch !important;
              align-self: stretch !important;
        }
      
        .v-application .order-md-first {
          -webkit-box-ordinal-group: 0 !important;
              -ms-flex-order: -1 !important;
                  order: -1 !important;
        }
      
        .v-application .order-md-0 {
          -webkit-box-ordinal-group: 1 !important;
              -ms-flex-order: 0 !important;
                  order: 0 !important;
        }
      
        .v-application .order-md-1 {
          -webkit-box-ordinal-group: 2 !important;
              -ms-flex-order: 1 !important;
                  order: 1 !important;
        }
      
        .v-application .order-md-2 {
          -webkit-box-ordinal-group: 3 !important;
              -ms-flex-order: 2 !important;
                  order: 2 !important;
        }
      
        .v-application .order-md-3 {
          -webkit-box-ordinal-group: 4 !important;
              -ms-flex-order: 3 !important;
                  order: 3 !important;
        }
      
        .v-application .order-md-4 {
          -webkit-box-ordinal-group: 5 !important;
              -ms-flex-order: 4 !important;
                  order: 4 !important;
        }
      
        .v-application .order-md-5 {
          -webkit-box-ordinal-group: 6 !important;
              -ms-flex-order: 5 !important;
                  order: 5 !important;
        }
      
        .v-application .order-md-6 {
          -webkit-box-ordinal-group: 7 !important;
              -ms-flex-order: 6 !important;
                  order: 6 !important;
        }
      
        .v-application .order-md-7 {
          -webkit-box-ordinal-group: 8 !important;
              -ms-flex-order: 7 !important;
                  order: 7 !important;
        }
      
        .v-application .order-md-8 {
          -webkit-box-ordinal-group: 9 !important;
              -ms-flex-order: 8 !important;
                  order: 8 !important;
        }
      
        .v-application .order-md-9 {
          -webkit-box-ordinal-group: 10 !important;
              -ms-flex-order: 9 !important;
                  order: 9 !important;
        }
      
        .v-application .order-md-10 {
          -webkit-box-ordinal-group: 11 !important;
              -ms-flex-order: 10 !important;
                  order: 10 !important;
        }
      
        .v-application .order-md-11 {
          -webkit-box-ordinal-group: 12 !important;
              -ms-flex-order: 11 !important;
                  order: 11 !important;
        }
      
        .v-application .order-md-12 {
          -webkit-box-ordinal-group: 13 !important;
              -ms-flex-order: 12 !important;
                  order: 12 !important;
        }
      
        .v-application .order-md-last {
          -webkit-box-ordinal-group: 14 !important;
              -ms-flex-order: 13 !important;
                  order: 13 !important;
        }
      
        .v-application .ma-md-0 {
          margin: 0px !important;
        }
      
        .v-application .ma-md-1 {
          margin: 4px !important;
        }
      
        .v-application .ma-md-2 {
          margin: 8px !important;
        }
      
        .v-application .ma-md-3 {
          margin: 12px !important;
        }
      
        .v-application .ma-md-4 {
          margin: 16px !important;
        }
      
        .v-application .ma-md-5 {
          margin: 20px !important;
        }
      
        .v-application .ma-md-6 {
          margin: 24px !important;
        }
      
        .v-application .ma-md-7 {
          margin: 28px !important;
        }
      
        .v-application .ma-md-8 {
          margin: 32px !important;
        }
      
        .v-application .ma-md-9 {
          margin: 36px !important;
        }
      
        .v-application .ma-md-10 {
          margin: 40px !important;
        }
      
        .v-application .ma-md-11 {
          margin: 44px !important;
        }
      
        .v-application .ma-md-12 {
          margin: 48px !important;
        }
      
        .v-application .ma-md-auto {
          margin: auto !important;
        }
      
        .v-application .mx-md-0 {
          margin-right: 0px !important;
          margin-left: 0px !important;
        }
      
        .v-application .mx-md-1 {
          margin-right: 4px !important;
          margin-left: 4px !important;
        }
      
        .v-application .mx-md-2 {
          margin-right: 8px !important;
          margin-left: 8px !important;
        }
      
        .v-application .mx-md-3 {
          margin-right: 12px !important;
          margin-left: 12px !important;
        }
      
        .v-application .mx-md-4 {
          margin-right: 16px !important;
          margin-left: 16px !important;
        }
      
        .v-application .mx-md-5 {
          margin-right: 20px !important;
          margin-left: 20px !important;
        }
      
        .v-application .mx-md-6 {
          margin-right: 24px !important;
          margin-left: 24px !important;
        }
      
        .v-application .mx-md-7 {
          margin-right: 28px !important;
          margin-left: 28px !important;
        }
      
        .v-application .mx-md-8 {
          margin-right: 32px !important;
          margin-left: 32px !important;
        }
      
        .v-application .mx-md-9 {
          margin-right: 36px !important;
          margin-left: 36px !important;
        }
      
        .v-application .mx-md-10 {
          margin-right: 40px !important;
          margin-left: 40px !important;
        }
      
        .v-application .mx-md-11 {
          margin-right: 44px !important;
          margin-left: 44px !important;
        }
      
        .v-application .mx-md-12 {
          margin-right: 48px !important;
          margin-left: 48px !important;
        }
      
        .v-application .mx-md-auto {
          margin-right: auto !important;
          margin-left: auto !important;
        }
      
        .v-application .my-md-0 {
          margin-top: 0px !important;
          margin-bottom: 0px !important;
        }
      
        .v-application .my-md-1 {
          margin-top: 4px !important;
          margin-bottom: 4px !important;
        }
      
        .v-application .my-md-2 {
          margin-top: 8px !important;
          margin-bottom: 8px !important;
        }
      
        .v-application .my-md-3 {
          margin-top: 12px !important;
          margin-bottom: 12px !important;
        }
      
        .v-application .my-md-4 {
          margin-top: 16px !important;
          margin-bottom: 16px !important;
        }
      
        .v-application .my-md-5 {
          margin-top: 20px !important;
          margin-bottom: 20px !important;
        }
      
        .v-application .my-md-6 {
          margin-top: 24px !important;
          margin-bottom: 24px !important;
        }
      
        .v-application .my-md-7 {
          margin-top: 28px !important;
          margin-bottom: 28px !important;
        }
      
        .v-application .my-md-8 {
          margin-top: 32px !important;
          margin-bottom: 32px !important;
        }
      
        .v-application .my-md-9 {
          margin-top: 36px !important;
          margin-bottom: 36px !important;
        }
      
        .v-application .my-md-10 {
          margin-top: 40px !important;
          margin-bottom: 40px !important;
        }
      
        .v-application .my-md-11 {
          margin-top: 44px !important;
          margin-bottom: 44px !important;
        }
      
        .v-application .my-md-12 {
          margin-top: 48px !important;
          margin-bottom: 48px !important;
        }
      
        .v-application .my-md-auto {
          margin-top: auto !important;
          margin-bottom: auto !important;
        }
      
        .v-application .mt-md-0 {
          margin-top: 0px !important;
        }
      
        .v-application .mt-md-1 {
          margin-top: 4px !important;
        }
      
        .v-application .mt-md-2 {
          margin-top: 8px !important;
        }
      
        .v-application .mt-md-3 {
          margin-top: 12px !important;
        }
      
        .v-application .mt-md-4 {
          margin-top: 16px !important;
        }
      
        .v-application .mt-md-5 {
          margin-top: 20px !important;
        }
      
        .v-application .mt-md-6 {
          margin-top: 24px !important;
        }
      
        .v-application .mt-md-7 {
          margin-top: 28px !important;
        }
      
        .v-application .mt-md-8 {
          margin-top: 32px !important;
        }
      
        .v-application .mt-md-9 {
          margin-top: 36px !important;
        }
      
        .v-application .mt-md-10 {
          margin-top: 40px !important;
        }
      
        .v-application .mt-md-11 {
          margin-top: 44px !important;
        }
      
        .v-application .mt-md-12 {
          margin-top: 48px !important;
        }
      
        .v-application .mt-md-auto {
          margin-top: auto !important;
        }
      
        .v-application .mr-md-0 {
          margin-right: 0px !important;
        }
      
        .v-application .mr-md-1 {
          margin-right: 4px !important;
        }
      
        .v-application .mr-md-2 {
          margin-right: 8px !important;
        }
      
        .v-application .mr-md-3 {
          margin-right: 12px !important;
        }
      
        .v-application .mr-md-4 {
          margin-right: 16px !important;
        }
      
        .v-application .mr-md-5 {
          margin-right: 20px !important;
        }
      
        .v-application .mr-md-6 {
          margin-right: 24px !important;
        }
      
        .v-application .mr-md-7 {
          margin-right: 28px !important;
        }
      
        .v-application .mr-md-8 {
          margin-right: 32px !important;
        }
      
        .v-application .mr-md-9 {
          margin-right: 36px !important;
        }
      
        .v-application .mr-md-10 {
          margin-right: 40px !important;
        }
      
        .v-application .mr-md-11 {
          margin-right: 44px !important;
        }
      
        .v-application .mr-md-12 {
          margin-right: 48px !important;
        }
      
        .v-application .mr-md-auto {
          margin-right: auto !important;
        }
      
        .v-application .mb-md-0 {
          margin-bottom: 0px !important;
        }
      
        .v-application .mb-md-1 {
          margin-bottom: 4px !important;
        }
      
        .v-application .mb-md-2 {
          margin-bottom: 8px !important;
        }
      
        .v-application .mb-md-3 {
          margin-bottom: 12px !important;
        }
      
        .v-application .mb-md-4 {
          margin-bottom: 16px !important;
        }
      
        .v-application .mb-md-5 {
          margin-bottom: 20px !important;
        }
      
        .v-application .mb-md-6 {
          margin-bottom: 24px !important;
        }
      
        .v-application .mb-md-7 {
          margin-bottom: 28px !important;
        }
      
        .v-application .mb-md-8 {
          margin-bottom: 32px !important;
        }
      
        .v-application .mb-md-9 {
          margin-bottom: 36px !important;
        }
      
        .v-application .mb-md-10 {
          margin-bottom: 40px !important;
        }
      
        .v-application .mb-md-11 {
          margin-bottom: 44px !important;
        }
      
        .v-application .mb-md-12 {
          margin-bottom: 48px !important;
        }
      
        .v-application .mb-md-auto {
          margin-bottom: auto !important;
        }
      
        .v-application .ml-md-0 {
          margin-left: 0px !important;
        }
      
        .v-application .ml-md-1 {
          margin-left: 4px !important;
        }
      
        .v-application .ml-md-2 {
          margin-left: 8px !important;
        }
      
        .v-application .ml-md-3 {
          margin-left: 12px !important;
        }
      
        .v-application .ml-md-4 {
          margin-left: 16px !important;
        }
      
        .v-application .ml-md-5 {
          margin-left: 20px !important;
        }
      
        .v-application .ml-md-6 {
          margin-left: 24px !important;
        }
      
        .v-application .ml-md-7 {
          margin-left: 28px !important;
        }
      
        .v-application .ml-md-8 {
          margin-left: 32px !important;
        }
      
        .v-application .ml-md-9 {
          margin-left: 36px !important;
        }
      
        .v-application .ml-md-10 {
          margin-left: 40px !important;
        }
      
        .v-application .ml-md-11 {
          margin-left: 44px !important;
        }
      
        .v-application .ml-md-12 {
          margin-left: 48px !important;
        }
      
        .v-application .ml-md-auto {
          margin-left: auto !important;
        }
      
        .v-application--is-ltr .ms-md-0 {
          margin-left: 0px !important;
        }
      
        .v-application--is-rtl .ms-md-0 {
          margin-right: 0px !important;
        }
      
        .v-application--is-ltr .ms-md-1 {
          margin-left: 4px !important;
        }
      
        .v-application--is-rtl .ms-md-1 {
          margin-right: 4px !important;
        }
      
        .v-application--is-ltr .ms-md-2 {
          margin-left: 8px !important;
        }
      
        .v-application--is-rtl .ms-md-2 {
          margin-right: 8px !important;
        }
      
        .v-application--is-ltr .ms-md-3 {
          margin-left: 12px !important;
        }
      
        .v-application--is-rtl .ms-md-3 {
          margin-right: 12px !important;
        }
      
        .v-application--is-ltr .ms-md-4 {
          margin-left: 16px !important;
        }
      
        .v-application--is-rtl .ms-md-4 {
          margin-right: 16px !important;
        }
      
        .v-application--is-ltr .ms-md-5 {
          margin-left: 20px !important;
        }
      
        .v-application--is-rtl .ms-md-5 {
          margin-right: 20px !important;
        }
      
        .v-application--is-ltr .ms-md-6 {
          margin-left: 24px !important;
        }
      
        .v-application--is-rtl .ms-md-6 {
          margin-right: 24px !important;
        }
      
        .v-application--is-ltr .ms-md-7 {
          margin-left: 28px !important;
        }
      
        .v-application--is-rtl .ms-md-7 {
          margin-right: 28px !important;
        }
      
        .v-application--is-ltr .ms-md-8 {
          margin-left: 32px !important;
        }
      
        .v-application--is-rtl .ms-md-8 {
          margin-right: 32px !important;
        }
      
        .v-application--is-ltr .ms-md-9 {
          margin-left: 36px !important;
        }
      
        .v-application--is-rtl .ms-md-9 {
          margin-right: 36px !important;
        }
      
        .v-application--is-ltr .ms-md-10 {
          margin-left: 40px !important;
        }
      
        .v-application--is-rtl .ms-md-10 {
          margin-right: 40px !important;
        }
      
        .v-application--is-ltr .ms-md-11 {
          margin-left: 44px !important;
        }
      
        .v-application--is-rtl .ms-md-11 {
          margin-right: 44px !important;
        }
      
        .v-application--is-ltr .ms-md-12 {
          margin-left: 48px !important;
        }
      
        .v-application--is-rtl .ms-md-12 {
          margin-right: 48px !important;
        }
      
        .v-application--is-ltr .ms-md-auto {
          margin-left: auto !important;
        }
      
        .v-application--is-rtl .ms-md-auto {
          margin-right: auto !important;
        }
      
        .v-application--is-ltr .me-md-0 {
          margin-right: 0px !important;
        }
      
        .v-application--is-rtl .me-md-0 {
          margin-left: 0px !important;
        }
      
        .v-application--is-ltr .me-md-1 {
          margin-right: 4px !important;
        }
      
        .v-application--is-rtl .me-md-1 {
          margin-left: 4px !important;
        }
      
        .v-application--is-ltr .me-md-2 {
          margin-right: 8px !important;
        }
      
        .v-application--is-rtl .me-md-2 {
          margin-left: 8px !important;
        }
      
        .v-application--is-ltr .me-md-3 {
          margin-right: 12px !important;
        }
      
        .v-application--is-rtl .me-md-3 {
          margin-left: 12px !important;
        }
      
        .v-application--is-ltr .me-md-4 {
          margin-right: 16px !important;
        }
      
        .v-application--is-rtl .me-md-4 {
          margin-left: 16px !important;
        }
      
        .v-application--is-ltr .me-md-5 {
          margin-right: 20px !important;
        }
      
        .v-application--is-rtl .me-md-5 {
          margin-left: 20px !important;
        }
      
        .v-application--is-ltr .me-md-6 {
          margin-right: 24px !important;
        }
      
        .v-application--is-rtl .me-md-6 {
          margin-left: 24px !important;
        }
      
        .v-application--is-ltr .me-md-7 {
          margin-right: 28px !important;
        }
      
        .v-application--is-rtl .me-md-7 {
          margin-left: 28px !important;
        }
      
        .v-application--is-ltr .me-md-8 {
          margin-right: 32px !important;
        }
      
        .v-application--is-rtl .me-md-8 {
          margin-left: 32px !important;
        }
      
        .v-application--is-ltr .me-md-9 {
          margin-right: 36px !important;
        }
      
        .v-application--is-rtl .me-md-9 {
          margin-left: 36px !important;
        }
      
        .v-application--is-ltr .me-md-10 {
          margin-right: 40px !important;
        }
      
        .v-application--is-rtl .me-md-10 {
          margin-left: 40px !important;
        }
      
        .v-application--is-ltr .me-md-11 {
          margin-right: 44px !important;
        }
      
        .v-application--is-rtl .me-md-11 {
          margin-left: 44px !important;
        }
      
        .v-application--is-ltr .me-md-12 {
          margin-right: 48px !important;
        }
      
        .v-application--is-rtl .me-md-12 {
          margin-left: 48px !important;
        }
      
        .v-application--is-ltr .me-md-auto {
          margin-right: auto !important;
        }
      
        .v-application--is-rtl .me-md-auto {
          margin-left: auto !important;
        }
      
        .v-application .ma-md-n1 {
          margin: -4px !important;
        }
      
        .v-application .ma-md-n2 {
          margin: -8px !important;
        }
      
        .v-application .ma-md-n3 {
          margin: -12px !important;
        }
      
        .v-application .ma-md-n4 {
          margin: -16px !important;
        }
      
        .v-application .ma-md-n5 {
          margin: -20px !important;
        }
      
        .v-application .ma-md-n6 {
          margin: -24px !important;
        }
      
        .v-application .ma-md-n7 {
          margin: -28px !important;
        }
      
        .v-application .ma-md-n8 {
          margin: -32px !important;
        }
      
        .v-application .ma-md-n9 {
          margin: -36px !important;
        }
      
        .v-application .ma-md-n10 {
          margin: -40px !important;
        }
      
        .v-application .ma-md-n11 {
          margin: -44px !important;
        }
      
        .v-application .ma-md-n12 {
          margin: -48px !important;
        }
      
        .v-application .mx-md-n1 {
          margin-right: -4px !important;
          margin-left: -4px !important;
        }
      
        .v-application .mx-md-n2 {
          margin-right: -8px !important;
          margin-left: -8px !important;
        }
      
        .v-application .mx-md-n3 {
          margin-right: -12px !important;
          margin-left: -12px !important;
        }
      
        .v-application .mx-md-n4 {
          margin-right: -16px !important;
          margin-left: -16px !important;
        }
      
        .v-application .mx-md-n5 {
          margin-right: -20px !important;
          margin-left: -20px !important;
        }
      
        .v-application .mx-md-n6 {
          margin-right: -24px !important;
          margin-left: -24px !important;
        }
      
        .v-application .mx-md-n7 {
          margin-right: -28px !important;
          margin-left: -28px !important;
        }
      
        .v-application .mx-md-n8 {
          margin-right: -32px !important;
          margin-left: -32px !important;
        }
      
        .v-application .mx-md-n9 {
          margin-right: -36px !important;
          margin-left: -36px !important;
        }
      
        .v-application .mx-md-n10 {
          margin-right: -40px !important;
          margin-left: -40px !important;
        }
      
        .v-application .mx-md-n11 {
          margin-right: -44px !important;
          margin-left: -44px !important;
        }
      
        .v-application .mx-md-n12 {
          margin-right: -48px !important;
          margin-left: -48px !important;
        }
      
        .v-application .my-md-n1 {
          margin-top: -4px !important;
          margin-bottom: -4px !important;
        }
      
        .v-application .my-md-n2 {
          margin-top: -8px !important;
          margin-bottom: -8px !important;
        }
      
        .v-application .my-md-n3 {
          margin-top: -12px !important;
          margin-bottom: -12px !important;
        }
      
        .v-application .my-md-n4 {
          margin-top: -16px !important;
          margin-bottom: -16px !important;
        }
      
        .v-application .my-md-n5 {
          margin-top: -20px !important;
          margin-bottom: -20px !important;
        }
      
        .v-application .my-md-n6 {
          margin-top: -24px !important;
          margin-bottom: -24px !important;
        }
      
        .v-application .my-md-n7 {
          margin-top: -28px !important;
          margin-bottom: -28px !important;
        }
      
        .v-application .my-md-n8 {
          margin-top: -32px !important;
          margin-bottom: -32px !important;
        }
      
        .v-application .my-md-n9 {
          margin-top: -36px !important;
          margin-bottom: -36px !important;
        }
      
        .v-application .my-md-n10 {
          margin-top: -40px !important;
          margin-bottom: -40px !important;
        }
      
        .v-application .my-md-n11 {
          margin-top: -44px !important;
          margin-bottom: -44px !important;
        }
      
        .v-application .my-md-n12 {
          margin-top: -48px !important;
          margin-bottom: -48px !important;
        }
      
        .v-application .mt-md-n1 {
          margin-top: -4px !important;
        }
      
        .v-application .mt-md-n2 {
          margin-top: -8px !important;
        }
      
        .v-application .mt-md-n3 {
          margin-top: -12px !important;
        }
      
        .v-application .mt-md-n4 {
          margin-top: -16px !important;
        }
      
        .v-application .mt-md-n5 {
          margin-top: -20px !important;
        }
      
        .v-application .mt-md-n6 {
          margin-top: -24px !important;
        }
      
        .v-application .mt-md-n7 {
          margin-top: -28px !important;
        }
      
        .v-application .mt-md-n8 {
          margin-top: -32px !important;
        }
      
        .v-application .mt-md-n9 {
          margin-top: -36px !important;
        }
      
        .v-application .mt-md-n10 {
          margin-top: -40px !important;
        }
      
        .v-application .mt-md-n11 {
          margin-top: -44px !important;
        }
      
        .v-application .mt-md-n12 {
          margin-top: -48px !important;
        }
      
        .v-application .mr-md-n1 {
          margin-right: -4px !important;
        }
      
        .v-application .mr-md-n2 {
          margin-right: -8px !important;
        }
      
        .v-application .mr-md-n3 {
          margin-right: -12px !important;
        }
      
        .v-application .mr-md-n4 {
          margin-right: -16px !important;
        }
      
        .v-application .mr-md-n5 {
          margin-right: -20px !important;
        }
      
        .v-application .mr-md-n6 {
          margin-right: -24px !important;
        }
      
        .v-application .mr-md-n7 {
          margin-right: -28px !important;
        }
      
        .v-application .mr-md-n8 {
          margin-right: -32px !important;
        }
      
        .v-application .mr-md-n9 {
          margin-right: -36px !important;
        }
      
        .v-application .mr-md-n10 {
          margin-right: -40px !important;
        }
      
        .v-application .mr-md-n11 {
          margin-right: -44px !important;
        }
      
        .v-application .mr-md-n12 {
          margin-right: -48px !important;
        }
      
        .v-application .mb-md-n1 {
          margin-bottom: -4px !important;
        }
      
        .v-application .mb-md-n2 {
          margin-bottom: -8px !important;
        }
      
        .v-application .mb-md-n3 {
          margin-bottom: -12px !important;
        }
      
        .v-application .mb-md-n4 {
          margin-bottom: -16px !important;
        }
      
        .v-application .mb-md-n5 {
          margin-bottom: -20px !important;
        }
      
        .v-application .mb-md-n6 {
          margin-bottom: -24px !important;
        }
      
        .v-application .mb-md-n7 {
          margin-bottom: -28px !important;
        }
      
        .v-application .mb-md-n8 {
          margin-bottom: -32px !important;
        }
      
        .v-application .mb-md-n9 {
          margin-bottom: -36px !important;
        }
      
        .v-application .mb-md-n10 {
          margin-bottom: -40px !important;
        }
      
        .v-application .mb-md-n11 {
          margin-bottom: -44px !important;
        }
      
        .v-application .mb-md-n12 {
          margin-bottom: -48px !important;
        }
      
        .v-application .ml-md-n1 {
          margin-left: -4px !important;
        }
      
        .v-application .ml-md-n2 {
          margin-left: -8px !important;
        }
      
        .v-application .ml-md-n3 {
          margin-left: -12px !important;
        }
      
        .v-application .ml-md-n4 {
          margin-left: -16px !important;
        }
      
        .v-application .ml-md-n5 {
          margin-left: -20px !important;
        }
      
        .v-application .ml-md-n6 {
          margin-left: -24px !important;
        }
      
        .v-application .ml-md-n7 {
          margin-left: -28px !important;
        }
      
        .v-application .ml-md-n8 {
          margin-left: -32px !important;
        }
      
        .v-application .ml-md-n9 {
          margin-left: -36px !important;
        }
      
        .v-application .ml-md-n10 {
          margin-left: -40px !important;
        }
      
        .v-application .ml-md-n11 {
          margin-left: -44px !important;
        }
      
        .v-application .ml-md-n12 {
          margin-left: -48px !important;
        }
      
        .v-application--is-ltr .ms-md-n1 {
          margin-left: -4px !important;
        }
      
        .v-application--is-rtl .ms-md-n1 {
          margin-right: -4px !important;
        }
      
        .v-application--is-ltr .ms-md-n2 {
          margin-left: -8px !important;
        }
      
        .v-application--is-rtl .ms-md-n2 {
          margin-right: -8px !important;
        }
      
        .v-application--is-ltr .ms-md-n3 {
          margin-left: -12px !important;
        }
      
        .v-application--is-rtl .ms-md-n3 {
          margin-right: -12px !important;
        }
      
        .v-application--is-ltr .ms-md-n4 {
          margin-left: -16px !important;
        }
      
        .v-application--is-rtl .ms-md-n4 {
          margin-right: -16px !important;
        }
      
        .v-application--is-ltr .ms-md-n5 {
          margin-left: -20px !important;
        }
      
        .v-application--is-rtl .ms-md-n5 {
          margin-right: -20px !important;
        }
      
        .v-application--is-ltr .ms-md-n6 {
          margin-left: -24px !important;
        }
      
        .v-application--is-rtl .ms-md-n6 {
          margin-right: -24px !important;
        }
      
        .v-application--is-ltr .ms-md-n7 {
          margin-left: -28px !important;
        }
      
        .v-application--is-rtl .ms-md-n7 {
          margin-right: -28px !important;
        }
      
        .v-application--is-ltr .ms-md-n8 {
          margin-left: -32px !important;
        }
      
        .v-application--is-rtl .ms-md-n8 {
          margin-right: -32px !important;
        }
      
        .v-application--is-ltr .ms-md-n9 {
          margin-left: -36px !important;
        }
      
        .v-application--is-rtl .ms-md-n9 {
          margin-right: -36px !important;
        }
      
        .v-application--is-ltr .ms-md-n10 {
          margin-left: -40px !important;
        }
      
        .v-application--is-rtl .ms-md-n10 {
          margin-right: -40px !important;
        }
      
        .v-application--is-ltr .ms-md-n11 {
          margin-left: -44px !important;
        }
      
        .v-application--is-rtl .ms-md-n11 {
          margin-right: -44px !important;
        }
      
        .v-application--is-ltr .ms-md-n12 {
          margin-left: -48px !important;
        }
      
        .v-application--is-rtl .ms-md-n12 {
          margin-right: -48px !important;
        }
      
        .v-application--is-ltr .me-md-n1 {
          margin-right: -4px !important;
        }
      
        .v-application--is-rtl .me-md-n1 {
          margin-left: -4px !important;
        }
      
        .v-application--is-ltr .me-md-n2 {
          margin-right: -8px !important;
        }
      
        .v-application--is-rtl .me-md-n2 {
          margin-left: -8px !important;
        }
      
        .v-application--is-ltr .me-md-n3 {
          margin-right: -12px !important;
        }
      
        .v-application--is-rtl .me-md-n3 {
          margin-left: -12px !important;
        }
      
        .v-application--is-ltr .me-md-n4 {
          margin-right: -16px !important;
        }
      
        .v-application--is-rtl .me-md-n4 {
          margin-left: -16px !important;
        }
      
        .v-application--is-ltr .me-md-n5 {
          margin-right: -20px !important;
        }
      
        .v-application--is-rtl .me-md-n5 {
          margin-left: -20px !important;
        }
      
        .v-application--is-ltr .me-md-n6 {
          margin-right: -24px !important;
        }
      
        .v-application--is-rtl .me-md-n6 {
          margin-left: -24px !important;
        }
      
        .v-application--is-ltr .me-md-n7 {
          margin-right: -28px !important;
        }
      
        .v-application--is-rtl .me-md-n7 {
          margin-left: -28px !important;
        }
      
        .v-application--is-ltr .me-md-n8 {
          margin-right: -32px !important;
        }
      
        .v-application--is-rtl .me-md-n8 {
          margin-left: -32px !important;
        }
      
        .v-application--is-ltr .me-md-n9 {
          margin-right: -36px !important;
        }
      
        .v-application--is-rtl .me-md-n9 {
          margin-left: -36px !important;
        }
      
        .v-application--is-ltr .me-md-n10 {
          margin-right: -40px !important;
        }
      
        .v-application--is-rtl .me-md-n10 {
          margin-left: -40px !important;
        }
      
        .v-application--is-ltr .me-md-n11 {
          margin-right: -44px !important;
        }
      
        .v-application--is-rtl .me-md-n11 {
          margin-left: -44px !important;
        }
      
        .v-application--is-ltr .me-md-n12 {
          margin-right: -48px !important;
        }
      
        .v-application--is-rtl .me-md-n12 {
          margin-left: -48px !important;
        }
      
        .v-application .pa-md-0 {
          padding: 0px !important;
        }
      
        .v-application .pa-md-1 {
          padding: 4px !important;
        }
      
        .v-application .pa-md-2 {
          padding: 8px !important;
        }
      
        .v-application .pa-md-3 {
          padding: 12px !important;
        }
      
        .v-application .pa-md-4 {
          padding: 16px !important;
        }
      
        .v-application .pa-md-5 {
          padding: 20px !important;
        }
      
        .v-application .pa-md-6 {
          padding: 24px !important;
        }
      
        .v-application .pa-md-7 {
          padding: 28px !important;
        }
      
        .v-application .pa-md-8 {
          padding: 32px !important;
        }
      
        .v-application .pa-md-9 {
          padding: 36px !important;
        }
      
        .v-application .pa-md-10 {
          padding: 40px !important;
        }
      
        .v-application .pa-md-11 {
          padding: 44px !important;
        }
      
        .v-application .pa-md-12 {
          padding: 48px !important;
        }
      
        .v-application .px-md-0 {
          padding-right: 0px !important;
          padding-left: 0px !important;
        }
      
        .v-application .px-md-1 {
          padding-right: 4px !important;
          padding-left: 4px !important;
        }
      
        .v-application .px-md-2 {
          padding-right: 8px !important;
          padding-left: 8px !important;
        }
      
        .v-application .px-md-3 {
          padding-right: 12px !important;
          padding-left: 12px !important;
        }
      
        .v-application .px-md-4 {
          padding-right: 16px !important;
          padding-left: 16px !important;
        }
      
        .v-application .px-md-5 {
          padding-right: 20px !important;
          padding-left: 20px !important;
        }
      
        .v-application .px-md-6 {
          padding-right: 24px !important;
          padding-left: 24px !important;
        }
      
        .v-application .px-md-7 {
          padding-right: 28px !important;
          padding-left: 28px !important;
        }
      
        .v-application .px-md-8 {
          padding-right: 32px !important;
          padding-left: 32px !important;
        }
      
        .v-application .px-md-9 {
          padding-right: 36px !important;
          padding-left: 36px !important;
        }
      
        .v-application .px-md-10 {
          padding-right: 40px !important;
          padding-left: 40px !important;
        }
      
        .v-application .px-md-11 {
          padding-right: 44px !important;
          padding-left: 44px !important;
        }
      
        .v-application .px-md-12 {
          padding-right: 48px !important;
          padding-left: 48px !important;
        }
      
        .v-application .py-md-0 {
          padding-top: 0px !important;
          padding-bottom: 0px !important;
        }
      
        .v-application .py-md-1 {
          padding-top: 4px !important;
          padding-bottom: 4px !important;
        }
      
        .v-application .py-md-2 {
          padding-top: 8px !important;
          padding-bottom: 8px !important;
        }
      
        .v-application .py-md-3 {
          padding-top: 12px !important;
          padding-bottom: 12px !important;
        }
      
        .v-application .py-md-4 {
          padding-top: 16px !important;
          padding-bottom: 16px !important;
        }
      
        .v-application .py-md-5 {
          padding-top: 20px !important;
          padding-bottom: 20px !important;
        }
      
        .v-application .py-md-6 {
          padding-top: 24px !important;
          padding-bottom: 24px !important;
        }
      
        .v-application .py-md-7 {
          padding-top: 28px !important;
          padding-bottom: 28px !important;
        }
      
        .v-application .py-md-8 {
          padding-top: 32px !important;
          padding-bottom: 32px !important;
        }
      
        .v-application .py-md-9 {
          padding-top: 36px !important;
          padding-bottom: 36px !important;
        }
      
        .v-application .py-md-10 {
          padding-top: 40px !important;
          padding-bottom: 40px !important;
        }
      
        .v-application .py-md-11 {
          padding-top: 44px !important;
          padding-bottom: 44px !important;
        }
      
        .v-application .py-md-12 {
          padding-top: 48px !important;
          padding-bottom: 48px !important;
        }
      
        .v-application .pt-md-0 {
          padding-top: 0px !important;
        }
      
        .v-application .pt-md-1 {
          padding-top: 4px !important;
        }
      
        .v-application .pt-md-2 {
          padding-top: 8px !important;
        }
      
        .v-application .pt-md-3 {
          padding-top: 12px !important;
        }
      
        .v-application .pt-md-4 {
          padding-top: 16px !important;
        }
      
        .v-application .pt-md-5 {
          padding-top: 20px !important;
        }
      
        .v-application .pt-md-6 {
          padding-top: 24px !important;
        }
      
        .v-application .pt-md-7 {
          padding-top: 28px !important;
        }
      
        .v-application .pt-md-8 {
          padding-top: 32px !important;
        }
      
        .v-application .pt-md-9 {
          padding-top: 36px !important;
        }
      
        .v-application .pt-md-10 {
          padding-top: 40px !important;
        }
      
        .v-application .pt-md-11 {
          padding-top: 44px !important;
        }
      
        .v-application .pt-md-12 {
          padding-top: 48px !important;
        }
      
        .v-application .pr-md-0 {
          padding-right: 0px !important;
        }
      
        .v-application .pr-md-1 {
          padding-right: 4px !important;
        }
      
        .v-application .pr-md-2 {
          padding-right: 8px !important;
        }
      
        .v-application .pr-md-3 {
          padding-right: 12px !important;
        }
      
        .v-application .pr-md-4 {
          padding-right: 16px !important;
        }
      
        .v-application .pr-md-5 {
          padding-right: 20px !important;
        }
      
        .v-application .pr-md-6 {
          padding-right: 24px !important;
        }
      
        .v-application .pr-md-7 {
          padding-right: 28px !important;
        }
      
        .v-application .pr-md-8 {
          padding-right: 32px !important;
        }
      
        .v-application .pr-md-9 {
          padding-right: 36px !important;
        }
      
        .v-application .pr-md-10 {
          padding-right: 40px !important;
        }
      
        .v-application .pr-md-11 {
          padding-right: 44px !important;
        }
      
        .v-application .pr-md-12 {
          padding-right: 48px !important;
        }
      
        .v-application .pb-md-0 {
          padding-bottom: 0px !important;
        }
      
        .v-application .pb-md-1 {
          padding-bottom: 4px !important;
        }
      
        .v-application .pb-md-2 {
          padding-bottom: 8px !important;
        }
      
        .v-application .pb-md-3 {
          padding-bottom: 12px !important;
        }
      
        .v-application .pb-md-4 {
          padding-bottom: 16px !important;
        }
      
        .v-application .pb-md-5 {
          padding-bottom: 20px !important;
        }
      
        .v-application .pb-md-6 {
          padding-bottom: 24px !important;
        }
      
        .v-application .pb-md-7 {
          padding-bottom: 28px !important;
        }
      
        .v-application .pb-md-8 {
          padding-bottom: 32px !important;
        }
      
        .v-application .pb-md-9 {
          padding-bottom: 36px !important;
        }
      
        .v-application .pb-md-10 {
          padding-bottom: 40px !important;
        }
      
        .v-application .pb-md-11 {
          padding-bottom: 44px !important;
        }
      
        .v-application .pb-md-12 {
          padding-bottom: 48px !important;
        }
      
        .v-application .pl-md-0 {
          padding-left: 0px !important;
        }
      
        .v-application .pl-md-1 {
          padding-left: 4px !important;
        }
      
        .v-application .pl-md-2 {
          padding-left: 8px !important;
        }
      
        .v-application .pl-md-3 {
          padding-left: 12px !important;
        }
      
        .v-application .pl-md-4 {
          padding-left: 16px !important;
        }
      
        .v-application .pl-md-5 {
          padding-left: 20px !important;
        }
      
        .v-application .pl-md-6 {
          padding-left: 24px !important;
        }
      
        .v-application .pl-md-7 {
          padding-left: 28px !important;
        }
      
        .v-application .pl-md-8 {
          padding-left: 32px !important;
        }
      
        .v-application .pl-md-9 {
          padding-left: 36px !important;
        }
      
        .v-application .pl-md-10 {
          padding-left: 40px !important;
        }
      
        .v-application .pl-md-11 {
          padding-left: 44px !important;
        }
      
        .v-application .pl-md-12 {
          padding-left: 48px !important;
        }
      
        .v-application--is-ltr .ps-md-0 {
          padding-left: 0px !important;
        }
      
        .v-application--is-rtl .ps-md-0 {
          padding-right: 0px !important;
        }
      
        .v-application--is-ltr .ps-md-1 {
          padding-left: 4px !important;
        }
      
        .v-application--is-rtl .ps-md-1 {
          padding-right: 4px !important;
        }
      
        .v-application--is-ltr .ps-md-2 {
          padding-left: 8px !important;
        }
      
        .v-application--is-rtl .ps-md-2 {
          padding-right: 8px !important;
        }
      
        .v-application--is-ltr .ps-md-3 {
          padding-left: 12px !important;
        }
      
        .v-application--is-rtl .ps-md-3 {
          padding-right: 12px !important;
        }
      
        .v-application--is-ltr .ps-md-4 {
          padding-left: 16px !important;
        }
      
        .v-application--is-rtl .ps-md-4 {
          padding-right: 16px !important;
        }
      
        .v-application--is-ltr .ps-md-5 {
          padding-left: 20px !important;
        }
      
        .v-application--is-rtl .ps-md-5 {
          padding-right: 20px !important;
        }
      
        .v-application--is-ltr .ps-md-6 {
          padding-left: 24px !important;
        }
      
        .v-application--is-rtl .ps-md-6 {
          padding-right: 24px !important;
        }
      
        .v-application--is-ltr .ps-md-7 {
          padding-left: 28px !important;
        }
      
        .v-application--is-rtl .ps-md-7 {
          padding-right: 28px !important;
        }
      
        .v-application--is-ltr .ps-md-8 {
          padding-left: 32px !important;
        }
      
        .v-application--is-rtl .ps-md-8 {
          padding-right: 32px !important;
        }
      
        .v-application--is-ltr .ps-md-9 {
          padding-left: 36px !important;
        }
      
        .v-application--is-rtl .ps-md-9 {
          padding-right: 36px !important;
        }
      
        .v-application--is-ltr .ps-md-10 {
          padding-left: 40px !important;
        }
      
        .v-application--is-rtl .ps-md-10 {
          padding-right: 40px !important;
        }
      
        .v-application--is-ltr .ps-md-11 {
          padding-left: 44px !important;
        }
      
        .v-application--is-rtl .ps-md-11 {
          padding-right: 44px !important;
        }
      
        .v-application--is-ltr .ps-md-12 {
          padding-left: 48px !important;
        }
      
        .v-application--is-rtl .ps-md-12 {
          padding-right: 48px !important;
        }
      
        .v-application--is-ltr .pe-md-0 {
          padding-right: 0px !important;
        }
      
        .v-application--is-rtl .pe-md-0 {
          padding-left: 0px !important;
        }
      
        .v-application--is-ltr .pe-md-1 {
          padding-right: 4px !important;
        }
      
        .v-application--is-rtl .pe-md-1 {
          padding-left: 4px !important;
        }
      
        .v-application--is-ltr .pe-md-2 {
          padding-right: 8px !important;
        }
      
        .v-application--is-rtl .pe-md-2 {
          padding-left: 8px !important;
        }
      
        .v-application--is-ltr .pe-md-3 {
          padding-right: 12px !important;
        }
      
        .v-application--is-rtl .pe-md-3 {
          padding-left: 12px !important;
        }
      
        .v-application--is-ltr .pe-md-4 {
          padding-right: 16px !important;
        }
      
        .v-application--is-rtl .pe-md-4 {
          padding-left: 16px !important;
        }
      
        .v-application--is-ltr .pe-md-5 {
          padding-right: 20px !important;
        }
      
        .v-application--is-rtl .pe-md-5 {
          padding-left: 20px !important;
        }
      
        .v-application--is-ltr .pe-md-6 {
          padding-right: 24px !important;
        }
      
        .v-application--is-rtl .pe-md-6 {
          padding-left: 24px !important;
        }
      
        .v-application--is-ltr .pe-md-7 {
          padding-right: 28px !important;
        }
      
        .v-application--is-rtl .pe-md-7 {
          padding-left: 28px !important;
        }
      
        .v-application--is-ltr .pe-md-8 {
          padding-right: 32px !important;
        }
      
        .v-application--is-rtl .pe-md-8 {
          padding-left: 32px !important;
        }
      
        .v-application--is-ltr .pe-md-9 {
          padding-right: 36px !important;
        }
      
        .v-application--is-rtl .pe-md-9 {
          padding-left: 36px !important;
        }
      
        .v-application--is-ltr .pe-md-10 {
          padding-right: 40px !important;
        }
      
        .v-application--is-rtl .pe-md-10 {
          padding-left: 40px !important;
        }
      
        .v-application--is-ltr .pe-md-11 {
          padding-right: 44px !important;
        }
      
        .v-application--is-rtl .pe-md-11 {
          padding-left: 44px !important;
        }
      
        .v-application--is-ltr .pe-md-12 {
          padding-right: 48px !important;
        }
      
        .v-application--is-rtl .pe-md-12 {
          padding-left: 48px !important;
        }
      
        .v-application .text-md-left {
          text-align: left !important;
        }
      
        .v-application .text-md-right {
          text-align: right !important;
        }
      
        .v-application .text-md-center {
          text-align: center !important;
        }
      
        .v-application .text-md-justify {
          text-align: justify !important;
        }
      
        .v-application .text-md-start {
          text-align: start !important;
        }
      
        .v-application .text-md-end {
          text-align: end !important;
        }
      }
      @media (min-width: 1264px) {
        .v-application .d-lg-none {
          display: none !important;
        }
      
        .v-application .d-lg-inline {
          display: inline !important;
        }
      
        .v-application .d-lg-inline-block {
          display: inline-block !important;
        }
      
        .v-application .d-lg-block {
          display: block !important;
        }
      
        .v-application .d-lg-table {
          display: table !important;
        }
      
        .v-application .d-lg-table-row {
          display: table-row !important;
        }
      
        .v-application .d-lg-table-cell {
          display: table-cell !important;
        }
      
        .v-application .d-lg-flex {
          display: -webkit-box !important;
          display: -ms-flexbox !important;
          display: flex !important;
        }
      
        .v-application .d-lg-inline-flex {
          display: -webkit-inline-box !important;
          display: -ms-inline-flexbox !important;
          display: inline-flex !important;
        }
      
        .v-application .float-lg-none {
          float: none !important;
        }
      
        .v-application .float-lg-left {
          float: left !important;
        }
      
        .v-application .float-lg-right {
          float: right !important;
        }
      
        .v-application .flex-lg-fill {
          -webkit-box-flex: 1 !important;
              -ms-flex: 1 1 auto !important;
                  flex: 1 1 auto !important;
        }
      
        .v-application .flex-lg-row {
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: normal !important;
              -ms-flex-direction: row !important;
                  flex-direction: row !important;
        }
      
        .v-application .flex-lg-column {
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: normal !important;
              -ms-flex-direction: column !important;
                  flex-direction: column !important;
        }
      
        .v-application .flex-lg-row-reverse {
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: reverse !important;
              -ms-flex-direction: row-reverse !important;
                  flex-direction: row-reverse !important;
        }
      
        .v-application .flex-lg-column-reverse {
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: reverse !important;
              -ms-flex-direction: column-reverse !important;
                  flex-direction: column-reverse !important;
        }
      
        .v-application .flex-lg-grow-0 {
          -webkit-box-flex: 0 !important;
              -ms-flex-positive: 0 !important;
                  flex-grow: 0 !important;
        }
      
        .v-application .flex-lg-grow-1 {
          -webkit-box-flex: 1 !important;
              -ms-flex-positive: 1 !important;
                  flex-grow: 1 !important;
        }
      
        .v-application .flex-lg-shrink-0 {
          -ms-flex-negative: 0 !important;
              flex-shrink: 0 !important;
        }
      
        .v-application .flex-lg-shrink-1 {
          -ms-flex-negative: 1 !important;
              flex-shrink: 1 !important;
        }
      
        .v-application .flex-lg-wrap {
          -ms-flex-wrap: wrap !important;
              flex-wrap: wrap !important;
        }
      
        .v-application .flex-lg-nowrap {
          -ms-flex-wrap: nowrap !important;
              flex-wrap: nowrap !important;
        }
      
        .v-application .flex-lg-wrap-reverse {
          -ms-flex-wrap: wrap-reverse !important;
              flex-wrap: wrap-reverse !important;
        }
      
        .v-application .justify-lg-start {
          -webkit-box-pack: start !important;
              -ms-flex-pack: start !important;
                  justify-content: flex-start !important;
        }
      
        .v-application .justify-lg-end {
          -webkit-box-pack: end !important;
              -ms-flex-pack: end !important;
                  justify-content: flex-end !important;
        }
      
        .v-application .justify-lg-center {
          -webkit-box-pack: center !important;
              -ms-flex-pack: center !important;
                  justify-content: center !important;
        }
      
        .v-application .justify-lg-space-between {
          -webkit-box-pack: justify !important;
              -ms-flex-pack: justify !important;
                  justify-content: space-between !important;
        }
      
        .v-application .justify-lg-space-around {
          -ms-flex-pack: distribute !important;
              justify-content: space-around !important;
        }
      
        .v-application .align-lg-start {
          -webkit-box-align: start !important;
              -ms-flex-align: start !important;
                  align-items: flex-start !important;
        }
      
        .v-application .align-lg-end {
          -webkit-box-align: end !important;
              -ms-flex-align: end !important;
                  align-items: flex-end !important;
        }
      
        .v-application .align-lg-center {
          -webkit-box-align: center !important;
              -ms-flex-align: center !important;
                  align-items: center !important;
        }
      
        .v-application .align-lg-baseline {
          -webkit-box-align: baseline !important;
              -ms-flex-align: baseline !important;
                  align-items: baseline !important;
        }
      
        .v-application .align-lg-stretch {
          -webkit-box-align: stretch !important;
              -ms-flex-align: stretch !important;
                  align-items: stretch !important;
        }
      
        .v-application .align-content-lg-start {
          -ms-flex-line-pack: start !important;
              align-content: flex-start !important;
        }
      
        .v-application .align-content-lg-end {
          -ms-flex-line-pack: end !important;
              align-content: flex-end !important;
        }
      
        .v-application .align-content-lg-center {
          -ms-flex-line-pack: center !important;
              align-content: center !important;
        }
      
        .v-application .align-content-lg-space-between {
          -ms-flex-line-pack: justify !important;
              align-content: space-between !important;
        }
      
        .v-application .align-content-lg-space-around {
          -ms-flex-line-pack: distribute !important;
              align-content: space-around !important;
        }
      
        .v-application .align-content-lg-stretch {
          -ms-flex-line-pack: stretch !important;
              align-content: stretch !important;
        }
      
        .v-application .align-self-lg-auto {
          -ms-flex-item-align: auto !important;
              align-self: auto !important;
        }
      
        .v-application .align-self-lg-start {
          -ms-flex-item-align: start !important;
              align-self: flex-start !important;
        }
      
        .v-application .align-self-lg-end {
          -ms-flex-item-align: end !important;
              align-self: flex-end !important;
        }
      
        .v-application .align-self-lg-center {
          -ms-flex-item-align: center !important;
              align-self: center !important;
        }
      
        .v-application .align-self-lg-baseline {
          -ms-flex-item-align: baseline !important;
              align-self: baseline !important;
        }
      
        .v-application .align-self-lg-stretch {
          -ms-flex-item-align: stretch !important;
              align-self: stretch !important;
        }
      
        .v-application .order-lg-first {
          -webkit-box-ordinal-group: 0 !important;
              -ms-flex-order: -1 !important;
                  order: -1 !important;
        }
      
        .v-application .order-lg-0 {
          -webkit-box-ordinal-group: 1 !important;
              -ms-flex-order: 0 !important;
                  order: 0 !important;
        }
      
        .v-application .order-lg-1 {
          -webkit-box-ordinal-group: 2 !important;
              -ms-flex-order: 1 !important;
                  order: 1 !important;
        }
      
        .v-application .order-lg-2 {
          -webkit-box-ordinal-group: 3 !important;
              -ms-flex-order: 2 !important;
                  order: 2 !important;
        }
      
        .v-application .order-lg-3 {
          -webkit-box-ordinal-group: 4 !important;
              -ms-flex-order: 3 !important;
                  order: 3 !important;
        }
      
        .v-application .order-lg-4 {
          -webkit-box-ordinal-group: 5 !important;
              -ms-flex-order: 4 !important;
                  order: 4 !important;
        }
      
        .v-application .order-lg-5 {
          -webkit-box-ordinal-group: 6 !important;
              -ms-flex-order: 5 !important;
                  order: 5 !important;
        }
      
        .v-application .order-lg-6 {
          -webkit-box-ordinal-group: 7 !important;
              -ms-flex-order: 6 !important;
                  order: 6 !important;
        }
      
        .v-application .order-lg-7 {
          -webkit-box-ordinal-group: 8 !important;
              -ms-flex-order: 7 !important;
                  order: 7 !important;
        }
      
        .v-application .order-lg-8 {
          -webkit-box-ordinal-group: 9 !important;
              -ms-flex-order: 8 !important;
                  order: 8 !important;
        }
      
        .v-application .order-lg-9 {
          -webkit-box-ordinal-group: 10 !important;
              -ms-flex-order: 9 !important;
                  order: 9 !important;
        }
      
        .v-application .order-lg-10 {
          -webkit-box-ordinal-group: 11 !important;
              -ms-flex-order: 10 !important;
                  order: 10 !important;
        }
      
        .v-application .order-lg-11 {
          -webkit-box-ordinal-group: 12 !important;
              -ms-flex-order: 11 !important;
                  order: 11 !important;
        }
      
        .v-application .order-lg-12 {
          -webkit-box-ordinal-group: 13 !important;
              -ms-flex-order: 12 !important;
                  order: 12 !important;
        }
      
        .v-application .order-lg-last {
          -webkit-box-ordinal-group: 14 !important;
              -ms-flex-order: 13 !important;
                  order: 13 !important;
        }
      
        .v-application .ma-lg-0 {
          margin: 0px !important;
        }
      
        .v-application .ma-lg-1 {
          margin: 4px !important;
        }
      
        .v-application .ma-lg-2 {
          margin: 8px !important;
        }
      
        .v-application .ma-lg-3 {
          margin: 12px !important;
        }
      
        .v-application .ma-lg-4 {
          margin: 16px !important;
        }
      
        .v-application .ma-lg-5 {
          margin: 20px !important;
        }
      
        .v-application .ma-lg-6 {
          margin: 24px !important;
        }
      
        .v-application .ma-lg-7 {
          margin: 28px !important;
        }
      
        .v-application .ma-lg-8 {
          margin: 32px !important;
        }
      
        .v-application .ma-lg-9 {
          margin: 36px !important;
        }
      
        .v-application .ma-lg-10 {
          margin: 40px !important;
        }
      
        .v-application .ma-lg-11 {
          margin: 44px !important;
        }
      
        .v-application .ma-lg-12 {
          margin: 48px !important;
        }
      
        .v-application .ma-lg-auto {
          margin: auto !important;
        }
      
        .v-application .mx-lg-0 {
          margin-right: 0px !important;
          margin-left: 0px !important;
        }
      
        .v-application .mx-lg-1 {
          margin-right: 4px !important;
          margin-left: 4px !important;
        }
      
        .v-application .mx-lg-2 {
          margin-right: 8px !important;
          margin-left: 8px !important;
        }
      
        .v-application .mx-lg-3 {
          margin-right: 12px !important;
          margin-left: 12px !important;
        }
      
        .v-application .mx-lg-4 {
          margin-right: 16px !important;
          margin-left: 16px !important;
        }
      
        .v-application .mx-lg-5 {
          margin-right: 20px !important;
          margin-left: 20px !important;
        }
      
        .v-application .mx-lg-6 {
          margin-right: 24px !important;
          margin-left: 24px !important;
        }
      
        .v-application .mx-lg-7 {
          margin-right: 28px !important;
          margin-left: 28px !important;
        }
      
        .v-application .mx-lg-8 {
          margin-right: 32px !important;
          margin-left: 32px !important;
        }
      
        .v-application .mx-lg-9 {
          margin-right: 36px !important;
          margin-left: 36px !important;
        }
      
        .v-application .mx-lg-10 {
          margin-right: 40px !important;
          margin-left: 40px !important;
        }
      
        .v-application .mx-lg-11 {
          margin-right: 44px !important;
          margin-left: 44px !important;
        }
      
        .v-application .mx-lg-12 {
          margin-right: 48px !important;
          margin-left: 48px !important;
        }
      
        .v-application .mx-lg-auto {
          margin-right: auto !important;
          margin-left: auto !important;
        }
      
        .v-application .my-lg-0 {
          margin-top: 0px !important;
          margin-bottom: 0px !important;
        }
      
        .v-application .my-lg-1 {
          margin-top: 4px !important;
          margin-bottom: 4px !important;
        }
      
        .v-application .my-lg-2 {
          margin-top: 8px !important;
          margin-bottom: 8px !important;
        }
      
        .v-application .my-lg-3 {
          margin-top: 12px !important;
          margin-bottom: 12px !important;
        }
      
        .v-application .my-lg-4 {
          margin-top: 16px !important;
          margin-bottom: 16px !important;
        }
      
        .v-application .my-lg-5 {
          margin-top: 20px !important;
          margin-bottom: 20px !important;
        }
      
        .v-application .my-lg-6 {
          margin-top: 24px !important;
          margin-bottom: 24px !important;
        }
      
        .v-application .my-lg-7 {
          margin-top: 28px !important;
          margin-bottom: 28px !important;
        }
      
        .v-application .my-lg-8 {
          margin-top: 32px !important;
          margin-bottom: 32px !important;
        }
      
        .v-application .my-lg-9 {
          margin-top: 36px !important;
          margin-bottom: 36px !important;
        }
      
        .v-application .my-lg-10 {
          margin-top: 40px !important;
          margin-bottom: 40px !important;
        }
      
        .v-application .my-lg-11 {
          margin-top: 44px !important;
          margin-bottom: 44px !important;
        }
      
        .v-application .my-lg-12 {
          margin-top: 48px !important;
          margin-bottom: 48px !important;
        }
      
        .v-application .my-lg-auto {
          margin-top: auto !important;
          margin-bottom: auto !important;
        }
      
        .v-application .mt-lg-0 {
          margin-top: 0px !important;
        }
      
        .v-application .mt-lg-1 {
          margin-top: 4px !important;
        }
      
        .v-application .mt-lg-2 {
          margin-top: 8px !important;
        }
      
        .v-application .mt-lg-3 {
          margin-top: 12px !important;
        }
      
        .v-application .mt-lg-4 {
          margin-top: 16px !important;
        }
      
        .v-application .mt-lg-5 {
          margin-top: 20px !important;
        }
      
        .v-application .mt-lg-6 {
          margin-top: 24px !important;
        }
      
        .v-application .mt-lg-7 {
          margin-top: 28px !important;
        }
      
        .v-application .mt-lg-8 {
          margin-top: 32px !important;
        }
      
        .v-application .mt-lg-9 {
          margin-top: 36px !important;
        }
      
        .v-application .mt-lg-10 {
          margin-top: 40px !important;
        }
      
        .v-application .mt-lg-11 {
          margin-top: 44px !important;
        }
      
        .v-application .mt-lg-12 {
          margin-top: 48px !important;
        }
      
        .v-application .mt-lg-auto {
          margin-top: auto !important;
        }
      
        .v-application .mr-lg-0 {
          margin-right: 0px !important;
        }
      
        .v-application .mr-lg-1 {
          margin-right: 4px !important;
        }
      
        .v-application .mr-lg-2 {
          margin-right: 8px !important;
        }
      
        .v-application .mr-lg-3 {
          margin-right: 12px !important;
        }
      
        .v-application .mr-lg-4 {
          margin-right: 16px !important;
        }
      
        .v-application .mr-lg-5 {
          margin-right: 20px !important;
        }
      
        .v-application .mr-lg-6 {
          margin-right: 24px !important;
        }
      
        .v-application .mr-lg-7 {
          margin-right: 28px !important;
        }
      
        .v-application .mr-lg-8 {
          margin-right: 32px !important;
        }
      
        .v-application .mr-lg-9 {
          margin-right: 36px !important;
        }
      
        .v-application .mr-lg-10 {
          margin-right: 40px !important;
        }
      
        .v-application .mr-lg-11 {
          margin-right: 44px !important;
        }
      
        .v-application .mr-lg-12 {
          margin-right: 48px !important;
        }
      
        .v-application .mr-lg-auto {
          margin-right: auto !important;
        }
      
        .v-application .mb-lg-0 {
          margin-bottom: 0px !important;
        }
      
        .v-application .mb-lg-1 {
          margin-bottom: 4px !important;
        }
      
        .v-application .mb-lg-2 {
          margin-bottom: 8px !important;
        }
      
        .v-application .mb-lg-3 {
          margin-bottom: 12px !important;
        }
      
        .v-application .mb-lg-4 {
          margin-bottom: 16px !important;
        }
      
        .v-application .mb-lg-5 {
          margin-bottom: 20px !important;
        }
      
        .v-application .mb-lg-6 {
          margin-bottom: 24px !important;
        }
      
        .v-application .mb-lg-7 {
          margin-bottom: 28px !important;
        }
      
        .v-application .mb-lg-8 {
          margin-bottom: 32px !important;
        }
      
        .v-application .mb-lg-9 {
          margin-bottom: 36px !important;
        }
      
        .v-application .mb-lg-10 {
          margin-bottom: 40px !important;
        }
      
        .v-application .mb-lg-11 {
          margin-bottom: 44px !important;
        }
      
        .v-application .mb-lg-12 {
          margin-bottom: 48px !important;
        }
      
        .v-application .mb-lg-auto {
          margin-bottom: auto !important;
        }
      
        .v-application .ml-lg-0 {
          margin-left: 0px !important;
        }
      
        .v-application .ml-lg-1 {
          margin-left: 4px !important;
        }
      
        .v-application .ml-lg-2 {
          margin-left: 8px !important;
        }
      
        .v-application .ml-lg-3 {
          margin-left: 12px !important;
        }
      
        .v-application .ml-lg-4 {
          margin-left: 16px !important;
        }
      
        .v-application .ml-lg-5 {
          margin-left: 20px !important;
        }
      
        .v-application .ml-lg-6 {
          margin-left: 24px !important;
        }
      
        .v-application .ml-lg-7 {
          margin-left: 28px !important;
        }
      
        .v-application .ml-lg-8 {
          margin-left: 32px !important;
        }
      
        .v-application .ml-lg-9 {
          margin-left: 36px !important;
        }
      
        .v-application .ml-lg-10 {
          margin-left: 40px !important;
        }
      
        .v-application .ml-lg-11 {
          margin-left: 44px !important;
        }
      
        .v-application .ml-lg-12 {
          margin-left: 48px !important;
        }
      
        .v-application .ml-lg-auto {
          margin-left: auto !important;
        }
      
        .v-application--is-ltr .ms-lg-0 {
          margin-left: 0px !important;
        }
      
        .v-application--is-rtl .ms-lg-0 {
          margin-right: 0px !important;
        }
      
        .v-application--is-ltr .ms-lg-1 {
          margin-left: 4px !important;
        }
      
        .v-application--is-rtl .ms-lg-1 {
          margin-right: 4px !important;
        }
      
        .v-application--is-ltr .ms-lg-2 {
          margin-left: 8px !important;
        }
      
        .v-application--is-rtl .ms-lg-2 {
          margin-right: 8px !important;
        }
      
        .v-application--is-ltr .ms-lg-3 {
          margin-left: 12px !important;
        }
      
        .v-application--is-rtl .ms-lg-3 {
          margin-right: 12px !important;
        }
      
        .v-application--is-ltr .ms-lg-4 {
          margin-left: 16px !important;
        }
      
        .v-application--is-rtl .ms-lg-4 {
          margin-right: 16px !important;
        }
      
        .v-application--is-ltr .ms-lg-5 {
          margin-left: 20px !important;
        }
      
        .v-application--is-rtl .ms-lg-5 {
          margin-right: 20px !important;
        }
      
        .v-application--is-ltr .ms-lg-6 {
          margin-left: 24px !important;
        }
      
        .v-application--is-rtl .ms-lg-6 {
          margin-right: 24px !important;
        }
      
        .v-application--is-ltr .ms-lg-7 {
          margin-left: 28px !important;
        }
      
        .v-application--is-rtl .ms-lg-7 {
          margin-right: 28px !important;
        }
      
        .v-application--is-ltr .ms-lg-8 {
          margin-left: 32px !important;
        }
      
        .v-application--is-rtl .ms-lg-8 {
          margin-right: 32px !important;
        }
      
        .v-application--is-ltr .ms-lg-9 {
          margin-left: 36px !important;
        }
      
        .v-application--is-rtl .ms-lg-9 {
          margin-right: 36px !important;
        }
      
        .v-application--is-ltr .ms-lg-10 {
          margin-left: 40px !important;
        }
      
        .v-application--is-rtl .ms-lg-10 {
          margin-right: 40px !important;
        }
      
        .v-application--is-ltr .ms-lg-11 {
          margin-left: 44px !important;
        }
      
        .v-application--is-rtl .ms-lg-11 {
          margin-right: 44px !important;
        }
      
        .v-application--is-ltr .ms-lg-12 {
          margin-left: 48px !important;
        }
      
        .v-application--is-rtl .ms-lg-12 {
          margin-right: 48px !important;
        }
      
        .v-application--is-ltr .ms-lg-auto {
          margin-left: auto !important;
        }
      
        .v-application--is-rtl .ms-lg-auto {
          margin-right: auto !important;
        }
      
        .v-application--is-ltr .me-lg-0 {
          margin-right: 0px !important;
        }
      
        .v-application--is-rtl .me-lg-0 {
          margin-left: 0px !important;
        }
      
        .v-application--is-ltr .me-lg-1 {
          margin-right: 4px !important;
        }
      
        .v-application--is-rtl .me-lg-1 {
          margin-left: 4px !important;
        }
      
        .v-application--is-ltr .me-lg-2 {
          margin-right: 8px !important;
        }
      
        .v-application--is-rtl .me-lg-2 {
          margin-left: 8px !important;
        }
      
        .v-application--is-ltr .me-lg-3 {
          margin-right: 12px !important;
        }
      
        .v-application--is-rtl .me-lg-3 {
          margin-left: 12px !important;
        }
      
        .v-application--is-ltr .me-lg-4 {
          margin-right: 16px !important;
        }
      
        .v-application--is-rtl .me-lg-4 {
          margin-left: 16px !important;
        }
      
        .v-application--is-ltr .me-lg-5 {
          margin-right: 20px !important;
        }
      
        .v-application--is-rtl .me-lg-5 {
          margin-left: 20px !important;
        }
      
        .v-application--is-ltr .me-lg-6 {
          margin-right: 24px !important;
        }
      
        .v-application--is-rtl .me-lg-6 {
          margin-left: 24px !important;
        }
      
        .v-application--is-ltr .me-lg-7 {
          margin-right: 28px !important;
        }
      
        .v-application--is-rtl .me-lg-7 {
          margin-left: 28px !important;
        }
      
        .v-application--is-ltr .me-lg-8 {
          margin-right: 32px !important;
        }
      
        .v-application--is-rtl .me-lg-8 {
          margin-left: 32px !important;
        }
      
        .v-application--is-ltr .me-lg-9 {
          margin-right: 36px !important;
        }
      
        .v-application--is-rtl .me-lg-9 {
          margin-left: 36px !important;
        }
      
        .v-application--is-ltr .me-lg-10 {
          margin-right: 40px !important;
        }
      
        .v-application--is-rtl .me-lg-10 {
          margin-left: 40px !important;
        }
      
        .v-application--is-ltr .me-lg-11 {
          margin-right: 44px !important;
        }
      
        .v-application--is-rtl .me-lg-11 {
          margin-left: 44px !important;
        }
      
        .v-application--is-ltr .me-lg-12 {
          margin-right: 48px !important;
        }
      
        .v-application--is-rtl .me-lg-12 {
          margin-left: 48px !important;
        }
      
        .v-application--is-ltr .me-lg-auto {
          margin-right: auto !important;
        }
      
        .v-application--is-rtl .me-lg-auto {
          margin-left: auto !important;
        }
      
        .v-application .ma-lg-n1 {
          margin: -4px !important;
        }
      
        .v-application .ma-lg-n2 {
          margin: -8px !important;
        }
      
        .v-application .ma-lg-n3 {
          margin: -12px !important;
        }
      
        .v-application .ma-lg-n4 {
          margin: -16px !important;
        }
      
        .v-application .ma-lg-n5 {
          margin: -20px !important;
        }
      
        .v-application .ma-lg-n6 {
          margin: -24px !important;
        }
      
        .v-application .ma-lg-n7 {
          margin: -28px !important;
        }
      
        .v-application .ma-lg-n8 {
          margin: -32px !important;
        }
      
        .v-application .ma-lg-n9 {
          margin: -36px !important;
        }
      
        .v-application .ma-lg-n10 {
          margin: -40px !important;
        }
      
        .v-application .ma-lg-n11 {
          margin: -44px !important;
        }
      
        .v-application .ma-lg-n12 {
          margin: -48px !important;
        }
      
        .v-application .mx-lg-n1 {
          margin-right: -4px !important;
          margin-left: -4px !important;
        }
      
        .v-application .mx-lg-n2 {
          margin-right: -8px !important;
          margin-left: -8px !important;
        }
      
        .v-application .mx-lg-n3 {
          margin-right: -12px !important;
          margin-left: -12px !important;
        }
      
        .v-application .mx-lg-n4 {
          margin-right: -16px !important;
          margin-left: -16px !important;
        }
      
        .v-application .mx-lg-n5 {
          margin-right: -20px !important;
          margin-left: -20px !important;
        }
      
        .v-application .mx-lg-n6 {
          margin-right: -24px !important;
          margin-left: -24px !important;
        }
      
        .v-application .mx-lg-n7 {
          margin-right: -28px !important;
          margin-left: -28px !important;
        }
      
        .v-application .mx-lg-n8 {
          margin-right: -32px !important;
          margin-left: -32px !important;
        }
      
        .v-application .mx-lg-n9 {
          margin-right: -36px !important;
          margin-left: -36px !important;
        }
      
        .v-application .mx-lg-n10 {
          margin-right: -40px !important;
          margin-left: -40px !important;
        }
      
        .v-application .mx-lg-n11 {
          margin-right: -44px !important;
          margin-left: -44px !important;
        }
      
        .v-application .mx-lg-n12 {
          margin-right: -48px !important;
          margin-left: -48px !important;
        }
      
        .v-application .my-lg-n1 {
          margin-top: -4px !important;
          margin-bottom: -4px !important;
        }
      
        .v-application .my-lg-n2 {
          margin-top: -8px !important;
          margin-bottom: -8px !important;
        }
      
        .v-application .my-lg-n3 {
          margin-top: -12px !important;
          margin-bottom: -12px !important;
        }
      
        .v-application .my-lg-n4 {
          margin-top: -16px !important;
          margin-bottom: -16px !important;
        }
      
        .v-application .my-lg-n5 {
          margin-top: -20px !important;
          margin-bottom: -20px !important;
        }
      
        .v-application .my-lg-n6 {
          margin-top: -24px !important;
          margin-bottom: -24px !important;
        }
      
        .v-application .my-lg-n7 {
          margin-top: -28px !important;
          margin-bottom: -28px !important;
        }
      
        .v-application .my-lg-n8 {
          margin-top: -32px !important;
          margin-bottom: -32px !important;
        }
      
        .v-application .my-lg-n9 {
          margin-top: -36px !important;
          margin-bottom: -36px !important;
        }
      
        .v-application .my-lg-n10 {
          margin-top: -40px !important;
          margin-bottom: -40px !important;
        }
      
        .v-application .my-lg-n11 {
          margin-top: -44px !important;
          margin-bottom: -44px !important;
        }
      
        .v-application .my-lg-n12 {
          margin-top: -48px !important;
          margin-bottom: -48px !important;
        }
      
        .v-application .mt-lg-n1 {
          margin-top: -4px !important;
        }
      
        .v-application .mt-lg-n2 {
          margin-top: -8px !important;
        }
      
        .v-application .mt-lg-n3 {
          margin-top: -12px !important;
        }
      
        .v-application .mt-lg-n4 {
          margin-top: -16px !important;
        }
      
        .v-application .mt-lg-n5 {
          margin-top: -20px !important;
        }
      
        .v-application .mt-lg-n6 {
          margin-top: -24px !important;
        }
      
        .v-application .mt-lg-n7 {
          margin-top: -28px !important;
        }
      
        .v-application .mt-lg-n8 {
          margin-top: -32px !important;
        }
      
        .v-application .mt-lg-n9 {
          margin-top: -36px !important;
        }
      
        .v-application .mt-lg-n10 {
          margin-top: -40px !important;
        }
      
        .v-application .mt-lg-n11 {
          margin-top: -44px !important;
        }
      
        .v-application .mt-lg-n12 {
          margin-top: -48px !important;
        }
      
        .v-application .mr-lg-n1 {
          margin-right: -4px !important;
        }
      
        .v-application .mr-lg-n2 {
          margin-right: -8px !important;
        }
      
        .v-application .mr-lg-n3 {
          margin-right: -12px !important;
        }
      
        .v-application .mr-lg-n4 {
          margin-right: -16px !important;
        }
      
        .v-application .mr-lg-n5 {
          margin-right: -20px !important;
        }
      
        .v-application .mr-lg-n6 {
          margin-right: -24px !important;
        }
      
        .v-application .mr-lg-n7 {
          margin-right: -28px !important;
        }
      
        .v-application .mr-lg-n8 {
          margin-right: -32px !important;
        }
      
        .v-application .mr-lg-n9 {
          margin-right: -36px !important;
        }
      
        .v-application .mr-lg-n10 {
          margin-right: -40px !important;
        }
      
        .v-application .mr-lg-n11 {
          margin-right: -44px !important;
        }
      
        .v-application .mr-lg-n12 {
          margin-right: -48px !important;
        }
      
        .v-application .mb-lg-n1 {
          margin-bottom: -4px !important;
        }
      
        .v-application .mb-lg-n2 {
          margin-bottom: -8px !important;
        }
      
        .v-application .mb-lg-n3 {
          margin-bottom: -12px !important;
        }
      
        .v-application .mb-lg-n4 {
          margin-bottom: -16px !important;
        }
      
        .v-application .mb-lg-n5 {
          margin-bottom: -20px !important;
        }
      
        .v-application .mb-lg-n6 {
          margin-bottom: -24px !important;
        }
      
        .v-application .mb-lg-n7 {
          margin-bottom: -28px !important;
        }
      
        .v-application .mb-lg-n8 {
          margin-bottom: -32px !important;
        }
      
        .v-application .mb-lg-n9 {
          margin-bottom: -36px !important;
        }
      
        .v-application .mb-lg-n10 {
          margin-bottom: -40px !important;
        }
      
        .v-application .mb-lg-n11 {
          margin-bottom: -44px !important;
        }
      
        .v-application .mb-lg-n12 {
          margin-bottom: -48px !important;
        }
      
        .v-application .ml-lg-n1 {
          margin-left: -4px !important;
        }
      
        .v-application .ml-lg-n2 {
          margin-left: -8px !important;
        }
      
        .v-application .ml-lg-n3 {
          margin-left: -12px !important;
        }
      
        .v-application .ml-lg-n4 {
          margin-left: -16px !important;
        }
      
        .v-application .ml-lg-n5 {
          margin-left: -20px !important;
        }
      
        .v-application .ml-lg-n6 {
          margin-left: -24px !important;
        }
      
        .v-application .ml-lg-n7 {
          margin-left: -28px !important;
        }
      
        .v-application .ml-lg-n8 {
          margin-left: -32px !important;
        }
      
        .v-application .ml-lg-n9 {
          margin-left: -36px !important;
        }
      
        .v-application .ml-lg-n10 {
          margin-left: -40px !important;
        }
      
        .v-application .ml-lg-n11 {
          margin-left: -44px !important;
        }
      
        .v-application .ml-lg-n12 {
          margin-left: -48px !important;
        }
      
        .v-application--is-ltr .ms-lg-n1 {
          margin-left: -4px !important;
        }
      
        .v-application--is-rtl .ms-lg-n1 {
          margin-right: -4px !important;
        }
      
        .v-application--is-ltr .ms-lg-n2 {
          margin-left: -8px !important;
        }
      
        .v-application--is-rtl .ms-lg-n2 {
          margin-right: -8px !important;
        }
      
        .v-application--is-ltr .ms-lg-n3 {
          margin-left: -12px !important;
        }
      
        .v-application--is-rtl .ms-lg-n3 {
          margin-right: -12px !important;
        }
      
        .v-application--is-ltr .ms-lg-n4 {
          margin-left: -16px !important;
        }
      
        .v-application--is-rtl .ms-lg-n4 {
          margin-right: -16px !important;
        }
      
        .v-application--is-ltr .ms-lg-n5 {
          margin-left: -20px !important;
        }
      
        .v-application--is-rtl .ms-lg-n5 {
          margin-right: -20px !important;
        }
      
        .v-application--is-ltr .ms-lg-n6 {
          margin-left: -24px !important;
        }
      
        .v-application--is-rtl .ms-lg-n6 {
          margin-right: -24px !important;
        }
      
        .v-application--is-ltr .ms-lg-n7 {
          margin-left: -28px !important;
        }
      
        .v-application--is-rtl .ms-lg-n7 {
          margin-right: -28px !important;
        }
      
        .v-application--is-ltr .ms-lg-n8 {
          margin-left: -32px !important;
        }
      
        .v-application--is-rtl .ms-lg-n8 {
          margin-right: -32px !important;
        }
      
        .v-application--is-ltr .ms-lg-n9 {
          margin-left: -36px !important;
        }
      
        .v-application--is-rtl .ms-lg-n9 {
          margin-right: -36px !important;
        }
      
        .v-application--is-ltr .ms-lg-n10 {
          margin-left: -40px !important;
        }
      
        .v-application--is-rtl .ms-lg-n10 {
          margin-right: -40px !important;
        }
      
        .v-application--is-ltr .ms-lg-n11 {
          margin-left: -44px !important;
        }
      
        .v-application--is-rtl .ms-lg-n11 {
          margin-right: -44px !important;
        }
      
        .v-application--is-ltr .ms-lg-n12 {
          margin-left: -48px !important;
        }
      
        .v-application--is-rtl .ms-lg-n12 {
          margin-right: -48px !important;
        }
      
        .v-application--is-ltr .me-lg-n1 {
          margin-right: -4px !important;
        }
      
        .v-application--is-rtl .me-lg-n1 {
          margin-left: -4px !important;
        }
      
        .v-application--is-ltr .me-lg-n2 {
          margin-right: -8px !important;
        }
      
        .v-application--is-rtl .me-lg-n2 {
          margin-left: -8px !important;
        }
      
        .v-application--is-ltr .me-lg-n3 {
          margin-right: -12px !important;
        }
      
        .v-application--is-rtl .me-lg-n3 {
          margin-left: -12px !important;
        }
      
        .v-application--is-ltr .me-lg-n4 {
          margin-right: -16px !important;
        }
      
        .v-application--is-rtl .me-lg-n4 {
          margin-left: -16px !important;
        }
      
        .v-application--is-ltr .me-lg-n5 {
          margin-right: -20px !important;
        }
      
        .v-application--is-rtl .me-lg-n5 {
          margin-left: -20px !important;
        }
      
        .v-application--is-ltr .me-lg-n6 {
          margin-right: -24px !important;
        }
      
        .v-application--is-rtl .me-lg-n6 {
          margin-left: -24px !important;
        }
      
        .v-application--is-ltr .me-lg-n7 {
          margin-right: -28px !important;
        }
      
        .v-application--is-rtl .me-lg-n7 {
          margin-left: -28px !important;
        }
      
        .v-application--is-ltr .me-lg-n8 {
          margin-right: -32px !important;
        }
      
        .v-application--is-rtl .me-lg-n8 {
          margin-left: -32px !important;
        }
      
        .v-application--is-ltr .me-lg-n9 {
          margin-right: -36px !important;
        }
      
        .v-application--is-rtl .me-lg-n9 {
          margin-left: -36px !important;
        }
      
        .v-application--is-ltr .me-lg-n10 {
          margin-right: -40px !important;
        }
      
        .v-application--is-rtl .me-lg-n10 {
          margin-left: -40px !important;
        }
      
        .v-application--is-ltr .me-lg-n11 {
          margin-right: -44px !important;
        }
      
        .v-application--is-rtl .me-lg-n11 {
          margin-left: -44px !important;
        }
      
        .v-application--is-ltr .me-lg-n12 {
          margin-right: -48px !important;
        }
      
        .v-application--is-rtl .me-lg-n12 {
          margin-left: -48px !important;
        }
      
        .v-application .pa-lg-0 {
          padding: 0px !important;
        }
      
        .v-application .pa-lg-1 {
          padding: 4px !important;
        }
      
        .v-application .pa-lg-2 {
          padding: 8px !important;
        }
      
        .v-application .pa-lg-3 {
          padding: 12px !important;
        }
      
        .v-application .pa-lg-4 {
          padding: 16px !important;
        }
      
        .v-application .pa-lg-5 {
          padding: 20px !important;
        }
      
        .v-application .pa-lg-6 {
          padding: 24px !important;
        }
      
        .v-application .pa-lg-7 {
          padding: 28px !important;
        }
      
        .v-application .pa-lg-8 {
          padding: 32px !important;
        }
      
        .v-application .pa-lg-9 {
          padding: 36px !important;
        }
      
        .v-application .pa-lg-10 {
          padding: 40px !important;
        }
      
        .v-application .pa-lg-11 {
          padding: 44px !important;
        }
      
        .v-application .pa-lg-12 {
          padding: 48px !important;
        }
      
        .v-application .px-lg-0 {
          padding-right: 0px !important;
          padding-left: 0px !important;
        }
      
        .v-application .px-lg-1 {
          padding-right: 4px !important;
          padding-left: 4px !important;
        }
      
        .v-application .px-lg-2 {
          padding-right: 8px !important;
          padding-left: 8px !important;
        }
      
        .v-application .px-lg-3 {
          padding-right: 12px !important;
          padding-left: 12px !important;
        }
      
        .v-application .px-lg-4 {
          padding-right: 16px !important;
          padding-left: 16px !important;
        }
      
        .v-application .px-lg-5 {
          padding-right: 20px !important;
          padding-left: 20px !important;
        }
      
        .v-application .px-lg-6 {
          padding-right: 24px !important;
          padding-left: 24px !important;
        }
      
        .v-application .px-lg-7 {
          padding-right: 28px !important;
          padding-left: 28px !important;
        }
      
        .v-application .px-lg-8 {
          padding-right: 32px !important;
          padding-left: 32px !important;
        }
      
        .v-application .px-lg-9 {
          padding-right: 36px !important;
          padding-left: 36px !important;
        }
      
        .v-application .px-lg-10 {
          padding-right: 40px !important;
          padding-left: 40px !important;
        }
      
        .v-application .px-lg-11 {
          padding-right: 44px !important;
          padding-left: 44px !important;
        }
      
        .v-application .px-lg-12 {
          padding-right: 48px !important;
          padding-left: 48px !important;
        }
      
        .v-application .py-lg-0 {
          padding-top: 0px !important;
          padding-bottom: 0px !important;
        }
      
        .v-application .py-lg-1 {
          padding-top: 4px !important;
          padding-bottom: 4px !important;
        }
      
        .v-application .py-lg-2 {
          padding-top: 8px !important;
          padding-bottom: 8px !important;
        }
      
        .v-application .py-lg-3 {
          padding-top: 12px !important;
          padding-bottom: 12px !important;
        }
      
        .v-application .py-lg-4 {
          padding-top: 16px !important;
          padding-bottom: 16px !important;
        }
      
        .v-application .py-lg-5 {
          padding-top: 20px !important;
          padding-bottom: 20px !important;
        }
      
        .v-application .py-lg-6 {
          padding-top: 24px !important;
          padding-bottom: 24px !important;
        }
      
        .v-application .py-lg-7 {
          padding-top: 28px !important;
          padding-bottom: 28px !important;
        }
      
        .v-application .py-lg-8 {
          padding-top: 32px !important;
          padding-bottom: 32px !important;
        }
      
        .v-application .py-lg-9 {
          padding-top: 36px !important;
          padding-bottom: 36px !important;
        }
      
        .v-application .py-lg-10 {
          padding-top: 40px !important;
          padding-bottom: 40px !important;
        }
      
        .v-application .py-lg-11 {
          padding-top: 44px !important;
          padding-bottom: 44px !important;
        }
      
        .v-application .py-lg-12 {
          padding-top: 48px !important;
          padding-bottom: 48px !important;
        }
      
        .v-application .pt-lg-0 {
          padding-top: 0px !important;
        }
      
        .v-application .pt-lg-1 {
          padding-top: 4px !important;
        }
      
        .v-application .pt-lg-2 {
          padding-top: 8px !important;
        }
      
        .v-application .pt-lg-3 {
          padding-top: 12px !important;
        }
      
        .v-application .pt-lg-4 {
          padding-top: 16px !important;
        }
      
        .v-application .pt-lg-5 {
          padding-top: 20px !important;
        }
      
        .v-application .pt-lg-6 {
          padding-top: 24px !important;
        }
      
        .v-application .pt-lg-7 {
          padding-top: 28px !important;
        }
      
        .v-application .pt-lg-8 {
          padding-top: 32px !important;
        }
      
        .v-application .pt-lg-9 {
          padding-top: 36px !important;
        }
      
        .v-application .pt-lg-10 {
          padding-top: 40px !important;
        }
      
        .v-application .pt-lg-11 {
          padding-top: 44px !important;
        }
      
        .v-application .pt-lg-12 {
          padding-top: 48px !important;
        }
      
        .v-application .pr-lg-0 {
          padding-right: 0px !important;
        }
      
        .v-application .pr-lg-1 {
          padding-right: 4px !important;
        }
      
        .v-application .pr-lg-2 {
          padding-right: 8px !important;
        }
      
        .v-application .pr-lg-3 {
          padding-right: 12px !important;
        }
      
        .v-application .pr-lg-4 {
          padding-right: 16px !important;
        }
      
        .v-application .pr-lg-5 {
          padding-right: 20px !important;
        }
      
        .v-application .pr-lg-6 {
          padding-right: 24px !important;
        }
      
        .v-application .pr-lg-7 {
          padding-right: 28px !important;
        }
      
        .v-application .pr-lg-8 {
          padding-right: 32px !important;
        }
      
        .v-application .pr-lg-9 {
          padding-right: 36px !important;
        }
      
        .v-application .pr-lg-10 {
          padding-right: 40px !important;
        }
      
        .v-application .pr-lg-11 {
          padding-right: 44px !important;
        }
      
        .v-application .pr-lg-12 {
          padding-right: 48px !important;
        }
      
        .v-application .pb-lg-0 {
          padding-bottom: 0px !important;
        }
      
        .v-application .pb-lg-1 {
          padding-bottom: 4px !important;
        }
      
        .v-application .pb-lg-2 {
          padding-bottom: 8px !important;
        }
      
        .v-application .pb-lg-3 {
          padding-bottom: 12px !important;
        }
      
        .v-application .pb-lg-4 {
          padding-bottom: 16px !important;
        }
      
        .v-application .pb-lg-5 {
          padding-bottom: 20px !important;
        }
      
        .v-application .pb-lg-6 {
          padding-bottom: 24px !important;
        }
      
        .v-application .pb-lg-7 {
          padding-bottom: 28px !important;
        }
      
        .v-application .pb-lg-8 {
          padding-bottom: 32px !important;
        }
      
        .v-application .pb-lg-9 {
          padding-bottom: 36px !important;
        }
      
        .v-application .pb-lg-10 {
          padding-bottom: 40px !important;
        }
      
        .v-application .pb-lg-11 {
          padding-bottom: 44px !important;
        }
      
        .v-application .pb-lg-12 {
          padding-bottom: 48px !important;
        }
      
        .v-application .pl-lg-0 {
          padding-left: 0px !important;
        }
      
        .v-application .pl-lg-1 {
          padding-left: 4px !important;
        }
      
        .v-application .pl-lg-2 {
          padding-left: 8px !important;
        }
      
        .v-application .pl-lg-3 {
          padding-left: 12px !important;
        }
      
        .v-application .pl-lg-4 {
          padding-left: 16px !important;
        }
      
        .v-application .pl-lg-5 {
          padding-left: 20px !important;
        }
      
        .v-application .pl-lg-6 {
          padding-left: 24px !important;
        }
      
        .v-application .pl-lg-7 {
          padding-left: 28px !important;
        }
      
        .v-application .pl-lg-8 {
          padding-left: 32px !important;
        }
      
        .v-application .pl-lg-9 {
          padding-left: 36px !important;
        }
      
        .v-application .pl-lg-10 {
          padding-left: 40px !important;
        }
      
        .v-application .pl-lg-11 {
          padding-left: 44px !important;
        }
      
        .v-application .pl-lg-12 {
          padding-left: 48px !important;
        }
      
        .v-application--is-ltr .ps-lg-0 {
          padding-left: 0px !important;
        }
      
        .v-application--is-rtl .ps-lg-0 {
          padding-right: 0px !important;
        }
      
        .v-application--is-ltr .ps-lg-1 {
          padding-left: 4px !important;
        }
      
        .v-application--is-rtl .ps-lg-1 {
          padding-right: 4px !important;
        }
      
        .v-application--is-ltr .ps-lg-2 {
          padding-left: 8px !important;
        }
      
        .v-application--is-rtl .ps-lg-2 {
          padding-right: 8px !important;
        }
      
        .v-application--is-ltr .ps-lg-3 {
          padding-left: 12px !important;
        }
      
        .v-application--is-rtl .ps-lg-3 {
          padding-right: 12px !important;
        }
      
        .v-application--is-ltr .ps-lg-4 {
          padding-left: 16px !important;
        }
      
        .v-application--is-rtl .ps-lg-4 {
          padding-right: 16px !important;
        }
      
        .v-application--is-ltr .ps-lg-5 {
          padding-left: 20px !important;
        }
      
        .v-application--is-rtl .ps-lg-5 {
          padding-right: 20px !important;
        }
      
        .v-application--is-ltr .ps-lg-6 {
          padding-left: 24px !important;
        }
      
        .v-application--is-rtl .ps-lg-6 {
          padding-right: 24px !important;
        }
      
        .v-application--is-ltr .ps-lg-7 {
          padding-left: 28px !important;
        }
      
        .v-application--is-rtl .ps-lg-7 {
          padding-right: 28px !important;
        }
      
        .v-application--is-ltr .ps-lg-8 {
          padding-left: 32px !important;
        }
      
        .v-application--is-rtl .ps-lg-8 {
          padding-right: 32px !important;
        }
      
        .v-application--is-ltr .ps-lg-9 {
          padding-left: 36px !important;
        }
      
        .v-application--is-rtl .ps-lg-9 {
          padding-right: 36px !important;
        }
      
        .v-application--is-ltr .ps-lg-10 {
          padding-left: 40px !important;
        }
      
        .v-application--is-rtl .ps-lg-10 {
          padding-right: 40px !important;
        }
      
        .v-application--is-ltr .ps-lg-11 {
          padding-left: 44px !important;
        }
      
        .v-application--is-rtl .ps-lg-11 {
          padding-right: 44px !important;
        }
      
        .v-application--is-ltr .ps-lg-12 {
          padding-left: 48px !important;
        }
      
        .v-application--is-rtl .ps-lg-12 {
          padding-right: 48px !important;
        }
      
        .v-application--is-ltr .pe-lg-0 {
          padding-right: 0px !important;
        }
      
        .v-application--is-rtl .pe-lg-0 {
          padding-left: 0px !important;
        }
      
        .v-application--is-ltr .pe-lg-1 {
          padding-right: 4px !important;
        }
      
        .v-application--is-rtl .pe-lg-1 {
          padding-left: 4px !important;
        }
      
        .v-application--is-ltr .pe-lg-2 {
          padding-right: 8px !important;
        }
      
        .v-application--is-rtl .pe-lg-2 {
          padding-left: 8px !important;
        }
      
        .v-application--is-ltr .pe-lg-3 {
          padding-right: 12px !important;
        }
      
        .v-application--is-rtl .pe-lg-3 {
          padding-left: 12px !important;
        }
      
        .v-application--is-ltr .pe-lg-4 {
          padding-right: 16px !important;
        }
      
        .v-application--is-rtl .pe-lg-4 {
          padding-left: 16px !important;
        }
      
        .v-application--is-ltr .pe-lg-5 {
          padding-right: 20px !important;
        }
      
        .v-application--is-rtl .pe-lg-5 {
          padding-left: 20px !important;
        }
      
        .v-application--is-ltr .pe-lg-6 {
          padding-right: 24px !important;
        }
      
        .v-application--is-rtl .pe-lg-6 {
          padding-left: 24px !important;
        }
      
        .v-application--is-ltr .pe-lg-7 {
          padding-right: 28px !important;
        }
      
        .v-application--is-rtl .pe-lg-7 {
          padding-left: 28px !important;
        }
      
        .v-application--is-ltr .pe-lg-8 {
          padding-right: 32px !important;
        }
      
        .v-application--is-rtl .pe-lg-8 {
          padding-left: 32px !important;
        }
      
        .v-application--is-ltr .pe-lg-9 {
          padding-right: 36px !important;
        }
      
        .v-application--is-rtl .pe-lg-9 {
          padding-left: 36px !important;
        }
      
        .v-application--is-ltr .pe-lg-10 {
          padding-right: 40px !important;
        }
      
        .v-application--is-rtl .pe-lg-10 {
          padding-left: 40px !important;
        }
      
        .v-application--is-ltr .pe-lg-11 {
          padding-right: 44px !important;
        }
      
        .v-application--is-rtl .pe-lg-11 {
          padding-left: 44px !important;
        }
      
        .v-application--is-ltr .pe-lg-12 {
          padding-right: 48px !important;
        }
      
        .v-application--is-rtl .pe-lg-12 {
          padding-left: 48px !important;
        }
      
        .v-application .text-lg-left {
          text-align: left !important;
        }
      
        .v-application .text-lg-right {
          text-align: right !important;
        }
      
        .v-application .text-lg-center {
          text-align: center !important;
        }
      
        .v-application .text-lg-justify {
          text-align: justify !important;
        }
      
        .v-application .text-lg-start {
          text-align: start !important;
        }
      
        .v-application .text-lg-end {
          text-align: end !important;
        }
      }
      @media (min-width: 1904px) {
        .v-application .d-xl-none {
          display: none !important;
        }
      
        .v-application .d-xl-inline {
          display: inline !important;
        }
      
        .v-application .d-xl-inline-block {
          display: inline-block !important;
        }
      
        .v-application .d-xl-block {
          display: block !important;
        }
      
        .v-application .d-xl-table {
          display: table !important;
        }
      
        .v-application .d-xl-table-row {
          display: table-row !important;
        }
      
        .v-application .d-xl-table-cell {
          display: table-cell !important;
        }
      
        .v-application .d-xl-flex {
          display: -webkit-box !important;
          display: -ms-flexbox !important;
          display: flex !important;
        }
      
        .v-application .d-xl-inline-flex {
          display: -webkit-inline-box !important;
          display: -ms-inline-flexbox !important;
          display: inline-flex !important;
        }
      
        .v-application .float-xl-none {
          float: none !important;
        }
      
        .v-application .float-xl-left {
          float: left !important;
        }
      
        .v-application .float-xl-right {
          float: right !important;
        }
      
        .v-application .flex-xl-fill {
          -webkit-box-flex: 1 !important;
              -ms-flex: 1 1 auto !important;
                  flex: 1 1 auto !important;
        }
      
        .v-application .flex-xl-row {
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: normal !important;
              -ms-flex-direction: row !important;
                  flex-direction: row !important;
        }
      
        .v-application .flex-xl-column {
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: normal !important;
              -ms-flex-direction: column !important;
                  flex-direction: column !important;
        }
      
        .v-application .flex-xl-row-reverse {
          -webkit-box-orient: horizontal !important;
          -webkit-box-direction: reverse !important;
              -ms-flex-direction: row-reverse !important;
                  flex-direction: row-reverse !important;
        }
      
        .v-application .flex-xl-column-reverse {
          -webkit-box-orient: vertical !important;
          -webkit-box-direction: reverse !important;
              -ms-flex-direction: column-reverse !important;
                  flex-direction: column-reverse !important;
        }
      
        .v-application .flex-xl-grow-0 {
          -webkit-box-flex: 0 !important;
              -ms-flex-positive: 0 !important;
                  flex-grow: 0 !important;
        }
      
        .v-application .flex-xl-grow-1 {
          -webkit-box-flex: 1 !important;
              -ms-flex-positive: 1 !important;
                  flex-grow: 1 !important;
        }
      
        .v-application .flex-xl-shrink-0 {
          -ms-flex-negative: 0 !important;
              flex-shrink: 0 !important;
        }
      
        .v-application .flex-xl-shrink-1 {
          -ms-flex-negative: 1 !important;
              flex-shrink: 1 !important;
        }
      
        .v-application .flex-xl-wrap {
          -ms-flex-wrap: wrap !important;
              flex-wrap: wrap !important;
        }
      
        .v-application .flex-xl-nowrap {
          -ms-flex-wrap: nowrap !important;
              flex-wrap: nowrap !important;
        }
      
        .v-application .flex-xl-wrap-reverse {
          -ms-flex-wrap: wrap-reverse !important;
              flex-wrap: wrap-reverse !important;
        }
      
        .v-application .justify-xl-start {
          -webkit-box-pack: start !important;
              -ms-flex-pack: start !important;
                  justify-content: flex-start !important;
        }
      
        .v-application .justify-xl-end {
          -webkit-box-pack: end !important;
              -ms-flex-pack: end !important;
                  justify-content: flex-end !important;
        }
      
        .v-application .justify-xl-center {
          -webkit-box-pack: center !important;
              -ms-flex-pack: center !important;
                  justify-content: center !important;
        }
      
        .v-application .justify-xl-space-between {
          -webkit-box-pack: justify !important;
              -ms-flex-pack: justify !important;
                  justify-content: space-between !important;
        }
      
        .v-application .justify-xl-space-around {
          -ms-flex-pack: distribute !important;
              justify-content: space-around !important;
        }
      
        .v-application .align-xl-start {
          -webkit-box-align: start !important;
              -ms-flex-align: start !important;
                  align-items: flex-start !important;
        }
      
        .v-application .align-xl-end {
          -webkit-box-align: end !important;
              -ms-flex-align: end !important;
                  align-items: flex-end !important;
        }
      
        .v-application .align-xl-center {
          -webkit-box-align: center !important;
              -ms-flex-align: center !important;
                  align-items: center !important;
        }
      
        .v-application .align-xl-baseline {
          -webkit-box-align: baseline !important;
              -ms-flex-align: baseline !important;
                  align-items: baseline !important;
        }
      
        .v-application .align-xl-stretch {
          -webkit-box-align: stretch !important;
              -ms-flex-align: stretch !important;
                  align-items: stretch !important;
        }
      
        .v-application .align-content-xl-start {
          -ms-flex-line-pack: start !important;
              align-content: flex-start !important;
        }
      
        .v-application .align-content-xl-end {
          -ms-flex-line-pack: end !important;
              align-content: flex-end !important;
        }
      
        .v-application .align-content-xl-center {
          -ms-flex-line-pack: center !important;
              align-content: center !important;
        }
      
        .v-application .align-content-xl-space-between {
          -ms-flex-line-pack: justify !important;
              align-content: space-between !important;
        }
      
        .v-application .align-content-xl-space-around {
          -ms-flex-line-pack: distribute !important;
              align-content: space-around !important;
        }
      
        .v-application .align-content-xl-stretch {
          -ms-flex-line-pack: stretch !important;
              align-content: stretch !important;
        }
      
        .v-application .align-self-xl-auto {
          -ms-flex-item-align: auto !important;
              align-self: auto !important;
        }
      
        .v-application .align-self-xl-start {
          -ms-flex-item-align: start !important;
              align-self: flex-start !important;
        }
      
        .v-application .align-self-xl-end {
          -ms-flex-item-align: end !important;
              align-self: flex-end !important;
        }
      
        .v-application .align-self-xl-center {
          -ms-flex-item-align: center !important;
              align-self: center !important;
        }
      
        .v-application .align-self-xl-baseline {
          -ms-flex-item-align: baseline !important;
              align-self: baseline !important;
        }
      
        .v-application .align-self-xl-stretch {
          -ms-flex-item-align: stretch !important;
              align-self: stretch !important;
        }
      
        .v-application .order-xl-first {
          -webkit-box-ordinal-group: 0 !important;
              -ms-flex-order: -1 !important;
                  order: -1 !important;
        }
      
        .v-application .order-xl-0 {
          -webkit-box-ordinal-group: 1 !important;
              -ms-flex-order: 0 !important;
                  order: 0 !important;
        }
      
        .v-application .order-xl-1 {
          -webkit-box-ordinal-group: 2 !important;
              -ms-flex-order: 1 !important;
                  order: 1 !important;
        }
      
        .v-application .order-xl-2 {
          -webkit-box-ordinal-group: 3 !important;
              -ms-flex-order: 2 !important;
                  order: 2 !important;
        }
      
        .v-application .order-xl-3 {
          -webkit-box-ordinal-group: 4 !important;
              -ms-flex-order: 3 !important;
                  order: 3 !important;
        }
      
        .v-application .order-xl-4 {
          -webkit-box-ordinal-group: 5 !important;
              -ms-flex-order: 4 !important;
                  order: 4 !important;
        }
      
        .v-application .order-xl-5 {
          -webkit-box-ordinal-group: 6 !important;
              -ms-flex-order: 5 !important;
                  order: 5 !important;
        }
      
        .v-application .order-xl-6 {
          -webkit-box-ordinal-group: 7 !important;
              -ms-flex-order: 6 !important;
                  order: 6 !important;
        }
      
        .v-application .order-xl-7 {
          -webkit-box-ordinal-group: 8 !important;
              -ms-flex-order: 7 !important;
                  order: 7 !important;
        }
      
        .v-application .order-xl-8 {
          -webkit-box-ordinal-group: 9 !important;
              -ms-flex-order: 8 !important;
                  order: 8 !important;
        }
      
        .v-application .order-xl-9 {
          -webkit-box-ordinal-group: 10 !important;
              -ms-flex-order: 9 !important;
                  order: 9 !important;
        }
      
        .v-application .order-xl-10 {
          -webkit-box-ordinal-group: 11 !important;
              -ms-flex-order: 10 !important;
                  order: 10 !important;
        }
      
        .v-application .order-xl-11 {
          -webkit-box-ordinal-group: 12 !important;
              -ms-flex-order: 11 !important;
                  order: 11 !important;
        }
      
        .v-application .order-xl-12 {
          -webkit-box-ordinal-group: 13 !important;
              -ms-flex-order: 12 !important;
                  order: 12 !important;
        }
      
        .v-application .order-xl-last {
          -webkit-box-ordinal-group: 14 !important;
              -ms-flex-order: 13 !important;
                  order: 13 !important;
        }
      
        .v-application .ma-xl-0 {
          margin: 0px !important;
        }
      
        .v-application .ma-xl-1 {
          margin: 4px !important;
        }
      
        .v-application .ma-xl-2 {
          margin: 8px !important;
        }
      
        .v-application .ma-xl-3 {
          margin: 12px !important;
        }
      
        .v-application .ma-xl-4 {
          margin: 16px !important;
        }
      
        .v-application .ma-xl-5 {
          margin: 20px !important;
        }
      
        .v-application .ma-xl-6 {
          margin: 24px !important;
        }
      
        .v-application .ma-xl-7 {
          margin: 28px !important;
        }
      
        .v-application .ma-xl-8 {
          margin: 32px !important;
        }
      
        .v-application .ma-xl-9 {
          margin: 36px !important;
        }
      
        .v-application .ma-xl-10 {
          margin: 40px !important;
        }
      
        .v-application .ma-xl-11 {
          margin: 44px !important;
        }
      
        .v-application .ma-xl-12 {
          margin: 48px !important;
        }
      
        .v-application .ma-xl-auto {
          margin: auto !important;
        }
      
        .v-application .mx-xl-0 {
          margin-right: 0px !important;
          margin-left: 0px !important;
        }
      
        .v-application .mx-xl-1 {
          margin-right: 4px !important;
          margin-left: 4px !important;
        }
      
        .v-application .mx-xl-2 {
          margin-right: 8px !important;
          margin-left: 8px !important;
        }
      
        .v-application .mx-xl-3 {
          margin-right: 12px !important;
          margin-left: 12px !important;
        }
      
        .v-application .mx-xl-4 {
          margin-right: 16px !important;
          margin-left: 16px !important;
        }
      
        .v-application .mx-xl-5 {
          margin-right: 20px !important;
          margin-left: 20px !important;
        }
      
        .v-application .mx-xl-6 {
          margin-right: 24px !important;
          margin-left: 24px !important;
        }
      
        .v-application .mx-xl-7 {
          margin-right: 28px !important;
          margin-left: 28px !important;
        }
      
        .v-application .mx-xl-8 {
          margin-right: 32px !important;
          margin-left: 32px !important;
        }
      
        .v-application .mx-xl-9 {
          margin-right: 36px !important;
          margin-left: 36px !important;
        }
      
        .v-application .mx-xl-10 {
          margin-right: 40px !important;
          margin-left: 40px !important;
        }
      
        .v-application .mx-xl-11 {
          margin-right: 44px !important;
          margin-left: 44px !important;
        }
      
        .v-application .mx-xl-12 {
          margin-right: 48px !important;
          margin-left: 48px !important;
        }
      
        .v-application .mx-xl-auto {
          margin-right: auto !important;
          margin-left: auto !important;
        }
      
        .v-application .my-xl-0 {
          margin-top: 0px !important;
          margin-bottom: 0px !important;
        }
      
        .v-application .my-xl-1 {
          margin-top: 4px !important;
          margin-bottom: 4px !important;
        }
      
        .v-application .my-xl-2 {
          margin-top: 8px !important;
          margin-bottom: 8px !important;
        }
      
        .v-application .my-xl-3 {
          margin-top: 12px !important;
          margin-bottom: 12px !important;
        }
      
        .v-application .my-xl-4 {
          margin-top: 16px !important;
          margin-bottom: 16px !important;
        }
      
        .v-application .my-xl-5 {
          margin-top: 20px !important;
          margin-bottom: 20px !important;
        }
      
        .v-application .my-xl-6 {
          margin-top: 24px !important;
          margin-bottom: 24px !important;
        }
      
        .v-application .my-xl-7 {
          margin-top: 28px !important;
          margin-bottom: 28px !important;
        }
      
        .v-application .my-xl-8 {
          margin-top: 32px !important;
          margin-bottom: 32px !important;
        }
      
        .v-application .my-xl-9 {
          margin-top: 36px !important;
          margin-bottom: 36px !important;
        }
      
        .v-application .my-xl-10 {
          margin-top: 40px !important;
          margin-bottom: 40px !important;
        }
      
        .v-application .my-xl-11 {
          margin-top: 44px !important;
          margin-bottom: 44px !important;
        }
      
        .v-application .my-xl-12 {
          margin-top: 48px !important;
          margin-bottom: 48px !important;
        }
      
        .v-application .my-xl-auto {
          margin-top: auto !important;
          margin-bottom: auto !important;
        }
      
        .v-application .mt-xl-0 {
          margin-top: 0px !important;
        }
      
        .v-application .mt-xl-1 {
          margin-top: 4px !important;
        }
      
        .v-application .mt-xl-2 {
          margin-top: 8px !important;
        }
      
        .v-application .mt-xl-3 {
          margin-top: 12px !important;
        }
      
        .v-application .mt-xl-4 {
          margin-top: 16px !important;
        }
      
        .v-application .mt-xl-5 {
          margin-top: 20px !important;
        }
      
        .v-application .mt-xl-6 {
          margin-top: 24px !important;
        }
      
        .v-application .mt-xl-7 {
          margin-top: 28px !important;
        }
      
        .v-application .mt-xl-8 {
          margin-top: 32px !important;
        }
      
        .v-application .mt-xl-9 {
          margin-top: 36px !important;
        }
      
        .v-application .mt-xl-10 {
          margin-top: 40px !important;
        }
      
        .v-application .mt-xl-11 {
          margin-top: 44px !important;
        }
      
        .v-application .mt-xl-12 {
          margin-top: 48px !important;
        }
      
        .v-application .mt-xl-auto {
          margin-top: auto !important;
        }
      
        .v-application .mr-xl-0 {
          margin-right: 0px !important;
        }
      
        .v-application .mr-xl-1 {
          margin-right: 4px !important;
        }
      
        .v-application .mr-xl-2 {
          margin-right: 8px !important;
        }
      
        .v-application .mr-xl-3 {
          margin-right: 12px !important;
        }
      
        .v-application .mr-xl-4 {
          margin-right: 16px !important;
        }
      
        .v-application .mr-xl-5 {
          margin-right: 20px !important;
        }
      
        .v-application .mr-xl-6 {
          margin-right: 24px !important;
        }
      
        .v-application .mr-xl-7 {
          margin-right: 28px !important;
        }
      
        .v-application .mr-xl-8 {
          margin-right: 32px !important;
        }
      
        .v-application .mr-xl-9 {
          margin-right: 36px !important;
        }
      
        .v-application .mr-xl-10 {
          margin-right: 40px !important;
        }
      
        .v-application .mr-xl-11 {
          margin-right: 44px !important;
        }
      
        .v-application .mr-xl-12 {
          margin-right: 48px !important;
        }
      
        .v-application .mr-xl-auto {
          margin-right: auto !important;
        }
      
        .v-application .mb-xl-0 {
          margin-bottom: 0px !important;
        }
      
        .v-application .mb-xl-1 {
          margin-bottom: 4px !important;
        }
      
        .v-application .mb-xl-2 {
          margin-bottom: 8px !important;
        }
      
        .v-application .mb-xl-3 {
          margin-bottom: 12px !important;
        }
      
        .v-application .mb-xl-4 {
          margin-bottom: 16px !important;
        }
      
        .v-application .mb-xl-5 {
          margin-bottom: 20px !important;
        }
      
        .v-application .mb-xl-6 {
          margin-bottom: 24px !important;
        }
      
        .v-application .mb-xl-7 {
          margin-bottom: 28px !important;
        }
      
        .v-application .mb-xl-8 {
          margin-bottom: 32px !important;
        }
      
        .v-application .mb-xl-9 {
          margin-bottom: 36px !important;
        }
      
        .v-application .mb-xl-10 {
          margin-bottom: 40px !important;
        }
      
        .v-application .mb-xl-11 {
          margin-bottom: 44px !important;
        }
      
        .v-application .mb-xl-12 {
          margin-bottom: 48px !important;
        }
      
        .v-application .mb-xl-auto {
          margin-bottom: auto !important;
        }
      
        .v-application .ml-xl-0 {
          margin-left: 0px !important;
        }
      
        .v-application .ml-xl-1 {
          margin-left: 4px !important;
        }
      
        .v-application .ml-xl-2 {
          margin-left: 8px !important;
        }
      
        .v-application .ml-xl-3 {
          margin-left: 12px !important;
        }
      
        .v-application .ml-xl-4 {
          margin-left: 16px !important;
        }
      
        .v-application .ml-xl-5 {
          margin-left: 20px !important;
        }
      
        .v-application .ml-xl-6 {
          margin-left: 24px !important;
        }
      
        .v-application .ml-xl-7 {
          margin-left: 28px !important;
        }
      
        .v-application .ml-xl-8 {
          margin-left: 32px !important;
        }
      
        .v-application .ml-xl-9 {
          margin-left: 36px !important;
        }
      
        .v-application .ml-xl-10 {
          margin-left: 40px !important;
        }
      
        .v-application .ml-xl-11 {
          margin-left: 44px !important;
        }
      
        .v-application .ml-xl-12 {
          margin-left: 48px !important;
        }
      
        .v-application .ml-xl-auto {
          margin-left: auto !important;
        }
      
        .v-application--is-ltr .ms-xl-0 {
          margin-left: 0px !important;
        }
      
        .v-application--is-rtl .ms-xl-0 {
          margin-right: 0px !important;
        }
      
        .v-application--is-ltr .ms-xl-1 {
          margin-left: 4px !important;
        }
      
        .v-application--is-rtl .ms-xl-1 {
          margin-right: 4px !important;
        }
      
        .v-application--is-ltr .ms-xl-2 {
          margin-left: 8px !important;
        }
      
        .v-application--is-rtl .ms-xl-2 {
          margin-right: 8px !important;
        }
      
        .v-application--is-ltr .ms-xl-3 {
          margin-left: 12px !important;
        }
      
        .v-application--is-rtl .ms-xl-3 {
          margin-right: 12px !important;
        }
      
        .v-application--is-ltr .ms-xl-4 {
          margin-left: 16px !important;
        }
      
        .v-application--is-rtl .ms-xl-4 {
          margin-right: 16px !important;
        }
      
        .v-application--is-ltr .ms-xl-5 {
          margin-left: 20px !important;
        }
      
        .v-application--is-rtl .ms-xl-5 {
          margin-right: 20px !important;
        }
      
        .v-application--is-ltr .ms-xl-6 {
          margin-left: 24px !important;
        }
      
        .v-application--is-rtl .ms-xl-6 {
          margin-right: 24px !important;
        }
      
        .v-application--is-ltr .ms-xl-7 {
          margin-left: 28px !important;
        }
      
        .v-application--is-rtl .ms-xl-7 {
          margin-right: 28px !important;
        }
      
        .v-application--is-ltr .ms-xl-8 {
          margin-left: 32px !important;
        }
      
        .v-application--is-rtl .ms-xl-8 {
          margin-right: 32px !important;
        }
      
        .v-application--is-ltr .ms-xl-9 {
          margin-left: 36px !important;
        }
      
        .v-application--is-rtl .ms-xl-9 {
          margin-right: 36px !important;
        }
      
        .v-application--is-ltr .ms-xl-10 {
          margin-left: 40px !important;
        }
      
        .v-application--is-rtl .ms-xl-10 {
          margin-right: 40px !important;
        }
      
        .v-application--is-ltr .ms-xl-11 {
          margin-left: 44px !important;
        }
      
        .v-application--is-rtl .ms-xl-11 {
          margin-right: 44px !important;
        }
      
        .v-application--is-ltr .ms-xl-12 {
          margin-left: 48px !important;
        }
      
        .v-application--is-rtl .ms-xl-12 {
          margin-right: 48px !important;
        }
      
        .v-application--is-ltr .ms-xl-auto {
          margin-left: auto !important;
        }
      
        .v-application--is-rtl .ms-xl-auto {
          margin-right: auto !important;
        }
      
        .v-application--is-ltr .me-xl-0 {
          margin-right: 0px !important;
        }
      
        .v-application--is-rtl .me-xl-0 {
          margin-left: 0px !important;
        }
      
        .v-application--is-ltr .me-xl-1 {
          margin-right: 4px !important;
        }
      
        .v-application--is-rtl .me-xl-1 {
          margin-left: 4px !important;
        }
      
        .v-application--is-ltr .me-xl-2 {
          margin-right: 8px !important;
        }
      
        .v-application--is-rtl .me-xl-2 {
          margin-left: 8px !important;
        }
      
        .v-application--is-ltr .me-xl-3 {
          margin-right: 12px !important;
        }
      
        .v-application--is-rtl .me-xl-3 {
          margin-left: 12px !important;
        }
      
        .v-application--is-ltr .me-xl-4 {
          margin-right: 16px !important;
        }
      
        .v-application--is-rtl .me-xl-4 {
          margin-left: 16px !important;
        }
      
        .v-application--is-ltr .me-xl-5 {
          margin-right: 20px !important;
        }
      
        .v-application--is-rtl .me-xl-5 {
          margin-left: 20px !important;
        }
      
        .v-application--is-ltr .me-xl-6 {
          margin-right: 24px !important;
        }
      
        .v-application--is-rtl .me-xl-6 {
          margin-left: 24px !important;
        }
      
        .v-application--is-ltr .me-xl-7 {
          margin-right: 28px !important;
        }
      
        .v-application--is-rtl .me-xl-7 {
          margin-left: 28px !important;
        }
      
        .v-application--is-ltr .me-xl-8 {
          margin-right: 32px !important;
        }
      
        .v-application--is-rtl .me-xl-8 {
          margin-left: 32px !important;
        }
      
        .v-application--is-ltr .me-xl-9 {
          margin-right: 36px !important;
        }
      
        .v-application--is-rtl .me-xl-9 {
          margin-left: 36px !important;
        }
      
        .v-application--is-ltr .me-xl-10 {
          margin-right: 40px !important;
        }
      
        .v-application--is-rtl .me-xl-10 {
          margin-left: 40px !important;
        }
      
        .v-application--is-ltr .me-xl-11 {
          margin-right: 44px !important;
        }
      
        .v-application--is-rtl .me-xl-11 {
          margin-left: 44px !important;
        }
      
        .v-application--is-ltr .me-xl-12 {
          margin-right: 48px !important;
        }
      
        .v-application--is-rtl .me-xl-12 {
          margin-left: 48px !important;
        }
      
        .v-application--is-ltr .me-xl-auto {
          margin-right: auto !important;
        }
      
        .v-application--is-rtl .me-xl-auto {
          margin-left: auto !important;
        }
      
        .v-application .ma-xl-n1 {
          margin: -4px !important;
        }
      
        .v-application .ma-xl-n2 {
          margin: -8px !important;
        }
      
        .v-application .ma-xl-n3 {
          margin: -12px !important;
        }
      
        .v-application .ma-xl-n4 {
          margin: -16px !important;
        }
      
        .v-application .ma-xl-n5 {
          margin: -20px !important;
        }
      
        .v-application .ma-xl-n6 {
          margin: -24px !important;
        }
      
        .v-application .ma-xl-n7 {
          margin: -28px !important;
        }
      
        .v-application .ma-xl-n8 {
          margin: -32px !important;
        }
      
        .v-application .ma-xl-n9 {
          margin: -36px !important;
        }
      
        .v-application .ma-xl-n10 {
          margin: -40px !important;
        }
      
        .v-application .ma-xl-n11 {
          margin: -44px !important;
        }
      
        .v-application .ma-xl-n12 {
          margin: -48px !important;
        }
      
        .v-application .mx-xl-n1 {
          margin-right: -4px !important;
          margin-left: -4px !important;
        }
      
        .v-application .mx-xl-n2 {
          margin-right: -8px !important;
          margin-left: -8px !important;
        }
      
        .v-application .mx-xl-n3 {
          margin-right: -12px !important;
          margin-left: -12px !important;
        }
      
        .v-application .mx-xl-n4 {
          margin-right: -16px !important;
          margin-left: -16px !important;
        }
      
        .v-application .mx-xl-n5 {
          margin-right: -20px !important;
          margin-left: -20px !important;
        }
      
        .v-application .mx-xl-n6 {
          margin-right: -24px !important;
          margin-left: -24px !important;
        }
      
        .v-application .mx-xl-n7 {
          margin-right: -28px !important;
          margin-left: -28px !important;
        }
      
        .v-application .mx-xl-n8 {
          margin-right: -32px !important;
          margin-left: -32px !important;
        }
      
        .v-application .mx-xl-n9 {
          margin-right: -36px !important;
          margin-left: -36px !important;
        }
      
        .v-application .mx-xl-n10 {
          margin-right: -40px !important;
          margin-left: -40px !important;
        }
      
        .v-application .mx-xl-n11 {
          margin-right: -44px !important;
          margin-left: -44px !important;
        }
      
        .v-application .mx-xl-n12 {
          margin-right: -48px !important;
          margin-left: -48px !important;
        }
      
        .v-application .my-xl-n1 {
          margin-top: -4px !important;
          margin-bottom: -4px !important;
        }
      
        .v-application .my-xl-n2 {
          margin-top: -8px !important;
          margin-bottom: -8px !important;
        }
      
        .v-application .my-xl-n3 {
          margin-top: -12px !important;
          margin-bottom: -12px !important;
        }
      
        .v-application .my-xl-n4 {
          margin-top: -16px !important;
          margin-bottom: -16px !important;
        }
      
        .v-application .my-xl-n5 {
          margin-top: -20px !important;
          margin-bottom: -20px !important;
        }
      
        .v-application .my-xl-n6 {
          margin-top: -24px !important;
          margin-bottom: -24px !important;
        }
      
        .v-application .my-xl-n7 {
          margin-top: -28px !important;
          margin-bottom: -28px !important;
        }
      
        .v-application .my-xl-n8 {
          margin-top: -32px !important;
          margin-bottom: -32px !important;
        }
      
        .v-application .my-xl-n9 {
          margin-top: -36px !important;
          margin-bottom: -36px !important;
        }
      
        .v-application .my-xl-n10 {
          margin-top: -40px !important;
          margin-bottom: -40px !important;
        }
      
        .v-application .my-xl-n11 {
          margin-top: -44px !important;
          margin-bottom: -44px !important;
        }
      
        .v-application .my-xl-n12 {
          margin-top: -48px !important;
          margin-bottom: -48px !important;
        }
      
        .v-application .mt-xl-n1 {
          margin-top: -4px !important;
        }
      
        .v-application .mt-xl-n2 {
          margin-top: -8px !important;
        }
      
        .v-application .mt-xl-n3 {
          margin-top: -12px !important;
        }
      
        .v-application .mt-xl-n4 {
          margin-top: -16px !important;
        }
      
        .v-application .mt-xl-n5 {
          margin-top: -20px !important;
        }
      
        .v-application .mt-xl-n6 {
          margin-top: -24px !important;
        }
      
        .v-application .mt-xl-n7 {
          margin-top: -28px !important;
        }
      
        .v-application .mt-xl-n8 {
          margin-top: -32px !important;
        }
      
        .v-application .mt-xl-n9 {
          margin-top: -36px !important;
        }
      
        .v-application .mt-xl-n10 {
          margin-top: -40px !important;
        }
      
        .v-application .mt-xl-n11 {
          margin-top: -44px !important;
        }
      
        .v-application .mt-xl-n12 {
          margin-top: -48px !important;
        }
      
        .v-application .mr-xl-n1 {
          margin-right: -4px !important;
        }
      
        .v-application .mr-xl-n2 {
          margin-right: -8px !important;
        }
      
        .v-application .mr-xl-n3 {
          margin-right: -12px !important;
        }
      
        .v-application .mr-xl-n4 {
          margin-right: -16px !important;
        }
      
        .v-application .mr-xl-n5 {
          margin-right: -20px !important;
        }
      
        .v-application .mr-xl-n6 {
          margin-right: -24px !important;
        }
      
        .v-application .mr-xl-n7 {
          margin-right: -28px !important;
        }
      
        .v-application .mr-xl-n8 {
          margin-right: -32px !important;
        }
      
        .v-application .mr-xl-n9 {
          margin-right: -36px !important;
        }
      
        .v-application .mr-xl-n10 {
          margin-right: -40px !important;
        }
      
        .v-application .mr-xl-n11 {
          margin-right: -44px !important;
        }
      
        .v-application .mr-xl-n12 {
          margin-right: -48px !important;
        }
      
        .v-application .mb-xl-n1 {
          margin-bottom: -4px !important;
        }
      
        .v-application .mb-xl-n2 {
          margin-bottom: -8px !important;
        }
      
        .v-application .mb-xl-n3 {
          margin-bottom: -12px !important;
        }
      
        .v-application .mb-xl-n4 {
          margin-bottom: -16px !important;
        }
      
        .v-application .mb-xl-n5 {
          margin-bottom: -20px !important;
        }
      
        .v-application .mb-xl-n6 {
          margin-bottom: -24px !important;
        }
      
        .v-application .mb-xl-n7 {
          margin-bottom: -28px !important;
        }
      
        .v-application .mb-xl-n8 {
          margin-bottom: -32px !important;
        }
      
        .v-application .mb-xl-n9 {
          margin-bottom: -36px !important;
        }
      
        .v-application .mb-xl-n10 {
          margin-bottom: -40px !important;
        }
      
        .v-application .mb-xl-n11 {
          margin-bottom: -44px !important;
        }
      
        .v-application .mb-xl-n12 {
          margin-bottom: -48px !important;
        }
      
        .v-application .ml-xl-n1 {
          margin-left: -4px !important;
        }
      
        .v-application .ml-xl-n2 {
          margin-left: -8px !important;
        }
      
        .v-application .ml-xl-n3 {
          margin-left: -12px !important;
        }
      
        .v-application .ml-xl-n4 {
          margin-left: -16px !important;
        }
      
        .v-application .ml-xl-n5 {
          margin-left: -20px !important;
        }
      
        .v-application .ml-xl-n6 {
          margin-left: -24px !important;
        }
      
        .v-application .ml-xl-n7 {
          margin-left: -28px !important;
        }
      
        .v-application .ml-xl-n8 {
          margin-left: -32px !important;
        }
      
        .v-application .ml-xl-n9 {
          margin-left: -36px !important;
        }
      
        .v-application .ml-xl-n10 {
          margin-left: -40px !important;
        }
      
        .v-application .ml-xl-n11 {
          margin-left: -44px !important;
        }
      
        .v-application .ml-xl-n12 {
          margin-left: -48px !important;
        }
      
        .v-application--is-ltr .ms-xl-n1 {
          margin-left: -4px !important;
        }
      
        .v-application--is-rtl .ms-xl-n1 {
          margin-right: -4px !important;
        }
      
        .v-application--is-ltr .ms-xl-n2 {
          margin-left: -8px !important;
        }
      
        .v-application--is-rtl .ms-xl-n2 {
          margin-right: -8px !important;
        }
      
        .v-application--is-ltr .ms-xl-n3 {
          margin-left: -12px !important;
        }
      
        .v-application--is-rtl .ms-xl-n3 {
          margin-right: -12px !important;
        }
      
        .v-application--is-ltr .ms-xl-n4 {
          margin-left: -16px !important;
        }
      
        .v-application--is-rtl .ms-xl-n4 {
          margin-right: -16px !important;
        }
      
        .v-application--is-ltr .ms-xl-n5 {
          margin-left: -20px !important;
        }
      
        .v-application--is-rtl .ms-xl-n5 {
          margin-right: -20px !important;
        }
      
        .v-application--is-ltr .ms-xl-n6 {
          margin-left: -24px !important;
        }
      
        .v-application--is-rtl .ms-xl-n6 {
          margin-right: -24px !important;
        }
      
        .v-application--is-ltr .ms-xl-n7 {
          margin-left: -28px !important;
        }
      
        .v-application--is-rtl .ms-xl-n7 {
          margin-right: -28px !important;
        }
      
        .v-application--is-ltr .ms-xl-n8 {
          margin-left: -32px !important;
        }
      
        .v-application--is-rtl .ms-xl-n8 {
          margin-right: -32px !important;
        }
      
        .v-application--is-ltr .ms-xl-n9 {
          margin-left: -36px !important;
        }
      
        .v-application--is-rtl .ms-xl-n9 {
          margin-right: -36px !important;
        }
      
        .v-application--is-ltr .ms-xl-n10 {
          margin-left: -40px !important;
        }
      
        .v-application--is-rtl .ms-xl-n10 {
          margin-right: -40px !important;
        }
      
        .v-application--is-ltr .ms-xl-n11 {
          margin-left: -44px !important;
        }
      
        .v-application--is-rtl .ms-xl-n11 {
          margin-right: -44px !important;
        }
      
        .v-application--is-ltr .ms-xl-n12 {
          margin-left: -48px !important;
        }
      
        .v-application--is-rtl .ms-xl-n12 {
          margin-right: -48px !important;
        }
      
        .v-application--is-ltr .me-xl-n1 {
          margin-right: -4px !important;
        }
      
        .v-application--is-rtl .me-xl-n1 {
          margin-left: -4px !important;
        }
      
        .v-application--is-ltr .me-xl-n2 {
          margin-right: -8px !important;
        }
      
        .v-application--is-rtl .me-xl-n2 {
          margin-left: -8px !important;
        }
      
        .v-application--is-ltr .me-xl-n3 {
          margin-right: -12px !important;
        }
      
        .v-application--is-rtl .me-xl-n3 {
          margin-left: -12px !important;
        }
      
        .v-application--is-ltr .me-xl-n4 {
          margin-right: -16px !important;
        }
      
        .v-application--is-rtl .me-xl-n4 {
          margin-left: -16px !important;
        }
      
        .v-application--is-ltr .me-xl-n5 {
          margin-right: -20px !important;
        }
      
        .v-application--is-rtl .me-xl-n5 {
          margin-left: -20px !important;
        }
      
        .v-application--is-ltr .me-xl-n6 {
          margin-right: -24px !important;
        }
      
        .v-application--is-rtl .me-xl-n6 {
          margin-left: -24px !important;
        }
      
        .v-application--is-ltr .me-xl-n7 {
          margin-right: -28px !important;
        }
      
        .v-application--is-rtl .me-xl-n7 {
          margin-left: -28px !important;
        }
      
        .v-application--is-ltr .me-xl-n8 {
          margin-right: -32px !important;
        }
      
        .v-application--is-rtl .me-xl-n8 {
          margin-left: -32px !important;
        }
      
        .v-application--is-ltr .me-xl-n9 {
          margin-right: -36px !important;
        }
      
        .v-application--is-rtl .me-xl-n9 {
          margin-left: -36px !important;
        }
      
        .v-application--is-ltr .me-xl-n10 {
          margin-right: -40px !important;
        }
      
        .v-application--is-rtl .me-xl-n10 {
          margin-left: -40px !important;
        }
      
        .v-application--is-ltr .me-xl-n11 {
          margin-right: -44px !important;
        }
      
        .v-application--is-rtl .me-xl-n11 {
          margin-left: -44px !important;
        }
      
        .v-application--is-ltr .me-xl-n12 {
          margin-right: -48px !important;
        }
      
        .v-application--is-rtl .me-xl-n12 {
          margin-left: -48px !important;
        }
      
        .v-application .pa-xl-0 {
          padding: 0px !important;
        }
      
        .v-application .pa-xl-1 {
          padding: 4px !important;
        }
      
        .v-application .pa-xl-2 {
          padding: 8px !important;
        }
      
        .v-application .pa-xl-3 {
          padding: 12px !important;
        }
      
        .v-application .pa-xl-4 {
          padding: 16px !important;
        }
      
        .v-application .pa-xl-5 {
          padding: 20px !important;
        }
      
        .v-application .pa-xl-6 {
          padding: 24px !important;
        }
      
        .v-application .pa-xl-7 {
          padding: 28px !important;
        }
      
        .v-application .pa-xl-8 {
          padding: 32px !important;
        }
      
        .v-application .pa-xl-9 {
          padding: 36px !important;
        }
      
        .v-application .pa-xl-10 {
          padding: 40px !important;
        }
      
        .v-application .pa-xl-11 {
          padding: 44px !important;
        }
      
        .v-application .pa-xl-12 {
          padding: 48px !important;
        }
      
        .v-application .px-xl-0 {
          padding-right: 0px !important;
          padding-left: 0px !important;
        }
      
        .v-application .px-xl-1 {
          padding-right: 4px !important;
          padding-left: 4px !important;
        }
      
        .v-application .px-xl-2 {
          padding-right: 8px !important;
          padding-left: 8px !important;
        }
      
        .v-application .px-xl-3 {
          padding-right: 12px !important;
          padding-left: 12px !important;
        }
      
        .v-application .px-xl-4 {
          padding-right: 16px !important;
          padding-left: 16px !important;
        }
      
        .v-application .px-xl-5 {
          padding-right: 20px !important;
          padding-left: 20px !important;
        }
      
        .v-application .px-xl-6 {
          padding-right: 24px !important;
          padding-left: 24px !important;
        }
      
        .v-application .px-xl-7 {
          padding-right: 28px !important;
          padding-left: 28px !important;
        }
      
        .v-application .px-xl-8 {
          padding-right: 32px !important;
          padding-left: 32px !important;
        }
      
        .v-application .px-xl-9 {
          padding-right: 36px !important;
          padding-left: 36px !important;
        }
      
        .v-application .px-xl-10 {
          padding-right: 40px !important;
          padding-left: 40px !important;
        }
      
        .v-application .px-xl-11 {
          padding-right: 44px !important;
          padding-left: 44px !important;
        }
      
        .v-application .px-xl-12 {
          padding-right: 48px !important;
          padding-left: 48px !important;
        }
      
        .v-application .py-xl-0 {
          padding-top: 0px !important;
          padding-bottom: 0px !important;
        }
      
        .v-application .py-xl-1 {
          padding-top: 4px !important;
          padding-bottom: 4px !important;
        }
      
        .v-application .py-xl-2 {
          padding-top: 8px !important;
          padding-bottom: 8px !important;
        }
      
        .v-application .py-xl-3 {
          padding-top: 12px !important;
          padding-bottom: 12px !important;
        }
      
        .v-application .py-xl-4 {
          padding-top: 16px !important;
          padding-bottom: 16px !important;
        }
      
        .v-application .py-xl-5 {
          padding-top: 20px !important;
          padding-bottom: 20px !important;
        }
      
        .v-application .py-xl-6 {
          padding-top: 24px !important;
          padding-bottom: 24px !important;
        }
      
        .v-application .py-xl-7 {
          padding-top: 28px !important;
          padding-bottom: 28px !important;
        }
      
        .v-application .py-xl-8 {
          padding-top: 32px !important;
          padding-bottom: 32px !important;
        }
      
        .v-application .py-xl-9 {
          padding-top: 36px !important;
          padding-bottom: 36px !important;
        }
      
        .v-application .py-xl-10 {
          padding-top: 40px !important;
          padding-bottom: 40px !important;
        }
      
        .v-application .py-xl-11 {
          padding-top: 44px !important;
          padding-bottom: 44px !important;
        }
      
        .v-application .py-xl-12 {
          padding-top: 48px !important;
          padding-bottom: 48px !important;
        }
      
        .v-application .pt-xl-0 {
          padding-top: 0px !important;
        }
      
        .v-application .pt-xl-1 {
          padding-top: 4px !important;
        }
      
        .v-application .pt-xl-2 {
          padding-top: 8px !important;
        }
      
        .v-application .pt-xl-3 {
          padding-top: 12px !important;
        }
      
        .v-application .pt-xl-4 {
          padding-top: 16px !important;
        }
      
        .v-application .pt-xl-5 {
          padding-top: 20px !important;
        }
      
        .v-application .pt-xl-6 {
          padding-top: 24px !important;
        }
      
        .v-application .pt-xl-7 {
          padding-top: 28px !important;
        }
      
        .v-application .pt-xl-8 {
          padding-top: 32px !important;
        }
      
        .v-application .pt-xl-9 {
          padding-top: 36px !important;
        }
      
        .v-application .pt-xl-10 {
          padding-top: 40px !important;
        }
      
        .v-application .pt-xl-11 {
          padding-top: 44px !important;
        }
      
        .v-application .pt-xl-12 {
          padding-top: 48px !important;
        }
      
        .v-application .pr-xl-0 {
          padding-right: 0px !important;
        }
      
        .v-application .pr-xl-1 {
          padding-right: 4px !important;
        }
      
        .v-application .pr-xl-2 {
          padding-right: 8px !important;
        }
      
        .v-application .pr-xl-3 {
          padding-right: 12px !important;
        }
      
        .v-application .pr-xl-4 {
          padding-right: 16px !important;
        }
      
        .v-application .pr-xl-5 {
          padding-right: 20px !important;
        }
      
        .v-application .pr-xl-6 {
          padding-right: 24px !important;
        }
      
        .v-application .pr-xl-7 {
          padding-right: 28px !important;
        }
      
        .v-application .pr-xl-8 {
          padding-right: 32px !important;
        }
      
        .v-application .pr-xl-9 {
          padding-right: 36px !important;
        }
      
        .v-application .pr-xl-10 {
          padding-right: 40px !important;
        }
      
        .v-application .pr-xl-11 {
          padding-right: 44px !important;
        }
      
        .v-application .pr-xl-12 {
          padding-right: 48px !important;
        }
      
        .v-application .pb-xl-0 {
          padding-bottom: 0px !important;
        }
      
        .v-application .pb-xl-1 {
          padding-bottom: 4px !important;
        }
      
        .v-application .pb-xl-2 {
          padding-bottom: 8px !important;
        }
      
        .v-application .pb-xl-3 {
          padding-bottom: 12px !important;
        }
      
        .v-application .pb-xl-4 {
          padding-bottom: 16px !important;
        }
      
        .v-application .pb-xl-5 {
          padding-bottom: 20px !important;
        }
      
        .v-application .pb-xl-6 {
          padding-bottom: 24px !important;
        }
      
        .v-application .pb-xl-7 {
          padding-bottom: 28px !important;
        }
      
        .v-application .pb-xl-8 {
          padding-bottom: 32px !important;
        }
      
        .v-application .pb-xl-9 {
          padding-bottom: 36px !important;
        }
      
        .v-application .pb-xl-10 {
          padding-bottom: 40px !important;
        }
      
        .v-application .pb-xl-11 {
          padding-bottom: 44px !important;
        }
      
        .v-application .pb-xl-12 {
          padding-bottom: 48px !important;
        }
      
        .v-application .pl-xl-0 {
          padding-left: 0px !important;
        }
      
        .v-application .pl-xl-1 {
          padding-left: 4px !important;
        }
      
        .v-application .pl-xl-2 {
          padding-left: 8px !important;
        }
      
        .v-application .pl-xl-3 {
          padding-left: 12px !important;
        }
      
        .v-application .pl-xl-4 {
          padding-left: 16px !important;
        }
      
        .v-application .pl-xl-5 {
          padding-left: 20px !important;
        }
      
        .v-application .pl-xl-6 {
          padding-left: 24px !important;
        }
      
        .v-application .pl-xl-7 {
          padding-left: 28px !important;
        }
      
        .v-application .pl-xl-8 {
          padding-left: 32px !important;
        }
      
        .v-application .pl-xl-9 {
          padding-left: 36px !important;
        }
      
        .v-application .pl-xl-10 {
          padding-left: 40px !important;
        }
      
        .v-application .pl-xl-11 {
          padding-left: 44px !important;
        }
      
        .v-application .pl-xl-12 {
          padding-left: 48px !important;
        }
      
        .v-application--is-ltr .ps-xl-0 {
          padding-left: 0px !important;
        }
      
        .v-application--is-rtl .ps-xl-0 {
          padding-right: 0px !important;
        }
      
        .v-application--is-ltr .ps-xl-1 {
          padding-left: 4px !important;
        }
      
        .v-application--is-rtl .ps-xl-1 {
          padding-right: 4px !important;
        }
      
        .v-application--is-ltr .ps-xl-2 {
          padding-left: 8px !important;
        }
      
        .v-application--is-rtl .ps-xl-2 {
          padding-right: 8px !important;
        }
      
        .v-application--is-ltr .ps-xl-3 {
          padding-left: 12px !important;
        }
      
        .v-application--is-rtl .ps-xl-3 {
          padding-right: 12px !important;
        }
      
        .v-application--is-ltr .ps-xl-4 {
          padding-left: 16px !important;
        }
      
        .v-application--is-rtl .ps-xl-4 {
          padding-right: 16px !important;
        }
      
        .v-application--is-ltr .ps-xl-5 {
          padding-left: 20px !important;
        }
      
        .v-application--is-rtl .ps-xl-5 {
          padding-right: 20px !important;
        }
      
        .v-application--is-ltr .ps-xl-6 {
          padding-left: 24px !important;
        }
      
        .v-application--is-rtl .ps-xl-6 {
          padding-right: 24px !important;
        }
      
        .v-application--is-ltr .ps-xl-7 {
          padding-left: 28px !important;
        }
      
        .v-application--is-rtl .ps-xl-7 {
          padding-right: 28px !important;
        }
      
        .v-application--is-ltr .ps-xl-8 {
          padding-left: 32px !important;
        }
      
        .v-application--is-rtl .ps-xl-8 {
          padding-right: 32px !important;
        }
      
        .v-application--is-ltr .ps-xl-9 {
          padding-left: 36px !important;
        }
      
        .v-application--is-rtl .ps-xl-9 {
          padding-right: 36px !important;
        }
      
        .v-application--is-ltr .ps-xl-10 {
          padding-left: 40px !important;
        }
      
        .v-application--is-rtl .ps-xl-10 {
          padding-right: 40px !important;
        }
      
        .v-application--is-ltr .ps-xl-11 {
          padding-left: 44px !important;
        }
      
        .v-application--is-rtl .ps-xl-11 {
          padding-right: 44px !important;
        }
      
        .v-application--is-ltr .ps-xl-12 {
          padding-left: 48px !important;
        }
      
        .v-application--is-rtl .ps-xl-12 {
          padding-right: 48px !important;
        }
      
        .v-application--is-ltr .pe-xl-0 {
          padding-right: 0px !important;
        }
      
        .v-application--is-rtl .pe-xl-0 {
          padding-left: 0px !important;
        }
      
        .v-application--is-ltr .pe-xl-1 {
          padding-right: 4px !important;
        }
      
        .v-application--is-rtl .pe-xl-1 {
          padding-left: 4px !important;
        }
      
        .v-application--is-ltr .pe-xl-2 {
          padding-right: 8px !important;
        }
      
        .v-application--is-rtl .pe-xl-2 {
          padding-left: 8px !important;
        }
      
        .v-application--is-ltr .pe-xl-3 {
          padding-right: 12px !important;
        }
      
        .v-application--is-rtl .pe-xl-3 {
          padding-left: 12px !important;
        }
      
        .v-application--is-ltr .pe-xl-4 {
          padding-right: 16px !important;
        }
      
        .v-application--is-rtl .pe-xl-4 {
          padding-left: 16px !important;
        }
      
        .v-application--is-ltr .pe-xl-5 {
          padding-right: 20px !important;
        }
      
        .v-application--is-rtl .pe-xl-5 {
          padding-left: 20px !important;
        }
      
        .v-application--is-ltr .pe-xl-6 {
          padding-right: 24px !important;
        }
      
        .v-application--is-rtl .pe-xl-6 {
          padding-left: 24px !important;
        }
      
        .v-application--is-ltr .pe-xl-7 {
          padding-right: 28px !important;
        }
      
        .v-application--is-rtl .pe-xl-7 {
          padding-left: 28px !important;
        }
      
        .v-application--is-ltr .pe-xl-8 {
          padding-right: 32px !important;
        }
      
        .v-application--is-rtl .pe-xl-8 {
          padding-left: 32px !important;
        }
      
        .v-application--is-ltr .pe-xl-9 {
          padding-right: 36px !important;
        }
      
        .v-application--is-rtl .pe-xl-9 {
          padding-left: 36px !important;
        }
      
        .v-application--is-ltr .pe-xl-10 {
          padding-right: 40px !important;
        }
      
        .v-application--is-rtl .pe-xl-10 {
          padding-left: 40px !important;
        }
      
        .v-application--is-ltr .pe-xl-11 {
          padding-right: 44px !important;
        }
      
        .v-application--is-rtl .pe-xl-11 {
          padding-left: 44px !important;
        }
      
        .v-application--is-ltr .pe-xl-12 {
          padding-right: 48px !important;
        }
      
        .v-application--is-rtl .pe-xl-12 {
          padding-left: 48px !important;
        }
      
        .v-application .text-xl-left {
          text-align: left !important;
        }
      
        .v-application .text-xl-right {
          text-align: right !important;
        }
      
        .v-application .text-xl-center {
          text-align: center !important;
        }
      
        .v-application .text-xl-justify {
          text-align: justify !important;
        }
      
        .v-application .text-xl-start {
          text-align: start !important;
        }
      
        .v-application .text-xl-end {
          text-align: end !important;
        }
      }
      @media print {
        .v-application .d-print-none {
          display: none !important;
        }
      
        .v-application .d-print-inline {
          display: inline !important;
        }
      
        .v-application .d-print-inline-block {
          display: inline-block !important;
        }
      
        .v-application .d-print-block {
          display: block !important;
        }
      
        .v-application .d-print-table {
          display: table !important;
        }
      
        .v-application .d-print-table-row {
          display: table-row !important;
        }
      
        .v-application .d-print-table-cell {
          display: table-cell !important;
        }
      
        .v-application .d-print-flex {
          display: -webkit-box !important;
          display: -ms-flexbox !important;
          display: flex !important;
        }
      
        .v-application .d-print-inline-flex {
          display: -webkit-inline-box !important;
          display: -ms-inline-flexbox !important;
          display: inline-flex !important;
        }
      
        .v-application .float-print-none {
          float: none !important;
        }
      
        .v-application .float-print-left {
          float: left !important;
        }
      
        .v-application .float-print-right {
          float: right !important;
        }
      }</style><style type="text/css">input.border-success[data-v-081e2ccc] {
        border: solid thin #0da313;
      }</style><style type="text/css">.vld-overlay {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        display: none;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        overflow: hidden;
        z-index: 1
      }
      
      .vld-overlay.is-active {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex
      }
      
      .vld-overlay.is-full-page {
        z-index: 999;
        position: fixed
      }
      
      .vld-overlay .vld-background {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        background: #fff;
        opacity: 0.5
      }
      
      .vld-overlay .vld-icon, .vld-parent {
        position: relative
      }
      
      </style><style type="text/css">
      .vue-map-container {
        position: relative;
      }
      .vue-map-container .vue-map {
        left: 0; right: 0; top: 0; bottom: 0;
        position: absolute;
      }
      .vue-map-hidden {
        display: none;
      }
      </style><style type="text/css">
      .vue-street-view-pano-container {
        position: relative;
      }
      .vue-street-view-pano-container .vue-street-view-pano {
        left: 0; right: 0; top: 0; bottom: 0;
        position: absolute;
      }
      </style><style type="text/css">/**
       * VueLayers
       * Web map Vue components with the power of OpenLayers
       *
       * @package vuelayers
       * @author Vladimir Vershinin <ghettovoice@gmail.com>
       * @version 0.11.4
       * @license MIT
       * @copyright (c) 2017-2019, Vladimir Vershinin <ghettovoice@gmail.com>
       */
      /* include OpenLayers styles */
      .ol-box {
        -webkit-box-sizing: border-box;
                box-sizing: border-box;
        border-radius: 2px;
        border: 2px solid blue; }
      .ol-mouse-position {
        top: 8px;
        right: 8px;
        position: absolute; }
      .ol-scale-line {
        background: rgba(0, 60, 136, 0.3);
        border-radius: 4px;
        bottom: 8px;
        left: 8px;
        padding: 2px;
        position: absolute; }
      .ol-scale-line-inner {
        border: 1px solid #eee;
        border-top: none;
        color: #eee;
        font-size: 10px;
        text-align: center;
        margin: 1px;
        will-change: contents, width; }
      .ol-overlay-container {
        will-change: left,right,top,bottom; }
      .ol-unsupported {
        display: none; }
      .ol-viewport, .ol-unselectable {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }
      .ol-selectable {
        -webkit-touch-callout: default;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        user-select: text; }
      .ol-grabbing {
        cursor: -webkit-grabbing;
        cursor: grabbing; }
      .ol-grab {
        cursor: move;
        cursor: -webkit-grab;
        cursor: grab; }
      .ol-control {
        position: absolute;
        background-color: rgba(255, 255, 255, 0.4);
        border-radius: 4px;
        padding: 2px; }
      .ol-control:hover {
        background-color: rgba(255, 255, 255, 0.6); }
      .ol-zoom {
        top: .5em;
        left: .5em; }
      .ol-rotate {
        top: .5em;
        right: .5em;
        -webkit-transition: opacity .25s linear, visibility 0s linear;
        transition: opacity .25s linear, visibility 0s linear; }
      .ol-rotate.ol-hidden {
        opacity: 0;
        visibility: hidden;
        -webkit-transition: opacity .25s linear, visibility 0s linear .25s;
        transition: opacity .25s linear, visibility 0s linear .25s; }
      .ol-zoom-extent {
        top: 4.643em;
        left: .5em; }
      .ol-full-screen {
        right: .5em;
        top: .5em; }
      @media print {
        .ol-control {
          display: none; } }
      .ol-control button {
        display: block;
        margin: 1px;
        padding: 0;
        color: white;
        font-size: 1.14em;
        font-weight: bold;
        text-decoration: none;
        text-align: center;
        height: 1.375em;
        width: 1.375em;
        line-height: .4em;
        background-color: rgba(0, 60, 136, 0.5);
        border: none;
        border-radius: 2px; }
      .ol-control button::-moz-focus-inner {
        border: none;
        padding: 0; }
      .ol-zoom-extent button {
        line-height: 1.4em; }
      .ol-compass {
        display: block;
        font-weight: normal;
        font-size: 1.2em;
        will-change: transform; }
      .ol-touch .ol-control button {
        font-size: 1.5em; }
      .ol-touch .ol-zoom-extent {
        top: 5.5em; }
      .ol-control button:hover,
      .ol-control button:focus {
        text-decoration: none;
        background-color: rgba(0, 60, 136, 0.7); }
      .ol-zoom .ol-zoom-in {
        border-radius: 2px 2px 0 0; }
      .ol-zoom .ol-zoom-out {
        border-radius: 0 0 2px 2px; }
      .ol-attribution {
        text-align: right;
        bottom: .5em;
        right: .5em;
        max-width: calc(100% - 1.3em); }
      .ol-attribution ul {
        margin: 0;
        padding: 0 .5em;
        font-size: .7rem;
        line-height: 1.375em;
        color: #000;
        text-shadow: 0 0 2px #fff; }
      .ol-attribution li {
        display: inline;
        list-style: none;
        line-height: inherit; }
      .ol-attribution li:not(:last-child):after {
        content: " "; }
      .ol-attribution img {
        max-height: 2em;
        max-width: inherit;
        vertical-align: middle; }
      .ol-attribution ul, .ol-attribution button {
        display: inline-block; }
      .ol-attribution.ol-collapsed ul {
        display: none; }
      .ol-attribution:not(.ol-collapsed) {
        background: rgba(255, 255, 255, 0.8); }
      .ol-attribution.ol-uncollapsible {
        bottom: 0;
        right: 0;
        border-radius: 4px 0 0;
        height: 1.1em;
        line-height: 1em; }
      .ol-attribution.ol-uncollapsible img {
        margin-top: -.2em;
        max-height: 1.6em; }
      .ol-attribution.ol-uncollapsible button {
        display: none; }
      .ol-zoomslider {
        top: 4.5em;
        left: .5em;
        height: 200px; }
      .ol-zoomslider button {
        position: relative;
        height: 10px; }
      .ol-touch .ol-zoomslider {
        top: 5.5em; }
      .ol-overviewmap {
        left: 0.5em;
        bottom: 0.5em; }
      .ol-overviewmap.ol-uncollapsible {
        bottom: 0;
        left: 0;
        border-radius: 0 4px 0 0; }
      .ol-overviewmap .ol-overviewmap-map,
      .ol-overviewmap button {
        display: inline-block; }
      .ol-overviewmap .ol-overviewmap-map {
        border: 1px solid #7b98bc;
        height: 150px;
        margin: 2px;
        width: 150px; }
      .ol-overviewmap:not(.ol-collapsed) button {
        bottom: 1px;
        left: 2px;
        position: absolute; }
      .ol-overviewmap.ol-collapsed .ol-overviewmap-map,
      .ol-overviewmap.ol-uncollapsible button {
        display: none; }
      .ol-overviewmap:not(.ol-collapsed) {
        background: rgba(255, 255, 255, 0.8); }
      .ol-overviewmap-box {
        border: 2px dotted rgba(0, 60, 136, 0.7); }
      .ol-overviewmap .ol-overviewmap-box:hover {
        cursor: move; }
      /* VueLayers base styles */
      .vl-map {
        width: 100%;
        height: 100%; }
      .vl-overlay {
        position: relative;
        visibility: hidden; }
      .vl-overlay.visible {
          visibility: visible; }</style><style type="text/css">
      .w-full[data-v-27213e1d] {
        width: 100%;
      }
      .inline-block[data-v-27213e1d] {
        display: inline-block;
      }
      .block[data-v-27213e1d] {
        display: block;
      }
      .flex[data-v-27213e1d] {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
      .border[data-v-27213e1d] {
        border-width: thin;
        border-style: solid;
      }
      .rounded[data-v-27213e1d] {
        border-radius: 0.25em;
      }
      .text-black[data-v-27213e1d] {
        color: #22292f;
      }
      .border-grey-lighter[data-v-27213e1d] {
        border-color: #ced4da;
      }
      .bg-grey-lighter[data-v-27213e1d] {
        background-color: #606f7b;
      }
      .bg-grey-light[data-v-27213e1d] {
        background-color: #dae1e7;
      }
      .bg-grey-dark[data-v-27213e1d] {
        background-color: #8795a1;
      }
      .bg-white[data-v-27213e1d] {
        background-color: #fff;
      }
      .pin-r[data-v-27213e1d] {
        right: 0;
      }
      .pin-y[data-v-27213e1d] {
        top: 0;
        bottom: 0;
      }
      .absolute[data-v-27213e1d] {
        position: absolute;
      }
      .relative[data-v-27213e1d] {
        position: relative;
      }
      .items-center[data-v-27213e1d] {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
      }
      .p-0[data-v-27213e1d] {
        padding: 0;
      }
      .p-1[data-v-27213e1d] {
        padding: 0.25em;
      }
      .px-1[data-v-27213e1d] {
        padding-left: 0.25em;
        padding-right: 0.25em;
      }
      .py-2[data-v-27213e1d] {
        padding-top: 0.5em;
        padding-bottom: 0.5em;
      }
      .px-2[data-v-27213e1d] {
        padding-left: 0.5em;
        padding-right: 0.5em;
      }
      .mt-px[data-v-27213e1d] {
        margin-top: 1px;
      }
      .leading-tight[data-v-27213e1d] {
        line-height: 1.25;
      }
      .leading-normal[data-v-27213e1d] {
        line-height: 1.5;
      }
      .text-left[data-v-27213e1d] {
        text-align: left;
      }
      .w-full[data-v-27213e1d] {
        width: 100%;
      }
      .shadow[data-v-27213e1d] {
        -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      }
      .list-reset[data-v-27213e1d] {
        list-style: none;
        padding: 0;
      }
      .overflow-auto[data-v-27213e1d] {
        overflow: auto;
      }
      .appearance-none[data-v-27213e1d] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
      }
      .w-1[data-v-27213e1d] {
        width: 0.25em;
      }
      .w-2[data-v-27213e1d] {
        width: 0.5em;
      }
      .w-3[data-v-27213e1d] {
        width: 0.75em;
      }
      .w-4[data-v-27213e1d] {
        width: 1em;
      }
      .h-4[data-v-27213e1d] {
        height: 1em;
      }
      .h-1[data-v-27213e1d] {
        height: 0.25em;
      }
      .h-2[data-v-27213e1d] {
        height: 0.5em;
      }
      .h-3[data-v-27213e1d] {
        height: 0.75em;
      }
      .fill-current[data-v-27213e1d] {
        fill: currentColor;
      }
      .no-underline[data-v-27213e1d] {
        text-decoration: none;
      }
      .hover\:no-underline[data-v-27213e1d]:hover {
        text-decoration: none;
      }
      .outline-none[data-v-27213e1d] {
        outline: 0;
      }
      .hover\:outline-none[data-v-27213e1d] {
        outline: 0;
      }
      .hover\:bg-grey-light[data-v-27213e1d]:hover {
        background-color: #dae1e7;
      }
      .shadow-md[data-v-27213e1d] {
        -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
      }
      .search-input[data-v-27213e1d] {
        display: block;
        width: 100%;
        padding: 0.375em 0.75em;
        font-size: 1em;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25em;
        -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        -webkit-box-sizing: border-box;
                box-sizing: border-box;
      }
      .icons[data-v-27213e1d] {
        padding: 0 1em;
        right: 0;
        top: 0;
        bottom: 0;
        fill: #606f7b;
      }
      .icons svg[data-v-27213e1d] {
        width: 0.75em;
        height: 0.75em;
      }
      .single-select-wrapper[data-v-27213e1d] {
        position: relative;
        margin-bottom: 0.5em;
      }
      .required[data-v-27213e1d] {
        _color: #721c24;
        _background-color: #f8d7da;
        border-color: #f5c6cb;
      }
      .cursor-pointer[data-v-27213e1d] {
        cursor: pointer;
      }
      .dropdown[data-v-27213e1d] {
        -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12),
          0 2px 4px 0 rgba(0, 0, 0, 0.08);
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
        background-color: #fff;
        color: #606f7b;
        border-radius: 0.25em;
        line-height: 1.25;
        text-align: left;
      }
      .dropdown > li[data-v-27213e1d] {
        padding: 0.5em 0.75em;
      }
      .active[data-v-27213e1d] {
        background: #dae1e7;
      }
      </style><style type="text/css">@font-face {
        font-family: "OneInventory";
        src: url(/fonts/OneInventory-Regular.208c0c77.woff) format("woff"), url(/fonts/OneInventory-Regular.5bb91cfe.ttf) format("truetype"), url(/img/OneInventory-Regular.fb68e9ea.svg) format("svg"), url(/fonts/OneInventory-Regular.49edb037.eot) format("embedded-opentype");
        font-weight: 300;
      }
      @font-face {
        font-family: "OneInventory";
        src: url(/fonts/OneInventory-Regular.208c0c77.woff) format("woff"), url(/fonts/OneInventory-Regular.5bb91cfe.ttf) format("truetype"), url(/img/OneInventory-Regular.fb68e9ea.svg) format("svg"), url(/fonts/OneInventory-Regular.49edb037.eot) format("embedded-opentype");
        font-weight: 400;
      }
      @font-face {
        font-family: "OneInventory";
        src: url(/fonts/OneInventory-Medium.5f438ea0.woff) format("woff"), url(/fonts/OneInventory-Medium.07cb21d1.ttf) format("truetype"), url(/img/OneInventory-Medium.2deebbfe.svg) format("svg"), url(/fonts/OneInventory-Medium.404e6ae4.eot) format("embedded-opentype");
        font-weight: 500;
      }
      @font-face {
        font-family: "OneInventory";
        src: url(/fonts/OneInventory-MediumItalic.7758d202.woff) format("woff"), url(/fonts/OneInventory-MediumItalic.d4ef50a3.ttf) format("truetype"), url(/img/OneInventory-MediumItalic.8b65b976.svg) format("svg"), url(/fonts/OneInventory-MediumItalic.97bca60d.eot) format("embedded-opentype");
        font-weight: 500;
        font-style: italic;
      }
      @font-face {
        font-family: "OneInventory";
        src: url(/fonts/OneInventory-Bold.8b55fc57.woff) format("woff"), url(/fonts/OneInventory-Bold.681bc2db.ttf) format("truetype"), url(/img/OneInventory-Bold.98ec930c.svg) format("svg"), url(/fonts/OneInventory-Bold.2ae1e3c2.eot) format("embedded-opentype");
        font-weight: bold;
      }</style><style type="text/css">@charset "UTF-8";
      @font-face {
        font-family: "icomoon";
        src: url(/fonts/icomoon.01da8d45.eot);
        src: url(/fonts/icomoon.01da8d45.eot#iefix) format("embedded-opentype"), url(/fonts/icomoon.d5796f65.ttf) format("truetype"), url(/fonts/icomoon.c81fa98e.woff) format("woff"), url(/img/icomoon.8695ac07.svg#icomoon) format("svg");
        font-weight: normal;
        font-style: normal;
        font-display: block;
      }
      [class^=icon-], [class*=" icon-"] {
        /* use !important to prevent issues with browser extensions that change fonts */
        font-family: "icomoon" !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }</style><style type="text/css">.flex-row, #register .content .steps {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
      }
      
      .flex-column, #register .content .steps .step, #register .content > div:nth-of-type(1), #register .content {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
      }
      
      #left-menu {
        position: fixed;
        top: 60px;
        padding: 30px 16px 0 24px;
        width: 310px;
        height: calc(100vh - 58px);
        color: #fff;
        background: #003e94;
        overflow: auto;
      }
      #left-menu .background {
        z-index: -1;
        background: url(/img/bg-pattern-gradien-re@3x.06f7b349.png);
        background-size: auto 190%;
        background-position: 190% 100%;
        background-repeat: no-repeat;
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
      }
      #left-menu hr {
        border-color: rgba(236, 228, 228, 0.12);
      }
      #left-menu .mb-26 {
        margin-bottom: 26px;
      }
      #left-menu ul {
        padding-left: 40px;
      }
      #left-menu ul li {
        margin-top: 18px;
      }
      #left-menu ul li:hover a {
        opacity: 1;
      }
      #left-menu ul li a {
        color: #fff;
        opacity: 0.8;
      }
      #left-menu .router-link-active {
        opacity: 1;
        font-weight: bold;
        color: #fed12f !important;
      }
      #left-menu .active span {
        opacity: 1;
      }
      #left-menu span {
        opacity: 0.8;
        line-height: 1.29;
      }
      #left-menu span.active {
        opacity: 1;
      }
      #left-menu span:hover {
        opacity: 1;
      }
      #left-menu span.icon {
        font-size: 20px;
        cursor: pointer;
      }
      #left-menu span.sub-header {
        display: block;
        opacity: 0.4;
        text-transform: uppercase;
        font-weight: bold;
        line-height: 1.25;
      }
      #left-menu span.main-item-title {
        margin-left: 20px;
      }
      #left-menu span.hotline {
        opacity: 1 !important;
        margin-left: -12px;
      }
      #left-menu .icon.active {
        color: #fed12f;
        opacity: 1;
      }
      #left-menu .copy-right {
        margin: 250px 0 20px 0px;
      }
      #left-menu .copy-right img {
        width: 160px;
      }
      #left-menu .copy-right p {
        font-size: 12px;
        margin-top: 6px;
        max-width: 210px;
      }
      
      #payment-method .layout.wrap > div {
        padding: 0 12px;
        margin: 0;
      }
      #payment-method .layout.wrap .v-messages {
        display: none;
      }
      #payment-method .row {
        display: block;
      }
      #payment-method .pay-gate-online .v-input__slot {
        margin-bottom: 0;
      }
      #payment-method .setting {
        margin-left: 32px;
      }
      #payment-method .setting button,
      #payment-method .setting i {
        font-size: 12px;
        color: #808080;
      }
      #payment-method .setting button.has-action {
        color: #173d8f;
      }
      
      #setting-screen {
        margin-left: 310px;
        margin-top: 60px;
      }
      #setting-screen .row-process {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        margin-bottom: 20px;
      }
      #setting-screen .row-process > div {
        width: 48%;
      }
      #setting-screen .email-setting {
        padding-bottom: 10px;
        border-bottom: solid thin #f6f6f6;
      }
      #setting-screen .setting-menu button {
        display: inline-block;
        padding: 20px 30px;
      }
      
      #gallary {
        margin-left: 310px;
        margin-top: 60px;
      }
      #gallary .top-container {
        margin: 20px 0;
        padding: 0 20px;
      }
      #gallary #image-gallary .btn-icon.delete {
        margin-right: 0px !important;
      }
      
      .image-gallary-modal {
        background: #fff;
      }
      .image-gallary-modal .v-image__image {
        background-size: contain;
      }
      .image-gallary-modal .row {
        padding: 20px;
        margin: 0;
      }
      
      #image-gallary .list-of-photos {
        max-height: 650px;
        overflow-y: auto;
      }
      #image-gallary .selecte-all-block {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding: 0 21px 15px 10px;
      }
      #image-gallary .img-elm {
        position: relative;
      }
      #image-gallary .img-elm .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        -o-object-fit: contain;
           object-fit: contain;
        border-radius: 8px;
        border: solid 2px #00a0dc;
        background-color: rgba(0, 160, 220, 0.3);
        z-index: 3;
        visibility: hidden;
      }
      #image-gallary .img-elm .mask.active {
        visibility: visible;
      }
      #image-gallary .img-elm:hover img {
        visibility: visible;
      }
      #image-gallary .img-elm img {
        position: absolute;
        right: 0;
        bottom: 2px;
        background: #fff;
        visibility: hidden;
        z-index: 2;
      }
      
      .Rectangle {
        position: relative;
        width: 460px;
        min-height: 635px;
        border-radius: 8px;
        background-image: url(/img/bg-pattern-gradien-re@3x.06f7b349.png), linear-gradient(183deg, #11499e, #1b3280);
        background-size: 250% 50%, 100%;
        margin: auto;
        text-align: center;
        padding: 20px 55px 30px;
      }
      
      .background {
        height: 100vh;
        background: url(/img/beach.352df9a4.jpg);
        background-size: 100%;
        background-repeat: round;
      }
      .background .ex-tip {
        z-index: 100;
        position: absolute;
        bottom: 0;
        left: 0px;
        display: block;
        background: #fff;
        padding: 5px;
        border: thin solid #000;
        color: #000;
        font-weight: normal;
        font-size: 12px;
        text-decoration: none;
      }
      
      #login input,
      #login .login {
        width: 350px;
        height: 51px;
        border-radius: 8px;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
                box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
      }
      #login .login {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        padding: 8px 0;
        background-color: #ccc;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
                box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
        font-weight: bold;
      }
      #login .login span,
      #login .login i {
        color: #fff;
      }
      #login .login.active {
        background-color: #fed12f;
      }
      #login .login-agent {
        border-top: solid thin #fff;
        padding: 10px 0;
      }
      #login .login-agent a {
        display: inline-block;
        font-weight: bold;
      }
      #login input {
        padding: 24px 10px;
      }
      #login .relative > .icon {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        right: 16px !important;
      }
      #login .relative span.icon {
        position: relative;
      }
      #login .relative span.icon.icon-Error {
        font-size: 16px;
      }
      #login img.one-inventory {
        margin-top: 50px;
        width: 80%;
      }
      #login label,
      #login p,
      #login h2,
      #login a {
        color: #fff;
      }
      #login p.title {
        font-size: 18px;
        font-weight: bold;
      }
      #login .bg-pattern-gradien-re {
        width: 100%;
        height: 346.8px;
        -o-object-fit: contain;
           object-fit: contain;
        position: absolute;
        top: 0;
        left: 0;
      }
      #login .Radius-5px {
        width: 80%;
        height: 51px;
        border-radius: 8px;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
                box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
        background-color: #ffffff;
      }
      #login h2,
      #login p,
      #login label,
      #login a {
        display: block;
        text-transform: capitalize;
      }
      #login h2 {
        margin-top: 64px;
        margin-bottom: 30px;
      }
      #login .error-message-login {
        background: #d9390d;
        padding: 13px 12px;
        text-align: left;
        text-transform: none;
      }
      #login > div {
        margin: 20px 0;
      }
      #login .forgot-password {
        margin-bottom: 25px;
      }
      #login .register {
        color: #fed12f;
        font-weight: bold;
        margin: 15px 0 20px 0;
      }
      #login label {
        margin-bottom: 10px;
      }
      #login .extranet {
        margin-bottom: 15px;
      }
      
      #register ::-webkit-input-placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        font-size: 14px;
        color: #b0b0b0;
        opacity: 1;
        /* Firefox */
      }
      
      #register ::-moz-placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        font-size: 14px;
        color: #b0b0b0;
        opacity: 1;
        /* Firefox */
      }
      
      #register :-ms-input-placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        font-size: 14px;
        color: #b0b0b0;
        opacity: 1;
        /* Firefox */
      }
      
      #register ::-ms-input-placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        font-size: 14px;
        color: #b0b0b0;
        opacity: 1;
        /* Firefox */
      }
      
      #register ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        font-size: 14px;
        color: #b0b0b0;
        opacity: 1;
        /* Firefox */
      }
      #register :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        font-size: 14px;
        color: #b0b0b0;
      }
      #register ::-ms-input-placeholder {
        /* Microsoft Edge */
        font-size: 14px;
        color: #b0b0b0;
      }
      #register .top-container {
        background-color: #fff;
        padding: 10px 125px;
      }
      #register .top-container img.one-inventory-blue {
        width: 220px;
      }
      #register .content {
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        margin: 20px 128px;
        padding: 16px 143px;
        background: #fff;
        border-radius: 8px;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
                box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
      }
      #register .content > div {
        width: 100%;
      }
      #register .content > div:nth-of-type(1) {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
      }
      #register .content > div:nth-of-type(1) p {
        text-align: center;
      }
      #register .content > div:nth-of-type(1) p:first-child {
        margin-top: 20px;
        width: 325px;
        font-size: 18px;
        font-weight: bold;
      }
      #register .content > div:nth-of-type(1) p:nth-child(2) {
        width: 450px;
      }
      #register .content .steps {
        width: 640px;
      }
      #register .content .steps .step {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -ms-flex-preferred-size: 140px;
            flex-basis: 140px;
      }
      #register .content .steps .step span {
        margin-top: 7px;
        font-weight: bold;
        color: #808080;
      }
      #register .content .steps .step span.active {
        color: #262626;
      }
      #register .content .steps .step .circle {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: #b4b4b4;
      }
      #register .content .steps .step .circle.active {
        background: #fed12f;
      }
      #register .content .steps hr {
        -webkit-box-flex: 1;
            -ms-flex: 1 1 0px;
                flex: 1 1 0;
        margin: 7px -40px 0;
        border-color: rgba(0, 0, 0, 0.12);
      }
      #register .logo {
        color: #000;
        font-size: 36px;
        text-align: left;
        background: #fff;
        padding: 10px 0;
        margin-bottom: 20px;
      }
      #register .personal-detail .sex {
        margin-top: 30px;
      }
      #register .personal-detail,
      #register .hotel-detail,
      #register .create-account {
        margin-top: 20px;
      }
      #register .personal-detail .row-process,
      #register .hotel-detail .row-process,
      #register .create-account .row-process {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
      }
      #register .personal-detail .row-process:nth-child(3),
      #register .hotel-detail .row-process:nth-child(3),
      #register .create-account .row-process:nth-child(3) {
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
      }
      #register .hotel-detail .row-process,
      #register .create-account .row-process {
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
      }
      #register label.title {
        display: block;
        text-align: left;
        margin-left: 10px;
      }
      #register .margin-bottom-20 {
        margin-bottom: 20px;
      }
      #register .bottom {
        margin-top: 20px;
        padding-top: 20px;
        border-top: solid 3px rgba(0, 0, 0, 0.05);
      }
      #register .bottom .btn {
        padding: 9px 0px;
        width: 160px;
        color: #808080;
        background: #dcdcdc;
      }
      #register .bottom .btn.register {
        color: #fff;
        background: #173d8f;
        border-radius: 8px;
      }
      #register .bottom .btn svg {
        margin: 0 8px;
      }
      #register .terms-of-use p {
        text-align: left;
      }
      #register .terms-of-use p:nth-child(1) {
        font-size: 12px;
        width: 288px;
      }
      #register .btn-register-complete {
        padding: 9px 0 12px !important;
        -webkit-box-flex: 0;
            -ms-flex: 0 0 309px;
                flex: 0 0 309px;
      }
      #register .create-account .icon {
        position: absolute;
        right: 10px;
      }
      #register .create-account .icon.check {
        color: #133a8d;
      }
      #register .create-account .icon.exclaimation,
      #register .create-account .invalid,
      #register .create-account .validation {
        color: #d9390d;
      }
      #register .create-account .validation {
        font-size: 12px;
        text-align: left;
        display: block;
        margin-top: 10px;
      }
      
      #final-register {
        text-align: center;
      }
      #final-register .btn-upload {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        margin: auto;
      }
      #final-register .img-mask {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        border-radius: 50%;
        margin: 30px auto;
        width: 120px;
        height: 120px;
        background-color: rgba(220, 220, 220, 0.2);
      }
      #final-register .text-content {
        margin: auto;
        width: 456px;
      }
      #final-register .text-content p:first-of-type {
        font-size: 18px;
        font-weight: bold;
        color: #173d8f;
      }
      #final-register .text-content p:nth-of-type(2) {
        font-size: 14px;
        width: 456px;
      }
      
      p.active {
        color: #000 !important;
        font-weight: bold;
      }
      
      #general-infomation {
        margin-left: 310px;
        margin-top: 60px;
      }
      #general-infomation .single-select-wrapper {
        margin-bottom: 0;
      }
      #general-infomation #upload-controller .container {
        margin-bottom: 0;
      }
      #general-infomation .hotel-gallary {
        max-height: 650px;
        overflow: hidden;
      }
      #general-infomation #image-gallary .list-of-photos {
        max-height: 580px;
        overflow-y: auto;
      }
      #general-infomation .tip {
        display: block;
        font-size: 12px;
        color: #808080;
        margin-left: 80px;
      }
      #general-infomation .dropbox {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        min-height: 121px !important;
      }
      #general-infomation .dropbox span {
        font-size: 24px;
        color: #173d8f;
      }
      #general-infomation .logo-box {
        min-height: 128px;
      }
      #general-infomation .logo-box img,
      #general-infomation .logo-box .mask {
        height: 128px;
        border-radius: 5px;
      }
      #general-infomation .logo-box:hover .mask {
        visibility: visible;
      }
      #general-infomation .logo-box .mask {
        visibility: hidden;
        position: absolute;
        width: 100%;
        top: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        background-color: rgba(128, 128, 128, 0.5);
      }
      #general-infomation .logo-box .mask span {
        margin: 0 8px;
        padding: 12px;
        border-radius: 5px;
        background: #fff;
        font-size: 24px;
        color: #173d8f;
      }
      #general-infomation .single-select-wrapper ul {
        max-height: 317px !important;
        -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
        background-color: #fff;
        color: #606f7b;
        border-radius: 0.25em;
        line-height: 1.25;
        text-align: left;
      }
      #general-infomation .single-select-wrapper ul li {
        margin: 0 10px;
        padding: 0.8em 0.25em;
        border-bottom: solid thin rgba(0, 0, 0, 0.1);
      }
      #general-infomation .glyphicon {
        color: #173d8f !important;
      }
      #general-infomation .required {
        border-color: #ff0000 !important;
      }
      
      #nearby-place i.btn-delete {
        margin-top: 36px;
      }
      
      #hotel-amenity .v-input__slot {
        margin-bottom: 4px;
      }
      #hotel-amenity .v-subheader {
        height: 14px;
      }
      #hotel-amenity .extension .v-input__control {
        height: 30px;
      }
      #hotel-amenity .extension .flex-box .v-input {
        margin-top: 0px;
        padding-top: 0px;
      }
      #hotel-amenity .extension-1 {
        width: 20px;
        height: 20px;
      }
      #hotel-amenity .amenity-group .col {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
      }
      #hotel-amenity .amenity .v-input__slot {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
      }
      
      #room-infomation,
      #list-room {
        margin-left: 310px;
        margin-top: 60px;
      }
      #room-infomation .hotel-gallary,
      #list-room .hotel-gallary {
        max-height: 640px;
        overflow: hidden;
      }
      #room-infomation #image-gallary .list-of-photos,
      #list-room #image-gallary .list-of-photos {
        max-height: 580px;
        overflow-y: auto;
      }
      #room-infomation .tip,
      #list-room .tip {
        display: block;
        font-size: 12px;
        color: #808080;
        margin-left: 80px;
      }
      
      #room-amenity .v-input__slot {
        margin-bottom: 4px;
      }
      #room-amenity .v-subheader {
        height: 14px;
      }
      #room-amenity .amenity-group .col {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
      }
      #room-amenity .amenity .v-input__slot {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
      }
      
      .date-picker .v-text-field {
        margin-top: 0;
        padding-top: 0;
      }
      
      #room-infomation-tab .day-not-applied #date-picker, #promotion-detail .day-not-applied #date-picker {
        padding-right: 8px;
      }
      
      .v-dialog .tab-header + .v-card {
        border-radius: 0 0 8px 8px;
      }
      .v-dialog .v-card {
        padding: 20px;
      }
      .v-dialog .headline {
        font-size: 14px !important;
        padding: 0;
      }
      .v-dialog .alert-box {
        background-color: #f9f9f9;
        padding: 30px 0;
        border-left: solid 2px #d9390d;
      }
      .v-dialog .alert-box p {
        margin-bottom: 0;
        text-align: center;
        font-size: 18px;
        line-height: 1.33;
        color: #808080;
      }
      
      .upload-dialog {
        overflow: hidden;
      }
      .upload-dialog button {
        border-radius: 8px;
        padding: 13px 30px;
        font-size: 14px;
      }
      .upload-dialog button.close-dialog {
        border: solid 1px #173d8f;
        color: #173d8f;
      }
      .upload-dialog button.delete {
        background-color: #d9390d;
        color: #ffffff;
      }
      .upload-dialog #image-gallary {
        overflow-x: hidden;
        max-height: 300px;
      }
      .upload-dialog #image-gallary .v-image {
        height: 76px !important;
      }
      .upload-dialog #image-gallary .container {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      
      #header {
        position: fixed;
        width: 100%;
        height: 60px;
        z-index: 99;
        background: #ffff;
        -webkit-box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);
                box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);
      }
      #header .notifications {
        padding-left: 10px;
        padding-right: 10px;
      }
      #header span {
        font-size: 18px;
      }
      #header img {
        -o-object-fit: cover;
           object-fit: cover;
      }
      #header .menu {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        min-width: 40px;
        height: 60px;
      }
      #header .menu:nth-of-type(3) {
        padding-left: 20px;
        padding-right: 30px;
      }
      #header .menu span {
        font-size: 14px;
      }
      #header .menu span.icon {
        color: #173d8f;
        font-size: 24px;
      }
      #header .menu > span:nth-of-type(1) {
        margin-left: 13px;
      }
      #header .menu img.avatar {
        width: 36px;
        height: 36px;
        border-radius: 5px;
      }
      #header .menu:hover ul {
        display: block;
      }
      #header .menu ul {
        position: absolute;
        top: 60px;
        right: 0px;
        display: none;
        border-radius: 5px;
        padding-left: 0;
        background: #ffff;
        -webkit-box-shadow: 0px 2px 2px #88888888;
                box-shadow: 0px 2px 2px #88888888;
        width: 260px;
      }
      #header .menu ul.language {
        width: 167px;
      }
      #header .menu ul li {
        padding: 10px 24px;
      }
      #header .menu ul li:hover {
        background: #ced4da;
      }
      #header .menu ul li span:nth-of-type(2) {
        margin-left: 13px;
      }
      
      * {
        -webkit-box-sizing: border-box;
                box-sizing: border-box;
      }
      
      html {
        scroll-behavior: smooth;
      }
      
      a,
      svg {
        cursor: pointer;
      }
      
      a,
      p,
      label,
      span,
      li {
        font-size: 14px;
      }
      
      li {
        list-style-type: none;
      }
      
      label.has-action:hover,
      span.has-action:hover {
        cursor: pointer;
        color: #173d8f;
      }
      
      a.has-action {
        text-decoration: underline !important;
        color: #173d8f !important;
      }
      a.disabled {
        text-decoration: none !important;
        color: #808080 !important;
      }
      
      input,
      select {
        border-radius: 8px !important;
        border: solid 1px #dcdcdc;
      }
      
      .form-control {
        padding: 0.3rem 0.75rem;
        height: 40px;
        line-height: 2;
        font-size: 14px;
      }
      
      input.form-control {
        line-height: 40;
      }
      
      span.icon {
        cursor: pointer;
        font-size: 24px;
      }
      span.icon.icon--indigo {
        color: #173d8f;
        background: #fff;
      }
      span.icon.icon--grey--opacity {
        color: #c1c1c0;
      }
      span.icon.icon--red {
        color: #ff0000;
      }
      span.has-action {
        cursor: pointer;
        color: #173d8f !important;
      }
      
      img,
      li,
      a {
        cursor: pointer;
      }
      
      .cursor {
        cursor: pointer;
      }
      
      #single-select.required {
        border-color: #ff0000;
      }
      
      .relative {
        position: relative;
      }
      .relative.select i {
        color: #173d8f;
      }
      .relative .icon {
        position: absolute;
        top: 8px;
        right: 6px;
      }
      .relative .icon svg {
        margin-left: 5px;
      }
      .relative .icon svg[data-icon=eye-slash] {
        color: #808080;
      }
      .relative .icon svg[data-icon=exclamation-circle] {
        color: #ff0000;
      }
      
      .absolute {
        position: absolute;
      }
      
      .invalid {
        color: #ff5252 !important;
        border: solid thin #ff5252 !important;
      }
      
      .cm-text-error {
        color: #ff5252 !important;
      }
      
      .error-message {
        color: #d9390d;
        font-size: 12px;
      }
      
      .success-message {
        color: #0da313;
        font-size: 12px;
      }
      
      .right-page-content {
        margin-left: 310px;
        margin-top: 60px;
      }
      
      .main-content {
        position: relative;
        padding: 40px 0 40px;
        min-height: calc(100vh - 60px);
        background: #f6f6f6;
      }
      
      .content {
        background: #fff;
        margin: 0 40px 0;
        padding: 0 0 4px;
        border-radius: 8px;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
                box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
      }
      
      .label-input {
        font-size: 14px;
        margin-left: 10px;
        display: block;
        text-align: left;
        color: #262626;
      }
      
      .tab-header {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        border-radius: 8px 8px 0 0;
        padding: 5px 24px;
        min-height: 50px;
        background-color: #fafafa;
      }
      .tab-header .col {
        padding-top: 0;
        padding-bottom: 0;
        min-height: 40px;
      }
      .tab-header .col:nth-of-type(1) {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
      }
      .tab-header label.tab-title {
        margin-bottom: 0;
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
        color: rgba(38, 38, 38, 0.5);
      }
      
      .tab-content {
        padding: 20px 24px;
      }
      
      #upload-controller .container {
        padding: 0;
        margin-bottom: 20px;
      }
      #upload-controller #input-file {
        position: absolute;
        opacity: 0;
        /* invisible but it's there! */
        width: 100%;
        height: 100%;
      }
      #upload-controller .dropbox {
        position: relative;
        border-radius: 8px;
        border: 1px dashed #707070;
        -webkit-backdrop-filter: blur(10px);
                backdrop-filter: blur(10px);
        outline-offset: -10px;
        padding: 10px 10px;
        max-height: 167px;
        /* minimum height */
      }
      #upload-controller .dropbox p {
        height: 100%;
        margin-top: 20px;
        text-align: center;
        font-size: 12px;
        color: #808080;
      }
      #upload-controller .dropbox p span {
        font-size: 18px;
        color: #262626;
      }
      #upload-controller .dropbox label[for=input-file] {
        border-radius: 8px;
        background-color: #173d8f;
        padding: 10px 30px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
      }
      
      #paging .navigation a {
        color: #808080;
      }
      #paging .navigation a.active {
        color: #173d8f;
      }
      
      .no-border {
        border: none !important;
      }
      
      .btn-bottom {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: end;
            -ms-flex-pack: end;
                justify-content: flex-end;
      }
      
      .btn-icon {
        padding: 8px 18px;
        border-radius: 8px;
        font-size: 24px;
        cursor: pointer;
      }
      .btn-icon.delete {
        color: #fff;
        background: #d9390d;
      }
      .btn-icon.add {
        color: #fff;
        background: #173d8f;
      }
      
      .btn {
        padding: 9px 29px;
        border-radius: 8px;
        font-size: 14px;
        cursor: pointer;
      }
      .btn.btn-indigo {
        background: #173d8f !important;
        color: #ffff !important;
      }
      .btn.btn-save {
        background: #173d8f;
        color: #ffff;
      }
      .btn.btn-close {
        border: solid 1px #173d8f;
      }
      .btn.btn-add-new {
        color: #fff;
        background-color: #173d8f;
      }
      .btn.btn-back, .btn.btn-copy {
        color: #173d8f;
        border: solid 1px #173d8f;
        background-color: #ffffff;
      }
      .btn.btn-upload {
        border: solid thin #173d8f;
        color: #173d8f;
      }
      .btn.btn-upload label {
        color: #173d8f !important;
      }
      .btn.btn-choose {
        background-color: #173d8f;
        border: solid 1px #173d8f;
        color: #ffffff;
        padding: 8px 30px;
      }
      .btn.btn-close-dialog {
        color: #173d8f;
        border: solid 1px #173d8f;
        background-color: #ffffff;
        padding: 8px 30px;
      }
      .btn.disabled {
        color: #fff;
        background-color: #808080;
        border: none;
      }
      
      .text-disabled {
        color: #BDBDBD;
      }
      
      .col-20 {
        -webkit-box-flex: 0 !important;
            -ms-flex: 0 0 20% !important;
                flex: 0 0 20% !important;
        max-width: 20% !important;
      }
      
      .col-12 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 12%;
                flex: 0 0 12%;
        max-width: 12%;
      }
      
      .v-input--selection-controls.v-input .v-label {
        margin-bottom: 0 !important;
        color: #262626;
        font-size: 14px;
      }
      
      .theme--light.v-messages {
        display: none;
      }
      
      .v-tabs {
        padding-left: 40px;
      }
      .v-tabs .v-slide-group__content {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
                flex: 0 0 auto;
      }
      .v-tabs .v-slide-group__content .v-tabs-slider-wrapper {
        display: none;
      }
      .v-tabs .v-slide-group__content .v-tab {
        -webkit-box-pack: start;
            -ms-flex-pack: start;
                justify-content: flex-start;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        margin-left: 0 !important;
        margin-right: 35px;
        padding: 0;
        min-width: 0;
        font-weight: normal;
        text-transform: unset;
      }
      .v-tabs .v-slide-group__content .v-tab.text-center {
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
      }
      .v-tabs .v-slide-group__content .v-tab:hover::before {
        opacity: 0 !important;
      }
      .v-tabs .v-slide-group__content .v-tab:hover {
        color: black !important;
      }
      .v-tabs .v-slide-group__content .v-tab.v-tab--active {
        border-bottom: solid 3px #173d8f;
        color: black;
      }
      .v-tabs .v-slide-group__content .v-tab .v-ripple__container {
        display: none;
      }
      
      .theme--light.v-data-table tbody tr:not(.v-data-table__empty-wrapper) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }
      
      .v-data-table__empty-wrapper td:before {
        content: "";
        background: none !important;
      }
      
      #date-picker .error--text input {
        border: solid thin #ff0000;
      }
      
      .v-data-table.elevation-1 {
        -webkit-box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0.2) !important;
                box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0.2) !important;
        border-radius: 8px;
      }
      .v-data-table th {
        vertical-align: middle;
      }
      .v-data-table th {
        padding-left: 16px;
        padding-right: 16px;
      }
      .v-data-table td {
        padding: 12px 16px !important;
      }
      .v-data-table th:not(:first-of-type) {
        padding-left: 8px !important;
        padding-right: 8px !important;
      }
      .v-data-table tr td:not(:first-of-type) {
        padding-left: 8px !important;
        padding-right: 8px !important;
      }
      
      .ck-content {
        min-height: 300px;
      }
      
      .date-picker .v-text-field > .v-input__control > .v-input__slot:before {
        border-style: none;
      }
      .date-picker .v-text-field__details {
        display: none;
      }
      .date-picker .v-input__slot {
        margin-bottom: 0px;
      }
      
      .amenity > div {
        max-width: 70%;
      }
      .amenity span {
        position: absolute;
        font-size: 24px;
        color: #808080;
        left: 38px;
      }
      .amenity label {
        margin-left: 20px;
      }
      .amenity .am-btn {
        cursor: pointer;
        padding: 3px 8px 3px 8px;
        border-radius: 5px;
        font-size: 14px;
        text-align: center;
      }
      .amenity .am-btn.fee {
        width: 84px;
        color: #0da313;
        background-color: rgba(16, 163, 19, 0.1);
      }
      .amenity .am-btn.free {
        width: 84px;
        color: #00a0dc;
        background-color: rgba(0, 126, 220, 0.3);
      }
      
      .ex-card {
        margin-top: 28px;
        border-radius: 8px;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
                box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
        background-color: #ffffff;
      }
      .ex-card .ex-card__title {
        display: block;
        width: 100%;
        background-color: #fafafa;
        padding: 18px 24px;
        font-size: 10px;
        font-weight: bold;
        text-transform: uppercase;
        color: rgba(38, 38, 38, 0.5);
      }
      .ex-card .ex-card__content {
        padding: 0 30px 14px;
      }
      .ex-card .ex-card__content ._item .row {
        margin-top: 14px;
      }
      .ex-card .ex-card__content ._item ._name {
        color: #808080;
      }
      .ex-card .ex-card__content ._item ._value.-green {
        color: #0da313;
      }
      .ex-card .ex-card__content ._item ._value.-bold {
        font-weight: 500;
      }
      
      table {
        border-collapse: collapse;
        border-right: none !important;
        border-left: none !important;
        width: 100%;
      }
      table th,
      table td {
        vertical-align: top;
        text-align: left;
      }
      table td {
        font-size: 12px !important;
      }
      table th {
        text-transform: uppercase;
        color: rgba(38, 38, 38, 0.5) !important;
        line-height: 24px;
        font-weight: bold;
        background: #fafafa;
      }
      table thead {
        text-transform: uppercase;
      }
      table thead span {
        font-size: 10px !important;
      }
      table span {
        font-size: 12px;
        word-break: break-word;
      }
      table span.item-name {
        font-weight: 500;
        color: #262626;
      }
      table span.name {
        font-weight: bold;
      }
      table span.active {
        color: #0da313;
      }
      table span.not-active {
        color: #ff0000;
      }
      table span.edit, table span.delete {
        padding: 2px 4px;
        font-size: 12px;
        cursor: pointer;
      }
      table span.edit {
        border-right: solid thin rgba(38, 38, 38, 0.5);
        color: #173d8f;
      }
      table span.delete {
        color: #ff0000;
      }
      
      .main-btn {
        padding: 10px 32px;
        border-radius: 8px;
        font-size: 0.9rem;
      }
      .main-btn.btn-pmirary {
        background: #173d8f;
        color: #ffff;
      }
      .main-btn.btn-pmirary:disabled {
        color: #808080;
        background-color: rgba(128, 128, 128, 0.1);
      }
      .main-btn.btn-danger {
        background: #d9390d;
        color: #ffff;
      }
      .main-btn.btn-danger:disabled {
        color: #808080;
        background-color: rgba(128, 128, 128, 0.1);
      }
      .main-btn.btn-secondary {
        color: #173d8f;
        border: solid 1px #173d8f;
        background-color: #ffffff;
      }
      .main-btn.btn-secondary:disabled {
        color: #808080;
        border: solid 1px #808080;
      }
      .main-btn.btn-text {
        padding: 3px 15px;
        color: #808080;
        font-size: 11px;
        font-weight: bold;
        text-transform: uppercase;
      }
      
      .vld-overlay {
        z-index: 999;
      }
      
      .main-tab-wrapper .v-tab {
        min-width: 60px;
        text-transform: none;
      }
      .main-tab-wrapper .v-tab:hover::before {
        opacity: 0 !important;
      }
      .main-tab-wrapper .v-tab:hover {
        color: black !important;
      }
      .main-tab-wrapper .v-tab.v-tab--active {
        color: black;
      }
      .main-tab-wrapper .v-tabs-slider-wrapper {
        color: #173d8f;
        height: 3px !important;
      }
      
      .main-table {
        border-radius: 0 !important;
      }
      .main-table .v-data-table__wrapper {
        border-radius: inherit !important;
      }
      .main-table .v-data-table-header {
        background-color: #fafafa;
      }
      .main-table thead {
        text-transform: uppercase;
      }
      .main-table thead span {
        font-size: 10px !important;
      }
      .main-table thead tr,
      .main-table thead tr th {
        border-bottom: 1px solid #b2b2b2 !important;
      }
      .main-table thead tr th {
        text-transform: uppercase;
        color: rgba(38, 38, 38, 0.5) !important;
        line-height: 24px;
        font-weight: bold;
        background: #fafafa;
        height: auto;
        padding-top: 5px !important;
        padding-bottom: 5px !important;
        font-size: 10px !important;
      }
      .main-table tbody tr {
        border-bottom: none !important;
      }
      .main-table tbody tr td {
        word-break: break-all;
        position: relative;
        border-bottom: none !important;
        height: auto;
      }
      .main-table tbody tr td:before {
        content: "";
        display: block;
        height: 1px;
        overflow: hidden;
        background: #b2b2b2;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
      }
      .main-table tbody tr td:first-child:before {
        left: 15px;
        right: 0;
      }
      .main-table tbody tr td:last-child:before {
        left: 0;
        right: 15px;
      }
      .main-table td,
      .main-table td > span,
      .main-table a {
        font-size: 12px !important;
      }
      .main-table .btn-edit {
        color: #173d8f !important;
      }
      .main-table .btn-delete {
        color: #ff0000 !important;
      }
      .main-table .status-actived {
        color: #0da313;
      }
      .main-table .status-deactived {
        color: #ff0000;
      }
      
      .main-input-text input {
        border-radius: 8px;
        height: calc(1.5em + 0.75rem + 6px);
      }
      .main-input-text input::-webkit-input-placeholder {
        color: #BDBDBD;
      }
      .main-input-text input::-moz-placeholder {
        color: #BDBDBD;
      }
      .main-input-text input:-ms-input-placeholder {
        color: #BDBDBD;
      }
      .main-input-text input::-ms-input-placeholder {
        color: #BDBDBD;
      }
      .main-input-text input::placeholder {
        color: #BDBDBD;
      }
      
      .main-input-select option:disabled {
        color: #BDBDBD;
      }
      
      .content-wrapper {
        margin: 0 40px 0;
      }
      
      .card-item {
        background: #fff;
        border-radius: 8px;
        padding-bottom: 4px;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
                box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
      }
      .card-item .card-item-header {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
        padding: 10px 14px;
        background-color: #fafafa;
      }
      .card-item .card-item-content {
        padding: 24px;
      }
      .card-item .card-item-content.small-padding {
        padding: 15px;
      }
      .card-item .card-item-content.no-padding {
        padding: 0;
      }
      .card-item .card-item-title {
        margin: 0;
        padding: 10px 10px;
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
        color: rgba(38, 38, 38, 0.5);
      }
      
      .dialog-confirm .v-card {
        padding: 20px;
      }
      .dialog-confirm .v-card__title {
        font-size: 14px !important;
        padding: 0 !important;
      }
      .dialog-confirm .btn-left-wrapper {
        padding-bottom: 0;
        padding-right: 0;
      }
      .dialog-confirm .btn-right-wrapper {
        padding-bottom: 0;
        padding-left: 0;
        text-align: right;
      }
      
      .main-checkbox-no-text {
        display: inline-block;
        margin: 0 !important;
        padding: 0 !important;
      }
      .main-checkbox-no-text .v-input__slot,
      .main-checkbox-no-text .v-input--selection-controls__input {
        margin: 0 !important;
      }
      
      .room-plan-container {
        width: 100%;
      }
      .room-plan-container thead {
        background-color: #fafafa;
      }
      .room-plan-container.no-bottom th {
        border-bottom: none;
      }
      .room-plan-container th {
        text-transform: none;
        line-height: unset;
        font-size: 10px;
        font-weight: normal;
        color: #808080 !important;
        border-top: solid 2px #dcdcdc;
        border-bottom: solid 2px #dcdcdc;
      }
      .room-plan-container th:not(:first-child) {
        min-width: 46px;
        width: 5%;
      }
      .room-plan-container th:not(:first-child) .header-wrapper {
        overflow: hidden;
        white-space: pre-wrap;
      }
      .room-plan-container th:first-child {
        min-width: 200px;
      }
      .room-plan-container th.weekend-header {
        color: #ff0000 !important;
        background-color: rgba(255, 0, 0, 0.04);
      }
      .room-plan-container td:not(.has-plan) {
        border-bottom: solid 2px #dcdcdc;
      }
      .room-plan-container td.has-plan {
        border-bottom: solid 2px #173d8f;
      }
      .room-plan-container td.weekend-body {
        color: #ff0000 !important;
        background-color: rgba(255, 0, 0, 0.04);
      }
      .room-plan-container td:first-child .body-wrapper:focus, .room-plan-container td:first-child .body-wrapper:focus-within, .room-plan-container td:first-child button {
        outline: none;
      }
      .room-plan-container .vertical-divider {
        border-left: solid 1px #dcdcdc;
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
      }
      .room-plan-container .header-wrapper {
        position: relative;
        height: 50px;
        margin: 10px 0px;
        padding: 10px 0px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        white-space: pre;
      }
      .room-plan-container .header-wrapper .month-text {
        font-size: 10px;
        color: #173d8f;
      }
      .room-plan-container .body-wrapper {
        height: 42px;
        margin: 0px;
        padding: 6px 0px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        white-space: pre;
        color: #262626;
        white-space: inherit;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .room-plan-container .body-wrapper:focus, .room-plan-container .body-wrapper:focus-within {
        outline: 2px solid #00a0dc;
      }
      .room-plan-container .body-wrapper.invalid {
        outline: 1px solid #ff5252;
      }
      .room-plan-container .body-wrapper input {
        padding: 0;
        border: none;
        border-radius: 0px;
        font-size: 10px;
        color: #808080;
        background: transparent;
        text-align: center;
      }
      .room-plan-container .body-wrapper input:focus {
        outline: none;
        -webkit-box-shadow: none;
                box-shadow: none;
      }
      .room-plan-container .body-wrapper input.invalid {
        border: none !important;
      }
      .room-plan-container .room-row {
        background-color: #f2f2f2;
      }
      .room-plan-container .room-row:first-child span {
        color: rgba(38, 38, 38, 0.5);
      }
      .room-plan-container .room-row .body-wrapper {
        height: 32px;
      }
      .room-plan-container .room-row input {
        height: 20px;
      }
      .room-plan-container .plan-row:first-child {
        border-left: 4px solid #173d8f;
      }
      .room-plan-container .plan-row .body-wrapper {
        height: 32px;
      }
      .room-plan-container .plan-row input {
        height: 20px;
      }
      
      .role-container {
        width: 100%;
      }
      .role-container thead {
        background-color: #fafafa;
      }
      .role-container th {
        padding: 10px 20px 10px 20px;
        text-transform: uppercase;
        font-size: bold;
        color: rgba(38, 38, 38, 0.5);
        font-size: 10px;
        border-top: solid 2px rgba(178, 178, 178, 0.5);
        border-bottom: solid 2px rgba(178, 178, 178, 0.5);
      }
      .role-container td {
        vertical-align: middle;
        position: relative;
        color: #262626;
        font-size: 12px;
        border-bottom: solid 2px rgba(178, 178, 178, 0.5);
      }
      .role-container td.level-1 {
        padding: 15px 20px 15px 20px;
      }
      .role-container td.level-1 .cell-icon {
        position: absolute;
        left: 0px;
        top: 15px;
      }
      .role-container td.level-2 {
        padding: 9px 20px 9px 20px;
      }
      .role-container td.level-2 .cell-icon {
        position: absolute;
        left: 20px;
        top: 9px;
      }
      .role-container td.level-2.child {
        padding-left: 40px !important;
      }
      .role-container td.level-3 {
        padding: 9px 20px 9px 20px;
      }
      .role-container td.level-3 .cell-icon {
        position: absolute;
        left: 40px;
        top: 9px;
      }
      .role-container td.level-3.child {
        padding-left: 60px !important;
      }
      
      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      
      /* Track */
      ::-webkit-scrollbar-track {
        background: #f1f1f1;
      }
      
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #b4b4b4;
        border-radius: 5px;
      }
      
      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: #808080;
      }
      
      .child-no-margin > * {
        margin: 0;
      }
      
      .flex-5 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 45%;
                flex: 0 0 45%;
        max-width: 45%;
      }
      
      .flex-14 {
        -webkit-box-flex: 0;
            -ms-flex: 0 0 10%;
                flex: 0 0 10%;
        max-width: 10%;
      }
      
      .single-select-wrapper {
        margin-bottom: 0;
      }
      .single-select-wrapper ul {
        max-height: 317px !important;
        -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
        background-color: #fff;
        color: #606f7b;
        border-radius: 0.25em;
        line-height: 1.25;
        text-align: left;
      }
      .single-select-wrapper ul li {
        margin: 0 10px;
        padding: 0.8em 0.25em;
        border-bottom: solid thin rgba(0, 0, 0, 0.1);
      }
      .single-select-wrapper .is-error {
        border-color: #ff5252;
      }
      
      .no-resize textarea {
        resize: none;
      }
      
      .no-focus-border:focus {
        outline: 0;
      }
      
      .flip-180 {
        -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
      }
      
      .app-link {
        font-size: 12px;
      }
      .app-link:not(.selected) {
        color: #173d8f;
        text-decoration: underline;
      }
      
      .app-secondary-text {
        font-size: 12px;
        color: #808080;
      }
      
      .card-note {
        width: 200px;
        min-height: 100px;
        padding: 10px;
        font-size: 12px;
        color: #262626;
      }
      
      .date-picker-wrapper {
        display: inline-block;
      }
      .date-picker-wrapper .v-text-field {
        margin: 0 !important;
      }
      .date-picker-wrapper .v-input__slot {
        margin: 0 !important;
      }
      .date-picker-wrapper .date-picker__icon {
        top: 8px !important;
      }
      
      .date-picker-short {
        width: 140px;
      }
      
      .input-gender {
        margin: 0;
        padding-left: 5px;
      }
      .input-gender .v-input__slot {
        margin: 0;
      }
      
      .booking-detail-total-wrapper {
        text-align: right;
        width: 200px;
      }
      
      .booking-detail-info-wrapper {
        min-height: 40px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: baseline;
            -ms-flex-align: baseline;
                align-items: baseline;
      }
      .booking-detail-info-wrapper .booking-detail-label {
        color: #808080;
      }
      .booking-detail-info-wrapper .booking-detail-label-width {
        min-width: 170px;
        width: 170px;
      }
      .booking-detail-info-wrapper .booking-detail-content {
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        word-break: break-word;
      }
      
      .flex-1 {
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
      }
      
      .text-black {
        font-weight: 500;
        color: #808080;
      }
      
      .text-green {
        font-weight: 500;
        color: #0da313;
      }
      
      .input-select-auto .ex-select {
        min-width: 200px;
        width: auto !important;
      }
      
      .hotel-info-link {
        font-size: 14px;
      }
      .hotel-info-link:not(.selected) {
        color: #173d8f;
        text-decoration: underline;
      }
      
      .hotel-info-subtitle {
        font-size: 14px;
        color: #808080;
      }
      
      .hotel-info-seperator {
        margin-top: 5px;
        margin-bottom: 5px;
        margin-left: 30px;
        margin-right: 15px;
      }
      
      #booking-detail .v-text-field__slot textarea {
        font-size: 12px !important;
        color: #262626 !important;
      }
      
      .room-plan-calendar.v-menu__content {
        margin-top: 40px;
      }
      
      .v-picker__title.primary {
        display: none;
      }</style><style type="text/css" id="vuetify-theme-stylesheet">.v-application a { color: #1976d2; }
      .v-application .primary {
        background-color: #1976d2 !important;
        border-color: #1976d2 !important;
      }
      .v-application .primary--text {
        color: #1976d2 !important;
        caret-color: #1976d2 !important;
      }
      .v-application .primary.lighten-5 {
        background-color: #c7fdff !important;
        border-color: #c7fdff !important;
      }
      .v-application .primary--text.text--lighten-5 {
        color: #c7fdff !important;
        caret-color: #c7fdff !important;
      }
      .v-application .primary.lighten-4 {
        background-color: #a8e0ff !important;
        border-color: #a8e0ff !important;
      }
      .v-application .primary--text.text--lighten-4 {
        color: #a8e0ff !important;
        caret-color: #a8e0ff !important;
      }
      .v-application .primary.lighten-3 {
        background-color: #8ac5ff !important;
        border-color: #8ac5ff !important;
      }
      .v-application .primary--text.text--lighten-3 {
        color: #8ac5ff !important;
        caret-color: #8ac5ff !important;
      }
      .v-application .primary.lighten-2 {
        background-color: #6aaaff !important;
        border-color: #6aaaff !important;
      }
      .v-application .primary--text.text--lighten-2 {
        color: #6aaaff !important;
        caret-color: #6aaaff !important;
      }
      .v-application .primary.lighten-1 {
        background-color: #488fef !important;
        border-color: #488fef !important;
      }
      .v-application .primary--text.text--lighten-1 {
        color: #488fef !important;
        caret-color: #488fef !important;
      }
      .v-application .primary.darken-1 {
        background-color: #005eb6 !important;
        border-color: #005eb6 !important;
      }
      .v-application .primary--text.text--darken-1 {
        color: #005eb6 !important;
        caret-color: #005eb6 !important;
      }
      .v-application .primary.darken-2 {
        background-color: #00479b !important;
        border-color: #00479b !important;
      }
      .v-application .primary--text.text--darken-2 {
        color: #00479b !important;
        caret-color: #00479b !important;
      }
      .v-application .primary.darken-3 {
        background-color: #003180 !important;
        border-color: #003180 !important;
      }
      .v-application .primary--text.text--darken-3 {
        color: #003180 !important;
        caret-color: #003180 !important;
      }
      .v-application .primary.darken-4 {
        background-color: #001e67 !important;
        border-color: #001e67 !important;
      }
      .v-application .primary--text.text--darken-4 {
        color: #001e67 !important;
        caret-color: #001e67 !important;
      }
      .v-application .secondary {
        background-color: #424242 !important;
        border-color: #424242 !important;
      }
      .v-application .secondary--text {
        color: #424242 !important;
        caret-color: #424242 !important;
      }
      .v-application .secondary.lighten-5 {
        background-color: #c1c1c1 !important;
        border-color: #c1c1c1 !important;
      }
      .v-application .secondary--text.text--lighten-5 {
        color: #c1c1c1 !important;
        caret-color: #c1c1c1 !important;
      }
      .v-application .secondary.lighten-4 {
        background-color: #a6a6a6 !important;
        border-color: #a6a6a6 !important;
      }
      .v-application .secondary--text.text--lighten-4 {
        color: #a6a6a6 !important;
        caret-color: #a6a6a6 !important;
      }
      .v-application .secondary.lighten-3 {
        background-color: #8b8b8b !important;
        border-color: #8b8b8b !important;
      }
      .v-application .secondary--text.text--lighten-3 {
        color: #8b8b8b !important;
        caret-color: #8b8b8b !important;
      }
      .v-application .secondary.lighten-2 {
        background-color: #727272 !important;
        border-color: #727272 !important;
      }
      .v-application .secondary--text.text--lighten-2 {
        color: #727272 !important;
        caret-color: #727272 !important;
      }
      .v-application .secondary.lighten-1 {
        background-color: #595959 !important;
        border-color: #595959 !important;
      }
      .v-application .secondary--text.text--lighten-1 {
        color: #595959 !important;
        caret-color: #595959 !important;
      }
      .v-application .secondary.darken-1 {
        background-color: #2c2c2c !important;
        border-color: #2c2c2c !important;
      }
      .v-application .secondary--text.text--darken-1 {
        color: #2c2c2c !important;
        caret-color: #2c2c2c !important;
      }
      .v-application .secondary.darken-2 {
        background-color: #171717 !important;
        border-color: #171717 !important;
      }
      .v-application .secondary--text.text--darken-2 {
        color: #171717 !important;
        caret-color: #171717 !important;
      }
      .v-application .secondary.darken-3 {
        background-color: #000000 !important;
        border-color: #000000 !important;
      }
      .v-application .secondary--text.text--darken-3 {
        color: #000000 !important;
        caret-color: #000000 !important;
      }
      .v-application .secondary.darken-4 {
        background-color: #000000 !important;
        border-color: #000000 !important;
      }
      .v-application .secondary--text.text--darken-4 {
        color: #000000 !important;
        caret-color: #000000 !important;
      }
      .v-application .accent {
        background-color: #82b1ff !important;
        border-color: #82b1ff !important;
      }
      .v-application .accent--text {
        color: #82b1ff !important;
        caret-color: #82b1ff !important;
      }
      .v-application .accent.lighten-5 {
        background-color: #ffffff !important;
        border-color: #ffffff !important;
      }
      .v-application .accent--text.text--lighten-5 {
        color: #ffffff !important;
        caret-color: #ffffff !important;
      }
      .v-application .accent.lighten-4 {
        background-color: #f8ffff !important;
        border-color: #f8ffff !important;
      }
      .v-application .accent--text.text--lighten-4 {
        color: #f8ffff !important;
        caret-color: #f8ffff !important;
      }
      .v-application .accent.lighten-3 {
        background-color: #daffff !important;
        border-color: #daffff !important;
      }
      .v-application .accent--text.text--lighten-3 {
        color: #daffff !important;
        caret-color: #daffff !important;
      }
      .v-application .accent.lighten-2 {
        background-color: #bce8ff !important;
        border-color: #bce8ff !important;
      }
      .v-application .accent--text.text--lighten-2 {
        color: #bce8ff !important;
        caret-color: #bce8ff !important;
      }
      .v-application .accent.lighten-1 {
        background-color: #9fccff !important;
        border-color: #9fccff !important;
      }
      .v-application .accent--text.text--lighten-1 {
        color: #9fccff !important;
        caret-color: #9fccff !important;
      }
      .v-application .accent.darken-1 {
        background-color: #6596e2 !important;
        border-color: #6596e2 !important;
      }
      .v-application .accent--text.text--darken-1 {
        color: #6596e2 !important;
        caret-color: #6596e2 !important;
      }
      .v-application .accent.darken-2 {
        background-color: #467dc6 !important;
        border-color: #467dc6 !important;
      }
      .v-application .accent--text.text--darken-2 {
        color: #467dc6 !important;
        caret-color: #467dc6 !important;
      }
      .v-application .accent.darken-3 {
        background-color: #2364aa !important;
        border-color: #2364aa !important;
      }
      .v-application .accent--text.text--darken-3 {
        color: #2364aa !important;
        caret-color: #2364aa !important;
      }
      .v-application .accent.darken-4 {
        background-color: #004c90 !important;
        border-color: #004c90 !important;
      }
      .v-application .accent--text.text--darken-4 {
        color: #004c90 !important;
        caret-color: #004c90 !important;
      }
      .v-application .error {
        background-color: #ff5252 !important;
        border-color: #ff5252 !important;
      }
      .v-application .error--text {
        color: #ff5252 !important;
        caret-color: #ff5252 !important;
      }
      .v-application .error.lighten-5 {
        background-color: #ffe4d5 !important;
        border-color: #ffe4d5 !important;
      }
      .v-application .error--text.text--lighten-5 {
        color: #ffe4d5 !important;
        caret-color: #ffe4d5 !important;
      }
      .v-application .error.lighten-4 {
        background-color: #ffc6b9 !important;
        border-color: #ffc6b9 !important;
      }
      .v-application .error--text.text--lighten-4 {
        color: #ffc6b9 !important;
        caret-color: #ffc6b9 !important;
      }
      .v-application .error.lighten-3 {
        background-color: #ffa99e !important;
        border-color: #ffa99e !important;
      }
      .v-application .error--text.text--lighten-3 {
        color: #ffa99e !important;
        caret-color: #ffa99e !important;
      }
      .v-application .error.lighten-2 {
        background-color: #ff8c84 !important;
        border-color: #ff8c84 !important;
      }
      .v-application .error--text.text--lighten-2 {
        color: #ff8c84 !important;
        caret-color: #ff8c84 !important;
      }
      .v-application .error.lighten-1 {
        background-color: #ff6f6a !important;
        border-color: #ff6f6a !important;
      }
      .v-application .error--text.text--lighten-1 {
        color: #ff6f6a !important;
        caret-color: #ff6f6a !important;
      }
      .v-application .error.darken-1 {
        background-color: #df323b !important;
        border-color: #df323b !important;
      }
      .v-application .error--text.text--darken-1 {
        color: #df323b !important;
        caret-color: #df323b !important;
      }
      .v-application .error.darken-2 {
        background-color: #bf0025 !important;
        border-color: #bf0025 !important;
      }
      .v-application .error--text.text--darken-2 {
        color: #bf0025 !important;
        caret-color: #bf0025 !important;
      }
      .v-application .error.darken-3 {
        background-color: #9f0010 !important;
        border-color: #9f0010 !important;
      }
      .v-application .error--text.text--darken-3 {
        color: #9f0010 !important;
        caret-color: #9f0010 !important;
      }
      .v-application .error.darken-4 {
        background-color: #800000 !important;
        border-color: #800000 !important;
      }
      .v-application .error--text.text--darken-4 {
        color: #800000 !important;
        caret-color: #800000 !important;
      }
      .v-application .info {
        background-color: #2196f3 !important;
        border-color: #2196f3 !important;
      }
      .v-application .info--text {
        color: #2196f3 !important;
        caret-color: #2196f3 !important;
      }
      .v-application .info.lighten-5 {
        background-color: #d4ffff !important;
        border-color: #d4ffff !important;
      }
      .v-application .info--text.text--lighten-5 {
        color: #d4ffff !important;
        caret-color: #d4ffff !important;
      }
      .v-application .info.lighten-4 {
        background-color: #b5ffff !important;
        border-color: #b5ffff !important;
      }
      .v-application .info--text.text--lighten-4 {
        color: #b5ffff !important;
        caret-color: #b5ffff !important;
      }
      .v-application .info.lighten-3 {
        background-color: #95e8ff !important;
        border-color: #95e8ff !important;
      }
      .v-application .info--text.text--lighten-3 {
        color: #95e8ff !important;
        caret-color: #95e8ff !important;
      }
      .v-application .info.lighten-2 {
        background-color: #75ccff !important;
        border-color: #75ccff !important;
      }
      .v-application .info--text.text--lighten-2 {
        color: #75ccff !important;
        caret-color: #75ccff !important;
      }
      .v-application .info.lighten-1 {
        background-color: #51b0ff !important;
        border-color: #51b0ff !important;
      }
      .v-application .info--text.text--lighten-1 {
        color: #51b0ff !important;
        caret-color: #51b0ff !important;
      }
      .v-application .info.darken-1 {
        background-color: #007cd6 !important;
        border-color: #007cd6 !important;
      }
      .v-application .info--text.text--darken-1 {
        color: #007cd6 !important;
        caret-color: #007cd6 !important;
      }
      .v-application .info.darken-2 {
        background-color: #0064ba !important;
        border-color: #0064ba !important;
      }
      .v-application .info--text.text--darken-2 {
        color: #0064ba !important;
        caret-color: #0064ba !important;
      }
      .v-application .info.darken-3 {
        background-color: #004d9f !important;
        border-color: #004d9f !important;
      }
      .v-application .info--text.text--darken-3 {
        color: #004d9f !important;
        caret-color: #004d9f !important;
      }
      .v-application .info.darken-4 {
        background-color: #003784 !important;
        border-color: #003784 !important;
      }
      .v-application .info--text.text--darken-4 {
        color: #003784 !important;
        caret-color: #003784 !important;
      }
      .v-application .success {
        background-color: #4caf50 !important;
        border-color: #4caf50 !important;
      }
      .v-application .success--text {
        color: #4caf50 !important;
        caret-color: #4caf50 !important;
      }
      .v-application .success.lighten-5 {
        background-color: #dcffd6 !important;
        border-color: #dcffd6 !important;
      }
      .v-application .success--text.text--lighten-5 {
        color: #dcffd6 !important;
        caret-color: #dcffd6 !important;
      }
      .v-application .success.lighten-4 {
        background-color: #beffba !important;
        border-color: #beffba !important;
      }
      .v-application .success--text.text--lighten-4 {
        color: #beffba !important;
        caret-color: #beffba !important;
      }
      .v-application .success.lighten-3 {
        background-color: #a2ff9e !important;
        border-color: #a2ff9e !important;
      }
      .v-application .success--text.text--lighten-3 {
        color: #a2ff9e !important;
        caret-color: #a2ff9e !important;
      }
      .v-application .success.lighten-2 {
        background-color: #85e783 !important;
        border-color: #85e783 !important;
      }
      .v-application .success--text.text--lighten-2 {
        color: #85e783 !important;
        caret-color: #85e783 !important;
      }
      .v-application .success.lighten-1 {
        background-color: #69cb69 !important;
        border-color: #69cb69 !important;
      }
      .v-application .success--text.text--lighten-1 {
        color: #69cb69 !important;
        caret-color: #69cb69 !important;
      }
      .v-application .success.darken-1 {
        background-color: #2d9437 !important;
        border-color: #2d9437 !important;
      }
      .v-application .success--text.text--darken-1 {
        color: #2d9437 !important;
        caret-color: #2d9437 !important;
      }
      .v-application .success.darken-2 {
        background-color: #00791e !important;
        border-color: #00791e !important;
      }
      .v-application .success--text.text--darken-2 {
        color: #00791e !important;
        caret-color: #00791e !important;
      }
      .v-application .success.darken-3 {
        background-color: #006000 !important;
        border-color: #006000 !important;
      }
      .v-application .success--text.text--darken-3 {
        color: #006000 !important;
        caret-color: #006000 !important;
      }
      .v-application .success.darken-4 {
        background-color: #004700 !important;
        border-color: #004700 !important;
      }
      .v-application .success--text.text--darken-4 {
        color: #004700 !important;
        caret-color: #004700 !important;
      }
      .v-application .warning {
        background-color: #fb8c00 !important;
        border-color: #fb8c00 !important;
      }
      .v-application .warning--text {
        color: #fb8c00 !important;
        caret-color: #fb8c00 !important;
      }
      .v-application .warning.lighten-5 {
        background-color: #ffff9e !important;
        border-color: #ffff9e !important;
      }
      .v-application .warning--text.text--lighten-5 {
        color: #ffff9e !important;
        caret-color: #ffff9e !important;
      }
      .v-application .warning.lighten-4 {
        background-color: #fffb82 !important;
        border-color: #fffb82 !important;
      }
      .v-application .warning--text.text--lighten-4 {
        color: #fffb82 !important;
        caret-color: #fffb82 !important;
      }
      .v-application .warning.lighten-3 {
        background-color: #ffdf67 !important;
        border-color: #ffdf67 !important;
      }
      .v-application .warning--text.text--lighten-3 {
        color: #ffdf67 !important;
        caret-color: #ffdf67 !important;
      }
      .v-application .warning.lighten-2 {
        background-color: #ffc24b !important;
        border-color: #ffc24b !important;
      }
      .v-application .warning--text.text--lighten-2 {
        color: #ffc24b !important;
        caret-color: #ffc24b !important;
      }
      .v-application .warning.lighten-1 {
        background-color: #ffa72d !important;
        border-color: #ffa72d !important;
      }
      .v-application .warning--text.text--lighten-1 {
        color: #ffa72d !important;
        caret-color: #ffa72d !important;
      }
      .v-application .warning.darken-1 {
        background-color: #db7200 !important;
        border-color: #db7200 !important;
      }
      .v-application .warning--text.text--darken-1 {
        color: #db7200 !important;
        caret-color: #db7200 !important;
      }
      .v-application .warning.darken-2 {
        background-color: #bb5900 !important;
        border-color: #bb5900 !important;
      }
      .v-application .warning--text.text--darken-2 {
        color: #bb5900 !important;
        caret-color: #bb5900 !important;
      }
      .v-application .warning.darken-3 {
        background-color: #9d4000 !important;
        border-color: #9d4000 !important;
      }
      .v-application .warning--text.text--darken-3 {
        color: #9d4000 !important;
        caret-color: #9d4000 !important;
      }
      .v-application .warning.darken-4 {
        background-color: #802700 !important;
        border-color: #802700 !important;
      }
      .v-application .warning--text.text--darken-4 {
        color: #802700 !important;
        caret-color: #802700 !important;
      }</style><style type="text/css">.notification-item[data-v-217f5c7b] {
        padding: 0px 20px;
        cursor: pointer;
      }
      .notification-item[data-v-217f5c7b]:hover {
        background-color: #ced4da;
      }
      .notification-item .notification-item-title[data-v-217f5c7b] {
        margin-top: 10px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
      }
      .notification-item .notification-item-title .notification-item-text[data-v-217f5c7b] {
        font-size: 14px;
        color: #262626;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .notification-item .notification-item-title .notification-item-time[data-v-217f5c7b] {
        position: relative;
        padding-left: 20px;
        font-size: 12px !important;
        line-height: 2;
        text-align: right;
        color: #808080;
      }
      .notification-item .notification-item-title .notification-item-time.badge-is-new[data-v-217f5c7b] {
        margin-right: 10px;
      }
      .notification-item .notification-item-title .notification-item-time .badge-is-new[data-v-217f5c7b] {
        position: absolute;
        font-size: 12px !important;
        display: block;
        top: 7px;
        right: -14px;
        width: 8px;
        height: 8px;
        padding: 0;
        border-radius: 50%;
        background: #d9390d;
      }
      .notification-item .notification-item-content[data-v-217f5c7b] {
        font-size: 12px !important;
        color: #808080;
      }
      .notification-item hr[data-v-217f5c7b] {
        margin-top: 5px;
        margin-bottom: 0px;
      }</style><style type="text/css">#account-setting .square[data-v-60b6b21e] {
        position: relative;
        -ms-flex-preferred-size: 100%;
            flex-basis: 100%;
        -webkit-box-sizing: border-box;
                box-sizing: border-box;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      #account-setting .square[data-v-60b6b21e]::before {
        content: "";
        display: block;
        padding-top: 100%;
      }
      #account-setting .square .square-content[data-v-60b6b21e] {
        border-radius: inherit;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
      }
      #account-setting .btn-icon[data-v-60b6b21e] {
        min-width: 50px;
        min-height: 50px;
        padding: 0;
      }
      .col-12[data-v-60b6b21e] {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
      }</style><style type="text/css">.label-upload[data-v-60b6b21e] {
        background: #fff;
        width: 50px;
      }</style><style type="text/css">.ex-select {
        border-radius: 8px;
        background: url(/img/sort-down.de2bbaaa.svg) no-repeat 98%;
        background-color: #fff;
        background-size: 24px;
        padding-right: 32px;
      }</style><style type="text/css">#date-picker .theme--light.v-text-field > .v-input__control > .v-input__slot::before {
        border: none;
      }
      #date-picker .v-input input {
        padding-left: 40px;
        max-height: 40px;
      }
      #date-picker .v-input input:disabled {
        background: rgba(128, 128, 128, 0.1);
      }
      #date-picker .date-picker__icon {
        position: absolute;
        top: 10px;
        left: 11px;
      }
      #date-picker .v-text-field__details {
        display: none;
      }</style><style type="text/css">#paging .total span {
        color: #808080;
      }
      #paging a,
      #paging svg {
        color: #173d8f;
        cursor: pointer;
      }
      #paging svg {
        margin-left: 3px;
      }
      #paging .col {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
      }
      #paging .selectAll {
        -webkit-box-pack: start;
            -ms-flex-pack: start;
                justify-content: start;
      }
      #paging .navigation a {
        font-weight: 500;
        display: inline-block;
        padding: 2px 6px;
      }</style><style type="text/css">@charset "UTF-8";
      .-overflow-hidden{overflow:hidden
      }
      .-is-hidden{display:none
      }
      @media screen and (max-width:767px){
      .-hide-up-to-tablet{display:none
      }
      }
      @media screen and (min-width:768px){
      .-hide-on-desktop{display:none
      }
      }</style><style type="text/css">.input-textarea[data-v-0f5bf528] {
        border-radius: 8px;
      }</style><style type="text/css">.col-12[data-v-c18d88d4] {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
      }</style>`
}